//@ts-nocheck
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { request } from "./api/instances/index";
import type { ErrorType } from "./api/instances/index";
export type UpdateWeightingMapBodySupplementedRearingModality = string | null;

export type UpdateWeightingMapBody = {
  averageWeight?: number;
  buyerId?: number;
  carcassYield?: number;
  closingTime?: string;
  commission?: number;
  emissionDate?: string;
  endTime?: string;
  fastingDate?: string;
  grossWeight?: number;
  gtaIds?: number[];
  invoiceIds?: number[];
  netWeight?: number;
  pricePerArroba?: number;
  referenceCode?: string;
  shippingCost?: number;
  startTime?: string;
  supplementedRearingModality?: UpdateWeightingMapBodySupplementedRearingModality;
  totalPurchase?: number;
  totalWeight?: number;
  weighingDate?: string;
};

export type CreateWeightingMapBodySupplementedRearingModality = string | null;

export type CreateWeightingMapBody = {
  averageWeight?: number;
  buyerId: number;
  carcassYield?: number;
  closingTime?: string;
  commission: number;
  emissionDate: string;
  endTime?: string;
  fastingDate?: string;
  grossWeight?: number;
  gtaIds?: number[];
  invoiceIds?: number[];
  netWeight?: number;
  pricePerArroba?: number;
  referenceCode: string;
  shippingCost: number;
  startTime?: string;
  supplementedRearingModality?: CreateWeightingMapBodySupplementedRearingModality;
  totalPurchase?: number;
  totalWeight?: number;
  weighingDate: string;
};

export type TroughManagementGraphViewParams = {
  batchId?: number;
  fullHistory?: boolean;
  since?: string;
};

export type TroughManagementViewParams = {
  batchId?: number;
};

export type TreatViewParams = {
  batchIds?: number[];
  hideTreatment?: boolean;
};

export type TransferViewParams = {
  corralDestinyId: number;
  corralOriginId: number;
};

export type SideBarViewParams = {
  batchId: number;
  since: string;
};

export type MultipleTreatsViewParams = {
  since?: string;
};

export type MultipleBeatsViewParams = {
  since?: string;
};

export type ListManagedBatchesParams = {
  batchId?: number;
};

export type FindOxParams = {
  animalStatus?: string;
  electronic?: string;
  electronicCode?: string;
  identifier?: string;
  managementCode?: string;
  oxId?: number;
  sisbov?: number;
};

export type BatchDetailsParams = {
  batchId: number;
};

export type RestoreFeedDataPublicBodyChannel =
  (typeof RestoreFeedDataPublicBodyChannel)[keyof typeof RestoreFeedDataPublicBodyChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RestoreFeedDataPublicBodyChannel = {
  latest: "latest",
  beta: "beta",
  alpha: "alpha",
  gamma: "gamma",
  cloud: "cloud",
} as const;

export type RestoreFeedDataPublicBody = {
  channel: RestoreFeedDataPublicBodyChannel;
  filename: string;
  sapId: string;
};

export type SubmitCertifierBody = {
  filename: string;
};

export type BndVerificationParams = {
  ownerId: number;
};

export type FindBndInfoBySisbovParams = {
  sisbov: number;
};

export type ListBNDsParams = {
  ownerId?: number;
};

export type ListSavedBackupsParams = {
  channel: string;
  sapId: string;
  userId?: number;
};

export type CreateBackupDataBody = {
  channel: string;
  sapId: string;
  /** Preenchido só por chamadas internas (ex.: criação/migração de fazenda); no botão "Salvar Backup" é derivado do request. */
  source?: BackupSource;
  userId?: number;
};

export type RestoreFeedDataBody = {
  filename: string;
};

export type ExportFeedDataParams = {
  filepath: string;
};

export type ManageTreatsConclusionBodyItem = {
  /** Id de lote deste dia */
  batchId: number;
  foreseen: number;
  /** Nulo apenas se for um trato livre */
  order?: number;
};

export type RemoveDuplicatedTreatsParams = {
  date: string;
};

export type ActivateTreatmentParams = {
  active: boolean;
};

export type ListTreatmentsParams = {
  active?: boolean;
};

export type StartTracerParams = {
  directory: string;
};

export type GetStockTimelineParams = {
  end?: string;
  start?: string;
};

export type RemoveStockParams = {
  amount: number;
  date: string;
  description: string;
};

export type ReceivePremixBody = {
  amount: number;
};

export type ReceiveStockParams = {
  amount: number;
  date: string;
  kiloPrice?: number;
  structureIds?: number[];
};

export type ActivateStockParams = {
  active: boolean;
};

export type GetStockAverageInfoBody = {
  ingredients: Ingredient[];
};

export type ListStocksRetroactiveNaturalMatter =
  (typeof ListStocksRetroactiveNaturalMatter)[keyof typeof ListStocksRetroactiveNaturalMatter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListStocksRetroactiveNaturalMatter = {
  empty: "empty",
  not_empty: "not empty",
} as const;

export type ListStocksRetroactiveParams = {
  active?: boolean;
  end?: string;
  isPremix?: boolean;
  isSupplement?: boolean;
  naturalMatter?: ListStocksRetroactiveNaturalMatter;
  start: string;
};

export type ListStocksNaturalMatter =
  (typeof ListStocksNaturalMatter)[keyof typeof ListStocksNaturalMatter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListStocksNaturalMatter = {
  empty: "empty",
  not_empty: "not empty",
} as const;

export type ListStocksParams = {
  active?: boolean;
  isPremix?: boolean;
  isSupplement?: boolean;
  naturalMatter?: ListStocksNaturalMatter;
};

export type GetSheetDataType =
  (typeof GetSheetDataType)[keyof typeof GetSheetDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSheetDataType = {
  R: "R",
  E: "E",
  N: "N",
} as const;

export type GetSheetDataParams = {
  purchaseId: number;
  type: GetSheetDataType;
};

export type InternalSeedAdvanceFarmParams = {
  days?: number;
};

export type ReverseOxenBulkBodyAssignmentsItem = {
  batchId: number;
  oxIds: number[];
};

export type ReverseOxenBulkBody = {
  assignments: ReverseOxenBulkBodyAssignmentsItem[];
};

export type UpdateSaleOrderBodyFreightPerAtSignBRL = number | null;

/**
 * Bônus (%) sobre o valor da venda
 */
export type UpdateSaleOrderBodyBonusPercent = number | null;

export type UpdateSaleOrderBodyAtSignPrice = number | null;

export type UpdateSaleOrderBody = {
  atSignPrice?: UpdateSaleOrderBodyAtSignPrice;
  /** Bônus (%) sobre o valor da venda */
  bonusPercent?: UpdateSaleOrderBodyBonusPercent;
  complementInvoiceIds?: number[];
  complementInvoices?: CreateInvoice[];
  destinyId?: number;
  exitTrucksIds?: number[];
  expirationDay?: string;
  freightPerAtSignBRL?: UpdateSaleOrderBodyFreightPerAtSignBRL;
  orderName?: string;
  orderNumber?: number;
  partnerAtSignPriceF?: number;
  partnerAtSignPriceM?: number;
  paymentMethod?: string;
  saleDate?: string;
  status?: EnumsSaleOrderStatus;
};

export type UpdateSaleOrderTypeBodyTypeOfClosed =
  (typeof UpdateSaleOrderTypeBodyTypeOfClosed)[keyof typeof UpdateSaleOrderTypeBodyTypeOfClosed];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSaleOrderTypeBodyTypeOfClosed = {
  BATCH: "BATCH",
  INDIVIDUAL: "INDIVIDUAL",
} as const;

export type UpdateSaleOrderTypeBody = {
  id: number;
  typeOfClosed: UpdateSaleOrderTypeBodyTypeOfClosed;
};

export type UpdateSaleOrderPenaltyBody = {
  description: string;
  id: number;
  penaltyAmount: number;
  saleOrderId: number;
};

export type CreateSaleOrderPenaltyBody = {
  description: string;
  oxId?: number;
  penaltyAmount: number;
  saleOrderId: number;
};

export type ListSaleOrderPenaltiesParams = {
  orderId: number;
};

export type DeleteSaleOrderPenaltyBody = {
  id: number;
  saleOrderId: number;
};

export type ListSaleOrdersParams = {
  /**
   * Filtra vendas que contenham animais dos lotes informados
   */
  batchIds?: number[];
  endDate?: string;
  limit?: number;
  liveWeightInKg?: number;
  number?: number;
  page?: number;
  partnerId?: number;
  /**
   * Busca por número ou nome da ordem de venda
   */
  search?: string;
  sort?: SortOrder;
  startDate?: string;
  status?: EnumsSaleOrderStatus;
};

export type CloseSaleManagementBody = {
  carcassExcessive?: number;
  carcassMedium?: number;
  carcassMissing?: number;
  carcassPrice: number;
  carcassThin?: number;
  carcassType?: EnumsCarcassType;
  carcassUniform?: number;
  carcassWeight: number;
  invoice?: string;
};

export type ListInternalSalesParams = {
  endDate?: string | unknown;
  startDate?: string | unknown;
};

export type ListSaleManagementsParams = {
  closed?: boolean;
  date?: string;
  gtaNumber?: string;
  ownerId?: number;
  producer?: string;
};

export type GetZootechnicalReportXlsxParams = {
  appVersion?: string | null;
  end: string;
  filename: string;
  start: string;
};

export type GetZootechnicalReportWeightType =
  (typeof GetZootechnicalReportWeightType)[keyof typeof GetZootechnicalReportWeightType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetZootechnicalReportWeightType = {
  ENTRY: "ENTRY",
  IDENTIFICATION: "IDENTIFICATION",
} as const;

export type GetZootechnicalReportGender =
  (typeof GetZootechnicalReportGender)[keyof typeof GetZootechnicalReportGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetZootechnicalReportGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export type GetZootechnicalReportParams = {
  batchIds?: number[];
  corralId?: number;
  end: string;
  entryDateEnd?: string;
  entryDateStart?: string;
  gender?: GetZootechnicalReportGender;
  ownerId?: number;
  purchaseId?: number;
  start: string;
  variety?: string;
  weighingMapId?: number;
  weightType: GetZootechnicalReportWeightType;
};

export type ListStocksRetroactiveXlsxNaturalMatter =
  (typeof ListStocksRetroactiveXlsxNaturalMatter)[keyof typeof ListStocksRetroactiveXlsxNaturalMatter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListStocksRetroactiveXlsxNaturalMatter = {
  empty: "empty",
  not_empty: "not empty",
} as const;

export type ListStocksRetroactiveXlsxParams = {
  active?: boolean;
  appVersion: string | null;
  end?: string;
  filename: string;
  isPremix?: boolean;
  isSupplement?: boolean;
  naturalMatter?: ListStocksRetroactiveXlsxNaturalMatter;
  start: string;
};

export type PasturesReportXlsxParams = {
  filename: string;
};

export type GeneratePartnerSlaughterReportXlsxParams = {
  appVersion?: string | null;
  end?: string | null;
  filename: string;
  start?: string | null;
};

export type GetOccurrencesReportXlsxParams = {
  appVersion?: string | null;
  end?: string;
  filename: string;
  start: string;
};

export type ExportMedicineApplicationsReportExcelParams = {
  appVersion?: string | null;
  end?: string | null;
  filename: string;
  start?: string | null;
};

export type GetInventoryControlReportXlsxParams = {
  appVersion?: string | null;
  filename: string;
};

export type GetIndividualCattleClosingReportXlsxParams = {
  appVersion?: string | null;
  batchId?: number;
  end?: string;
  filename: string;
  start?: string;
};

export type GetHistoryReportXlsxParams = {
  appVersion: string | null;
  batchId: number;
  end: string;
  filename: string;
  start: string;
};

export type GetFoodReportXlsxParams = {
  appVersion?: string | null;
  filename: string;
};

export type GetFoodHistoryReportXlsxParams = {
  appVersion: string | null;
  end: string;
  filename: string;
  start: string;
  stockId: number;
};

export type ExportDiedOxenReportExcelParams = {
  appVersion?: string | null;
  end?: string | null;
  filename: string;
  start?: string | null;
};

export type GenerateOxenEntranceReportXlsxParams = {
  appVersion?: string | null;
  end?: string;
  filename: string;
  gender?: EnumsOxGender;
  partnerId?: number;
  purchaseName?: string;
  start?: string;
  type?: EnumsOxPurpose;
};

export type GenerateComissionReportXlsxParams = {
  appVersion?: string | null;
  buyerId?: number;
  end?: string;
  filename: string;
  purchaseName?: string;
  start?: string;
};

export type GetAnalyticalBatchDaysDetailsXlsxMetric =
  (typeof GetAnalyticalBatchDaysDetailsXlsxMetric)[keyof typeof GetAnalyticalBatchDaysDetailsXlsxMetric];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAnalyticalBatchDaysDetailsXlsxMetric = {
  confinement: "confinement",
  treatment: "treatment",
} as const;

export type GetAnalyticalBatchDaysDetailsXlsxParams = {
  batchId: number;
  filename: string;
  metric: GetAnalyticalBatchDaysDetailsXlsxMetric;
};

export type GetWeighingReportParams = {
  chunkKey: string;
};

export type GetWeighingReportXlsxParams = {
  appVersion?: string | null;
  columns?: string;
  end?: string | null;
  filename: string;
  start?: string | null;
};

export type CountWeighingReportParams = {
  batchId?: number;
  day: string;
  end: string;
  limit?: number;
  sisbovs?: string[];
  start: string;
};

export type GetTroughReadingReportParams = {
  end?: string;
  start?: string;
};

export type GenerateTreatEfficiencyReportExcelBody = {
  average: TreatEfficiencyAverage;
  history: EfficiencyReportResult[];
};

export type GenerateTreatEfficiencyReportExcelParams = {
  appVersion?: string | null;
  end: string;
  filename: string;
  start: string;
};

export type GetTreatEfficiencyReportParams = {
  end: string;
  start: string;
};

export type GetBatchTransferParams = {
  batchId?: number;
};

export type StartTestJobReportParams = {
  slices?: number;
};

export type GetSlaughterScaleReportParams = {
  chunkKey: string;
};

export type GenerateSlaughterScaleReportExcelBody = {
  monthlySummary: SlaughterScaleMonthSummaryWithSummaryRow[];
  slaughterEndDate?: string;
  slaughterStartDate?: string;
  weeklyData: SlaughterScaleWeekSummary[];
  weeklySummary: SlaughterScaleWeekSummaryWithSummaryRow[];
};

export type GenerateSlaughterScaleReportExcelParams = {
  appVersion?: string | null;
  filename: string;
};

export type CountBatchesForSlaughterScaleReportParams = {
  genders?: string;
  limit: number;
  partnerHerd?: string;
  slaughterEndDate?: string;
  slaughterStartDate?: string;
};

export type GetSlaughterResultReportParams = {
  saleNumber: number;
};

export type ListPartnersForSalesReportParams = {
  destinyId?: number;
  endSaleDate: string;
  startSaleDate: string;
};

export type ExportSalesReportExcelParams = {
  appVersion?: string | null;
  end?: string | null;
  filename: string;
  start?: string | null;
};

export type ListEstablishmentsForSalesReportParams = {
  endSaleDate: string;
  partnerId?: number;
  startSaleDate: string;
};

export type GenerateSalesReportParams = {
  destinyId?: number;
  endSaleDate: string;
  partnerId?: number;
  startSaleDate: string;
};

export type GetPartnerSlaughterResultReportParams = {
  gender: EnumsOxGender;
  partnerId: number;
  purchaseId: number;
};

export type MovementHistoryReportParams = {
  animalSearch?: string;
  batchId?: number;
  end?: string;
  includeTotal?: boolean;
  knownTotal?: number;
  limit?: number;
  oxId?: number;
  page?: number;
  start: string;
};

export type GetInventoryControlParams = {
  limit?: number;
  page?: number;
};

export type IndividualCattleClosingReportParams = {
  batchId?: number;
  end?: string;
  limit?: number;
  page?: number;
  start?: string;
};

export type BatchHistoryReportParams = {
  batchId: number;
  end?: string;
  start: string;
};

export type GetFoodStockHistoryParams = {
  end?: string;
  start: string;
  stockId: number;
};

export type GetFoodEnergyHistoryReportExcelParams = {
  appVersion?: string | null;
  end: string;
  filename: string;
  start: string;
};

export type GetFoodEnergyHistoryReportParams = {
  end: string;
  start: string;
  stockId?: number;
};

export type GenerateFinancialBatchesReportExcelParams = {
  appVersion?: string | null;
  filename: string;
};

export type GetOxenEntranceReportParams = {
  end?: string;
  gender?: EnumsOxGender;
  partnerId?: number;
  purchaseName?: string;
  start?: string;
  type?: EnumsOxPurpose;
};

export type GetEconomicReportExcelParams = {
  appVersion?: string | null;
  end: string;
  filename: string;
  start: string;
};

export type GetEconomicReportWeightType =
  (typeof GetEconomicReportWeightType)[keyof typeof GetEconomicReportWeightType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEconomicReportWeightType = {
  ENTRY: "ENTRY",
  IDENTIFICATION: "IDENTIFICATION",
} as const;

export type GetEconomicReportGender =
  (typeof GetEconomicReportGender)[keyof typeof GetEconomicReportGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEconomicReportGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export type GetEconomicReportParams = {
  batchIds?: number[];
  corralId?: number;
  end: string;
  entryDateEnd?: string;
  entryDateStart?: string;
  gender?: GetEconomicReportGender;
  ownerId?: number;
  purchaseId?: number;
  start: string;
  variety?: string;
  weighingMapId?: number;
  weightType: GetEconomicReportWeightType;
};

export type GetDailyFoodReportExcelParams = {
  appVersion?: string | null;
  end: string;
  filename: string;
  start: string;
};

export type GetDailyFoodReportParams = {
  end: string;
  start: string;
};

export type GetConsolidatedInternalSaleReportParams = {
  chunkKey: string;
};

export type GetConsolidatedInternalSaleReportXlsxParams = {
  columns?: string;
  filename: string;
};

export type CountConsolidatedInternalSaleReportParams = {
  end: string;
  internalSaleId?: number;
  limit?: number;
  ownerId?: number;
  start: string;
};

export type GetComissionReportParams = {
  buyerId?: number;
  end?: string;
  purchaseName?: string;
  start?: string;
};

export type GetCattleEntryPerCategoryReportParams = {
  category?: EnumsOxCategory;
  endDate?: string;
  gender?: EnumsOxGender;
  maximumDistance?: number;
  minimumDistance?: number;
  startDate?: string;
};

export type GenerateCattleEntryPerCategoryReportExcelParams = {
  appVersion?: string | null;
  end?: string | null;
  filename: string;
  start?: string | null;
};

export type GetBakingEfficiencyReportParams = {
  chunkKey: string;
};

export type GenerateBakingEfficiencyReportExcelBody = {
  report: BakingEfficiencyReportDataResponseItem[];
};

export type GenerateBakingEfficiencyReportExcelParams = {
  appVersion?: string | null;
  end?: string;
  filename: string;
  start?: string;
};

export type CountBeatsForBakingEfficiencyReportParams = {
  end?: string;
  limit?: number;
  start: string;
};

export type GetStackedAnalyticalReportExcelBody = {
  reports: AnalyticalReportServiceResponse[];
};

export type GetStackedAnalyticalReportExcelParams = {
  appVersion?: string | null;
  end: string;
  filename: string;
  start: string;
};

export type GetAnalyticalReportExcelParams = {
  appVersion?: string | null;
  filename: string;
};

export type AnalyticalBatchDaysDetailsParams = {
  batchId: number;
};

export type GetAnalyticalReportWeightType =
  (typeof GetAnalyticalReportWeightType)[keyof typeof GetAnalyticalReportWeightType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAnalyticalReportWeightType = {
  ENTRY: "ENTRY",
  IDENTIFICATION: "IDENTIFICATION",
} as const;

export type GetAnalyticalReportGender =
  (typeof GetAnalyticalReportGender)[keyof typeof GetAnalyticalReportGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAnalyticalReportGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export type GetAnalyticalReportParams = {
  batchId?: number;
  batchIds?: number[];
  corralId?: number;
  entryDateEnd?: string;
  entryDateStart?: string;
  exitDateEnd?: string;
  exitDateStart?: string;
  gender?: GetAnalyticalReportGender;
  ownerId?: number;
  purchaseId?: number;
  variety?: string;
  weighingMapId?: number;
  weightType: GetAnalyticalReportWeightType;
};

export type GenerateActiveBatchesReportExcelBodyAppVersion = string | null;

export type GenerateActiveBatchesReportExcelBody = {
  appVersion?: GenerateActiveBatchesReportExcelBodyAppVersion;
  averagesByDay: ActiveBatchesDayAverages[];
  filename: string;
  orderBy?: ActiveBatchesReportOrder;
  report: ActiveBatchesReportItem[];
  showBatchCost: boolean;
  sortType: SortType;
};

export type WarmupActiveBatchesConsumeParams = {
  end?: string;
  start?: string;
};

export type GetActiveBatchesConsumeStatusParams = {
  end?: string;
  start?: string;
};

export type GetActiveBatchesReportParams = {
  end?: string;
  start?: string;
};

export type ListRecipesParams = {
  active?: boolean;
};

export type ListWeightingMapsByPurchaseIdStatus =
  (typeof ListWeightingMapsByPurchaseIdStatus)[keyof typeof ListWeightingMapsByPurchaseIdStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListWeightingMapsByPurchaseIdStatus = {
  AVAILABLE: "AVAILABLE",
  IN_USE: "IN_USE",
  FINISHED: "FINISHED",
} as const;

export type ListWeightingMapsByPurchaseIdParams = {
  status?: ListWeightingMapsByPurchaseIdStatus;
};

export type DeletePurchaseCategory =
  (typeof DeletePurchaseCategory)[keyof typeof DeletePurchaseCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeletePurchaseCategory = {
  FOODS: "FOODS",
  ANIMALS: "ANIMALS",
  EARRINGS: "EARRINGS",
} as const;

export type DeletePurchaseParams = {
  category: DeletePurchaseCategory;
};

export type StoredPurchaseChargebackParams = {
  partnerId?: number;
};

export type ChargebackOxenPurchaseBody = {
  destinationIds: number[];
  originId: number;
  oxenIds?: number[];
};

export type ChargebackOxenPurchaseParams = {
  partnerId?: number;
};

export type ListOxenPurchaseParams = {
  partnerId: number;
};

export type PurchaseNameExistsParams = {
  name: string;
};

export type SisbovExistsParams = {
  sisbov: number;
};

export type PurchasesAvailableEarringsParams = {
  category?: EnumsPurchaseCategory;
  gtaNumber?: string;
  issuedAt?: string;
  limit?: number;
  name?: string;
  orderByStatus?: EnumsPurchaseStatus;
  page?: number;
  producer?: string;
  status?: EnumsPurchaseStatus;
};

export type ListPurchasesParams = {
  category?: EnumsPurchaseCategory;
  gtaNumber?: string;
  issuedAt?: string;
  limit?: number;
  name?: string;
  orderByStatus?: EnumsPurchaseStatus;
  page?: number;
  producer?: string;
  status?: EnumsPurchaseStatus;
};

export type ListPartnerClosuresByPartnerIdParams = {
  endSaleDate: string;
  gender: string;
  partnerId: number;
  startSaleDate: string;
};

export type GetBoitelClosureSummaryParams = {
  oxenPurchaseId: number;
};

export type ListPartnersWithClosuresParams = {
  endSaleDate: string;
  gender: string;
  startSaleDate: string;
};

export type UpdateOxHealthByOxIdBodyMedicinesItem = {
  appliedDose: number;
  dosePrice: number;
  medicineId: number;
};

export type UpdateOxHealthByOxIdBody = {
  applicatorId?: number;
  appliedAt: string;
  disease: string;
  healthProtocolId?: number;
  medicines: UpdateOxHealthByOxIdBodyMedicinesItem[];
};

export type ReverseOxBody = {
  batchId?: number;
};

export type RemoveOxFromTruckBody = {
  batchTargetId?: number;
};

export type ListDeadOxenXlsxParams = {
  filename: string;
};

export type GetOxWeightsParams = {
  oxIds: string;
};

export type ListRepeatedIdentifiersParams = {
  identifier?: string;
};

export type UpdateIdentifierParams = {
  identifier: string;
  newIdentifier: string;
  oxId: number;
};

export type SpreadsheetOxIdentificationParams = {
  oxId: number;
};

export type ClearSpreadsheetIdentificationParams = {
  corralId: number;
};

export type ReverseOxBulkBodyAssignmentsItem = {
  batchId: number;
  oxIds: number[];
};

export type ReverseOxBulkBody = {
  assignments: ReverseOxBulkBodyAssignmentsItem[];
};

export type GetOxPriceTableParams = {
  year: number;
};

export type ListOxMovementHistoryGender =
  (typeof ListOxMovementHistoryGender)[keyof typeof ListOxMovementHistoryGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListOxMovementHistoryGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export type ListOxMovementHistoryParams = {
  animalSearch?: string;
  availability?: OxMovementAvailabilityFilter;
  breed?: string;
  destBatchId?: number;
  destCorralId?: number;
  end?: string;
  gender?: ListOxMovementHistoryGender;
  limit?: number;
  movementKind?: OxMovementKind;
  originBatchId?: number;
  originCorralId?: number;
  ownerId?: number;
  page?: number;
  purchaseId?: number;
  start?: string;
};

export type MoveOxenBody = {
  corralOriginId?: number;
  corralTargetId: number;
  description?: string;
  oxenIds?: number[];
  toEmpty?: boolean;
  toEmptyBypass?: boolean;
};

export type MedicateBatchOxBodyDoseMapItem = {
  dose: number;
  id: number;
};

export type MedicateBatchOxBody = {
  animalCount?: number;
  batchId: number;
  customDate?: string;
  disease: EnumsDisease;
  doseMap: MedicateBatchOxBodyDoseMapItem[];
  extraMedicineIds?: number[];
  healthProtocolId?: number;
  medicineApplicatorId: number;
};

export type CheckRepeatedOxMedicineApplicationParams = {
  appliedAt: string;
  medicineIds: string;
  oxId: number;
};

export type ListAndExportMedicineApplicationsOxenParams = {
  end: string;
  ownerId?: number;
  partnerId?: number;
  start: string;
};

export type ListAndExportDiedOxenParams = {
  end: string;
  ownerId?: number;
  partnerId?: number;
  start: string;
};

export type ListAndExportDailyLivestockInventoryOxenParams = {
  end: string;
  ownerId?: number;
  partnerId?: number;
  start: string;
};

export type OxIdentificationParams = {
  batchId: number;
};

export type CheckOxIdentificationParams = {
  /**
   * Dados do brinco eletrônico
   */
  electronic?: string;
  sisbov?: number;
};

export type ListOxenHealthParams = {
  appliedAt?: string;
  batchId?: number;
  corralId?: number;
  limit?: number;
  oxIdentifier?: string;
  page?: number;
};

export type FindOxenBySisbovsBody = {
  sisbovs: string[];
};

export type ExportOxenFromInternalSaleBody = {
  filename: string;
  internalSaleIds: number[];
};

export type ExportOxSearchParams = {
  animalStatus?: string;
  batchId?: number;
  breed?: string;
  category?: EnumsOxCategory;
  corralId?: number;
  currentWeight?: number;
  displayUntilDate?: string;
  electronic?: string;
  electronicCode?: string;
  entryDate?: string;
  entryWeight?: number;
  exitDate?: string;
  filename: string;
  foreseenSlaughtWeight?: number;
  gender?: EnumsOxGender;
  gtaId?: number;
  id?: number;
  identifier?: string;
  invoice?: string;
  lastWeightingDate?: string;
  limit?: number;
  managementCode?: string;
  onlyLiveAnimal?: boolean;
  originId?: number;
  originResponsibleId?: number;
  ownerId?: number;
  page?: number;
  purchaseId?: number;
  sisbov?: string;
  variety?: string;
};

export type ExportAllIdentificationOxenToExcelParams = {
  end: string;
  start: string;
};

export type ExportAllDiedOxenToExcelParams = {
  end: string;
  start: string;
};

export type ListOxenParams = {
  animalStatus?: string;
  batchId?: number;
  breed?: string;
  category?: EnumsOxCategory;
  corralId?: number;
  currentWeight?: number;
  displayUntilDate?: string;
  electronic?: string;
  electronicCode?: string;
  entryDate?: string;
  entryWeight?: number;
  exitDate?: string;
  foreseenSlaughtWeight?: number;
  gender?: EnumsOxGender;
  gtaId?: number;
  id?: number;
  identifier?: string;
  invoice?: string;
  lastWeightingDate?: string;
  limit?: number;
  managementCode?: string;
  onlyLiveAnimal?: boolean;
  originId?: number;
  originResponsibleId?: number;
  ownerId?: number;
  page?: number;
  purchaseId?: number;
  sisbov?: string;
  variety?: string;
};

export type CreateOtherDeathCauseBody = {
  name: string;
};

export type GetOperationalCostsParams = {
  groupId: number;
};

export type ListOccurrencesByBatchIdParams = {
  batchId: number;
};

export type ListOccurrencesParams = {
  end?: string;
  limit?: number;
  page?: number;
  start?: string;
};

export type UpsertWeightConfigBody = {
  entryWeightMax: number;
  entryWeightMin: number;
};

export type UpsertPurchaseConfigBody = {
  purchaseCalculationType: PurchaseCalculationType;
};

export type UpsertOperationalCostConfigBodyOperationalCostCalculationType =
  (typeof UpsertOperationalCostConfigBodyOperationalCostCalculationType)[keyof typeof UpsertOperationalCostConfigBodyOperationalCostCalculationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertOperationalCostConfigBodyOperationalCostCalculationType = {
  MONTHLY_APPORTIONMENT: "MONTHLY_APPORTIONMENT",
  PER_HEAD_PER_DAY: "PER_HEAD_PER_DAY",
} as const;

export type UpsertOperationalCostConfigBody = {
  operationalCostCalculationType: UpsertOperationalCostConfigBodyOperationalCostCalculationType;
};

export type UpsertMasterConfigBody = {
  macAddress: string;
};

export type SearchAnimalSwapParams = {
  aliveSisbov: string;
  deadSisbov: string;
};

export type DisableMixerParams = {
  id: number;
};

export type ActivateMedicineParams = {
  active: boolean;
};

export type GetMedicinesParams = {
  active?: boolean;
};

export type ListManagementSessionsParams = {
  status?: EnumsManagementStatus;
};

export type CreateManagementRowBody = {
  corral: string;
  managementId: string;
  oxId: number;
};

export type GetManagementOxenByManagementIdParams = {
  managementId: string;
};

export type DeleteManagementOxenByManagementIdParams = {
  managementId: string;
};

export type GenerateInternalSalesRealizedExcelBody = {
  filename: string;
  internalSaleIds: number[];
};

export type ValidateSingleHoldingSaleRowBodySisbov = string | null;

/**
 * Brinco extra (identificador interno)
 */
export type ValidateSingleHoldingSaleRowBodyIdentifier = string | null;

export type ValidateSingleHoldingSaleRowBodyElectronic = string | null;

export type ValidateSingleHoldingSaleRowBodyDentition = string | null;

export type ValidateSingleHoldingSaleRowBody = {
  dentition?: ValidateSingleHoldingSaleRowBodyDentition;
  electronic?: ValidateSingleHoldingSaleRowBodyElectronic;
  /** Brinco extra (identificador interno) */
  identifier?: ValidateSingleHoldingSaleRowBodyIdentifier;
  sisbov?: ValidateSingleHoldingSaleRowBodySisbov;
  weight: number;
};

export type ListHoldingSalesParams = {
  batchName?: string;
  endDate?: string;
  maxExitWeightAverage?: number;
  maxOxenAmount?: number;
  maxTruckCount?: number;
  minExitWeightAverage?: number;
  minOxenAmount?: number;
  minTruckCount?: number;
  startDate?: string;
};

export type ActivateHealthProtocolParams = {
  active: boolean;
};

export type GetHealthProtocolParams = {
  name?: string;
};

export type ListHealthProtocolsParams = {
  active?: boolean;
};

export type ForeseenGtaDataGenders =
  (typeof ForeseenGtaDataGenders)[keyof typeof ForeseenGtaDataGenders];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForeseenGtaDataGenders = {
  ALL: "ALL",
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export type ForeseenGtaDataParams = {
  dateCount: number;
  genders: ForeseenGtaDataGenders;
  ownerId: number;
};

export type ListOfGtasForChargebackEnd =
  (typeof ListOfGtasForChargebackEnd)[keyof typeof ListOfGtasForChargebackEnd];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListOfGtasForChargebackEnd = {
  origin: "origin",
  destiny: "destiny",
} as const;

export type ListOfGtasForChargebackParams = {
  end: ListOfGtasForChargebackEnd;
  neededFemaleAges?: string;
  neededMaleAges?: string;
  partnerId?: number;
  purchaseId?: number;
};

export type ListGtasParams = {
  announcementEmmited?: boolean;
  completed?: boolean;
  gtaId?: number;
  originResponsibleId?: number;
  withoutPurchases?: boolean;
};

export type ListGeneralLogsParams = {
  category: EnumsGeneralLogCategory;
  entityId?: number;
  logType: string;
};

export type LoadFinancialReportParams = {
  end: string;
  start: string;
};

export type ListInvoicesParams = {
  hasExitTruck?: boolean;
  hasWeightingMap?: boolean;
  number?: string;
  series?: string;
};

export type UpdateFeedLinkTreatmentHourBody = {
  hour: string;
  id: number;
};

export type UpdateFeedLinkStatusBodyType =
  (typeof UpdateFeedLinkStatusBodyType)[keyof typeof UpdateFeedLinkStatusBodyType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateFeedLinkStatusBodyType = {
  treats: "treats",
  beats: "beats",
  beatIngredients: "beatIngredients",
  treatStatuses: "treatStatuses",
} as const;

export type UpdateFeedLinkStatusBody = {
  error?: string;
  id?: number;
  ids?: number[];
  status: EnumsFeedLinkStatus;
  type: UpdateFeedLinkStatusBodyType;
};

export type ReviewFeedLinkFilesBodyDecision =
  (typeof ReviewFeedLinkFilesBodyDecision)[keyof typeof ReviewFeedLinkFilesBodyDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewFeedLinkFilesBodyDecision = {
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
} as const;

export type ReviewFeedLinkFilesBody = {
  decision: ReviewFeedLinkFilesBodyDecision;
  ids?: number[];
  referenceDay?: string;
};

export type RemoveFeedLinkErrorBody = {
  beatIngredients: number[];
  beats: number[];
  treats: number[];
};

export type ProccessFeedLinkTreatStatusBody = {
  treatStatuses: unknown[];
};

export type ProccessFeedLinkDataBody = {
  beatIngredients: unknown[];
  beats: unknown[];
  treats: unknown[];
};

export type GetTreatmentHourByCorralPositionParams = {
  corralPosition: number;
};

export type CreateFeedLinkDataBody = {
  data: unknown[];
  error?: string;
  filename: string;
  slug: EnumsFeedLinkSlug;
};

export type UpdateWeightGainCurveStartedAtBody = {
  startedAt: string;
};

export type ListWeightGainCurvesParams = {
  gender?: EnumsOxGender;
  variety?: string;
};

export type CreateBatchWeightGainCurveParams = {
  filename: string;
  name?: string;
};

export type UpdateBiotypeWeightGainCurveParams = {
  filename: string;
  gender: EnumsOxGender;
  name: string;
  startedAt?: string;
  variety?: string;
};

export type UpdateWeightBreakGoalsParams = {
  filename: string;
};

export type UpdateTreatViewTypeBody = {
  treatViewType: EnumsTreatViewType;
};

export type UpdateFeedLinkConfigBody = {
  active: boolean;
  interval: number;
};

export type LookupFarmCredentialParams = {
  customerId: string;
  dbPort: number;
  serverIp: string;
};

export type FindExitGtasBody = {
  excludeTruckId?: number;
  gta: string;
  serie: string;
};

export type ListExitTrucksExitType =
  (typeof ListExitTrucksExitType)[keyof typeof ListExitTrucksExitType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListExitTrucksExitType = {
  BATCH: "BATCH",
  MANAGEMENT: "MANAGEMENT",
} as const;

export type ListExitTrucksParams = {
  date?: string;
  destiny?: string;
  destinyId?: number;
  endDate?: string;
  exitType?: ListExitTrucksExitType;
  gtaNumber?: string;
  info?: string;
  name?: string;
  notEmitted?: boolean;
  sale?: boolean;
  startDate?: string;
  status?: EnumsExitTruckStatus;
};

export type ActivateEstablishmentParams = {
  active: boolean;
};

export type ListEstablishmentsParams = {
  active?: boolean;
  destiny?: boolean;
  origin?: boolean;
};

export type RegisterEarringsParams = {
  purchaseId: number;
};

export type SucceedDietParams = {
  confirmed?: boolean;
  newDietId: number;
};

export type ActivateDietParams = {
  active: boolean;
};

export type ChangeBatchesDietBody = {
  batchesId: number[];
  confirmed?: boolean;
  newDietId: number;
};

export type ListAllDietsParams = {
  active?: boolean;
  category?: EnumsDietCategory;
  inUse?: boolean;
  isPremix?: boolean;
};

export type ListDietsParams = {
  active?: boolean;
  category?: EnumsDietCategory;
  inUse?: boolean;
  isPremix?: boolean;
};

export type ReplaceTargetDietInDietTransitionBody = {
  batchId: number;
  newDietId: number;
  oldDietId: number;
  transitionId: number;
};

export type MigratePhaseDietTransitionBody = {
  batchId: number;
  transitionId: number;
};

export type FinalizeDietTransitionBody = {
  batchId: number;
  transitionId: number;
};

export type ChangeTransitionBatchesDietBody = {
  batchesId: number[];
  confirmed?: boolean;
  newDietId: number;
  oldDietId: number;
};

export type ListDietTransitionsParams = {
  divisions?: number;
};

export type MoveBatchParams = {
  targetId: number;
};

export type ListCorralsSimplifiedParams = {
  day?: string;
  /**
   * Não tem lotes no momento
   */
  empty?: boolean;
  /**
   * Traz também, por curral, os lotes finalizados que passaram por ele.
   */
  inactiveBatches?: boolean;
  type?: EnumsCorralType;
};

export type ListCorralsAndBatchesType =
  (typeof ListCorralsAndBatchesType)[keyof typeof ListCorralsAndBatchesType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListCorralsAndBatchesType = {
  PICKET: "PICKET",
  PASTURE: "PASTURE",
} as const;

export type ListCorralsAndBatchesParams = {
  type: ListCorralsAndBatchesType;
  withExits?: boolean;
};

export type ListCorralParams = {
  day?: string;
  /**
   * Não tem lotes no momento
   */
  empty?: boolean;
  type?: EnumsCorralType;
};

export type UploadFileToCloudBody = {
  file: unknown;
};

export type RegisterNewTenantBody = {
  fromScratch?: boolean;
  tenant: string;
};

export type RemoveTenantParams = {
  tenant: string;
};

export type ListCattleManifestLayoutEstablishmentsParams = {
  search?: string;
};

export type ListCattleManifestLayoutsStatus =
  (typeof ListCattleManifestLayoutsStatus)[keyof typeof ListCattleManifestLayoutsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListCattleManifestLayoutsStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

export type ListCattleManifestLayoutsParams = {
  establishmentId?: number;
  status?: ListCattleManifestLayoutsStatus;
};

export type UpdateInvalidBeatRealizedsBody = {
  dietId: number;
  id: number[];
  newStockId: number;
};

export type DeleteInvalidBeatRealizedsBody = {
  dietId: number;
  id: number[];
};

export type PreviewBiotypeRollbackParams = {
  startDate: string;
};

export type ApplyCurveWithRecalculationParams = {
  curveId: number;
  startDate: string;
};

export type PreviewCurveRecalculationParams = {
  curveId: number;
  startDate: string;
};

export type ApplyBatchWeightGainCurveParams = {
  curveId: number;
};

export type RollbackBatchWeightGainCurveParams = {
  startDate?: string;
};

export type TransitionBatchDietParams = {
  dietId: number;
  transitionId: number;
};

export type RemoveBatchFromTreatmentBodyUntil = string | null;

export type RemoveBatchFromTreatmentBody = {
  remove: boolean;
  until?: RemoveBatchFromTreatmentBodyUntil;
};

export type MovimentOxenByBatchAndGtaIdBody = {
  description?: string;
  gtaId: number;
  newBatchId: number;
  oxenAmount: number;
  toEmpty?: boolean;
};

export type UpdateHoldingEntryAgesBodyAgesItem = {
  femaleTotal: number;
  id: number;
  maleTotal: number;
};

export type UpdateHoldingEntryAgesBody = {
  ages: UpdateHoldingEntryAgesBodyAgesItem[];
};

export type GetTroughManagementGraphParams = {
  end?: string;
  start?: string;
};

export type ChangeVarietyDeadOxenBody = {
  variety: string;
};

export type ChangeVarietyBody = {
  variety: string;
};

export type UpdateBatchAdjustedCostBody = {
  adjustedPurchaseCost: number;
};

export type AdjustBatchEntryWeightsBody = {
  /** Novo peso de entrada (kg) aplicado a todos os animais do relatório */
  weight: number;
};

export type AdjustBatchAverageWeightBody = {
  /** Novo peso médio (kg) aplicado a todos os animais vivos do lote */
  weight: number;
};

export type ActivateBatchParams = {
  dietId: number;
  liveWeight: number;
  treatmentId?: number;
};

export type EnsureBatchStatusesBodyCheckType =
  (typeof EnsureBatchStatusesBodyCheckType)[keyof typeof EnsureBatchStatusesBodyCheckType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnsureBatchStatusesBodyCheckType = {
  none_managed: "none managed",
  all_managed: "all managed",
  none_managed_or_all_managed: "none managed or all managed",
} as const;

export type EnsureBatchStatusesBody = {
  batchIds: number[];
  checkType: EnsureBatchStatusesBodyCheckType;
};

export type BatchesOxenParams = {
  corralId: number;
};

export type ListFinalizedBatchesParams = {
  limit?: number;
  page?: number;
};

export type ListBatchesSimplifiedStatus =
  (typeof ListBatchesSimplifiedStatus)[keyof typeof ListBatchesSimplifiedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListBatchesSimplifiedStatus = {
  active: "active",
  inactive: "inactive",
} as const;

export type ListBatchesSimplifiedCreatedAt =
  (typeof ListBatchesSimplifiedCreatedAt)[keyof typeof ListBatchesSimplifiedCreatedAt];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListBatchesSimplifiedCreatedAt = {
  activatedAt: "activatedAt",
  createdAt: "createdAt",
} as const;

export type ListBatchesSimplifiedParams = {
  createdAt?: ListBatchesSimplifiedCreatedAt;
  status?: ListBatchesSimplifiedStatus;
  type?: EnumsCorralType;
};

export type ListActiveAndFinalizedBatchesParams = {
  corralType?: EnumsCorralType;
  q?: string;
};

export type ListBatchesStatus =
  (typeof ListBatchesStatus)[keyof typeof ListBatchesStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListBatchesStatus = {
  active: "active",
  inactive: "inactive",
} as const;

export type ListBatchesCreatedAt =
  (typeof ListBatchesCreatedAt)[keyof typeof ListBatchesCreatedAt];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListBatchesCreatedAt = {
  activatedAt: "activatedAt",
  createdAt: "createdAt",
} as const;

export type ListBatchesParams = {
  createdAt?: ListBatchesCreatedAt;
  status?: ListBatchesStatus;
  type?: EnumsCorralType;
};

export type RefreshTokenBody = {
  oldRefresh: string;
};

export type AuditMoveOxParams = {
  auditId: number;
};

export type AuditOxIdentificationBodySisbov = number | null;

export type AuditOxIdentificationBody = {
  ageInMonths: number;
  auditId: number;
  /** O batch que o boi vai começar */
  batchId: number;
  breedBND?: string;
  dentitionStage?: EnumsDentitionStage;
  /** Dados do brinco eletrônico */
  electronic?: string;
  /** Id do protocolo de saúde */
  extraMedicineIds?: number[];
  gender?: EnumsOxGender;
  /** Id da gta */
  gtaId?: number;
  /** Id do protocolo de saúde */
  healthProtocolId?: number;
  identifiedAt?: string;
  identifier?: string;
  managementId: string;
  sisbov?: AuditOxIdentificationBodySisbov;
  tagColor?: string;
  weight: number;
};

export type RemoveGtasFromEntryAnnouncementBody = {
  gtaIds: number[];
};

export type GenerateUnusabilityBody = {
  date: string;
};

export type GenerateChangeOfCharacteristicsBody = {
  changeOfCharacteristicDate: string;
};

export type GenerateEntryAnnouncementExcelParams = {
  announcementEmmited?: boolean;
  appVersion?: string | null;
  completed?: boolean;
  filename: string;
  gtaId?: number;
  nonConformity?: boolean;
  originResponsibleId?: number;
  withoutPurchases?: boolean;
};

export type CheckGtasBody = {
  gtasId: number[];
};

export type ListDeadOxenWithoutAnnouncementParams = {
  diedAt?: string;
  sisbov?: string;
};

export type ListAnnouncementsParams = {
  date?: string;
  emitted?: boolean;
  limit?: number;
  onlyExpired?: boolean;
  owner?: string;
  page?: number;
  sisbov?: string;
  type?: EnumsAnnouncementType;
};

export type RestoreBatchBody = {
  ids: number[];
};

export interface GlobalPrismaJsonNightlyRead {
  hadFood: boolean;
  hour: string;
}

export interface GlobalPrismaJsonLatLng {
  lat: number;
  lng: number;
}

/**
 * Documentos de uma inscrição estadual de um estabelecimento / fazenda.
 */
export interface GlobalPrismaJsonGovDocuments {
  /** Número do ERAS */
  ERAS?: string;
  /** Número do registro no Instituto Nacional de Colonização e Reforma Agrária */
  INCRA?: string;
  /** Inscrição Estadual */
  IS?: string;
  /** Número do Imóvel na Receita Federal */
  NIRF?: string;
  [key: string]: string | unknown;
}

/**
 * Um array de boolean para como true -> novo trato e false -> trato antigo (length = quantia de dias).
 */
export type GlobalPrismaJsonDietTransitionDay = boolean[];

export type GlobalPrismaJsonAnnouncementData =
  | DeathAnnouncement[]
  | EntryAnnouncement
  | SaleAnnouncement
  | ExitAnnouncement[]
  | ReIdentificationAnnouncement[]
  | ChangeOfCharacteristicAnnouncement[]
  | UnusabilityAnnouncement[]
  | BirthAnnouncement[];

export type GlobalBufferBuffer = {
  byteLength: number;
};

export interface GlobalBuffer {
  buffer: GlobalBufferBuffer;
  byteLength: number;
  byteOffset: number;
  BYTES_PER_ELEMENT: number;
  length: number;
  [key: string]: number;
}

export interface ZootechnicalResumeItem {
  averageCarcassGain: number;
  averageConfinementDays: number;
  averageDryMatterConsumption: number;
  averageGDC: number;
  averageGPD: number;
  averageLiveWeightRate: number;
  averageNaturalMatterConsumption: number;
  averageTreatmentDays: number;
  biologicalEfficiency: number;
  entryAverageWeightAtSign: number;
  exitAverageCarcassWeight: number;
  exitAverageCarcassWeightAtSign: number;
  exitAverageWeight: number;
  exitCarcassYield: number;
  foodConversion: number;
  initialAverageWeight: number;
  mortalityRate: number;
  oxenEntries: number;
  oxenIndirectEntries: number;
  pastureReturnOxenAmount: number;
  totalDeaths: number;
  totalOxenExit: number;
}

export interface ZootechnicalInfo {
  carcassYield: number;
  deadWeightInAt: number;
  deadWeightInKg: number;
  exitWeightAverage: number;
  GMDKgPerDay: number;
  processedDaysAveraged: number;
  processedWeightAverage: number;
  processedWeightAverageInKg: number;
  rightWeight: number;
  totalWeight: number;
}

export type ZootechnicalHeaderItemInitialAverageDate = string | null;

export type ZootechnicalHeaderItemExitAverageDate = string | null;

export interface ZootechnicalHeaderItem {
  averageCarcassGain: number;
  averageConfinementDays: number;
  averageDaysWithoutProcessing: number;
  averageDryMatterConsumption: number;
  averageGDC: number;
  averageGPD: number;
  averageLiveWeightRate: number;
  averageNaturalMatterConsumption: number;
  averageTreatmentDays: number;
  batchName: string;
  biologicalEfficiency: number;
  categories: EnumsOxGender[];
  corralName: string;
  cov: number;
  deadOxenAmount: number;
  entryAverageWeightAtSign: number;
  entryTypes: EnumsOxPurpose[];
  exitAverageCarcassWeight: number;
  exitAverageCarcassWeightAtSign: number;
  exitAverageDate: ZootechnicalHeaderItemExitAverageDate;
  exitAverageWeight: number;
  exitCarcassYield: number;
  foodConversion: number;
  initialAverageDate: ZootechnicalHeaderItemInitialAverageDate;
  initialAverageWeight: number;
  mortalityRate: number;
  ownersNames: string[];
  pastureReturnOxenAmount: number;
  slaughteredOxenAmount: number;
  totalCarcassGain: number;
  totalTreatmentDays: number;
  varieties: string[];
}

export interface ZootechnicalReportServiceResponse {
  headers: ZootechnicalHeaderItem[];
  resume: ZootechnicalResumeItem;
}

export type WeightType = EnumsWeightType;

export type WeightGainCurveType = EnumsWeightGainCurveType;

export interface WeighingReportResponse {
  items: WeighingReportItem[];
}

export type WeighingReportItemWeighingDate = string | null;

export type WeighingReportItemSisbov = string | null;

export type WeighingReportItemPurchase = string | null;

export type WeighingReportItemProcessingDate = string | null;

export type WeighingReportItemPreviousWeightAnyOf = {
  date?: string;
  source?: string;
  type?: string;
  weight: number;
};

export type WeighingReportItemPreviousWeight =
  WeighingReportItemPreviousWeightAnyOf | null;

export type WeighingReportItemPreviousWeighingDate = string | null;

export type WeighingReportItemPartner = string | null;

export type WeighingReportItemOwner = string | null;

export type WeighingReportItemOriginBatch = string | null;

export type WeighingReportItemMapa = string | null;

export type WeighingReportItemIdentifier = string | null;

export type WeighingReportItemGta = string | null;

export type WeighingReportItemGpd = number | null;

export type WeighingReportItemGmd = number | null;

export interface WeighingReportItem {
  confinementDays: number;
  currentWeight: WeighingReportItemCurrentWeight;
  daysBetweenWeighings: WeighingDaysBetweenWeighings[];
  destinyBatch: WeighingReportItemDestinyBatch;
  electronic: WeighingReportItemElectronic;
  firstWeight: WeighingReportItemFirstWeight;
  gmd: WeighingReportItemGmd;
  gpd: WeighingReportItemGpd;
  gta: WeighingReportItemGta;
  identifier: WeighingReportItemIdentifier;
  manegementType: string;
  mapa: WeighingReportItemMapa;
  originBatch: WeighingReportItemOriginBatch;
  owner: WeighingReportItemOwner;
  partner: WeighingReportItemPartner;
  previousWeighingDate: WeighingReportItemPreviousWeighingDate;
  previousWeight: WeighingReportItemPreviousWeight;
  processingDate: WeighingReportItemProcessingDate;
  purchase: WeighingReportItemPurchase;
  sisbov: WeighingReportItemSisbov;
  weighingDate: WeighingReportItemWeighingDate;
}

export type WeighingReportItemFirstWeightAnyOf = {
  date?: string;
  source?: string;
  type?: string;
  weight: number;
};

export type WeighingReportItemFirstWeight =
  WeighingReportItemFirstWeightAnyOf | null;

export type WeighingReportItemElectronic = string | null;

export type WeighingReportItemDestinyBatch = string | null;

export type WeighingReportItemCurrentWeightAnyOf = {
  date?: string;
  source?: string;
  type?: string;
  weight: number;
};

export type WeighingReportItemCurrentWeight =
  WeighingReportItemCurrentWeightAnyOf | null;

export interface WeighingOx {
  customDate?: string;
  electronic?: string;
  extraMedicineIds?: number[];
  healthProtocolId?: number;
  identifier?: string;
  /** UUID da sessão de manejo (`managements.uuid`) tipo WEIGHING — opcional. Quando informado, registra linha no comprovante/extrato (não altera cálculos de peso). */
  managementSessionUuid?: string;
  oxId?: number;
  sisbov?: number;
  type?: EnumsWeightType;
  weight: number;
}

export interface WeighingDaysBetweenWeighings {
  days: number;
}

export interface WarmupActiveBatchesConsumeResponse {
  blocked: boolean;
  enqueued: number;
  missing: number;
  pending: number;
  running: number;
}

export interface VerifyPasswordResetCodeResponse {
  expiresAt: string;
  /** Token de uso único exigido para definir a nova senha. */
  resetToken: string;
}

export interface VerifyPasswordResetCodeBody {
  code: string;
  email: string;
}

export interface VerifyEmailBody {
  code: string;
  email: string;
}

export interface ValidateCattleManifestLayoutSampleResponse {
  errors: CattleManifestRowError[];
  validAnimals: CattleManifestConsolidatedAnimal[];
}

export interface ValidateCattleManifestLayoutSampleBody {
  filename: string;
}

export type ValidOxStatus = (typeof ValidOxStatus)[keyof typeof ValidOxStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidOxStatus = {
  OK: "OK",
} as const;

export type ValidOxSisbov = string | null;

export type ValidOxExtraEarring = string | null;

export type ValidOxElectronic = string | null;

export type ValidOxDentition = string | null;

export interface ValidOx {
  batchId: number;
  breed: string;
  category: string;
  dentition: ValidOxDentition;
  electronic: ValidOxElectronic;
  extraEarring: ValidOxExtraEarring;
  identifier: string;
  line: number;
  oxId: number;
  sisbov: ValidOxSisbov;
  status: ValidOxStatus;
  weight: number;
}

export type UpsertTruckInvoicesResponse = UpsertTruckInvoicesResponseItem[];

export type UpsertTruckInvoicesResponseItemWeightingMapId = number | null;

export type UpsertTruckInvoicesResponseItemSaleOrderId = number | null;

export type UpsertTruckInvoicesResponseItemIsComplement = boolean | null;

export type UpsertTruckInvoicesResponseItemExitTruckId = number | null;

export type UpsertTruckInvoicesResponseItemEmittedAt = string | null;

export type UpsertTruckInvoicesResponseItem = {
  emittedAt: UpsertTruckInvoicesResponseItemEmittedAt;
  exitTruckId: UpsertTruckInvoicesResponseItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: UpsertTruckInvoicesResponseItemIsComplement;
  number: string;
  saleOrderId: UpsertTruckInvoicesResponseItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: UpsertTruckInvoicesResponseItemWeightingMapId;
};

export interface UploadFileToCloudResponse {
  filepath: string;
}

export type UpdateWeightingMapResponseTotalWeight = number | null;

export type UpdateWeightingMapResponseTotalPurchase = number | null;

export type UpdateWeightingMapResponseSupplementedRearingModality =
  EnumsSupplementedRearingModality | null;

export type UpdateWeightingMapResponseStartTime = string | null;

export type UpdateWeightingMapResponseReferenceCode = string | null;

export type UpdateWeightingMapResponsePurchaseId = number | null;

export type UpdateWeightingMapResponsePricePerArroba = number | null;

export type UpdateWeightingMapResponseNetWeight = number | null;

export interface UpdateWeightingMapResponse {
  averageWeight: UpdateWeightingMapResponseAverageWeight;
  buyer: UpdateWeightingMapResponseBuyer;
  buyerId: number;
  carcassYield: UpdateWeightingMapResponseCarcassYield;
  closingTime: UpdateWeightingMapResponseClosingTime;
  commission: number;
  emissionDate: string;
  endTime: UpdateWeightingMapResponseEndTime;
  farmId: number;
  fastingDate: UpdateWeightingMapResponseFastingDate;
  grossWeight: UpdateWeightingMapResponseGrossWeight;
  gtas: UpdateWeightingMapResponseGtasItem[];
  id: number;
  invoices: UpdateWeightingMapResponseInvoicesItem[];
  netWeight: UpdateWeightingMapResponseNetWeight;
  pricePerArroba: UpdateWeightingMapResponsePricePerArroba;
  purchaseId: UpdateWeightingMapResponsePurchaseId;
  referenceCode: UpdateWeightingMapResponseReferenceCode;
  shippingCost: number;
  startTime: UpdateWeightingMapResponseStartTime;
  status: EnumsWeightingMapStatus;
  supplementedRearingModality: UpdateWeightingMapResponseSupplementedRearingModality;
  totalPurchase: UpdateWeightingMapResponseTotalPurchase;
  totalWeight: UpdateWeightingMapResponseTotalWeight;
  weighingDate: string;
}

export type UpdateWeightingMapResponseInvoicesItemWeightingMapId =
  | number
  | null;

export type UpdateWeightingMapResponseInvoicesItemSaleOrderId = number | null;

export type UpdateWeightingMapResponseInvoicesItemIsComplement = boolean | null;

export type UpdateWeightingMapResponseInvoicesItemExitTruckId = number | null;

export type UpdateWeightingMapResponseInvoicesItemEmittedAt = string | null;

export type UpdateWeightingMapResponseInvoicesItem = {
  emittedAt: UpdateWeightingMapResponseInvoicesItemEmittedAt;
  exitTruckId: UpdateWeightingMapResponseInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: UpdateWeightingMapResponseInvoicesItemIsComplement;
  number: string;
  saleOrderId: UpdateWeightingMapResponseInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: UpdateWeightingMapResponseInvoicesItemWeightingMapId;
};

export type UpdateWeightingMapResponseGtasItemWeightingMapId = number | null;

export type UpdateWeightingMapResponseGtasItemWeightAverage = number | null;

export type UpdateWeightingMapResponseGtasItemPurchaseId = number | null;

export type UpdateWeightingMapResponseGtasItemOriginWeightAverage =
  | number
  | null;

export type UpdateWeightingMapResponseGtasItemInvoice = string | null;

export type UpdateWeightingMapResponseGtasItemHours = number | null;

export type UpdateWeightingMapResponseGtasItemDistance = number | null;

export type UpdateWeightingMapResponseGtasItemDestinyId = number | null;

export type UpdateWeightingMapResponseGtasItemDescription = string | null;

export type UpdateWeightingMapResponseGtasItem = {
  completed: boolean;
  description: UpdateWeightingMapResponseGtasItemDescription;
  destinyId: UpdateWeightingMapResponseGtasItemDestinyId;
  distance: UpdateWeightingMapResponseGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: UpdateWeightingMapResponseGtasItemHours;
  id: number;
  invoice: UpdateWeightingMapResponseGtasItemInvoice;
  number: string;
  originId: number;
  originWeightAverage: UpdateWeightingMapResponseGtasItemOriginWeightAverage;
  purchaseId: UpdateWeightingMapResponseGtasItemPurchaseId;
  series: string;
  weightAverage: UpdateWeightingMapResponseGtasItemWeightAverage;
  weightingMapId: UpdateWeightingMapResponseGtasItemWeightingMapId;
};

export type UpdateWeightingMapResponseGrossWeight = number | null;

export type UpdateWeightingMapResponseFastingDate = string | null;

export type UpdateWeightingMapResponseEndTime = string | null;

export type UpdateWeightingMapResponseClosingTime = string | null;

export type UpdateWeightingMapResponseCarcassYield = number | null;

export type UpdateWeightingMapResponseBuyerPhone = string | null;

export type UpdateWeightingMapResponseBuyerDocument = string | null;

export type UpdateWeightingMapResponseBuyerDescription = string | null;

export type UpdateWeightingMapResponseBuyerCode = string | null;

export type UpdateWeightingMapResponseBuyer = {
  code: UpdateWeightingMapResponseBuyerCode;
  createdAt: string;
  description: UpdateWeightingMapResponseBuyerDescription;
  document: UpdateWeightingMapResponseBuyerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: UpdateWeightingMapResponseBuyerPhone;
  profiles: EnumsProfile[];
};

export type UpdateWeightingMapResponseAverageWeight = number | null;

export type UpdateUnusabilityAnnouncementResponseExpiresAt = string | null;

export type UpdateUnusabilityAnnouncementResponseEmittedAt = string | null;

export type UpdateUnusabilityAnnouncementResponseCreatedAt = string | null;

export interface UpdateUnusabilityAnnouncementResponse {
  createdAt: UpdateUnusabilityAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: UpdateUnusabilityAnnouncementResponseEmittedAt;
  expiresAt: UpdateUnusabilityAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export interface UpdateUnusabilityAnnouncement {
  brand: string;
  observation?: string;
  sisbov: number;
}

export interface UpdateTruck {
  bigWeighingMachineWeightKg?: number;
  capacity?: number;
  destinyId?: number;
  exitGta?: string;
  exitGtaSeries?: string;
  info?: string;
  invoicesIds?: number[];
  name?: string;
  plate?: string;
}

export interface UpdateTreatmentPlanBody {
  divisions?: number[];
  hours?: string[];
  name?: string;
}

export interface UpdateTreatViewTypeResponse {
  treatViewType: EnumsTreatViewType;
}

export type UpdateTreatResponseSequence = number | null;

export type UpdateTreatResponseRealizedAt = string | null;

export type UpdateTreatResponseOxenCount = number | null;

export type UpdateTreatResponseOriginalNaturalMatter = number | null;

export type UpdateTreatResponseOrder = number | null;

export type UpdateTreatResponseMixerId = number | null;

export type UpdateTreatResponseForeseenNaturalMatter = number | null;

export type UpdateTreatResponseFinalDryMatter = number | null;

export type UpdateTreatResponseFeederId = number | null;

export type UpdateTreatResponseConcludedProportion = number | null;

export type UpdateTreatResponseConcludedNaturalMatter = number | null;

export type UpdateTreatResponseConcludedAt = string | null;

export interface UpdateTreatResponse {
  batchId: number;
  concluded: boolean;
  concludedAt: UpdateTreatResponseConcludedAt;
  concludedNaturalMatter: UpdateTreatResponseConcludedNaturalMatter;
  concludedProportion: UpdateTreatResponseConcludedProportion;
  day: string;
  dietId: number;
  farmId: number;
  feederId: UpdateTreatResponseFeederId;
  finalDryMatter: UpdateTreatResponseFinalDryMatter;
  first: boolean;
  foreseenNaturalMatter: UpdateTreatResponseForeseenNaturalMatter;
  id: number;
  key: string;
  mixerId: UpdateTreatResponseMixerId;
  order: UpdateTreatResponseOrder;
  originalNaturalMatter: UpdateTreatResponseOriginalNaturalMatter;
  oxenCount: UpdateTreatResponseOxenCount;
  realizedAt: UpdateTreatResponseRealizedAt;
  realizedNaturalMatter: number;
  sequence: UpdateTreatResponseSequence;
}

export type UpdateTreatRealizedResponseSequence = number | null;

export type UpdateTreatRealizedResponseRealizedAt = string | null;

export type UpdateTreatRealizedResponseOxenCount = number | null;

export type UpdateTreatRealizedResponseOriginalNaturalMatter = number | null;

export type UpdateTreatRealizedResponseOrder = number | null;

export type UpdateTreatRealizedResponseMixerId = number | null;

export type UpdateTreatRealizedResponseForeseenNaturalMatter = number | null;

export type UpdateTreatRealizedResponseFinalDryMatter = number | null;

export type UpdateTreatRealizedResponseFeederId = number | null;

export type UpdateTreatRealizedResponseConcludedProportion = number | null;

export type UpdateTreatRealizedResponseConcludedNaturalMatter = number | null;

export type UpdateTreatRealizedResponseConcludedAt = string | null;

export interface UpdateTreatRealizedResponse {
  batchId: number;
  concluded: boolean;
  concludedAt: UpdateTreatRealizedResponseConcludedAt;
  concludedNaturalMatter: UpdateTreatRealizedResponseConcludedNaturalMatter;
  concludedProportion: UpdateTreatRealizedResponseConcludedProportion;
  day: string;
  dietId: number;
  farmId: number;
  feederId: UpdateTreatRealizedResponseFeederId;
  finalDryMatter: UpdateTreatRealizedResponseFinalDryMatter;
  first: boolean;
  foreseenNaturalMatter: UpdateTreatRealizedResponseForeseenNaturalMatter;
  id: number;
  key: string;
  mixerId: UpdateTreatRealizedResponseMixerId;
  order: UpdateTreatRealizedResponseOrder;
  originalNaturalMatter: UpdateTreatRealizedResponseOriginalNaturalMatter;
  oxenCount: UpdateTreatRealizedResponseOxenCount;
  realizedAt: UpdateTreatRealizedResponseRealizedAt;
  realizedNaturalMatter: number;
  sequence: UpdateTreatRealizedResponseSequence;
}

export interface UpdateTreatRealizedDto {
  feederId?: number;
  foreseenNaturalMatter?: number;
  order?: number;
  originalNaturalMatter?: number;
  realizedNaturalMatter?: number;
}

export interface UpdateTreat {
  /** Id do tratador que realizou o trato */
  feederId?: number;
}

export interface UpdateStructureResponse {
  category: EnumsStructureCategory;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
}

export interface UpdateStructure {
  category?: EnumsStructureCategory;
  name?: string;
}

export type UpdateStockTimelineEntriesItem = {
  /** Quantidade em kg/MN lançada no dia, somada ao saldo daquele dia em diante. Negativa retira do saldo. */
  amount?: number;
  date: string;
  kiloPrice?: number;
};

/**
 * Somente os dias corrigidos. Dias omitidos herdam o último valor/saldo informado.
 */
export interface UpdateStockTimeline {
  entries: UpdateStockTimelineEntriesItem[];
}

export interface UpdateStockInvoice {
  /** Peso declarado na nota fiscal (saída da fábrica) */
  billedWeight?: number;
  /** ID da nota fiscal */
  id: number;
  /** Número da nota fiscal do caminhão que chegou com o pedido */
  number?: string;
  /** Preço declarado na nota fiscal */
  price?: number;
  /** Data de recebimento da nota fiscal */
  receivedAt?: string;
  /** Peso aferido na fazenda (chegada do caminhão) */
  receivedWeight?: number;
}

export type UpdateStockCodeResponsePremix = boolean | null;

export type UpdateStockCodeResponseActive = boolean | null;

export interface UpdateStockCodeResponse {
  active: UpdateStockCodeResponseActive;
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: UpdateStockCodeResponsePremix;
  supplement: boolean;
}

export interface UpdateStockCode {
  code: string;
  id: number;
}

export interface UpdateSaleOrderWeightsBody {
  exitWeight: number;
}

export type UpdateSaleOrderResponseTypeOfClosed = EnumsSaleOrderType | null;

export type UpdateSaleOrderResponseSourceType = EnumsSaleOrderSourceType | null;

export type UpdateSaleOrderResponsePartnerClosureId = number | null;

export type UpdateSaleOrderResponsePartnerAtSignPriceM = number | null;

export type UpdateSaleOrderResponsePartnerAtSignPriceF = number | null;

export type UpdateSaleOrderResponseFreightPerAtSignBRL = number | null;

export interface UpdateSaleOrderResponse {
  announcementId: UpdateSaleOrderResponseAnnouncementId;
  atSignPrice: UpdateSaleOrderResponseAtSignPrice;
  bonusPercent: UpdateSaleOrderResponseBonusPercent;
  complementInvoices: UpdateSaleOrderResponseComplementInvoicesItem[];
  createdAt: string;
  createdBy: number;
  destinyId: number;
  expirationDay: string;
  farmId: number;
  freightPerAtSignBRL: UpdateSaleOrderResponseFreightPerAtSignBRL;
  id: number;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF: UpdateSaleOrderResponsePartnerAtSignPriceF;
  partnerAtSignPriceM: UpdateSaleOrderResponsePartnerAtSignPriceM;
  partnerClosureId: UpdateSaleOrderResponsePartnerClosureId;
  paymentMethod: string;
  saleDate: string;
  sourceType: UpdateSaleOrderResponseSourceType;
  status: EnumsSaleOrderStatus;
  typeOfClosed: UpdateSaleOrderResponseTypeOfClosed;
}

export type UpdateSaleOrderResponseComplementInvoicesItemWeightingMapId =
  | number
  | null;

export type UpdateSaleOrderResponseComplementInvoicesItemSaleOrderId =
  | number
  | null;

export type UpdateSaleOrderResponseComplementInvoicesItemIsComplement =
  | boolean
  | null;

export type UpdateSaleOrderResponseComplementInvoicesItemExitTruckId =
  | number
  | null;

export type UpdateSaleOrderResponseComplementInvoicesItemEmittedAt =
  | string
  | null;

export type UpdateSaleOrderResponseComplementInvoicesItem = {
  emittedAt: UpdateSaleOrderResponseComplementInvoicesItemEmittedAt;
  exitTruckId: UpdateSaleOrderResponseComplementInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: UpdateSaleOrderResponseComplementInvoicesItemIsComplement;
  number: string;
  saleOrderId: UpdateSaleOrderResponseComplementInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: UpdateSaleOrderResponseComplementInvoicesItemWeightingMapId;
};

export type UpdateSaleOrderResponseBonusPercent = number | null;

export type UpdateSaleOrderResponseAtSignPrice = number | null;

export type UpdateSaleOrderResponseAnnouncementId = number | null;

export interface UpdateSaleOrderByExcelBody {
  filename: string;
}

export interface UpdateRecipeResponse {
  capacityMn: number;
  code: number;
  createdAt: string;
  dietId: number;
  farmId: number;
  id: number;
  mixerId: number;
}

export interface UpdateRecipe {
  capacityMn?: number;
  code?: number;
  dietId?: number;
  mixerId?: number;
}

export type UpdateReIdentificationAnnouncementResponseExpiresAt = string | null;

export type UpdateReIdentificationAnnouncementResponseEmittedAt = string | null;

export type UpdateReIdentificationAnnouncementResponseCreatedAt = string | null;

export interface UpdateReIdentificationAnnouncementResponse {
  createdAt: UpdateReIdentificationAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: UpdateReIdentificationAnnouncementResponseEmittedAt;
  expiresAt: UpdateReIdentificationAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export interface UpdateReIdentificationAnnouncement {
  createdAt?: string;
  newSisbov: number;
  oldSisbov: number;
  oxId: number;
}

export type UpdatePremixResponsePremix = boolean | null;

export type UpdatePremixResponseActive = boolean | null;

export interface UpdatePremixResponse {
  active: UpdatePremixResponseActive;
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: UpdatePremixResponsePremix;
  supplement: boolean;
}

export type UpdatePremixIngredientsItem = {
  percentage: number;
  stockId: number;
};

export interface UpdatePremix {
  autoUpdateFactor?: boolean;
  code?: string;
  ingredients: UpdatePremixIngredientsItem[];
  name: string;
}

export type UpdatePersonResponsePhone = string | null;

export type UpdatePersonResponseDocument = string | null;

export type UpdatePersonResponseDescription = string | null;

export type UpdatePersonResponseCode = string | null;

export interface UpdatePersonResponse {
  code: UpdatePersonResponseCode;
  createdAt: string;
  description: UpdatePersonResponseDescription;
  document: UpdatePersonResponseDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: UpdatePersonResponsePhone;
  profiles: EnumsProfile[];
}

export interface UpdatePerson {
  /** Código do funcionário no tracer */
  code?: string;
  description?: string;
  document?: string;
  imageUrl?: string;
  name?: string;
  phone?: string;
  profiles?: EnumsProfile[];
  user?: UpdatePersonUser;
}

export type UpdatePersonUserPassword = string | null;

export type UpdatePersonUserEmail = string | null;

export type UpdatePersonUser = {
  email: UpdatePersonUserEmail;
  gov?: GlobalPrismaJsonGovDocuments;
  password: UpdatePersonUserPassword;
};

export type UpdatePartnerClosureV2ResponseObservation = string | null;

export interface UpdatePartnerClosureV2Response {
  closingDate: string;
  createdAt: string;
  farmId: number;
  finalValue: number;
  id: number;
  observation: UpdatePartnerClosureV2ResponseObservation;
  oxenPurchaseId: number;
  type: EnumsPartnerClosureV2Type;
}

export interface UpdatePartnerClosureV2Request {
  boitel?: CreatePartnerClosureBoitelData;
  classic?: CreatePartnerClosureClassicData;
  closingDate: string;
  fatCattle?: CreatePartnerClosureFatCattleData;
  finalValue: number;
  observation?: string;
}

export interface UpdatePartnerClosureResponse {
  createdAt: string;
  farmId: number;
  finalSalePrice: number;
  id: number;
  oxenPurchaseId: number;
}

export interface UpdateOxenPurchase {
  buyerId?: number;
  commission?: number;
  /** Desconto (%) aplicado na parceria */
  discountPercent?: number;
  femaleDailyPrice?: number;
  femaleEntryCarcassYield?: number;
  femaleFutureAnimalPrice?: number;
  femaleProducedPrice?: number;
  gtaIds?: number[];
  invoice?: string;
  issuedAt?: string;
  maleDailyPrice?: number;
  maleEntryCarcassYield?: number;
  maleFutureAnimalPrice?: number;
  maleProducedPrice?: number;
  mapa?: string;
  name?: string;
  observation?: string;
  ownerId?: number;
  oxenAmount?: number;
  partnerHerd?: string;
  partnerId?: number;
  price?: number;
  purpose?: EnumsOxPurpose;
  series?: string;
  shipping?: number;
  traceable?: boolean;
  weighingAt?: string;
  weightAverage?: number;
  weightingMapIds?: number[];
}

export interface UpdateOxWeightsBodyItem {
  weight: number;
  weightId: number;
}

export interface UpdateOxWeightsBody {
  weights: UpdateOxWeightsBodyItem[];
}

export interface UpdateOxPriceTableMonthValueRequest {
  month: number;
  price: number;
  year: number;
}

export type UpdateOxPerformanceRequestGender =
  (typeof UpdateOxPerformanceRequestGender)[keyof typeof UpdateOxPerformanceRequestGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOxPerformanceRequestGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export interface UpdateOxPerformanceRequest {
  exitCarcassYield: number;
  exitWeight: number;
  gender: UpdateOxPerformanceRequestGender;
  gmd: number;
  minimumEntryWeight: number;
  referenceDays: number;
  slaughterWeight: number;
}

export interface UpdateOxHealthByOxIdResponse {
  [key: string]: any;
}

export interface UpdateOxBody {
  ageInMonths?: number;
  breed?: string;
  category?: EnumsOxCategory;
  electronic?: string;
  gender?: EnumsOxGender;
  salesMarketType?: EnumsSalesMarketType;
  sisbov?: string;
  weight?: number;
}

export interface UpdateOperationalCostMonthValueRequest {
  groupId: number;
  month: number;
  totalMonthlyCost: number;
}

export interface UpdateOperationalCostBatchesRequest {
  batchIds: number[];
  groupId: number;
}

export interface UpdateMixerResponse {
  active: boolean;
  code: number;
  createdAt: string;
  distributor: boolean;
  farmId: number;
  id: number;
  mixer: boolean;
  mixerType: EnumsMixerType;
  mixTime: string;
  name: string;
  rounding: number;
}

export interface UpdateMixer {
  code?: number;
  distributor?: boolean;
  mixer?: boolean;
  mixerType?: EnumsMixerType;
  mixTime?: string;
  name?: string;
  rounding?: number;
}

export type UpdateMedicineResponsePerKg = number | null;

export type UpdateMedicineResponseKiloDose = number | null;

export type UpdateMedicineResponseApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export interface UpdateMedicineResponse {
  active: boolean;
  applicationSuggestion: UpdateMedicineResponseApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: UpdateMedicineResponseKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: UpdateMedicineResponsePerKg;
  type: EnumsMedicineType;
}

export type UpdateMedicinePerKg = number | null;

export interface UpdateMedicine {
  applicationSuggestion?: EnumsApplicationSuggestion;
  blockingDays?: number;
  dosePrice?: number;
  kiloDose?: number;
  manufacturer?: string;
  measurement?: EnumsMeasurement;
  name?: string;
  perKg?: UpdateMedicinePerKg;
  type?: EnumsMedicineType;
}

export type UpdateManagementSessionResponseFinishedById = number | null;

export interface UpdateManagementSessionResponse {
  createdAt: string;
  data: unknown;
  farmId: number;
  finishedById: UpdateManagementSessionResponseFinishedById;
  id: number;
  name: string;
  status: EnumsManagementStatus;
  type: EnumsTypeManagement;
  updatedAt: string;
  uuid: string;
}

export type UpdateManagementSessionData = { [key: string]: any };

export interface UpdateManagementSession {
  data?: UpdateManagementSessionData;
  name?: string;
  type?: EnumsTypeManagement;
}

export interface UpdateInvoice {
  emittedAt: string;
  exitTruckId?: number;
  isComplement?: boolean;
  number?: string;
  series?: string;
  value?: number;
}

export interface UpdateInternalSaleGtasResponse {
  gtas: string[];
  id: number;
}

export interface UpdateInternalSaleGtasBody {
  gtas: string[];
}

export interface UpdateIdentifierBody {
  identifier: string;
  newIdentifier: string;
  oxId: number;
}

export interface UpdateHoldingSaleWeightsBody {
  exitWeight: number;
}

export type UpdateHoldingSaleResponseName = string | null;

export interface UpdateHoldingSaleResponse {
  batchId: number;
  date: string;
  id: number;
  name: UpdateHoldingSaleResponseName;
}

export interface UpdateHoldingEntryDateBody {
  currentDate: string;
  dryRun: boolean;
  newDate: string;
  oxIds: number[];
}

export type UpdateGtaResponseWeightingMapId = number | null;

export type UpdateGtaResponseWeightAverage = number | null;

export type UpdateGtaResponsePurchaseId = number | null;

export type UpdateGtaResponseOriginWeightAverage = number | null;

export type UpdateGtaResponseInvoice = string | null;

export type UpdateGtaResponseHours = number | null;

export type UpdateGtaResponseDistance = number | null;

export type UpdateGtaResponseDestinyId = number | null;

export type UpdateGtaResponseDescription = string | null;

export interface UpdateGtaResponse {
  completed: boolean;
  description: UpdateGtaResponseDescription;
  destinyId: UpdateGtaResponseDestinyId;
  distance: UpdateGtaResponseDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: UpdateGtaResponseHours;
  id: number;
  invoice: UpdateGtaResponseInvoice;
  number: string;
  originId: number;
  originWeightAverage: UpdateGtaResponseOriginWeightAverage;
  purchaseId: UpdateGtaResponsePurchaseId;
  series: string;
  weightAverage: UpdateGtaResponseWeightAverage;
  weightingMapId: UpdateGtaResponseWeightingMapId;
}

export type UpdateGtaOxenAgesItem = {
  femaleTotal: number;
  maleTotal: number;
  yearsOld: number;
};

export interface UpdateGta {
  description?: string;
  destinyId?: number;
  distance?: number;
  emission?: string;
  entry?: string;
  expiration?: string;
  hours?: number;
  invoice?: string;
  number?: string;
  originId?: number;
  originWeightAverage?: number;
  oxenAges?: UpdateGtaOxenAgesItem[];
  series?: string;
  weightAverage?: number;
}

export type UpdateFoodPurchaseResponse = unknown;

export interface UpdateFoodPurchase {
  amount?: number;
  invoice?: string;
  invoices?: UpdateStockInvoice[];
  issuedAt?: string;
  name?: string;
  observation?: string;
  partnerHerd?: string;
  price?: number;
  series?: string;
  stockId?: number;
}

export interface UpdateFeedLinkConfigResponse {
  active: boolean;
  farmId: number;
  id: number;
  interval: number;
}

export type UpdateFarmStartDateResponseDirection =
  (typeof UpdateFarmStartDateResponseDirection)[keyof typeof UpdateFarmStartDateResponseDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateFarmStartDateResponseDirection = {
  BACKWARD: "BACKWARD",
  FORWARD: "FORWARD",
} as const;

export interface UpdateFarmStartDateResponse {
  affected: FarmStartDateAffected;
  after: string;
  applied: boolean;
  before: string;
  direction: UpdateFarmStartDateResponseDirection;
  dryRun: boolean;
  warnings: string[];
}

export interface UpdateFarmStartDateBody {
  createdAt: string;
  dryRun: boolean;
}

export type UpdateFarmResponseSenarPercent = number | null;

export type UpdateFarmResponseMatinalReadTime = string | null;

export type UpdateFarmResponseLastCertifierImport = string | null;

export type UpdateFarmResponseLastBndImport = string | null;

export type UpdateFarmResponseInstallRunId = string | null;

export type UpdateFarmResponseCustomerId = string | null;

export type UpdateFarmResponseCorrectionPercent = number | null;

export type UpdateFarmResponseAlias = string | null;

export interface UpdateFarmResponse {
  addressId: number;
  alias: UpdateFarmResponseAlias;
  blockedDays: number;
  correctionPercent: UpdateFarmResponseCorrectionPercent;
  createdAt: string;
  customerId: UpdateFarmResponseCustomerId;
  dailyCost: number;
  day: string;
  divisionThreshold: number;
  factory: GlobalPrismaJsonLatLng[];
  gradeInfo: unknown;
  gradeMethod: EnumsGradeMethod;
  hasAutomation: boolean;
  hasTraceability: boolean;
  id: number;
  installRunId: UpdateFarmResponseInstallRunId;
  interestRate: number;
  lastBndImport: UpdateFarmResponseLastBndImport;
  lastCertifierImport: UpdateFarmResponseLastCertifierImport;
  managementConfig: unknown;
  matinalReadTime: UpdateFarmResponseMatinalReadTime;
  name: string;
  nightlyReadTimes: string[];
  position: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification: boolean;
  sapId: string;
  senarPercent: UpdateFarmResponseSenarPercent;
  treatViewType: EnumsTreatViewType;
}

export type UpdateFarmConfigResponseSenarPercent = number | null;

export type UpdateFarmConfigResponseMatinalReadTime = string | null;

export type UpdateFarmConfigResponseLastCertifierImport = string | null;

export type UpdateFarmConfigResponseLastBndImport = string | null;

export type UpdateFarmConfigResponseInstallRunId = string | null;

export type UpdateFarmConfigResponseCustomerId = string | null;

export type UpdateFarmConfigResponseCorrectionPercent = number | null;

export type UpdateFarmConfigResponseAlias = string | null;

export interface UpdateFarmConfigResponse {
  addressId: number;
  alias: UpdateFarmConfigResponseAlias;
  blockedDays: number;
  correctionPercent: UpdateFarmConfigResponseCorrectionPercent;
  createdAt: string;
  customerId: UpdateFarmConfigResponseCustomerId;
  dailyCost: number;
  day: string;
  divisionThreshold: number;
  factory: GlobalPrismaJsonLatLng[];
  gradeInfo: unknown;
  gradeMethod: EnumsGradeMethod;
  hasAutomation: boolean;
  hasTraceability: boolean;
  id: number;
  installRunId: UpdateFarmConfigResponseInstallRunId;
  interestRate: number;
  lastBndImport: UpdateFarmConfigResponseLastBndImport;
  lastCertifierImport: UpdateFarmConfigResponseLastCertifierImport;
  managementConfig: unknown;
  matinalReadTime: UpdateFarmConfigResponseMatinalReadTime;
  name: string;
  nightlyReadTimes: string[];
  position: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification: boolean;
  sapId: string;
  senarPercent: UpdateFarmConfigResponseSenarPercent;
  treatViewType: EnumsTreatViewType;
}

export interface UpdateFarmConfig {
  blockedUntil?: number;
  /** Taxa de correção/antecipação mensal (fração, ex.: 0.025 = 2,5% a.m.) */
  correctionPercent?: number;
  dailyCost?: number;
  /** Porcentagem do FeedLink */
  divisionThreshold?: number;
  factory?: GlobalPrismaJsonLatLng[];
  gradeInfo?: unknown;
  gradeMethod?: EnumsGradeMethod;
  hasAutomation?: boolean;
  hasTraceability?: boolean;
  managementConfig?: unknown;
  matinalReadTime?: string;
  nightlyReadTimes?: string[];
  position?: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification?: boolean;
  /** Percentual SENAR */
  senarPercent?: number;
}

export interface UpdateFarm {
  alias?: string;
  name?: string;
  position?: GlobalPrismaJsonLatLng;
}

export type UpdateExitTruckResponseSaleOrderId = number | null;

export type UpdateExitTruckResponseSaleId = number | null;

export type UpdateExitTruckResponsePlate = string | null;

export type UpdateExitTruckResponseName = string | null;

export type UpdateExitTruckResponseInfo = string | null;

export type UpdateExitTruckResponseHoldingSaleId = number | null;

export type UpdateExitTruckResponseExitGtaSeries = string | null;

export type UpdateExitTruckResponseExitGta = string | null;

export type UpdateExitTruckResponseDestinyId = number | null;

export type UpdateExitTruckResponseBigWeighingMachineWeightKg = number | null;

export type UpdateExitTruckResponseAnnouncementId = number | null;

export interface UpdateExitTruckResponse {
  announcementId: UpdateExitTruckResponseAnnouncementId;
  bigWeighingMachineWeightKg: UpdateExitTruckResponseBigWeighingMachineWeightKg;
  capacity: number;
  destinyId: UpdateExitTruckResponseDestinyId;
  exitAt: string;
  exitGta: UpdateExitTruckResponseExitGta;
  exitGtaSeries: UpdateExitTruckResponseExitGtaSeries;
  farmId: number;
  holdingSaleId: UpdateExitTruckResponseHoldingSaleId;
  id: number;
  info: UpdateExitTruckResponseInfo;
  isVisible: boolean;
  name: UpdateExitTruckResponseName;
  plate: UpdateExitTruckResponsePlate;
  reason: EnumsExitReason;
  saleId: UpdateExitTruckResponseSaleId;
  saleOrderId: UpdateExitTruckResponseSaleOrderId;
  status: EnumsExitTruckStatus;
}

export type UpdateEstablishmentResponseCode = string | null;

export type UpdateEstablishmentResponseCattleManifestLayoutId = number | null;

export interface UpdateEstablishmentResponse {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: UpdateEstablishmentResponseCattleManifestLayoutId;
  code: UpdateEstablishmentResponseCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsibleId: number;
}

export type UpdateEstablishmentAddress = {
  city?: string;
  complement?: string;
  country?: string;
  neighborhood?: string;
  number?: string;
  state?: string;
  street?: string;
  zip?: string;
};

export interface UpdateEstablishment {
  address: UpdateEstablishmentAddress;
  /** Código do SIF, SIE ou SIM do estabelecimento */
  code?: string;
  /** Se este estabelecimento pode ser usado como destino */
  destiny?: boolean;
  /** [GovDocuments] Documentos deste estabelecimento */
  gov?: GlobalPrismaJsonGovDocuments;
  /** Nome do estabelecimento */
  name?: string;
  /** Se este estabelecimento pode ser usado como origem */
  origin?: boolean;
  /** (EXTERN) Usuário responsável por este estabelecimento. */
  responsible?: number;
}

export interface UpdateElgOrElm {
  elg?: number;
  elm?: number;
}

export type UpdateEarringPurchaseResponseReceivedAt = string | null;

export type UpdateEarringPurchaseResponsePartnerHerd = string | null;

export type UpdateEarringPurchaseResponseObservation = string | null;

export type UpdateEarringPurchaseResponseEarringsPerPage = number | null;

export interface UpdateEarringPurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: UpdateEarringPurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: UpdateEarringPurchaseResponseObservation;
  partnerHerd: UpdateEarringPurchaseResponsePartnerHerd;
  price: number;
  receivedAt: UpdateEarringPurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export interface UpdateEarringPurchase {
  brand?: string;
  earringsPerPage?: number;
  finalSisbov?: number;
  initialSisbov?: number;
  invoice?: string;
  issuedAt?: string;
  name?: string;
  observation?: string;
  orderNumber?: string;
  ownerId?: number;
  partnerHerd?: string;
  price?: number;
  series?: string;
}

export type UpdateDietResponsePremixId = number | null;

export type UpdateDietResponseObservation = string | null;

export type UpdateDietResponseFixedElg = number | null;

export type UpdateDietResponseCode = string | null;

export type UpdateDietResponseCategory = EnumsDietCategory | null;

export interface UpdateDietResponse {
  active: boolean;
  category: UpdateDietResponseCategory;
  code: UpdateDietResponseCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: UpdateDietResponseFixedElg;
  id: number;
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: UpdateDietResponseObservation;
  premixId: UpdateDietResponsePremixId;
}

export interface UpdateDiet {
  category?: EnumsDietCategory;
  code?: string;
  estimatedWeightGain: number;
  expiry?: number;
  ingredients?: Ingredient[];
  name: string;
  observation?: string;
}

export interface UpdateDeathGroupDateBody {
  currentDate: string;
  dryRun: boolean;
  newDate: string;
  oxIds: number[];
}

export type UpdateDeathAnnouncementResponseExpiresAt = string | null;

export type UpdateDeathAnnouncementResponseEmittedAt = string | null;

export type UpdateDeathAnnouncementResponseCreatedAt = string | null;

export interface UpdateDeathAnnouncementResponse {
  createdAt: UpdateDeathAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: UpdateDeathAnnouncementResponseEmittedAt;
  expiresAt: UpdateDeathAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export type UpdateCorralResponsePosition = number | null;

export interface UpdateCorralResponse {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: UpdateCorralResponsePosition;
  type: EnumsCorralType;
}

export type UpdateCorralPositionsOrderResponseItemPosition = number | null;

export type UpdateCorralPositionsOrderResponseItem = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: UpdateCorralPositionsOrderResponseItemPosition;
  type: EnumsCorralType;
};

export type UpdateCorralPositionsOrderResponse =
  UpdateCorralPositionsOrderResponseItem[];

export interface UpdateCorral {
  area?: number;
  capacity?: number;
  name?: string;
  polygon?: GlobalPrismaJsonLatLng[];
  /** Position auto preenchido, caso não fornecido. */
  position?: number;
  type?: EnumsCorralType;
}

export type UpdateCattleManifestLayoutTransformationConfigBodyWeightAggregation =
  (typeof UpdateCattleManifestLayoutTransformationConfigBodyWeightAggregation)[keyof typeof UpdateCattleManifestLayoutTransformationConfigBodyWeightAggregation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCattleManifestLayoutTransformationConfigBodyWeightAggregation =
  {
    SUM: "SUM",
    AVERAGE: "AVERAGE",
  } as const;

export type UpdateCattleManifestLayoutTransformationConfigBodyFinishingDivergencePolicy =
  (typeof UpdateCattleManifestLayoutTransformationConfigBodyFinishingDivergencePolicy)[keyof typeof UpdateCattleManifestLayoutTransformationConfigBodyFinishingDivergencePolicy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCattleManifestLayoutTransformationConfigBodyFinishingDivergencePolicy =
  {
    BLOCK: "BLOCK",
    HIGHEST: "HIGHEST",
    LOWEST: "LOWEST",
  } as const;

export interface UpdateCattleManifestLayoutTransformationConfigBody {
  bandConsolidationEnabled: boolean;
  bandGroupByField?: CattleManifestTargetFieldValue;
  finishingDivergencePolicy?: UpdateCattleManifestLayoutTransformationConfigBodyFinishingDivergencePolicy;
  weightAggregation?: UpdateCattleManifestLayoutTransformationConfigBodyWeightAggregation;
}

export interface UpdateCattleManifestLayoutFinishingMappingBody {
  mappings: CattleManifestLayoutFinishingMappingItem[];
  useStandardFinishingNumbering: boolean;
}

export interface UpdateCattleManifestLayoutFieldMappingMappingInput {
  columnIndex?: number;
  headerName?: string;
  targetField: CattleManifestTargetFieldValue;
}

export interface UpdateCattleManifestLayoutFieldMappingBody {
  headerRowsToSkip: number;
  mappings: UpdateCattleManifestLayoutFieldMappingMappingInput[];
  sourceMode: CattleManifestSourceModeValue;
}

export interface UpdateBeat {
  /** Não pode ser menor que zero, pois é uma alteração */
  realizedNaturalMatter: number;
}

export type UpdateBatchWeightsBodyProcessingWeight = number | null;

export type UpdateBatchWeightsBodyEntryWeight = number | null;

export interface UpdateBatchWeightsBody {
  entryWeight?: UpdateBatchWeightsBodyEntryWeight;
  processingWeight?: UpdateBatchWeightsBodyProcessingWeight;
}

export type UpdateBatchResponseScaledToSlaughter = boolean | null;

export type UpdateBatchResponseOperationalCostGroupId = number | null;

export type UpdateBatchResponseOldCorralId = number | null;

export type UpdateBatchResponseHideFromTreatmentUntil = string | null;

export type UpdateBatchResponseHideFromTreatment = boolean | null;

export type UpdateBatchResponseForeseenSlaughterDate = string | null;

export type UpdateBatchResponseFinalizedAt = string | null;

export type UpdateBatchResponseDescrption = string | null;

export type UpdateBatchResponseCorralId = number | null;

export type UpdateBatchResponseCarcassUniform = number | null;

export type UpdateBatchResponseCarcassThin = number | null;

export type UpdateBatchResponseCarcassMissing = number | null;

export type UpdateBatchResponseCarcassMedium = number | null;

export type UpdateBatchResponseCarcassExcessive = number | null;

export type UpdateBatchResponseAdjustedPurchaseCost = number | null;

export type UpdateBatchResponseActivationEditedAt = string | null;

export type UpdateBatchResponseActivatedAt = string | null;

export interface UpdateBatchResponse {
  activatedAt: UpdateBatchResponseActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: UpdateBatchResponseActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: UpdateBatchResponseAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: UpdateBatchResponseCarcassExcessive;
  carcassMedium: UpdateBatchResponseCarcassMedium;
  carcassMissing: UpdateBatchResponseCarcassMissing;
  carcassThin: UpdateBatchResponseCarcassThin;
  carcassUniform: UpdateBatchResponseCarcassUniform;
  corralId: UpdateBatchResponseCorralId;
  createdAt: string;
  descrption: UpdateBatchResponseDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: UpdateBatchResponseFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: UpdateBatchResponseForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: UpdateBatchResponseHideFromTreatment;
  hideFromTreatmentUntil: UpdateBatchResponseHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: UpdateBatchResponseOldCorralId;
  operationalCostGroupId: UpdateBatchResponseOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: UpdateBatchResponseScaledToSlaughter;
}

export interface UpdateBatchClosingDateResponse {
  affected: BatchClosingDateAffected;
  after: string;
  applied: boolean;
  before: string;
  dryRun: boolean;
  warnings: string[];
}

export interface UpdateBatchClosingDateBody {
  dryRun: boolean;
  newDate: string;
}

export type UpdateBatchAdjustedCostResponseAdjustedPurchaseCost = number | null;

export interface UpdateBatchAdjustedCostResponse {
  adjustedPurchaseCost: UpdateBatchAdjustedCostResponseAdjustedPurchaseCost;
  id: number;
}

export type UpdateBatchActivationDateResponseDirection =
  (typeof UpdateBatchActivationDateResponseDirection)[keyof typeof UpdateBatchActivationDateResponseDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBatchActivationDateResponseDirection = {
  BACKWARD: "BACKWARD",
  FORWARD: "FORWARD",
} as const;

export interface UpdateBatchActivationDateResponse {
  affected: BatchActivationDateAffected;
  after: string;
  applied: boolean;
  before: string;
  direction: UpdateBatchActivationDateResponseDirection;
  dryRun: boolean;
  warnings: string[];
}

export interface UpdateBatchActivationDateBody {
  activatedAt: string;
  dryRun: boolean;
  oxenInGap: BatchActivationOxenPolicy;
}

export interface UpdateBatch {
  admCost?: number;
  carcass?: number;
  corralId?: number;
  descrption?: string;
  exitPrice?: number;
  foreseenCarcass?: number;
  foreseenSlaughterDate?: string;
  foreseenWeight?: number;
  isHospitalPen?: boolean;
  name?: string;
  otherCost?: number;
  scaledToSlaughter?: boolean;
}

export type UpdateAnnouncementResponseExpiresAt = string | null;

export type UpdateAnnouncementResponseEmittedAt = string | null;

export type UpdateAnnouncementResponseCreatedAt = string | null;

export interface UpdateAnnouncementResponse {
  createdAt: UpdateAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: UpdateAnnouncementResponseEmittedAt;
  expiresAt: UpdateAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export interface UpdateAnnouncement {
  data: GlobalPrismaJsonAnnouncementData;
  type: EnumsAnnouncementType;
}

export type UpdateAnimalPurchaseResponseReceivedAt = string | null;

export type UpdateAnimalPurchaseResponsePartnerHerd = string | null;

export type UpdateAnimalPurchaseResponseObservation = string | null;

export type UpdateAnimalPurchaseResponseEarringsPerPage = number | null;

export interface UpdateAnimalPurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: UpdateAnimalPurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: UpdateAnimalPurchaseResponseObservation;
  partnerHerd: UpdateAnimalPurchaseResponsePartnerHerd;
  price: number;
  receivedAt: UpdateAnimalPurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export type UpdateAddressResponseStreet = string | null;

export type UpdateAddressResponseNumber = string | null;

export type UpdateAddressResponseNeighborhood = string | null;

export type UpdateAddressResponseComplement = string | null;

export interface UpdateAddressResponse {
  city: string;
  complement: UpdateAddressResponseComplement;
  country: string;
  id: number;
  neighborhood: UpdateAddressResponseNeighborhood;
  number: UpdateAddressResponseNumber;
  state: string;
  street: UpdateAddressResponseStreet;
  zip: string;
}

export interface UpdateAddress {
  city?: string;
  complement?: string;
  country?: string;
  neighborhood?: string;
  number?: string;
  state?: string;
  street?: string;
  zip?: string;
}

export type UnusedBatchCorralName = string | null;

/**
 * Lote criado e nunca utilizado, candidato à exclusão automática.
 */
export interface UnusedBatch {
  corralName: UnusedBatchCorralName;
  createdAt: string;
  id: number;
  name: string;
}

export interface UnusabilityAnnouncement {
  brand: string;
  observation?: string;
  sisbov: number;
}

export type UntraceableTransferBodyGtaOxAge =
  (typeof UntraceableTransferBodyGtaOxAge)[keyof typeof UntraceableTransferBodyGtaOxAge];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UntraceableTransferBodyGtaOxAge = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export interface UntraceableTransferBody {
  breed?: string;
  corralDestinyId: number;
  corralOriginId: number;
  description?: string;
  gender?: EnumsOxGender;
  gtaOxAge?: UntraceableTransferBodyGtaOxAge;
  oxenAmount: number;
  toEmpty?: boolean;
}

export interface UnlinkWeightingMapFromPurchaseResponse {
  success: boolean;
}

export interface UnlinkCattleManifestLayoutEstablishmentsResponse {
  unlinkedIds: number[];
}

export interface UnlinkCattleManifestLayoutEstablishmentsBody {
  establishmentIds: number[];
}

export type TypeManagement = EnumsTypeManagement;

export type TroughReadingReportRowNightlyReadsItem = {
  hadFood: boolean;
  hour: string;
  noNightlyReads?: boolean;
};

export interface TroughReadingReportRow {
  batch: TroughReadingReportRowBatch;
  clean?: boolean;
  corral: TroughReadingReportRowCorral;
  date: string;
  diet: TroughReadingReportRowDietItem[];
  leftOver?: TroughReadingReportRowLeftOver;
  matinalRead?: TroughReadingReportRowMatinalRead;
  nightlyReads: TroughReadingReportRowNightlyReadsItem[];
}

export type TroughReadingReportRowMatinalReadReadValue = number | null;

export type TroughReadingReportRowMatinalRead = {
  hour: string;
  readType: EnumsReadType;
  readValue?: TroughReadingReportRowMatinalReadReadValue;
};

export type TroughReadingReportRowLeftOver = number | null;

export type TroughReadingReportRowDietItem = {
  id: number;
  name: string;
};

export type TroughReadingReportRowCorral = {
  id: number;
  name: string;
  position?: number;
};

export type TroughReadingReportRowBatch = {
  id: number;
  name: string;
};

export type TroughManagementViewResponse = TroughManagementViewResponseItem[];

export type TroughManagementViewResponseItemTreatment = {
  divisions: number[];
  name: string;
};

export type TroughManagementViewResponseItemPosition = number | null;

export type TroughManagementViewResponseItemManagedAt = string | null;

export type TroughManagementViewResponseItemIdentifiedAtAverage = string | null;

export type TroughManagementViewResponseItemHideFromTreatmentUntil =
  | string
  | null;

export type TroughManagementViewResponseItemEntry = string | null;

export type TroughManagementViewResponseItem = {
  activationEditDeletedTreats: boolean;
  activationEditedAt: TroughManagementViewResponseItemActivationEditedAt;
  activationEditRemovedOxen: boolean;
  activeCurve: TroughManagementViewResponseItemActiveCurve;
  batchCreationDate: string;
  batchId: number;
  batchName: string;
  breeds: string[];
  confinementDays: number;
  corralId?: number;
  corralName?: string;
  currentWeight: number;
  d_0: TroughManagementViewResponseItemD0;
  d_1: TroughManagementViewResponseItemD1;
  dietExpiration: number;
  dietId: number;
  dietName: string;
  dietTransition?: string;
  entry: TroughManagementViewResponseItemEntry;
  entryWeight: number;
  genders: EnumsOxGender[];
  hideFromTreatment: boolean;
  hideFromTreatmentUntil: TroughManagementViewResponseItemHideFromTreatmentUntil;
  identificationWeight?: number;
  identifiedAtAverage: TroughManagementViewResponseItemIdentifiedAtAverage;
  managedAt: TroughManagementViewResponseItemManagedAt;
  naturalMatterFactor?: number;
  oxenAmount: number;
  position?: TroughManagementViewResponseItemPosition;
  throughDays: number;
  treatment?: TroughManagementViewResponseItemTreatment;
  treatmentDays: number;
  varieties: string[];
};

export type TroughManagementViewResponseItemD1ReadValue = number | null;

export type TroughManagementViewResponseItemD1ReadType = EnumsReadType | null;

export type TroughManagementViewResponseItemD1 = {
  deviation?: number;
  foreseen: number;
  foreseenLiveWeight?: number;
  nightlyReads?: GlobalPrismaJsonNightlyRead[];
  readType?: TroughManagementViewResponseItemD1ReadType;
  readValue?: TroughManagementViewResponseItemD1ReadValue;
  realized: number;
  realizedLiveWeight?: number;
};

export type TroughManagementViewResponseItemD0ReadValue = number | null;

export type TroughManagementViewResponseItemD0ReadType = EnumsReadType | null;

export type TroughManagementViewResponseItemD0 = {
  currentWeight: number;
  deviation?: number;
  foreseen: number;
  foreseenLiveWeight: number;
  hideFromTreatment: boolean;
  nightlyReads: GlobalPrismaJsonNightlyRead[];
  readType: TroughManagementViewResponseItemD0ReadType;
  readValue: TroughManagementViewResponseItemD0ReadValue;
  realized: number;
  realizedLiveWeight: number;
  sugestion: number;
};

export type TroughManagementViewResponseItemActiveCurveAnyOf = {
  name: string;
  type: EnumsWeightGainCurveType;
};

export type TroughManagementViewResponseItemActiveCurve =
  TroughManagementViewResponseItemActiveCurveAnyOf | null;

export type TroughManagementViewResponseItemActivationEditedAt = string | null;

export type TroughManagementPrintingCardViewResponseItem = {
  batchId: number;
  batchName: string;
  corralName?: string;
};

export type TroughManagementPrintingCardViewResponse =
  TroughManagementPrintingCardViewResponseItem[];

export type TroughManagementGraphViewResponse =
  TroughManagementGraphViewResponseItem[];

export type TroughManagementGraphViewResponseItemOccurrencesItemStockChangeId =
  | number
  | null;

export type TroughManagementGraphViewResponseItemOccurrencesItemOldFactor =
  | number
  | null;

export type TroughManagementGraphViewResponseItemOccurrencesItemNewFactor =
  | number
  | null;

export type TroughManagementGraphViewResponseItemOccurrencesItemName =
  | string
  | null;

export type TroughManagementGraphViewResponseItemOccurrencesItem = {
  category: EnumsOccurrenceCategory;
  date: string;
  description: string;
  farmId: number;
  id: number;
  name: TroughManagementGraphViewResponseItemOccurrencesItemName;
  newFactor: TroughManagementGraphViewResponseItemOccurrencesItemNewFactor;
  oldFactor: TroughManagementGraphViewResponseItemOccurrencesItemOldFactor;
  stockChangeId: TroughManagementGraphViewResponseItemOccurrencesItemStockChangeId;
  type: EnumsOccurrenceType;
};

export type TroughManagementGraphViewResponseItem = {
  batchId: number;
  graph: TroughManagementGraphViewResponseItemGraphItem[];
  occurrences: TroughManagementGraphViewResponseItemOccurrencesItem[];
};

export type TroughManagementGraphViewResponseItemGraphItemTransition = {
  source: EnumsDietCategory;
  target?: EnumsDietCategory;
};

export type TroughManagementGraphViewResponseItemGraphItemReadType =
  EnumsReadType | null;

export type TroughManagementGraphViewResponseItemGraphItem = {
  day: string;
  deviation: number;
  diet: TroughManagementGraphViewResponseItemGraphItemDietItem[];
  foreseen: number;
  foreseenLiveWeightConsume: number;
  liveWeightConsume: number;
  nightlyReads: GlobalPrismaJsonNightlyRead[];
  oxenAmount: number;
  readType: TroughManagementGraphViewResponseItemGraphItemReadType;
  realized: number;
  throughDays: number;
  transition: TroughManagementGraphViewResponseItemGraphItemTransition;
};

export type TroughManagementGraphViewResponseItemGraphItemDietItemCategory =
  EnumsDietCategory | null;

export type TroughManagementGraphViewResponseItemGraphItemDietItem = {
  category: TroughManagementGraphViewResponseItemGraphItemDietItemCategory;
  name: string;
};

export interface TroughManagementGraphSearch {
  batchId?: number;
  fullHistory?: boolean;
  since?: string;
}

export type TroughManagementGraphReturnNightlyReadsItem = {
  hadFood: boolean;
  hour: string;
};

export interface TroughManagementGraphReturn {
  /** Limpou o cocho */
  clean?: boolean;
  /** Dias médios de Cocho */
  confinementDays: number;
  /** Data */
  date: string;
  /** CMS = Consumo de Matéria Seca */
  dryMatterConsume: number;
  /** Consumo Previsto de Matéria Seca */
  foreseen: number;
  /** Sobra */
  leftovers?: number;
  /** CMS PV = Porcentagem de Consumo de Matéria Seca baseado no Peso Vivo */
  liveWeightConsume: number;
  /** Leitura matutina */
  matinalRead: EnumsReadType;
  /** Leituras noturnas */
  nightlyReads: TroughManagementGraphReturnNightlyReadsItem[];
  /** Quantidade de bois no lote */
  oxenAmount: number;
  /** Ajuste Planejado */
  plannedAdjustment: number;
  /** Desvio Trato */
  treatmentDeviation: number;
  /** Diferença de peso entre o dia anterior e o dia atual */
  weightDifference: number;
}

export interface TroughManagementGraphQuery {
  end?: string;
  start?: string;
}

export type TreatViewType = EnumsTreatViewType;

export type TreatViewResponseTreatsItem = {
  adjustedForeseen: boolean;
  automated: boolean;
  batchId: number;
  batchName: string;
  beatSequences?: number[];
  corralId: number;
  corralName: string;
  corralPosition: TreatViewResponseTreatsItemCorralPosition;
  dietChangedDuringDay: boolean;
  dietId: number;
  dietName: string;
  foreseen: number;
  hideFromTreatment: TreatViewResponseTreatsItemHideFromTreatment;
  hour?: string;
  order: number;
  originalForeseen: number;
  realized: number;
  realizedList: TreatViewResponseTreatsItemRealizedListItem[];
  treatSequences?: number[];
  wrongsRealizedList: TreatViewResponseTreatsItemWrongsRealizedListItem[];
};

export interface TreatViewResponse {
  totalOriginalForeseen: number;
  treats: TreatViewResponseTreatsItem[];
  treatViewType: EnumsTreatViewType;
}

export type TreatViewResponseTreatsItemWrongsRealizedListItemSequence =
  | number
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemRealizedAt =
  | string
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemOxenCount =
  | number
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemOriginalNaturalMatter =
  number | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemOrder =
  | number
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemMixerId =
  | number
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemForeseenNaturalMatter =
  number | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemFinalDryMatter =
  | number
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemFeederId =
  | number
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemFeederAnyOf = {
  id: number;
  name: string;
};

export type TreatViewResponseTreatsItemWrongsRealizedListItemFeeder =
  TreatViewResponseTreatsItemWrongsRealizedListItemFeederAnyOf | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemDiet = {
  id: number;
  name: string;
};

export type TreatViewResponseTreatsItemWrongsRealizedListItemConcludedProportion =
  number | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemConcludedNaturalMatter =
  number | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItemConcludedAt =
  | string
  | null;

export type TreatViewResponseTreatsItemWrongsRealizedListItem = {
  batchId: number;
  concluded: boolean;
  concludedAt: TreatViewResponseTreatsItemWrongsRealizedListItemConcludedAt;
  concludedNaturalMatter: TreatViewResponseTreatsItemWrongsRealizedListItemConcludedNaturalMatter;
  concludedProportion: TreatViewResponseTreatsItemWrongsRealizedListItemConcludedProportion;
  day: string;
  diet: TreatViewResponseTreatsItemWrongsRealizedListItemDiet;
  dietId: number;
  farmId: number;
  feeder: TreatViewResponseTreatsItemWrongsRealizedListItemFeeder;
  feederId: TreatViewResponseTreatsItemWrongsRealizedListItemFeederId;
  finalDryMatter: TreatViewResponseTreatsItemWrongsRealizedListItemFinalDryMatter;
  first: boolean;
  foreseenNaturalMatter: TreatViewResponseTreatsItemWrongsRealizedListItemForeseenNaturalMatter;
  id: number;
  key: string;
  mixerId: TreatViewResponseTreatsItemWrongsRealizedListItemMixerId;
  order: TreatViewResponseTreatsItemWrongsRealizedListItemOrder;
  originalNaturalMatter: TreatViewResponseTreatsItemWrongsRealizedListItemOriginalNaturalMatter;
  oxenCount: TreatViewResponseTreatsItemWrongsRealizedListItemOxenCount;
  realizedAt: TreatViewResponseTreatsItemWrongsRealizedListItemRealizedAt;
  realizedNaturalMatter: number;
  sequence: TreatViewResponseTreatsItemWrongsRealizedListItemSequence;
};

export type TreatViewResponseTreatsItemRealizedListItemSequence = number | null;

export type TreatViewResponseTreatsItemRealizedListItemRealizedAt =
  | string
  | null;

export type TreatViewResponseTreatsItemRealizedListItemOxenCount =
  | number
  | null;

export type TreatViewResponseTreatsItemRealizedListItemOriginalNaturalMatter =
  | number
  | null;

export type TreatViewResponseTreatsItemRealizedListItemOrder = number | null;

export type TreatViewResponseTreatsItemRealizedListItemMixerId = number | null;

export type TreatViewResponseTreatsItemRealizedListItemForeseenNaturalMatter =
  | number
  | null;

export type TreatViewResponseTreatsItemRealizedListItemFinalDryMatter =
  | number
  | null;

export type TreatViewResponseTreatsItemRealizedListItemFeederId = number | null;

export type TreatViewResponseTreatsItemRealizedListItemFeederAnyOf = {
  id: number;
  name: string;
};

export type TreatViewResponseTreatsItemRealizedListItemFeeder =
  TreatViewResponseTreatsItemRealizedListItemFeederAnyOf | null;

export type TreatViewResponseTreatsItemRealizedListItemDiet = {
  id: number;
  name: string;
};

export type TreatViewResponseTreatsItemRealizedListItemConcludedProportion =
  | number
  | null;

export type TreatViewResponseTreatsItemRealizedListItemConcludedNaturalMatter =
  | number
  | null;

export type TreatViewResponseTreatsItemRealizedListItemConcludedAt =
  | string
  | null;

export type TreatViewResponseTreatsItemRealizedListItem = {
  batchId: number;
  concluded: boolean;
  concludedAt: TreatViewResponseTreatsItemRealizedListItemConcludedAt;
  concludedNaturalMatter: TreatViewResponseTreatsItemRealizedListItemConcludedNaturalMatter;
  concludedProportion: TreatViewResponseTreatsItemRealizedListItemConcludedProportion;
  day: string;
  diet: TreatViewResponseTreatsItemRealizedListItemDiet;
  dietId: number;
  farmId: number;
  feeder: TreatViewResponseTreatsItemRealizedListItemFeeder;
  feederId: TreatViewResponseTreatsItemRealizedListItemFeederId;
  finalDryMatter: TreatViewResponseTreatsItemRealizedListItemFinalDryMatter;
  first: boolean;
  foreseenNaturalMatter: TreatViewResponseTreatsItemRealizedListItemForeseenNaturalMatter;
  id: number;
  key: string;
  mixerId: TreatViewResponseTreatsItemRealizedListItemMixerId;
  order: TreatViewResponseTreatsItemRealizedListItemOrder;
  originalNaturalMatter: TreatViewResponseTreatsItemRealizedListItemOriginalNaturalMatter;
  oxenCount: TreatViewResponseTreatsItemRealizedListItemOxenCount;
  realizedAt: TreatViewResponseTreatsItemRealizedListItemRealizedAt;
  realizedNaturalMatter: number;
  sequence: TreatViewResponseTreatsItemRealizedListItemSequence;
};

export type TreatViewResponseTreatsItemHideFromTreatment = boolean | null;

export type TreatViewResponseTreatsItemCorralPosition = number | null;

/**
 * Médias agregadas do período — calculadas pelo aggregator ao final do streaming, mesma fórmula do service legado (`services/reports/treat-efficiency/treat-efficiency-service.ts`).
 */
export interface TreatEfficiencyAverage {
  foreseenWeight: number;
  realWeight: number;
  weightDifference: number;
  weightDifferencePercentage: number;
}

export interface TreatConclusionByOrderResponse {
  completedCount: number;
  message: string;
  order: number;
  success: boolean;
}

export interface TreatConclusionByOrderBody {
  feederId?: number;
  order: number;
}

export interface TreatConclusionByHourResponse {
  completedCount: number;
  hour: string;
  message: string;
  success: boolean;
}

export interface TreatConclusionByHourBody {
  hour: string;
}

export interface TreatConclusionBody {
  batchId: number;
  feederId?: number;
  order: number;
}

export type TransitionBatchDietResponseFinalizedAt = string | null;

export interface TransitionBatchDietResponse {
  batchId: number;
  createdAt: string;
  finalizedAt: TransitionBatchDietResponseFinalizedAt;
  id: number;
  phaseIncrement: number;
  transitionId: number;
}

export type TransferViewResponseOriginOxenItemAge =
  (typeof TransferViewResponseOriginOxenItemAge)[keyof typeof TransferViewResponseOriginOxenItemAge];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferViewResponseOriginOxenItemAge = {
  NUMBER_0: 0,
  NUMBER_2: 2,
  NUMBER_1: 1,
  NUMBER_3: 3,
} as const;

export type TransferViewResponseOriginOxenItem = {
  age: TransferViewResponseOriginOxenItemAge;
  birth: string;
  breed: string;
  gender: EnumsOxGender;
  variety: string;
};

export type TransferViewResponseOriginAgesItem =
  (typeof TransferViewResponseOriginAgesItem)[keyof typeof TransferViewResponseOriginAgesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferViewResponseOriginAgesItem = {
  NUMBER_0: 0,
  NUMBER_2: 2,
  NUMBER_1: 1,
  NUMBER_3: 3,
} as const;

export type TransferViewResponseOrigin = {
  ages: TransferViewResponseOriginAgesItem[];
  batch: string;
  batchId: number;
  breeds: string[];
  corral: string;
  corralId: number;
  diet?: string;
  genders: EnumsOxGender[];
  metaStats: OxenGroupStats;
  oxen: TransferViewResponseOriginOxenItem[];
  oxenAmount: number;
  varieties: string[];
};

export type TransferViewResponseDestinyActivatedAt = string | null;

export type TransferViewResponseDestiny = {
  activatedAt?: TransferViewResponseDestinyActivatedAt;
  batch?: string;
  batchId?: number;
  breeds?: string[];
  corral: string;
  corralId: number;
  diet?: string;
  genders?: EnumsOxGender[];
  metaStats?: OxenGroupStats;
  oxenAmount?: number;
  varieties?: string[];
};

export interface TransferViewResponse {
  destiny: TransferViewResponseDestiny;
  origin: TransferViewResponseOrigin;
}

export interface TransferTreatRealizedBody {
  /** Id do lote deste dia */
  batchId?: number;
  /** Ordem deste trato */
  order?: number;
}

export type TransferOxenBetweenSaleOrdersResponseDeletedOriginCattleManifestId =
  number | null;

export interface TransferOxenBetweenSaleOrdersResponse {
  deletedOriginCattleManifestId: TransferOxenBetweenSaleOrdersResponseDeletedOriginCattleManifestId;
  /** True quando a venda de origem ficou sem nenhum boi/caminhão após a transferência e foi excluída junto. */
  deletedOriginSaleOrder: boolean;
  newExitTruckId: number;
  transferredOxIds: number[];
}

export interface TransferOxenBetweenSaleOrdersBody {
  destinySaleOrderId: number;
  movePenaltiesToDestination: boolean;
  originSaleOrderId: number;
  oxen: SaleOrderTransferOxInput[];
}

export type TestJobStateResponseResult = TestJobResult | null;

export type TestJobStateResponseError = string | null;

export interface TestJobStateResponse {
  error: TestJobStateResponseError;
  jobId: string;
  progress: ReportJobProgress;
  result: TestJobStateResponseResult;
  status: ReportJobStatus;
}

/**
 * Linha do resultado artificial. Existe só para a tela de teste ter o que renderizar em tabela.
 */
export interface TestJobRow {
  id: number;
  label: string;
  value: number;
}

export interface TestJobResult {
  /** Tempo real de processamento, para comparar com o que a tela mostrou. */
  elapsedMs: number;
  rows: TestJobRow[];
}

export type SyncManagementResponsePurchaseItem = {
  finalSisbov: number;
  id: number;
  initialSisbov: number;
};

export interface SyncManagementResponse {
  electronic: string[];
  purchase: SyncManagementResponsePurchaseItem[];
  sisbov: string[];
  unusability: string[];
}

export type SubmitTreatResponse = boolean | PrismaBatchPayload;

export interface SubmitTreat {
  /** Id de lote deste dia */
  batchId: number;
  /** Id da dieta de realizado */
  dietId: number;
  /** Id do tratador que realizou o trato */
  feederId?: number;
  /** Se é o primeiro trato do lote */
  first?: boolean;
  /** Matéria natural prevista para o trato */
  foreseenNaturalMatter?: number;
  /** Id do trato realizado */
  id?: number;
  /** Chave única do trato */
  key: string;
  /** Id do misturador */
  mixerId?: number;
  /** Nulo apenas se for um trato livre */
  order?: number;
  /** Matéria natural realizada naquele dia. (mostra sempre o inputado pelo usuário) */
  originalNaturalMatter?: number;
  oxenCount?: number;
  /** Momento em que o trato foi realizado, caso tenha sido informado */
  realizedAt?: string;
  /** Matéria natural realizada naquele dia. */
  realizedNaturalMatter: number;
  /** Sequência do trato */
  sequence?: number;
}

export interface SubmitCertifierResponse {
  updated: SubmitCertifierResponseUpdatedItem[];
}

export type SubmitCertifierResponseUpdatedItemStartOfTreatment = string | null;

export type SubmitCertifierResponseUpdatedItemSisbov = string | null;

export type SubmitCertifierResponseUpdatedItemSalesMarketType =
  EnumsSalesMarketType | null;

export type SubmitCertifierResponseUpdatedItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type SubmitCertifierResponseUpdatedItemReversedDeathDetails =
  | string
  | null;

export type SubmitCertifierResponseUpdatedItemReversedDeathDate = string | null;

export type SubmitCertifierResponseUpdatedItemReversedDeathCause =
  EnumsDeathCause | null;

export type SubmitCertifierResponseUpdatedItemPurchaseId = number | null;

export type SubmitCertifierResponseUpdatedItemPriceAtSignExit = number | null;

export type SubmitCertifierResponseUpdatedItemPriceAtSignEntry = number | null;

export type SubmitCertifierResponseUpdatedItemOtherDeathCause = string | null;

export type SubmitCertifierResponseUpdatedItemIsNecropsyPerformed =
  | boolean
  | null;

export type SubmitCertifierResponseUpdatedItemInvoice = string | null;

export type SubmitCertifierResponseUpdatedItemInternalSaleId = number | null;

export type SubmitCertifierResponseUpdatedItemIdentifier = string | null;

export type SubmitCertifierResponseUpdatedItemIdentifiedAt = string | null;

export type SubmitCertifierResponseUpdatedItemIdentificationSource =
  EnumsIdentificationSource | null;

export type SubmitCertifierResponseUpdatedItemHasBirthAnnouncement =
  | boolean
  | null;

export type SubmitCertifierResponseUpdatedItemGtaId = number | null;

export type SubmitCertifierResponseUpdatedItemExitTruckId = number | null;

export type SubmitCertifierResponseUpdatedItemElectronic = string | null;

export type SubmitCertifierResponseUpdatedItemDiedAt = string | null;

export type SubmitCertifierResponseUpdatedItemDentitionStage =
  EnumsDentitionStage | null;

export type SubmitCertifierResponseUpdatedItemDeathReason =
  EnumsDeathCause | null;

export type SubmitCertifierResponseUpdatedItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type SubmitCertifierResponseUpdatedItemDeathDetails = string | null;

export type SubmitCertifierResponseUpdatedItemDeathCause =
  EnumsDeathCause | null;

export type SubmitCertifierResponseUpdatedItemComments = string | null;

export type SubmitCertifierResponseUpdatedItemCertifierDate = string | null;

export type SubmitCertifierResponseUpdatedItemCattleManifestId = number | null;

export type SubmitCertifierResponseUpdatedItemCarcassWeight = number | null;

export type SubmitCertifierResponseUpdatedItemCarcassType =
  EnumsCarcassType | null;

export type SubmitCertifierResponseUpdatedItemCarcassPrice = number | null;

export type SubmitCertifierResponseUpdatedItemCarcass = number | null;

export type SubmitCertifierResponseUpdatedItemBornOnFarm = boolean | null;

export type SubmitCertifierResponseUpdatedItemBndTracked = boolean | null;

export type SubmitCertifierResponseUpdatedItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: SubmitCertifierResponseUpdatedItemBndTracked;
  bornOnFarm: SubmitCertifierResponseUpdatedItemBornOnFarm;
  breed: string;
  carcass: SubmitCertifierResponseUpdatedItemCarcass;
  carcassPrice: SubmitCertifierResponseUpdatedItemCarcassPrice;
  carcassType: SubmitCertifierResponseUpdatedItemCarcassType;
  carcassWeight: SubmitCertifierResponseUpdatedItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: SubmitCertifierResponseUpdatedItemCattleManifestId;
  certifierDate: SubmitCertifierResponseUpdatedItemCertifierDate;
  comments: SubmitCertifierResponseUpdatedItemComments;
  deathCause: SubmitCertifierResponseUpdatedItemDeathCause;
  deathDetails: SubmitCertifierResponseUpdatedItemDeathDetails;
  deathNecropsy: SubmitCertifierResponseUpdatedItemDeathNecropsy;
  deathReason: SubmitCertifierResponseUpdatedItemDeathReason;
  dentitionStage: SubmitCertifierResponseUpdatedItemDentitionStage;
  diedAt: SubmitCertifierResponseUpdatedItemDiedAt;
  electronic: SubmitCertifierResponseUpdatedItemElectronic;
  exitTruckId: SubmitCertifierResponseUpdatedItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: SubmitCertifierResponseUpdatedItemGtaId;
  hasBirthAnnouncement: SubmitCertifierResponseUpdatedItemHasBirthAnnouncement;
  id: number;
  identificationSource: SubmitCertifierResponseUpdatedItemIdentificationSource;
  identifiedAt: SubmitCertifierResponseUpdatedItemIdentifiedAt;
  identifier: SubmitCertifierResponseUpdatedItemIdentifier;
  includedAt: string;
  internalSaleId: SubmitCertifierResponseUpdatedItemInternalSaleId;
  invoice: SubmitCertifierResponseUpdatedItemInvoice;
  isNecropsyPerformed: SubmitCertifierResponseUpdatedItemIsNecropsyPerformed;
  otherDeathCause: SubmitCertifierResponseUpdatedItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: SubmitCertifierResponseUpdatedItemPriceAtSignEntry;
  priceAtSignExit: SubmitCertifierResponseUpdatedItemPriceAtSignExit;
  purchaseId: SubmitCertifierResponseUpdatedItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: SubmitCertifierResponseUpdatedItemReversedDeathCause;
  reversedDeathDate: SubmitCertifierResponseUpdatedItemReversedDeathDate;
  reversedDeathDetails: SubmitCertifierResponseUpdatedItemReversedDeathDetails;
  reversedDeathNecropsy: SubmitCertifierResponseUpdatedItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: SubmitCertifierResponseUpdatedItemSalesMarketType;
  sisbov: SubmitCertifierResponseUpdatedItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: SubmitCertifierResponseUpdatedItemStartOfTreatment;
  variety: string;
};

export interface SubmitBndBody {
  code?: string;
  expedition: string;
  filepath: string;
  ownerId: number;
}

export interface SubmitBeat {
  /** Id da dieta que essa fabricação pertence. */
  dietId: number;
  /** Id do tratador que realizou essa fabricação, caso tenha sido especificado. */
  feederId?: number;
  /** Previsto da batida avulsa, em matéria natural. Quando informado, substitui o previsto calculado pelo saldo do dia. */
  foreseen?: number;
  /** Usado pelo tracer */
  mixerId?: number;
  /** Defaults para o dia de hoje */
  realizedAt?: string;
  /** Quantidade de matéria natural realizada. */
  realizedNaturalMatter: number;
  /** Id do estoque que essa fabricação pertence. */
  stockId: number;
}

export type StructureCategory = EnumsStructureCategory;

export type StoredPurchaseChargebackResponse =
  StoredPurchaseChargebackResponseItem[];

export type StoredPurchaseChargebackResponseItemOxenItemSisbov = string | null;

export type StoredPurchaseChargebackResponseItemOxenItemGtaId = number | null;

export type StoredPurchaseChargebackResponseItemOxenItem = {
  birth: string;
  gender: EnumsOxGender;
  gtaId: StoredPurchaseChargebackResponseItemOxenItemGtaId;
  id: number;
  sisbov: StoredPurchaseChargebackResponseItemOxenItemSisbov;
};

export type StoredPurchaseChargebackResponseItem = {
  oxen: StoredPurchaseChargebackResponseItemOxenItem[];
  purchaseId: number;
  purchaseName: string;
  totalAnimals: number;
};

export type StorageOxenPurchaseResponseReceivedAt = string | null;

export type StorageOxenPurchaseResponsePartnerHerd = string | null;

export type StorageOxenPurchaseResponseObservation = string | null;

export type StorageOxenPurchaseResponseEarringsPerPage = number | null;

export interface StorageOxenPurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: StorageOxenPurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: StorageOxenPurchaseResponseObservation;
  partnerHerd: StorageOxenPurchaseResponsePartnerHerd;
  price: number;
  receivedAt: StorageOxenPurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export interface StockTimelineFilter {
  end?: string;
  start?: string;
}

/**
 * Um dia da linha do tempo de um alimento: preço e saldo vigentes naquela data.
 */
export interface StockTimelineDay {
  /** Saldo em kg/MN no fim do dia */
  amount: number;
  corrected: boolean;
  date: string;
  /** Preço por kg/MN vigente no dia (carregado do último dia informado) */
  kiloPrice: number;
  /** Quantidade em kg/MN que saiu do estoque no dia (trato, saídas manuais) */
  treated: number;
}

/**
 * Devolução ao estoque de um ingrediente consumido pelos tratos apagados.
 */
export interface StockReversalItem {
  /** Kg de matéria natural devolvidos ao estoque. */
  naturalMatter: number;
  stockId: number;
  stockName: string;
}

export type StockFilterNaturalMatter =
  (typeof StockFilterNaturalMatter)[keyof typeof StockFilterNaturalMatter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StockFilterNaturalMatter = {
  empty: "empty",
  not_empty: "not empty",
} as const;

export interface StockFilter {
  active?: boolean;
  isPremix?: boolean;
  isSupplement?: boolean;
  naturalMatter?: StockFilterNaturalMatter;
}

/**
 * Resposta do disparo: o relatório ainda não existe, só o rastreio dele.
 */
export interface StartTestJobResponse {
  jobId: string;
  /** `true` quando já havia um job igual em andamento e este pedido entrou nele. */
  reused: boolean;
  status: ReportJobStatus;
}

export interface StartForecastResponse {
  jobId: string;
  reused: boolean;
  status: ReportJobStatus;
  total: number;
}

export interface StartFinancialBatchesResponse {
  jobId: string;
  /** `true` quando já havia um job igual em andamento e este pedido entrou nele. */
  reused: boolean;
  status: ReportJobStatus;
  /** Lotes que serão processados. Zero significa que não há nada a relatar no dia. */
  total: number;
}

export interface StartActiveBatchesResponse {
  jobId: string;
  reused: boolean;
  status: ReportJobStatus;
  total: number;
}

export interface SpreadsheetOxIdentification {
  dentitionStage?: EnumsDentitionStage;
  electronic?: string;
  identifier?: string;
  proccessedAt?: string;
  sisbov?: number;
  weight?: number;
}

export type SortType = (typeof SortType)[keyof typeof SortType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortType = {
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type SlaughterScaleWeekSummaryWithSummaryRowAnyOfFour = {
  atFutureMarketPrice: number;
  confinementDays: number;
  d1dm: number;
  d1pv: number;
  d3dm: number;
  d3pv: number;
  d5dm: number;
  d5pv: number;
  differenceDays: number;
  dm: number;
  isSummaryRow: boolean;
  oxenExportCount: number;
  oxenExportPercentage: number;
  oxenInternalCount: number;
  oxenInternalPercentage: number;
  oxenTotalCount: number;
  partnersHerds: string;
  pv: number;
  referenceDays: number;
  totalMarketPrice: number;
  weekEnd?: string;
  weekIndex?: number;
  weekStart?: string;
  weightEntry: number;
  weightProcessed: number;
  weightProduced: number;
  weightProjected: number;
  weightSlaughter: number;
  weightTotal: number;
};

export type SlaughterScaleWeekSummaryWithSummaryRow =
  | SlaughterScaleWeekSummaryWithSummaryRowAnyOf
  | SlaughterScaleWeekSummaryWithSummaryRowAnyOfFour;

export type SlaughterScaleWeekSummaryWithSummaryRowAnyOfScaledToSlaughter =
  | boolean
  | null;

export type SlaughterScaleWeekSummaryWithSummaryRowAnyOfForeseenSlaughterDate =
  | string
  | null;

export type SlaughterScaleWeekSummaryWithSummaryRowAnyOf = {
  adjustedSlaughterDateCount: number;
  atFutureMarketPrice: number;
  batch: string;
  confinementDays: number;
  corral: string;
  d1dm: number;
  d1pv: number;
  d3dm: number;
  d3pv: number;
  d5dm: number;
  d5pv: number;
  differenceDays: number;
  dm: number;
  entryDate: string;
  entryType: string;
  entryWeightKg: number;
  exitProjectedWeight: number;
  exitReferenceWeight: number;
  farm: string;
  foreseenSlaughterDate?: SlaughterScaleWeekSummaryWithSummaryRowAnyOfForeseenSlaughterDate;
  gender: string;
  gpd: number;
  isSummaryRow?: boolean;
  owner: string;
  oxenExportCount: number;
  oxenExportPercentage: number;
  oxenInternalCount: number;
  oxenInternalPercentage: number;
  oxenTotalCount: number;
  partner: string;
  partnersHerds: string;
  processingDate: string;
  processingWeightKg: number;
  pv: number;
  referenceDays: number;
  scaledToSlaughter?: SlaughterScaleWeekSummaryWithSummaryRowAnyOfScaledToSlaughter;
  slaughterDate: string;
  totalMarketPrice: number;
  variety: string;
  weekEnd?: string;
  weekIndex?: number;
  weekStart?: string;
  weightEntry: number;
  weightProcessed: number;
  weightProduced: number;
  weightProjected: number;
  weightSlaughter: number;
  weightTotal: number;
};

export type SlaughterScaleWeekSummarySummary = {
  averageAtFutureMarketPrice: number;
  averageConfinementDays: number;
  averageD1DM: number;
  averageD1PV: number;
  averageD3DM: number;
  averageD3PV: number;
  averageD5DM: number;
  averageD5PV: number;
  averageDifferenceDays: number;
  averageDM: number;
  averageOxenExportPercentage: number;
  averageOxenInternalPercentage: number;
  averagePV: number;
  averageReferenceDays: number;
  averageWeightEntry: number;
  averageWeightProcessed: number;
  averageWeightProduced: number;
  averageWeightProjected: number;
  averageWeightSlaughter: number;
  totalBatches: number;
  totalMarketPrice: number;
  totalOxenCount: number;
  totalOxenExportCount: number;
  totalOxenInternalCount: number;
  weightTotal: number;
};

export interface SlaughterScaleWeekSummary {
  batches: SlaughterScaleWeekSummaryBatchesItem[];
  summary: SlaughterScaleWeekSummarySummary;
  weekEnd?: string;
  weekIndex: number;
  weekStart?: string;
}

export type SlaughterScaleWeekSummaryBatchesItemScaledToSlaughter =
  | boolean
  | null;

export type SlaughterScaleWeekSummaryBatchesItemForeseenSlaughterDate =
  | string
  | null;

export type SlaughterScaleWeekSummaryBatchesItem = {
  adjustedSlaughterDateCount: number;
  atFutureMarketPrice: number;
  batch: string;
  confinementDays: number;
  corral: string;
  d1dm: number;
  d1pv: number;
  d3dm: number;
  d3pv: number;
  d5dm: number;
  d5pv: number;
  differenceDays: number;
  dm: number;
  entryDate: string;
  entryType: string;
  entryWeightKg: number;
  exitProjectedWeight: number;
  exitReferenceWeight: number;
  farm: string;
  foreseenSlaughterDate?: SlaughterScaleWeekSummaryBatchesItemForeseenSlaughterDate;
  gender: string;
  gpd: number;
  isSummaryRow?: boolean;
  owner: string;
  oxenExportCount: number;
  oxenExportPercentage: number;
  oxenInternalCount: number;
  oxenInternalPercentage: number;
  oxenTotalCount: number;
  partner: string;
  partnersHerds: string;
  processingDate: string;
  processingWeightKg: number;
  pv: number;
  referenceDays: number;
  scaledToSlaughter?: SlaughterScaleWeekSummaryBatchesItemScaledToSlaughter;
  slaughterDate: string;
  totalMarketPrice: number;
  variety: string;
  weekEnd?: string;
  weekIndex?: number;
  weekStart?: string;
  weightEntry: number;
  weightProcessed: number;
  weightProduced: number;
  weightProjected: number;
  weightSlaughter: number;
  weightTotal: number;
};

export type SlaughterScaleReportDataResponseItemScaledToSlaughter =
  | boolean
  | null;

export type SlaughterScaleReportDataResponseItemForeseenSlaughterDate =
  | string
  | null;

export interface SlaughterScaleReportDataResponseItem {
  adjustedSlaughterDateCount: number;
  atFutureMarketPrice: number;
  batch: string;
  confinementDays: number;
  corral: string;
  d1dm: number;
  d1pv: number;
  d3dm: number;
  d3pv: number;
  d5dm: number;
  d5pv: number;
  differenceDays: number;
  dm: number;
  entryDate: string;
  entryType: string;
  entryWeightKg: number;
  exitProjectedWeight: number;
  exitReferenceWeight: number;
  farm: string;
  foreseenSlaughterDate?: SlaughterScaleReportDataResponseItemForeseenSlaughterDate;
  gender: string;
  gpd: number;
  owner: string;
  oxenExportCount: number;
  oxenExportPercentage: number;
  oxenInternalCount: number;
  oxenInternalPercentage: number;
  oxenTotalCount: number;
  partner: string;
  partnersHerds: string;
  processingDate: string;
  processingWeightKg: number;
  pv: number;
  referenceDays: number;
  scaledToSlaughter?: SlaughterScaleReportDataResponseItemScaledToSlaughter;
  slaughterDate: string;
  totalMarketPrice: number;
  variety: string;
  weekEnd?: string;
  weekIndex?: number;
  weekStart?: string;
  weightEntry: number;
  weightProcessed: number;
  weightProduced: number;
  weightProjected: number;
  weightSlaughter: number;
  weightTotal: number;
}

export type SlaughterScaleMonthSummaryWithSummaryRowSummary = {
  averageAtFutureMarketPrice: number;
  averageConfinementDays: number;
  averageD1DM: number;
  averageD1PV: number;
  averageD3DM: number;
  averageD3PV: number;
  averageD5DM: number;
  averageD5PV: number;
  averageDifferenceDays: number;
  averageDM: number;
  averageOxenExportPercentage: number;
  averageOxenInternalPercentage: number;
  averagePV: number;
  averageReferenceDays: number;
  averageWeightEntry: number;
  averageWeightProcessed: number;
  averageWeightProduced: number;
  averageWeightProjected: number;
  averageWeightSlaughter: number;
  totalBatches: number;
  totalMarketPrice: number;
  totalOxenCount: number;
  totalOxenExportCount: number;
  totalOxenInternalCount: number;
  weightTotal: number;
};

export interface SlaughterScaleMonthSummaryWithSummaryRow {
  isSummaryRow?: boolean;
  monthLabel: string;
  summary: SlaughterScaleMonthSummaryWithSummaryRowSummary;
  yearLabel: string;
}

export interface SideBarViewResponse {
  corralInfo: SideBarViewResponseCorralInfo;
  graph: SideBarViewResponseGraphItem[];
  managementInfo: SideBarViewResponseManagementInfo;
  occurrences: SideBarViewResponseOccurrencesItem[];
}

export type SideBarViewResponseOccurrencesItemStockChangeId = number | null;

export type SideBarViewResponseOccurrencesItemOldFactor = number | null;

export type SideBarViewResponseOccurrencesItemNewFactor = number | null;

export type SideBarViewResponseOccurrencesItemName = string | null;

export type SideBarViewResponseOccurrencesItem = {
  category: EnumsOccurrenceCategory;
  date: string;
  description: string;
  farmId: number;
  id: number;
  name: SideBarViewResponseOccurrencesItemName;
  newFactor: SideBarViewResponseOccurrencesItemNewFactor;
  oldFactor: SideBarViewResponseOccurrencesItemOldFactor;
  stockChangeId: SideBarViewResponseOccurrencesItemStockChangeId;
  type: EnumsOccurrenceType;
};

export type SideBarViewResponseManagementInfoReadValue = number | null;

export type SideBarViewResponseManagementInfoReadType = EnumsReadType | null;

export type SideBarViewResponseManagementInfo = {
  deviation: number;
  foreseen?: number;
  foreseenLiveWeight: number;
  nightlyReads?: GlobalPrismaJsonNightlyRead[];
  readType?: SideBarViewResponseManagementInfoReadType;
  readValue?: SideBarViewResponseManagementInfoReadValue;
  realized: number;
  realizedLiveWeight: number;
};

export type SideBarViewResponseGraphItemTransition = {
  source: EnumsDietCategory;
  target?: EnumsDietCategory;
};

export type SideBarViewResponseGraphItemReadType = EnumsReadType | null;

export type SideBarViewResponseGraphItem = {
  day: string;
  deviation: number;
  diet: SideBarViewResponseGraphItemDietItem[];
  foreseen: number;
  foreseenLiveWeightConsume: number;
  liveWeightConsume: number;
  nightlyReads: GlobalPrismaJsonNightlyRead[];
  oxenAmount: number;
  readType: SideBarViewResponseGraphItemReadType;
  realized: number;
  throughDays: number;
  transition: SideBarViewResponseGraphItemTransition;
};

export type SideBarViewResponseGraphItemDietItemCategory =
  EnumsDietCategory | null;

export type SideBarViewResponseGraphItemDietItem = {
  category: SideBarViewResponseGraphItemDietItemCategory;
  name: string;
};

export type SideBarViewResponseCorralInfoGtasItem = {
  count: number;
  gta?: string;
};

export type SideBarViewResponseCorralInfoEntry = string | null;

export type SideBarViewResponseCorralInfoEarringColorsItem = {
  color?: string;
  count: number;
};

export type SideBarViewResponseCorralInfoActivatedAt = string | null;

export type SideBarViewResponseCorralInfo = {
  activatedAt: SideBarViewResponseCorralInfoActivatedAt;
  animalUnitLoadPerHectare: number;
  averageBirth: number;
  breeds: string[];
  category: EnumsOxCategory[];
  corralName: string;
  corralType?: EnumsCorralType;
  currentWeight: number;
  daysFarm: number;
  dietName: string;
  earringColors: SideBarViewResponseCorralInfoEarringColorsItem[];
  entry: SideBarViewResponseCorralInfoEntry;
  entryType: EnumsOxPurpose[];
  entryWeight: number;
  gender: EnumsOxGender[];
  gtas: SideBarViewResponseCorralInfoGtasItem[];
  owner: string[];
  oxenAmount: number;
  supplementOxenDaily: number;
  throughDays: number;
  varieties: string[];
};

export interface SetDietPrice {
  date?: string;
  /** Preço por kg de matéria seca (R$/kg MS). Obrigatório quando `manualPrice` está ativo. */
  kiloPriceDM?: number;
  manualPrice: boolean;
}

export interface SearchTreatment {
  active?: boolean;
}

export interface SearchSaleManagement {
  closed?: boolean;
  date?: string;
  gtaNumber?: string;
  ownerId?: number;
  producer?: string;
}

export interface SearchPurchase {
  category?: EnumsPurchaseCategory;
  gtaNumber?: string;
  issuedAt?: string;
  limit?: number;
  name?: string;
  orderByStatus?: EnumsPurchaseStatus;
  page?: number;
  producer?: string;
  status?: EnumsPurchaseStatus;
}

export type SearchPeopleResponseItemUserAnyOfPassword = string | null;

export type SearchPeopleResponseItemUserAnyOfGov =
  GlobalPrismaJsonGovDocuments | null;

export type SearchPeopleResponseItemUserAnyOfEmailVerifiedAt = string | null;

export type SearchPeopleResponseItemUserAnyOfEmail = string | null;

export type SearchPeopleResponseItemUserAnyOf = {
  email: SearchPeopleResponseItemUserAnyOfEmail;
  emailVerifiedAt: SearchPeopleResponseItemUserAnyOfEmailVerifiedAt;
  farmId: number;
  gov: SearchPeopleResponseItemUserAnyOfGov;
  id: number;
  password: SearchPeopleResponseItemUserAnyOfPassword;
  personId: number;
};

export type SearchPeopleResponseItemUser =
  SearchPeopleResponseItemUserAnyOf | null;

export type SearchPeopleResponseItemPhone = string | null;

export type SearchPeopleResponseItemEstablishmentsItem = {
  id: number;
  name: string;
};

export type SearchPeopleResponseItemDocument = string | null;

export type SearchPeopleResponseItemDescription = string | null;

export type SearchPeopleResponseItemCode = string | null;

export type SearchPeopleResponseItem = {
  code: SearchPeopleResponseItemCode;
  createdAt: string;
  description: SearchPeopleResponseItemDescription;
  document: SearchPeopleResponseItemDocument;
  establishments: SearchPeopleResponseItemEstablishmentsItem[];
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: SearchPeopleResponseItemPhone;
  profiles: EnumsProfile[];
  user: SearchPeopleResponseItemUser;
};

export type SearchPeopleResponse = SearchPeopleResponseItem[];

export interface SearchOx {
  animalStatus?: string;
  electronic?: string;
  electronicCode?: string;
  identifier?: string;
  managementCode?: string;
  oxId?: number;
  sisbov?: number;
}

export type SearchExitTruckExitType =
  (typeof SearchExitTruckExitType)[keyof typeof SearchExitTruckExitType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchExitTruckExitType = {
  BATCH: "BATCH",
  MANAGEMENT: "MANAGEMENT",
} as const;

export interface SearchExitTruck {
  date?: string;
  destiny?: string;
  destinyId?: number;
  endDate?: string;
  exitType?: SearchExitTruckExitType;
  gtaNumber?: string;
  info?: string;
  name?: string;
  notEmitted?: boolean;
  sale?: boolean;
  startDate?: string;
  status?: EnumsExitTruckStatus;
}

export interface SearchEstablishment {
  active?: boolean;
  destiny?: boolean;
  origin?: boolean;
}

export type SalesMarketType = EnumsSalesMarketType;

export type SaleTruckPriceAtSignExit = number | null;

export type SaleTruckPlate = string | null;

export type SaleTruckName = string | null;

export type SaleTruckExitLiveWeight = number | null;

export type SaleTruckCarcassYield = number | null;

/**
 * Valores representativos da venda (média dos animais do caminhão).
 */
export type SaleTruckCarcassWeight = number | null;

/**
 * Uma venda = um caminhão de saída (ExitTruck).
 */
export interface SaleTruck {
  /** Valores representativos da venda (média dos animais do caminhão). */
  carcassWeight: SaleTruckCarcassWeight;
  carcassYield: SaleTruckCarcassYield;
  exitAt: string;
  exitLiveWeight: SaleTruckExitLiveWeight;
  name: SaleTruckName;
  oxen: SaleOxRow[];
  plate: SaleTruckPlate;
  priceAtSignExit: SaleTruckPriceAtSignExit;
  reason: EnumsExitReason;
  status: EnumsExitTruckStatus;
  truckId: number;
}

export type SaleOxRowSisbov = string | null;

export type SaleOxRowPriceAtSignExit = number | null;

export type SaleOxRowIdentifier = string | null;

/**
 * Último peso registrado (OxWeight).
 */
export type SaleOxRowExitLiveWeight = number | null;

/**
 * Primeiro peso `WEIGHTED` registrado (OxWeight).
 */
export type SaleOxRowEntryLiveWeight = number | null;

export type SaleOxRowDiedAt = string | null;

export type SaleOxRowCarcassWeight = number | null;

export type SaleOxRowCarcassPrice = number | null;

/**
 * Rendimento de carcaça do animal (fração).
 */
export type SaleOxRowCarcass = number | null;

/**
 * Um animal dentro de uma venda ou na lista de não atribuídos.
 */
export interface SaleOxRow {
  /** Rendimento de carcaça do animal (fração). */
  carcass: SaleOxRowCarcass;
  carcassPrice: SaleOxRowCarcassPrice;
  carcassWeight: SaleOxRowCarcassWeight;
  diedAt: SaleOxRowDiedAt;
  /** Primeiro peso `WEIGHTED` registrado (OxWeight). */
  entryLiveWeight: SaleOxRowEntryLiveWeight;
  /** Último peso registrado (OxWeight). */
  exitLiveWeight: SaleOxRowExitLiveWeight;
  identifier: SaleOxRowIdentifier;
  /** `true` = animal é venda (tem `diedAt` e `deathCause` de abate). */
  isSale: boolean;
  oxId: number;
  priceAtSignExit: SaleOxRowPriceAtSignExit;
  sisbov: SaleOxRowSisbov;
}

/**
 * KEEP_CURRENT: preserva os valores de carcaça/romaneio que o boi já tinha. ADAPT_TO_DESTINATION: zera (se a venda destino não tem romaneio) ou migra pro padrão da venda destino (se tem).
 */
export type SaleOrderTransferOxInputManifestAction =
  (typeof SaleOrderTransferOxInputManifestAction)[keyof typeof SaleOrderTransferOxInputManifestAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SaleOrderTransferOxInputManifestAction = {
  KEEP_CURRENT: "KEEP_CURRENT",
  ADAPT_TO_DESTINATION: "ADAPT_TO_DESTINATION",
} as const;

export interface SaleOrderTransferOxInput {
  carcassPriceOverride?: number;
  /** Peso/preço de carcaça informados manualmente. Quando qualquer um dos dois vem preenchido, substituem por completo o que manifestAction (KEEP_CURRENT/ADAPT_TO_DESTINATION) calcularia para este boi. */
  carcassWeightOverrideKg?: number;
  /** Só usado quando manifestAction é ADAPT_TO_DESTINATION e a venda destino já tem romaneio. */
  finishingCategory?: CarcassFinishingCategory;
  /** KEEP_CURRENT: preserva os valores de carcaça/romaneio que o boi já tinha. ADAPT_TO_DESTINATION: zera (se a venda destino não tem romaneio) ou migra pro padrão da venda destino (se tem). */
  manifestAction: SaleOrderTransferOxInputManifestAction;
  oxId: number;
  /** Peso de saída (kg) informado manualmente pelo usuário; se omitido, mantém o peso EXIT atual do boi. */
  weightOverrideKg?: number;
}

export type SaleOrderStatus = EnumsSaleOrderStatus;

export interface SaleHoldingBatch {
  /** Data da saída (YYYY-MM-DD). Ausente → dia atual da fazenda. Retroativa apaga os dados do lote posteriores a ela e devolve o estoque consumido. */
  date?: string;
  destinyId: number;
  exitWeightAverage: number;
  name?: string;
  oxenAmount: number;
  /** Identificadores dos animais selecionados para a saída. */
  oxenIds?: number[];
}

export type SaleExecutionSyncResponseMetaPhasesItem = {
  ms: number;
  name: string;
  rows: number;
};

export type SaleExecutionSyncResponseMetaCounts = {
  auditAnimals: number;
  batches: number;
  corrals: number;
  establishments: number;
  gtas: number;
  healthHistory: number;
  healthProtocols: number;
  invoices: number;
  owners: number;
  oxen: number;
  purchases: number;
  weights: number;
};

export type SaleExecutionSyncResponseMeta = {
  concurrency: number;
  counts: SaleExecutionSyncResponseMetaCounts;
  day: string;
  phases: SaleExecutionSyncResponseMetaPhasesItem[];
  totalMs: number;
};

export type SaleExecutionSyncResponseData = {
  auditAnimals: SaleExecutionSyncResponseDataAuditAnimalsItem[];
  batches: SaleExecutionSyncResponseDataBatchesItem[];
  corrals: SaleExecutionSyncResponseDataCorralsItem[];
  establishments: SaleExecutionSyncResponseDataEstablishmentsItem[];
  gtas: SaleExecutionSyncResponseDataGtasItem[];
  healthHistory: SaleExecutionSyncResponseDataHealthHistoryItem[];
  healthProtocols: SaleExecutionSyncResponseDataHealthProtocolsItem[];
  invoices: SaleExecutionSyncResponseDataInvoicesItem[];
  owners: SaleExecutionSyncResponseDataOwnersItem[];
  oxen: SaleExecutionSyncResponseDataOxenItem[];
  purchases: SaleExecutionSyncResponseDataPurchasesItem[];
  weights: SaleExecutionSyncResponseDataWeightsItem[];
};

export interface SaleExecutionSyncResponse {
  data: SaleExecutionSyncResponseData;
  meta: SaleExecutionSyncResponseMeta;
}

export type SaleExecutionSyncResponseDataWeightsItemLastWeight = number | null;

export type SaleExecutionSyncResponseDataWeightsItemLastWeighingDate =
  | string
  | null;

export type SaleExecutionSyncResponseDataWeightsItemLastDate = string | null;

export type SaleExecutionSyncResponseDataWeightsItemGmdReal = number | null;

export type SaleExecutionSyncResponseDataWeightsItemGmd = number | null;

export type SaleExecutionSyncResponseDataWeightsItemEntryWeight = number | null;

export type SaleExecutionSyncResponseDataWeightsItemEntryDate = string | null;

export type SaleExecutionSyncResponseDataWeightsItem = {
  currentDate: string;
  currentSource: string;
  currentWeight: number;
  entryDate: SaleExecutionSyncResponseDataWeightsItemEntryDate;
  entryWeight: SaleExecutionSyncResponseDataWeightsItemEntryWeight;
  gmd: SaleExecutionSyncResponseDataWeightsItemGmd;
  gmdReal: SaleExecutionSyncResponseDataWeightsItemGmdReal;
  lastDate: SaleExecutionSyncResponseDataWeightsItemLastDate;
  lastWeighingDate: SaleExecutionSyncResponseDataWeightsItemLastWeighingDate;
  lastWeight: SaleExecutionSyncResponseDataWeightsItemLastWeight;
  oxId: number;
};

export type SaleExecutionSyncResponseDataPurchasesItemWeighingAt =
  | string
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemPartnerId = number | null;

export type SaleExecutionSyncResponseDataPurchasesItemOxenAmount =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemMapa = string | null;

export type SaleExecutionSyncResponseDataPurchasesItemMaleProducedPrice =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemMaleFutureAnimalPrice =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemMaleEntryCarcassYield =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemMaleDailyPrice =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemFemaleProducedPrice =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemFemaleFutureAnimalPrice =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemFemaleEntryCarcassYield =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemFemaleDailyPrice =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItemDiscountPercent =
  | number
  | null;

export type SaleExecutionSyncResponseDataPurchasesItem = {
  buyerId: number;
  commission: number;
  discountPercent: SaleExecutionSyncResponseDataPurchasesItemDiscountPercent;
  femaleDailyPrice: SaleExecutionSyncResponseDataPurchasesItemFemaleDailyPrice;
  femaleEntryCarcassYield: SaleExecutionSyncResponseDataPurchasesItemFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: SaleExecutionSyncResponseDataPurchasesItemFemaleFutureAnimalPrice;
  femaleProducedPrice: SaleExecutionSyncResponseDataPurchasesItemFemaleProducedPrice;
  id: number;
  maleDailyPrice: SaleExecutionSyncResponseDataPurchasesItemMaleDailyPrice;
  maleEntryCarcassYield: SaleExecutionSyncResponseDataPurchasesItemMaleEntryCarcassYield;
  maleFutureAnimalPrice: SaleExecutionSyncResponseDataPurchasesItemMaleFutureAnimalPrice;
  maleProducedPrice: SaleExecutionSyncResponseDataPurchasesItemMaleProducedPrice;
  mapa: SaleExecutionSyncResponseDataPurchasesItemMapa;
  ownerId: number;
  oxenAmount: SaleExecutionSyncResponseDataPurchasesItemOxenAmount;
  partnerId: SaleExecutionSyncResponseDataPurchasesItemPartnerId;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purchaseName: string;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: SaleExecutionSyncResponseDataPurchasesItemWeighingAt;
  weightAverage: number;
};

export type SaleExecutionSyncResponseDataOxenItemStartOfTreatment =
  | string
  | null;

export type SaleExecutionSyncResponseDataOxenItemSisbov = string | null;

export type SaleExecutionSyncResponseDataOxenItemSalesMarketType =
  EnumsSalesMarketType | null;

export type SaleExecutionSyncResponseDataOxenItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type SaleExecutionSyncResponseDataOxenItemReversedDeathDetails =
  | string
  | null;

export type SaleExecutionSyncResponseDataOxenItemReversedDeathDate =
  | string
  | null;

export type SaleExecutionSyncResponseDataOxenItemReversedDeathCause =
  EnumsDeathCause | null;

export type SaleExecutionSyncResponseDataOxenItemPurchaseId = number | null;

export type SaleExecutionSyncResponseDataOxenItemPriceAtSignExit =
  | number
  | null;

export type SaleExecutionSyncResponseDataOxenItemPriceAtSignEntry =
  | number
  | null;

export type SaleExecutionSyncResponseDataOxenItemOtherDeathCause =
  | string
  | null;

export type SaleExecutionSyncResponseDataOxenItemIsNecropsyPerformed =
  | boolean
  | null;

export type SaleExecutionSyncResponseDataOxenItemInvoice = string | null;

export type SaleExecutionSyncResponseDataOxenItemInternalSaleId = number | null;

export type SaleExecutionSyncResponseDataOxenItemIdentifier = string | null;

export type SaleExecutionSyncResponseDataOxenItemIdentifiedAt = string | null;

export type SaleExecutionSyncResponseDataOxenItemIdentificationSource =
  EnumsIdentificationSource | null;

export type SaleExecutionSyncResponseDataOxenItemHasBirthAnnouncement =
  | boolean
  | null;

export type SaleExecutionSyncResponseDataOxenItemGtaId = number | null;

export type SaleExecutionSyncResponseDataOxenItemExitTruckId = number | null;

export type SaleExecutionSyncResponseDataOxenItemElectronic = string | null;

export type SaleExecutionSyncResponseDataOxenItemDiedAt = string | null;

export type SaleExecutionSyncResponseDataOxenItemDentitionStage =
  EnumsDentitionStage | null;

export type SaleExecutionSyncResponseDataOxenItemDeathReason =
  EnumsDeathCause | null;

export type SaleExecutionSyncResponseDataOxenItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type SaleExecutionSyncResponseDataOxenItemDeathDetails = string | null;

export type SaleExecutionSyncResponseDataOxenItemDeathCause =
  EnumsDeathCause | null;

export type SaleExecutionSyncResponseDataOxenItemComments = string | null;

export type SaleExecutionSyncResponseDataOxenItemCertifierDate = string | null;

export type SaleExecutionSyncResponseDataOxenItemCattleManifestId =
  | number
  | null;

export type SaleExecutionSyncResponseDataOxenItemCarcassWeight = number | null;

export type SaleExecutionSyncResponseDataOxenItemCarcassType =
  EnumsCarcassType | null;

export type SaleExecutionSyncResponseDataOxenItemCarcassPrice = number | null;

export type SaleExecutionSyncResponseDataOxenItemCarcass = number | null;

export type SaleExecutionSyncResponseDataOxenItemBornOnFarm = boolean | null;

export type SaleExecutionSyncResponseDataOxenItemBndTracked = boolean | null;

export type SaleExecutionSyncResponseDataOxenItem = {
  batchId: number;
  birth: string;
  blockedUntil: string;
  bndTracked: SaleExecutionSyncResponseDataOxenItemBndTracked;
  bornOnFarm: SaleExecutionSyncResponseDataOxenItemBornOnFarm;
  breed: string;
  carcass: SaleExecutionSyncResponseDataOxenItemCarcass;
  carcassPrice: SaleExecutionSyncResponseDataOxenItemCarcassPrice;
  carcassType: SaleExecutionSyncResponseDataOxenItemCarcassType;
  carcassWeight: SaleExecutionSyncResponseDataOxenItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: SaleExecutionSyncResponseDataOxenItemCattleManifestId;
  certifierDate: SaleExecutionSyncResponseDataOxenItemCertifierDate;
  comments: SaleExecutionSyncResponseDataOxenItemComments;
  deathCause: SaleExecutionSyncResponseDataOxenItemDeathCause;
  deathDetails: SaleExecutionSyncResponseDataOxenItemDeathDetails;
  deathNecropsy: SaleExecutionSyncResponseDataOxenItemDeathNecropsy;
  deathReason: SaleExecutionSyncResponseDataOxenItemDeathReason;
  dentitionStage: SaleExecutionSyncResponseDataOxenItemDentitionStage;
  diedAt: SaleExecutionSyncResponseDataOxenItemDiedAt;
  electronic: SaleExecutionSyncResponseDataOxenItemElectronic;
  exitTruckId: SaleExecutionSyncResponseDataOxenItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: SaleExecutionSyncResponseDataOxenItemGtaId;
  hasBirthAnnouncement: SaleExecutionSyncResponseDataOxenItemHasBirthAnnouncement;
  id: number;
  identificationSource: SaleExecutionSyncResponseDataOxenItemIdentificationSource;
  identifiedAt: SaleExecutionSyncResponseDataOxenItemIdentifiedAt;
  identifier: SaleExecutionSyncResponseDataOxenItemIdentifier;
  includedAt: string;
  internalSaleId: SaleExecutionSyncResponseDataOxenItemInternalSaleId;
  invoice: SaleExecutionSyncResponseDataOxenItemInvoice;
  isNecropsyPerformed: SaleExecutionSyncResponseDataOxenItemIsNecropsyPerformed;
  otherDeathCause: SaleExecutionSyncResponseDataOxenItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: SaleExecutionSyncResponseDataOxenItemPriceAtSignEntry;
  priceAtSignExit: SaleExecutionSyncResponseDataOxenItemPriceAtSignExit;
  purchaseId: SaleExecutionSyncResponseDataOxenItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: SaleExecutionSyncResponseDataOxenItemReversedDeathCause;
  reversedDeathDate: SaleExecutionSyncResponseDataOxenItemReversedDeathDate;
  reversedDeathDetails: SaleExecutionSyncResponseDataOxenItemReversedDeathDetails;
  reversedDeathNecropsy: SaleExecutionSyncResponseDataOxenItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: SaleExecutionSyncResponseDataOxenItemSalesMarketType;
  sisbov: SaleExecutionSyncResponseDataOxenItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: SaleExecutionSyncResponseDataOxenItemStartOfTreatment;
  variety: string;
};

export type SaleExecutionSyncResponseDataOwnersItemPhone = string | null;

export type SaleExecutionSyncResponseDataOwnersItemDocument = string | null;

export type SaleExecutionSyncResponseDataOwnersItemDescription = string | null;

export type SaleExecutionSyncResponseDataOwnersItemCode = string | null;

export type SaleExecutionSyncResponseDataOwnersItem = {
  code: SaleExecutionSyncResponseDataOwnersItemCode;
  createdAt: string;
  description: SaleExecutionSyncResponseDataOwnersItemDescription;
  document: SaleExecutionSyncResponseDataOwnersItemDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: SaleExecutionSyncResponseDataOwnersItemPhone;
  profiles: EnumsProfile[];
};

export type SaleExecutionSyncResponseDataInvoicesItemIsComplement =
  | boolean
  | null;

export type SaleExecutionSyncResponseDataInvoicesItemEmittedAt = string | null;

export type SaleExecutionSyncResponseDataInvoicesItem = {
  emittedAt: SaleExecutionSyncResponseDataInvoicesItemEmittedAt;
  id: number;
  isComplement: SaleExecutionSyncResponseDataInvoicesItemIsComplement;
  number: string;
  series: string;
  value: number;
};

export type SaleExecutionSyncResponseDataHealthProtocolsItem = {
  active: boolean;
  id: number;
  medicines: SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItem[];
  name: string;
};

export type SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItemPerKg =
  number | null;

export type SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItemKiloDose =
  number | null;

export type SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItemApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export type SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItem = {
  active: boolean;
  applicationSuggestion: SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItemApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItemKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: SaleExecutionSyncResponseDataHealthProtocolsItemMedicinesItemPerKg;
  type: EnumsMedicineType;
};

export type SaleExecutionSyncResponseDataHealthHistoryItemMedicineApplicatorId =
  number | null;

export type SaleExecutionSyncResponseDataHealthHistoryItemHealthProtocolId =
  | number
  | null;

export type SaleExecutionSyncResponseDataHealthHistoryItemApplicationType =
  EnumsApplicationType | null;

export type SaleExecutionSyncResponseDataHealthHistoryItem = {
  applicationType: SaleExecutionSyncResponseDataHealthHistoryItemApplicationType;
  appliedAt: string;
  disease: EnumsDisease;
  healthProtocolId: SaleExecutionSyncResponseDataHealthHistoryItemHealthProtocolId;
  id: number;
  medicineApplicatorId: SaleExecutionSyncResponseDataHealthHistoryItemMedicineApplicatorId;
  oxId: number;
};

export type SaleExecutionSyncResponseDataGtasItemWeightingMapId = number | null;

export type SaleExecutionSyncResponseDataGtasItemWeightAverage = number | null;

export type SaleExecutionSyncResponseDataGtasItemPurchaseId = number | null;

export type SaleExecutionSyncResponseDataGtasItemOriginWeightAverage =
  | number
  | null;

export type SaleExecutionSyncResponseDataGtasItemInvoice = string | null;

export type SaleExecutionSyncResponseDataGtasItemHours = number | null;

export type SaleExecutionSyncResponseDataGtasItemDistance = number | null;

export type SaleExecutionSyncResponseDataGtasItemDestinyId = number | null;

export type SaleExecutionSyncResponseDataGtasItemDescription = string | null;

export type SaleExecutionSyncResponseDataGtasItem = {
  completed: boolean;
  description: SaleExecutionSyncResponseDataGtasItemDescription;
  destinyId: SaleExecutionSyncResponseDataGtasItemDestinyId;
  distance: SaleExecutionSyncResponseDataGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: SaleExecutionSyncResponseDataGtasItemHours;
  id: number;
  invoice: SaleExecutionSyncResponseDataGtasItemInvoice;
  number: string;
  originId: number;
  originWeightAverage: SaleExecutionSyncResponseDataGtasItemOriginWeightAverage;
  purchaseId: SaleExecutionSyncResponseDataGtasItemPurchaseId;
  series: string;
  weightAverage: SaleExecutionSyncResponseDataGtasItemWeightAverage;
  weightingMapId: SaleExecutionSyncResponseDataGtasItemWeightingMapId;
};

export type SaleExecutionSyncResponseDataEstablishmentsItemCode = string | null;

export type SaleExecutionSyncResponseDataEstablishmentsItem = {
  city: string;
  code: SaleExecutionSyncResponseDataEstablishmentsItemCode;
  destiny: boolean;
  id: number;
  name: string;
  origin: boolean;
  state: string;
};

export type SaleExecutionSyncResponseDataCorralsItemPosition = number | null;

export type SaleExecutionSyncResponseDataCorralsItem = {
  capacity: number;
  id: number;
  name: string;
  position: SaleExecutionSyncResponseDataCorralsItemPosition;
  type: EnumsCorralType;
};

export type SaleExecutionSyncResponseDataBatchesItemScaledToSlaughter =
  | boolean
  | null;

export type SaleExecutionSyncResponseDataBatchesItemOperationalCostGroupId =
  | number
  | null;

export type SaleExecutionSyncResponseDataBatchesItemOldCorralId = number | null;

export type SaleExecutionSyncResponseDataBatchesItemHideFromTreatmentUntil =
  | string
  | null;

export type SaleExecutionSyncResponseDataBatchesItemHideFromTreatment =
  | boolean
  | null;

export type SaleExecutionSyncResponseDataBatchesItemForeseenSlaughterDate =
  | string
  | null;

export type SaleExecutionSyncResponseDataBatchesItemFinalizedAt = string | null;

export type SaleExecutionSyncResponseDataBatchesItemDescrption = string | null;

export type SaleExecutionSyncResponseDataBatchesItemCorralId = number | null;

export type SaleExecutionSyncResponseDataBatchesItemCarcassUniform =
  | number
  | null;

export type SaleExecutionSyncResponseDataBatchesItemCarcassThin = number | null;

export type SaleExecutionSyncResponseDataBatchesItemCarcassMissing =
  | number
  | null;

export type SaleExecutionSyncResponseDataBatchesItemCarcassMedium =
  | number
  | null;

export type SaleExecutionSyncResponseDataBatchesItemCarcassExcessive =
  | number
  | null;

export type SaleExecutionSyncResponseDataBatchesItemAdjustedPurchaseCost =
  | number
  | null;

export type SaleExecutionSyncResponseDataBatchesItemActivationEditedAt =
  | string
  | null;

export type SaleExecutionSyncResponseDataBatchesItemActivatedAt = string | null;

export type SaleExecutionSyncResponseDataBatchesItem = {
  activatedAt: SaleExecutionSyncResponseDataBatchesItemActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: SaleExecutionSyncResponseDataBatchesItemActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: SaleExecutionSyncResponseDataBatchesItemAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: SaleExecutionSyncResponseDataBatchesItemCarcassExcessive;
  carcassMedium: SaleExecutionSyncResponseDataBatchesItemCarcassMedium;
  carcassMissing: SaleExecutionSyncResponseDataBatchesItemCarcassMissing;
  carcassThin: SaleExecutionSyncResponseDataBatchesItemCarcassThin;
  carcassUniform: SaleExecutionSyncResponseDataBatchesItemCarcassUniform;
  corralId: SaleExecutionSyncResponseDataBatchesItemCorralId;
  createdAt: string;
  descrption: SaleExecutionSyncResponseDataBatchesItemDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: SaleExecutionSyncResponseDataBatchesItemFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: SaleExecutionSyncResponseDataBatchesItemForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: SaleExecutionSyncResponseDataBatchesItemHideFromTreatment;
  hideFromTreatmentUntil: SaleExecutionSyncResponseDataBatchesItemHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: SaleExecutionSyncResponseDataBatchesItemOldCorralId;
  operationalCostGroupId: SaleExecutionSyncResponseDataBatchesItemOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: SaleExecutionSyncResponseDataBatchesItemScaledToSlaughter;
};

export type SaleExecutionSyncResponseDataAuditAnimalsItemOxId = number | null;

export type SaleExecutionSyncResponseDataAuditAnimalsItem = {
  bacthOrigin: number;
  batchDestiny: number;
  createdAt: string;
  electronic: string;
  farmId: number;
  gta: string;
  id: number;
  metadata: unknown;
  oxId: SaleExecutionSyncResponseDataAuditAnimalsItemOxId;
  sisbov: string;
  status: EnumsAuditManagementStatus;
};

export type SaleDiffTruckName = string | null;

export interface SaleDiff {
  oxenCount: number;
  rows: FieldDiff[];
  truckId: number;
  truckName: SaleDiffTruckName;
}

/**
 * Status do pedido (somente SALE_ORDER).
 */
export type SaleDateItemStatus = string | null;

export type SaleDateItemKind =
  (typeof SaleDateItemKind)[keyof typeof SaleDateItemKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SaleDateItemKind = {
  SALE_ORDER: "SALE_ORDER",
  HOLDING_SALE: "HOLDING_SALE",
} as const;

/**
 * Destino da saída, quando houver.
 */
export type SaleDateItemDestiny = string | null;

/**
 * Data de saída/venda atual.
 */
export type SaleDateItemCurrentDate = string | null;

/**
 * Uma venda listável para edição de data.
 */
export interface SaleDateItem {
  /** Nomes dos lotes envolvidos na saída. */
  batches: string[];
  /** Data de saída/venda atual. */
  currentDate: SaleDateItemCurrentDate;
  /** Destino da saída, quando houver. */
  destiny: SaleDateItemDestiny;
  /** Id de SaleOrder (SALE_ORDER) ou HoldingSale (HOLDING_SALE). */
  id: number;
  kind: SaleDateItemKind;
  /** Texto de identificação (nº/nome do pedido ou lote da saída avulsa). */
  label: string;
  /** Quantidade de animais embarcados. */
  oxenAmount: number;
  /** Status do pedido (somente SALE_ORDER). */
  status: SaleDateItemStatus;
}

/**
 * Quantidade de registros afetados pela troca de data.
 */
export interface SaleDateEditAffected {
  /** ExitTruck.exitAt atualizados. */
  exitTrucks: number;
  /** HoldingSale.date atualizados. */
  holdingSales: number;
  /** Ox.diedAt atualizados. */
  oxen: number;
  /** OxOnBatches.finalizedAt atualizados. */
  oxOnBatches: number;
  /** SaleOrder atualizados (createdAt/saleDate/expirationDay). */
  saleOrders: number;
}

export interface SaleAnnouncement {
  establishmentId?: number;
  oxenIds: number[];
  saleId: number;
}

export interface RevertSaleOrderPreviewResult {
  batches: RevertBatchPreview[];
  farmDay: string;
  warnings: string[];
}

/**
 * Body compartilhado do preview e do apply do estorno.
 */
export interface RevertSaleOrderBody {
  options?: RevertBatchOptions[];
}

/**
 * Nulo quando o lote segue ativo (saída parcial) — estorno direto, sem gap.
 */
export type RevertHoldingSalePreviewResultBatch = RevertBatchPreview | null;

export interface RevertHoldingSalePreviewResult {
  /** Nulo quando o lote segue ativo (saída parcial) — estorno direto, sem gap. */
  batch: RevertHoldingSalePreviewResultBatch;
  farmDay: string;
  /** Animais na saída — teto do estorno parcial. */
  oxCount: number;
  warnings: string[];
}

/**
 * Escolhas do estorno da saída avulsa — lote único, sem `batchId`.
 */
export interface RevertHoldingSaleOptions {
  /** Curral de destino. Obrigatório quando o original está ocupado (`needsCorralSelection`). */
  corralId?: number;
  /** Estorno parcial por quantidade: quantos animais reviver (os primeiros da saída, ordenados por id). Ausente ou igual ao total da saída → estorno total. Não pode exceder o total vendido (`oxCount`). Mutuamente exclusivo com `oxIds`. */
  oxenAmount?: number;
  /** Estorno por seleção individual: ids dos animais a reviver. Todos devem pertencer à saída. Lista vazia é inválida; lista com todos os animais da saída equivale ao estorno total. Mutuamente exclusivo com `oxenAmount`. */
  oxIds?: number[];
}

/**
 * Body compartilhado do preview e do apply do estorno da saída avulsa.
 */
export interface RevertHoldingSaleBody {
  options?: RevertHoldingSaleOptions;
}

export type RevertBatchPreviewOldCorralName = string | null;

export type RevertBatchPreviewOldCorralId = number | null;

export interface RevertBatchPreview {
  batchId: number;
  batchLabel: string;
  /** Dias sem nota de cocho: recebem a nota de estorno zerada (fechamento+1 … dia atual). */
  historyGapDays: string[];
  /** Curral original ocupado por outro lote — o estorno exige `corralId`. */
  needsCorralSelection: boolean;
  oldCorralId: RevertBatchPreviewOldCorralId;
  oldCorralName: RevertBatchPreviewOldCorralName;
  /** Dias sem realizado de trato: recebem um trato zerado (fechamento … dia atual−1). */
  treatGapDays: string[];
}

/**
 * Escolhas de estorno por lote afetado pela venda.
 */
export interface RevertBatchOptions {
  batchId: number;
  /** Curral de destino. Obrigatório quando o original está ocupado (`needsCorralSelection`). */
  corralId?: number;
}

export interface RetroactiveHoldingSalePreviewResult {
  batchLabel: string;
  /** A venda vai fechar o lote (quantidade = animais ativos). */
  batchWillFinalize: boolean;
  farmDay: string;
  /** Há dados a excluir/devolver — o dialog de confirmação só aparece quando true. */
  hasChanges: boolean;
  summary: AdjustHoldingSaleDateSummary;
}

/**
 * Body do preview da saída avulsa retroativa.
 */
export interface RetroactiveHoldingSalePreviewBody {
  /** Data da saída (YYYY-MM-DD), até o dia atual da fazenda. */
  date: string;
  oxenAmount: number;
  /** Identificadores dos animais selecionados para a saída. */
  oxenIds?: number[];
}

export interface RestoreFeedDataPublicResponse {
  ok: boolean;
}

export interface ResetStockResponse {
  /** Movimentações de estoque removidas (entradas e saídas) */
  flowsRemoved: number;
  /** Pedidos de compra removidos (com suas notas fiscais) */
  purchasesRemoved: number;
}

export interface ResetAllReportsCacheResponse {
  message: string;
  success: boolean;
}

export interface RequestPasswordResetResponse {
  /** Mensagem genérica: não revela se o e-mail está cadastrado. */
  message: string;
}

export interface RequestPasswordResetBody {
  email: string;
}

export interface RequestEmailVerificationResponse {
  /** Mensagem genérica: não revela se o e-mail está cadastrado ou já verificado. */
  message: string;
}

export interface RequestEmailVerificationBody {
  email: string;
}

export type ReportSlaughterResultResponseTrucksItemFreightPerAtSign =
  | number
  | null;

export type ReportSlaughterResultResponseTrucksItem = {
  bigWeighingMachineWeightKg: number;
  destiny: string;
  driver: string;
  exitDate: string;
  freightPerAtSign: ReportSlaughterResultResponseTrucksItemFreightPerAtSign;
  gtaNumber: string;
  oxenAmount: number;
  plate: string;
  totalWeightKg: number;
};

export type ReportSlaughterResultResponseTotalWeight = {
  totalCarcassWeightAtSign: number;
  totalCarcassWeightKg: number;
  totalWeightKg: number;
};

export type ReportSlaughterResultResponseInvoicesItemIsComplement =
  | boolean
  | null;

export type ReportSlaughterResultResponseInvoicesItemEmittedAt = string | null;

export type ReportSlaughterResultResponseInvoicesItem = {
  emittedAt: ReportSlaughterResultResponseInvoicesItemEmittedAt;
  isComplement: ReportSlaughterResultResponseInvoicesItemIsComplement;
  number: string;
  value: number;
};

export type ReportSlaughterResultResponseFridgeInfo = {
  oxenAmount: number;
  slaughterDate: string;
};

export type ReportSlaughterResultResponseFinancialAtSignPrice = number | null;

export type ReportSlaughterResultResponseFinancial = {
  atSignPrice: ReportSlaughterResultResponseFinancialAtSignPrice;
  expirationDate: string;
  finalSalePrice: number;
  paymentMethod: string;
};

export type ReportSlaughterResultResponseExpectedResult = {
  carcassYield?: number;
  perAnimalWeightAtSign?: number;
  perAnimalWeightKg?: number;
};

export type ReportSlaughterResultResponseCorrectResult = {
  carcassYield: number;
  oxenAmount: number;
  perAnimalWeightKg: number;
  totalCarcassWeightKg: number;
  totalWeightKg: number;
};

export type ReportSlaughterResultResponseAverageWeight = {
  carcassWeightAverageAtSign: number;
  carcassWeightAverageKg: number;
};

export interface ReportSlaughterResultResponse {
  averageWeight: ReportSlaughterResultResponseAverageWeight;
  correctResult: ReportSlaughterResultResponseCorrectResult;
  expectedResult: ReportSlaughterResultResponseExpectedResult;
  financial: ReportSlaughterResultResponseFinancial;
  fridgeInfo: ReportSlaughterResultResponseFridgeInfo;
  id: number;
  invoices: ReportSlaughterResultResponseInvoicesItem[];
  saleNumber: string;
  totalInvoicesWComplement: number;
  totalInvoicesWoComplement: number;
  totalWeight: ReportSlaughterResultResponseTotalWeight;
  trucks: ReportSlaughterResultResponseTrucksItem[];
}

export interface ReportSlaughterResultRequest {
  saleNumber: number;
}

/**
 * Registro em memória dos relatórios que rodam em segundo plano.

O `POST` que dispara o relatório responde na hora com o `jobId` e **não aguarda** o processamento; o frontend acompanha pelo `GET` de estado. Ver `docs/viabilidade-relatorio-em-segundo-plano.md`.

Cache próprio de propósito, e não o `SingletonTTLCache`: aquele é compartilhado com os chunks dos relatórios atuais e é zerado inteiro pelo `POST /reports/reset-cache`, o que derrubaria o estado de jobs em andamento.
 */
export type ReportJobStatus =
  (typeof ReportJobStatus)[keyof typeof ReportJobStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportJobStatus = {
  running: "running",
  done: "done",
  error: "error",
  canceled: "canceled",
} as const;

export interface ReportJobProgress {
  percentage: number;
  processed: number;
  total: number;
}

export interface ReportInterval {
  end?: string;
  start: string;
}

export type ReplicateCurrentForeseenResponseReadValue = number | null;

export type ReplicateCurrentForeseenResponseReadType = EnumsReadType | null;

export type ReplicateCurrentForeseenResponseManagedAt = string | null;

export interface ReplicateCurrentForeseenResponse {
  batchId: number;
  clean: boolean;
  day: string;
  farmId: number;
  hideFromTreatment: boolean;
  id: number;
  managedAt: ReplicateCurrentForeseenResponseManagedAt;
  matterVariation: number;
  nightlyReads: GlobalPrismaJsonNightlyRead[];
  readType: ReplicateCurrentForeseenResponseReadType;
  readValue: ReplicateCurrentForeseenResponseReadValue;
  resultingMatter: number;
}

export interface ReplaceFeederBody {
  batchId: number;
  feederId: number;
  order: number;
}

export interface RenameCattleManifestLayoutResponse {
  id: number;
  name: string;
}

export interface RenameCattleManifestLayoutBody {
  name: string;
}

export interface RemoveStockResponse {
  [key: string]: any;
}

export interface RemoveGtasFromEntryAnnouncementResponse {
  announcementDeleted: boolean;
  removedGtaIds: number[];
}

export type RemovalResultRevivedToBatchId = number | null;

export interface RemovalResult {
  batchWasFinalized: boolean;
  oxId: number;
  revivedToBatchId: RemovalResultRevivedToBatchId;
  /** `true` quando o animal já estava estornado (operação pulada). */
  skipped: boolean;
}

export interface RegisterCloudFarmResponse {
  schema: string;
}

export type RegisterCloudFarmStructuresItem = {
  category: string;
  name: string;
};

export type RegisterCloudFarmPosition = {
  lat: number;
  lng: number;
};

export type RegisterCloudFarmOwner = {
  document?: string;
  email?: string;
  ERAS?: string;
  image?: string;
  INCRA?: string;
  IS?: string;
  name: string;
  NIRF?: string;
  password: string;
};

export type RegisterCloudFarmFactoryItem = {
  lat: number;
  lng: number;
};

export type RegisterCloudFarmAddress = {
  city: string;
  complement?: string;
  country: string;
  neighborhood?: string;
  number?: string;
  state: string;
  street?: string;
  zip: string;
};

export interface RegisterCloudFarm {
  address: RegisterCloudFarmAddress;
  alias?: string;
  channel: string;
  coreToken: string;
  day: string;
  factory: RegisterCloudFarmFactoryItem[];
  hasAutomation: boolean;
  hasTraceability: boolean;
  managementGroupName: string;
  name: string;
  owner: RegisterCloudFarmOwner;
  position: RegisterCloudFarmPosition;
  structures: RegisterCloudFarmStructuresItem[];
  type: string;
  userId: number;
}

export interface RefreshTokenResponse {
  expiresAt: number;
  refresh: string;
  token: string;
  user: RefreshTokenResponseUser;
}

export type RefreshTokenResponseUserPersonPhone = string | null;

export type RefreshTokenResponseUserPersonDocument = string | null;

export type RefreshTokenResponseUserPersonDescription = string | null;

export type RefreshTokenResponseUserPersonCode = string | null;

export type RefreshTokenResponseUserPerson = {
  code: RefreshTokenResponseUserPersonCode;
  createdAt: string;
  description: RefreshTokenResponseUserPersonDescription;
  document: RefreshTokenResponseUserPersonDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: RefreshTokenResponseUserPersonPhone;
  profiles: EnumsProfile[];
};

export type RefreshTokenResponseUserPassword = string | null;

export type RefreshTokenResponseUserGov = GlobalPrismaJsonGovDocuments | null;

export type RefreshTokenResponseUser = {
  email: RefreshTokenResponseUserEmail;
  emailVerifiedAt: RefreshTokenResponseUserEmailVerifiedAt;
  farm: RefreshTokenResponseUserFarm;
  farmId: number;
  gov: RefreshTokenResponseUserGov;
  id: number;
  password: RefreshTokenResponseUserPassword;
  person: RefreshTokenResponseUserPerson;
  personId: number;
};

export type RefreshTokenResponseUserFarmSenarPercent = number | null;

export type RefreshTokenResponseUserFarmMatinalReadTime = string | null;

export type RefreshTokenResponseUserFarmLastCertifierImport = string | null;

export type RefreshTokenResponseUserFarmLastBndImport = string | null;

export type RefreshTokenResponseUserFarmInstallRunId = string | null;

export type RefreshTokenResponseUserFarmCustomerId = string | null;

export type RefreshTokenResponseUserFarmCorrectionPercent = number | null;

export type RefreshTokenResponseUserFarmAlias = string | null;

export type RefreshTokenResponseUserFarm = {
  addressId: number;
  alias: RefreshTokenResponseUserFarmAlias;
  blockedDays: number;
  correctionPercent: RefreshTokenResponseUserFarmCorrectionPercent;
  createdAt: string;
  customerId: RefreshTokenResponseUserFarmCustomerId;
  dailyCost: number;
  day: string;
  divisionThreshold: number;
  factory: GlobalPrismaJsonLatLng[];
  gradeInfo: unknown;
  gradeMethod: EnumsGradeMethod;
  hasAutomation: boolean;
  hasTraceability: boolean;
  id: number;
  installRunId: RefreshTokenResponseUserFarmInstallRunId;
  interestRate: number;
  lastBndImport: RefreshTokenResponseUserFarmLastBndImport;
  lastCertifierImport: RefreshTokenResponseUserFarmLastCertifierImport;
  managementConfig: unknown;
  matinalReadTime: RefreshTokenResponseUserFarmMatinalReadTime;
  name: string;
  nightlyReadTimes: string[];
  position: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification: boolean;
  sapId: string;
  senarPercent: RefreshTokenResponseUserFarmSenarPercent;
  treatViewType: EnumsTreatViewType;
};

export type RefreshTokenResponseUserEmailVerifiedAt = string | null;

export type RefreshTokenResponseUserEmail = string | null;

export type ReceiveStockResponsePremix = boolean | null;

export type ReceiveStockResponseActive = boolean | null;

export interface ReceiveStockResponse {
  active: ReceiveStockResponseActive;
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  naturalMatter: number;
  premix: ReceiveStockResponsePremix;
  supplement: boolean;
}

export type ReceiveStockPurchaseBodyPartialEntriesItem = {
  /** Peso declarado na nota fiscal (saída da fábrica) */
  billedWeight: number;
  /** Número da nota fiscal do caminhão que chegou com o pedido */
  number: string;
  /** Preço declarado na nota fiscal */
  price: number;
  /** Peso aferido na fazenda (chegada do caminhão) */
  receivedWeight: number;
};

export interface ReceiveStockPurchaseBody {
  date: string;
  partialEntries: ReceiveStockPurchaseBodyPartialEntriesItem[];
  purchaseId: number;
  structureIds?: number[];
}

export type ReceivePurchaseResponseReceivedAt = string | null;

export type ReceivePurchaseResponsePartnerHerd = string | null;

export type ReceivePurchaseResponseObservation = string | null;

export type ReceivePurchaseResponseEarringsPerPage = number | null;

export interface ReceivePurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: ReceivePurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: ReceivePurchaseResponseObservation;
  partnerHerd: ReceivePurchaseResponsePartnerHerd;
  price: number;
  receivedAt: ReceivePurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export type ReceivePremixResponseDescription = string | null;

export interface ReceivePremixResponse {
  amount: number;
  date: string;
  description: ReceivePremixResponseDescription;
  id: number;
  stockId: number;
}

export type ReadType = EnumsReadType;

export interface ReIdentificationAnnouncement {
  createdAt?: string;
  newSisbov: number;
  oldSisbov: number;
  oxId: number;
}

export type PurchasesAvailableEarringsResponseItemsItem = {
  available: number[];
  cancelled: number[];
  name: string;
  owner: string;
  purchaseId: number;
  total: number;
  used: number[];
};

export interface PurchasesAvailableEarringsResponse {
  items: PurchasesAvailableEarringsResponseItemsItem[];
  next?: number;
  previous?: number;
}

export type PurchaseStatus = EnumsPurchaseStatus;

export type PurchaseCategory = EnumsPurchaseCategory;

export type PurchaseCalculationType =
  (typeof PurchaseCalculationType)[keyof typeof PurchaseCalculationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseCalculationType = {
  AVERAGE_PRICE: "AVERAGE_PRICE",
  APPORTIONMENT_PER_ANIMAL: "APPORTIONMENT_PER_ANIMAL",
  PROCESSING_WEIGHT: "PROCESSING_WEIGHT",
} as const;

export type Profile = EnumsProfile;

export type ProccessFeedLinkTreatStatusResponseItem = {
  error?: string;
  id: number;
  success: boolean;
};

export type ProccessFeedLinkTreatStatusResponse =
  ProccessFeedLinkTreatStatusResponseItem[];

/**
 * Batch Payload for updateMany & deleteMany & createMany
 */
export interface PrismaBatchPayload {
  count: number;
}

export type PreviewCurveRecalculationResponseProjectedAvgWeightKg =
  | number
  | null;

export interface PreviewCurveRecalculationResponse {
  projectedAvgWeightKg: PreviewCurveRecalculationResponseProjectedAvgWeightKg;
}

export type PreviewBiotypeRollbackResponseProjectedAvgWeightKg = number | null;

export interface PreviewBiotypeRollbackResponse {
  projectedAvgWeightKg: PreviewBiotypeRollbackResponseProjectedAvgWeightKg;
}

export interface PersonFilter {
  profiles?: EnumsProfile[];
}

export interface PerDistanceItem {
  atSignPrice: number;
  atSignShipping: number;
  atSignWeight: number;
  breakDiffGoal: number;
  breakGoalPercentage: number;
  diffBreakPercentage: number;
  diffQuantityPercentage: number;
  distance: number;
  distanceRange: string;
  observedBreakAtSign: number;
  observedBreakPercentage: number;
  oxenAmount: number;
  oxenAmountPercentage: number;
  quantityGoalPercentage: number;
  reportOxenCount?: number;
  totalAtSign: number;
  totalAtSignPrice: number;
  totalPrice: number;
}

export interface PerContractItem {
  atSignPrice: number;
  averageDistance: number;
  breakDiffGoal: number;
  breakGoalPercentage: number;
  buyer: string;
  contractNumber: string;
  contractOxenPercentage: number;
  entryAtSignWeight: number;
  entryDate: string;
  entryType: EnumsOxPurpose;
  observedBreakAtSign: number;
  observedBreakPercentage: number;
  /** Cabeças na GTA (sexo da aba) ou total do pedido; exibido em QTD (CAB). */
  oxenAmount: number;
  partner: string;
  /** Registros de boi no relatório usados para médias (somatórios / linhas); removido após normalização. */
  reportOxenCount?: number;
  shippingAtSign: number;
  totalAtSign: number;
  totalAtSignPrice: number;
  totalPrice: number;
  totalShipping: number;
}

export interface PerCategoryItem {
  atSignPrice: number;
  atSignShipping: number;
  atSignWeight: number;
  breakDiffGoal: number;
  breakGoalPercentage: number;
  category: EnumsOxCategory;
  diffBreakPercentage: number;
  diffQuantityPercentage: number;
  distance: number;
  observedBreakAtSign: number;
  observedBreakPercentage: number;
  oxenAmount: number;
  oxenAmountPercentage: number;
  quantityGoalPercentage: number;
  reportOxenCount?: number;
  totalAtSign: number;
  totalAtSignPrice: number;
  totalPrice: number;
  weightRange: string;
}

export type PendingOxStatus =
  (typeof PendingOxStatus)[keyof typeof PendingOxStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PendingOxStatus = {
  PENDING: "PENDING",
} as const;

export interface PendingOx {
  blockedUntil: string;
  daysRemaining: number;
  identifier: string;
  line: number;
  oxId: number;
  reason: string;
  status: PendingOxStatus;
}

export type PasturesReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type PasturesReportXlsxResponse =
  | PasturesReportXlsxResponseAnyOf
  | PasturesReportXlsxResponseAnyOfThree;

export type PasturesReportXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type PasturesReportXlsxResponseAnyOf = {
  buffer: PasturesReportXlsxResponseAnyOfBuffer;
};

export type PasturesReportResponse = PastureReportResult[];

export interface PastureToPicketPreviewResult {
  batchId: number;
  batchName: string;
  corralName: string;
  missingDays: string[];
}

export interface PastureToPicketBody {
  batchId: number;
}

export interface PastureSupplementationBody {
  amount: number;
  date: string;
  supplementId: number;
}

export type PastureReportResultConsume = {
  average: number;
  lastPeriod: number;
};

export interface PastureReportResult {
  batchName: string;
  breed: string;
  category: EnumsOxCategory[];
  consume: PastureReportResultConsume;
  corralName: string;
  currentWeight: number;
  deaths: number;
  entryDate: string;
  entryType: EnumsOxPurpose[];
  entryWeight: number;
  foodCost: number;
  GPD: number;
  ownerName: string;
  oxenAmount: number;
  pastureDays: number;
  supplementName: string;
}

export interface PartnerSlaughterResultRequest {
  gender: EnumsOxGender;
  partnerId: number;
  purchaseId: number;
}

export interface PartnerSlaughterResult {
  financialSummary: FinancialSummary;
  generalInfo: GeneralInfo;
  zootechnicalInfo: ZootechnicalInfo;
}

export interface PartnerClosureUpdateRequest {
  finalSalePrice: number;
}

export interface PartnerClosureRequest {
  finalSalePrice: number;
  oxenPurchaseId: number;
  saleOrderIds: number[];
}

export interface Paginate {
  limit?: number;
  page?: number;
}

export interface OxenHealthFilter {
  appliedAt?: string;
  batchId?: number;
  corralId?: number;
  limit?: number;
  oxIdentifier?: string;
  page?: number;
}

export type OxenGroupStats3 = {
  FEMALE: number;
  MALE: number;
};

export type OxenGroupStats2 = {
  FEMALE: number;
  MALE: number;
};

export type OxenGroupStats1 = {
  FEMALE: number;
  MALE: number;
};

export type OxenGroupStats0 = {
  FEMALE: number;
  MALE: number;
};

export interface OxenGroupStats {
  [key: string]: {
    "0": OxenGroupStats0;
    "1": OxenGroupStats1;
    "2": OxenGroupStats2;
    "3": OxenGroupStats3;
  };
}

export type OxPurpose = EnumsOxPurpose;

export type OxPerformanceGender =
  (typeof OxPerformanceGender)[keyof typeof OxPerformanceGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OxPerformanceGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export interface OxPerformance {
  exitCarcassYield: number;
  exitWeight: number;
  gender: OxPerformanceGender;
  gmd: number;
  minimumEntryWeight: number;
  referenceDays: number;
  slaughterWeight: number;
}

export type OxMovementKind =
  (typeof OxMovementKind)[keyof typeof OxMovementKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OxMovementKind = {
  ANIMAL: "ANIMAL",
  BATCH: "BATCH",
  CORRAL: "CORRAL",
} as const;

export type OxMovementHistoryRowWeightingMapId = number | null;

export type OxMovementHistoryRowWeightingMapCode = string | null;

export type OxMovementHistoryRowVariety = string | null;

export type OxMovementHistoryRowSisbov = string | null;

export type OxMovementHistoryRowPurchaseObservation = string | null;

export type OxMovementHistoryRowPurchaseName = string | null;

export type OxMovementHistoryRowProcessingWeight = number | null;

export type OxMovementHistoryRowPriceAtSignEntry = number | null;

export type OxMovementHistoryRowPartnerName = string | null;

export type OxMovementHistoryRowOxOnBatchId = number | null;

export type OxMovementHistoryRowOwnerName = string | null;

export type OxMovementHistoryRowOriginOwnerName = string | null;

export type OxMovementHistoryRowOriginName = string | null;

export type OxMovementHistoryRowOriginCorralName = string | null;

export type OxMovementHistoryRowOriginCorralId = number | null;

export type OxMovementHistoryRowLastWeightingDate = string | null;

export type OxMovementHistoryRowLastWeight = number | null;

export type OxMovementHistoryRowInternalSaleName = string | null;

export type OxMovementHistoryRowIncludedAt = string | null;

export type OxMovementHistoryRowIdentifier = string | null;

export type OxMovementHistoryRowIdentifiedAt = string | null;

export type OxMovementHistoryRowIdentificationDate = string | null;

export type OxMovementHistoryRowGtaNumber = string | null;

export type OxMovementHistoryRowGtaEmission = string | null;

export type OxMovementHistoryRowEntryWeight = number | null;

export type OxMovementHistoryRowElectronic = string | null;

export type OxMovementHistoryRowDiedAt = string | null;

export type OxMovementHistoryRowDestCorralName = string | null;

export type OxMovementHistoryRowDestCorralId = number | null;

export type OxMovementHistoryRowDentitionStage = string | null;

export type OxMovementHistoryRowCurrentWeight = number | null;

export type OxMovementHistoryRowCurrentCorralName = string | null;

export type OxMovementHistoryRowCurrentBatchName = string | null;

export type OxMovementHistoryRowCurrentBatchId = number | null;

export type OxMovementHistoryRowCertifierDate = string | null;

export type OxMovementHistoryRowBuyerName = string | null;

export type OxMovementHistoryRowBlockReason = OxMovementBlockReason | null;

export type OxMovementHistoryRowBlockedUntil = string | null;

export type OxMovementHistoryRowBirth = string | null;

export type OxMovementEventType =
  (typeof OxMovementEventType)[keyof typeof OxMovementEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OxMovementEventType = {
  OX_BATCH_TRANSFER: "OX_BATCH_TRANSFER",
  BATCH_CORRAL_MOVE: "BATCH_CORRAL_MOVE",
} as const;

export interface OxMovementHistoryRow {
  birth: OxMovementHistoryRowBirth;
  blockedUntil: OxMovementHistoryRowBlockedUntil;
  blockReason: OxMovementHistoryRowBlockReason;
  breed: string;
  buyerName: OxMovementHistoryRowBuyerName;
  certifierDate: OxMovementHistoryRowCertifierDate;
  currentBatchId: OxMovementHistoryRowCurrentBatchId;
  currentBatchName: OxMovementHistoryRowCurrentBatchName;
  currentCorralName: OxMovementHistoryRowCurrentCorralName;
  currentWeight: OxMovementHistoryRowCurrentWeight;
  dentitionStage: OxMovementHistoryRowDentitionStage;
  destBatchId: number;
  destBatchName: string;
  destCorralId: OxMovementHistoryRowDestCorralId;
  destCorralName: OxMovementHistoryRowDestCorralName;
  diedAt: OxMovementHistoryRowDiedAt;
  editable: boolean;
  electronic: OxMovementHistoryRowElectronic;
  entryWeight: OxMovementHistoryRowEntryWeight;
  eventKey: string;
  eventType: OxMovementEventType;
  gender: string;
  gtaEmission: OxMovementHistoryRowGtaEmission;
  gtaNumber: OxMovementHistoryRowGtaNumber;
  identificationDate: OxMovementHistoryRowIdentificationDate;
  identifiedAt: OxMovementHistoryRowIdentifiedAt;
  identifier: OxMovementHistoryRowIdentifier;
  includedAt: OxMovementHistoryRowIncludedAt;
  internalSaleName: OxMovementHistoryRowInternalSaleName;
  isLastMovement: boolean;
  lastWeight: OxMovementHistoryRowLastWeight;
  lastWeightingDate: OxMovementHistoryRowLastWeightingDate;
  movementKind: OxMovementKind;
  operationAt: string;
  operationDate: string;
  originBatchId: number;
  originBatchName: string;
  originCorralId: OxMovementHistoryRowOriginCorralId;
  originCorralName: OxMovementHistoryRowOriginCorralName;
  originName: OxMovementHistoryRowOriginName;
  originOwnerName: OxMovementHistoryRowOriginOwnerName;
  ownerName: OxMovementHistoryRowOwnerName;
  oxId: number;
  oxOnBatchId: OxMovementHistoryRowOxOnBatchId;
  partnerName: OxMovementHistoryRowPartnerName;
  priceAtSignEntry: OxMovementHistoryRowPriceAtSignEntry;
  processingWeight: OxMovementHistoryRowProcessingWeight;
  purchaseName: OxMovementHistoryRowPurchaseName;
  purchaseObservation: OxMovementHistoryRowPurchaseObservation;
  sisbov: OxMovementHistoryRowSisbov;
  variety: OxMovementHistoryRowVariety;
  weightingMapCode: OxMovementHistoryRowWeightingMapCode;
  weightingMapId: OxMovementHistoryRowWeightingMapId;
}

export type OxMovementBlockReason =
  (typeof OxMovementBlockReason)[keyof typeof OxMovementBlockReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OxMovementBlockReason = {
  HAS_SUBSEQUENT_MOVEMENT: "HAS_SUBSEQUENT_MOVEMENT",
  DEAD: "DEAD",
  CORRAL_MOVE: "CORRAL_MOVE",
} as const;

export type OxMovementAvailabilityFilter =
  (typeof OxMovementAvailabilityFilter)[keyof typeof OxMovementAvailabilityFilter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OxMovementAvailabilityFilter = {
  EDITABLE: "EDITABLE",
  BLOCKED: "BLOCKED",
} as const;

export type OxLastTransferSnapshotTransferredAt = string | null;

export interface OxLastTransferSnapshot {
  destinyBatchId: number;
  destinyBatchName: string;
  originBatchId: number;
  originBatchName: string;
  transferredAt: OxLastTransferSnapshotTransferredAt;
}

export interface OxLastTransferAffected {
  consumesImpacted: number;
  destinyFinalized: number;
  historiesImpacted: number;
  originReopened: number;
  oxOnBatchesRemoved: number;
  oxOnBatchesUpdated: number;
  treatsImpacted: number;
}

export type OxLastTransferAction =
  (typeof OxLastTransferAction)[keyof typeof OxLastTransferAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OxLastTransferAction = {
  CHANGE_DATE: "CHANGE_DATE",
  UNDO: "UNDO",
  MOVE_TO_BATCH: "MOVE_TO_BATCH",
} as const;

export type OxIdentificationResponseStartOfTreatment = string | null;

export type OxIdentificationResponseSisbov = string | null;

export type OxIdentificationResponseSalesMarketType =
  EnumsSalesMarketType | null;

export type OxIdentificationResponseReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type OxIdentificationResponseReversedDeathDetails = string | null;

export type OxIdentificationResponseReversedDeathDate = string | null;

export type OxIdentificationResponseReversedDeathCause = EnumsDeathCause | null;

export type OxIdentificationResponsePurchaseId = number | null;

export type OxIdentificationResponsePriceAtSignExit = number | null;

export type OxIdentificationResponsePriceAtSignEntry = number | null;

export type OxIdentificationResponseOtherDeathCause = string | null;

export type OxIdentificationResponseIsNecropsyPerformed = boolean | null;

export type OxIdentificationResponseInvoice = string | null;

export type OxIdentificationResponseInternalSaleId = number | null;

export type OxIdentificationResponseIdentifier = string | null;

export type OxIdentificationResponseIdentifiedAt = string | null;

export type OxIdentificationResponseIdentificationSource =
  EnumsIdentificationSource | null;

export type OxIdentificationResponseHasBirthAnnouncement = boolean | null;

export type OxIdentificationResponseGtaId = number | null;

export type OxIdentificationResponseExitTruckId = number | null;

export type OxIdentificationResponseElectronic = string | null;

export type OxIdentificationResponseDiedAt = string | null;

export type OxIdentificationResponseDentitionStage = EnumsDentitionStage | null;

export type OxIdentificationResponseDeathReason = EnumsDeathCause | null;

export type OxIdentificationResponseDeathNecropsy = EnumsDeathNecropsy | null;

export type OxIdentificationResponseDeathDetails = string | null;

export type OxIdentificationResponseDeathCause = EnumsDeathCause | null;

export type OxIdentificationResponseComments = string | null;

export type OxIdentificationResponseCertifierDate = string | null;

export type OxIdentificationResponseCattleManifestId = number | null;

export type OxIdentificationResponseCarcassWeight = number | null;

export type OxIdentificationResponseCarcassType = EnumsCarcassType | null;

export type OxIdentificationResponseCarcassPrice = number | null;

export type OxIdentificationResponseCarcass = number | null;

export type OxIdentificationResponseBornOnFarm = boolean | null;

export type OxIdentificationResponseBndTracked = boolean | null;

export type OxIdentificationResponseBatchesItemFinalizedAt = string | null;

export type OxIdentificationResponseBatchesItemDescription = string | null;

export type OxIdentificationResponseBatchesItem = {
  batchId: number;
  createdAt: string;
  description: OxIdentificationResponseBatchesItemDescription;
  finalizedAt: OxIdentificationResponseBatchesItemFinalizedAt;
  id: number;
  oxId: number;
};

export interface OxIdentificationResponse {
  batches: OxIdentificationResponseBatchesItem[];
  birth: string;
  blockedUntil: string;
  bndTracked: OxIdentificationResponseBndTracked;
  bornOnFarm: OxIdentificationResponseBornOnFarm;
  breed: string;
  carcass: OxIdentificationResponseCarcass;
  carcassPrice: OxIdentificationResponseCarcassPrice;
  carcassType: OxIdentificationResponseCarcassType;
  carcassWeight: OxIdentificationResponseCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: OxIdentificationResponseCattleManifestId;
  certifierDate: OxIdentificationResponseCertifierDate;
  comments: OxIdentificationResponseComments;
  deathCause: OxIdentificationResponseDeathCause;
  deathDetails: OxIdentificationResponseDeathDetails;
  deathNecropsy: OxIdentificationResponseDeathNecropsy;
  deathReason: OxIdentificationResponseDeathReason;
  dentitionStage: OxIdentificationResponseDentitionStage;
  diedAt: OxIdentificationResponseDiedAt;
  electronic: OxIdentificationResponseElectronic;
  exitTruckId: OxIdentificationResponseExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: OxIdentificationResponseGtaId;
  hasBirthAnnouncement: OxIdentificationResponseHasBirthAnnouncement;
  id: number;
  identificationSource: OxIdentificationResponseIdentificationSource;
  identifiedAt: OxIdentificationResponseIdentifiedAt;
  identifier: OxIdentificationResponseIdentifier;
  includedAt: string;
  internalSaleId: OxIdentificationResponseInternalSaleId;
  invoice: OxIdentificationResponseInvoice;
  isNecropsyPerformed: OxIdentificationResponseIsNecropsyPerformed;
  otherDeathCause: OxIdentificationResponseOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: OxIdentificationResponsePriceAtSignEntry;
  priceAtSignExit: OxIdentificationResponsePriceAtSignExit;
  purchaseId: OxIdentificationResponsePurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: OxIdentificationResponseReversedDeathCause;
  reversedDeathDate: OxIdentificationResponseReversedDeathDate;
  reversedDeathDetails: OxIdentificationResponseReversedDeathDetails;
  reversedDeathNecropsy: OxIdentificationResponseReversedDeathNecropsy;
  runtime: number;
  salesMarketType: OxIdentificationResponseSalesMarketType;
  sisbov: OxIdentificationResponseSisbov;
  sisbovHistory: string[];
  startOfTreatment: OxIdentificationResponseStartOfTreatment;
  variety: string;
}

export type OxGender = EnumsOxGender;

export interface OxFillIdentity {
  electronic: string;
  identifier?: string;
  sisbov: number;
}

/**
 * Animais da entrada que compartilham GTA, faixa etária e sexo.
 */
export interface OxEntryGroup {
  ageInMonths: number;
  amount: number;
  gender: EnumsOxGender;
  gtaId: number;
}

export interface OxEntryAffected {
  consumesImpacted: number;
  historiesImpacted: number;
  oxenCreated: number;
  treatsImpacted: number;
}

export interface OxClosureResponse {
  carcassWeightAverage: number;
  carcassWeightAverageAtSign: number;
  carcassYieldAverage: number;
  notFoundOxen: string[];
  oxenUpdated: OxClosureResponseOxenUpdatedItem[];
  priceAtSignAverage: number;
}

export type OxClosureResponseOxenUpdatedItemStartOfTreatment = string | null;

export type OxClosureResponseOxenUpdatedItemSisbov = string | null;

export type OxClosureResponseOxenUpdatedItemSalesMarketType =
  EnumsSalesMarketType | null;

export type OxClosureResponseOxenUpdatedItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type OxClosureResponseOxenUpdatedItemReversedDeathDetails =
  | string
  | null;

export type OxClosureResponseOxenUpdatedItemReversedDeathDate = string | null;

export type OxClosureResponseOxenUpdatedItemReversedDeathCause =
  EnumsDeathCause | null;

export type OxClosureResponseOxenUpdatedItemPurchaseId = number | null;

export type OxClosureResponseOxenUpdatedItemPriceAtSignExit = number | null;

export type OxClosureResponseOxenUpdatedItemPriceAtSignEntry = number | null;

export type OxClosureResponseOxenUpdatedItemOtherDeathCause = string | null;

export type OxClosureResponseOxenUpdatedItemIsNecropsyPerformed =
  | boolean
  | null;

export type OxClosureResponseOxenUpdatedItemInvoice = string | null;

export type OxClosureResponseOxenUpdatedItemInternalSaleId = number | null;

export type OxClosureResponseOxenUpdatedItemIdentifier = string | null;

export type OxClosureResponseOxenUpdatedItemIdentifiedAt = string | null;

export type OxClosureResponseOxenUpdatedItemIdentificationSource =
  EnumsIdentificationSource | null;

export type OxClosureResponseOxenUpdatedItemHasBirthAnnouncement =
  | boolean
  | null;

export type OxClosureResponseOxenUpdatedItemGtaId = number | null;

export type OxClosureResponseOxenUpdatedItemExitTruckId = number | null;

export type OxClosureResponseOxenUpdatedItemElectronic = string | null;

export type OxClosureResponseOxenUpdatedItemDiedAt = string | null;

export type OxClosureResponseOxenUpdatedItemDentitionStage =
  EnumsDentitionStage | null;

export type OxClosureResponseOxenUpdatedItemDeathReason =
  EnumsDeathCause | null;

export type OxClosureResponseOxenUpdatedItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type OxClosureResponseOxenUpdatedItemDeathDetails = string | null;

export type OxClosureResponseOxenUpdatedItemDeathCause = EnumsDeathCause | null;

export type OxClosureResponseOxenUpdatedItemComments = string | null;

export type OxClosureResponseOxenUpdatedItemCertifierDate = string | null;

export type OxClosureResponseOxenUpdatedItemCattleManifestId = number | null;

export type OxClosureResponseOxenUpdatedItemCarcassWeight = number | null;

export type OxClosureResponseOxenUpdatedItemCarcassType =
  EnumsCarcassType | null;

export type OxClosureResponseOxenUpdatedItemCarcassPrice = number | null;

export type OxClosureResponseOxenUpdatedItemCarcass = number | null;

export type OxClosureResponseOxenUpdatedItemBornOnFarm = boolean | null;

export type OxClosureResponseOxenUpdatedItemBndTracked = boolean | null;

export type OxClosureResponseOxenUpdatedItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: OxClosureResponseOxenUpdatedItemBndTracked;
  bornOnFarm: OxClosureResponseOxenUpdatedItemBornOnFarm;
  breed: string;
  carcass: OxClosureResponseOxenUpdatedItemCarcass;
  carcassPrice: OxClosureResponseOxenUpdatedItemCarcassPrice;
  carcassType: OxClosureResponseOxenUpdatedItemCarcassType;
  carcassWeight: OxClosureResponseOxenUpdatedItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: OxClosureResponseOxenUpdatedItemCattleManifestId;
  certifierDate: OxClosureResponseOxenUpdatedItemCertifierDate;
  comments: OxClosureResponseOxenUpdatedItemComments;
  deathCause: OxClosureResponseOxenUpdatedItemDeathCause;
  deathDetails: OxClosureResponseOxenUpdatedItemDeathDetails;
  deathNecropsy: OxClosureResponseOxenUpdatedItemDeathNecropsy;
  deathReason: OxClosureResponseOxenUpdatedItemDeathReason;
  dentitionStage: OxClosureResponseOxenUpdatedItemDentitionStage;
  diedAt: OxClosureResponseOxenUpdatedItemDiedAt;
  electronic: OxClosureResponseOxenUpdatedItemElectronic;
  exitTruckId: OxClosureResponseOxenUpdatedItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: OxClosureResponseOxenUpdatedItemGtaId;
  hasBirthAnnouncement: OxClosureResponseOxenUpdatedItemHasBirthAnnouncement;
  id: number;
  identificationSource: OxClosureResponseOxenUpdatedItemIdentificationSource;
  identifiedAt: OxClosureResponseOxenUpdatedItemIdentifiedAt;
  identifier: OxClosureResponseOxenUpdatedItemIdentifier;
  includedAt: string;
  internalSaleId: OxClosureResponseOxenUpdatedItemInternalSaleId;
  invoice: OxClosureResponseOxenUpdatedItemInvoice;
  isNecropsyPerformed: OxClosureResponseOxenUpdatedItemIsNecropsyPerformed;
  otherDeathCause: OxClosureResponseOxenUpdatedItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: OxClosureResponseOxenUpdatedItemPriceAtSignEntry;
  priceAtSignExit: OxClosureResponseOxenUpdatedItemPriceAtSignExit;
  purchaseId: OxClosureResponseOxenUpdatedItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: OxClosureResponseOxenUpdatedItemReversedDeathCause;
  reversedDeathDate: OxClosureResponseOxenUpdatedItemReversedDeathDate;
  reversedDeathDetails: OxClosureResponseOxenUpdatedItemReversedDeathDetails;
  reversedDeathNecropsy: OxClosureResponseOxenUpdatedItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: OxClosureResponseOxenUpdatedItemSalesMarketType;
  sisbov: OxClosureResponseOxenUpdatedItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: OxClosureResponseOxenUpdatedItemStartOfTreatment;
  variety: string;
};

export interface OxClosureBody {
  atSignPrice?: number;
  carcassPrice?: number;
  filename: string;
  invoice?: string;
  orderNumber: number;
}

export type OxCategory = EnumsOxCategory;

/**
 * Mês/ano do período do lote sem custo operacional registrado (considerado 0 no cálculo da média).
 */
export interface OperationalCostAlert {
  month: number;
  year: number;
}

export type OccurrencesReportXlsxQueryAppVersion = string | null;

export interface OccurrencesReportXlsxQuery {
  appVersion?: OccurrencesReportXlsxQueryAppVersion;
  end?: string;
  filename: string;
  start: string;
}

export type OccurrenceType = EnumsOccurrenceType;

export type OccurrenceCategory = EnumsOccurrenceCategory;

export type NmUpdatesHistoryResponse = NmUpdatesHistoryResponseItem[];

export type NmUpdatesHistoryResponseItemStockId = number | null;

export type NmUpdatesHistoryResponseItemStockChangeId = number | null;

export type NmUpdatesHistoryResponseItemOldFactor = number | null;

export type NmUpdatesHistoryResponseItemNewFactor = number | null;

export type NmUpdatesHistoryResponseItemName = string | null;

export type NmUpdatesHistoryResponseItem = {
  date: string;
  name: NmUpdatesHistoryResponseItemName;
  newFactor: NmUpdatesHistoryResponseItemNewFactor;
  oldFactor: NmUpdatesHistoryResponseItemOldFactor;
  percentageChange: number;
  stockChangeId: NmUpdatesHistoryResponseItemStockChangeId;
  stockId: NmUpdatesHistoryResponseItemStockId;
};

export type MultipleTreatsViewResponse = MultipleTreatsViewResponseItem[];

export type MultipleTreatsViewResponseItemDataTreatsItem = {
  adjustedForeseen: boolean;
  automated: boolean;
  batchId: number;
  batchName: string;
  beatSequences?: number[];
  corralId: number;
  corralName: string;
  corralPosition: MultipleTreatsViewResponseItemDataTreatsItemCorralPosition;
  dietChangedDuringDay: boolean;
  dietId: number;
  dietName: string;
  foreseen: number;
  hideFromTreatment: MultipleTreatsViewResponseItemDataTreatsItemHideFromTreatment;
  hour?: string;
  order: number;
  originalForeseen: number;
  realized: number;
  realizedList: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItem[];
  treatSequences?: number[];
  wrongsRealizedList: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItem[];
};

export type MultipleTreatsViewResponseItemData = {
  totalOriginalForeseen: number;
  treats: MultipleTreatsViewResponseItemDataTreatsItem[];
  treatViewType: EnumsTreatViewType;
};

export type MultipleTreatsViewResponseItem = {
  data: MultipleTreatsViewResponseItemData;
  day: string;
};

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemSequence =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemRealizedAt =
  string | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemOxenCount =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemOriginalNaturalMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemOrder =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemMixerId =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemForeseenNaturalMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFinalDryMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFeederId =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFeederAnyOf =
  {
    id: number;
    name: string;
  };

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFeeder =
  MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFeederAnyOf | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemDiet =
  {
    id: number;
    name: string;
  };

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemConcludedProportion =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemConcludedNaturalMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemConcludedAt =
  string | null;

export type MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItem =
  {
    batchId: number;
    concluded: boolean;
    concludedAt: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemConcludedAt;
    concludedNaturalMatter: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemConcludedNaturalMatter;
    concludedProportion: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemConcludedProportion;
    day: string;
    diet: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemDiet;
    dietId: number;
    farmId: number;
    feeder: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFeeder;
    feederId: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFeederId;
    finalDryMatter: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemFinalDryMatter;
    first: boolean;
    foreseenNaturalMatter: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemForeseenNaturalMatter;
    id: number;
    key: string;
    mixerId: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemMixerId;
    order: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemOrder;
    originalNaturalMatter: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemOriginalNaturalMatter;
    oxenCount: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemOxenCount;
    realizedAt: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemRealizedAt;
    realizedNaturalMatter: number;
    sequence: MultipleTreatsViewResponseItemDataTreatsItemWrongsRealizedListItemSequence;
  };

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemSequence =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemRealizedAt =
  string | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemOxenCount =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemOriginalNaturalMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemOrder =
  | number
  | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemMixerId =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemForeseenNaturalMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFinalDryMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFeederId =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFeederAnyOf =
  {
    id: number;
    name: string;
  };

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFeeder =
  MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFeederAnyOf | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemDiet = {
  id: number;
  name: string;
};

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemConcludedProportion =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemConcludedNaturalMatter =
  number | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemConcludedAt =
  string | null;

export type MultipleTreatsViewResponseItemDataTreatsItemRealizedListItem = {
  batchId: number;
  concluded: boolean;
  concludedAt: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemConcludedAt;
  concludedNaturalMatter: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemConcludedNaturalMatter;
  concludedProportion: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemConcludedProportion;
  day: string;
  diet: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemDiet;
  dietId: number;
  farmId: number;
  feeder: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFeeder;
  feederId: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFeederId;
  finalDryMatter: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemFinalDryMatter;
  first: boolean;
  foreseenNaturalMatter: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemForeseenNaturalMatter;
  id: number;
  key: string;
  mixerId: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemMixerId;
  order: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemOrder;
  originalNaturalMatter: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemOriginalNaturalMatter;
  oxenCount: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemOxenCount;
  realizedAt: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemRealizedAt;
  realizedNaturalMatter: number;
  sequence: MultipleTreatsViewResponseItemDataTreatsItemRealizedListItemSequence;
};

export type MultipleTreatsViewResponseItemDataTreatsItemHideFromTreatment =
  | boolean
  | null;

export type MultipleTreatsViewResponseItemDataTreatsItemCorralPosition =
  | number
  | null;

export interface MultipleEntriesReturn {
  age: number;
  electronic?: string;
  gender: EnumsOxGender;
  identifier?: string;
  line: number;
  sisbov?: number;
  weight: number;
}

export interface MultipleEntriesResponse {
  data: MultipleEntriesReturn[];
  errors: unknown;
}

export interface MultipleEntriesDto {
  filename: string;
}

export type MultipleBeatsViewResponseItem = {
  data: BeatViewResponse;
  day: string;
};

export type MultipleBeatsViewResponse = MultipleBeatsViewResponseItem[];

export type MovementHistoryReportRowWeight = number | null;

export type MovementHistoryReportRowWeighingDate = string | null;

export type MovementHistoryReportRowSisbov = string | null;

export type MovementHistoryReportRowPartnerName = string | null;

export type MovementHistoryReportRowOxId = number | null;

export type MovementHistoryReportRowOwnerName = string | null;

export type MovementHistoryReportRowOriginCorralName = string | null;

export type MovementHistoryReportRowIdentifier = string | null;

export type MovementHistoryReportRowEventType =
  (typeof MovementHistoryReportRowEventType)[keyof typeof MovementHistoryReportRowEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MovementHistoryReportRowEventType = {
  OX_BATCH_TRANSFER: "OX_BATCH_TRANSFER",
  BATCH_CORRAL_MOVE: "BATCH_CORRAL_MOVE",
} as const;

export type MovementHistoryReportRowElectronic = string | null;

export type MovementHistoryReportRowDestCorralName = string | null;

export interface MovementHistoryReportRow {
  destBatchId: number;
  destBatchName: string;
  destCorralName: MovementHistoryReportRowDestCorralName;
  electronic: MovementHistoryReportRowElectronic;
  eventType: MovementHistoryReportRowEventType;
  hasWeighing: boolean;
  identifier: MovementHistoryReportRowIdentifier;
  operationAt: string;
  operationDate: string;
  originBatchId: number;
  originBatchName: string;
  originCorralName: MovementHistoryReportRowOriginCorralName;
  ownerName: MovementHistoryReportRowOwnerName;
  oxId: MovementHistoryReportRowOxId;
  partnerName: MovementHistoryReportRowPartnerName;
  sisbov: MovementHistoryReportRowSisbov;
  weighingDate: MovementHistoryReportRowWeighingDate;
  weight: MovementHistoryReportRowWeight;
}

export interface MovementHistoryReportResult {
  limit: number;
  page: number;
  rows: MovementHistoryReportRow[];
  total: number;
}

export type MovementHistoryReportResponse = MovementHistoryReportResult;

export interface MovementHistoryReportFilter {
  animalSearch?: string;
  batchId?: number;
  end?: string;
  includeTotal?: boolean;
  knownTotal?: number;
  limit?: number;
  oxId?: number;
  page?: number;
  start: string;
}

export type MovementHistoryGenerateExcelRequestAppVersion = string | null;

export interface MovementHistoryGenerateExcelRequest {
  animalSearch?: string;
  appVersion?: MovementHistoryGenerateExcelRequestAppVersion;
  batchId?: number;
  end: string;
  filename: string;
  oxId?: number;
  rows: MovementHistoryReportRow[];
  start: string;
}

export type MoveBatchResponseScaledToSlaughter = boolean | null;

export type MoveBatchResponseOperationalCostGroupId = number | null;

export type MoveBatchResponseOldCorralId = number | null;

export type MoveBatchResponseHideFromTreatmentUntil = string | null;

export type MoveBatchResponseHideFromTreatment = boolean | null;

export type MoveBatchResponseForeseenSlaughterDate = string | null;

export type MoveBatchResponseFinalizedAt = string | null;

export type MoveBatchResponseDescrption = string | null;

export type MoveBatchResponseCorralId = number | null;

export type MoveBatchResponseCarcassUniform = number | null;

export type MoveBatchResponseCarcassThin = number | null;

export type MoveBatchResponseCarcassMissing = number | null;

export type MoveBatchResponseCarcassMedium = number | null;

export type MoveBatchResponseCarcassExcessive = number | null;

export type MoveBatchResponseAdjustedPurchaseCost = number | null;

export type MoveBatchResponseActivationEditedAt = string | null;

export type MoveBatchResponseActivatedAt = string | null;

export interface MoveBatchResponse {
  activatedAt: MoveBatchResponseActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: MoveBatchResponseActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: MoveBatchResponseAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: MoveBatchResponseCarcassExcessive;
  carcassMedium: MoveBatchResponseCarcassMedium;
  carcassMissing: MoveBatchResponseCarcassMissing;
  carcassThin: MoveBatchResponseCarcassThin;
  carcassUniform: MoveBatchResponseCarcassUniform;
  corralId: MoveBatchResponseCorralId;
  createdAt: string;
  descrption: MoveBatchResponseDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: MoveBatchResponseFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: MoveBatchResponseForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: MoveBatchResponseHideFromTreatment;
  hideFromTreatmentUntil: MoveBatchResponseHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: MoveBatchResponseOldCorralId;
  operationalCostGroupId: MoveBatchResponseOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: MoveBatchResponseScaledToSlaughter;
}

export interface Months {
  april?: number;
  august?: number;
  december?: number;
  february?: number;
  january?: number;
  july?: number;
  june?: number;
  march?: number;
  may?: number;
  november?: number;
  october?: number;
  september?: number;
}

export type MixerType = EnumsMixerType;

export type MedicineType = EnumsMedicineType;

export type MedicateOxResponseMedicineApplicatorId = number | null;

export type MedicateOxResponseHealthProtocolId = number | null;

export type MedicateOxResponseApplicationType = EnumsApplicationType | null;

export interface MedicateOxResponse {
  applicationType: MedicateOxResponseApplicationType;
  appliedAt: string;
  disease: EnumsDisease;
  healthProtocolId: MedicateOxResponseHealthProtocolId;
  id: number;
  medicineApplicatorId: MedicateOxResponseMedicineApplicatorId;
  oxId: number;
}

export type MedicateOxMedicineToOxHealthItem = {
  appliedDose: number;
  dosePrice: number;
  medicineId: number;
};

export interface MedicateOx {
  applicationType?: EnumsApplicationType;
  customDate?: string;
  disease: EnumsDisease;
  electronic?: string;
  extraMedicineIds?: number[];
  healthProtocolId?: number;
  identifier?: string;
  medicineApplicatorId: number;
  medicineToOxHealth: MedicateOxMedicineToOxHealthItem[];
  oxId?: number;
  sisbov?: number;
  totalCost: number;
}

export type MedicateBulkOxResponseErrorsItem = {
  message: string;
  oxId: number;
};

export interface MedicateBulkOxResponse {
  applied: number;
  errors: MedicateBulkOxResponseErrorsItem[];
}

export type MedicateBulkOxMedicineToOxHealthItem = {
  appliedDose: number;
  dosePrice: number;
  medicineId: number;
};

export interface MedicateBulkOx {
  customDate?: string;
  disease: EnumsDisease;
  extraMedicineIds?: number[];
  healthProtocolId?: number;
  medicineApplicatorId: number;
  medicineToOxHealth: MedicateBulkOxMedicineToOxHealthItem[];
  oxIds: number[];
}

export interface MedicateBatchOxResponse {
  count: number;
  success: boolean;
}

export type Measurement = EnumsMeasurement;

export type ManagementStatus = EnumsManagementStatus;

export interface ManagementSessionExtractSummaryLine {
  label: string;
  value: string;
}

export type ManagementSessionExtractLineSource =
  EnumsManagementSessionExtractLineSource;

export type ManagementSessionExtractExportRequestSession = {
  createdAt: string;
  farmName: string;
  id: number;
  name: string;
  statusLabel: string;
  typeLabel: string;
  updatedAt: string;
};

export type ManagementSessionExtractExportRequestAppVersion = string | null;

export interface ManagementSessionExtractExportRequest {
  animals: ListManagementSessionExtractAnimalsResponseItem[];
  appVersion?: ManagementSessionExtractExportRequestAppVersion;
  configSummary: ManagementSessionExtractSummaryLine[];
  entryColumns?: boolean;
  filename: string;
  identificationColumns?: boolean;
  saleColumns?: boolean;
  session: ManagementSessionExtractExportRequestSession;
  weighColumns: boolean;
}

export interface LookupFarmCredentialResponse {
  dbPassword: string;
  dbUser: string;
}

export interface LoginResponse {
  expiresAt: number;
  refresh: string;
  token: string;
  user: LoginResponseUser;
}

export type LoginResponseUserPersonPhone = string | null;

export type LoginResponseUserPersonDocument = string | null;

export type LoginResponseUserPersonDescription = string | null;

export type LoginResponseUserPersonCode = string | null;

export type LoginResponseUserPerson = {
  code: LoginResponseUserPersonCode;
  createdAt: string;
  description: LoginResponseUserPersonDescription;
  document: LoginResponseUserPersonDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: LoginResponseUserPersonPhone;
  profiles: EnumsProfile[];
};

export type LoginResponseUserPassword = string | null;

export type LoginResponseUserGov = GlobalPrismaJsonGovDocuments | null;

export type LoginResponseUser = {
  email: LoginResponseUserEmail;
  emailVerifiedAt: LoginResponseUserEmailVerifiedAt;
  farm: LoginResponseUserFarm;
  farmId: number;
  gov: LoginResponseUserGov;
  id: number;
  password: LoginResponseUserPassword;
  person: LoginResponseUserPerson;
  personId: number;
};

export type LoginResponseUserFarmSenarPercent = number | null;

export type LoginResponseUserFarmMatinalReadTime = string | null;

export type LoginResponseUserFarmLastCertifierImport = string | null;

export type LoginResponseUserFarmLastBndImport = string | null;

export type LoginResponseUserFarmInstallRunId = string | null;

export type LoginResponseUserFarmCustomerId = string | null;

export type LoginResponseUserFarmCorrectionPercent = number | null;

export type LoginResponseUserFarmAlias = string | null;

export type LoginResponseUserFarm = {
  addressId: number;
  alias: LoginResponseUserFarmAlias;
  blockedDays: number;
  correctionPercent: LoginResponseUserFarmCorrectionPercent;
  createdAt: string;
  customerId: LoginResponseUserFarmCustomerId;
  dailyCost: number;
  day: string;
  divisionThreshold: number;
  factory: GlobalPrismaJsonLatLng[];
  gradeInfo: unknown;
  gradeMethod: EnumsGradeMethod;
  hasAutomation: boolean;
  hasTraceability: boolean;
  id: number;
  installRunId: LoginResponseUserFarmInstallRunId;
  interestRate: number;
  lastBndImport: LoginResponseUserFarmLastBndImport;
  lastCertifierImport: LoginResponseUserFarmLastCertifierImport;
  managementConfig: unknown;
  matinalReadTime: LoginResponseUserFarmMatinalReadTime;
  name: string;
  nightlyReadTimes: string[];
  position: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification: boolean;
  sapId: string;
  senarPercent: LoginResponseUserFarmSenarPercent;
  treatViewType: EnumsTreatViewType;
};

export type LoginResponseUserEmailVerifiedAt = string | null;

export type LoginResponseUserEmail = string | null;

export interface Login {
  email: string;
  password: string;
  schema: string;
}

export type LoadFinancialReportResponseItem = {
  animalsPurchases: number;
  beatPrice: number;
  day: string;
  earringsPurchases: number;
  foodsPurchases: number;
};

export type LoadFinancialReportResponse = LoadFinancialReportResponseItem[];

export type ListWeightingMapsResponse = ListWeightingMapsResponseItem[];

export type ListWeightingMapsResponseItemTotalWeight = number | null;

export type ListWeightingMapsResponseItemTotalPurchase = number | null;

export type ListWeightingMapsResponseItemSupplementedRearingModality =
  EnumsSupplementedRearingModality | null;

export type ListWeightingMapsResponseItemStartTime = string | null;

export type ListWeightingMapsResponseItemReferenceCode = string | null;

export type ListWeightingMapsResponseItemPurchaseId = number | null;

export type ListWeightingMapsResponseItemPurchaseAnyOf = {
  id: number;
  name: string;
};

export type ListWeightingMapsResponseItemPurchase =
  ListWeightingMapsResponseItemPurchaseAnyOf | null;

export type ListWeightingMapsResponseItemPricePerArroba = number | null;

export type ListWeightingMapsResponseItemNetWeight = number | null;

export type ListWeightingMapsResponseItemInvoicesItemWeightingMapId =
  | number
  | null;

export type ListWeightingMapsResponseItemInvoicesItemSaleOrderId =
  | number
  | null;

export type ListWeightingMapsResponseItemInvoicesItemIsComplement =
  | boolean
  | null;

export type ListWeightingMapsResponseItemInvoicesItemExitTruckId =
  | number
  | null;

export type ListWeightingMapsResponseItemInvoicesItemEmittedAt = string | null;

export type ListWeightingMapsResponseItemInvoicesItem = {
  emittedAt: ListWeightingMapsResponseItemInvoicesItemEmittedAt;
  exitTruckId: ListWeightingMapsResponseItemInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: ListWeightingMapsResponseItemInvoicesItemIsComplement;
  number: string;
  saleOrderId: ListWeightingMapsResponseItemInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: ListWeightingMapsResponseItemInvoicesItemWeightingMapId;
};

export type ListWeightingMapsResponseItemGtasItem = {
  id: number;
  number: string;
  series: string;
};

export type ListWeightingMapsResponseItemGrossWeight = number | null;

export type ListWeightingMapsResponseItemFastingDate = string | null;

export type ListWeightingMapsResponseItemEndTime = string | null;

export type ListWeightingMapsResponseItemClosingTime = string | null;

export type ListWeightingMapsResponseItemCarcassYield = number | null;

export type ListWeightingMapsResponseItemBuyer = {
  id: number;
  name: string;
};

export type ListWeightingMapsResponseItemAverageWeight = number | null;

export type ListWeightingMapsResponseItem = {
  averageWeight: ListWeightingMapsResponseItemAverageWeight;
  buyer: ListWeightingMapsResponseItemBuyer;
  buyerId: number;
  carcassYield: ListWeightingMapsResponseItemCarcassYield;
  closingTime: ListWeightingMapsResponseItemClosingTime;
  commission: number;
  emissionDate: string;
  endTime: ListWeightingMapsResponseItemEndTime;
  farmId: number;
  fastingDate: ListWeightingMapsResponseItemFastingDate;
  grossWeight: ListWeightingMapsResponseItemGrossWeight;
  gtas: ListWeightingMapsResponseItemGtasItem[];
  id: number;
  invoices: ListWeightingMapsResponseItemInvoicesItem[];
  netWeight: ListWeightingMapsResponseItemNetWeight;
  pricePerArroba: ListWeightingMapsResponseItemPricePerArroba;
  purchase: ListWeightingMapsResponseItemPurchase;
  purchaseId: ListWeightingMapsResponseItemPurchaseId;
  referenceCode: ListWeightingMapsResponseItemReferenceCode;
  shippingCost: number;
  startTime: ListWeightingMapsResponseItemStartTime;
  status: EnumsWeightingMapStatus;
  supplementedRearingModality: ListWeightingMapsResponseItemSupplementedRearingModality;
  totalPurchase: ListWeightingMapsResponseItemTotalPurchase;
  totalWeight: ListWeightingMapsResponseItemTotalWeight;
  weighingDate: string;
};

export type ListWeightingMapsByPurchaseIdResponse =
  ListWeightingMapsByPurchaseIdResponseItem[];

export type ListWeightingMapsByPurchaseIdResponseItemTotalWeight =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemTotalPurchase =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemSupplementedRearingModality =
  EnumsSupplementedRearingModality | null;

export type ListWeightingMapsByPurchaseIdResponseItemStartTime = string | null;

export type ListWeightingMapsByPurchaseIdResponseItemReferenceCode =
  | string
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemPurchaseId = number | null;

export type ListWeightingMapsByPurchaseIdResponseItemPricePerArroba =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemNetWeight = number | null;

export type ListWeightingMapsByPurchaseIdResponseItem = {
  averageWeight: ListWeightingMapsByPurchaseIdResponseItemAverageWeight;
  buyer: ListWeightingMapsByPurchaseIdResponseItemBuyer;
  buyerId: number;
  carcassYield: ListWeightingMapsByPurchaseIdResponseItemCarcassYield;
  closingTime: ListWeightingMapsByPurchaseIdResponseItemClosingTime;
  commission: number;
  emissionDate: string;
  endTime: ListWeightingMapsByPurchaseIdResponseItemEndTime;
  farmId: number;
  fastingDate: ListWeightingMapsByPurchaseIdResponseItemFastingDate;
  grossWeight: ListWeightingMapsByPurchaseIdResponseItemGrossWeight;
  gtas: ListWeightingMapsByPurchaseIdResponseItemGtasItem[];
  id: number;
  invoices: ListWeightingMapsByPurchaseIdResponseItemInvoicesItem[];
  netWeight: ListWeightingMapsByPurchaseIdResponseItemNetWeight;
  pricePerArroba: ListWeightingMapsByPurchaseIdResponseItemPricePerArroba;
  purchaseId: ListWeightingMapsByPurchaseIdResponseItemPurchaseId;
  referenceCode: ListWeightingMapsByPurchaseIdResponseItemReferenceCode;
  shippingCost: number;
  startTime: ListWeightingMapsByPurchaseIdResponseItemStartTime;
  status: EnumsWeightingMapStatus;
  supplementedRearingModality: ListWeightingMapsByPurchaseIdResponseItemSupplementedRearingModality;
  totalPurchase: ListWeightingMapsByPurchaseIdResponseItemTotalPurchase;
  totalWeight: ListWeightingMapsByPurchaseIdResponseItemTotalWeight;
  weighingDate: string;
};

export type ListWeightingMapsByPurchaseIdResponseItemInvoicesItemWeightingMapId =
  number | null;

export type ListWeightingMapsByPurchaseIdResponseItemInvoicesItemSaleOrderId =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemInvoicesItemIsComplement =
  | boolean
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemInvoicesItemExitTruckId =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemInvoicesItemEmittedAt =
  | string
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemInvoicesItem = {
  emittedAt: ListWeightingMapsByPurchaseIdResponseItemInvoicesItemEmittedAt;
  exitTruckId: ListWeightingMapsByPurchaseIdResponseItemInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: ListWeightingMapsByPurchaseIdResponseItemInvoicesItemIsComplement;
  number: string;
  saleOrderId: ListWeightingMapsByPurchaseIdResponseItemInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: ListWeightingMapsByPurchaseIdResponseItemInvoicesItemWeightingMapId;
};

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemWeightingMapId =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemWeightAverage =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemPurchaseId =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginWeightAverage =
  number | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsiblePhone =
  string | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsibleDocument =
  string | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsibleDescription =
  string | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsibleCode =
  string | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsible =
  {
    code: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsibleCode;
    createdAt: string;
    description: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsibleDescription;
    document: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsibleDocument;
    farmId: number;
    id: number;
    imageUrl: string;
    name: string;
    phone: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsiblePhone;
    profiles: EnumsProfile[];
  };

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginCode =
  | string
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginCattleManifestLayoutId =
  number | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemOrigin = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginCattleManifestLayoutId;
  code: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginResponsible;
  responsibleId: number;
};

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemInvoice =
  | string
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemHours =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemDistance =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemDestinyId =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemDescription =
  | string
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemGtasItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  yearsOld: number;
};

export type ListWeightingMapsByPurchaseIdResponseItemGtasItem = {
  ages: ListWeightingMapsByPurchaseIdResponseItemGtasItemAgesItem[];
  completed: boolean;
  description: ListWeightingMapsByPurchaseIdResponseItemGtasItemDescription;
  destinyId: ListWeightingMapsByPurchaseIdResponseItemGtasItemDestinyId;
  distance: ListWeightingMapsByPurchaseIdResponseItemGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: ListWeightingMapsByPurchaseIdResponseItemGtasItemHours;
  id: number;
  invoice: ListWeightingMapsByPurchaseIdResponseItemGtasItemInvoice;
  number: string;
  origin: ListWeightingMapsByPurchaseIdResponseItemGtasItemOrigin;
  originId: number;
  originWeightAverage: ListWeightingMapsByPurchaseIdResponseItemGtasItemOriginWeightAverage;
  purchaseId: ListWeightingMapsByPurchaseIdResponseItemGtasItemPurchaseId;
  series: string;
  weightAverage: ListWeightingMapsByPurchaseIdResponseItemGtasItemWeightAverage;
  weightingMapId: ListWeightingMapsByPurchaseIdResponseItemGtasItemWeightingMapId;
};

export type ListWeightingMapsByPurchaseIdResponseItemGrossWeight =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemFastingDate =
  | string
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemEndTime = string | null;

export type ListWeightingMapsByPurchaseIdResponseItemClosingTime =
  | string
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemCarcassYield =
  | number
  | null;

export type ListWeightingMapsByPurchaseIdResponseItemBuyer = {
  id: number;
  name: string;
};

export type ListWeightingMapsByPurchaseIdResponseItemAverageWeight =
  | number
  | null;

export type ListWeightGainCurvesResponseItem =
  | BiotypeWeightGainCurve
  | BatchWeightGainCurve;

export type ListWeightGainCurvesResponse = ListWeightGainCurvesResponseItem[];

export type _ListTreatmentsResponseItemCount = {
  batches: number;
};

export type ListTreatmentsResponseItem = {
  _count: _ListTreatmentsResponseItemCount;
  active: boolean;
  createdAt: string;
  divisions: number[];
  farmId: number;
  hours: string[];
  id: number;
  name: string;
};

export type ListTreatmentsResponse = ListTreatmentsResponseItem[];

export type ListStructuresResponseItem = {
  category: EnumsStructureCategory;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
};

export type ListStructuresResponse = ListStructuresResponseItem[];

export type ListStocksRetroactiveXlsxResponseAnyOfThree = {
  buffer: null;
};

export type ListStocksRetroactiveXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type ListStocksRetroactiveXlsxResponseAnyOf = {
  buffer: ListStocksRetroactiveXlsxResponseAnyOfBuffer;
};

export type ListStocksRetroactiveXlsxResponse =
  | ListStocksRetroactiveXlsxResponseAnyOf
  | ListStocksRetroactiveXlsxResponseAnyOfThree;

export type ListStocksRetroactiveResultStocksItemPremix = boolean | null;

export type ListStocksRetroactiveResultStocksItem = {
  code: string;
  elg: number;
  elm: number;
  farmId: number;
  id: number;
  kiloPrice: number;
  loadMode: unknown;
  name: string;
  naturalMatter: number;
  naturalMatterFactor: number;
  premix: ListStocksRetroactiveResultStocksItemPremix;
};

export interface ListStocksRetroactiveResult {
  day: string;
  stocks: ListStocksRetroactiveResultStocksItem[];
}

export type ListStocksRetroactiveResponse = ListStocksRetroactiveResult[];

export type ListStocksResponseItemPremix = boolean | null;

export type ListStocksResponseItemActive = boolean | null;

export type ListStocksResponseItem = {
  active: ListStocksResponseItemActive;
  code: string;
  elg: number;
  elm: number;
  farmId: number;
  id: number;
  kiloPrice: number;
  loadMode: EnumsLoadMode;
  name: string;
  naturalMatter: number;
  naturalMatterFactor: number;
  premix: ListStocksResponseItemPremix;
};

export type ListStocksResponse = ListStocksResponseItem[];

export type ListSlaughtersResponseItem = {
  id: number;
  orderName: string;
  orderNumber: number;
};

export type ListSlaughtersResponse = ListSlaughtersResponseItem[];

export type ListSimpleGtasResponseItemPurchaseId = number | null;

export type ListSimpleGtasResponseItem = {
  id: number;
  number: string;
  purchaseId: ListSimpleGtasResponseItemPurchaseId;
};

export type ListSimpleGtasResponse = ListSimpleGtasResponseItem[];

export type ListSimpleAnimalResponseSimpleAnimalsItem = {
  ox: ListSimpleAnimalResponseSimpleAnimalsItemOx;
};

export interface ListSimpleAnimalResponse {
  gtas: ListSimpleAnimalResponseGtasItem[];
  id: number;
  name: string;
  simpleAnimals: ListSimpleAnimalResponseSimpleAnimalsItem[];
  totalAnimals: number;
  totalSimpleAnimals: number;
}

export type ListSimpleAnimalResponseSimpleAnimalsItemOxStartOfTreatment =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxSisbov = string | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxSalesMarketType =
  EnumsSalesMarketType | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathDetails =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathDate =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathCause =
  EnumsDeathCause | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxPurchaseId =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxPriceAtSignExit =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxPriceAtSignEntry =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxOtherDeathCause =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxIsNecropsyPerformed =
  | boolean
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxInvoice = string | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxInternalSaleId =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxIdentifier =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxIdentifiedAt =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxIdentificationSource =
  EnumsIdentificationSource | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxHasBirthAnnouncement =
  | boolean
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxGtaId = number | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxExitTruckId =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxElectronic =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxDiedAt = string | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxDentitionStage =
  EnumsDentitionStage | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxDeathReason =
  EnumsDeathCause | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxDeathDetails =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxDeathCause =
  EnumsDeathCause | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxComments = string | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxCertifierDate =
  | string
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxCattleManifestId =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxCarcassWeight =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxCarcassType =
  EnumsCarcassType | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxCarcassPrice =
  | number
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxCarcass = number | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxBornOnFarm =
  | boolean
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOxBndTracked =
  | boolean
  | null;

export type ListSimpleAnimalResponseSimpleAnimalsItemOx = {
  birth: string;
  blockedUntil: string;
  bndTracked: ListSimpleAnimalResponseSimpleAnimalsItemOxBndTracked;
  bornOnFarm: ListSimpleAnimalResponseSimpleAnimalsItemOxBornOnFarm;
  breed: string;
  carcass: ListSimpleAnimalResponseSimpleAnimalsItemOxCarcass;
  carcassPrice: ListSimpleAnimalResponseSimpleAnimalsItemOxCarcassPrice;
  carcassType: ListSimpleAnimalResponseSimpleAnimalsItemOxCarcassType;
  carcassWeight: ListSimpleAnimalResponseSimpleAnimalsItemOxCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: ListSimpleAnimalResponseSimpleAnimalsItemOxCattleManifestId;
  certifierDate: ListSimpleAnimalResponseSimpleAnimalsItemOxCertifierDate;
  comments: ListSimpleAnimalResponseSimpleAnimalsItemOxComments;
  deathCause: ListSimpleAnimalResponseSimpleAnimalsItemOxDeathCause;
  deathDetails: ListSimpleAnimalResponseSimpleAnimalsItemOxDeathDetails;
  deathNecropsy: ListSimpleAnimalResponseSimpleAnimalsItemOxDeathNecropsy;
  deathReason: ListSimpleAnimalResponseSimpleAnimalsItemOxDeathReason;
  dentitionStage: ListSimpleAnimalResponseSimpleAnimalsItemOxDentitionStage;
  diedAt: ListSimpleAnimalResponseSimpleAnimalsItemOxDiedAt;
  electronic: ListSimpleAnimalResponseSimpleAnimalsItemOxElectronic;
  exitTruckId: ListSimpleAnimalResponseSimpleAnimalsItemOxExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: ListSimpleAnimalResponseSimpleAnimalsItemOxGtaId;
  hasBirthAnnouncement: ListSimpleAnimalResponseSimpleAnimalsItemOxHasBirthAnnouncement;
  id: number;
  identificationSource: ListSimpleAnimalResponseSimpleAnimalsItemOxIdentificationSource;
  identifiedAt: ListSimpleAnimalResponseSimpleAnimalsItemOxIdentifiedAt;
  identifier: ListSimpleAnimalResponseSimpleAnimalsItemOxIdentifier;
  includedAt: string;
  internalSaleId: ListSimpleAnimalResponseSimpleAnimalsItemOxInternalSaleId;
  invoice: ListSimpleAnimalResponseSimpleAnimalsItemOxInvoice;
  isNecropsyPerformed: ListSimpleAnimalResponseSimpleAnimalsItemOxIsNecropsyPerformed;
  otherDeathCause: ListSimpleAnimalResponseSimpleAnimalsItemOxOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: ListSimpleAnimalResponseSimpleAnimalsItemOxPriceAtSignEntry;
  priceAtSignExit: ListSimpleAnimalResponseSimpleAnimalsItemOxPriceAtSignExit;
  purchaseId: ListSimpleAnimalResponseSimpleAnimalsItemOxPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathCause;
  reversedDeathDate: ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathDate;
  reversedDeathDetails: ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathDetails;
  reversedDeathNecropsy: ListSimpleAnimalResponseSimpleAnimalsItemOxReversedDeathNecropsy;
  runtime: number;
  salesMarketType: ListSimpleAnimalResponseSimpleAnimalsItemOxSalesMarketType;
  sisbov: ListSimpleAnimalResponseSimpleAnimalsItemOxSisbov;
  sisbovHistory: string[];
  startOfTreatment: ListSimpleAnimalResponseSimpleAnimalsItemOxStartOfTreatment;
  variety: string;
};

export type ListSimpleAnimalResponseGtasItem = {
  gtaId: number;
  gtaNumber: string;
  simpleAnimals: number;
  totalAnimals: number;
};

export interface ListSimpleAnimalByGtaResponse {
  batches: ListSimpleAnimalByGtaResponseBatchesItem[];
  gtaId: number;
  simpleAnimals: ListSimpleAnimalByGtaResponseSimpleAnimalsItem[];
  totalAnimals: number;
  totalSimpleAnimals: number;
}

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemStartOfTreatment =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemSisbov =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemSalesMarketType =
  EnumsSalesMarketType | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathDetails =
  string | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathDate =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathCause =
  EnumsDeathCause | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemPurchaseId =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemPriceAtSignExit =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemPriceAtSignEntry =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemOtherDeathCause =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemIsNecropsyPerformed =
  | boolean
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemInvoice =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemInternalSaleId =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemIdentifier =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemIdentifiedAt =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemIdentificationSource =
  EnumsIdentificationSource | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemHasBirthAnnouncement =
  boolean | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemGtaId = number | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemExitTruckId =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemElectronic =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemDiedAt =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemDentitionStage =
  EnumsDentitionStage | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathReason =
  EnumsDeathCause | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathDetails =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathCause =
  EnumsDeathCause | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemComments =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemCertifierDate =
  | string
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemCattleManifestId =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcassWeight =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcassType =
  EnumsCarcassType | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcassPrice =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcass =
  | number
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemBornOnFarm =
  | boolean
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemBndTracked =
  | boolean
  | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItem = {
  batches: ListSimpleAnimalByGtaResponseSimpleAnimalsItemBatchesItem[];
  birth: string;
  blockedUntil: string;
  bndTracked: ListSimpleAnimalByGtaResponseSimpleAnimalsItemBndTracked;
  bornOnFarm: ListSimpleAnimalByGtaResponseSimpleAnimalsItemBornOnFarm;
  breed: string;
  carcass: ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcass;
  carcassPrice: ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcassPrice;
  carcassType: ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcassType;
  carcassWeight: ListSimpleAnimalByGtaResponseSimpleAnimalsItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: ListSimpleAnimalByGtaResponseSimpleAnimalsItemCattleManifestId;
  certifierDate: ListSimpleAnimalByGtaResponseSimpleAnimalsItemCertifierDate;
  comments: ListSimpleAnimalByGtaResponseSimpleAnimalsItemComments;
  deathCause: ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathCause;
  deathDetails: ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathDetails;
  deathNecropsy: ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathNecropsy;
  deathReason: ListSimpleAnimalByGtaResponseSimpleAnimalsItemDeathReason;
  dentitionStage: ListSimpleAnimalByGtaResponseSimpleAnimalsItemDentitionStage;
  diedAt: ListSimpleAnimalByGtaResponseSimpleAnimalsItemDiedAt;
  electronic: ListSimpleAnimalByGtaResponseSimpleAnimalsItemElectronic;
  exitTruckId: ListSimpleAnimalByGtaResponseSimpleAnimalsItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: ListSimpleAnimalByGtaResponseSimpleAnimalsItemGtaId;
  hasBirthAnnouncement: ListSimpleAnimalByGtaResponseSimpleAnimalsItemHasBirthAnnouncement;
  id: number;
  identificationSource: ListSimpleAnimalByGtaResponseSimpleAnimalsItemIdentificationSource;
  identifiedAt: ListSimpleAnimalByGtaResponseSimpleAnimalsItemIdentifiedAt;
  identifier: ListSimpleAnimalByGtaResponseSimpleAnimalsItemIdentifier;
  includedAt: string;
  internalSaleId: ListSimpleAnimalByGtaResponseSimpleAnimalsItemInternalSaleId;
  invoice: ListSimpleAnimalByGtaResponseSimpleAnimalsItemInvoice;
  isNecropsyPerformed: ListSimpleAnimalByGtaResponseSimpleAnimalsItemIsNecropsyPerformed;
  otherDeathCause: ListSimpleAnimalByGtaResponseSimpleAnimalsItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: ListSimpleAnimalByGtaResponseSimpleAnimalsItemPriceAtSignEntry;
  priceAtSignExit: ListSimpleAnimalByGtaResponseSimpleAnimalsItemPriceAtSignExit;
  purchaseId: ListSimpleAnimalByGtaResponseSimpleAnimalsItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathCause;
  reversedDeathDate: ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathDate;
  reversedDeathDetails: ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathDetails;
  reversedDeathNecropsy: ListSimpleAnimalByGtaResponseSimpleAnimalsItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: ListSimpleAnimalByGtaResponseSimpleAnimalsItemSalesMarketType;
  sisbov: ListSimpleAnimalByGtaResponseSimpleAnimalsItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: ListSimpleAnimalByGtaResponseSimpleAnimalsItemStartOfTreatment;
  variety: string;
};

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemBatchesItemBatchDescrption =
  string | null;

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemBatchesItemBatch = {
  descrption: ListSimpleAnimalByGtaResponseSimpleAnimalsItemBatchesItemBatchDescrption;
  name: string;
};

export type ListSimpleAnimalByGtaResponseSimpleAnimalsItemBatchesItem = {
  batch: ListSimpleAnimalByGtaResponseSimpleAnimalsItemBatchesItemBatch;
  batchId: number;
};

export type ListSimpleAnimalByGtaResponseBatchesItem = {
  id: number;
  name: string;
};

export type ListSavedBackupsResponseBackupsItem = {
  date: string;
  name: string;
};

export interface ListSavedBackupsResponse {
  backups: ListSavedBackupsResponseBackupsItem[];
}

export interface ListSaleOrdersResponse {
  currentPage: number;
  hasNextPage: boolean;
  items: ListSaleOrdersResponseItemsItem[];
}

export type ListSaleOrdersResponseItemsItemTrucksItemInvoicesItem = {
  value: number;
};

export type ListSaleOrdersResponseItemsItemTrucksItemBoardingItemPriceAtSignExit =
  number | null;

export type ListSaleOrdersResponseItemsItemTrucksItemBoardingItem = {
  batchId: number;
  carcassWeight: number;
  exitWeight: number;
  priceAtSignExit: ListSaleOrdersResponseItemsItemTrucksItemBoardingItemPriceAtSignExit;
};

export type ListSaleOrdersResponseItemsItemTrucksItem = {
  boarding: ListSaleOrdersResponseItemsItemTrucksItemBoardingItem[];
  invoices: ListSaleOrdersResponseItemsItemTrucksItemInvoicesItem[];
  name: string;
};

export type ListSaleOrdersResponseItemsItemComplementInvoicesItem = {
  value: number;
};

export type ListSaleOrdersResponseItemsItemAtSignPrice = number | null;

export type ListSaleOrdersResponseItemsItem = {
  announcementId: number;
  atSignPrice: ListSaleOrdersResponseItemsItemAtSignPrice;
  batches: number[];
  complementInvoices: ListSaleOrdersResponseItemsItemComplementInvoicesItem[];
  exitWeightAverage: number;
  freightPerAtSignBRL: number;
  id: number;
  inBatch: boolean;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF: number;
  partnerAtSignPriceM: number;
  saleDate: string;
  status: string;
  totalSlaughter: number;
  trucks: ListSaleOrdersResponseItemsItemTrucksItem[];
};

export interface ListSaleOrdersFilters {
  /** Filtra vendas que contenham animais dos lotes informados */
  batchIds?: number[];
  endDate?: string;
  limit?: number;
  liveWeightInKg?: number;
  number?: number;
  page?: number;
  partnerId?: number;
  /** Busca por número ou nome da ordem de venda */
  search?: string;
  sort?: SortOrder;
  startDate?: string;
  status?: EnumsSaleOrderStatus;
}

export type ListSaleOrderPenaltySaleOrder = {
  id: number;
  orderName: string;
  orderNumber: number;
};

export type ListSaleOrderPenaltyOxId = number | null;

export interface ListSaleOrderPenalty {
  createdAt: string;
  description: string;
  id: number;
  ox?: ListSaleOrderPenaltyOx;
  oxId?: ListSaleOrderPenaltyOxId;
  penaltyAmount: number;
  saleOrder: ListSaleOrderPenaltySaleOrder;
  saleOrderId: number;
  updatedAt: string;
}

export type ListSaleOrderPenaltyOxAnyOfSisbov = string | null;

export type ListSaleOrderPenaltyOxAnyOf = {
  id: number;
  sisbov: ListSaleOrderPenaltyOxAnyOfSisbov;
};

export type ListSaleOrderPenaltyOx = ListSaleOrderPenaltyOxAnyOf | null;

export type ListSaleOrderPenaltiesResponse = ListSaleOrderPenalty[];

export type ListSaleManagementsResponseItem = {
  announcement: ListSaleManagementsResponseItemAnnouncement;
  announcementId: ListSaleManagementsResponseItemAnnouncementId;
  closed: boolean;
  date: string;
  farmId: number;
  id: number;
  owner: ListSaleManagementsResponseItemOwner;
  ownerId: number;
  trucks: ListSaleManagementsResponseItemTrucksItem[];
};

export type ListSaleManagementsResponse = ListSaleManagementsResponseItem[];

export type ListSaleManagementsResponseItemTrucksItemSaleOrderId =
  | number
  | null;

export type ListSaleManagementsResponseItemTrucksItemSaleId = number | null;

export type ListSaleManagementsResponseItemTrucksItemPlate = string | null;

export type ListSaleManagementsResponseItemTrucksItemName = string | null;

export type ListSaleManagementsResponseItemTrucksItemInfo = string | null;

export type ListSaleManagementsResponseItemTrucksItemHoldingSaleId =
  | number
  | null;

export type ListSaleManagementsResponseItemTrucksItemExitGtaSeries =
  | string
  | null;

export type ListSaleManagementsResponseItemTrucksItemExitGta = string | null;

export type ListSaleManagementsResponseItemTrucksItemDestinyId = number | null;

export type ListSaleManagementsResponseItemTrucksItem = {
  announcementId: ListSaleManagementsResponseItemTrucksItemAnnouncementId;
  bigWeighingMachineWeightKg: ListSaleManagementsResponseItemTrucksItemBigWeighingMachineWeightKg;
  boarding: ListSaleManagementsResponseItemTrucksItemBoardingItem[];
  capacity: number;
  destinyId: ListSaleManagementsResponseItemTrucksItemDestinyId;
  exitAt: string;
  exitGta: ListSaleManagementsResponseItemTrucksItemExitGta;
  exitGtaSeries: ListSaleManagementsResponseItemTrucksItemExitGtaSeries;
  farmId: number;
  holdingSaleId: ListSaleManagementsResponseItemTrucksItemHoldingSaleId;
  id: number;
  info: ListSaleManagementsResponseItemTrucksItemInfo;
  isVisible: boolean;
  name: ListSaleManagementsResponseItemTrucksItemName;
  plate: ListSaleManagementsResponseItemTrucksItemPlate;
  reason: EnumsExitReason;
  saleId: ListSaleManagementsResponseItemTrucksItemSaleId;
  saleOrderId: ListSaleManagementsResponseItemTrucksItemSaleOrderId;
  status: EnumsExitTruckStatus;
};

export type ListSaleManagementsResponseItemTrucksItemBoardingItemSisbov =
  | string
  | null;

export type ListSaleManagementsResponseItemTrucksItemBoardingItem = {
  id: number;
  sisbov: ListSaleManagementsResponseItemTrucksItemBoardingItemSisbov;
};

export type ListSaleManagementsResponseItemTrucksItemBigWeighingMachineWeightKg =
  number | null;

export type ListSaleManagementsResponseItemTrucksItemAnnouncementId =
  | number
  | null;

export type ListSaleManagementsResponseItemOwner = {
  name: string;
};

export type ListSaleManagementsResponseItemAnnouncementId = number | null;

export type ListSaleManagementsResponseItemAnnouncementAnyOf = {
  id: number;
};

export type ListSaleManagementsResponseItemAnnouncement =
  ListSaleManagementsResponseItemAnnouncementAnyOf | null;

/**
 * Resultado da listagem agrupada por tipo de venda.
 */
export interface ListSaleDatesResult {
  /** Vendas avulsas. */
  holdingSales: SaleDateItem[];
  /** Vendas por venda (pedido de venda). */
  saleOrders: SaleDateItem[];
}

export type ListRestorableBatchesResponse = ListRestorableBatchesResponseItem[];

export type ListRestorableBatchesResponseItemFinalizedAt = string | null;

export type ListRestorableBatchesResponseItemDescription = string | null;

export type ListRestorableBatchesResponseItemCorralName = string | null;

export type ListRestorableBatchesResponseItemActivatedAt = string | null;

/**
 * Um lote disponível para restauração, exibido na tela de moderação.
 */
export type ListRestorableBatchesResponseItem = {
  activatedAt: ListRestorableBatchesResponseItemActivatedAt;
  corralName: ListRestorableBatchesResponseItemCorralName;
  createdAt: string;
  description: ListRestorableBatchesResponseItemDescription;
  farmId: number;
  farmName: string;
  finalizedAt: ListRestorableBatchesResponseItemFinalizedAt;
  id: number;
  name: string;
};

export interface ListRepeatedIdentifierResponse {
  count: number;
  identifier: ListRepeatedIdentifierResponseIdentifier;
  oxen: ListRepeatedIdentifierResponseOxenItem[];
}

export type ListRepeatedIdentifiersResponse = ListRepeatedIdentifierResponse[];

export type ListRepeatedIdentifierResponseOxenItemVariety = string | null;

export type ListRepeatedIdentifierResponseOxenItemSisbov = string | null;

export type ListRepeatedIdentifierResponseOxenItemGender = EnumsOxGender | null;

export type ListRepeatedIdentifierResponseOxenItemElectronic = string | null;

export type ListRepeatedIdentifierResponseOxenItemBatchName = string | null;

export type ListRepeatedIdentifierResponseOxenItemBatchId = number | null;

export type ListRepeatedIdentifierResponseOxenItem = {
  batchId: ListRepeatedIdentifierResponseOxenItemBatchId;
  batchName: ListRepeatedIdentifierResponseOxenItemBatchName;
  electronic: ListRepeatedIdentifierResponseOxenItemElectronic;
  gender: ListRepeatedIdentifierResponseOxenItemGender;
  id: number;
  sisbov: ListRepeatedIdentifierResponseOxenItemSisbov;
  variety: ListRepeatedIdentifierResponseOxenItemVariety;
};

export type ListRepeatedIdentifierResponseIdentifier = string | null;

export interface ListRepeatedIdentifierFilter {
  identifier?: string;
}

export type ListRecipesResponseItemMixer = {
  active: boolean;
  code: number;
  createdAt: string;
  distributor: boolean;
  farmId: number;
  id: number;
  mixer: boolean;
  mixerType: EnumsMixerType;
  mixTime: string;
  name: string;
  rounding: number;
};

export type ListRecipesResponseItem = {
  capacityMn: number;
  code: number;
  createdAt: string;
  diet: ListRecipesResponseItemDiet;
  dietId: number;
  farmId: number;
  id: number;
  mixer: ListRecipesResponseItemMixer;
  mixerId: number;
};

export type ListRecipesResponse = ListRecipesResponseItem[];

export type ListRecipesResponseItemDietPremixId = number | null;

export type ListRecipesResponseItemDietObservation = string | null;

export type ListRecipesResponseItemDietFixedElg = number | null;

export type ListRecipesResponseItemDietCode = string | null;

export type ListRecipesResponseItemDietCategory = EnumsDietCategory | null;

export type ListRecipesResponseItemDiet = {
  active: boolean;
  category: ListRecipesResponseItemDietCategory;
  code: ListRecipesResponseItemDietCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: ListRecipesResponseItemDietFixedElg;
  id: number;
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: ListRecipesResponseItemDietObservation;
  premixId: ListRecipesResponseItemDietPremixId;
};

export type ListPurchasesWithLiveOxenResponseItem = {
  id: number;
  name: string;
};

export type ListPurchasesWithLiveOxenResponse =
  ListPurchasesWithLiveOxenResponseItem[];

export interface ListPurchasesResponse {
  items: ListPurchasesResponseItemsItem[];
  next?: number;
  previous?: number;
}

export type ListPurchasesResponseItemsItemStock =
  ListPurchasesResponseItemsItemStockAnyOf | null;

export type ListPurchasesResponseItemsItemStockAnyOfStoredAt = string | null;

export type ListPurchasesResponseItemsItemStockAnyOfInvoicesItemReceivedAt =
  | string
  | null;

export type ListPurchasesResponseItemsItemStockAnyOfInvoicesItem = {
  billedWeight: number;
  id: number;
  number: string;
  price: number;
  receivedAt: ListPurchasesResponseItemsItemStockAnyOfInvoicesItemReceivedAt;
  receivedWeight: number;
  stockPurchaseId: number;
};

export type ListPurchasesResponseItemsItemStockAnyOf = {
  amount: number;
  id: number;
  invoices: ListPurchasesResponseItemsItemStockAnyOfInvoicesItem[];
  invoicesPrice: number;
  purchaseId: number;
  stockId: number;
  storedAt: ListPurchasesResponseItemsItemStockAnyOfStoredAt;
};

export type ListPurchasesResponseItemsItemSisbov =
  ListPurchasesResponseItemsItemSisbovAnyOf | null;

export type ListPurchasesResponseItemsItem = {
  category: EnumsPurchaseCategory;
  earringsPerPage: ListPurchasesResponseItemsItemEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: ListPurchasesResponseItemsItemObservation;
  oxen: ListPurchasesResponseItemsItemOxen;
  partnerHerd: ListPurchasesResponseItemsItemPartnerHerd;
  price: number;
  receivedAt: ListPurchasesResponseItemsItemReceivedAt;
  series: string;
  sisbov: ListPurchasesResponseItemsItemSisbov;
  status: EnumsPurchaseStatus;
  stock: ListPurchasesResponseItemsItemStock;
};

export type ListPurchasesResponseItemsItemSisbovAnyOfOwnerPhone = string | null;

export type ListPurchasesResponseItemsItemSisbovAnyOfOwnerDocument =
  | string
  | null;

export type ListPurchasesResponseItemsItemSisbovAnyOfOwnerDescription =
  | string
  | null;

export type ListPurchasesResponseItemsItemSisbovAnyOfOwnerCode = string | null;

export type ListPurchasesResponseItemsItemSisbovAnyOfOwner = {
  code: ListPurchasesResponseItemsItemSisbovAnyOfOwnerCode;
  createdAt: string;
  description: ListPurchasesResponseItemsItemSisbovAnyOfOwnerDescription;
  document: ListPurchasesResponseItemsItemSisbovAnyOfOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListPurchasesResponseItemsItemSisbovAnyOfOwnerPhone;
  profiles: EnumsProfile[];
};

export type ListPurchasesResponseItemsItemSisbovAnyOfOrder = string | null;

export type ListPurchasesResponseItemsItemSisbovAnyOf = {
  brand: string;
  cancelled: number[];
  finalSisbov: number;
  id: number;
  initialSisbov: number;
  order: ListPurchasesResponseItemsItemSisbovAnyOfOrder;
  owner: ListPurchasesResponseItemsItemSisbovAnyOfOwner;
  ownerId: number;
  purchaseId: number;
};

export type ListPurchasesResponseItemsItemReceivedAt = string | null;

export type ListPurchasesResponseItemsItemPartnerHerd = string | null;

export type ListPurchasesResponseItemsItemOxen =
  ListPurchasesResponseItemsItemOxenAnyOf | null;

export type ListPurchasesResponseItemsItemOxenAnyOfWeighingAt = string | null;

export type ListPurchasesResponseItemsItemOxenAnyOfPartnerId = number | null;

export type ListPurchasesResponseItemsItemOxenAnyOfOxenAmount = number | null;

export type ListPurchasesResponseItemsItemOxenAnyOfMapa = string | null;

export type ListPurchasesResponseItemsItemOxenAnyOfMaleProducedPrice =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfMaleFutureAnimalPrice =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfMaleEntryCarcassYield =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfMaleDailyPrice =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfGtasItemOriginResponsible = {
  id: number;
  name: string;
};

export type ListPurchasesResponseItemsItemOxenAnyOfGtasItemOrigin = {
  responsible: ListPurchasesResponseItemsItemOxenAnyOfGtasItemOriginResponsible;
};

export type ListPurchasesResponseItemsItemOxenAnyOfGtasItem = {
  origin: ListPurchasesResponseItemsItemOxenAnyOfGtasItemOrigin;
};

export type ListPurchasesResponseItemsItemOxenAnyOfFemaleProducedPrice =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfFemaleFutureAnimalPrice =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfFemaleEntryCarcassYield =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfFemaleDailyPrice =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfDiscountPercent =
  | number
  | null;

export type ListPurchasesResponseItemsItemOxenAnyOfBuyer = {
  id: number;
  name: string;
};

export type ListPurchasesResponseItemsItemOxenAnyOf = {
  buyer: ListPurchasesResponseItemsItemOxenAnyOfBuyer;
  buyerId: number;
  commission: number;
  discountPercent: ListPurchasesResponseItemsItemOxenAnyOfDiscountPercent;
  femaleDailyPrice: ListPurchasesResponseItemsItemOxenAnyOfFemaleDailyPrice;
  femaleEntryCarcassYield: ListPurchasesResponseItemsItemOxenAnyOfFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: ListPurchasesResponseItemsItemOxenAnyOfFemaleFutureAnimalPrice;
  femaleProducedPrice: ListPurchasesResponseItemsItemOxenAnyOfFemaleProducedPrice;
  gtas: ListPurchasesResponseItemsItemOxenAnyOfGtasItem[];
  id: number;
  maleDailyPrice: ListPurchasesResponseItemsItemOxenAnyOfMaleDailyPrice;
  maleEntryCarcassYield: ListPurchasesResponseItemsItemOxenAnyOfMaleEntryCarcassYield;
  maleFutureAnimalPrice: ListPurchasesResponseItemsItemOxenAnyOfMaleFutureAnimalPrice;
  maleProducedPrice: ListPurchasesResponseItemsItemOxenAnyOfMaleProducedPrice;
  mapa: ListPurchasesResponseItemsItemOxenAnyOfMapa;
  ownerId: number;
  oxenAmount: ListPurchasesResponseItemsItemOxenAnyOfOxenAmount;
  partnerId: ListPurchasesResponseItemsItemOxenAnyOfPartnerId;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: ListPurchasesResponseItemsItemOxenAnyOfWeighingAt;
  weightAverage: number;
};

export type ListPurchasesResponseItemsItemObservation = string | null;

export type ListPurchasesResponseItemsItemEarringsPerPage = number | null;

export type ListPurchasesEarringsResponseEarringsPerPage = number | null;

export type ListPurchasesEarringsResponseEarringsItemElectronic = string | null;

export type ListPurchasesEarringsResponseEarringsItem = {
  electronic?: ListPurchasesEarringsResponseEarringsItemElectronic;
  entryDate?: string;
  managementCode: string;
  sisbov: number;
  status: string;
};

export interface ListPurchasesEarringsResponse {
  earringManufacturer?: string;
  earrings: ListPurchasesEarringsResponseEarringsItem[];
  earringsPerPage: ListPurchasesEarringsResponseEarringsPerPage;
}

export type ListPastureBatchesResponse = ListPastureBatchesResponseItem[];

export type ListPastureBatchesResponseItemTreatsRealizedItemDiet = {
  name: string;
};

export type ListPastureBatchesResponseItemTreatsRealizedItem = {
  day: string;
  diet: ListPastureBatchesResponseItemTreatsRealizedItemDiet;
  realizedNaturalMatter: number;
};

export type ListPastureBatchesResponseItemOldCorralId = number | null;

export type ListPastureBatchesResponseItemFinalizedAt = string | null;

export type ListPastureBatchesResponseItemDietsItemFinalizedAt = string | null;

export type ListPastureBatchesResponseItemDietsItem = {
  batchId: number;
  createdAt: string;
  diet: ListPastureBatchesResponseItemDietsItemDiet;
  dietId: number;
  finalizedAt: ListPastureBatchesResponseItemDietsItemFinalizedAt;
  id: number;
};

export type ListPastureBatchesResponseItem = {
  activatedAt: ListPastureBatchesResponseItemActivatedAt;
  corral: ListPastureBatchesResponseItemCorral;
  corralId: ListPastureBatchesResponseItemCorralId;
  createdAt: string;
  descrption: ListPastureBatchesResponseItemDescrption;
  diets: ListPastureBatchesResponseItemDietsItem[];
  farmId: number;
  finalizedAt: ListPastureBatchesResponseItemFinalizedAt;
  id: number;
  name: string;
  oldCorralId: ListPastureBatchesResponseItemOldCorralId;
  treatsRealized: ListPastureBatchesResponseItemTreatsRealizedItem[];
};

export type ListPastureBatchesResponseItemDietsItemDietPremixId = number | null;

export type ListPastureBatchesResponseItemDietsItemDietObservation =
  | string
  | null;

export type ListPastureBatchesResponseItemDietsItemDietFixedElg = number | null;

export type ListPastureBatchesResponseItemDietsItemDietCode = string | null;

export type ListPastureBatchesResponseItemDietsItemDietCategory =
  EnumsDietCategory | null;

export type ListPastureBatchesResponseItemDietsItemDiet = {
  active: boolean;
  category: ListPastureBatchesResponseItemDietsItemDietCategory;
  code: ListPastureBatchesResponseItemDietsItemDietCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: ListPastureBatchesResponseItemDietsItemDietFixedElg;
  id: number;
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: ListPastureBatchesResponseItemDietsItemDietObservation;
  premixId: ListPastureBatchesResponseItemDietsItemDietPremixId;
};

export type ListPastureBatchesResponseItemDescrption = string | null;

export type ListPastureBatchesResponseItemCorralId = number | null;

export type ListPastureBatchesResponseItemCorralAnyOf = {
  id: number;
  name: string;
  type: EnumsCorralType;
};

export type ListPastureBatchesResponseItemCorral =
  ListPastureBatchesResponseItemCorralAnyOf | null;

export type ListPastureBatchesResponseItemActivatedAt = string | null;

export type ListPartnersWithClosuresResponsePartnersItem = {
  id?: number;
  name?: string;
};

export interface ListPartnersWithClosuresResponse {
  partners: ListPartnersWithClosuresResponsePartnersItem[];
}

export interface ListPartnersWithClosuresRequest {
  endSaleDate: string;
  gender: string;
  startSaleDate: string;
}

export type ListPartnersForSalesReportResponseItem = {
  id?: number;
  name?: string;
};

export type ListPartnersForSalesReportResponse =
  ListPartnersForSalesReportResponseItem[];

export type ListPartnerHerdsAvailableResponsePartnerHerdsItem =
  | string
  | null
  | unknown;

export interface ListPartnerHerdsAvailableResponse {
  partnerHerds: ListPartnerHerdsAvailableResponsePartnerHerdsItem[];
}

export type ListPartnerClosuresV2ResponseItem = {
  boitel: ListPartnerClosuresV2ResponseItemBoitel;
  classic: ListPartnerClosuresV2ResponseItemClassic;
  closingDate: string;
  createdAt: string;
  farmId: number;
  fatCattle: ListPartnerClosuresV2ResponseItemFatCattle;
  finalValue: number;
  id: number;
  observation: ListPartnerClosuresV2ResponseItemObservation;
  oxenPurchase: ListPartnerClosuresV2ResponseItemOxenPurchase;
  oxenPurchaseId: number;
  type: EnumsPartnerClosureV2Type;
};

export type ListPartnerClosuresV2Response = ListPartnerClosuresV2ResponseItem[];

export type ListPartnerClosuresV2ResponseItemOxenPurchaseWeighingAt =
  | string
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchasePurchase = {
  name: string;
};

export type ListPartnerClosuresV2ResponseItemOxenPurchasePartnerId =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchasePartnerAnyOf = {
  name: string;
};

export type ListPartnerClosuresV2ResponseItemOxenPurchasePartner =
  ListPartnerClosuresV2ResponseItemOxenPurchasePartnerAnyOf | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseOxenAmount =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseMapa = string | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseMaleProducedPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseMaleFutureAnimalPrice =
  number | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseMaleEntryCarcassYield =
  number | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseMaleDailyPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleProducedPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleFutureAnimalPrice =
  number | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleEntryCarcassYield =
  number | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleDailyPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchaseDiscountPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemOxenPurchase = {
  buyerId: number;
  commission: number;
  discountPercent: ListPartnerClosuresV2ResponseItemOxenPurchaseDiscountPercent;
  femaleDailyPrice: ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleDailyPrice;
  femaleEntryCarcassYield: ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleFutureAnimalPrice;
  femaleProducedPrice: ListPartnerClosuresV2ResponseItemOxenPurchaseFemaleProducedPrice;
  id: number;
  maleDailyPrice: ListPartnerClosuresV2ResponseItemOxenPurchaseMaleDailyPrice;
  maleEntryCarcassYield: ListPartnerClosuresV2ResponseItemOxenPurchaseMaleEntryCarcassYield;
  maleFutureAnimalPrice: ListPartnerClosuresV2ResponseItemOxenPurchaseMaleFutureAnimalPrice;
  maleProducedPrice: ListPartnerClosuresV2ResponseItemOxenPurchaseMaleProducedPrice;
  mapa: ListPartnerClosuresV2ResponseItemOxenPurchaseMapa;
  ownerId: number;
  oxenAmount: ListPartnerClosuresV2ResponseItemOxenPurchaseOxenAmount;
  partner: ListPartnerClosuresV2ResponseItemOxenPurchasePartner;
  partnerId: ListPartnerClosuresV2ResponseItemOxenPurchasePartnerId;
  purchase: ListPartnerClosuresV2ResponseItemOxenPurchasePurchase;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: ListPartnerClosuresV2ResponseItemOxenPurchaseWeighingAt;
  weightAverage: number;
};

export type ListPartnerClosuresV2ResponseItemObservation = string | null;

export type ListPartnerClosuresV2ResponseItemFatCattle =
  ListPartnerClosuresV2ResponseItemFatCattleAnyOf | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfSlaughterhouse =
  | string
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfSlaughterDate =
  | string
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfSenarPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfPaymentDays =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfPaymentDate =
  | string
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightTrips =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightTransportedAmount =
  number | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightTotalWeightKg =
  number | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightDetourPerTrip =
  number | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightCostPerTrip =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightAtSignPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfExitAtSignPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOfDiscountPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemFatCattleAnyOf = {
  discountPercent: ListPartnerClosuresV2ResponseItemFatCattleAnyOfDiscountPercent;
  exitAtSignPrice: ListPartnerClosuresV2ResponseItemFatCattleAnyOfExitAtSignPrice;
  freightAtSignPrice: ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightAtSignPrice;
  freightCostPerTrip: ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightCostPerTrip;
  freightDetourPerTrip: ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightDetourPerTrip;
  freightTotalWeightKg: ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightTotalWeightKg;
  freightTransportedAmount: ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightTransportedAmount;
  freightTrips: ListPartnerClosuresV2ResponseItemFatCattleAnyOfFreightTrips;
  id: number;
  partnerClosureV2Id: number;
  paymentDate: ListPartnerClosuresV2ResponseItemFatCattleAnyOfPaymentDate;
  paymentDays: ListPartnerClosuresV2ResponseItemFatCattleAnyOfPaymentDays;
  senarPercent: ListPartnerClosuresV2ResponseItemFatCattleAnyOfSenarPercent;
  slaughterDate: ListPartnerClosuresV2ResponseItemFatCattleAnyOfSlaughterDate;
  slaughterhouse: ListPartnerClosuresV2ResponseItemFatCattleAnyOfSlaughterhouse;
};

export type ListPartnerClosuresV2ResponseItemClassic =
  ListPartnerClosuresV2ResponseItemClassicAnyOf | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfTotalEntryLiveWeight =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfSenarPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfReceiptDays =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfPaymentDays =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfMaleExitCarcassYield =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfFemaleExitCarcassYield =
  number | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfExitAtSignPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfDiscountPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfCorrectionPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfContractNumber =
  | string
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfContractedAmount =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfCarcassYield =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOfBonusPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemClassicAnyOf = {
  bonusPercent: ListPartnerClosuresV2ResponseItemClassicAnyOfBonusPercent;
  carcassYield: ListPartnerClosuresV2ResponseItemClassicAnyOfCarcassYield;
  contractedAmount: ListPartnerClosuresV2ResponseItemClassicAnyOfContractedAmount;
  contractNumber: ListPartnerClosuresV2ResponseItemClassicAnyOfContractNumber;
  correctionPercent: ListPartnerClosuresV2ResponseItemClassicAnyOfCorrectionPercent;
  discountPercent: ListPartnerClosuresV2ResponseItemClassicAnyOfDiscountPercent;
  exitAtSignPrice: ListPartnerClosuresV2ResponseItemClassicAnyOfExitAtSignPrice;
  femaleExitCarcassYield: ListPartnerClosuresV2ResponseItemClassicAnyOfFemaleExitCarcassYield;
  id: number;
  maleExitCarcassYield: ListPartnerClosuresV2ResponseItemClassicAnyOfMaleExitCarcassYield;
  partnerClosureV2Id: number;
  paymentDays: ListPartnerClosuresV2ResponseItemClassicAnyOfPaymentDays;
  receiptDays: ListPartnerClosuresV2ResponseItemClassicAnyOfReceiptDays;
  senarPercent: ListPartnerClosuresV2ResponseItemClassicAnyOfSenarPercent;
  totalEntryLiveWeight: ListPartnerClosuresV2ResponseItemClassicAnyOfTotalEntryLiveWeight;
};

export type ListPartnerClosuresV2ResponseItemBoitel =
  ListPartnerClosuresV2ResponseItemBoitelAnyOf | null;

export type ListPartnerClosuresV2ResponseItemBoitelAnyOfTotalLockedAtSign =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemBoitelAnyOfSenarPercent =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemBoitelAnyOfSanitaryCost =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemBoitelAnyOfPartnerPaymentDate =
  | string
  | null;

export type ListPartnerClosuresV2ResponseItemBoitelAnyOfLockedFee =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemBoitelAnyOfLockedAtSignPrice =
  | number
  | null;

export type ListPartnerClosuresV2ResponseItemBoitelAnyOf = {
  atSignPrice: number;
  dailyRate: number;
  id: number;
  lockedAtSignPrice: ListPartnerClosuresV2ResponseItemBoitelAnyOfLockedAtSignPrice;
  lockedFee: ListPartnerClosuresV2ResponseItemBoitelAnyOfLockedFee;
  partnerClosureV2Id: number;
  partnerPaymentDate: ListPartnerClosuresV2ResponseItemBoitelAnyOfPartnerPaymentDate;
  sanitaryCost: ListPartnerClosuresV2ResponseItemBoitelAnyOfSanitaryCost;
  senarPercent: ListPartnerClosuresV2ResponseItemBoitelAnyOfSenarPercent;
  totalAtSign: number;
  totalDays: number;
  totalLockedAtSign: ListPartnerClosuresV2ResponseItemBoitelAnyOfTotalLockedAtSign;
};

export type ListPartnerClosuresResponseItem = {
  createdAt: string;
  finalSalePrice: number;
  id: number;
  oxenPurchase: ListPartnerClosuresResponseItemOxenPurchase;
  saleOrders: ListPartnerClosuresResponseItemSaleOrdersItem[];
};

export type ListPartnerClosuresResponse = ListPartnerClosuresResponseItem[];

export type ListPartnerClosuresResponseItemSaleOrdersItemTypeOfClosed =
  EnumsSaleOrderType | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemSourceType =
  EnumsSaleOrderSourceType | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemPartnerClosureId =
  | number
  | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemPartnerAtSignPriceM =
  | number
  | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemPartnerAtSignPriceF =
  | number
  | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemFreightPerAtSignBRL =
  | number
  | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemBonusPercent =
  | number
  | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemAtSignPrice =
  | number
  | null;

export type ListPartnerClosuresResponseItemSaleOrdersItemAnnouncementId =
  | number
  | null;

export type ListPartnerClosuresResponseItemSaleOrdersItem = {
  announcementId: ListPartnerClosuresResponseItemSaleOrdersItemAnnouncementId;
  atSignPrice: ListPartnerClosuresResponseItemSaleOrdersItemAtSignPrice;
  bonusPercent: ListPartnerClosuresResponseItemSaleOrdersItemBonusPercent;
  createdAt: string;
  createdBy: number;
  destinyId: number;
  expirationDay: string;
  farmId: number;
  freightPerAtSignBRL: ListPartnerClosuresResponseItemSaleOrdersItemFreightPerAtSignBRL;
  id: number;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF: ListPartnerClosuresResponseItemSaleOrdersItemPartnerAtSignPriceF;
  partnerAtSignPriceM: ListPartnerClosuresResponseItemSaleOrdersItemPartnerAtSignPriceM;
  partnerClosureId: ListPartnerClosuresResponseItemSaleOrdersItemPartnerClosureId;
  paymentMethod: string;
  saleDate: string;
  sourceType: ListPartnerClosuresResponseItemSaleOrdersItemSourceType;
  status: EnumsSaleOrderStatus;
  typeOfClosed: ListPartnerClosuresResponseItemSaleOrdersItemTypeOfClosed;
};

export type ListPartnerClosuresResponseItemOxenPurchasePurchasePartnerHerd =
  | string
  | null;

export type ListPartnerClosuresResponseItemOxenPurchasePurchase = {
  name: string;
  partnerHerd: ListPartnerClosuresResponseItemOxenPurchasePurchasePartnerHerd;
};

export type ListPartnerClosuresResponseItemOxenPurchase = {
  purchase: ListPartnerClosuresResponseItemOxenPurchasePurchase;
};

export type ListPartnerClosuresByPartnerIdResponseItem = {
  createdAt: string;
  finalSalePrice: number;
  id: number;
  oxenPurchase: ListPartnerClosuresByPartnerIdResponseItemOxenPurchase;
  saleOrders: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItem[];
};

export type ListPartnerClosuresByPartnerIdResponse =
  ListPartnerClosuresByPartnerIdResponseItem[];

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemTypeOfClosed =
  EnumsSaleOrderType | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemSourceType =
  EnumsSaleOrderSourceType | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemPartnerClosureId =
  number | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemPartnerAtSignPriceM =
  number | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemPartnerAtSignPriceF =
  number | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemFreightPerAtSignBRL =
  number | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemBonusPercent =
  number | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemAtSignPrice =
  number | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemAnnouncementId =
  number | null;

export type ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItem = {
  announcementId: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemAnnouncementId;
  atSignPrice: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemAtSignPrice;
  bonusPercent: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemBonusPercent;
  createdAt: string;
  createdBy: number;
  destinyId: number;
  expirationDay: string;
  farmId: number;
  freightPerAtSignBRL: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemFreightPerAtSignBRL;
  id: number;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemPartnerAtSignPriceF;
  partnerAtSignPriceM: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemPartnerAtSignPriceM;
  partnerClosureId: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemPartnerClosureId;
  paymentMethod: string;
  saleDate: string;
  sourceType: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemSourceType;
  status: EnumsSaleOrderStatus;
  typeOfClosed: ListPartnerClosuresByPartnerIdResponseItemSaleOrdersItemTypeOfClosed;
};

export type ListPartnerClosuresByPartnerIdResponseItemOxenPurchasePurchasePartnerHerd =
  string | null;

export type ListPartnerClosuresByPartnerIdResponseItemOxenPurchasePurchase = {
  name: string;
  partnerHerd: ListPartnerClosuresByPartnerIdResponseItemOxenPurchasePurchasePartnerHerd;
};

export type ListPartnerClosuresByPartnerIdResponseItemOxenPurchase = {
  id: number;
  purchase: ListPartnerClosuresByPartnerIdResponseItemOxenPurchasePurchase;
};

export interface ListPartnerClosuresByPartnerIdRequest {
  endSaleDate: string;
  gender: string;
  partnerId: number;
  startSaleDate: string;
}

export type ListOxenRowSisbov = string | null;

export type ListOxenRowPurchaseOwnerName = string | null;

export type ListOxenRowPurchaseOwner = {
  name: ListOxenRowPurchaseOwnerName;
};

export type ListOxenRowPurchasePartnerHerd = string | null;

export type ListOxenRowPurchaseObservation = string | null;

export type ListOxenRowPurchase = {
  id: number;
  name: string;
  observation: ListOxenRowPurchaseObservation;
  partnerHerd: ListOxenRowPurchasePartnerHerd;
};

export type ListOxenRowPriceAtSignEntry = number | null;

export type ListOxenRowOwner = {
  id: number;
  name: string;
};

export interface ListOxenRow {
  batch: ListOxenRowBatch;
  birth: string;
  blockedUntil: string;
  breed: string;
  buyer: ListOxenRowBuyer;
  category: EnumsOxCategory;
  certifierDate: ListOxenRowCertifierDate;
  corral: ListOxenRowCorral;
  currentWeight: number;
  dentitionStage: ListOxenRowDentitionStage;
  diedAt: ListOxenRowDiedAt;
  electronic: ListOxenRowElectronic;
  entryDate: string;
  entryWeight: number;
  foreseenSlaughtWeight: number;
  gender: EnumsOxGender;
  gta: ListOxenRowGta;
  id: number;
  identificationDate: ListOxenRowIdentificationDate;
  identifier: ListOxenRowIdentifier;
  internalSale?: ListOxenRowInternalSale;
  lastIntermediateWeight: number;
  lastWeightingDate: string;
  managementCode: ListOxenRowManagementCode;
  origin: ListOxenRowOrigin;
  owner: ListOxenRowOwner;
  priceAtSignEntry: ListOxenRowPriceAtSignEntry;
  processingWeight: number;
  purchase: ListOxenRowPurchase;
  purchaseOwner?: ListOxenRowPurchaseOwner;
  sisbov: ListOxenRowSisbov;
  variety: string;
}

export type ListOxenRowOriginResponsible = {
  id: number;
  name: string;
};

export type ListOxenRowOrigin = {
  id: number;
  name: string;
  responsible: ListOxenRowOriginResponsible;
};

export type ListOxenRowManagementCode = string | null;

export type ListOxenRowInternalSaleName = string | null;

export type ListOxenRowInternalSale = {
  name: ListOxenRowInternalSaleName;
};

export type ListOxenRowIdentifier = string | null;

export type ListOxenRowIdentificationDate = string | null;

export type ListOxenRowGtaWeightingMapReferenceCode = string | null;

export type ListOxenRowGtaWeightingMapId = number | null;

export type ListOxenRowGtaWeightingMap = {
  id: ListOxenRowGtaWeightingMapId;
  referenceCode: ListOxenRowGtaWeightingMapReferenceCode;
};

export type ListOxenRowGta = {
  emission: string;
  id: number;
  invoice: string;
  number: string;
  series: string;
  weightingMap: ListOxenRowGtaWeightingMap;
};

export type ListOxenRowElectronic = string | null;

export type ListOxenRowDiedAt = string | null;

export type ListOxenRowDentitionStage = EnumsDentitionStage | null;

export type ListOxenRowCorral = {
  id: number;
  name: string;
  position: number;
  type: EnumsCorralType;
};

export type ListOxenRowCertifierDate = string | null;

export type ListOxenRowBuyer = {
  id: number;
  name: string;
};

export type ListOxenRowBatchAdjustedPurchaseCost = number | null;

export type ListOxenRowBatch = {
  adjustedPurchaseCost: ListOxenRowBatchAdjustedPurchaseCost;
  carcass: number;
  id: number;
  name: string;
};

export interface ListOxenResponse {
  items: ListOxenRow[];
  page: number;
  totalPages: number;
}

export type ListOxenPurchaseResponse = ListOxenPurchaseResponseItem[];

export type ListOxenPurchaseResponseItemWeighingAt = string | null;

export type ListOxenPurchaseResponseItemPurchase = {
  name: string;
};

export type ListOxenPurchaseResponseItemPartnerId = number | null;

export type ListOxenPurchaseResponseItemOxenAmount = number | null;

export type ListOxenPurchaseResponseItemMapa = string | null;

export type ListOxenPurchaseResponseItemMaleProducedPrice = number | null;

export type ListOxenPurchaseResponseItemMaleFutureAnimalPrice = number | null;

export type ListOxenPurchaseResponseItemMaleEntryCarcassYield = number | null;

export type ListOxenPurchaseResponseItemMaleDailyPrice = number | null;

export type ListOxenPurchaseResponseItemFemaleProducedPrice = number | null;

export type ListOxenPurchaseResponseItemFemaleFutureAnimalPrice = number | null;

export type ListOxenPurchaseResponseItemFemaleEntryCarcassYield = number | null;

export type ListOxenPurchaseResponseItemFemaleDailyPrice = number | null;

export type ListOxenPurchaseResponseItemDiscountPercent = number | null;

export type ListOxenPurchaseResponseItem = {
  buyerId: number;
  commission: number;
  discountPercent: ListOxenPurchaseResponseItemDiscountPercent;
  femaleDailyPrice: ListOxenPurchaseResponseItemFemaleDailyPrice;
  femaleEntryCarcassYield: ListOxenPurchaseResponseItemFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: ListOxenPurchaseResponseItemFemaleFutureAnimalPrice;
  femaleProducedPrice: ListOxenPurchaseResponseItemFemaleProducedPrice;
  id: number;
  maleDailyPrice: ListOxenPurchaseResponseItemMaleDailyPrice;
  maleEntryCarcassYield: ListOxenPurchaseResponseItemMaleEntryCarcassYield;
  maleFutureAnimalPrice: ListOxenPurchaseResponseItemMaleFutureAnimalPrice;
  maleProducedPrice: ListOxenPurchaseResponseItemMaleProducedPrice;
  mapa: ListOxenPurchaseResponseItemMapa;
  ownerId: number;
  oxenAmount: ListOxenPurchaseResponseItemOxenAmount;
  partnerId: ListOxenPurchaseResponseItemPartnerId;
  purchase: ListOxenPurchaseResponseItemPurchase;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: ListOxenPurchaseResponseItemWeighingAt;
  weightAverage: number;
};

export type ListOxenOfflineSaleResponse = ListOxenOfflineSaleResponseItem[];

export type ListOxenOfflineSaleResponseItemStartOfTreatment = string | null;

export type ListOxenOfflineSaleResponseItemSisbov = string | null;

export type ListOxenOfflineSaleResponseItemSalesMarketType =
  EnumsSalesMarketType | null;

export type ListOxenOfflineSaleResponseItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListOxenOfflineSaleResponseItemReversedDeathDetails = string | null;

export type ListOxenOfflineSaleResponseItemReversedDeathDate = string | null;

export type ListOxenOfflineSaleResponseItemReversedDeathCause =
  EnumsDeathCause | null;

export type ListOxenOfflineSaleResponseItemPurchaseId = number | null;

export type ListOxenOfflineSaleResponseItemPriceAtSignExit = number | null;

export type ListOxenOfflineSaleResponseItemPriceAtSignEntry = number | null;

export type ListOxenOfflineSaleResponseItemOwnerPhone = string | null;

export type ListOxenOfflineSaleResponseItemOwnerDocument = string | null;

export type ListOxenOfflineSaleResponseItemOwnerDescription = string | null;

export type ListOxenOfflineSaleResponseItemOwnerCode = string | null;

export type ListOxenOfflineSaleResponseItemOwner = {
  code: ListOxenOfflineSaleResponseItemOwnerCode;
  createdAt: string;
  description: ListOxenOfflineSaleResponseItemOwnerDescription;
  document: ListOxenOfflineSaleResponseItemOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListOxenOfflineSaleResponseItemOwnerPhone;
  profiles: EnumsProfile[];
};

export type ListOxenOfflineSaleResponseItemOtherDeathCause = string | null;

export type ListOxenOfflineSaleResponseItemIsNecropsyPerformed = boolean | null;

export type ListOxenOfflineSaleResponseItemInvoice = string | null;

export type ListOxenOfflineSaleResponseItemInternalSaleId = number | null;

export type ListOxenOfflineSaleResponseItemIntermediateWeightsItem = {
  date: string;
  weight: number;
};

export type ListOxenOfflineSaleResponseItemIdentifier = string | null;

export type ListOxenOfflineSaleResponseItemIdentifiedAt = string | null;

export type ListOxenOfflineSaleResponseItemIdentificationSource =
  EnumsIdentificationSource | null;

export type ListOxenOfflineSaleResponseItemHasBirthAnnouncement =
  | boolean
  | null;

export type ListOxenOfflineSaleResponseItemGtaId = number | null;

export type ListOxenOfflineSaleResponseItemExitTruckId = number | null;

export type ListOxenOfflineSaleResponseItemElectronic = string | null;

export type ListOxenOfflineSaleResponseItemDiedAt = string | null;

export type ListOxenOfflineSaleResponseItemDentitionStage =
  EnumsDentitionStage | null;

export type ListOxenOfflineSaleResponseItemDeathReason = EnumsDeathCause | null;

export type ListOxenOfflineSaleResponseItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListOxenOfflineSaleResponseItemDeathDetails = string | null;

export type ListOxenOfflineSaleResponseItemDeathCause = EnumsDeathCause | null;

export type ListOxenOfflineSaleResponseItemCorralAnyOfPosition = number | null;

export type ListOxenOfflineSaleResponseItemCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: ListOxenOfflineSaleResponseItemCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type ListOxenOfflineSaleResponseItemCorral =
  ListOxenOfflineSaleResponseItemCorralAnyOf | null;

export type ListOxenOfflineSaleResponseItemComments = string | null;

export type ListOxenOfflineSaleResponseItemCertifierDate = string | null;

export type ListOxenOfflineSaleResponseItemCattleManifestId = number | null;

export type ListOxenOfflineSaleResponseItemCarcassWeight = number | null;

export type ListOxenOfflineSaleResponseItemCarcassType =
  EnumsCarcassType | null;

export type ListOxenOfflineSaleResponseItemCarcassPrice = number | null;

export type ListOxenOfflineSaleResponseItemCarcass = number | null;

export type ListOxenOfflineSaleResponseItemBornOnFarm = boolean | null;

export type ListOxenOfflineSaleResponseItemBndTracked = boolean | null;

export type ListOxenOfflineSaleResponseItemBatchesItemFinalizedAt =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemDescription =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatch = {
  activatedAt: ListOxenOfflineSaleResponseItemBatchesItemBatchActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: ListOxenOfflineSaleResponseItemBatchesItemBatchActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: ListOxenOfflineSaleResponseItemBatchesItemBatchAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassExcessive;
  carcassMedium: ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassMedium;
  carcassMissing: ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassMissing;
  carcassThin: ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassThin;
  carcassUniform: ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassUniform;
  corral: ListOxenOfflineSaleResponseItemBatchesItemBatchCorral;
  corralId: ListOxenOfflineSaleResponseItemBatchesItemBatchCorralId;
  createdAt: string;
  descrption: ListOxenOfflineSaleResponseItemBatchesItemBatchDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: ListOxenOfflineSaleResponseItemBatchesItemBatchFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: ListOxenOfflineSaleResponseItemBatchesItemBatchForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: ListOxenOfflineSaleResponseItemBatchesItemBatchHideFromTreatment;
  hideFromTreatmentUntil: ListOxenOfflineSaleResponseItemBatchesItemBatchHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: ListOxenOfflineSaleResponseItemBatchesItemBatchOldCorralId;
  operationalCostGroupId: ListOxenOfflineSaleResponseItemBatchesItemBatchOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: ListOxenOfflineSaleResponseItemBatchesItemBatchScaledToSlaughter;
};

export type ListOxenOfflineSaleResponseItemBatchesItem = {
  batch: ListOxenOfflineSaleResponseItemBatchesItemBatch;
  batchId: number;
  createdAt: string;
  description: ListOxenOfflineSaleResponseItemBatchesItemDescription;
  finalizedAt: ListOxenOfflineSaleResponseItemBatchesItemFinalizedAt;
  id: number;
  oxId: number;
};

export type ListOxenOfflineSaleResponseItem = {
  batch?: ListOxenOfflineSaleResponseItemBatch;
  batches: ListOxenOfflineSaleResponseItemBatchesItem[];
  birth: string;
  blockedUntil: string;
  bndTracked: ListOxenOfflineSaleResponseItemBndTracked;
  bornOnFarm: ListOxenOfflineSaleResponseItemBornOnFarm;
  breed: string;
  carcass: ListOxenOfflineSaleResponseItemCarcass;
  carcassPrice: ListOxenOfflineSaleResponseItemCarcassPrice;
  carcassType: ListOxenOfflineSaleResponseItemCarcassType;
  carcassWeight: ListOxenOfflineSaleResponseItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: ListOxenOfflineSaleResponseItemCattleManifestId;
  certifierDate: ListOxenOfflineSaleResponseItemCertifierDate;
  comments: ListOxenOfflineSaleResponseItemComments;
  corral?: ListOxenOfflineSaleResponseItemCorral;
  currentWeight: number;
  deathCause: ListOxenOfflineSaleResponseItemDeathCause;
  deathDetails: ListOxenOfflineSaleResponseItemDeathDetails;
  deathNecropsy: ListOxenOfflineSaleResponseItemDeathNecropsy;
  deathReason: ListOxenOfflineSaleResponseItemDeathReason;
  dentitionStage: ListOxenOfflineSaleResponseItemDentitionStage;
  diedAt: ListOxenOfflineSaleResponseItemDiedAt;
  electronic: ListOxenOfflineSaleResponseItemElectronic;
  entryWeight: number;
  exitTruckId: ListOxenOfflineSaleResponseItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gmdEstimated: number;
  gmdReal: number;
  gpd: number;
  gtaId: ListOxenOfflineSaleResponseItemGtaId;
  hasBirthAnnouncement: ListOxenOfflineSaleResponseItemHasBirthAnnouncement;
  hiltonQuota?: boolean;
  id: number;
  identificationSource: ListOxenOfflineSaleResponseItemIdentificationSource;
  identifiedAt: ListOxenOfflineSaleResponseItemIdentifiedAt;
  identifier: ListOxenOfflineSaleResponseItemIdentifier;
  includedAt: string;
  intermediateWeights: ListOxenOfflineSaleResponseItemIntermediateWeightsItem[];
  internalSaleId: ListOxenOfflineSaleResponseItemInternalSaleId;
  invoice: ListOxenOfflineSaleResponseItemInvoice;
  isNecropsyPerformed: ListOxenOfflineSaleResponseItemIsNecropsyPerformed;
  otherDeathCause: ListOxenOfflineSaleResponseItemOtherDeathCause;
  owner: ListOxenOfflineSaleResponseItemOwner;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: ListOxenOfflineSaleResponseItemPriceAtSignEntry;
  priceAtSignExit: ListOxenOfflineSaleResponseItemPriceAtSignExit;
  purchaseId: ListOxenOfflineSaleResponseItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: ListOxenOfflineSaleResponseItemReversedDeathCause;
  reversedDeathDate: ListOxenOfflineSaleResponseItemReversedDeathDate;
  reversedDeathDetails: ListOxenOfflineSaleResponseItemReversedDeathDetails;
  reversedDeathNecropsy: ListOxenOfflineSaleResponseItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: ListOxenOfflineSaleResponseItemSalesMarketType;
  sisbov: ListOxenOfflineSaleResponseItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: ListOxenOfflineSaleResponseItemStartOfTreatment;
  variety: string;
  weights?: unknown;
};

export type ListOxenOfflineSaleResponseItemBatchesItemBatchScaledToSlaughter =
  | boolean
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchOperationalCostGroupId =
  number | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchOldCorralId =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchHideFromTreatmentUntil =
  string | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchHideFromTreatment =
  | boolean
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchForeseenSlaughterDate =
  string | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchFinalizedAt =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchDescrption =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCorralId =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCorralAnyOfPosition =
  number | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: ListOxenOfflineSaleResponseItemBatchesItemBatchCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCorral =
  ListOxenOfflineSaleResponseItemBatchesItemBatchCorralAnyOf | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassUniform =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassThin =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassMissing =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassMedium =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchCarcassExcessive =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchAdjustedPurchaseCost =
  number | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchActivationEditedAt =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchesItemBatchActivatedAt =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchScaledToSlaughter =
  | boolean
  | null;

export type ListOxenOfflineSaleResponseItemBatchOperationalCostGroupId =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchOldCorralId = number | null;

export type ListOxenOfflineSaleResponseItemBatchHideFromTreatmentUntil =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchHideFromTreatment =
  | boolean
  | null;

export type ListOxenOfflineSaleResponseItemBatchForeseenSlaughterDate =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchFinalizedAt = string | null;

export type ListOxenOfflineSaleResponseItemBatchDescrption = string | null;

export type ListOxenOfflineSaleResponseItemBatchCorralId = number | null;

export type ListOxenOfflineSaleResponseItemBatch = {
  activatedAt: ListOxenOfflineSaleResponseItemBatchActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: ListOxenOfflineSaleResponseItemBatchActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: ListOxenOfflineSaleResponseItemBatchAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: ListOxenOfflineSaleResponseItemBatchCarcassExcessive;
  carcassMedium: ListOxenOfflineSaleResponseItemBatchCarcassMedium;
  carcassMissing: ListOxenOfflineSaleResponseItemBatchCarcassMissing;
  carcassThin: ListOxenOfflineSaleResponseItemBatchCarcassThin;
  carcassUniform: ListOxenOfflineSaleResponseItemBatchCarcassUniform;
  corral: ListOxenOfflineSaleResponseItemBatchCorral;
  corralId: ListOxenOfflineSaleResponseItemBatchCorralId;
  createdAt: string;
  descrption: ListOxenOfflineSaleResponseItemBatchDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: ListOxenOfflineSaleResponseItemBatchFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: ListOxenOfflineSaleResponseItemBatchForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: ListOxenOfflineSaleResponseItemBatchHideFromTreatment;
  hideFromTreatmentUntil: ListOxenOfflineSaleResponseItemBatchHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: ListOxenOfflineSaleResponseItemBatchOldCorralId;
  operationalCostGroupId: ListOxenOfflineSaleResponseItemBatchOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: ListOxenOfflineSaleResponseItemBatchScaledToSlaughter;
};

export type ListOxenOfflineSaleResponseItemBatchCorralAnyOfPosition =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: ListOxenOfflineSaleResponseItemBatchCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type ListOxenOfflineSaleResponseItemBatchCorral =
  ListOxenOfflineSaleResponseItemBatchCorralAnyOf | null;

export type ListOxenOfflineSaleResponseItemBatchCarcassUniform = number | null;

export type ListOxenOfflineSaleResponseItemBatchCarcassThin = number | null;

export type ListOxenOfflineSaleResponseItemBatchCarcassMissing = number | null;

export type ListOxenOfflineSaleResponseItemBatchCarcassMedium = number | null;

export type ListOxenOfflineSaleResponseItemBatchCarcassExcessive =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchAdjustedPurchaseCost =
  | number
  | null;

export type ListOxenOfflineSaleResponseItemBatchActivationEditedAt =
  | string
  | null;

export type ListOxenOfflineSaleResponseItemBatchActivatedAt = string | null;

export type ListOxenHealthResponseItemsItem = {
  appliedAt: string;
  batchName: ListOxenHealthResponseItemsItemBatchName;
  corralName: ListOxenHealthResponseItemsItemCorralName;
  disease: EnumsDisease;
  healthProtocol: ListOxenHealthResponseItemsItemHealthProtocol;
  id: number;
  medicineApplicator: ListOxenHealthResponseItemsItemMedicineApplicator;
  medicineToOxHealth: ListOxenHealthResponseItemsItemMedicineToOxHealthItem[];
  ox: ListOxenHealthResponseItemsItemOx;
  oxId: number;
};

export interface ListOxenHealthResponse {
  items: ListOxenHealthResponseItemsItem[];
  next?: number;
  previous?: number;
}

export type ListOxenHealthResponseItemsItemOxSisbov = string | null;

export type ListOxenHealthResponseItemsItemOxIdentifier = string | null;

export type ListOxenHealthResponseItemsItemOxElectronic = string | null;

export type ListOxenHealthResponseItemsItemOxDiedAt = string | null;

export type ListOxenHealthResponseItemsItemOx = {
  diedAt: ListOxenHealthResponseItemsItemOxDiedAt;
  electronic: ListOxenHealthResponseItemsItemOxElectronic;
  gender: EnumsOxGender;
  identifier: ListOxenHealthResponseItemsItemOxIdentifier;
  sisbov: ListOxenHealthResponseItemsItemOxSisbov;
  variety: string;
};

export type ListOxenHealthResponseItemsItemMedicineToOxHealthItemMedicinePerKg =
  number | null;

export type ListOxenHealthResponseItemsItemMedicineToOxHealthItemMedicineKiloDose =
  number | null;

export type ListOxenHealthResponseItemsItemMedicineToOxHealthItemMedicine = {
  kiloDose: ListOxenHealthResponseItemsItemMedicineToOxHealthItemMedicineKiloDose;
  name: string;
  perKg: ListOxenHealthResponseItemsItemMedicineToOxHealthItemMedicinePerKg;
};

export type ListOxenHealthResponseItemsItemMedicineToOxHealthItemAppliedDose =
  | number
  | null;

export type ListOxenHealthResponseItemsItemMedicineToOxHealthItem = {
  appliedDose: ListOxenHealthResponseItemsItemMedicineToOxHealthItemAppliedDose;
  dosePrice: number;
  medicine: ListOxenHealthResponseItemsItemMedicineToOxHealthItemMedicine;
  medicineId: number;
};

export type ListOxenHealthResponseItemsItemMedicineApplicatorAnyOf = {
  name: string;
};

export type ListOxenHealthResponseItemsItemMedicineApplicator =
  ListOxenHealthResponseItemsItemMedicineApplicatorAnyOf | null;

export type ListOxenHealthResponseItemsItemHealthProtocolAnyOf = {
  name: string;
};

export type ListOxenHealthResponseItemsItemHealthProtocol =
  ListOxenHealthResponseItemsItemHealthProtocolAnyOf | null;

export type ListOxenHealthResponseItemsItemCorralName = string | null;

export type ListOxenHealthResponseItemsItemBatchName = string | null;

export type ListOxenHealthBatchResultDescription = string | null;

export type ListOxenHealthBatchResultCorralName = string | null;

export type ListOxenHealthBatchResultCorralId = number | null;

export interface ListOxenHealthBatchResult {
  batchId: number;
  batchName: string;
  corralId: ListOxenHealthBatchResultCorralId;
  corralName: ListOxenHealthBatchResultCorralName;
  description: ListOxenHealthBatchResultDescription;
  oxHealthIds: number[];
}

export type ListOxenHealthBatchesResponse = ListOxenHealthBatchResult[];

export interface ListOxenFilter {
  animalStatus?: string;
  batchId?: number;
  breed?: string;
  category?: EnumsOxCategory;
  corralId?: number;
  currentWeight?: number;
  displayUntilDate?: string;
  electronic?: string;
  electronicCode?: string;
  entryDate?: string;
  entryWeight?: number;
  exitDate?: string;
  foreseenSlaughtWeight?: number;
  gender?: EnumsOxGender;
  gtaId?: number;
  id?: number;
  identifier?: string;
  invoice?: string;
  lastWeightingDate?: string;
  limit?: number;
  managementCode?: string;
  onlyLiveAnimal?: boolean;
  originId?: number;
  originResponsibleId?: number;
  ownerId?: number;
  page?: number;
  purchaseId?: number;
  sisbov?: string;
  variety?: string;
}

export type ListOxenByBatchIdResponseTreatmentsItemTreatment = {
  name: string;
};

export type ListOxenByBatchIdResponseTreatmentsItem = {
  treatment: ListOxenByBatchIdResponseTreatmentsItemTreatment;
};

export type ListOxenByBatchIdResponseScaledToSlaughter = boolean | null;

export type ListOxenByBatchIdResponseOxenItem = {
  ox: ListOxenByBatchIdResponseOxenItemOx;
};

export interface ListOxenByBatchIdResponse {
  activatedAt: ListOxenByBatchIdResponseActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: ListOxenByBatchIdResponseActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: ListOxenByBatchIdResponseAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: ListOxenByBatchIdResponseCarcassExcessive;
  carcassMedium: ListOxenByBatchIdResponseCarcassMedium;
  carcassMissing: ListOxenByBatchIdResponseCarcassMissing;
  carcassThin: ListOxenByBatchIdResponseCarcassThin;
  carcassUniform: ListOxenByBatchIdResponseCarcassUniform;
  corral: ListOxenByBatchIdResponseCorral;
  corralId: ListOxenByBatchIdResponseCorralId;
  createdAt: string;
  descrption: ListOxenByBatchIdResponseDescrption;
  diets: ListOxenByBatchIdResponseDietsItem[];
  exitPrice: number;
  farmId: number;
  finalizedAt: ListOxenByBatchIdResponseFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: ListOxenByBatchIdResponseForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: ListOxenByBatchIdResponseHideFromTreatment;
  hideFromTreatmentUntil: ListOxenByBatchIdResponseHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: ListOxenByBatchIdResponseOldCorralId;
  operationalCostGroupId: ListOxenByBatchIdResponseOperationalCostGroupId;
  otherCost: number;
  oxen: ListOxenByBatchIdResponseOxenItem[];
  oxFinancing: boolean;
  scaledToSlaughter: ListOxenByBatchIdResponseScaledToSlaughter;
  treatments: ListOxenByBatchIdResponseTreatmentsItem[];
}

export type ListOxenByBatchIdResponseOxenItemOxWeightsItemType =
  EnumsWeightType | null;

export type ListOxenByBatchIdResponseOxenItemOxWeightsItem = {
  date: string;
  id: number;
  oxId: number;
  source: EnumsWeightSource;
  type: ListOxenByBatchIdResponseOxenItemOxWeightsItemType;
  weight: number;
};

export type ListOxenByBatchIdResponseOxenItemOxStartOfTreatment = string | null;

export type ListOxenByBatchIdResponseOxenItemOxSisbov = string | null;

export type ListOxenByBatchIdResponseOxenItemOxSalesMarketType =
  EnumsSalesMarketType | null;

export type ListOxenByBatchIdResponseOxenItemOxReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListOxenByBatchIdResponseOxenItemOxReversedDeathDetails =
  | string
  | null;

export type ListOxenByBatchIdResponseOxenItemOxReversedDeathDate =
  | string
  | null;

export type ListOxenByBatchIdResponseOxenItemOxReversedDeathCause =
  EnumsDeathCause | null;

export type ListOxenByBatchIdResponseOxenItemOxPurchaseId = number | null;

export type ListOxenByBatchIdResponseOxenItemOxPriceAtSignExit = number | null;

export type ListOxenByBatchIdResponseOxenItemOxPriceAtSignEntry = number | null;

export type ListOxenByBatchIdResponseOxenItemOxOtherDeathCause = string | null;

export type ListOxenByBatchIdResponseOxenItemOxIsNecropsyPerformed =
  | boolean
  | null;

export type ListOxenByBatchIdResponseOxenItemOxInvoice = string | null;

export type ListOxenByBatchIdResponseOxenItemOxInternalSaleId = number | null;

export type ListOxenByBatchIdResponseOxenItemOxIntermediateWeightsItem = {
  date: string;
  weight: number;
};

export type ListOxenByBatchIdResponseOxenItemOxIdentifier = string | null;

export type ListOxenByBatchIdResponseOxenItemOxIdentifiedAt = string | null;

export type ListOxenByBatchIdResponseOxenItemOxIdentificationSource =
  EnumsIdentificationSource | null;

export type ListOxenByBatchIdResponseOxenItemOxHasBirthAnnouncement =
  | boolean
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaId = number | null;

export type ListOxenByBatchIdResponseOxenItemOx = {
  birth: string;
  blockedUntil: string;
  bndTracked: ListOxenByBatchIdResponseOxenItemOxBndTracked;
  bornOnFarm: ListOxenByBatchIdResponseOxenItemOxBornOnFarm;
  breed: string;
  carcass: ListOxenByBatchIdResponseOxenItemOxCarcass;
  carcassPrice: ListOxenByBatchIdResponseOxenItemOxCarcassPrice;
  carcassType: ListOxenByBatchIdResponseOxenItemOxCarcassType;
  carcassWeight: ListOxenByBatchIdResponseOxenItemOxCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: ListOxenByBatchIdResponseOxenItemOxCattleManifestId;
  certifierDate: ListOxenByBatchIdResponseOxenItemOxCertifierDate;
  comments: ListOxenByBatchIdResponseOxenItemOxComments;
  deathCause: ListOxenByBatchIdResponseOxenItemOxDeathCause;
  deathDetails: ListOxenByBatchIdResponseOxenItemOxDeathDetails;
  deathNecropsy: ListOxenByBatchIdResponseOxenItemOxDeathNecropsy;
  deathReason: ListOxenByBatchIdResponseOxenItemOxDeathReason;
  dentitionStage: ListOxenByBatchIdResponseOxenItemOxDentitionStage;
  diedAt: ListOxenByBatchIdResponseOxenItemOxDiedAt;
  electronic: ListOxenByBatchIdResponseOxenItemOxElectronic;
  exitTruckId: ListOxenByBatchIdResponseOxenItemOxExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gta: ListOxenByBatchIdResponseOxenItemOxGta;
  gtaId: ListOxenByBatchIdResponseOxenItemOxGtaId;
  hasBirthAnnouncement: ListOxenByBatchIdResponseOxenItemOxHasBirthAnnouncement;
  id: number;
  identificationSource: ListOxenByBatchIdResponseOxenItemOxIdentificationSource;
  identifiedAt: ListOxenByBatchIdResponseOxenItemOxIdentifiedAt;
  identifier: ListOxenByBatchIdResponseOxenItemOxIdentifier;
  includedAt: string;
  intermediateWeights: ListOxenByBatchIdResponseOxenItemOxIntermediateWeightsItem[];
  internalSaleId: ListOxenByBatchIdResponseOxenItemOxInternalSaleId;
  invoice: ListOxenByBatchIdResponseOxenItemOxInvoice;
  isNecropsyPerformed: ListOxenByBatchIdResponseOxenItemOxIsNecropsyPerformed;
  otherDeathCause: ListOxenByBatchIdResponseOxenItemOxOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: ListOxenByBatchIdResponseOxenItemOxPriceAtSignEntry;
  priceAtSignExit: ListOxenByBatchIdResponseOxenItemOxPriceAtSignExit;
  purchaseId: ListOxenByBatchIdResponseOxenItemOxPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: ListOxenByBatchIdResponseOxenItemOxReversedDeathCause;
  reversedDeathDate: ListOxenByBatchIdResponseOxenItemOxReversedDeathDate;
  reversedDeathDetails: ListOxenByBatchIdResponseOxenItemOxReversedDeathDetails;
  reversedDeathNecropsy: ListOxenByBatchIdResponseOxenItemOxReversedDeathNecropsy;
  runtime: number;
  salesMarketType: ListOxenByBatchIdResponseOxenItemOxSalesMarketType;
  sisbov: ListOxenByBatchIdResponseOxenItemOxSisbov;
  sisbovHistory: string[];
  startOfTreatment: ListOxenByBatchIdResponseOxenItemOxStartOfTreatment;
  variety: string;
  weights: ListOxenByBatchIdResponseOxenItemOxWeightsItem[];
};

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfWeightingMapId =
  | number
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfWeightAverage =
  | number
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseId =
  | number
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchase =
  ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOf | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOf = {
  completed: boolean;
  description: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfDescription;
  destinyId: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfDestinyId;
  distance: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfHours;
  id: number;
  invoice: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfInvoice;
  number: string;
  origin: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOrigin;
  originId: number;
  originWeightAverage: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOriginWeightAverage;
  purchase: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchase;
  purchaseId: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseId;
  series: string;
  weightAverage: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfWeightAverage;
  weightingMapId: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfWeightingMapId;
};

export type ListOxenByBatchIdResponseOxenItemOxGta =
  ListOxenByBatchIdResponseOxenItemOxGtaAnyOf | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfWeighingAt =
  string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfPurchase = {
  name: string;
};

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfPartnerId =
  | number
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOxenAmount =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerPhone =
  string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerDocument =
  string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerDescription =
  string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerCode =
  | string
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwner = {
  code: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerCode;
  createdAt: string;
  description: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerDescription;
  document: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwnerPhone;
  profiles: EnumsProfile[];
};

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMapa =
  | string
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleProducedPrice =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleFutureAnimalPrice =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleEntryCarcassYield =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleDailyPrice =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleProducedPrice =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleFutureAnimalPrice =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleEntryCarcassYield =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleDailyPrice =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfDiscountPercent =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOf = {
  buyer: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyer;
  buyerId: number;
  commission: number;
  discountPercent: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfDiscountPercent;
  femaleDailyPrice: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleDailyPrice;
  femaleEntryCarcassYield: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleFutureAnimalPrice;
  femaleProducedPrice: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfFemaleProducedPrice;
  id: number;
  maleDailyPrice: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleDailyPrice;
  maleEntryCarcassYield: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleEntryCarcassYield;
  maleFutureAnimalPrice: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleFutureAnimalPrice;
  maleProducedPrice: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMaleProducedPrice;
  mapa: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfMapa;
  owner: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOwner;
  ownerId: number;
  oxenAmount: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfOxenAmount;
  partnerId: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfPartnerId;
  purchase: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfPurchase;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfWeighingAt;
  weightAverage: number;
};

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerPhone =
  string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerDocument =
  string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerDescription =
  string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerCode =
  | string
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyer = {
  code: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerCode;
  createdAt: string;
  description: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerDescription;
  document: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfPurchaseAnyOfBuyerPhone;
  profiles: EnumsProfile[];
};

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOriginWeightAverage =
  | number
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOriginCode =
  | string
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOriginCattleManifestLayoutId =
  number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOrigin = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOriginCattleManifestLayoutId;
  code: ListOxenByBatchIdResponseOxenItemOxGtaAnyOfOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsibleId: number;
};

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfInvoice = string | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfHours = number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfDistance = number | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfDestinyId =
  | number
  | null;

export type ListOxenByBatchIdResponseOxenItemOxGtaAnyOfDescription =
  | string
  | null;

export type ListOxenByBatchIdResponseOxenItemOxExitTruckId = number | null;

export type ListOxenByBatchIdResponseOxenItemOxElectronic = string | null;

export type ListOxenByBatchIdResponseOxenItemOxDiedAt = string | null;

export type ListOxenByBatchIdResponseOxenItemOxDentitionStage =
  EnumsDentitionStage | null;

export type ListOxenByBatchIdResponseOxenItemOxDeathReason =
  EnumsDeathCause | null;

export type ListOxenByBatchIdResponseOxenItemOxDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListOxenByBatchIdResponseOxenItemOxDeathDetails = string | null;

export type ListOxenByBatchIdResponseOxenItemOxDeathCause =
  EnumsDeathCause | null;

export type ListOxenByBatchIdResponseOxenItemOxComments = string | null;

export type ListOxenByBatchIdResponseOxenItemOxCertifierDate = string | null;

export type ListOxenByBatchIdResponseOxenItemOxCattleManifestId = number | null;

export type ListOxenByBatchIdResponseOxenItemOxCarcassWeight = number | null;

export type ListOxenByBatchIdResponseOxenItemOxCarcassType =
  EnumsCarcassType | null;

export type ListOxenByBatchIdResponseOxenItemOxCarcassPrice = number | null;

export type ListOxenByBatchIdResponseOxenItemOxCarcass = number | null;

export type ListOxenByBatchIdResponseOxenItemOxBornOnFarm = boolean | null;

export type ListOxenByBatchIdResponseOxenItemOxBndTracked = boolean | null;

export type ListOxenByBatchIdResponseOperationalCostGroupId = number | null;

export type ListOxenByBatchIdResponseOldCorralId = number | null;

export type ListOxenByBatchIdResponseHideFromTreatmentUntil = string | null;

export type ListOxenByBatchIdResponseHideFromTreatment = boolean | null;

export type ListOxenByBatchIdResponseForeseenSlaughterDate = string | null;

export type ListOxenByBatchIdResponseFinalizedAt = string | null;

export type ListOxenByBatchIdResponseDietsItemDiet = {
  name: string;
};

export type ListOxenByBatchIdResponseDietsItem = {
  diet: ListOxenByBatchIdResponseDietsItemDiet;
};

export type ListOxenByBatchIdResponseDescrption = string | null;

export type ListOxenByBatchIdResponseCorralId = number | null;

export type ListOxenByBatchIdResponseCorralAnyOfPosition = number | null;

export type ListOxenByBatchIdResponseCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: ListOxenByBatchIdResponseCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type ListOxenByBatchIdResponseCorral =
  ListOxenByBatchIdResponseCorralAnyOf | null;

export type ListOxenByBatchIdResponseCarcassUniform = number | null;

export type ListOxenByBatchIdResponseCarcassThin = number | null;

export type ListOxenByBatchIdResponseCarcassMissing = number | null;

export type ListOxenByBatchIdResponseCarcassMedium = number | null;

export type ListOxenByBatchIdResponseCarcassExcessive = number | null;

export type ListOxenByBatchIdResponseAdjustedPurchaseCost = number | null;

export type ListOxenByBatchIdResponseActivationEditedAt = string | null;

export type ListOxenByBatchIdResponseActivatedAt = string | null;

export type ListOxPerformanceResponse = ListOxPerformanceResponseItem[];

export type ListOxPerformanceResponseItemUpdatedById = number | null;

export type ListOxPerformanceResponseItemUpdatedAt = string | null;

export type ListOxPerformanceResponseItemCreatedById = number | null;

export type ListOxPerformanceResponseItem = {
  createdAt: string;
  createdById: ListOxPerformanceResponseItemCreatedById;
  exitCarcassYield: number;
  exitWeight: number;
  farmId: number;
  gender: EnumsOxGender;
  gmd: number;
  id: number;
  minimumEntryWeight: number;
  referenceDays: number;
  slaughterWeight: number;
  updatedAt: ListOxPerformanceResponseItemUpdatedAt;
  updatedById: ListOxPerformanceResponseItemUpdatedById;
};

export interface ListOxMovementHistoryResponse {
  editableCount: number;
  limit: number;
  page: number;
  rows: OxMovementHistoryRow[];
  total: number;
}

export type ListOxMovementHistoryQueryGender =
  (typeof ListOxMovementHistoryQueryGender)[keyof typeof ListOxMovementHistoryQueryGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListOxMovementHistoryQueryGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export interface ListOxMovementHistoryQuery {
  animalSearch?: string;
  availability?: OxMovementAvailabilityFilter;
  breed?: string;
  destBatchId?: number;
  destCorralId?: number;
  end?: string;
  gender?: ListOxMovementHistoryQueryGender;
  limit?: number;
  movementKind?: OxMovementKind;
  originBatchId?: number;
  originCorralId?: number;
  ownerId?: number;
  page?: number;
  purchaseId?: number;
  start?: string;
}

export type ListOtherDeathCauseResponseItem = {
  active: boolean;
  id: number;
  name: string;
};

export type ListOtherDeathCauseResponse = ListOtherDeathCauseResponseItem[];

export interface ListOperationalCostGroupsResponse {
  groups: ListOperationalCostGroupsResponseGroupsItem[];
}

export type ListOperationalCostGroupsResponseGroupsItemType =
  (typeof ListOperationalCostGroupsResponseGroupsItemType)[keyof typeof ListOperationalCostGroupsResponseGroupsItemType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListOperationalCostGroupsResponseGroupsItemType = {
  FIXED: "FIXED",
  CUSTOM: "CUSTOM",
} as const;

export type ListOperationalCostGroupsResponseGroupsItemBatchesItem = {
  id: number;
  name: string;
};

export type ListOperationalCostGroupsResponseGroupsItem = {
  batches: ListOperationalCostGroupsResponseGroupsItemBatchesItem[];
  createdAt: string;
  id: number;
  type: ListOperationalCostGroupsResponseGroupsItemType;
  year: number;
};

export type ListOfGtasForChargebackResponseItemWeightingMapReferenceCode =
  | string
  | null;

export type ListOfGtasForChargebackResponseItemWeightingMapId = number | null;

export type ListOfGtasForChargebackResponseItemOxItem = {
  femaleAlive?: number;
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleAlive?: number;
  maleManaged: number;
  maleTotal: number;
  yearsOld: number;
};

export type ListOfGtasForChargebackResponseItem = {
  id: number;
  number: string;
  ox: ListOfGtasForChargebackResponseItemOxItem[];
  purchaseId?: number;
  purchaseName?: string;
  totalAnimals: number;
  varieties: string[];
  weightingMapId: ListOfGtasForChargebackResponseItemWeightingMapId;
  weightingMapReferenceCode: ListOfGtasForChargebackResponseItemWeightingMapReferenceCode;
};

export type ListOfGtasForChargebackResponse =
  ListOfGtasForChargebackResponseItem[];

export interface ListOccurrencesResponse {
  items: ListOccurrencesResponseItemsItem[];
  next?: number;
  previous?: number;
}

export type ListOccurrencesResponseItemsItemStockChangeId = number | null;

export type ListOccurrencesResponseItemsItemOldFactor = number | null;

export type ListOccurrencesResponseItemsItemNewFactor = number | null;

export type ListOccurrencesResponseItemsItemName = string | null;

export type ListOccurrencesResponseItemsItemBatchesItem = {
  id: number;
  name: string;
};

export type ListOccurrencesResponseItemsItem = {
  batches: ListOccurrencesResponseItemsItemBatchesItem[];
  category: EnumsOccurrenceCategory;
  date: string;
  description: string;
  farmId: number;
  id: number;
  name: ListOccurrencesResponseItemsItemName;
  newFactor: ListOccurrencesResponseItemsItemNewFactor;
  oldFactor: ListOccurrencesResponseItemsItemOldFactor;
  stockChangeId: ListOccurrencesResponseItemsItemStockChangeId;
  type: EnumsOccurrenceType;
};

export interface ListOccurrencesQuery {
  end?: string;
  limit?: number;
  page?: number;
  start?: string;
}

export type ListOccurrencesByBatchIdResponseItemStockChangeId = number | null;

export type ListOccurrencesByBatchIdResponseItemOldFactor = number | null;

export type ListOccurrencesByBatchIdResponseItemNewFactor = number | null;

export type ListOccurrencesByBatchIdResponseItemName = string | null;

export type ListOccurrencesByBatchIdResponseItemBatchesItem = {
  id: number;
  name: string;
};

export type ListOccurrencesByBatchIdResponseItem = {
  batches: ListOccurrencesByBatchIdResponseItemBatchesItem[];
  category: EnumsOccurrenceCategory;
  date: string;
  description: string;
  farmId: number;
  id: number;
  name: ListOccurrencesByBatchIdResponseItemName;
  newFactor: ListOccurrencesByBatchIdResponseItemNewFactor;
  oldFactor: ListOccurrencesByBatchIdResponseItemOldFactor;
  stockChangeId: ListOccurrencesByBatchIdResponseItemStockChangeId;
  type: EnumsOccurrenceType;
};

export type ListOccurrencesByBatchIdResponse =
  ListOccurrencesByBatchIdResponseItem[];

export type ListMixersResponseItem = {
  active: boolean;
  code: number;
  createdAt: string;
  distributor: boolean;
  farmId: number;
  id: number;
  mixer: boolean;
  mixerType: EnumsMixerType;
  mixTime: string;
  name: string;
  rounding: number;
};

export type ListMixersResponse = ListMixersResponseItem[];

export type ListManagementSessionsResponseItemFinishedById = number | null;

export type ListManagementSessionsResponseItem = {
  createdAt: string;
  data: unknown;
  farmId: number;
  finishedById: ListManagementSessionsResponseItemFinishedById;
  id: number;
  name: string;
  status: EnumsManagementStatus;
  type: EnumsTypeManagement;
  updatedAt: string;
  uuid: string;
};

export type ListManagementSessionsResponse =
  ListManagementSessionsResponseItem[];

export interface ListManagementSessionsQuery {
  status?: EnumsManagementStatus;
}

/**
 * Última pesagem já existente antes da atual (comprovante pesagem intermediária).
 */
export type ListManagementSessionExtractAnimalsResponseItemWeightPrevious =
  | number
  | null;

export type ListManagementSessionExtractAnimalsResponseItemWeight =
  | number
  | null;

export type ListManagementSessionExtractAnimalsResponseItemTruckLabel =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemSortingLabel =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemSisbov =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemOxId = number | null;

export type ListManagementSessionExtractAnimalsResponseItemOriginCorralName =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemManagementListId =
  | number
  | null;

export type ListManagementSessionExtractAnimalsResponseItemGtaLabel =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemGender =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemCorralName =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemBreed =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemBatchOriginName =
  | string
  | null;

export type ListManagementSessionExtractAnimalsResponseItemAuditManagementId =
  | number
  | null;

export interface ListManagementSessionExtractAnimalsResponseItem {
  auditManagementId: ListManagementSessionExtractAnimalsResponseItemAuditManagementId;
  batchOriginName?: ListManagementSessionExtractAnimalsResponseItemBatchOriginName;
  breed: ListManagementSessionExtractAnimalsResponseItemBreed;
  corralName: ListManagementSessionExtractAnimalsResponseItemCorralName;
  createdAt: string;
  electronic: string;
  gender: ListManagementSessionExtractAnimalsResponseItemGender;
  gtaLabel?: ListManagementSessionExtractAnimalsResponseItemGtaLabel;
  id: number;
  managementListId: ListManagementSessionExtractAnimalsResponseItemManagementListId;
  originCorralName?: ListManagementSessionExtractAnimalsResponseItemOriginCorralName;
  oxId: ListManagementSessionExtractAnimalsResponseItemOxId;
  sisbov: ListManagementSessionExtractAnimalsResponseItemSisbov;
  sortingLabel?: ListManagementSessionExtractAnimalsResponseItemSortingLabel;
  source: EnumsManagementSessionExtractLineSource;
  truckLabel?: ListManagementSessionExtractAnimalsResponseItemTruckLabel;
  weight: ListManagementSessionExtractAnimalsResponseItemWeight;
  /** Última pesagem já existente antes da atual (comprovante pesagem intermediária). */
  weightPrevious: ListManagementSessionExtractAnimalsResponseItemWeightPrevious;
}

export type ListManagementSessionExtractAnimalsResponse =
  ListManagementSessionExtractAnimalsResponseItem[];

export type ListManagedBatchesResponseItemManagedAt = string | null;

export type ListManagedBatchesResponseItem = {
  batchId: number;
  batchName: string;
  corralName?: string;
  managedAt: ListManagedBatchesResponseItemManagedAt;
};

export type ListManagedBatchesResponse = ListManagedBatchesResponseItem[];

export type ListLogsResponse = ListLogsResponseItem[];

export type ListLogsResponseItemUserId = number | null;

export type ListLogsResponseItemUserAnyOf = {
  name: string;
};

export type ListLogsResponseItemUser = ListLogsResponseItemUserAnyOf | null;

export type ListLogsResponseItemError = string | null;

export type ListLogsResponseItem = {
  category: EnumsLogCategory;
  createdAt: string;
  details: unknown;
  error: ListLogsResponseItemError;
  farmId: number;
  id: number;
  message: string;
  type: EnumsLogType;
  user: ListLogsResponseItemUser;
  userId: ListLogsResponseItemUserId;
};

export type ListInvoicesResponse = ListInvoicesResponseItem[];

export type ListInvoicesResponseItemWeightingMapId = number | null;

export type ListInvoicesResponseItemSaleOrderId = number | null;

export type ListInvoicesResponseItemIsComplement = boolean | null;

export type ListInvoicesResponseItemExitTruckId = number | null;

export type ListInvoicesResponseItemExitTruck =
  ListInvoicesResponseItemExitTruckAnyOf | null;

export type ListInvoicesResponseItem = {
  emittedAt: ListInvoicesResponseItemEmittedAt;
  exitTruck: ListInvoicesResponseItemExitTruck;
  exitTruckId: ListInvoicesResponseItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: ListInvoicesResponseItemIsComplement;
  number: string;
  saleOrderId: ListInvoicesResponseItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: ListInvoicesResponseItemWeightingMapId;
};

export type ListInvoicesResponseItemExitTruckAnyOfSaleOrderId = number | null;

export type ListInvoicesResponseItemExitTruckAnyOfSaleId = number | null;

export type ListInvoicesResponseItemExitTruckAnyOfPlate = string | null;

export type ListInvoicesResponseItemExitTruckAnyOfName = string | null;

export type ListInvoicesResponseItemExitTruckAnyOfInfo = string | null;

export type ListInvoicesResponseItemExitTruckAnyOfHoldingSaleId = number | null;

export type ListInvoicesResponseItemExitTruckAnyOfExitGtaSeries = string | null;

export type ListInvoicesResponseItemExitTruckAnyOfExitGta = string | null;

export type ListInvoicesResponseItemExitTruckAnyOfDestinyId = number | null;

export type ListInvoicesResponseItemExitTruckAnyOfBigWeighingMachineWeightKg =
  | number
  | null;

export type ListInvoicesResponseItemExitTruckAnyOfAnnouncementId =
  | number
  | null;

export type ListInvoicesResponseItemExitTruckAnyOf = {
  announcementId: ListInvoicesResponseItemExitTruckAnyOfAnnouncementId;
  bigWeighingMachineWeightKg: ListInvoicesResponseItemExitTruckAnyOfBigWeighingMachineWeightKg;
  capacity: number;
  destinyId: ListInvoicesResponseItemExitTruckAnyOfDestinyId;
  exitAt: string;
  exitGta: ListInvoicesResponseItemExitTruckAnyOfExitGta;
  exitGtaSeries: ListInvoicesResponseItemExitTruckAnyOfExitGtaSeries;
  farmId: number;
  holdingSaleId: ListInvoicesResponseItemExitTruckAnyOfHoldingSaleId;
  id: number;
  info: ListInvoicesResponseItemExitTruckAnyOfInfo;
  isVisible: boolean;
  name: ListInvoicesResponseItemExitTruckAnyOfName;
  plate: ListInvoicesResponseItemExitTruckAnyOfPlate;
  reason: EnumsExitReason;
  saleId: ListInvoicesResponseItemExitTruckAnyOfSaleId;
  saleOrderId: ListInvoicesResponseItemExitTruckAnyOfSaleOrderId;
  status: EnumsExitTruckStatus;
};

export type ListInvoicesResponseItemEmittedAt = string | null;

export type ListInvalidBeatRealizedsResponse = InvalidRealizedDietResult[];

export type ListInternalSalesResponse = ListInternalSalesResponseItem[];

export type ListInternalSalesResponseItemOwner = {
  name: string;
};

export type ListInternalSalesResponseItemName = string | null;

export type ListInternalSalesResponseItemAtSalePrice = number | null;

export type ListInternalSalesResponseItem = {
  atSalePrice: ListInternalSalesResponseItemAtSalePrice;
  createdAt: string;
  farmId: number;
  gtas: string[];
  id: number;
  name: ListInternalSalesResponseItemName;
  originalOwners: string[];
  owner: ListInternalSalesResponseItemOwner;
  ownerId: number;
  totalOxen: number;
  updatedAt: string;
};

export type ListHoldingSalesResponseItemName = string | null;

export type ListHoldingSalesResponseItem = {
  batches: string[];
  date: string;
  destiny?: string;
  exitWeightAverage?: number;
  id: number;
  name: ListHoldingSalesResponseItemName;
  oxenAmount?: number;
  truckCount: number;
};

export type ListHoldingSalesResponse = ListHoldingSalesResponseItem[];

export interface ListHoldingSalesFilters {
  batchName?: string;
  endDate?: string;
  maxExitWeightAverage?: number;
  maxOxenAmount?: number;
  maxTruckCount?: number;
  minExitWeightAverage?: number;
  minOxenAmount?: number;
  minTruckCount?: number;
  startDate?: string;
}

export type ListHoldingBatchesResponse = ListHoldingBatchesResponseItem[];

export type ListHoldingBatchesResponseItemWeightingMapReferenceCode =
  | string
  | null;

export type ListHoldingBatchesResponseItemCorralName = string | null;

export type ListHoldingBatchesResponseItem = {
  batchId: number;
  batchName: string;
  corralName: ListHoldingBatchesResponseItemCorralName;
  entryDate: string;
  oxenAmount: number;
  purchaseId: number;
  purchaseName: string;
  weightingMapReferenceCode: ListHoldingBatchesResponseItemWeightingMapReferenceCode;
};

export type ListHealthProtocolsResponseItem = {
  active: boolean;
  id: number;
  medicines: ListHealthProtocolsResponseItemMedicinesItem[];
  name: string;
};

export type ListHealthProtocolsResponse = ListHealthProtocolsResponseItem[];

export type ListHealthProtocolsResponseItemMedicinesItemPerKg = number | null;

export type ListHealthProtocolsResponseItemMedicinesItemKiloDose =
  | number
  | null;

export type ListHealthProtocolsResponseItemMedicinesItemApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export type ListHealthProtocolsResponseItemMedicinesItem = {
  active: boolean;
  applicationSuggestion: ListHealthProtocolsResponseItemMedicinesItemApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: ListHealthProtocolsResponseItemMedicinesItemKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: ListHealthProtocolsResponseItemMedicinesItemPerKg;
  type: EnumsMedicineType;
};

export interface ListGtasWithForeseenResponse {
  averageEntryDate: string;
  averageEntryWeight: number;
  averageGmd: number;
  averageProcessingWeight: number;
  averageProjectedWeight: number;
  daysSinceEmission: number;
  femaleTotal: number;
  gtaEmissionDate: string;
  gtaId: number;
  gtaNumber: string;
  maleTotal: number;
  owners: string;
  purchase: string;
  today: string;
  totalProjectedWeight: number;
}

export type ListGtasResponse = ListGtasResponseItem[];

export type ListGtasResponseItemWeightingMapId = number | null;

export type ListGtasResponseItemWeightingMap = string | null;

export type ListGtasResponseItemWeightAverage = number | null;

export type ListGtasResponseItemPurchaseId = number | null;

export type ListGtasResponseItemOriginWeightAverage = number | null;

export type ListGtasResponseItemOriginState = string | null;

export type ListGtasResponseItem = {
  ages: ListGtasResponseItemAgesItem[];
  announcementId?: number;
  announcementNumber: ListGtasResponseItemAnnouncementNumber;
  completed: boolean;
  description: ListGtasResponseItemDescription;
  destiny: ListGtasResponseItemDestiny;
  destinyId: ListGtasResponseItemDestinyId;
  distance: ListGtasResponseItemDistance;
  emission: string;
  entry: string;
  entryDate: string;
  expiration: string;
  farm: ListGtasResponseItemFarm;
  farmId: number;
  hours: ListGtasResponseItemHours;
  id: number;
  invoice: ListGtasResponseItemInvoice;
  number: string;
  origin: ListGtasResponseItemOrigin;
  originId: number;
  originState: ListGtasResponseItemOriginState;
  originWeightAverage: ListGtasResponseItemOriginWeightAverage;
  oxenManagedTotal: number;
  oxenProcessedTotal: number;
  oxenSisbovProcessedTotal: number;
  oxenSisbovTotal: number;
  oxenSystemTotal: number;
  oxenTotal: number;
  purchase?: string;
  purchaseId: ListGtasResponseItemPurchaseId;
  remainingDays: number;
  series: string;
  weightAverage: ListGtasResponseItemWeightAverage;
  weightingMap?: ListGtasResponseItemWeightingMap;
  weightingMapId: ListGtasResponseItemWeightingMapId;
};

export type ListGtasResponseItemOriginResponsiblePhone = string | null;

export type ListGtasResponseItemOriginResponsibleDocument = string | null;

export type ListGtasResponseItemOriginResponsibleDescription = string | null;

export type ListGtasResponseItemOriginResponsibleCode = string | null;

export type ListGtasResponseItemOriginResponsible = {
  code: ListGtasResponseItemOriginResponsibleCode;
  createdAt: string;
  description: ListGtasResponseItemOriginResponsibleDescription;
  document: ListGtasResponseItemOriginResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListGtasResponseItemOriginResponsiblePhone;
  profiles: EnumsProfile[];
};

export type ListGtasResponseItemOrigin = {
  name: string;
  responsible: ListGtasResponseItemOriginResponsible;
};

export type ListGtasResponseItemInvoice = string | null;

export type ListGtasResponseItemHours = number | null;

export type ListGtasResponseItemFarm = {
  day: string;
  name: string;
};

export type ListGtasResponseItemDistance = number | null;

export type ListGtasResponseItemDestinyId = number | null;

export type ListGtasResponseItemDestiny =
  ListGtasResponseItemDestinyAnyOf | null;

export type ListGtasResponseItemDestinyAnyOfResponsiblePhone = string | null;

export type ListGtasResponseItemDestinyAnyOfResponsibleDocument = string | null;

export type ListGtasResponseItemDestinyAnyOfResponsibleDescription =
  | string
  | null;

export type ListGtasResponseItemDestinyAnyOfResponsibleCode = string | null;

export type ListGtasResponseItemDestinyAnyOfResponsible = {
  code: ListGtasResponseItemDestinyAnyOfResponsibleCode;
  createdAt: string;
  description: ListGtasResponseItemDestinyAnyOfResponsibleDescription;
  document: ListGtasResponseItemDestinyAnyOfResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListGtasResponseItemDestinyAnyOfResponsiblePhone;
  profiles: EnumsProfile[];
};

export type ListGtasResponseItemDestinyAnyOf = {
  name: string;
  responsible: ListGtasResponseItemDestinyAnyOfResponsible;
};

export type ListGtasResponseItemDescription = string | null;

export type ListGtasResponseItemAnnouncementNumber = string | null;

export type ListGtasResponseItemAgesItemOxenItem = {
  birth: string;
  id: number;
};

export type ListGtasResponseItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  oxen: ListGtasResponseItemAgesItemOxenItem[];
  yearsOld: number;
};

export type ListGtasFromNDaysAgoResponse = ListGtasFromNDaysAgoResponseItem[];

export type ListGtasFromNDaysAgoResponseItemTotalProjectedWeight =
  | number
  | null;

export type ListGtasFromNDaysAgoResponseItemOxenItem = {
  gender: string;
  gtaId: number;
  id: number;
};

export type ListGtasFromNDaysAgoResponseItemAverageProjectedWeight =
  | number
  | null;

export type ListGtasFromNDaysAgoResponseItemAverageEntryWeight = number | null;

export type ListGtasFromNDaysAgoResponseItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  maleManaged: number;
  maleTotal: number;
};

export type ListGtasFromNDaysAgoResponseItem = {
  ages: ListGtasFromNDaysAgoResponseItemAgesItem[];
  averageEntryWeight: ListGtasFromNDaysAgoResponseItemAverageEntryWeight;
  averageProjectedWeight: ListGtasFromNDaysAgoResponseItemAverageProjectedWeight;
  batchesIds: number[];
  completed: boolean;
  daysSinceEmission: number;
  id: number;
  number: string;
  oxen: ListGtasFromNDaysAgoResponseItemOxenItem[];
  totalProjectedWeight: ListGtasFromNDaysAgoResponseItemTotalProjectedWeight;
};

export type ListGtasFromNDaysAgoRequestBodyDateCount = number | 50;

export interface ListGtasFromNDaysAgoRequestBody {
  dateCount: ListGtasFromNDaysAgoRequestBodyDateCount;
  getAverageEntryWeight?: boolean;
  getAverageProjectedWeight?: boolean;
  ownerId: number;
}

export type ListGtasFromNDaysAgoRepositoryOutputOxenItem = {
  gender: string;
  gtaId: number;
  id: number;
};

export type ListGtasFromNDaysAgoRepositoryOutputAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  maleManaged: number;
  maleTotal: number;
};

export interface ListGtasFromNDaysAgoRepositoryOutput {
  ages: ListGtasFromNDaysAgoRepositoryOutputAgesItem[];
  batchesIds: number[];
  completed: boolean;
  daysSinceEmission: number;
  id: number;
  number: string;
  oxen: ListGtasFromNDaysAgoRepositoryOutputOxenItem[];
}

export type ListGtasByPurchaseIdResponse = ListGtasByPurchaseIdResponseItem[];

export type ListGtasByPurchaseIdResponseItemWeightingMapId = number | null;

export type ListGtasByPurchaseIdResponseItemWeightAverage = number | null;

export type ListGtasByPurchaseIdResponseItemPurchaseId = number | null;

export type ListGtasByPurchaseIdResponseItemOriginWeightAverage = number | null;

export type ListGtasByPurchaseIdResponseItemInvoice = string | null;

export type ListGtasByPurchaseIdResponseItemHours = number | null;

export type ListGtasByPurchaseIdResponseItemDistance = number | null;

export type ListGtasByPurchaseIdResponseItemDestinyId = number | null;

export type ListGtasByPurchaseIdResponseItemDescription = string | null;

export type ListGtasByPurchaseIdResponseItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  yearsOld: number;
};

export type ListGtasByPurchaseIdResponseItem = {
  ages: ListGtasByPurchaseIdResponseItemAgesItem[];
  completed: boolean;
  description: ListGtasByPurchaseIdResponseItemDescription;
  destinyId: ListGtasByPurchaseIdResponseItemDestinyId;
  distance: ListGtasByPurchaseIdResponseItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: ListGtasByPurchaseIdResponseItemHours;
  id: number;
  invoice: ListGtasByPurchaseIdResponseItemInvoice;
  number: string;
  originId: number;
  originWeightAverage: ListGtasByPurchaseIdResponseItemOriginWeightAverage;
  purchaseId: ListGtasByPurchaseIdResponseItemPurchaseId;
  series: string;
  weightAverage: ListGtasByPurchaseIdResponseItemWeightAverage;
  weightingMapId: ListGtasByPurchaseIdResponseItemWeightingMapId;
};

export interface ListGeneralLogsResponse {
  logs: GeneralLogItem[];
}

export interface ListFinalizedBatchesResponse {
  items: ListFinalizedBatchesResponseItemsItem[];
  next?: number;
  previous?: number;
}

export type ListFinalizedBatchesResponseItemsItemScaledToSlaughter =
  | boolean
  | null;

export type ListFinalizedBatchesResponseItemsItemOperationalCostGroupId =
  | number
  | null;

export type ListFinalizedBatchesResponseItemsItemOldCorralId = number | null;

export type ListFinalizedBatchesResponseItemsItemHideFromTreatmentUntil =
  | string
  | null;

export type ListFinalizedBatchesResponseItemsItemHideFromTreatment =
  | boolean
  | null;

export type ListFinalizedBatchesResponseItemsItemForeseenSlaughterDate =
  | string
  | null;

export type ListFinalizedBatchesResponseItemsItemFinalizedAt = string | null;

export type ListFinalizedBatchesResponseItemsItemDescrption = string | null;

export type ListFinalizedBatchesResponseItemsItemCorralId = number | null;

export type ListFinalizedBatchesResponseItemsItemCarcassUniform = number | null;

export type ListFinalizedBatchesResponseItemsItemCarcassThin = number | null;

export type ListFinalizedBatchesResponseItemsItemCarcassMissing = number | null;

export type ListFinalizedBatchesResponseItemsItemCarcassMedium = number | null;

export type ListFinalizedBatchesResponseItemsItemCarcassExcessive =
  | number
  | null;

export type ListFinalizedBatchesResponseItemsItemAdjustedPurchaseCost =
  | number
  | null;

export type ListFinalizedBatchesResponseItemsItemActivationEditedAt =
  | string
  | null;

export type ListFinalizedBatchesResponseItemsItemActivatedAt = string | null;

export type ListFinalizedBatchesResponseItemsItem = {
  activatedAt: ListFinalizedBatchesResponseItemsItemActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: ListFinalizedBatchesResponseItemsItemActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: ListFinalizedBatchesResponseItemsItemAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: ListFinalizedBatchesResponseItemsItemCarcassExcessive;
  carcassMedium: ListFinalizedBatchesResponseItemsItemCarcassMedium;
  carcassMissing: ListFinalizedBatchesResponseItemsItemCarcassMissing;
  carcassThin: ListFinalizedBatchesResponseItemsItemCarcassThin;
  carcassUniform: ListFinalizedBatchesResponseItemsItemCarcassUniform;
  corralId: ListFinalizedBatchesResponseItemsItemCorralId;
  createdAt: string;
  descrption: ListFinalizedBatchesResponseItemsItemDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: ListFinalizedBatchesResponseItemsItemFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: ListFinalizedBatchesResponseItemsItemForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: ListFinalizedBatchesResponseItemsItemHideFromTreatment;
  hideFromTreatmentUntil: ListFinalizedBatchesResponseItemsItemHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: ListFinalizedBatchesResponseItemsItemOldCorralId;
  operationalCostGroupId: ListFinalizedBatchesResponseItemsItemOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: ListFinalizedBatchesResponseItemsItemScaledToSlaughter;
};

export type ListExitTrucksResponse = ListExitTrucksResponseItem[];

export type ListExitTrucksResponseItemSaleOrderId = number | null;

export type ListExitTrucksResponseItemSaleId = number | null;

export type ListExitTrucksResponseItemPlate = string | null;

export type ListExitTrucksResponseItemName = string | null;

export type ListExitTrucksResponseItemInvoicesItemCarcassPrice = number | null;

export type ListExitTrucksResponseItemInvoicesItem = {
  carcassPrice: ListExitTrucksResponseItemInvoicesItemCarcassPrice;
  id: number;
  number: string;
  series: string;
  value: number;
};

export type ListExitTrucksResponseItemInfo = string | null;

export type ListExitTrucksResponseItemHoldingSaleId = number | null;

export type ListExitTrucksResponseItemExitGtaSeries = string | null;

export type ListExitTrucksResponseItemExitGta = string | null;

export type ListExitTrucksResponseItemDestinyId = number | null;

export type ListExitTrucksResponseItem = {
  announcementId: ListExitTrucksResponseItemAnnouncementId;
  announcementNumber: ListExitTrucksResponseItemAnnouncementNumber;
  bigWeighingMachineWeightKg: ListExitTrucksResponseItemBigWeighingMachineWeightKg;
  boarding: ListExitTrucksResponseItemBoardingItem[];
  capacity: number;
  destiny: ListExitTrucksResponseItemDestiny;
  destinyId: ListExitTrucksResponseItemDestinyId;
  exitAt: string;
  exitGta: ListExitTrucksResponseItemExitGta;
  exitGtaSeries: ListExitTrucksResponseItemExitGtaSeries;
  farmId: number;
  gtas: string[];
  holdingSaleId: ListExitTrucksResponseItemHoldingSaleId;
  id: number;
  info: ListExitTrucksResponseItemInfo;
  invoices: ListExitTrucksResponseItemInvoicesItem[];
  isVisible: boolean;
  name: ListExitTrucksResponseItemName;
  oxenAmount: number;
  oxenSisbovAmount: number;
  plate: ListExitTrucksResponseItemPlate;
  reason: EnumsExitReason;
  saleId: ListExitTrucksResponseItemSaleId;
  saleOrderId: ListExitTrucksResponseItemSaleOrderId;
  status: EnumsExitTruckStatus;
  totalWeights: number;
};

export type ListExitTrucksResponseItemDestinyAnyOfResponsible = {
  id: number;
  name: string;
};

export type ListExitTrucksResponseItemDestinyAnyOfCode = string | null;

export type ListExitTrucksResponseItemDestinyAnyOfCattleManifestLayoutId =
  | number
  | null;

export type ListExitTrucksResponseItemDestinyAnyOf = {
  active: boolean;
  address: ListExitTrucksResponseItemDestinyAnyOfAddress;
  addressId: number;
  cattleManifestLayoutId: ListExitTrucksResponseItemDestinyAnyOfCattleManifestLayoutId;
  code: ListExitTrucksResponseItemDestinyAnyOfCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: ListExitTrucksResponseItemDestinyAnyOfResponsible;
  responsibleId: number;
};

export type ListExitTrucksResponseItemDestiny =
  ListExitTrucksResponseItemDestinyAnyOf | null;

export type ListExitTrucksResponseItemDestinyAnyOfAddressStreet = string | null;

export type ListExitTrucksResponseItemDestinyAnyOfAddressNumber = string | null;

export type ListExitTrucksResponseItemDestinyAnyOfAddressNeighborhood =
  | string
  | null;

export type ListExitTrucksResponseItemDestinyAnyOfAddressComplement =
  | string
  | null;

export type ListExitTrucksResponseItemDestinyAnyOfAddress = {
  city: string;
  complement: ListExitTrucksResponseItemDestinyAnyOfAddressComplement;
  country: string;
  id: number;
  neighborhood: ListExitTrucksResponseItemDestinyAnyOfAddressNeighborhood;
  number: ListExitTrucksResponseItemDestinyAnyOfAddressNumber;
  state: string;
  street: ListExitTrucksResponseItemDestinyAnyOfAddressStreet;
  zip: string;
};

export type ListExitTrucksResponseItemBoardingItemWeightsItem = {
  oxId: number;
  weight: number;
};

export type ListExitTrucksResponseItemBoardingItemCarcassWeight = number | null;

export type ListExitTrucksResponseItemBoardingItemCarcassPrice = number | null;

export type ListExitTrucksResponseItemBoardingItem = {
  carcassPrice: ListExitTrucksResponseItemBoardingItemCarcassPrice;
  carcassWeight: ListExitTrucksResponseItemBoardingItemCarcassWeight;
  id: number;
  weights: ListExitTrucksResponseItemBoardingItemWeightsItem[];
};

export type ListExitTrucksResponseItemBigWeighingMachineWeightKg =
  | number
  | null;

export type ListExitTrucksResponseItemAnnouncementNumber = string | null;

export type ListExitTrucksResponseItemAnnouncementId = number | null;

export type ListEstablishmentsResponse = ListEstablishmentsResponseItem[];

export type ListEstablishmentsResponseItemResponsiblePhone = string | null;

export type ListEstablishmentsResponseItemResponsibleDocument = string | null;

export type ListEstablishmentsResponseItemResponsibleDescription =
  | string
  | null;

export type ListEstablishmentsResponseItemResponsibleCode = string | null;

export type ListEstablishmentsResponseItemResponsible = {
  code: ListEstablishmentsResponseItemResponsibleCode;
  createdAt: string;
  description: ListEstablishmentsResponseItemResponsibleDescription;
  document: ListEstablishmentsResponseItemResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListEstablishmentsResponseItemResponsiblePhone;
  profiles: EnumsProfile[];
};

export type ListEstablishmentsResponseItemCode = string | null;

export type ListEstablishmentsResponseItemCattleManifestLayoutId =
  | number
  | null;

export type ListEstablishmentsResponseItem = {
  active: boolean;
  address: ListEstablishmentsResponseItemAddress;
  addressId: number;
  cattleManifestLayoutId: ListEstablishmentsResponseItemCattleManifestLayoutId;
  code: ListEstablishmentsResponseItemCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: ListEstablishmentsResponseItemResponsible;
  responsibleId: number;
};

export type ListEstablishmentsResponseItemAddressStreet = string | null;

export type ListEstablishmentsResponseItemAddressNumber = string | null;

export type ListEstablishmentsResponseItemAddressNeighborhood = string | null;

export type ListEstablishmentsResponseItemAddressComplement = string | null;

export type ListEstablishmentsResponseItemAddress = {
  city: string;
  complement: ListEstablishmentsResponseItemAddressComplement;
  country: string;
  id: number;
  neighborhood: ListEstablishmentsResponseItemAddressNeighborhood;
  number: ListEstablishmentsResponseItemAddressNumber;
  state: string;
  street: ListEstablishmentsResponseItemAddressStreet;
  zip: string;
};

export type ListEstablishmentsForSalesReportResponseItem = {
  city: string;
  id: number;
  name: string;
};

export type ListEstablishmentsForSalesReportResponse =
  ListEstablishmentsForSalesReportResponseItem[];

export interface ListEarringPurchases {
  cancelleds: number[];
  completed: boolean;
  finalSisbov: number;
  initialSisbov: number;
  useds: number[];
}

export type ListEarringPurchasesResponse = ListEarringPurchases[];

export type ListDietsResponse = ListDietsResponseItem[];

export type ListDietsResponseItemPremixId = number | null;

export type ListDietsResponseItemObservation = string | null;

export type ListDietsResponseItemIngredientsItemStockPremix = boolean | null;

export type ListDietsResponseItemIngredientsItemStockChangesItemDescription =
  | string
  | null;

export type ListDietsResponseItemIngredientsItemStockChangesItem = {
  date: string;
  description: ListDietsResponseItemIngredientsItemStockChangesItemDescription;
  elg: number;
  elm: number;
  id: number;
  kiloPrice: number;
  naturalMatterFactor: number;
  stockId: number;
};

export type ListDietsResponseItemIngredientsItemStockActive = boolean | null;

export type ListDietsResponseItemIngredientsItemStock = {
  active: ListDietsResponseItemIngredientsItemStockActive;
  changes: ListDietsResponseItemIngredientsItemStockChangesItem[];
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: ListDietsResponseItemIngredientsItemStockPremix;
  supplement: boolean;
};

export type ListDietsResponseItemIngredientsItem = {
  dietId: number;
  id: number;
  percentage: number;
  rotorOrder: number;
  stock: ListDietsResponseItemIngredientsItemStock;
  stockId: number;
  topplingOrder: number;
};

export type ListDietsResponseItemFixedElg = number | null;

export type ListDietsResponseItemCode = string | null;

export type ListDietsResponseItemCategory = EnumsDietCategory | null;

export type ListDietsResponseItem = {
  active: boolean;
  category: ListDietsResponseItemCategory;
  code: ListDietsResponseItemCode;
  createdAt: string;
  elg: number;
  elm: number;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: ListDietsResponseItemFixedElg;
  id: number;
  ingredients: ListDietsResponseItemIngredientsItem[];
  isPremix: boolean;
  kiloPrice: number;
  kiloPriceDM: number;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  naturalMatterFactor: number;
  observation: ListDietsResponseItemObservation;
  premixId: ListDietsResponseItemPremixId;
};

export type ListDietsInTransitionResponseItemBatchesItem = {
  id: number;
  name: string;
};

export type ListDietsInTransitionResponseItem = {
  batches: ListDietsInTransitionResponseItemBatchesItem[];
  id: number;
  name: string;
};

export type ListDietsInTransitionResponse = ListDietsInTransitionResponseItem[];

export type ListDietTransitionsResponseItem = {
  days: GlobalPrismaJsonDietTransitionDay[];
  divisions: number;
  farmId: number;
  id: number;
  name: string;
};

export type ListDietTransitionsResponse = ListDietTransitionsResponseItem[];

export type ListDeadOxenXlsxResponseAnyOfThree = {
  buffer: null;
};

export type ListDeadOxenXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type ListDeadOxenXlsxResponseAnyOf = {
  buffer: ListDeadOxenXlsxResponseAnyOfBuffer;
};

export type ListDeadOxenXlsxResponse =
  | ListDeadOxenXlsxResponseAnyOf
  | ListDeadOxenXlsxResponseAnyOfThree;

export interface ListDeadOxenWithoutAnnouncementResult {
  deathCause: EnumsDeathCause;
  deathDetails: string;
  deathNecropsy: EnumsDeathNecropsy;
  deathReason: EnumsDeathCause;
  diedAt: string;
  isNecropsyPerformed: boolean;
  sisbov: string;
}

export type ListDeadOxenWithoutAnnouncementResponse =
  ListDeadOxenWithoutAnnouncementResult[];

export type ListDeadOxenResponse = ListDeadOxenResponseItem[];

export type ListDeadOxenResponseItemStartOfTreatment = string | null;

export type ListDeadOxenResponseItemSisbov = string | null;

export type ListDeadOxenResponseItemSalesMarketType =
  EnumsSalesMarketType | null;

export type ListDeadOxenResponseItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListDeadOxenResponseItemReversedDeathDetails = string | null;

export type ListDeadOxenResponseItemReversedDeathDate = string | null;

export type ListDeadOxenResponseItemReversedDeathCause = EnumsDeathCause | null;

export type ListDeadOxenResponseItemPurchaseId = number | null;

export type ListDeadOxenResponseItemOtherDeathCause = string | null;

export type ListDeadOxenResponseItemIsNecropsyPerformed = boolean | null;

export type ListDeadOxenResponseItemInvoice = string | null;

export type ListDeadOxenResponseItemInternalSaleId = number | null;

export type ListDeadOxenResponseItemIdentifier = string | null;

export type ListDeadOxenResponseItemIdentifiedAt = string | null;

export type ListDeadOxenResponseItemIdentificationSource =
  EnumsIdentificationSource | null;

export type ListDeadOxenResponseItemHasBirthAnnouncement = boolean | null;

export type ListDeadOxenResponseItemGtaId = number | null;

export type ListDeadOxenResponseItemExitTruckId = number | null;

export type ListDeadOxenResponseItemElectronic = string | null;

export type ListDeadOxenResponseItemDiedAt = string | null;

export type ListDeadOxenResponseItemDentitionStage = EnumsDentitionStage | null;

export type ListDeadOxenResponseItemDeathReason = EnumsDeathCause | null;

export type ListDeadOxenResponseItemDeathNecropsy = EnumsDeathNecropsy | null;

export type ListDeadOxenResponseItemDeathDetails = string | null;

export type ListDeadOxenResponseItemDeathCause = EnumsDeathCause | null;

export type ListDeadOxenResponseItemComments = string | null;

export type ListDeadOxenResponseItemCertifierDate = string | null;

export type ListDeadOxenResponseItemCattleManifestId = number | null;

export type ListDeadOxenResponseItemCarcassWeight = number | null;

export type ListDeadOxenResponseItemCarcassType = EnumsCarcassType | null;

export type ListDeadOxenResponseItemCarcass = number | null;

export type ListDeadOxenResponseItemBornOnFarm = boolean | null;

export type ListDeadOxenResponseItemBndTracked = boolean | null;

export type ListDeadOxenResponseItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: ListDeadOxenResponseItemBndTracked;
  bornOnFarm: ListDeadOxenResponseItemBornOnFarm;
  breed: string;
  carcass: ListDeadOxenResponseItemCarcass;
  carcassPrice: number;
  carcassType: ListDeadOxenResponseItemCarcassType;
  carcassWeight: ListDeadOxenResponseItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: ListDeadOxenResponseItemCattleManifestId;
  certifierDate: ListDeadOxenResponseItemCertifierDate;
  comments: ListDeadOxenResponseItemComments;
  deathCause: ListDeadOxenResponseItemDeathCause;
  deathDetails: ListDeadOxenResponseItemDeathDetails;
  deathNecropsy: ListDeadOxenResponseItemDeathNecropsy;
  deathReason: ListDeadOxenResponseItemDeathReason;
  dentitionStage: ListDeadOxenResponseItemDentitionStage;
  diedAt: ListDeadOxenResponseItemDiedAt;
  electronic: ListDeadOxenResponseItemElectronic;
  exitTruckId: ListDeadOxenResponseItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: ListDeadOxenResponseItemGtaId;
  hasBirthAnnouncement: ListDeadOxenResponseItemHasBirthAnnouncement;
  id: number;
  identificationSource: ListDeadOxenResponseItemIdentificationSource;
  identifiedAt: ListDeadOxenResponseItemIdentifiedAt;
  identifier: ListDeadOxenResponseItemIdentifier;
  includedAt: string;
  internalSaleId: ListDeadOxenResponseItemInternalSaleId;
  invoice: ListDeadOxenResponseItemInvoice;
  isNecropsyPerformed: ListDeadOxenResponseItemIsNecropsyPerformed;
  otherDeathCause: ListDeadOxenResponseItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: number;
  priceAtSignExit: number;
  purchaseId: ListDeadOxenResponseItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: ListDeadOxenResponseItemReversedDeathCause;
  reversedDeathDate: ListDeadOxenResponseItemReversedDeathDate;
  reversedDeathDetails: ListDeadOxenResponseItemReversedDeathDetails;
  reversedDeathNecropsy: ListDeadOxenResponseItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: ListDeadOxenResponseItemSalesMarketType;
  sisbov: ListDeadOxenResponseItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: ListDeadOxenResponseItemStartOfTreatment;
  variety: string;
};

export type ListCorralsWithoutDietResponseItemDietsItemFinalizedAt =
  | string
  | null;

export type ListCorralsWithoutDietResponseItemDietsItem = {
  batchId: number;
  createdAt: string;
  dietId: number;
  finalizedAt: ListCorralsWithoutDietResponseItemDietsItemFinalizedAt;
  id: number;
};

export type ListCorralsWithoutDietResponseItemDescrption = string | null;

export type ListCorralsWithoutDietResponseItem = {
  _count: _ListCorralsWithoutDietResponseItemCount;
  activatedAt: ListCorralsWithoutDietResponseItemActivatedAt;
  corral: ListCorralsWithoutDietResponseItemCorral;
  createdAt: string;
  descrption: ListCorralsWithoutDietResponseItemDescrption;
  diets: ListCorralsWithoutDietResponseItemDietsItem[];
  id: number;
  name: string;
};

export type ListCorralsWithoutDietResponse =
  ListCorralsWithoutDietResponseItem[];

export type ListCorralsWithoutDietResponseItemCorralAnyOf = {
  id: number;
  name: string;
};

export type ListCorralsWithoutDietResponseItemCorral =
  ListCorralsWithoutDietResponseItemCorralAnyOf | null;

export type ListCorralsWithoutDietResponseItemActivatedAt = string | null;

export type _ListCorralsWithoutDietResponseItemCount = {
  oxen: number;
};

export type ListCorralsSimplifiedResponseItemPosition = number | null;

export type ListCorralsSimplifiedResponseItemInactiveBatchesItemFinalizedAt =
  | string
  | null;

export type ListCorralsSimplifiedResponseItemInactiveBatchesItemDescrption =
  | string
  | null;

export type ListCorralsSimplifiedResponseItemInactiveBatchesItem = {
  descrption: ListCorralsSimplifiedResponseItemInactiveBatchesItemDescrption;
  finalizedAt: ListCorralsSimplifiedResponseItemInactiveBatchesItemFinalizedAt;
  id: number;
  name: string;
};

export type ListCorralsSimplifiedResponseItemBatchAnyOfDescrption =
  | string
  | null;

export type ListCorralsSimplifiedResponseItemBatchAnyOfActivatedAt =
  | string
  | null;

export type _ListCorralsSimplifiedResponseItemBatchAnyOfCount = {
  oxen: number;
};

export type ListCorralsSimplifiedResponseItemBatchAnyOf = {
  _count: _ListCorralsSimplifiedResponseItemBatchAnyOfCount;
  activatedAt: ListCorralsSimplifiedResponseItemBatchAnyOfActivatedAt;
  descrption: ListCorralsSimplifiedResponseItemBatchAnyOfDescrption;
  id: number;
  name: string;
};

export type ListCorralsSimplifiedResponseItemBatch =
  ListCorralsSimplifiedResponseItemBatchAnyOf | null;

export type ListCorralsSimplifiedResponseItem = {
  area: number;
  batch: ListCorralsSimplifiedResponseItemBatch;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  inactiveBatches: ListCorralsSimplifiedResponseItemInactiveBatchesItem[];
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: ListCorralsSimplifiedResponseItemPosition;
  type: EnumsCorralType;
};

export type ListCorralsSimplifiedResponse = ListCorralsSimplifiedResponseItem[];

export type ListCorralsAndBatchesResponse = ListCorralsAndBatchesResponseItem[];

export type ListCorralsAndBatchesResponseItemBatchAnyOf = {
  id: number;
  name: string;
};

export type ListCorralsAndBatchesResponseItemBatch =
  ListCorralsAndBatchesResponseItemBatchAnyOf | null;

export type ListCorralsAndBatchesResponseItem = {
  batch: ListCorralsAndBatchesResponseItemBatch;
  id: number;
  name: string;
};

export type ListCorralResponseItemPosition = number | null;

export type ListCorralResponseItemBatch =
  ListCorralResponseItemBatchAnyOf | null;

export type ListCorralResponseItem = {
  area: number;
  batch: ListCorralResponseItemBatch;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: ListCorralResponseItemPosition;
  troughDays: number;
  type: EnumsCorralType;
};

export type ListCorralResponse = ListCorralResponseItem[];

export type ListCorralResponseItemBatchAnyOfScaledToSlaughter = boolean | null;

export type ListCorralResponseItemBatchAnyOfOxenItemFinalizedAt = string | null;

export type ListCorralResponseItemBatchAnyOfOxenItemDescription = string | null;

export type ListCorralResponseItemBatchAnyOfOxenItem = {
  batchId: number;
  createdAt: string;
  description: ListCorralResponseItemBatchAnyOfOxenItemDescription;
  finalizedAt: ListCorralResponseItemBatchAnyOfOxenItemFinalizedAt;
  id: number;
  oxId: number;
};

export type ListCorralResponseItemBatchAnyOfOperationalCostGroupId =
  | number
  | null;

export type ListCorralResponseItemBatchAnyOfOldCorralId = number | null;

export type ListCorralResponseItemBatchAnyOfHideFromTreatmentUntil =
  | string
  | null;

export type ListCorralResponseItemBatchAnyOfHideFromTreatment = boolean | null;

export type ListCorralResponseItemBatchAnyOfForeseenSlaughterDate =
  | string
  | null;

export type ListCorralResponseItemBatchAnyOfFinalizedAt = string | null;

export type ListCorralResponseItemBatchAnyOfDescrption = string | null;

export type ListCorralResponseItemBatchAnyOfCorralId = number | null;

export type ListCorralResponseItemBatchAnyOfCarcassUniform = number | null;

export type ListCorralResponseItemBatchAnyOfCarcassThin = number | null;

export type ListCorralResponseItemBatchAnyOfCarcassMissing = number | null;

export type ListCorralResponseItemBatchAnyOfCarcassMedium = number | null;

export type ListCorralResponseItemBatchAnyOfCarcassExcessive = number | null;

export type ListCorralResponseItemBatchAnyOfAdjustedPurchaseCost =
  | number
  | null;

export type ListCorralResponseItemBatchAnyOfActivationEditedAt = string | null;

export type ListCorralResponseItemBatchAnyOfActivatedAt = string | null;

export type ListCorralResponseItemBatchAnyOf = {
  activatedAt: ListCorralResponseItemBatchAnyOfActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: ListCorralResponseItemBatchAnyOfActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: ListCorralResponseItemBatchAnyOfAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: ListCorralResponseItemBatchAnyOfCarcassExcessive;
  carcassMedium: ListCorralResponseItemBatchAnyOfCarcassMedium;
  carcassMissing: ListCorralResponseItemBatchAnyOfCarcassMissing;
  carcassThin: ListCorralResponseItemBatchAnyOfCarcassThin;
  carcassUniform: ListCorralResponseItemBatchAnyOfCarcassUniform;
  corralId: ListCorralResponseItemBatchAnyOfCorralId;
  createdAt: string;
  descrption: ListCorralResponseItemBatchAnyOfDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: ListCorralResponseItemBatchAnyOfFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: ListCorralResponseItemBatchAnyOfForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: ListCorralResponseItemBatchAnyOfHideFromTreatment;
  hideFromTreatmentUntil: ListCorralResponseItemBatchAnyOfHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: ListCorralResponseItemBatchAnyOfOldCorralId;
  operationalCostGroupId: ListCorralResponseItemBatchAnyOfOperationalCostGroupId;
  otherCost: number;
  oxen: ListCorralResponseItemBatchAnyOfOxenItem[];
  oxFinancing: boolean;
  scaledToSlaughter: ListCorralResponseItemBatchAnyOfScaledToSlaughter;
};

export type ListCorralPositionsResponsePositionsItemPosition = number | null;

export type ListCorralPositionsResponsePositionsItem = {
  id: number;
  name: string;
  position: ListCorralPositionsResponsePositionsItemPosition;
};

export interface ListCorralPositionsResponse {
  next: number;
  positions: ListCorralPositionsResponsePositionsItem[];
}

export type ListCorralOxenResponse = ListCorralOxenResponseItem[];

export type ListCorralOxenResponseItemStartOfTreatment = string | null;

export type ListCorralOxenResponseItemSisbov = string | null;

export type ListCorralOxenResponseItemSalesMarketType =
  EnumsSalesMarketType | null;

export type ListCorralOxenResponseItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListCorralOxenResponseItemReversedDeathDetails = string | null;

export type ListCorralOxenResponseItemReversedDeathDate = string | null;

export type ListCorralOxenResponseItemReversedDeathCause =
  EnumsDeathCause | null;

export type ListCorralOxenResponseItemPurchaseId = number | null;

export type ListCorralOxenResponseItemPriceAtSignExit = number | null;

export type ListCorralOxenResponseItemPriceAtSignEntry = number | null;

export type ListCorralOxenResponseItemOtherDeathCause = string | null;

export type ListCorralOxenResponseItemIsNecropsyPerformed = boolean | null;

export type ListCorralOxenResponseItemInvoice = string | null;

export type ListCorralOxenResponseItemInternalSaleId = number | null;

export type ListCorralOxenResponseItemIdentifier = string | null;

export type ListCorralOxenResponseItemIdentifiedAt = string | null;

export type ListCorralOxenResponseItemIdentificationSource =
  EnumsIdentificationSource | null;

export type ListCorralOxenResponseItemHasBirthAnnouncement = boolean | null;

export type ListCorralOxenResponseItemGtaId = number | null;

export type ListCorralOxenResponseItemExitTruckId = number | null;

export type ListCorralOxenResponseItemElectronic = string | null;

export type ListCorralOxenResponseItemDiedAt = string | null;

export type ListCorralOxenResponseItemDentitionStage =
  EnumsDentitionStage | null;

export type ListCorralOxenResponseItemDeathReason = EnumsDeathCause | null;

export type ListCorralOxenResponseItemDeathNecropsy = EnumsDeathNecropsy | null;

export type ListCorralOxenResponseItemDeathDetails = string | null;

export type ListCorralOxenResponseItemDeathCause = EnumsDeathCause | null;

export type ListCorralOxenResponseItemComments = string | null;

export type ListCorralOxenResponseItemCertifierDate = string | null;

export type ListCorralOxenResponseItemCattleManifestId = number | null;

export type ListCorralOxenResponseItemCarcassWeight = number | null;

export type ListCorralOxenResponseItemCarcassType = EnumsCarcassType | null;

export type ListCorralOxenResponseItemCarcassPrice = number | null;

export type ListCorralOxenResponseItemCarcass = number | null;

export type ListCorralOxenResponseItemBornOnFarm = boolean | null;

export type ListCorralOxenResponseItemBndTracked = boolean | null;

export type ListCorralOxenResponseItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: ListCorralOxenResponseItemBndTracked;
  bornOnFarm: ListCorralOxenResponseItemBornOnFarm;
  breed: string;
  carcass: ListCorralOxenResponseItemCarcass;
  carcassPrice: ListCorralOxenResponseItemCarcassPrice;
  carcassType: ListCorralOxenResponseItemCarcassType;
  carcassWeight: ListCorralOxenResponseItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: ListCorralOxenResponseItemCattleManifestId;
  certifierDate: ListCorralOxenResponseItemCertifierDate;
  comments: ListCorralOxenResponseItemComments;
  deathCause: ListCorralOxenResponseItemDeathCause;
  deathDetails: ListCorralOxenResponseItemDeathDetails;
  deathNecropsy: ListCorralOxenResponseItemDeathNecropsy;
  deathReason: ListCorralOxenResponseItemDeathReason;
  dentitionStage: ListCorralOxenResponseItemDentitionStage;
  diedAt: ListCorralOxenResponseItemDiedAt;
  electronic: ListCorralOxenResponseItemElectronic;
  exitTruckId: ListCorralOxenResponseItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: ListCorralOxenResponseItemGtaId;
  hasBirthAnnouncement: ListCorralOxenResponseItemHasBirthAnnouncement;
  id: number;
  identificationSource: ListCorralOxenResponseItemIdentificationSource;
  identifiedAt: ListCorralOxenResponseItemIdentifiedAt;
  identifier: ListCorralOxenResponseItemIdentifier;
  includedAt: string;
  internalSaleId: ListCorralOxenResponseItemInternalSaleId;
  invoice: ListCorralOxenResponseItemInvoice;
  isNecropsyPerformed: ListCorralOxenResponseItemIsNecropsyPerformed;
  otherDeathCause: ListCorralOxenResponseItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: ListCorralOxenResponseItemPriceAtSignEntry;
  priceAtSignExit: ListCorralOxenResponseItemPriceAtSignExit;
  purchaseId: ListCorralOxenResponseItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: ListCorralOxenResponseItemReversedDeathCause;
  reversedDeathDate: ListCorralOxenResponseItemReversedDeathDate;
  reversedDeathDetails: ListCorralOxenResponseItemReversedDeathDetails;
  reversedDeathNecropsy: ListCorralOxenResponseItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: ListCorralOxenResponseItemSalesMarketType;
  sisbov: ListCorralOxenResponseItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: ListCorralOxenResponseItemStartOfTreatment;
  variety: string;
};

export type ListCattleManifestLayoutsResponse = CattleManifestLayoutListItem[];

export type ListCattleManifestLayoutsQueryStatus =
  (typeof ListCattleManifestLayoutsQueryStatus)[keyof typeof ListCattleManifestLayoutsQueryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListCattleManifestLayoutsQueryStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

export interface ListCattleManifestLayoutsQuery {
  establishmentId?: number;
  status?: ListCattleManifestLayoutsQueryStatus;
}

export type ListCattleManifestLayoutEstablishmentsResponse =
  EstablishmentWithLayout[];

export interface ListCattleManifestLayoutEstablishmentsQuery {
  search?: string;
}

export type ListBatchesWithNonIdentifiedOxenResponseItem = {
  batchId: number;
  batchName: string;
  corralId: number;
  corralName: string;
};

export type ListBatchesWithNonIdentifiedOxenResponse =
  ListBatchesWithNonIdentifiedOxenResponseItem[];

export type ListBatchesSimplifiedResponse = ListBatchesSimplifiedResponseItem[];

export type ListBatchesSimplifiedResponseItemOldCorralId = number | null;

export type ListBatchesSimplifiedResponseItemFinalizedAt = string | null;

export type ListBatchesSimplifiedResponseItemDescrption = string | null;

export type ListBatchesSimplifiedResponseItemCorralId = number | null;

export type ListBatchesSimplifiedResponseItemCorralAnyOfPosition =
  | number
  | null;

export type ListBatchesSimplifiedResponseItemCorralAnyOf = {
  capacity: number;
  name: string;
  position: ListBatchesSimplifiedResponseItemCorralAnyOfPosition;
};

export type ListBatchesSimplifiedResponseItemCorral =
  ListBatchesSimplifiedResponseItemCorralAnyOf | null;

export type ListBatchesSimplifiedResponseItemActivatedAt = string | null;

export type _ListBatchesSimplifiedResponseItemCount = {
  oxen: number;
};

export type ListBatchesSimplifiedResponseItem = {
  _count: _ListBatchesSimplifiedResponseItemCount;
  activatedAt: ListBatchesSimplifiedResponseItemActivatedAt;
  corral: ListBatchesSimplifiedResponseItemCorral;
  corralId: ListBatchesSimplifiedResponseItemCorralId;
  createdAt: string;
  descrption: ListBatchesSimplifiedResponseItemDescrption;
  farmId: number;
  finalizedAt: ListBatchesSimplifiedResponseItemFinalizedAt;
  id: number;
  name: string;
  oldCorralId: ListBatchesSimplifiedResponseItemOldCorralId;
};

export type ListBatchesResponseItemScaledToSlaughter = boolean | null;

export type ListBatchesResponseItemOxenItem = {
  batchId: number;
  createdAt: string;
  description: ListBatchesResponseItemOxenItemDescription;
  finalizedAt: ListBatchesResponseItemOxenItemFinalizedAt;
  id: number;
  ox: ListBatchesResponseItemOxenItemOx;
  oxId: number;
};

export type ListBatchesResponseItem = {
  activatedAt: ListBatchesResponseItemActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: ListBatchesResponseItemActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: ListBatchesResponseItemAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: ListBatchesResponseItemCarcassExcessive;
  carcassMedium: ListBatchesResponseItemCarcassMedium;
  carcassMissing: ListBatchesResponseItemCarcassMissing;
  carcassThin: ListBatchesResponseItemCarcassThin;
  carcassUniform: ListBatchesResponseItemCarcassUniform;
  corral: ListBatchesResponseItemCorral;
  corralId: ListBatchesResponseItemCorralId;
  createdAt: string;
  descrption: ListBatchesResponseItemDescrption;
  diets: ListBatchesResponseItemDietsItem[];
  exitPrice: number;
  farmId: number;
  finalizedAt: ListBatchesResponseItemFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: ListBatchesResponseItemForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: ListBatchesResponseItemHideFromTreatment;
  hideFromTreatmentUntil: ListBatchesResponseItemHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorral: ListBatchesResponseItemOldCorral;
  oldCorralId: ListBatchesResponseItemOldCorralId;
  operationalCostGroupId: ListBatchesResponseItemOperationalCostGroupId;
  otherCost: number;
  oxen: ListBatchesResponseItemOxenItem[];
  oxFinancing: boolean;
  scaledToSlaughter: ListBatchesResponseItemScaledToSlaughter;
};

export type ListBatchesResponse = ListBatchesResponseItem[];

export type ListBatchesResponseItemOxenItemOxStartOfTreatment = string | null;

export type ListBatchesResponseItemOxenItemOxSisbov = string | null;

export type ListBatchesResponseItemOxenItemOxSalesMarketType =
  EnumsSalesMarketType | null;

export type ListBatchesResponseItemOxenItemOxReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListBatchesResponseItemOxenItemOxReversedDeathDetails =
  | string
  | null;

export type ListBatchesResponseItemOxenItemOxReversedDeathDate = string | null;

export type ListBatchesResponseItemOxenItemOxReversedDeathCause =
  EnumsDeathCause | null;

export type ListBatchesResponseItemOxenItemOxPurchaseId = number | null;

export type ListBatchesResponseItemOxenItemOxPriceAtSignExit = number | null;

export type ListBatchesResponseItemOxenItemOxPriceAtSignEntry = number | null;

export type ListBatchesResponseItemOxenItemOxOtherDeathCause = string | null;

export type ListBatchesResponseItemOxenItemOxIsNecropsyPerformed =
  | boolean
  | null;

export type ListBatchesResponseItemOxenItemOxInvoice = string | null;

export type ListBatchesResponseItemOxenItemOxInternalSaleId = number | null;

export type ListBatchesResponseItemOxenItemOxIdentifier = string | null;

export type ListBatchesResponseItemOxenItemOxIdentifiedAt = string | null;

export type ListBatchesResponseItemOxenItemOxIdentificationSource =
  EnumsIdentificationSource | null;

export type ListBatchesResponseItemOxenItemOxHasBirthAnnouncement =
  | boolean
  | null;

export type ListBatchesResponseItemOxenItemOxGtaId = number | null;

export type ListBatchesResponseItemOxenItemOxExitTruckId = number | null;

export type ListBatchesResponseItemOxenItemOxElectronic = string | null;

export type ListBatchesResponseItemOxenItemOxDiedAt = string | null;

export type ListBatchesResponseItemOxenItemOxDentitionStage =
  EnumsDentitionStage | null;

export type ListBatchesResponseItemOxenItemOxDeathReason =
  EnumsDeathCause | null;

export type ListBatchesResponseItemOxenItemOxDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ListBatchesResponseItemOxenItemOxDeathDetails = string | null;

export type ListBatchesResponseItemOxenItemOxDeathCause =
  EnumsDeathCause | null;

export type ListBatchesResponseItemOxenItemOxComments = string | null;

export type ListBatchesResponseItemOxenItemOxCertifierDate = string | null;

export type ListBatchesResponseItemOxenItemOxCattleManifestId = number | null;

export type ListBatchesResponseItemOxenItemOxCarcassWeight = number | null;

export type ListBatchesResponseItemOxenItemOxCarcassType =
  EnumsCarcassType | null;

export type ListBatchesResponseItemOxenItemOxCarcassPrice = number | null;

export type ListBatchesResponseItemOxenItemOxCarcass = number | null;

export type ListBatchesResponseItemOxenItemOxBornOnFarm = boolean | null;

export type ListBatchesResponseItemOxenItemOxBndTracked = boolean | null;

export type ListBatchesResponseItemOxenItemOx = {
  birth: string;
  blockedUntil: string;
  bndTracked: ListBatchesResponseItemOxenItemOxBndTracked;
  bornOnFarm: ListBatchesResponseItemOxenItemOxBornOnFarm;
  breed: string;
  carcass: ListBatchesResponseItemOxenItemOxCarcass;
  carcassPrice: ListBatchesResponseItemOxenItemOxCarcassPrice;
  carcassType: ListBatchesResponseItemOxenItemOxCarcassType;
  carcassWeight: ListBatchesResponseItemOxenItemOxCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: ListBatchesResponseItemOxenItemOxCattleManifestId;
  certifierDate: ListBatchesResponseItemOxenItemOxCertifierDate;
  comments: ListBatchesResponseItemOxenItemOxComments;
  deathCause: ListBatchesResponseItemOxenItemOxDeathCause;
  deathDetails: ListBatchesResponseItemOxenItemOxDeathDetails;
  deathNecropsy: ListBatchesResponseItemOxenItemOxDeathNecropsy;
  deathReason: ListBatchesResponseItemOxenItemOxDeathReason;
  dentitionStage: ListBatchesResponseItemOxenItemOxDentitionStage;
  diedAt: ListBatchesResponseItemOxenItemOxDiedAt;
  electronic: ListBatchesResponseItemOxenItemOxElectronic;
  exitTruckId: ListBatchesResponseItemOxenItemOxExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: ListBatchesResponseItemOxenItemOxGtaId;
  hasBirthAnnouncement: ListBatchesResponseItemOxenItemOxHasBirthAnnouncement;
  id: number;
  identificationSource: ListBatchesResponseItemOxenItemOxIdentificationSource;
  identifiedAt: ListBatchesResponseItemOxenItemOxIdentifiedAt;
  identifier: ListBatchesResponseItemOxenItemOxIdentifier;
  includedAt: string;
  internalSaleId: ListBatchesResponseItemOxenItemOxInternalSaleId;
  invoice: ListBatchesResponseItemOxenItemOxInvoice;
  isNecropsyPerformed: ListBatchesResponseItemOxenItemOxIsNecropsyPerformed;
  otherDeathCause: ListBatchesResponseItemOxenItemOxOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: ListBatchesResponseItemOxenItemOxPriceAtSignEntry;
  priceAtSignExit: ListBatchesResponseItemOxenItemOxPriceAtSignExit;
  purchaseId: ListBatchesResponseItemOxenItemOxPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: ListBatchesResponseItemOxenItemOxReversedDeathCause;
  reversedDeathDate: ListBatchesResponseItemOxenItemOxReversedDeathDate;
  reversedDeathDetails: ListBatchesResponseItemOxenItemOxReversedDeathDetails;
  reversedDeathNecropsy: ListBatchesResponseItemOxenItemOxReversedDeathNecropsy;
  runtime: number;
  salesMarketType: ListBatchesResponseItemOxenItemOxSalesMarketType;
  sisbov: ListBatchesResponseItemOxenItemOxSisbov;
  sisbovHistory: string[];
  startOfTreatment: ListBatchesResponseItemOxenItemOxStartOfTreatment;
  variety: string;
};

export type ListBatchesResponseItemOxenItemFinalizedAt = string | null;

export type ListBatchesResponseItemOxenItemDescription = string | null;

export type ListBatchesResponseItemOperationalCostGroupId = number | null;

export type ListBatchesResponseItemOldCorralId = number | null;

export type ListBatchesResponseItemOldCorralAnyOf = {
  id: number;
  name: string;
  type: EnumsCorralType;
};

export type ListBatchesResponseItemOldCorral =
  ListBatchesResponseItemOldCorralAnyOf | null;

export type ListBatchesResponseItemHideFromTreatmentUntil = string | null;

export type ListBatchesResponseItemHideFromTreatment = boolean | null;

export type ListBatchesResponseItemForeseenSlaughterDate = string | null;

export type ListBatchesResponseItemFinalizedAt = string | null;

export type ListBatchesResponseItemDietsItemFinalizedAt = string | null;

export type ListBatchesResponseItemDietsItemDietPremixId = number | null;

export type ListBatchesResponseItemDietsItemDietObservation = string | null;

export type ListBatchesResponseItemDietsItemDietFixedElg = number | null;

export type ListBatchesResponseItemDietsItemDietCode = string | null;

export type ListBatchesResponseItemDietsItemDietCategory =
  EnumsDietCategory | null;

export type ListBatchesResponseItemDietsItemDiet = {
  active: boolean;
  category: ListBatchesResponseItemDietsItemDietCategory;
  code: ListBatchesResponseItemDietsItemDietCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: ListBatchesResponseItemDietsItemDietFixedElg;
  id: number;
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: ListBatchesResponseItemDietsItemDietObservation;
  premixId: ListBatchesResponseItemDietsItemDietPremixId;
};

export type ListBatchesResponseItemDietsItem = {
  batchId: number;
  createdAt: string;
  diet: ListBatchesResponseItemDietsItemDiet;
  dietId: number;
  finalizedAt: ListBatchesResponseItemDietsItemFinalizedAt;
  id: number;
};

export type ListBatchesResponseItemDescrption = string | null;

export type ListBatchesResponseItemCorralId = number | null;

export type ListBatchesResponseItemCorralAnyOf = {
  capacity: number;
  id: number;
  name: string;
  type: EnumsCorralType;
};

export type ListBatchesResponseItemCorral =
  ListBatchesResponseItemCorralAnyOf | null;

export type ListBatchesResponseItemCarcassUniform = number | null;

export type ListBatchesResponseItemCarcassThin = number | null;

export type ListBatchesResponseItemCarcassMissing = number | null;

export type ListBatchesResponseItemCarcassMedium = number | null;

export type ListBatchesResponseItemCarcassExcessive = number | null;

export type ListBatchesResponseItemAdjustedPurchaseCost = number | null;

export type ListBatchesResponseItemActivationEditedAt = string | null;

export type ListBatchesResponseItemActivatedAt = string | null;

export type ListBatchesForSaleCorrectionResponse = BatchSaleCorrectionOption[];

export type ListBatchesForEntryDateEditResponse = BatchEntryDateOption[];

export interface ListBatchesForAnalyticalReportItem {
  id: number;
  name: string;
}

export type ListBatchesForAnalyticalReportResponse =
  ListBatchesForAnalyticalReportItem[];

export type ListBatchWeightGainCurveHistoryResponse = BatchCurveOnBatchesItem[];

export type ListBNDsResponseItem = {
  expedition: string;
  name: string;
  ownerId: number;
  status: EnumsBndStatus;
};

export type ListBNDsResponse = ListBNDsResponseItem[];

export type ListAvailableWeightingMapsResponse =
  ListAvailableWeightingMapsResponseItem[];

export type ListAvailableWeightingMapsResponseItemTotalWeight = number | null;

export type ListAvailableWeightingMapsResponseItemTotalPurchase = number | null;

export type ListAvailableWeightingMapsResponseItemSupplementedRearingModality =
  EnumsSupplementedRearingModality | null;

export type ListAvailableWeightingMapsResponseItemStartTime = string | null;

export type ListAvailableWeightingMapsResponseItemReferenceCode = string | null;

export type ListAvailableWeightingMapsResponseItemPurchaseId = number | null;

export type ListAvailableWeightingMapsResponseItemPricePerArroba =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemNetWeight = number | null;

export type ListAvailableWeightingMapsResponseItemInvoicesItemWeightingMapId =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemInvoicesItemSaleOrderId =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemInvoicesItemIsComplement =
  | boolean
  | null;

export type ListAvailableWeightingMapsResponseItemInvoicesItemExitTruckId =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemInvoicesItemEmittedAt =
  | string
  | null;

export type ListAvailableWeightingMapsResponseItemInvoicesItem = {
  emittedAt: ListAvailableWeightingMapsResponseItemInvoicesItemEmittedAt;
  exitTruckId: ListAvailableWeightingMapsResponseItemInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: ListAvailableWeightingMapsResponseItemInvoicesItemIsComplement;
  number: string;
  saleOrderId: ListAvailableWeightingMapsResponseItemInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: ListAvailableWeightingMapsResponseItemInvoicesItemWeightingMapId;
};

export type ListAvailableWeightingMapsResponseItem = {
  averageWeight: ListAvailableWeightingMapsResponseItemAverageWeight;
  buyer: ListAvailableWeightingMapsResponseItemBuyer;
  buyerId: number;
  carcassYield: ListAvailableWeightingMapsResponseItemCarcassYield;
  closingTime: ListAvailableWeightingMapsResponseItemClosingTime;
  commission: number;
  emissionDate: string;
  endTime: ListAvailableWeightingMapsResponseItemEndTime;
  farmId: number;
  fastingDate: ListAvailableWeightingMapsResponseItemFastingDate;
  grossWeight: ListAvailableWeightingMapsResponseItemGrossWeight;
  gtas: ListAvailableWeightingMapsResponseItemGtasItem[];
  id: number;
  invoices: ListAvailableWeightingMapsResponseItemInvoicesItem[];
  netWeight: ListAvailableWeightingMapsResponseItemNetWeight;
  pricePerArroba: ListAvailableWeightingMapsResponseItemPricePerArroba;
  purchaseId: ListAvailableWeightingMapsResponseItemPurchaseId;
  referenceCode: ListAvailableWeightingMapsResponseItemReferenceCode;
  shippingCost: number;
  startTime: ListAvailableWeightingMapsResponseItemStartTime;
  status: EnumsWeightingMapStatus;
  supplementedRearingModality: ListAvailableWeightingMapsResponseItemSupplementedRearingModality;
  totalPurchase: ListAvailableWeightingMapsResponseItemTotalPurchase;
  totalWeight: ListAvailableWeightingMapsResponseItemTotalWeight;
  weighingDate: string;
};

export type ListAvailableWeightingMapsResponseItemGtasItemWeightingMapId =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemWeightAverage =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemPurchaseId =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemOriginWeightAverage =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemOrigin = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: ListAvailableWeightingMapsResponseItemGtasItemOriginCattleManifestLayoutId;
  code: ListAvailableWeightingMapsResponseItemGtasItemOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: ListAvailableWeightingMapsResponseItemGtasItemOriginResponsible;
  responsibleId: number;
};

export type ListAvailableWeightingMapsResponseItemGtasItem = {
  ages: ListAvailableWeightingMapsResponseItemGtasItemAgesItem[];
  completed: boolean;
  description: ListAvailableWeightingMapsResponseItemGtasItemDescription;
  destinyId: ListAvailableWeightingMapsResponseItemGtasItemDestinyId;
  distance: ListAvailableWeightingMapsResponseItemGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: ListAvailableWeightingMapsResponseItemGtasItemHours;
  id: number;
  invoice: ListAvailableWeightingMapsResponseItemGtasItemInvoice;
  number: string;
  origin: ListAvailableWeightingMapsResponseItemGtasItemOrigin;
  originId: number;
  originWeightAverage: ListAvailableWeightingMapsResponseItemGtasItemOriginWeightAverage;
  purchaseId: ListAvailableWeightingMapsResponseItemGtasItemPurchaseId;
  series: string;
  weightAverage: ListAvailableWeightingMapsResponseItemGtasItemWeightAverage;
  weightingMapId: ListAvailableWeightingMapsResponseItemGtasItemWeightingMapId;
};

export type ListAvailableWeightingMapsResponseItemGtasItemOriginResponsiblePhone =
  string | null;

export type ListAvailableWeightingMapsResponseItemGtasItemOriginResponsibleDocument =
  string | null;

export type ListAvailableWeightingMapsResponseItemGtasItemOriginResponsibleDescription =
  string | null;

export type ListAvailableWeightingMapsResponseItemGtasItemOriginResponsibleCode =
  string | null;

export type ListAvailableWeightingMapsResponseItemGtasItemOriginResponsible = {
  code: ListAvailableWeightingMapsResponseItemGtasItemOriginResponsibleCode;
  createdAt: string;
  description: ListAvailableWeightingMapsResponseItemGtasItemOriginResponsibleDescription;
  document: ListAvailableWeightingMapsResponseItemGtasItemOriginResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: ListAvailableWeightingMapsResponseItemGtasItemOriginResponsiblePhone;
  profiles: EnumsProfile[];
};

export type ListAvailableWeightingMapsResponseItemGtasItemOriginCode =
  | string
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemOriginCattleManifestLayoutId =
  number | null;

export type ListAvailableWeightingMapsResponseItemGtasItemInvoice =
  | string
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemHours = number | null;

export type ListAvailableWeightingMapsResponseItemGtasItemDistance =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemDestinyId =
  | number
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemDescription =
  | string
  | null;

export type ListAvailableWeightingMapsResponseItemGtasItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  yearsOld: number;
};

export type ListAvailableWeightingMapsResponseItemGrossWeight = number | null;

export type ListAvailableWeightingMapsResponseItemFastingDate = string | null;

export type ListAvailableWeightingMapsResponseItemEndTime = string | null;

export type ListAvailableWeightingMapsResponseItemClosingTime = string | null;

export type ListAvailableWeightingMapsResponseItemCarcassYield = number | null;

export type ListAvailableWeightingMapsResponseItemBuyer = {
  id: number;
  name: string;
};

export type ListAvailableWeightingMapsResponseItemAverageWeight = number | null;

export type ListAvailableInvoicesForWeightingMapResponseItemEmittedAt =
  | string
  | null;

export type ListAvailableInvoicesForWeightingMapResponseItem = {
  emittedAt: ListAvailableInvoicesForWeightingMapResponseItemEmittedAt;
  id: number;
  number: string;
  series: string;
  value: number;
};

export type ListAvailableInvoicesForWeightingMapResponse =
  ListAvailableInvoicesForWeightingMapResponseItem[];

export type ListAvailableGtasForWeightingMapResponse =
  ListAvailableGtasForWeightingMapResponseItem[];

export type ListAvailableGtasForWeightingMapResponseItemOrigin = {
  name: string;
};

export type ListAvailableGtasForWeightingMapResponseItemAgesItem = {
  femaleTotal: number;
  maleTotal: number;
};

export type ListAvailableGtasForWeightingMapResponseItem = {
  ages: ListAvailableGtasForWeightingMapResponseItemAgesItem[];
  emission: string;
  id: number;
  number: string;
  origin: ListAvailableGtasForWeightingMapResponseItemOrigin;
  series: string;
};

export type ListAuditAnimalResponseItemOxId = number | null;

export type ListAuditAnimalResponseItem = {
  bacthOrigin: number;
  batchDestiny: number;
  createdAt: string;
  electronic: string;
  farmId: number;
  gta: string;
  id: number;
  metadata: unknown;
  oxId: ListAuditAnimalResponseItemOxId;
  sisbov: string;
  status: EnumsAuditManagementStatus;
};

export type ListAuditAnimalResponse = ListAuditAnimalResponseItem[];

export interface ListAnnouncementsResponse {
  items: ListAnnouncementItem[];
  next?: number;
  previous?: number;
}

export type ListAnnouncementItemExpiresAt = string | null;

export type ListAnnouncementItemEmittedAt = string | null;

export type ListAnnouncementItemCreatedAt = string | null;

export interface ListAnnouncementItem {
  announcementNumber: string;
  createdAt: ListAnnouncementItemCreatedAt;
  data: unknown;
  emittedAt: ListAnnouncementItemEmittedAt;
  expiresAt: ListAnnouncementItemExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export type ListAndExportOxenResultSisbov = string | null;

export type ListAndExportOxenResultOtherDeathCause = string | null;

export type ListAndExportOxenResultElectronic = string | null;

export type ListAndExportOxenResultDeathReason = EnumsDeathCause | null;

export type ListAndExportOxenResultDeathNecropsy = EnumsDeathNecropsy | null;

export type ListAndExportOxenResultDeathDetails = string | null;

export type ListAndExportOxenResultDeathCause = EnumsDeathCause | null;

export interface ListAndExportOxenResult {
  batch: string;
  breed: string;
  corral: string;
  days: number;
  deathCause: ListAndExportOxenResultDeathCause;
  deathDetails: ListAndExportOxenResultDeathDetails;
  deathNecropsy: ListAndExportOxenResultDeathNecropsy;
  deathReason: ListAndExportOxenResultDeathReason;
  diedAt: string;
  electronic: ListAndExportOxenResultElectronic;
  entryDate: string;
  gender: EnumsOxGender;
  hasMedicate: string;
  idPurpose: number;
  originOwner: string;
  otherDeathCause: ListAndExportOxenResultOtherDeathCause;
  oxOwner: string;
  partner: string;
  purchaseName: string;
  purpose: EnumsOxPurpose;
  sisbov: ListAndExportOxenResultSisbov;
}

export type ListAndExportMedicineApplicationsOxenResponseItem = {
  applicationType?: string;
  appliedAt: string;
  batch: string;
  breed: string;
  corral: string;
  disease: EnumsDisease;
  entryDate: string;
  gender: EnumsOxGender;
  medicineApplicator: string;
  medicines: string;
  originOwner: string;
  oxId: number;
  oxOwner: string;
  partner: string;
  protocol: string;
  purchaseName: string;
  purpose: EnumsOxPurpose;
  sisbov: string;
  totalCost: string;
  totalDose: string;
};

export type ListAndExportMedicineApplicationsOxenResponse =
  ListAndExportMedicineApplicationsOxenResponseItem[];

export type ListAndExportDiedOxenResponse = ListAndExportOxenResult[];

export interface ListAndExportDailyLivestockInventoryOxenResult {
  current_balance: string;
  date: string;
  deaths: string;
  entries: string;
  totalExits: string;
}

export type ListAndExportDailyLivestockInventoryOxenResponse =
  ListAndExportDailyLivestockInventoryOxenResult[];

export type ListAllDietsResponseItemPremixId = number | null;

export type ListAllDietsResponseItemObservation = string | null;

export type ListAllDietsResponseItemFixedElg = number | null;

export type ListAllDietsResponseItemCode = string | null;

export type ListAllDietsResponseItemCategory = EnumsDietCategory | null;

export type ListAllDietsResponseItem = {
  active: boolean;
  category: ListAllDietsResponseItemCategory;
  code: ListAllDietsResponseItemCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: ListAllDietsResponseItemFixedElg;
  id: number;
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: ListAllDietsResponseItemObservation;
  premixId: ListAllDietsResponseItemPremixId;
};

export type ListAllDietsResponse = ListAllDietsResponseItem[];

export type ListActiveCorralsResponseItem = {
  id: number;
  name: string;
};

export type ListActiveCorralsResponse = ListActiveCorralsResponseItem[];

export type ListActiveAndFinalizedBatchesResponseItem = {
  id: number;
  name: string;
};

export type ListActiveAndFinalizedBatchesResponse =
  ListActiveAndFinalizedBatchesResponseItem[];

export interface LinkCattleManifestLayoutEstablishmentsResponse {
  linkedIds: number[];
}

export interface LinkCattleManifestLayoutEstablishmentsBody {
  establishmentIds: number[];
}

export type KillOxStartOfTreatment = string | null;

export type KillOxOtherDeathCause = string | null;

/**
 * Motivo da Morte
 */
export type KillOxDeathReason = EnumsDeathCause | null;

export interface KillOx {
  cause: EnumsDeathCause;
  /** Motivo da Morte */
  deathReason?: KillOxDeathReason;
  diedAt: string;
  isNecropsyPerformed?: boolean;
  necropsy?: EnumsDeathNecropsy;
  observation?: string;
  otherDeathCause?: KillOxOtherDeathCause;
  startOfTreatment?: KillOxStartOfTreatment;
  /** Peso do boi na hora da morte, caso calculado. */
  weight?: number;
}

export interface InventoryProjection {
  days15: number;
  days3: number;
  days30: number;
  days7: number;
}

export type InventoryControlItemPremixComponentsItem = { [key: string]: any };

export type InventoryControlItemPremix = boolean | null;

export interface InventoryControlItem {
  currentStock: number;
  dailyConsumption: number;
  date: string;
  durationInDays: number;
  id: number;
  isPremix: boolean;
  name: string;
  naturalMatterFactor: number;
  naturalMatterPrice: number;
  periodEntries: number;
  premix: InventoryControlItemPremix;
  premixComponents?: InventoryControlItemPremixComponentsItem[];
  projections: InventoryProjection;
}

export interface InventoryControlFilter {
  limit?: number;
  page?: number;
}

export type InvalidRealizedDietResultValidIngredientsItem = {
  stockCode: string;
  stockId: number;
  stockName: string;
};

export type InvalidRealizedDietResultInvalidRealizedItemsItem = {
  ids: number[];
  stockCode: string;
  stockName: string;
  totalRealized: number;
};

export interface InvalidRealizedDietResult {
  dietId: number;
  dietName: string;
  invalidRealizedItems: InvalidRealizedDietResultInvalidRealizedItemsItem[];
  validIngredients: InvalidRealizedDietResultValidIngredientsItem[];
}

export interface Ingredient {
  percentage: number;
  rotorOrder?: number;
  stockId: number;
  topplingOrder?: number;
}

export type IndividualCattleClosingXlsxAppVersion = string | null;

export interface IndividualCattleClosingXlsx {
  appVersion?: IndividualCattleClosingXlsxAppVersion;
  batchId?: number;
  end?: string;
  filename: string;
  start?: string;
}

export type IndividualCattleClosingReturnSisbov = number | null;

/**
 * TIPO DE MERCADO
 */
export type IndividualCattleClosingReturnSalesMarketType =
  EnumsSalesMarketType | null;

/**
 * NOME DA ORDEM DE VENDA
 */
export type IndividualCattleClosingReturnSaleOrder = string | null;

/**
 * Proprietário de origem
 */
export type IndividualCattleClosingReturnOriginOwner = string | null;

/**
 * Venda interna
 */
export type IndividualCattleClosingReturnInternalSale = string | null;

/**
 * Brinco extra
 */
export type IndividualCattleClosingReturnIdentifier = string | null;

/**
 * DATA DE SAÍDA conf
 */
export type IndividualCattleClosingReturnExitDate = string | null;

/**
 * Brinco eletrônico
 */
export type IndividualCattleClosingReturnElectronic = string | null;

export type IndividualCattleClosingReturnDeathCauseAnyOf = {
  [key: string]: any;
};

/**
 * Causa da morte conf
 */
export type IndividualCattleClosingReturnDeathCause =
  | "SALE"
  | IndividualCattleClosingReturnDeathCauseAnyOf;

/**
 * Comentário
 */
export type IndividualCattleClosingReturnComments = string | null;

export interface IndividualCattleClosingReturn {
  /** Linha núcleo Adaptação */
  adaptationCoreLine: string;
  /** CUSTO ARROBA COMPRA (R$/CAB) */
  atSignCost: number;
  atSignProduced: number;
  /** CUSTO ARROBA PRODUZIDA (R$/@ prod) conf */
  atSignProducedCost: number;
  /** EFICIÊNCIA BIOLÓGICA (kg de MS/@ Prod) */
  biologicEfficiency: number;
  /** Comprador */
  buyer?: string;
  /** GANHO DIARIO DE CARCAÇA (KG) */
  carcassDailyGain: number;
  /** CATEGORIA */
  category: EnumsOxGender;
  /** Cidade */
  city?: string;
  /** Cliente */
  client: string;
  /** Comentário */
  comments?: IndividualCattleClosingReturnComments;
  /** Comissão Compra (R$/CAB) */
  commissionCost: number;
  /** DIAS CONF (CAB) */
  confinementDays: number;
  /** Linha núcleo Terminação */
  coreLineTermination: string;
  /** CONSUMO MN (KG/CAB/DIA) */
  dailyMatterConsume: number;
  /** CONSUMO MS (KG/CAB/DIA) */
  dailyNaturalMatterConsume: number;
  /** Causa da morte conf */
  deathCause: IndividualCattleClosingReturnDeathCause;
  /** FRIGORÍFICO DESTINO */
  destiny: string;
  /** DIFERENÇA DE DIÁRIAS (CAB) */
  diffDays: number;
  /** Enfermidades */
  diseases: EnumsDisease[];
  /** Km rodado da origem */
  distance?: number;
  /** Brinco eletrônico */
  electronic?: IndividualCattleClosingReturnElectronic;
  /** CONSUMO Elg (mcal/CAB/PERÍODO) */
  elgConsume: number;
  /** CONSUMO Elg (mcal/CAB/DIA) */
  elgConsumePerOx: number;
  /** CV do peso de entrada do lote */
  entryBatchCov: number;
  /** PESO ENTRADA conf (ARROBA) */
  entryCarcassAtSign: number;
  /** PESO ENTRADA conf (CARCAÇA) (kg) */
  entryCarcassWeight: number;
  /** RENDIMENTO CARCAÇA (ENTRADA) conf (%) */
  entryCarcassYield: number;
  /** CUSTO DE ENTRADA ANIMAL (R$/CAB) */
  entryCostPerOx: number;
  /** DATA DE ENTRADA conf */
  entryDate: string;
  /** PESO ENTRADA Confinamento (KG) */
  entryWeight: number;
  /** LOTE Saída confinamento */
  exitBatch: string;
  /** PESO SAÍDA (ARROBA) */
  exitCarcassAtSign: number;
  /** PESO SAÍDA (CARCAÇA) (kg) */
  exitCarcassWeight: number;
  /** RENDIMENTO CARCAÇA (%) saida conf */
  exitCarcassYield: number;
  /** DATA DE SAÍDA conf */
  exitDate: IndividualCattleClosingReturnExitDate;
  /** PESO SAÍDA conf (KG) */
  exitWeight: number;
  /** CONVERSÃO ALIMENTAR (Kg de MS/kgPV) */
  feedConversion: number;
  /** EFICIÊNCIA ALIMENTAR (GPD/Cons MS dia) */
  feedEfficiency: number;
  /** CUSTO FIXO (R$/CAB/PERÍODO) */
  fixedCost: number;
  /** PERCENTUAL CUSTO FIXO NO CUSTO TOTAL (%) */
  fixedCostPercentageOfTotalCost: number;
  /** CUSTO ALIMENTAR (R$/CAB/DIA) */
  foodCost: number;
  /** PERCENTUAL CUSTO ALIMENTAR NO CUSTO TOTAL (%) */
  foodCostPercentageOfTotalCost: number;
  /** Margem líquida "Dentro da porteira" (R$/cabeça) */
  gateIn: number;
  /** Margem líquida "Fora da porteira" (R$/cabeça) */
  gateOut: number;
  /** PERCENTUAL CUSTO SANIDADE NO CUSTO TOTAL (%) */
  healthCostPercentageOfTotalCost: number;
  /** Brinco extra */
  identifier?: IndividualCattleClosingReturnIdentifier;
  /** IMS (%PV) */
  ims: number;
  /** Venda interna */
  internalSale?: IndividualCattleClosingReturnInternalSale;
  /** COD. Manejo */
  managementCode?: string;
  /** Protocolo sanitário */
  medicines: string;
  /** RENTABILIDADE (MÊS) (%) */
  monthlyProfitabilityPercentage: number;
  /** LUCRO LÍQUIDO (R$/CAB/PERÍODO) */
  netProfit: number;
  /** CUSTO OPERACIONAL (R$/CAB/DIA) */
  operacional: number;
  /** Proprietário de origem */
  originOwner?: IndividualCattleClosingReturnOriginOwner;
  /** OUTROS CUSTOS (R$/CAB/DIA) */
  otherCost: number;
  /** OUTROS CUSTOS (R$/CAB/DIA) conf */
  otherCostConf: number;
  /** PERCENTUAL OUTROS CUSTOS NO CUSTO TOTAL (%) */
  otherCostsPercentageOfTotalCost: number;
  /** Proprietário */
  owner?: string;
  /** Parceiro/Rebanho */
  partnerHerd: string;
  /** PERCENTUAL CUSTO COMPRA ANIM NO CUSTO TOTAL (%) */
  percentageCostAnimalPurchaseInTotalCost: number;
  /** RENTABILIDADE (PERÍODO) (%) */
  periodProfitabilityPercentage: number;
  /** DIAS PRÉ-CONF (CAB) */
  preConfinementDays: number;
  /** Valor do animal do pedido de compra dividido pelas @ baseadas no peso do balanção */
  priceAtSignReceived?: number;
  /** DATA DE PROCESSAMENTO */
  processingDate: string;
  /** PESO DE PROCESSAMENTO (kg) */
  processingWeight: number;
  /** CUSTO PRODUÇÃO (R$/CAB/DIA) conf */
  productionCost: number;
  /** Sanidade tratamento aplicado */
  protocols: string;
  /** NOME DA ORDEM DE COMPRA */
  purchase: string;
  /** Peso médio do pedido de compra */
  purchaseWeightAverage?: number;
  /** Tipo de Cadastro */
  purpose?: EnumsOxPurpose;
  /** RECEITA (R$/CAB) */
  recipe: number;
  /** VALOR DE VENDA (R$/@) */
  saleAtSignCost: number;
  /** NOME DA ORDEM DE VENDA */
  saleOrder?: IndividualCattleClosingReturnSaleOrder;
  /** TIPO DE MERCADO */
  salesMarketType: IndividualCattleClosingReturnSalesMarketType;
  /** CUSTO DE FRETE + COMISSÃO (R$/CAB) */
  shipping: number;
  /** CUSTO FRETE (R$/CAB) */
  shippingCost: number;
  sisbov?: IndividualCattleClosingReturnSisbov;
  /** Estado */
  state?: string;
  /** CUSTO TOTAL DE AQUISIÇÃO (R$/CAB) */
  totalAnimalCost: number;
  /** CUSTO TOTAL (R$/CAB/PERÍODO) conf */
  totalCost: number;
  /** CUSTO TOTAL DO ANIMAL (R$/CAB) */
  totalEntryCost: number;
  /** CUSTO ALIMENTAR (R$/CAB/PERÍODO) */
  totalFoodCost: number;
  /** CONSUMO MN TOTAL (KG/CAB/PERÍODO) */
  totalMatterConsume: number;
  /** CONSUMO MS TOTAL (KG/CAB/PERÍODO) */
  totalNaturalMatterConsume: number;
  /** OUTROS CUSTOS (R$/CAB/PERÍODO) conf */
  totalOtherCostConf: number;
  /** CUSTO PRODUÇÃO (R$/CAB/PERÍODO) conf */
  totalProductionCost: number;
  /** CUSTO SANIDADE (R$/CAB/PERÍODO) conf */
  totalVeterinarySupplies: number;
  /** DIÁRIAS ALIMENTAR (TOTAL) */
  treatmentDays: number;
  /** RAÇA */
  variety: string;
  /** CUSTO SANIDADE (R$/CAB/DIA) conf */
  veterinarySupplies: number;
  /** Quebra de peso (kg) */
  weightBreak: number;
  /** Quebra de peso (%) */
  weightBreakPercentage: number;
  /** GANHO DE PESO DIA (KG) */
  weightDailyGain: number;
}

export type IndividualCattleClosingReportResponse =
  IndividualCattleClosingReturn[];

export interface IndividualCattleClosingFilter {
  batchId?: number;
  end?: string;
  limit?: number;
  page?: number;
  start?: string;
}

export interface ImportResult {
  imported: number;
  requested: number;
  sourceBatchId: number;
  toTruckId: number;
}

export type ImportMassiveAnimalsResponseCreatedCounts = {
  animals: number;
  batches: number;
  corrals: number;
  earringPurchases: number;
  establishments: number;
  gtas: number;
  owners: number;
  oxenPurchases: number;
};

export interface ImportMassiveAnimalsResponse {
  createdCounts: ImportMassiveAnimalsResponseCreatedCounts;
  /** Lista de erros descritivos. Quando preenchida, a transação foi revertida. */
  errors: string[];
  success: boolean;
}

/**
 * Payload aceito por POST /utils/import-massive-animals.

O frontend faz toda a resolução de "o que existe" vs "o que falta criar" nas etapas anteriores e envia tudo num único POST. O backend cria tudo dentro de uma transação Prisma — se qualquer item falhar, nada é gravado.

Itens em `existing.*` já têm id no sistema. Itens em `toCreate.*` referenciam dependências por NOME — o backend resolve em ordem e mantém maps `nome → id`.
 */
export interface ImportMassiveAnimalsBody {
  existing: ImportMassiveAnimalsBodyExisting;
  meta: ImportMassiveAnimalsBodyMeta;
  toCreate: ImportMassiveAnimalsBodyToCreate;
}

export type ImportMassiveAnimalsBodyToCreateOxenPurchaseAnyOf = {
  existingGtaIds: number[];
  name: string;
  ownerId: number;
  toCreateGtaNumbers: string[];
};

export type ImportMassiveAnimalsBodyToCreateOxenPurchase =
  ImportMassiveAnimalsBodyToCreateOxenPurchaseAnyOf | null;

export type ImportMassiveAnimalsBodyToCreateOwnersItem = {
  name: string;
};

export type ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups36 = {
  female: number;
  male: number;
};

export type ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups2536 = {
  female: number;
  male: number;
};

export type ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups1324 = {
  female: number;
  male: number;
};

export type ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups012 = {
  female: number;
  male: number;
};

export type ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups = {
  "0-12": ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups012;
  "13-24": ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups1324;
  "25-36": ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups2536;
  "36+": ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups36;
};

export type ImportMassiveAnimalsBodyToCreateGtasItem = {
  ageGroups: ImportMassiveAnimalsBodyToCreateGtasItemAgeGroups;
  number: string;
  originName: string;
};

export type ImportMassiveAnimalsBodyToCreateEstablishmentsItem = {
  name: string;
  ownerName: string;
};

/**
 * Pode vir null caso o usuário não tenha selecionado dono no step de pedidos.
 */
export type ImportMassiveAnimalsBodyToCreateEarringPurchasesItemOwnerId =
  | number
  | null;

export type ImportMassiveAnimalsBodyToCreateEarringPurchasesItem = {
  finalSisbov: string;
  initialSisbov: string;
  /** Pode vir null caso o usuário não tenha selecionado dono no step de pedidos. */
  ownerId: ImportMassiveAnimalsBodyToCreateEarringPurchasesItemOwnerId;
};

export type ImportMassiveAnimalsBodyToCreateCorralsItem = {
  name: string;
};

export type ImportMassiveAnimalsBodyToCreateBatchesItem = {
  corralName: string;
  name: string;
};

export type ImportMassiveAnimalsBodyToCreate = {
  animals: ImportMassiveAnimalsBodyToCreateAnimalsItem[];
  batches: ImportMassiveAnimalsBodyToCreateBatchesItem[];
  corrals: ImportMassiveAnimalsBodyToCreateCorralsItem[];
  earringPurchases: ImportMassiveAnimalsBodyToCreateEarringPurchasesItem[];
  establishments: ImportMassiveAnimalsBodyToCreateEstablishmentsItem[];
  gtas: ImportMassiveAnimalsBodyToCreateGtasItem[];
  owners: ImportMassiveAnimalsBodyToCreateOwnersItem[];
  oxenPurchase: ImportMassiveAnimalsBodyToCreateOxenPurchase;
};

export type ImportMassiveAnimalsBodyToCreateAnimalsItemSisbov = number | null;

export type ImportMassiveAnimalsBodyToCreateAnimalsItemGender =
  (typeof ImportMassiveAnimalsBodyToCreateAnimalsItemGender)[keyof typeof ImportMassiveAnimalsBodyToCreateAnimalsItemGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportMassiveAnimalsBodyToCreateAnimalsItemGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export type ImportMassiveAnimalsBodyToCreateAnimalsItem = {
  ageInMonths: number;
  batchName: string;
  breed: string;
  breedFarm: string;
  electronic: string;
  gender: ImportMassiveAnimalsBodyToCreateAnimalsItemGender;
  gtaNumber: string;
  ownerName: string;
  sisbov: ImportMassiveAnimalsBodyToCreateAnimalsItemSisbov;
  weight: number;
};

export type ImportMassiveAnimalsBodyMeta = {
  /** UUID gerado pelo client. Permite identificar a operação em logs. */
  clientRequestId: string;
  /** Dia da fazenda em UTC, usado como `createdAt`/`emission`/`entry` etc. */
  farmDayUTC: string;
};

export type ImportMassiveAnimalsBodyExistingOxenPurchaseAnyOf = {
  id: number;
};

export type ImportMassiveAnimalsBodyExistingOxenPurchase =
  ImportMassiveAnimalsBodyExistingOxenPurchaseAnyOf | null;

export type ImportMassiveAnimalsBodyExistingOwnersItem = {
  id: number;
  name: string;
};

export type ImportMassiveAnimalsBodyExistingGtasItem = {
  id: number;
  number: string;
};

export type ImportMassiveAnimalsBodyExistingEstablishmentsItem = {
  id: number;
  name: string;
};

export type ImportMassiveAnimalsBodyExistingCorralsItem = {
  id: number;
  name: string;
};

export type ImportMassiveAnimalsBodyExistingBatchesItem = {
  corral: string;
  corralId: number;
  id: number;
  name: string;
};

export type ImportMassiveAnimalsBodyExisting = {
  batches: ImportMassiveAnimalsBodyExistingBatchesItem[];
  corrals: ImportMassiveAnimalsBodyExistingCorralsItem[];
  establishments: ImportMassiveAnimalsBodyExistingEstablishmentsItem[];
  gtas: ImportMassiveAnimalsBodyExistingGtasItem[];
  owners: ImportMassiveAnimalsBodyExistingOwnersItem[];
  oxenPurchase: ImportMassiveAnimalsBodyExistingOxenPurchase;
};

export type ImportExcelValidationResultSummary = {
  errors: number;
  pending: number;
  total: number;
  valid: number;
};

export interface ImportExcelValidationResult {
  errors: ErrorOx[];
  inferredBatchIds: number[];
  pending: PendingOx[];
  summary: ImportExcelValidationResultSummary;
  valid: ValidOx[];
}

export interface ImportExcelValidateBody {
  filename: string;
}

export type ImportCattleManifestResponseOxenUpdatedItem = {
  id: number;
};

export interface ImportCattleManifestResponse {
  errors: CattleManifestRowError[];
  notFoundOxen: string[];
  oxenUpdated: ImportCattleManifestResponseOxenUpdatedItem[];
}

export interface ImportCattleManifestBody {
  atSignPrice?: number;
  filename: string;
  invoice?: string;
}

export interface IdentificationOx {
  ageInMonths: number;
  /** O batch que o boi vai começar */
  batchId: number;
  dentitionStage?: EnumsDentitionStage;
  /** Dados do brinco eletrônico */
  electronic?: string;
  /** Id do protocolo de saúde */
  extraMedicineIds?: number[];
  gender?: EnumsOxGender;
  /** Id da gta */
  gtaId?: number;
  /** Id do protocolo de saúde */
  healthProtocolId?: number;
  identifiedAt?: string;
  identifier?: string;
  sisbov?: number;
  weight: number;
}

export interface HttpError {
  code?: string;
  error?: string;
  message?: string;
  statusCode?: number;
}

export type HoldingBatchSaleResponseName = string | null;

export type HoldingBatchSaleResponseExitTruckSaleOrderId = number | null;

export type HoldingBatchSaleResponseExitTruckSaleId = number | null;

export type HoldingBatchSaleResponseExitTruckPlate = string | null;

export type HoldingBatchSaleResponseExitTruckName = string | null;

export type HoldingBatchSaleResponseExitTruckInfo = string | null;

export type HoldingBatchSaleResponseExitTruckHoldingSaleId = number | null;

export type HoldingBatchSaleResponseExitTruckExitGtaSeries = string | null;

export type HoldingBatchSaleResponseExitTruckExitGta = string | null;

export type HoldingBatchSaleResponseExitTruckDestinyId = number | null;

export type HoldingBatchSaleResponseExitTruckBigWeighingMachineWeightKg =
  | number
  | null;

export type HoldingBatchSaleResponseExitTruckAnnouncementId = number | null;

export type HoldingBatchSaleResponseExitTruck = {
  announcementId: HoldingBatchSaleResponseExitTruckAnnouncementId;
  bigWeighingMachineWeightKg: HoldingBatchSaleResponseExitTruckBigWeighingMachineWeightKg;
  capacity: number;
  destinyId: HoldingBatchSaleResponseExitTruckDestinyId;
  exitAt: string;
  exitGta: HoldingBatchSaleResponseExitTruckExitGta;
  exitGtaSeries: HoldingBatchSaleResponseExitTruckExitGtaSeries;
  farmId: number;
  holdingSaleId: HoldingBatchSaleResponseExitTruckHoldingSaleId;
  id: number;
  info: HoldingBatchSaleResponseExitTruckInfo;
  isVisible: boolean;
  name: HoldingBatchSaleResponseExitTruckName;
  plate: HoldingBatchSaleResponseExitTruckPlate;
  reason: EnumsExitReason;
  saleId: HoldingBatchSaleResponseExitTruckSaleId;
  saleOrderId: HoldingBatchSaleResponseExitTruckSaleOrderId;
  status: EnumsExitTruckStatus;
};

export interface HoldingBatchSaleResponse {
  batchId: number;
  date: string;
  exitTruck: HoldingBatchSaleResponseExitTruck;
  id: number;
  name: HoldingBatchSaleResponseName;
}

export interface HealthCheckResponse {
  database: string;
  environment: string;
  status: string;
  uptime: number;
  version: string;
}

export interface GtaFilter {
  announcementEmmited?: boolean;
  completed?: boolean;
  gtaId?: number;
  originResponsibleId?: number;
  withoutPurchases?: boolean;
}

export type GradeMethod = EnumsGradeMethod;

export type GetZootechnicalReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetZootechnicalReportXlsxResponse =
  | GetZootechnicalReportXlsxResponseAnyOf
  | GetZootechnicalReportXlsxResponseAnyOfThree;

export type GetZootechnicalReportXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GetZootechnicalReportXlsxResponseAnyOf = {
  buffer: GetZootechnicalReportXlsxResponseAnyOfBuffer;
};

export type GetWeightingMapResponseTotalWeight = number | null;

export type GetWeightingMapResponseTotalPurchase = number | null;

export type GetWeightingMapResponseSupplementedRearingModality =
  EnumsSupplementedRearingModality | null;

export type GetWeightingMapResponseStartTime = string | null;

export type GetWeightingMapResponseReferenceCode = string | null;

export type GetWeightingMapResponsePurchaseId = number | null;

export type GetWeightingMapResponsePricePerArroba = number | null;

export type GetWeightingMapResponseNetWeight = number | null;

export interface GetWeightingMapResponse {
  averageWeight: GetWeightingMapResponseAverageWeight;
  buyer: GetWeightingMapResponseBuyer;
  buyerId: number;
  carcassYield: GetWeightingMapResponseCarcassYield;
  closingTime: GetWeightingMapResponseClosingTime;
  commission: number;
  emissionDate: string;
  endTime: GetWeightingMapResponseEndTime;
  farmId: number;
  fastingDate: GetWeightingMapResponseFastingDate;
  grossWeight: GetWeightingMapResponseGrossWeight;
  gtas: GetWeightingMapResponseGtasItem[];
  id: number;
  invoices: GetWeightingMapResponseInvoicesItem[];
  netWeight: GetWeightingMapResponseNetWeight;
  pricePerArroba: GetWeightingMapResponsePricePerArroba;
  purchaseId: GetWeightingMapResponsePurchaseId;
  referenceCode: GetWeightingMapResponseReferenceCode;
  shippingCost: number;
  startTime: GetWeightingMapResponseStartTime;
  status: EnumsWeightingMapStatus;
  supplementedRearingModality: GetWeightingMapResponseSupplementedRearingModality;
  totalPurchase: GetWeightingMapResponseTotalPurchase;
  totalWeight: GetWeightingMapResponseTotalWeight;
  weighingDate: string;
}

export type GetWeightingMapResponseInvoicesItemWeightingMapId = number | null;

export type GetWeightingMapResponseInvoicesItemSaleOrderId = number | null;

export type GetWeightingMapResponseInvoicesItemIsComplement = boolean | null;

export type GetWeightingMapResponseInvoicesItemExitTruckId = number | null;

export type GetWeightingMapResponseInvoicesItemEmittedAt = string | null;

export type GetWeightingMapResponseInvoicesItem = {
  emittedAt: GetWeightingMapResponseInvoicesItemEmittedAt;
  exitTruckId: GetWeightingMapResponseInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: GetWeightingMapResponseInvoicesItemIsComplement;
  number: string;
  saleOrderId: GetWeightingMapResponseInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: GetWeightingMapResponseInvoicesItemWeightingMapId;
};

export type GetWeightingMapResponseGtasItemWeightingMapId = number | null;

export type GetWeightingMapResponseGtasItemWeightAverage = number | null;

export type GetWeightingMapResponseGtasItemPurchaseId = number | null;

export type GetWeightingMapResponseGtasItemOriginWeightAverage = number | null;

export type GetWeightingMapResponseGtasItemOrigin = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: GetWeightingMapResponseGtasItemOriginCattleManifestLayoutId;
  code: GetWeightingMapResponseGtasItemOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetWeightingMapResponseGtasItemOriginResponsible;
  responsibleId: number;
};

export type GetWeightingMapResponseGtasItem = {
  _count: _GetWeightingMapResponseGtasItemCount;
  ages: GetWeightingMapResponseGtasItemAgesItem[];
  completed: boolean;
  description: GetWeightingMapResponseGtasItemDescription;
  destinyId: GetWeightingMapResponseGtasItemDestinyId;
  distance: GetWeightingMapResponseGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: GetWeightingMapResponseGtasItemHours;
  id: number;
  invoice: GetWeightingMapResponseGtasItemInvoice;
  number: string;
  origin: GetWeightingMapResponseGtasItemOrigin;
  originId: number;
  originWeightAverage: GetWeightingMapResponseGtasItemOriginWeightAverage;
  purchaseId: GetWeightingMapResponseGtasItemPurchaseId;
  series: string;
  weightAverage: GetWeightingMapResponseGtasItemWeightAverage;
  weightingMapId: GetWeightingMapResponseGtasItemWeightingMapId;
};

export type GetWeightingMapResponseGtasItemOriginResponsiblePhone =
  | string
  | null;

export type GetWeightingMapResponseGtasItemOriginResponsibleDocument =
  | string
  | null;

export type GetWeightingMapResponseGtasItemOriginResponsibleDescription =
  | string
  | null;

export type GetWeightingMapResponseGtasItemOriginResponsibleCode =
  | string
  | null;

export type GetWeightingMapResponseGtasItemOriginResponsible = {
  code: GetWeightingMapResponseGtasItemOriginResponsibleCode;
  createdAt: string;
  description: GetWeightingMapResponseGtasItemOriginResponsibleDescription;
  document: GetWeightingMapResponseGtasItemOriginResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetWeightingMapResponseGtasItemOriginResponsiblePhone;
  profiles: EnumsProfile[];
};

export type GetWeightingMapResponseGtasItemOriginCode = string | null;

export type GetWeightingMapResponseGtasItemOriginCattleManifestLayoutId =
  | number
  | null;

export type GetWeightingMapResponseGtasItemInvoice = string | null;

export type GetWeightingMapResponseGtasItemHours = number | null;

export type GetWeightingMapResponseGtasItemDistance = number | null;

export type GetWeightingMapResponseGtasItemDestinyId = number | null;

export type GetWeightingMapResponseGtasItemDescription = string | null;

export type GetWeightingMapResponseGtasItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  yearsOld: number;
};

export type _GetWeightingMapResponseGtasItemCount = {
  oxen: number;
};

export type GetWeightingMapResponseGrossWeight = number | null;

export type GetWeightingMapResponseFastingDate = string | null;

export type GetWeightingMapResponseEndTime = string | null;

export type GetWeightingMapResponseClosingTime = string | null;

export type GetWeightingMapResponseCarcassYield = number | null;

export type GetWeightingMapResponseBuyerPhone = string | null;

export type GetWeightingMapResponseBuyerDocument = string | null;

export type GetWeightingMapResponseBuyerDescription = string | null;

export type GetWeightingMapResponseBuyerCode = string | null;

export type GetWeightingMapResponseBuyer = {
  code: GetWeightingMapResponseBuyerCode;
  createdAt: string;
  description: GetWeightingMapResponseBuyerDescription;
  document: GetWeightingMapResponseBuyerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetWeightingMapResponseBuyerPhone;
  profiles: EnumsProfile[];
};

export type GetWeightingMapResponseAverageWeight = number | null;

export type GetWeightGainCurveByIdResponse =
  | BiotypeWeightGainCurve
  | BatchWeightGainCurve;

export interface GetWeightConfigResponse {
  entryWeightMax: number;
  entryWeightMin: number;
}

export interface GetWeightBreakGoal {
  goalPercent: number;
  id: number;
  lowerDistance: number;
  startedAt: string;
  upperDistance: number;
}

export type GetWeightBreakGoalsResponse = GetWeightBreakGoal[];

export type GetWeighingReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetWeighingReportXlsxResponse =
  | GetWeighingReportXlsxResponseAnyOf
  | GetWeighingReportXlsxResponseAnyOfThree;

export type GetWeighingReportXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type GetWeighingReportXlsxResponseAnyOf = {
  buffer: GetWeighingReportXlsxResponseAnyOfBuffer;
};

export interface GetWeighingReportResponse {
  isCompleted: boolean;
  report: WeighingReportResponse;
}

export interface GetVersionResponse {
  alpha?: string;
  beta?: string;
  gamma?: string;
  version?: string;
}

export type GetUnusabilityAnnouncementResponseUnusabilitiesItem = {
  brand: string;
  observation?: string;
  sisbov: number;
};

export type GetUnusabilityAnnouncementResponseOriginOwnerItemDocument =
  | string
  | null;

export type GetUnusabilityAnnouncementResponseOriginOwnerItem = {
  document: GetUnusabilityAnnouncementResponseOriginOwnerItemDocument;
  name: string;
};

export type GetUnusabilityAnnouncementResponseOriginAddress = {
  city: string;
  state: string;
};

export type GetUnusabilityAnnouncementResponseOrigin = {
  address: GetUnusabilityAnnouncementResponseOriginAddress;
  id: number;
  name: string;
  owner: GetUnusabilityAnnouncementResponseOriginOwnerItem[];
  propertyCode: string[];
};

export interface GetUnusabilityAnnouncementResponse {
  origin: GetUnusabilityAnnouncementResponseOrigin;
  unusabilities: GetUnusabilityAnnouncementResponseUnusabilitiesItem[];
}

export interface GetTuckDetailsResponse {
  covWeight: number;
  gmd: number;
  totalBoarded: number;
  totalWeight: number;
  truck: GetTuckDetailsResponseTruck;
  weightAverage: number;
}

export type GetTuckDetailsResponseTruckSaleOrderId = number | null;

export type GetTuckDetailsResponseTruckSaleId = number | null;

export type GetTuckDetailsResponseTruckPlate = string | null;

export type GetTuckDetailsResponseTruckName = string | null;

export type GetTuckDetailsResponseTruckInfo = string | null;

export type GetTuckDetailsResponseTruckHoldingSaleId = number | null;

export type GetTuckDetailsResponseTruckExitGtaSeries = string | null;

export type GetTuckDetailsResponseTruckExitGta = string | null;

export type GetTuckDetailsResponseTruckDestinyId = number | null;

export type GetTuckDetailsResponseTruckBoardingItemWeightsItemAnyOfWeight =
  | number
  | null;

export type GetTuckDetailsResponseTruckBoardingItemWeightsItemAnyOfSisbov =
  | string
  | null;

export type GetTuckDetailsResponseTruckBoardingItemWeightsItemAnyOf = {
  oxId?: number;
  sisbov?: GetTuckDetailsResponseTruckBoardingItemWeightsItemAnyOfSisbov;
  weight: GetTuckDetailsResponseTruckBoardingItemWeightsItemAnyOfWeight;
};

export type GetTuckDetailsResponseTruckBoardingItemWeightsItem =
  | GetTuckDetailsResponseTruckBoardingItemWeightsItemAnyOf
  | unknown;

export type GetTuckDetailsResponseTruckBoardingItemStartOfTreatment =
  | string
  | null;

export type GetTuckDetailsResponseTruckBoardingItemSisbov = string | null;

export type GetTuckDetailsResponseTruckBoardingItemSalesMarketType =
  EnumsSalesMarketType | null;

export type GetTuckDetailsResponseTruckBoardingItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetTuckDetailsResponseTruckBoardingItemReversedDeathDetails =
  | string
  | null;

export type GetTuckDetailsResponseTruckBoardingItemReversedDeathDate =
  | string
  | null;

export type GetTuckDetailsResponseTruckBoardingItemReversedDeathCause =
  EnumsDeathCause | null;

export type GetTuckDetailsResponseTruckBoardingItemPurchaseId = number | null;

export type GetTuckDetailsResponseTruckBoardingItemOtherDeathCause =
  | string
  | null;

export type GetTuckDetailsResponseTruckBoardingItemIsNecropsyPerformed =
  | boolean
  | null;

export type GetTuckDetailsResponseTruckBoardingItemInvoice = string | null;

export type GetTuckDetailsResponseTruckBoardingItemInternalSaleId =
  | number
  | null;

export type GetTuckDetailsResponseTruckBoardingItemIdentifier = string | null;

export type GetTuckDetailsResponseTruckBoardingItemIdentifiedAt = string | null;

export type GetTuckDetailsResponseTruckBoardingItemIdentificationSource =
  EnumsIdentificationSource | null;

export type GetTuckDetailsResponseTruckBoardingItemHasBirthAnnouncement =
  | boolean
  | null;

export type GetTuckDetailsResponseTruckBoardingItemGtaId = number | null;

export type GetTuckDetailsResponseTruckBoardingItemExitTruckId = number | null;

export type GetTuckDetailsResponseTruckBoardingItemElectronic = string | null;

export type GetTuckDetailsResponseTruckBoardingItemDiedAt = string | null;

export type GetTuckDetailsResponseTruckBoardingItemDentitionStage =
  EnumsDentitionStage | null;

export type GetTuckDetailsResponseTruckBoardingItemDeathReason =
  EnumsDeathCause | null;

export type GetTuckDetailsResponseTruckBoardingItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetTuckDetailsResponseTruckBoardingItemDeathDetails = string | null;

export type GetTuckDetailsResponseTruckBoardingItemDeathCause =
  EnumsDeathCause | null;

export type GetTuckDetailsResponseTruckBoardingItemComments = string | null;

export type GetTuckDetailsResponseTruckBoardingItemCertifierDate =
  | string
  | null;

export type GetTuckDetailsResponseTruckBoardingItemCattleManifestId =
  | number
  | null;

export type GetTuckDetailsResponseTruckBoardingItemCarcassWeight =
  | number
  | null;

export type GetTuckDetailsResponseTruckBoardingItemCarcassType =
  EnumsCarcassType | null;

export type GetTuckDetailsResponseTruckBoardingItemCarcass = number | null;

export type GetTuckDetailsResponseTruckBoardingItemBornOnFarm = boolean | null;

export type GetTuckDetailsResponseTruckBoardingItemBndTracked = boolean | null;

export type GetTuckDetailsResponseTruckBoardingItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: GetTuckDetailsResponseTruckBoardingItemBndTracked;
  bornOnFarm: GetTuckDetailsResponseTruckBoardingItemBornOnFarm;
  breed: string;
  carcass: GetTuckDetailsResponseTruckBoardingItemCarcass;
  carcassPrice: number;
  carcassType: GetTuckDetailsResponseTruckBoardingItemCarcassType;
  carcassWeight: GetTuckDetailsResponseTruckBoardingItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: GetTuckDetailsResponseTruckBoardingItemCattleManifestId;
  certifierDate: GetTuckDetailsResponseTruckBoardingItemCertifierDate;
  comments: GetTuckDetailsResponseTruckBoardingItemComments;
  deathCause: GetTuckDetailsResponseTruckBoardingItemDeathCause;
  deathDetails: GetTuckDetailsResponseTruckBoardingItemDeathDetails;
  deathNecropsy: GetTuckDetailsResponseTruckBoardingItemDeathNecropsy;
  deathReason: GetTuckDetailsResponseTruckBoardingItemDeathReason;
  dentitionStage: GetTuckDetailsResponseTruckBoardingItemDentitionStage;
  diedAt: GetTuckDetailsResponseTruckBoardingItemDiedAt;
  electronic: GetTuckDetailsResponseTruckBoardingItemElectronic;
  exitTruckId: GetTuckDetailsResponseTruckBoardingItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: GetTuckDetailsResponseTruckBoardingItemGtaId;
  hasBirthAnnouncement: GetTuckDetailsResponseTruckBoardingItemHasBirthAnnouncement;
  id: number;
  identificationSource: GetTuckDetailsResponseTruckBoardingItemIdentificationSource;
  identifiedAt: GetTuckDetailsResponseTruckBoardingItemIdentifiedAt;
  identifier: GetTuckDetailsResponseTruckBoardingItemIdentifier;
  includedAt: string;
  internalSaleId: GetTuckDetailsResponseTruckBoardingItemInternalSaleId;
  invoice: GetTuckDetailsResponseTruckBoardingItemInvoice;
  isNecropsyPerformed: GetTuckDetailsResponseTruckBoardingItemIsNecropsyPerformed;
  otherDeathCause: GetTuckDetailsResponseTruckBoardingItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: number;
  priceAtSignExit: number;
  purchaseId: GetTuckDetailsResponseTruckBoardingItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: GetTuckDetailsResponseTruckBoardingItemReversedDeathCause;
  reversedDeathDate: GetTuckDetailsResponseTruckBoardingItemReversedDeathDate;
  reversedDeathDetails: GetTuckDetailsResponseTruckBoardingItemReversedDeathDetails;
  reversedDeathNecropsy: GetTuckDetailsResponseTruckBoardingItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: GetTuckDetailsResponseTruckBoardingItemSalesMarketType;
  sisbov: GetTuckDetailsResponseTruckBoardingItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: GetTuckDetailsResponseTruckBoardingItemStartOfTreatment;
  variety: string;
  weights: GetTuckDetailsResponseTruckBoardingItemWeightsItem[];
};

export type GetTuckDetailsResponseTruckBigWeighingMachineWeightKg =
  | number
  | null;

export type GetTuckDetailsResponseTruckAnnouncementId = number | null;

export type GetTuckDetailsResponseTruck = {
  announcementId: GetTuckDetailsResponseTruckAnnouncementId;
  bigWeighingMachineWeightKg: GetTuckDetailsResponseTruckBigWeighingMachineWeightKg;
  boarding: GetTuckDetailsResponseTruckBoardingItem[];
  capacity: number;
  destinyId: GetTuckDetailsResponseTruckDestinyId;
  exitAt: string;
  exitGta: GetTuckDetailsResponseTruckExitGta;
  exitGtaSeries: GetTuckDetailsResponseTruckExitGtaSeries;
  farmId: number;
  holdingSaleId: GetTuckDetailsResponseTruckHoldingSaleId;
  id: number;
  info: GetTuckDetailsResponseTruckInfo;
  isVisible: boolean;
  name: GetTuckDetailsResponseTruckName;
  plate: GetTuckDetailsResponseTruckPlate;
  reason: EnumsExitReason;
  saleId: GetTuckDetailsResponseTruckSaleId;
  saleOrderId: GetTuckDetailsResponseTruckSaleOrderId;
  status: EnumsExitTruckStatus;
};

export type GetTroughReadingReportResponse = TroughReadingReportRow[];

export type GetTroughManagementGraphResponse = TroughManagementGraphReturn[];

export interface GetTreatViewTypeResponse {
  treatViewType: EnumsTreatViewType;
}

export type GetTraceabilitySheetDataType =
  (typeof GetTraceabilitySheetDataType)[keyof typeof GetTraceabilitySheetDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTraceabilitySheetDataType = {
  R: "R",
  E: "E",
  N: "N",
} as const;

export interface GetTraceabilitySheetData {
  purchaseId: number;
  type: GetTraceabilitySheetDataType;
}

export type GetStockTimelineResponse = StockTimelineDay[];

export type GetStockResponseAnyOfPremixIngredientsItem = {
  id: number;
  percentage: number;
  premixId: number;
  stock: GetStockResponseAnyOfPremixIngredientsItemStock;
  stockId: number;
};

export type GetStockResponseAnyOf = {
  active: GetStockResponseAnyOfActive;
  changes: GetStockResponseAnyOfChangesItem[];
  code: string;
  elg: number;
  elm: number;
  farmId: number;
  id: number;
  kiloPrice: number;
  loadMode: EnumsLoadMode;
  name: string;
  naturalMatter: number;
  naturalMatterFactor: number;
  premix: GetStockResponseAnyOfPremix;
  premixIngredients: GetStockResponseAnyOfPremixIngredientsItem[];
  supplement: boolean;
  used: boolean;
};

export type GetStockResponse = GetStockResponseAnyOf | unknown;

export type GetStockResponseAnyOfPremixIngredientsItemStockPremix =
  | boolean
  | null;

export type GetStockResponseAnyOfPremixIngredientsItemStockActive =
  | boolean
  | null;

export type GetStockResponseAnyOfPremixIngredientsItemStock = {
  active: GetStockResponseAnyOfPremixIngredientsItemStockActive;
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: GetStockResponseAnyOfPremixIngredientsItemStockPremix;
  supplement: boolean;
};

export type GetStockResponseAnyOfPremix = boolean | null;

export type GetStockResponseAnyOfChangesItem = {
  date: string;
  elg: number;
  elm: number;
  kiloPrice: number;
  naturalMatterFactor: number;
};

export type GetStockResponseAnyOfActive = boolean | null;

export interface GetStockAverageInfoResponse {
  elg: number;
  elm: number;
  kiloPrice: number;
  naturalMatterFactor: number;
}

export type GetStackedAnalyticalReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GetStackedAnalyticalReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GetStackedAnalyticalReportExcelResponseAnyOf = {
  buffer: GetStackedAnalyticalReportExcelResponseAnyOfBuffer;
};

export type GetStackedAnalyticalReportExcelResponse =
  | GetStackedAnalyticalReportExcelResponseAnyOf
  | GetStackedAnalyticalReportExcelResponseAnyOfThree;

export interface GetSlaughterScaleReportResponse {
  day: string;
  isCompleted: boolean;
  report: SlaughterScaleReportDataResponseItem[];
}

export type GetSheetDataResponsePersonDocument = string | null;

export interface GetSheetDataResponse {
  earringManufacturer?: string;
  earringsPerPage: number;
  farmAddress: string;
  farmCityState: string;
  farmName: string;
  oxen: GetSheetDataResponseOxenItemItem[][];
  personDocument: GetSheetDataResponsePersonDocument;
  personName: string;
}

export type GetSheetDataResponseOxenItemItemReason =
  (typeof GetSheetDataResponseOxenItemItemReason)[keyof typeof GetSheetDataResponseOxenItemItemReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSheetDataResponseOxenItemItemReason = {
  R: "R",
  E: "E",
  N: "N",
} as const;

export type GetSheetDataResponseOxenItemItemIncludedAt = string | null;

export type GetSheetDataResponseOxenItemItemGta = {
  number: string;
};

export type GetSheetDataResponseOxenItemItemGender = EnumsOxGender | null;

export type GetSheetDataResponseOxenItemItemBreed = string | null;

export type GetSheetDataResponseOxenItemItemBirth = string | null;

export type GetSheetDataResponseOxenItemItemAge = number | null;

export type GetSheetDataResponseOxenItemItem = {
  age: GetSheetDataResponseOxenItemItemAge;
  birth: GetSheetDataResponseOxenItemItemBirth;
  bornOnFarm: boolean;
  breed: GetSheetDataResponseOxenItemItemBreed;
  gender: GetSheetDataResponseOxenItemItemGender;
  gta: GetSheetDataResponseOxenItemItemGta;
  includedAt: GetSheetDataResponseOxenItemItemIncludedAt;
  isLeftingEarring?: boolean;
  managementNumber: string;
  reason: GetSheetDataResponseOxenItemItemReason;
  sisbov: string;
  sisbovHistory: string[];
};

export interface GetSeedResponse {
  msg: string;
}

export type GetSaleOrderWeightsResponseExitWeightAverage = number | null;

export interface GetSaleOrderWeightsResponse {
  exitWeightAverage: GetSaleOrderWeightsResponseExitWeightAverage;
}

export type GetSaleOrderByIdResponseTypeOfClosed = EnumsSaleOrderType | null;

export type GetSaleOrderByIdResponseTrucksItemSaleOrderId = number | null;

export type GetSaleOrderByIdResponseTrucksItemSaleId = number | null;

export type GetSaleOrderByIdResponseTrucksItemPlate = string | null;

export type GetSaleOrderByIdResponseTrucksItemName = string | null;

export type GetSaleOrderByIdResponseTrucksItem = {
  announcementId: GetSaleOrderByIdResponseTrucksItemAnnouncementId;
  bigWeighingMachineWeightKg: GetSaleOrderByIdResponseTrucksItemBigWeighingMachineWeightKg;
  boarding: GetSaleOrderByIdResponseTrucksItemBoardingItem[];
  capacity: number;
  destiny: GetSaleOrderByIdResponseTrucksItemDestiny;
  destinyId: GetSaleOrderByIdResponseTrucksItemDestinyId;
  exitAt: string;
  exitGta: GetSaleOrderByIdResponseTrucksItemExitGta;
  exitGtaSeries: GetSaleOrderByIdResponseTrucksItemExitGtaSeries;
  farmId: number;
  holdingSaleId: GetSaleOrderByIdResponseTrucksItemHoldingSaleId;
  id: number;
  info: GetSaleOrderByIdResponseTrucksItemInfo;
  invoices: GetSaleOrderByIdResponseTrucksItemInvoicesItem[];
  isVisible: boolean;
  name: GetSaleOrderByIdResponseTrucksItemName;
  oxenAmount: number;
  plate: GetSaleOrderByIdResponseTrucksItemPlate;
  reason: EnumsExitReason;
  saleId: GetSaleOrderByIdResponseTrucksItemSaleId;
  saleOrderId: GetSaleOrderByIdResponseTrucksItemSaleOrderId;
  status: EnumsExitTruckStatus;
  totalWeights: number;
};

export interface GetSaleOrderByIdResponse {
  announcementId: GetSaleOrderByIdResponseAnnouncementId;
  atSignPrice: GetSaleOrderByIdResponseAtSignPrice;
  batches: GetSaleOrderByIdResponseBatchesItem[];
  bonusPercent: GetSaleOrderByIdResponseBonusPercent;
  cattleManifest: GetSaleOrderByIdResponseCattleManifest;
  complementInvoices: GetSaleOrderByIdResponseComplementInvoicesItem[];
  createdAt: string;
  createdBy: number;
  destiny: GetSaleOrderByIdResponseDestiny;
  destinyId: number;
  exitWeightAverage: number;
  expirationDay: string;
  farmId: number;
  freightPerAtSignBRL: GetSaleOrderByIdResponseFreightPerAtSignBRL;
  id: number;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF: GetSaleOrderByIdResponsePartnerAtSignPriceF;
  partnerAtSignPriceM: GetSaleOrderByIdResponsePartnerAtSignPriceM;
  partnerClosureId: GetSaleOrderByIdResponsePartnerClosureId;
  paymentMethod: string;
  saleDate: string;
  sourceType: GetSaleOrderByIdResponseSourceType;
  status: EnumsSaleOrderStatus;
  totalSlaughter: number;
  trucks: GetSaleOrderByIdResponseTrucksItem[];
  typeOfClosed: GetSaleOrderByIdResponseTypeOfClosed;
}

export type GetSaleOrderByIdResponseTrucksItemInvoicesItemWeightingMapId =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemInvoicesItemSaleOrderId =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemInvoicesItemIsComplement =
  | boolean
  | null;

export type GetSaleOrderByIdResponseTrucksItemInvoicesItemExitTruckId =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemInvoicesItemEmittedAt =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemInvoicesItem = {
  emittedAt: GetSaleOrderByIdResponseTrucksItemInvoicesItemEmittedAt;
  exitTruckId: GetSaleOrderByIdResponseTrucksItemInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: GetSaleOrderByIdResponseTrucksItemInvoicesItemIsComplement;
  number: string;
  saleOrderId: GetSaleOrderByIdResponseTrucksItemInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: GetSaleOrderByIdResponseTrucksItemInvoicesItemWeightingMapId;
};

export type GetSaleOrderByIdResponseTrucksItemInfo = string | null;

export type GetSaleOrderByIdResponseTrucksItemHoldingSaleId = number | null;

export type GetSaleOrderByIdResponseTrucksItemExitGtaSeries = string | null;

export type GetSaleOrderByIdResponseTrucksItemExitGta = string | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyId = number | null;

export type GetSaleOrderByIdResponseTrucksItemDestiny =
  GetSaleOrderByIdResponseTrucksItemDestinyAnyOf | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsiblePhone =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsibleDocument =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsibleDescription =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsibleCode =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsible = {
  code: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsibleCode;
  createdAt: string;
  description: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsibleDescription;
  document: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsiblePhone;
  profiles: EnumsProfile[];
};

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfCode = string | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfCattleManifestLayoutId =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOf = {
  active: boolean;
  address: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddress;
  addressId: number;
  cattleManifestLayoutId: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfCattleManifestLayoutId;
  code: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfResponsible;
  responsibleId: number;
};

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressStreet =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressNumber =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressNeighborhood =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressComplement =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddress = {
  city: string;
  complement: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressComplement;
  country: string;
  id: number;
  neighborhood: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressNeighborhood;
  number: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressNumber;
  state: string;
  street: GetSaleOrderByIdResponseTrucksItemDestinyAnyOfAddressStreet;
  zip: string;
};

export type GetSaleOrderByIdResponseTrucksItemBoardingItemWeightsItemType =
  EnumsWeightType | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemWeightsItem = {
  date: string;
  id: number;
  oxId: number;
  source: EnumsWeightSource;
  type: GetSaleOrderByIdResponseTrucksItemBoardingItemWeightsItemType;
  weight: number;
};

export type GetSaleOrderByIdResponseTrucksItemBoardingItemStartOfTreatment =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemSisbov =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemSalesMarketType =
  EnumsSalesMarketType | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemSaleOrderPenaltyItem =
  {
    id: number;
  };

export type GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathDetails =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathDate =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathCause =
  EnumsDeathCause | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemPurchaseId =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemPriceAtSignExit =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemPriceAtSignEntry =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemOtherDeathCause =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemIsNecropsyPerformed =
  | boolean
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemInvoice =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemInternalSaleId =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemIdentifier =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemIdentifiedAt =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemIdentificationSource =
  EnumsIdentificationSource | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemHasBirthAnnouncement =
  boolean | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemGtaId = number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemExitTruckId =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemElectronic =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemDiedAt =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemDentitionStage =
  EnumsDentitionStage | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemDeathReason =
  EnumsDeathCause | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemDeathDetails =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemDeathCause =
  EnumsDeathCause | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemComments =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemCertifierDate =
  | string
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemCattleManifestId =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemCarcassWeight =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemCarcassType =
  EnumsCarcassType | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemCarcassPrice =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemCarcass =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBornOnFarm =
  | boolean
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBndTracked =
  | boolean
  | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItem = {
  batches: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItem[];
  birth: string;
  blockedUntil: string;
  bndTracked: GetSaleOrderByIdResponseTrucksItemBoardingItemBndTracked;
  bornOnFarm: GetSaleOrderByIdResponseTrucksItemBoardingItemBornOnFarm;
  breed: string;
  carcass: GetSaleOrderByIdResponseTrucksItemBoardingItemCarcass;
  carcassPrice: GetSaleOrderByIdResponseTrucksItemBoardingItemCarcassPrice;
  carcassType: GetSaleOrderByIdResponseTrucksItemBoardingItemCarcassType;
  carcassWeight: GetSaleOrderByIdResponseTrucksItemBoardingItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: GetSaleOrderByIdResponseTrucksItemBoardingItemCattleManifestId;
  certifierDate: GetSaleOrderByIdResponseTrucksItemBoardingItemCertifierDate;
  comments: GetSaleOrderByIdResponseTrucksItemBoardingItemComments;
  deathCause: GetSaleOrderByIdResponseTrucksItemBoardingItemDeathCause;
  deathDetails: GetSaleOrderByIdResponseTrucksItemBoardingItemDeathDetails;
  deathNecropsy: GetSaleOrderByIdResponseTrucksItemBoardingItemDeathNecropsy;
  deathReason: GetSaleOrderByIdResponseTrucksItemBoardingItemDeathReason;
  dentitionStage: GetSaleOrderByIdResponseTrucksItemBoardingItemDentitionStage;
  diedAt: GetSaleOrderByIdResponseTrucksItemBoardingItemDiedAt;
  electronic: GetSaleOrderByIdResponseTrucksItemBoardingItemElectronic;
  exitTruckId: GetSaleOrderByIdResponseTrucksItemBoardingItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: GetSaleOrderByIdResponseTrucksItemBoardingItemGtaId;
  hasBirthAnnouncement: GetSaleOrderByIdResponseTrucksItemBoardingItemHasBirthAnnouncement;
  id: number;
  identificationSource: GetSaleOrderByIdResponseTrucksItemBoardingItemIdentificationSource;
  identifiedAt: GetSaleOrderByIdResponseTrucksItemBoardingItemIdentifiedAt;
  identifier: GetSaleOrderByIdResponseTrucksItemBoardingItemIdentifier;
  includedAt: string;
  internalSaleId: GetSaleOrderByIdResponseTrucksItemBoardingItemInternalSaleId;
  invoice: GetSaleOrderByIdResponseTrucksItemBoardingItemInvoice;
  isNecropsyPerformed: GetSaleOrderByIdResponseTrucksItemBoardingItemIsNecropsyPerformed;
  otherDeathCause: GetSaleOrderByIdResponseTrucksItemBoardingItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: GetSaleOrderByIdResponseTrucksItemBoardingItemPriceAtSignEntry;
  priceAtSignExit: GetSaleOrderByIdResponseTrucksItemBoardingItemPriceAtSignExit;
  purchaseId: GetSaleOrderByIdResponseTrucksItemBoardingItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathCause;
  reversedDeathDate: GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathDate;
  reversedDeathDetails: GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathDetails;
  reversedDeathNecropsy: GetSaleOrderByIdResponseTrucksItemBoardingItemReversedDeathNecropsy;
  runtime: number;
  SaleOrderPenalty: GetSaleOrderByIdResponseTrucksItemBoardingItemSaleOrderPenaltyItem[];
  salesMarketType: GetSaleOrderByIdResponseTrucksItemBoardingItemSalesMarketType;
  sisbov: GetSaleOrderByIdResponseTrucksItemBoardingItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: GetSaleOrderByIdResponseTrucksItemBoardingItemStartOfTreatment;
  variety: string;
  weights: GetSaleOrderByIdResponseTrucksItemBoardingItemWeightsItem[];
};

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemFinalizedAt =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemDescription =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItem = {
  batch: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatch;
  batchId: number;
  createdAt: string;
  description: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemDescription;
  finalizedAt: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemFinalizedAt;
  id: number;
  oxId: number;
};

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchScaledToSlaughter =
  boolean | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchOperationalCostGroupId =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchOldCorralId =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchHideFromTreatmentUntil =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchHideFromTreatment =
  boolean | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchForeseenSlaughterDate =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchFinalizedAt =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchDescrption =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCorralId =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassUniform =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassThin =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassMissing =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassMedium =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassExcessive =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchAdjustedPurchaseCost =
  number | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchActivationEditedAt =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchActivatedAt =
  string | null;

export type GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatch = {
  activatedAt: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassExcessive;
  carcassMedium: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassMedium;
  carcassMissing: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassMissing;
  carcassThin: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassThin;
  carcassUniform: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCarcassUniform;
  corralId: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchCorralId;
  createdAt: string;
  descrption: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchHideFromTreatment;
  hideFromTreatmentUntil: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchOldCorralId;
  operationalCostGroupId: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: GetSaleOrderByIdResponseTrucksItemBoardingItemBatchesItemBatchScaledToSlaughter;
};

export type GetSaleOrderByIdResponseTrucksItemBigWeighingMachineWeightKg =
  | number
  | null;

export type GetSaleOrderByIdResponseTrucksItemAnnouncementId = number | null;

export type GetSaleOrderByIdResponseSourceType =
  EnumsSaleOrderSourceType | null;

export type GetSaleOrderByIdResponsePartnerClosureId = number | null;

export type GetSaleOrderByIdResponsePartnerAtSignPriceM = number | null;

export type GetSaleOrderByIdResponsePartnerAtSignPriceF = number | null;

export type GetSaleOrderByIdResponseFreightPerAtSignBRL = number | null;

export type GetSaleOrderByIdResponseDestinyCode = string | null;

export type GetSaleOrderByIdResponseDestinyCattleManifestLayoutId =
  | number
  | null;

export type GetSaleOrderByIdResponseDestiny = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: GetSaleOrderByIdResponseDestinyCattleManifestLayoutId;
  code: GetSaleOrderByIdResponseDestinyCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsibleId: number;
};

export type GetSaleOrderByIdResponseComplementInvoicesItemWeightingMapId =
  | number
  | null;

export type GetSaleOrderByIdResponseComplementInvoicesItemSaleOrderId =
  | number
  | null;

export type GetSaleOrderByIdResponseComplementInvoicesItemIsComplement =
  | boolean
  | null;

export type GetSaleOrderByIdResponseComplementInvoicesItemExitTruckId =
  | number
  | null;

export type GetSaleOrderByIdResponseComplementInvoicesItemEmittedAt =
  | string
  | null;

export type GetSaleOrderByIdResponseComplementInvoicesItem = {
  emittedAt: GetSaleOrderByIdResponseComplementInvoicesItemEmittedAt;
  exitTruckId: GetSaleOrderByIdResponseComplementInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: GetSaleOrderByIdResponseComplementInvoicesItemIsComplement;
  number: string;
  saleOrderId: GetSaleOrderByIdResponseComplementInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: GetSaleOrderByIdResponseComplementInvoicesItemWeightingMapId;
};

export type GetSaleOrderByIdResponseCattleManifestAnyOf = {
  carcassExcessive: number;
  carcassMedium: number;
  carcassMissing: number;
  carcassThin: number;
  carcassUniform: number;
  createdAt: string;
  id: number;
  saleOrderId: number;
  updatedAt: string;
};

export type GetSaleOrderByIdResponseCattleManifest =
  GetSaleOrderByIdResponseCattleManifestAnyOf | null;

export type GetSaleOrderByIdResponseBonusPercent = number | null;

export type GetSaleOrderByIdResponseBatchesItemScaledToSlaughter =
  | boolean
  | null;

export type GetSaleOrderByIdResponseBatchesItemOperationalCostGroupId =
  | number
  | null;

export type GetSaleOrderByIdResponseBatchesItemOldCorralId = number | null;

export type GetSaleOrderByIdResponseBatchesItemHideFromTreatmentUntil =
  | string
  | null;

export type GetSaleOrderByIdResponseBatchesItemHideFromTreatment =
  | boolean
  | null;

export type GetSaleOrderByIdResponseBatchesItemForeseenSlaughterDate =
  | string
  | null;

export type GetSaleOrderByIdResponseBatchesItemFinalizedAt = string | null;

export type GetSaleOrderByIdResponseBatchesItemDescrption = string | null;

export type GetSaleOrderByIdResponseBatchesItemCorralId = number | null;

export type GetSaleOrderByIdResponseBatchesItemCarcassUniform = number | null;

export type GetSaleOrderByIdResponseBatchesItemCarcassThin = number | null;

export type GetSaleOrderByIdResponseBatchesItemCarcassMissing = number | null;

export type GetSaleOrderByIdResponseBatchesItemCarcassMedium = number | null;

export type GetSaleOrderByIdResponseBatchesItemCarcassExcessive = number | null;

export type GetSaleOrderByIdResponseBatchesItemAdjustedPurchaseCost =
  | number
  | null;

export type GetSaleOrderByIdResponseBatchesItemActivationEditedAt =
  | string
  | null;

export type GetSaleOrderByIdResponseBatchesItemActivatedAt = string | null;

export type GetSaleOrderByIdResponseBatchesItem = {
  activatedAt: GetSaleOrderByIdResponseBatchesItemActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: GetSaleOrderByIdResponseBatchesItemActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: GetSaleOrderByIdResponseBatchesItemAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: GetSaleOrderByIdResponseBatchesItemCarcassExcessive;
  carcassMedium: GetSaleOrderByIdResponseBatchesItemCarcassMedium;
  carcassMissing: GetSaleOrderByIdResponseBatchesItemCarcassMissing;
  carcassThin: GetSaleOrderByIdResponseBatchesItemCarcassThin;
  carcassUniform: GetSaleOrderByIdResponseBatchesItemCarcassUniform;
  corralId: GetSaleOrderByIdResponseBatchesItemCorralId;
  createdAt: string;
  descrption: GetSaleOrderByIdResponseBatchesItemDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: GetSaleOrderByIdResponseBatchesItemFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: GetSaleOrderByIdResponseBatchesItemForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: GetSaleOrderByIdResponseBatchesItemHideFromTreatment;
  hideFromTreatmentUntil: GetSaleOrderByIdResponseBatchesItemHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: GetSaleOrderByIdResponseBatchesItemOldCorralId;
  operationalCostGroupId: GetSaleOrderByIdResponseBatchesItemOperationalCostGroupId;
  otherCost: number;
  oxenAmount: number;
  oxFinancing: boolean;
  scaledToSlaughter: GetSaleOrderByIdResponseBatchesItemScaledToSlaughter;
};

export type GetSaleOrderByIdResponseAtSignPrice = number | null;

export type GetSaleOrderByIdResponseAnnouncementId = number | null;

export interface GetSaleManagementResponse {
  batches: GetSaleManagementResponseBatchesItem[];
  carcassWeight: number;
  sale: GetSaleManagementResponseSale;
  weightAverage: number;
}

export type GetSaleManagementResponseSaleTrucksItemSaleOrderId = number | null;

export type GetSaleManagementResponseSaleTrucksItemSaleId = number | null;

export type GetSaleManagementResponseSaleTrucksItemPlate = string | null;

export type GetSaleManagementResponseSaleTrucksItemName = string | null;

export type GetSaleManagementResponseSaleTrucksItemInfo = string | null;

export type GetSaleManagementResponseSaleTrucksItemHoldingSaleId =
  | number
  | null;

export type GetSaleManagementResponseSaleTrucksItemExitGtaSeries =
  | string
  | null;

export type GetSaleManagementResponseSaleTrucksItemExitGta = string | null;

export type GetSaleManagementResponseSaleTrucksItemDestinyId = number | null;

export type GetSaleManagementResponseSaleTrucksItem = {
  announcementId: GetSaleManagementResponseSaleTrucksItemAnnouncementId;
  bigWeighingMachineWeightKg: GetSaleManagementResponseSaleTrucksItemBigWeighingMachineWeightKg;
  boarding: GetSaleManagementResponseSaleTrucksItemBoardingItem[];
  capacity: number;
  destiny: GetSaleManagementResponseSaleTrucksItemDestiny;
  destinyId: GetSaleManagementResponseSaleTrucksItemDestinyId;
  exitAt: string;
  exitGta: GetSaleManagementResponseSaleTrucksItemExitGta;
  exitGtaSeries: GetSaleManagementResponseSaleTrucksItemExitGtaSeries;
  farmId: number;
  holdingSaleId: GetSaleManagementResponseSaleTrucksItemHoldingSaleId;
  id: number;
  info: GetSaleManagementResponseSaleTrucksItemInfo;
  isVisible: boolean;
  name: GetSaleManagementResponseSaleTrucksItemName;
  plate: GetSaleManagementResponseSaleTrucksItemPlate;
  reason: EnumsExitReason;
  saleId: GetSaleManagementResponseSaleTrucksItemSaleId;
  saleOrderId: GetSaleManagementResponseSaleTrucksItemSaleOrderId;
  status: EnumsExitTruckStatus;
};

export type GetSaleManagementResponseSale = {
  announcementId: GetSaleManagementResponseSaleAnnouncementId;
  closed: boolean;
  date: string;
  farmId: number;
  id: number;
  ownerId: number;
  trucks: GetSaleManagementResponseSaleTrucksItem[];
};

export type GetSaleManagementResponseSaleTrucksItemDestinyAnyOf = {
  name: string;
};

export type GetSaleManagementResponseSaleTrucksItemDestiny =
  GetSaleManagementResponseSaleTrucksItemDestinyAnyOf | null;

export type GetSaleManagementResponseSaleTrucksItemBoardingItemSisbov =
  | string
  | null;

export type GetSaleManagementResponseSaleTrucksItemBoardingItemCarcassWeight =
  | number
  | null;

export type GetSaleManagementResponseSaleTrucksItemBoardingItem = {
  carcassWeight: GetSaleManagementResponseSaleTrucksItemBoardingItemCarcassWeight;
  id: number;
  sisbov: GetSaleManagementResponseSaleTrucksItemBoardingItemSisbov;
};

export type GetSaleManagementResponseSaleTrucksItemBigWeighingMachineWeightKg =
  | number
  | null;

export type GetSaleManagementResponseSaleTrucksItemAnnouncementId =
  | number
  | null;

export type GetSaleManagementResponseSaleAnnouncementId = number | null;

export type GetSaleManagementResponseBatchesItemScaledToSlaughter =
  | boolean
  | null;

export type GetSaleManagementResponseBatchesItemOperationalCostGroupId =
  | number
  | null;

export type GetSaleManagementResponseBatchesItemOldCorralId = number | null;

export type GetSaleManagementResponseBatchesItemHideFromTreatmentUntil =
  | string
  | null;

export type GetSaleManagementResponseBatchesItemHideFromTreatment =
  | boolean
  | null;

export type GetSaleManagementResponseBatchesItemForeseenSlaughterDate =
  | string
  | null;

export type GetSaleManagementResponseBatchesItemFinalizedAt = string | null;

export type GetSaleManagementResponseBatchesItemDescrption = string | null;

export type GetSaleManagementResponseBatchesItemCorralId = number | null;

export type GetSaleManagementResponseBatchesItem = {
  activatedAt: GetSaleManagementResponseBatchesItemActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: GetSaleManagementResponseBatchesItemActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: GetSaleManagementResponseBatchesItemAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: GetSaleManagementResponseBatchesItemCarcassExcessive;
  carcassMedium: GetSaleManagementResponseBatchesItemCarcassMedium;
  carcassMissing: GetSaleManagementResponseBatchesItemCarcassMissing;
  carcassThin: GetSaleManagementResponseBatchesItemCarcassThin;
  carcassUniform: GetSaleManagementResponseBatchesItemCarcassUniform;
  corral: GetSaleManagementResponseBatchesItemCorral;
  corralId: GetSaleManagementResponseBatchesItemCorralId;
  createdAt: string;
  descrption: GetSaleManagementResponseBatchesItemDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: GetSaleManagementResponseBatchesItemFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: GetSaleManagementResponseBatchesItemForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: GetSaleManagementResponseBatchesItemHideFromTreatment;
  hideFromTreatmentUntil: GetSaleManagementResponseBatchesItemHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: GetSaleManagementResponseBatchesItemOldCorralId;
  operationalCostGroupId: GetSaleManagementResponseBatchesItemOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: GetSaleManagementResponseBatchesItemScaledToSlaughter;
};

export type GetSaleManagementResponseBatchesItemCorralAnyOfPosition =
  | number
  | null;

export type GetSaleManagementResponseBatchesItemCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: GetSaleManagementResponseBatchesItemCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type GetSaleManagementResponseBatchesItemCorral =
  GetSaleManagementResponseBatchesItemCorralAnyOf | null;

export type GetSaleManagementResponseBatchesItemCarcassUniform = number | null;

export type GetSaleManagementResponseBatchesItemCarcassThin = number | null;

export type GetSaleManagementResponseBatchesItemCarcassMissing = number | null;

export type GetSaleManagementResponseBatchesItemCarcassMedium = number | null;

export type GetSaleManagementResponseBatchesItemCarcassExcessive =
  | number
  | null;

export type GetSaleManagementResponseBatchesItemAdjustedPurchaseCost =
  | number
  | null;

export type GetSaleManagementResponseBatchesItemActivationEditedAt =
  | string
  | null;

export type GetSaleManagementResponseBatchesItemActivatedAt = string | null;

export type GetSaleAnnouncementResponseTrucksItemPlate = string | null;

export type GetSaleAnnouncementResponseTrucksItem = {
  exitAt: string;
  exitGta: GetSaleAnnouncementResponseTrucksItemExitGta;
  exitGtaSeries: GetSaleAnnouncementResponseTrucksItemExitGtaSeries;
  id: number;
  name: GetSaleAnnouncementResponseTrucksItemName;
  oxen: GetSaleAnnouncementResponseTrucksItemOxenItem[];
  plate: GetSaleAnnouncementResponseTrucksItemPlate;
  reason: EnumsExitReason;
};

export interface GetSaleAnnouncementResponse {
  destiny: GetSaleAnnouncementResponseDestiny;
  origin: GetSaleAnnouncementResponseOrigin;
  trucks: GetSaleAnnouncementResponseTrucksItem[];
}

export type GetSaleAnnouncementResponseTrucksItemOxenItemStartOfTreatment =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemSisbov = string | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemSalesMarketType =
  EnumsSalesMarketType | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathDetails =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathDate =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathCause =
  EnumsDeathCause | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemPurchaseId =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemPriceAtSignExit =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemPriceAtSignEntry =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemOwnerDocument =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemOwner = {
  document: GetSaleAnnouncementResponseTrucksItemOxenItemOwnerDocument;
  name: string;
};

export type GetSaleAnnouncementResponseTrucksItemOxenItemOtherDeathCause =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemIsNecropsyPerformed =
  | boolean
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemInvoice =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemInternalSaleId =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemIdentifier =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemIdentifiedAt =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemIdentificationSource =
  EnumsIdentificationSource | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemHasBirthAnnouncement =
  | boolean
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemGtaId = number | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemExitTruckId =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemElectronic =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemDiedAt = string | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemDentitionStage =
  EnumsDentitionStage | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemDeathReason =
  EnumsDeathCause | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemDeathDetails =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemDeathCause =
  EnumsDeathCause | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemComments =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemCertifierDate =
  | string
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemCattleManifestId =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemCarcassWeight =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemCarcassType =
  EnumsCarcassType | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemCarcassPrice =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemCarcass =
  | number
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemBornOnFarm =
  | boolean
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItemBndTracked =
  | boolean
  | null;

export type GetSaleAnnouncementResponseTrucksItemOxenItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: GetSaleAnnouncementResponseTrucksItemOxenItemBndTracked;
  bornOnFarm: GetSaleAnnouncementResponseTrucksItemOxenItemBornOnFarm;
  breed: string;
  carcass: GetSaleAnnouncementResponseTrucksItemOxenItemCarcass;
  carcassPrice: GetSaleAnnouncementResponseTrucksItemOxenItemCarcassPrice;
  carcassType: GetSaleAnnouncementResponseTrucksItemOxenItemCarcassType;
  carcassWeight: GetSaleAnnouncementResponseTrucksItemOxenItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: GetSaleAnnouncementResponseTrucksItemOxenItemCattleManifestId;
  certifierDate: GetSaleAnnouncementResponseTrucksItemOxenItemCertifierDate;
  comments: GetSaleAnnouncementResponseTrucksItemOxenItemComments;
  deathCause: GetSaleAnnouncementResponseTrucksItemOxenItemDeathCause;
  deathDetails: GetSaleAnnouncementResponseTrucksItemOxenItemDeathDetails;
  deathNecropsy: GetSaleAnnouncementResponseTrucksItemOxenItemDeathNecropsy;
  deathReason: GetSaleAnnouncementResponseTrucksItemOxenItemDeathReason;
  dentitionStage: GetSaleAnnouncementResponseTrucksItemOxenItemDentitionStage;
  diedAt: GetSaleAnnouncementResponseTrucksItemOxenItemDiedAt;
  electronic: GetSaleAnnouncementResponseTrucksItemOxenItemElectronic;
  exitTruckId: GetSaleAnnouncementResponseTrucksItemOxenItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: GetSaleAnnouncementResponseTrucksItemOxenItemGtaId;
  hasBirthAnnouncement: GetSaleAnnouncementResponseTrucksItemOxenItemHasBirthAnnouncement;
  id: number;
  identificationSource: GetSaleAnnouncementResponseTrucksItemOxenItemIdentificationSource;
  identifiedAt: GetSaleAnnouncementResponseTrucksItemOxenItemIdentifiedAt;
  identifier: GetSaleAnnouncementResponseTrucksItemOxenItemIdentifier;
  includedAt: string;
  internalSaleId: GetSaleAnnouncementResponseTrucksItemOxenItemInternalSaleId;
  invoice: GetSaleAnnouncementResponseTrucksItemOxenItemInvoice;
  isNecropsyPerformed: GetSaleAnnouncementResponseTrucksItemOxenItemIsNecropsyPerformed;
  otherDeathCause: GetSaleAnnouncementResponseTrucksItemOxenItemOtherDeathCause;
  owner: GetSaleAnnouncementResponseTrucksItemOxenItemOwner;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: GetSaleAnnouncementResponseTrucksItemOxenItemPriceAtSignEntry;
  priceAtSignExit: GetSaleAnnouncementResponseTrucksItemOxenItemPriceAtSignExit;
  purchaseId: GetSaleAnnouncementResponseTrucksItemOxenItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathCause;
  reversedDeathDate: GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathDate;
  reversedDeathDetails: GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathDetails;
  reversedDeathNecropsy: GetSaleAnnouncementResponseTrucksItemOxenItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: GetSaleAnnouncementResponseTrucksItemOxenItemSalesMarketType;
  sisbov: GetSaleAnnouncementResponseTrucksItemOxenItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: GetSaleAnnouncementResponseTrucksItemOxenItemStartOfTreatment;
  variety: string;
};

export type GetSaleAnnouncementResponseTrucksItemName = string | null;

export type GetSaleAnnouncementResponseTrucksItemExitGtaSeries = string | null;

export type GetSaleAnnouncementResponseTrucksItemExitGta = string | null;

export type GetSaleAnnouncementResponseOriginOwnerItemDocument = string | null;

export type GetSaleAnnouncementResponseOriginOwnerItem = {
  document: GetSaleAnnouncementResponseOriginOwnerItemDocument;
  name: string;
};

export type GetSaleAnnouncementResponseOriginAddress = {
  city: string;
  state: string;
};

export type GetSaleAnnouncementResponseOrigin = {
  address: GetSaleAnnouncementResponseOriginAddress;
  bndCode: string;
  id: number;
  name: string;
  owner: GetSaleAnnouncementResponseOriginOwnerItem[];
};

export type GetSaleAnnouncementResponseDestinyPropertyCode = string | null;

export type GetSaleAnnouncementResponseDestiny = {
  address: GetSaleAnnouncementResponseDestinyAddress;
  bndCode: string;
  id: number;
  name: string;
  owner: GetSaleAnnouncementResponseDestinyOwner;
  propertyCode: GetSaleAnnouncementResponseDestinyPropertyCode;
};

export type GetSaleAnnouncementResponseDestinyOwnerPhone = string | null;

export type GetSaleAnnouncementResponseDestinyOwnerDocument = string | null;

export type GetSaleAnnouncementResponseDestinyOwnerDescription = string | null;

export type GetSaleAnnouncementResponseDestinyOwnerCode = string | null;

export type GetSaleAnnouncementResponseDestinyOwner = {
  code: GetSaleAnnouncementResponseDestinyOwnerCode;
  createdAt: string;
  description: GetSaleAnnouncementResponseDestinyOwnerDescription;
  document: GetSaleAnnouncementResponseDestinyOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetSaleAnnouncementResponseDestinyOwnerPhone;
  profiles: EnumsProfile[];
};

export type GetSaleAnnouncementResponseDestinyAddress = {
  city: string;
  state: string;
};

export type GetRecipeResponseAnyOf = {
  capacityMn: number;
  code: number;
  createdAt: string;
  dietId: number;
  farmId: number;
  id: number;
  mixerId: number;
};

export type GetRecipeResponse = GetRecipeResponseAnyOf | null;

export type GetReIdentificationAnnouncementResponseReIdentificationsItem = {
  age: number;
  birth: string;
  createdAt?: string;
  earringBrand?: string;
  newSisbov: number;
  oldSisbov: number;
  oxId: number;
};

export type GetReIdentificationAnnouncementResponseOwnerItemDocument =
  | string
  | null;

export type GetReIdentificationAnnouncementResponseOwnerItem = {
  document: GetReIdentificationAnnouncementResponseOwnerItemDocument;
  name: string;
};

export type GetReIdentificationAnnouncementResponseFarm = {
  id: number;
  name: string;
};

export type GetReIdentificationAnnouncementResponseAddress = {
  city: string;
  state: string;
};

export interface GetReIdentificationAnnouncementResponse {
  address: GetReIdentificationAnnouncementResponseAddress;
  farm: GetReIdentificationAnnouncementResponseFarm;
  id: number;
  owner: GetReIdentificationAnnouncementResponseOwnerItem[];
  reIdentifications: GetReIdentificationAnnouncementResponseReIdentificationsItem[];
}

export type GetPurchaseResponseStock = GetPurchaseResponseStockAnyOf | null;

export interface GetPurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: GetPurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: GetPurchaseResponseObservation;
  oxen: GetPurchaseResponseOxen;
  partnerHerd: GetPurchaseResponsePartnerHerd;
  price: number;
  processingWeightCalculationStatus: GetPurchaseResponseProcessingWeightCalculationStatus;
  processingWeightCoverage: GetPurchaseResponseProcessingWeightCoverage;
  receivedAt: GetPurchaseResponseReceivedAt;
  series: string;
  sisbov: GetPurchaseResponseSisbov;
  status: EnumsPurchaseStatus;
  stock: GetPurchaseResponseStock;
}

export type GetPurchaseResponseStockAnyOfStoredAt = string | null;

export type GetPurchaseResponseStockAnyOfStockPremix = boolean | null;

export type GetPurchaseResponseStockAnyOfStockActive = boolean | null;

export type GetPurchaseResponseStockAnyOfStock = {
  active: GetPurchaseResponseStockAnyOfStockActive;
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: GetPurchaseResponseStockAnyOfStockPremix;
  supplement: boolean;
};

export type GetPurchaseResponseStockAnyOfInvoicesItemReceivedAt = string | null;

export type GetPurchaseResponseStockAnyOfInvoicesItem = {
  billedWeight: number;
  id: number;
  number: string;
  price: number;
  receivedAt: GetPurchaseResponseStockAnyOfInvoicesItemReceivedAt;
  receivedWeight: number;
  stockPurchaseId: number;
};

export type GetPurchaseResponseStockAnyOf = {
  amount: number;
  id: number;
  invoices: GetPurchaseResponseStockAnyOfInvoicesItem[];
  purchaseId: number;
  stock: GetPurchaseResponseStockAnyOfStock;
  stockId: number;
  storedAt: GetPurchaseResponseStockAnyOfStoredAt;
};

export type GetPurchaseResponseSisbovAnyOf = {
  brand: string;
  cancelled: number[];
  finalSisbov: number;
  id: number;
  initialSisbov: number;
  order: GetPurchaseResponseSisbovAnyOfOrder;
  owner: GetPurchaseResponseSisbovAnyOfOwner;
  ownerId: number;
  purchaseId: number;
};

export type GetPurchaseResponseSisbov = GetPurchaseResponseSisbovAnyOf | null;

export type GetPurchaseResponseSisbovAnyOfOwnerPhone = string | null;

export type GetPurchaseResponseSisbovAnyOfOwnerDocument = string | null;

export type GetPurchaseResponseSisbovAnyOfOwnerDescription = string | null;

export type GetPurchaseResponseSisbovAnyOfOwnerCode = string | null;

export type GetPurchaseResponseSisbovAnyOfOwner = {
  code: GetPurchaseResponseSisbovAnyOfOwnerCode;
  createdAt: string;
  description: GetPurchaseResponseSisbovAnyOfOwnerDescription;
  document: GetPurchaseResponseSisbovAnyOfOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetPurchaseResponseSisbovAnyOfOwnerPhone;
  profiles: EnumsProfile[];
};

export type GetPurchaseResponseSisbovAnyOfOrder = string | null;

export type GetPurchaseResponseReceivedAt = string | null;

export type GetPurchaseResponseProcessingWeightCoverageAnyOf = {
  eligibleAnimals: number;
  missingAnimals: number;
  totalAnimals: number;
};

export type GetPurchaseResponseProcessingWeightCoverage =
  GetPurchaseResponseProcessingWeightCoverageAnyOf | null;

export type GetPurchaseResponseProcessingWeightCalculationStatus =
  (typeof GetPurchaseResponseProcessingWeightCalculationStatus)[keyof typeof GetPurchaseResponseProcessingWeightCalculationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPurchaseResponseProcessingWeightCalculationStatus = {
  NOT_APPLICABLE: "NOT_APPLICABLE",
  PENDING_PROCESSING_WEIGHT: "PENDING_PROCESSING_WEIGHT",
  READY: "READY",
} as const;

export type GetPurchaseResponsePartnerHerd = string | null;

export type GetPurchaseResponseOxenAnyOfWeighingAt = string | null;

export type GetPurchaseResponseOxenAnyOfPartnerId = number | null;

export type GetPurchaseResponseOxenAnyOfOxenAmount = number | null;

export type GetPurchaseResponseOxenAnyOfOwnerPhone = string | null;

export type GetPurchaseResponseOxenAnyOfOwnerDocument = string | null;

export type GetPurchaseResponseOxenAnyOfOwnerDescription = string | null;

export type GetPurchaseResponseOxenAnyOfOwnerCode = string | null;

export type GetPurchaseResponseOxenAnyOfOwner = {
  code: GetPurchaseResponseOxenAnyOfOwnerCode;
  createdAt: string;
  description: GetPurchaseResponseOxenAnyOfOwnerDescription;
  document: GetPurchaseResponseOxenAnyOfOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetPurchaseResponseOxenAnyOfOwnerPhone;
  profiles: EnumsProfile[];
};

export type GetPurchaseResponseOxenAnyOfMapa = string | null;

export type GetPurchaseResponseOxenAnyOfMaleProducedPrice = number | null;

export type GetPurchaseResponseOxenAnyOfMaleFutureAnimalPrice = number | null;

export type GetPurchaseResponseOxenAnyOfMaleEntryCarcassYield = number | null;

export type GetPurchaseResponseOxenAnyOfMaleDailyPrice = number | null;

export type GetPurchaseResponseOxenAnyOfGtasItemWeightingMapId = number | null;

export type GetPurchaseResponseOxenAnyOfGtasItemWeightAverage = number | null;

export type GetPurchaseResponseOxenAnyOfGtasItemPurchaseId = number | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOriginWeightAverage =
  | number
  | null;

export type GetPurchaseResponseOxenAnyOfGtasItem = {
  ages: GetPurchaseResponseOxenAnyOfGtasItemAgesItem[];
  completed: boolean;
  description: GetPurchaseResponseOxenAnyOfGtasItemDescription;
  destinyId: GetPurchaseResponseOxenAnyOfGtasItemDestinyId;
  distance: GetPurchaseResponseOxenAnyOfGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: GetPurchaseResponseOxenAnyOfGtasItemHours;
  id: number;
  invoice: GetPurchaseResponseOxenAnyOfGtasItemInvoice;
  number: string;
  origin: GetPurchaseResponseOxenAnyOfGtasItemOrigin;
  originId: number;
  originWeightAverage: GetPurchaseResponseOxenAnyOfGtasItemOriginWeightAverage;
  purchaseId: GetPurchaseResponseOxenAnyOfGtasItemPurchaseId;
  series: string;
  weightAverage: GetPurchaseResponseOxenAnyOfGtasItemWeightAverage;
  weightingMapId: GetPurchaseResponseOxenAnyOfGtasItemWeightingMapId;
};

export type GetPurchaseResponseOxenAnyOfFemaleDailyPrice = number | null;

export type GetPurchaseResponseOxenAnyOfDiscountPercent = number | null;

export type GetPurchaseResponseOxenAnyOf = {
  buyer: GetPurchaseResponseOxenAnyOfBuyer;
  buyerId: number;
  commission: number;
  discountPercent: GetPurchaseResponseOxenAnyOfDiscountPercent;
  femaleDailyPrice: GetPurchaseResponseOxenAnyOfFemaleDailyPrice;
  femaleEntryCarcassYield: GetPurchaseResponseOxenAnyOfFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: GetPurchaseResponseOxenAnyOfFemaleFutureAnimalPrice;
  femaleProducedPrice: GetPurchaseResponseOxenAnyOfFemaleProducedPrice;
  gtas: GetPurchaseResponseOxenAnyOfGtasItem[];
  id: number;
  maleDailyPrice: GetPurchaseResponseOxenAnyOfMaleDailyPrice;
  maleEntryCarcassYield: GetPurchaseResponseOxenAnyOfMaleEntryCarcassYield;
  maleFutureAnimalPrice: GetPurchaseResponseOxenAnyOfMaleFutureAnimalPrice;
  maleProducedPrice: GetPurchaseResponseOxenAnyOfMaleProducedPrice;
  mapa: GetPurchaseResponseOxenAnyOfMapa;
  owner: GetPurchaseResponseOxenAnyOfOwner;
  ownerId: number;
  oxenAmount: GetPurchaseResponseOxenAnyOfOxenAmount;
  partnerId: GetPurchaseResponseOxenAnyOfPartnerId;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: GetPurchaseResponseOxenAnyOfWeighingAt;
  weightAverage: number;
};

export type GetPurchaseResponseOxen = GetPurchaseResponseOxenAnyOf | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOriginResponsiblePhone =
  | string
  | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOriginResponsibleDocument =
  | string
  | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOriginResponsibleDescription =
  | string
  | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOriginResponsibleCode =
  | string
  | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOriginResponsible = {
  code: GetPurchaseResponseOxenAnyOfGtasItemOriginResponsibleCode;
  createdAt: string;
  description: GetPurchaseResponseOxenAnyOfGtasItemOriginResponsibleDescription;
  document: GetPurchaseResponseOxenAnyOfGtasItemOriginResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetPurchaseResponseOxenAnyOfGtasItemOriginResponsiblePhone;
  profiles: EnumsProfile[];
};

export type GetPurchaseResponseOxenAnyOfGtasItemOriginCode = string | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOriginCattleManifestLayoutId =
  | number
  | null;

export type GetPurchaseResponseOxenAnyOfGtasItemOrigin = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: GetPurchaseResponseOxenAnyOfGtasItemOriginCattleManifestLayoutId;
  code: GetPurchaseResponseOxenAnyOfGtasItemOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetPurchaseResponseOxenAnyOfGtasItemOriginResponsible;
  responsibleId: number;
};

export type GetPurchaseResponseOxenAnyOfGtasItemInvoice = string | null;

export type GetPurchaseResponseOxenAnyOfGtasItemHours = number | null;

export type GetPurchaseResponseOxenAnyOfGtasItemDistance = number | null;

export type GetPurchaseResponseOxenAnyOfGtasItemDestinyId = number | null;

export type GetPurchaseResponseOxenAnyOfGtasItemDescription = string | null;

export type GetPurchaseResponseOxenAnyOfGtasItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  yearsOld: number;
};

export type GetPurchaseResponseOxenAnyOfFemaleProducedPrice = number | null;

export type GetPurchaseResponseOxenAnyOfFemaleFutureAnimalPrice = number | null;

export type GetPurchaseResponseOxenAnyOfFemaleEntryCarcassYield = number | null;

export type GetPurchaseResponseOxenAnyOfBuyerPhone = string | null;

export type GetPurchaseResponseOxenAnyOfBuyerDocument = string | null;

export type GetPurchaseResponseOxenAnyOfBuyerDescription = string | null;

export type GetPurchaseResponseOxenAnyOfBuyerCode = string | null;

export type GetPurchaseResponseOxenAnyOfBuyer = {
  code: GetPurchaseResponseOxenAnyOfBuyerCode;
  createdAt: string;
  description: GetPurchaseResponseOxenAnyOfBuyerDescription;
  document: GetPurchaseResponseOxenAnyOfBuyerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetPurchaseResponseOxenAnyOfBuyerPhone;
  profiles: EnumsProfile[];
};

export type GetPurchaseResponseObservation = string | null;

export type GetPurchaseResponseEarringsPerPage = number | null;

export interface GetPurchaseConfigResponse {
  purchaseCalculationType: EnumsPurchaseCalculationType;
}

export interface GetPriceTableAvailableYearsResponse {
  years: number[];
}

export type GetPersonResponseUser = GetPersonResponseUserAnyOf | null;

export type GetPersonResponseUserAnyOfGov = GlobalPrismaJsonGovDocuments | null;

export type GetPersonResponseUserAnyOfEmail = string | null;

export type GetPersonResponseUserAnyOf = {
  email: GetPersonResponseUserAnyOfEmail;
  gov: GetPersonResponseUserAnyOfGov;
};

export type GetPersonResponsePhone = string | null;

export type GetPersonResponseDocument = string | null;

export type GetPersonResponseDescription = string | null;

export type GetPersonResponseCode = string | null;

export interface GetPersonResponse {
  code: GetPersonResponseCode;
  description: GetPersonResponseDescription;
  document: GetPersonResponseDocument;
  name: string;
  phone: GetPersonResponsePhone;
  profiles: EnumsProfile[];
  user: GetPersonResponseUser;
}

export type GetPartnerSlaughterResultReportResponseItem = {
  financialSummary: FinancialSummary;
  generalInfo: GeneralInfo;
  id: number;
  zootechnicalInfo: ZootechnicalInfo;
};

export type GetPartnerSlaughterResultReportResponse =
  GetPartnerSlaughterResultReportResponseItem[];

export interface GetPartnerClosureV2ByIdResponse {
  boitel: GetPartnerClosureV2ByIdResponseBoitel;
  boitelSummary: GetPartnerClosureV2ByIdResponseBoitelSummary;
  classic: GetPartnerClosureV2ByIdResponseClassic;
  closingDate: string;
  createdAt: string;
  farmId: number;
  fatCattle: GetPartnerClosureV2ByIdResponseFatCattle;
  finalValue: number;
  id: number;
  observation: GetPartnerClosureV2ByIdResponseObservation;
  oxenPurchase: GetPartnerClosureV2ByIdResponseOxenPurchase;
  oxenPurchaseId: number;
  type: EnumsPartnerClosureV2Type;
}

export type GetPartnerClosureV2ByIdResponseOxenPurchaseWeighingAt =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchasePurchasePartnerHerd =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchasePurchase = {
  name: string;
  partnerHerd: GetPartnerClosureV2ByIdResponseOxenPurchasePurchasePartnerHerd;
};

export type GetPartnerClosureV2ByIdResponseOxenPurchasePartnerId =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchasePartnerAnyOf = {
  name: string;
};

export type GetPartnerClosureV2ByIdResponseOxenPurchasePartner =
  GetPartnerClosureV2ByIdResponseOxenPurchasePartnerAnyOf | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseOxenAmount =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseMapa = string | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseMaleProducedPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseMaleFutureAnimalPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseMaleEntryCarcassYield =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseMaleDailyPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleProducedPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleFutureAnimalPrice =
  number | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleEntryCarcassYield =
  number | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleDailyPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchaseDiscountPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseOxenPurchase = {
  buyerId: number;
  commission: number;
  discountPercent: GetPartnerClosureV2ByIdResponseOxenPurchaseDiscountPercent;
  femaleDailyPrice: GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleDailyPrice;
  femaleEntryCarcassYield: GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleFutureAnimalPrice;
  femaleProducedPrice: GetPartnerClosureV2ByIdResponseOxenPurchaseFemaleProducedPrice;
  id: number;
  maleDailyPrice: GetPartnerClosureV2ByIdResponseOxenPurchaseMaleDailyPrice;
  maleEntryCarcassYield: GetPartnerClosureV2ByIdResponseOxenPurchaseMaleEntryCarcassYield;
  maleFutureAnimalPrice: GetPartnerClosureV2ByIdResponseOxenPurchaseMaleFutureAnimalPrice;
  maleProducedPrice: GetPartnerClosureV2ByIdResponseOxenPurchaseMaleProducedPrice;
  mapa: GetPartnerClosureV2ByIdResponseOxenPurchaseMapa;
  ownerId: number;
  oxenAmount: GetPartnerClosureV2ByIdResponseOxenPurchaseOxenAmount;
  partner: GetPartnerClosureV2ByIdResponseOxenPurchasePartner;
  partnerId: GetPartnerClosureV2ByIdResponseOxenPurchasePartnerId;
  purchase: GetPartnerClosureV2ByIdResponseOxenPurchasePurchase;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: GetPartnerClosureV2ByIdResponseOxenPurchaseWeighingAt;
  weightAverage: number;
};

export type GetPartnerClosureV2ByIdResponseObservation = string | null;

export type GetPartnerClosureV2ByIdResponseFatCattle =
  GetPartnerClosureV2ByIdResponseFatCattleAnyOf | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfSlaughterhouse =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfSlaughterDate =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfSenarPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfQuotesItemQuoteDate =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfQuotesItemLabel =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfQuotesItem = {
  id: number;
  kind: string;
  label: GetPartnerClosureV2ByIdResponseFatCattleAnyOfQuotesItemLabel;
  partnerClosureFatCattleId: number;
  price: number;
  quoteDate: GetPartnerClosureV2ByIdResponseFatCattleAnyOfQuotesItemQuoteDate;
};

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfPaymentDays =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfPaymentDate =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOf = {
  discountPercent: GetPartnerClosureV2ByIdResponseFatCattleAnyOfDiscountPercent;
  exitAtSignPrice: GetPartnerClosureV2ByIdResponseFatCattleAnyOfExitAtSignPrice;
  freightAtSignPrice: GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightAtSignPrice;
  freightCostPerTrip: GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightCostPerTrip;
  freightDetourPerTrip: GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightDetourPerTrip;
  freightTotalWeightKg: GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightTotalWeightKg;
  freightTransportedAmount: GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightTransportedAmount;
  freightTrips: GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightTrips;
  id: number;
  lots: GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItem[];
  partnerClosureV2Id: number;
  paymentDate: GetPartnerClosureV2ByIdResponseFatCattleAnyOfPaymentDate;
  paymentDays: GetPartnerClosureV2ByIdResponseFatCattleAnyOfPaymentDays;
  quotes: GetPartnerClosureV2ByIdResponseFatCattleAnyOfQuotesItem[];
  senarPercent: GetPartnerClosureV2ByIdResponseFatCattleAnyOfSenarPercent;
  slaughterDate: GetPartnerClosureV2ByIdResponseFatCattleAnyOfSlaughterDate;
  slaughterhouse: GetPartnerClosureV2ByIdResponseFatCattleAnyOfSlaughterhouse;
};

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItemLotRef =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItemFreightPerAtSign =
  number | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItemBonusPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItem = {
  amount: number;
  bonusPercent: GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItemBonusPercent;
  carcassKg: number;
  freightPerAtSign: GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItemFreightPerAtSign;
  id: number;
  lotRef: GetPartnerClosureV2ByIdResponseFatCattleAnyOfLotsItemLotRef;
  partnerClosureFatCattleId: number;
  revenue: number;
};

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightTrips =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightTransportedAmount =
  number | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightTotalWeightKg =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightDetourPerTrip =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightCostPerTrip =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfFreightAtSignPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfExitAtSignPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseFatCattleAnyOfDiscountPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassic =
  GetPartnerClosureV2ByIdResponseClassicAnyOf | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfTotalEntryLiveWeight =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemSlaughterhouse =
  string | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemReceiptDate =
  string | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemPaymentDate =
  string | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemMarketType =
  string | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemDiscountPercent =
  number | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemCorrectionOverride =
  number | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemContractRef =
  string | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemAdvanceDate =
  string | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItem = {
  advanceDate: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemAdvanceDate;
  amount: number;
  contractRef: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemContractRef;
  correctionOverride: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemCorrectionOverride;
  discountPercent: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemDiscountPercent;
  id: number;
  marketType: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemMarketType;
  partnerClosureClassicId: number;
  paymentDate: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemPaymentDate;
  physicalAtSignPrice: number;
  receiptDate: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemReceiptDate;
  slaughterDate: string;
  slaughterhouse: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItemSlaughterhouse;
};

export type GetPartnerClosureV2ByIdResponseClassicAnyOfSenarPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfReceiptDays =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfPaymentDays =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfMaleExitCarcassYield =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfFemaleExitCarcassYield =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfExitAtSignPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfDiscountPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfCorrectionPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfContractNumber =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfContractedAmount =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfCarcassYield =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOfBonusPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseClassicAnyOf = {
  bonusPercent: GetPartnerClosureV2ByIdResponseClassicAnyOfBonusPercent;
  carcassYield: GetPartnerClosureV2ByIdResponseClassicAnyOfCarcassYield;
  contractedAmount: GetPartnerClosureV2ByIdResponseClassicAnyOfContractedAmount;
  contractNumber: GetPartnerClosureV2ByIdResponseClassicAnyOfContractNumber;
  correctionPercent: GetPartnerClosureV2ByIdResponseClassicAnyOfCorrectionPercent;
  discountPercent: GetPartnerClosureV2ByIdResponseClassicAnyOfDiscountPercent;
  exitAtSignPrice: GetPartnerClosureV2ByIdResponseClassicAnyOfExitAtSignPrice;
  femaleExitCarcassYield: GetPartnerClosureV2ByIdResponseClassicAnyOfFemaleExitCarcassYield;
  id: number;
  maleExitCarcassYield: GetPartnerClosureV2ByIdResponseClassicAnyOfMaleExitCarcassYield;
  partnerClosureV2Id: number;
  paymentDays: GetPartnerClosureV2ByIdResponseClassicAnyOfPaymentDays;
  receiptDays: GetPartnerClosureV2ByIdResponseClassicAnyOfReceiptDays;
  senarPercent: GetPartnerClosureV2ByIdResponseClassicAnyOfSenarPercent;
  slaughters: GetPartnerClosureV2ByIdResponseClassicAnyOfSlaughtersItem[];
  totalEntryLiveWeight: GetPartnerClosureV2ByIdResponseClassicAnyOfTotalEntryLiveWeight;
};

export type GetPartnerClosureV2ByIdResponseBoitelSummary =
  BoitelClosureSummary | null;

export type GetPartnerClosureV2ByIdResponseBoitel =
  GetPartnerClosureV2ByIdResponseBoitelAnyOf | null;

export type GetPartnerClosureV2ByIdResponseBoitelAnyOfTotalLockedAtSign =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseBoitelAnyOfSenarPercent =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseBoitelAnyOfSanitaryCost =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseBoitelAnyOfPartnerPaymentDate =
  | string
  | null;

export type GetPartnerClosureV2ByIdResponseBoitelAnyOfLockedFee = number | null;

export type GetPartnerClosureV2ByIdResponseBoitelAnyOfLockedAtSignPrice =
  | number
  | null;

export type GetPartnerClosureV2ByIdResponseBoitelAnyOf = {
  atSignPrice: number;
  dailyRate: number;
  id: number;
  lockedAtSignPrice: GetPartnerClosureV2ByIdResponseBoitelAnyOfLockedAtSignPrice;
  lockedFee: GetPartnerClosureV2ByIdResponseBoitelAnyOfLockedFee;
  partnerClosureV2Id: number;
  partnerPaymentDate: GetPartnerClosureV2ByIdResponseBoitelAnyOfPartnerPaymentDate;
  sanitaryCost: GetPartnerClosureV2ByIdResponseBoitelAnyOfSanitaryCost;
  senarPercent: GetPartnerClosureV2ByIdResponseBoitelAnyOfSenarPercent;
  totalAtSign: number;
  totalDays: number;
  totalLockedAtSign: GetPartnerClosureV2ByIdResponseBoitelAnyOfTotalLockedAtSign;
};

export interface GetPartnerClosureByIdResponse {
  createdAt?: string;
  farmId?: number;
  finalSalePrice?: number;
  id?: number;
  oxenPurchase?: GetPartnerClosureByIdResponseOxenPurchase;
  oxenPurchaseId?: number;
  saleOrders?: GetPartnerClosureByIdResponseSaleOrdersItem[];
}

export type GetPartnerClosureByIdResponseSaleOrdersItemTypeOfClosed =
  EnumsSaleOrderType | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemSourceType =
  EnumsSaleOrderSourceType | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemPartnerClosureId =
  | number
  | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemPartnerAtSignPriceM =
  | number
  | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemPartnerAtSignPriceF =
  | number
  | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemFreightPerAtSignBRL =
  | number
  | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemBonusPercent =
  | number
  | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemAtSignPrice =
  | number
  | null;

export type GetPartnerClosureByIdResponseSaleOrdersItemAnnouncementId =
  | number
  | null;

export type GetPartnerClosureByIdResponseSaleOrdersItem = {
  announcementId: GetPartnerClosureByIdResponseSaleOrdersItemAnnouncementId;
  atSignPrice: GetPartnerClosureByIdResponseSaleOrdersItemAtSignPrice;
  bonusPercent: GetPartnerClosureByIdResponseSaleOrdersItemBonusPercent;
  createdAt: string;
  createdBy: number;
  destinyId: number;
  expirationDay: string;
  farmId: number;
  freightPerAtSignBRL: GetPartnerClosureByIdResponseSaleOrdersItemFreightPerAtSignBRL;
  id: number;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF: GetPartnerClosureByIdResponseSaleOrdersItemPartnerAtSignPriceF;
  partnerAtSignPriceM: GetPartnerClosureByIdResponseSaleOrdersItemPartnerAtSignPriceM;
  partnerClosureId: GetPartnerClosureByIdResponseSaleOrdersItemPartnerClosureId;
  paymentMethod: string;
  saleDate: string;
  sourceType: GetPartnerClosureByIdResponseSaleOrdersItemSourceType;
  status: EnumsSaleOrderStatus;
  typeOfClosed: GetPartnerClosureByIdResponseSaleOrdersItemTypeOfClosed;
};

export type GetPartnerClosureByIdResponseOxenPurchaseWeighingAt = string | null;

export type GetPartnerClosureByIdResponseOxenPurchasePurchaseReceivedAt =
  | string
  | null;

export type GetPartnerClosureByIdResponseOxenPurchasePurchasePartnerHerd =
  | string
  | null;

export type GetPartnerClosureByIdResponseOxenPurchasePurchaseObservation =
  | string
  | null;

export type GetPartnerClosureByIdResponseOxenPurchasePurchaseEarringsPerPage =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchasePurchase = {
  category: EnumsPurchaseCategory;
  earringsPerPage: GetPartnerClosureByIdResponseOxenPurchasePurchaseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: GetPartnerClosureByIdResponseOxenPurchasePurchaseObservation;
  partnerHerd: GetPartnerClosureByIdResponseOxenPurchasePurchasePartnerHerd;
  price: number;
  receivedAt: GetPartnerClosureByIdResponseOxenPurchasePurchaseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
};

export type GetPartnerClosureByIdResponseOxenPurchasePartnerId = number | null;

export type GetPartnerClosureByIdResponseOxenPurchaseOxenAmount = number | null;

export type GetPartnerClosureByIdResponseOxenPurchaseMapa = string | null;

export type GetPartnerClosureByIdResponseOxenPurchaseMaleProducedPrice =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseMaleFutureAnimalPrice =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseMaleEntryCarcassYield =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseMaleDailyPrice =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseFemaleProducedPrice =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseFemaleFutureAnimalPrice =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseFemaleEntryCarcassYield =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseFemaleDailyPrice =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchaseDiscountPercent =
  | number
  | null;

export type GetPartnerClosureByIdResponseOxenPurchase = {
  buyerId: number;
  commission: number;
  discountPercent: GetPartnerClosureByIdResponseOxenPurchaseDiscountPercent;
  femaleDailyPrice: GetPartnerClosureByIdResponseOxenPurchaseFemaleDailyPrice;
  femaleEntryCarcassYield: GetPartnerClosureByIdResponseOxenPurchaseFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: GetPartnerClosureByIdResponseOxenPurchaseFemaleFutureAnimalPrice;
  femaleProducedPrice: GetPartnerClosureByIdResponseOxenPurchaseFemaleProducedPrice;
  id: number;
  maleDailyPrice: GetPartnerClosureByIdResponseOxenPurchaseMaleDailyPrice;
  maleEntryCarcassYield: GetPartnerClosureByIdResponseOxenPurchaseMaleEntryCarcassYield;
  maleFutureAnimalPrice: GetPartnerClosureByIdResponseOxenPurchaseMaleFutureAnimalPrice;
  maleProducedPrice: GetPartnerClosureByIdResponseOxenPurchaseMaleProducedPrice;
  mapa: GetPartnerClosureByIdResponseOxenPurchaseMapa;
  ownerId: number;
  oxenAmount: GetPartnerClosureByIdResponseOxenPurchaseOxenAmount;
  partnerId: GetPartnerClosureByIdResponseOxenPurchasePartnerId;
  purchase: GetPartnerClosureByIdResponseOxenPurchasePurchase;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: GetPartnerClosureByIdResponseOxenPurchaseWeighingAt;
  weightAverage: number;
};

export interface GetOxWithdrawalsResponse {
  appliedAt: string;
  medicine: string;
  oxId: number;
  withdrawalDate: string;
}

export type GetOxWeightsResponse = GetOxWeightsResponseItem[];

export type GetOxWeightsResponseItemWeightsItemType = EnumsWeightType | null;

export type GetOxWeightsResponseItemWeightsItem = {
  date: string;
  id: number;
  type: GetOxWeightsResponseItemWeightsItemType;
  weight: number;
};

export type GetOxWeightsResponseItemSisbov = string | null;

export type GetOxWeightsResponseItemProjectedWeightAnyOf = {
  date: string;
  weight: number;
};

export type GetOxWeightsResponseItemProjectedWeight =
  GetOxWeightsResponseItemProjectedWeightAnyOf | null;

export type GetOxWeightsResponseItemIdentifier = string | null;

export type GetOxWeightsResponseItemElectronic = string | null;

export type GetOxWeightsResponseItem = {
  electronic: GetOxWeightsResponseItemElectronic;
  identifier: GetOxWeightsResponseItemIdentifier;
  isAlive: boolean;
  oxId: number;
  projectedWeight: GetOxWeightsResponseItemProjectedWeight;
  sisbov: GetOxWeightsResponseItemSisbov;
  weights: GetOxWeightsResponseItemWeightsItem[];
};

export type GetOxPriceTableResponseItemPrice = number | null;

export type GetOxPriceTableResponseItem = {
  farmId: number;
  gender: EnumsOxGender;
  id: number;
  month: number;
  price: GetOxPriceTableResponseItemPrice;
  year: number;
};

export type GetOxPriceTableResponse = GetOxPriceTableResponseItem[];

export type GetOperationalCostsResponseItem = {
  createdAt: string;
  farmId: number;
  groupId: number;
  id: number;
  month: number;
  totalMonthlyCost: number;
  type: EnumsOperationalCostType;
  updatedAt: string;
  year: number;
};

export type GetOperationalCostsResponse = GetOperationalCostsResponseItem[];

export type GetOperationalCostConfigResponseOperationalCostCalculationType =
  (typeof GetOperationalCostConfigResponseOperationalCostCalculationType)[keyof typeof GetOperationalCostConfigResponseOperationalCostCalculationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOperationalCostConfigResponseOperationalCostCalculationType = {
  MONTHLY_APPORTIONMENT: "MONTHLY_APPORTIONMENT",
  PER_HEAD_PER_DAY: "PER_HEAD_PER_DAY",
} as const;

export interface GetOperationalCostConfigResponse {
  operationalCostCalculationType: GetOperationalCostConfigResponseOperationalCostCalculationType;
}

export type GetOccurrencesReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetOccurrencesReportXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type GetOccurrencesReportXlsxResponseAnyOf = {
  buffer: GetOccurrencesReportXlsxResponseAnyOfBuffer;
};

export type GetOccurrencesReportXlsxResponse =
  | GetOccurrencesReportXlsxResponseAnyOf
  | GetOccurrencesReportXlsxResponseAnyOfThree;

export type GetMixerResponseAnyOf = {
  active: boolean;
  code: number;
  createdAt: string;
  distributor: boolean;
  farmId: number;
  id: number;
  mixer: boolean;
  mixerType: EnumsMixerType;
  mixTime: string;
  name: string;
  rounding: number;
};

export type GetMixerResponse = GetMixerResponseAnyOf | null;

export type GetMedicinesResponse = GetMedicinesResponseItem[];

export type GetMedicinesResponseItemPerKg = number | null;

export type GetMedicinesResponseItemKiloDose = number | null;

export type GetMedicinesResponseItemApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export type GetMedicinesResponseItem = {
  active: boolean;
  applicationSuggestion: GetMedicinesResponseItemApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: GetMedicinesResponseItemKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: GetMedicinesResponseItemPerKg;
  type: EnumsMedicineType;
};

export type GetMedicineResponse = GetMedicineResponseAnyOf | null;

export type GetMedicineResponseAnyOfPerKg = number | null;

export type GetMedicineResponseAnyOfKiloDose = number | null;

export type GetMedicineResponseAnyOfImagesItemName = string | null;

export type GetMedicineResponseAnyOfImagesItemMedicineId = number | null;

export type GetMedicineResponseAnyOfImagesItemHealthProtocolId = number | null;

export type GetMedicineResponseAnyOfImagesItem = {
  base64: string;
  farmId: number;
  healthProtocolId: GetMedicineResponseAnyOfImagesItemHealthProtocolId;
  id: number;
  medicineId: GetMedicineResponseAnyOfImagesItemMedicineId;
  name: GetMedicineResponseAnyOfImagesItemName;
};

export type GetMedicineResponseAnyOfApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export type GetMedicineResponseAnyOf = {
  active: boolean;
  applicationSuggestion: GetMedicineResponseAnyOfApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  Images: GetMedicineResponseAnyOfImagesItem[];
  kiloDose: GetMedicineResponseAnyOfKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: GetMedicineResponseAnyOfPerKg;
  type: EnumsMedicineType;
};

export type GetMasterConfigResponseMaster = string | null;

export interface GetMasterConfigResponse {
  master: GetMasterConfigResponseMaster;
}

export type GetManagementSessionResponseFinishedById = number | null;

export interface GetManagementSessionResponse {
  createdAt: string;
  data: unknown;
  farmId: number;
  finishedById: GetManagementSessionResponseFinishedById;
  id: number;
  name: string;
  status: EnumsManagementStatus;
  type: EnumsTypeManagement;
  updatedAt: string;
  uuid: string;
}

export type GetManagementOxenByManagementIdReturnSisbov = string | null;

export interface GetManagementOxenByManagementIdReturn {
  breed: string;
  corralId: number;
  corralName: string;
  gender: EnumsOxGender;
  managementListId: number;
  oxId: number;
  sisbov: GetManagementOxenByManagementIdReturnSisbov;
  weight: number;
}

export type GetManagementOxenByManagementIdResponse =
  GetManagementOxenByManagementIdReturn[];

export type GetLastBatchOxResponseFinalizedAt = string | null;

export type GetLastBatchOxResponseActivatedAt = string | null;

export interface GetLastBatchOxResponse {
  activatedAt: GetLastBatchOxResponseActivatedAt;
  createdAt: string;
  finalizedAt: GetLastBatchOxResponseFinalizedAt;
  id: number;
  name: string;
}

export type GetKillOxResponseStartOfTreatment = string | null;

export type GetKillOxResponseSisbov = string | null;

export type GetKillOxResponseOtherDeathCause = string | null;

export type GetKillOxResponseIsNecropsyPerformed = boolean | null;

export type GetKillOxResponseElectronic = string | null;

export type GetKillOxResponseDiedAt = string | null;

export type GetKillOxResponseDeathReason = EnumsDeathCause | null;

export type GetKillOxResponseDeathNecropsy = EnumsDeathNecropsy | null;

export type GetKillOxResponseDeathDetails = string | null;

export type GetKillOxResponseDeathCause = EnumsDeathCause | null;

export interface GetKillOxResponse {
  batches: GetKillOxResponseBatchesItem[];
  deathCause: GetKillOxResponseDeathCause;
  deathDetails: GetKillOxResponseDeathDetails;
  deathNecropsy: GetKillOxResponseDeathNecropsy;
  deathReason: GetKillOxResponseDeathReason;
  diedAt: GetKillOxResponseDiedAt;
  electronic: GetKillOxResponseElectronic;
  id: number;
  includedAt: string;
  isNecropsyPerformed: GetKillOxResponseIsNecropsyPerformed;
  otherDeathCause: GetKillOxResponseOtherDeathCause;
  sisbov: GetKillOxResponseSisbov;
  startOfTreatment: GetKillOxResponseStartOfTreatment;
}

export type GetKillOxResponseBatchesItemBatchCorralId = number | null;

export type GetKillOxResponseBatchesItemBatch = {
  corralId: GetKillOxResponseBatchesItemBatchCorralId;
  name: string;
};

export type GetKillOxResponseBatchesItem = {
  batch: GetKillOxResponseBatchesItemBatch;
  batchId: number;
};

export type GetInvoiceByIdResponseWeightingMapId = number | null;

export type GetInvoiceByIdResponseSaleOrderId = number | null;

export type GetInvoiceByIdResponseIsComplement = boolean | null;

export type GetInvoiceByIdResponseExitTruckId = number | null;

export type GetInvoiceByIdResponseEmittedAt = string | null;

export interface GetInvoiceByIdResponse {
  emittedAt: GetInvoiceByIdResponseEmittedAt;
  exitTruckId: GetInvoiceByIdResponseExitTruckId;
  farmId: number;
  id: number;
  isComplement: GetInvoiceByIdResponseIsComplement;
  number: string;
  saleOrderId: GetInvoiceByIdResponseSaleOrderId;
  series: string;
  value: number;
  weightingMapId: GetInvoiceByIdResponseWeightingMapId;
}

export type GetInventoryControlResponseTotals = {
  currentStock: number;
  dailyConsumption: number;
  periodEntries: number;
};

export interface GetInventoryControlResponse {
  items: InventoryControlItem[];
  limit: number;
  page: number;
  totalItems: number;
  totalPages: number;
  totals: GetInventoryControlResponseTotals;
}

export type GetInventoryControlReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetInventoryControlReportXlsxResponse =
  | GetInventoryControlReportXlsxResponseAnyOf
  | GetInventoryControlReportXlsxResponseAnyOfThree;

export type GetInventoryControlReportXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GetInventoryControlReportXlsxResponseAnyOf = {
  buffer: GetInventoryControlReportXlsxResponseAnyOfBuffer;
};

export type GetIndividualCattleClosingReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetIndividualCattleClosingReportXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GetIndividualCattleClosingReportXlsxResponseAnyOf = {
  buffer: GetIndividualCattleClosingReportXlsxResponseAnyOfBuffer;
};

export type GetIndividualCattleClosingReportXlsxResponse =
  | GetIndividualCattleClosingReportXlsxResponseAnyOf
  | GetIndividualCattleClosingReportXlsxResponseAnyOfThree;

export type GetHoldingSaleWeightsResponseExitWeightAverage = number | null;

export interface GetHoldingSaleWeightsResponse {
  exitWeightAverage: GetHoldingSaleWeightsResponseExitWeightAverage;
}

export interface GetHoldingSaleResponse {
  batchId: number;
  batchMoved: boolean;
  batchName: string;
  date: string;
  destinyId: number;
  destinyName: string;
  exitWeightAverage: number;
  name: GetHoldingSaleResponseName;
  oxen: GetHoldingSaleResponseOxenItem[];
  oxenAmount: number;
}

export type GetHoldingSaleResponseOxenItemSisbov = string | null;

export type GetHoldingSaleResponseOxenItemExitTruckId = number | null;

export type GetHoldingSaleResponseOxenItemDiedAt = string | null;

export type GetHoldingSaleResponseOxenItem = {
  category: EnumsOxCategory;
  diedAt: GetHoldingSaleResponseOxenItemDiedAt;
  exitTruckId: GetHoldingSaleResponseOxenItemExitTruckId;
  gender: EnumsOxGender;
  id: number;
  sisbov: GetHoldingSaleResponseOxenItemSisbov;
  variety: string;
};

export type GetHoldingSaleResponseName = string | null;

export type GetHoldingEntryResponseWeightingMapReferenceCode = string | null;

export type GetHoldingEntryResponseIdentifiedCountByGtaId = {
  [key: string]: {
    withId: number;
    withoutId: number;
  };
};

export type GetHoldingEntryResponseEntryCountByGtaId = {
  [key: string]: {
    [key: string]: {
      female: number;
      male: number;
    };
  };
};

export interface GetHoldingEntryResponse {
  batchName: string;
  batchOxenAmount: number;
  breed: string;
  entryCountByGtaId: GetHoldingEntryResponseEntryCountByGtaId;
  entryGtaIds: number[];
  entryOxenAmount: number;
  gender: EnumsOxGender;
  identifiedCountByGtaId: GetHoldingEntryResponseIdentifiedCountByGtaId;
  purchaseDbId: number;
  purchaseName: string;
  purpose: EnumsOxPurpose;
  variety: string;
  weightingMapReferenceCode: GetHoldingEntryResponseWeightingMapReferenceCode;
}

export type GetHistoryReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetHistoryReportXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type GetHistoryReportXlsxResponseAnyOf = {
  buffer: GetHistoryReportXlsxResponseAnyOfBuffer;
};

export type GetHistoryReportXlsxResponse =
  | GetHistoryReportXlsxResponseAnyOf
  | GetHistoryReportXlsxResponseAnyOfThree;

export type GetHealthProtocolResponse = GetHealthProtocolResponseAnyOf | null;

export type GetHealthProtocolResponseAnyOfMedicinesItemPerKg = number | null;

export type GetHealthProtocolResponseAnyOfMedicinesItemKiloDose = number | null;

export type GetHealthProtocolResponseAnyOfMedicinesItemApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export type GetHealthProtocolResponseAnyOfMedicinesItem = {
  active: boolean;
  applicationSuggestion: GetHealthProtocolResponseAnyOfMedicinesItemApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: GetHealthProtocolResponseAnyOfMedicinesItemKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: GetHealthProtocolResponseAnyOfMedicinesItemPerKg;
  type: EnumsMedicineType;
};

export type GetHealthProtocolResponseAnyOfImagesItemName = string | null;

export type GetHealthProtocolResponseAnyOfImagesItemMedicineId = number | null;

export type GetHealthProtocolResponseAnyOfImagesItemHealthProtocolId =
  | number
  | null;

export type GetHealthProtocolResponseAnyOfImagesItem = {
  base64: string;
  farmId: number;
  healthProtocolId: GetHealthProtocolResponseAnyOfImagesItemHealthProtocolId;
  id: number;
  medicineId: GetHealthProtocolResponseAnyOfImagesItemMedicineId;
  name: GetHealthProtocolResponseAnyOfImagesItemName;
};

export type GetHealthProtocolResponseAnyOf = {
  active: boolean;
  createdAt: string;
  farmId: number;
  id: number;
  images: GetHealthProtocolResponseAnyOfImagesItem[];
  medicines: GetHealthProtocolResponseAnyOfMedicinesItem[];
  name: string;
};

export type GetGtaResponseWeightingMapId = number | null;

export type GetGtaResponseWeightAverage = number | null;

export type GetGtaResponsePurchaseId = number | null;

export type GetGtaResponsePurchase = GetGtaResponsePurchaseAnyOf | null;

export interface GetGtaResponse {
  ages: GetGtaResponseAgesItem[];
  completed: boolean;
  description: GetGtaResponseDescription;
  destiny: GetGtaResponseDestiny;
  destinyId: GetGtaResponseDestinyId;
  distance: GetGtaResponseDistance;
  emission: string;
  entry: string;
  expiration: string;
  farm: GetGtaResponseFarm;
  farmId: number;
  hours: GetGtaResponseHours;
  id: number;
  invoice: GetGtaResponseInvoice;
  number: string;
  origin: GetGtaResponseOrigin;
  originId: number;
  originWeightAverage: GetGtaResponseOriginWeightAverage;
  oxen: GetGtaResponseOxenItem[];
  purchase: GetGtaResponsePurchase;
  purchaseId: GetGtaResponsePurchaseId;
  series: string;
  weightAverage: GetGtaResponseWeightAverage;
  weightingMapId: GetGtaResponseWeightingMapId;
}

export type GetGtaResponsePurchaseAnyOfWeighingAt = string | null;

export type GetGtaResponsePurchaseAnyOfPurchaseReceivedAt = string | null;

export type GetGtaResponsePurchaseAnyOfPurchasePartnerHerd = string | null;

export type GetGtaResponsePurchaseAnyOfPurchaseObservation = string | null;

export type GetGtaResponsePurchaseAnyOfPurchaseEarringsPerPage = number | null;

export type GetGtaResponsePurchaseAnyOfPurchase = {
  category: EnumsPurchaseCategory;
  earringsPerPage: GetGtaResponsePurchaseAnyOfPurchaseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: GetGtaResponsePurchaseAnyOfPurchaseObservation;
  partnerHerd: GetGtaResponsePurchaseAnyOfPurchasePartnerHerd;
  price: number;
  receivedAt: GetGtaResponsePurchaseAnyOfPurchaseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
};

export type GetGtaResponsePurchaseAnyOfPartnerId = number | null;

export type GetGtaResponsePurchaseAnyOfOxenAmount = number | null;

export type GetGtaResponsePurchaseAnyOfMapa = string | null;

export type GetGtaResponsePurchaseAnyOfMaleProducedPrice = number | null;

export type GetGtaResponsePurchaseAnyOfMaleFutureAnimalPrice = number | null;

export type GetGtaResponsePurchaseAnyOfMaleEntryCarcassYield = number | null;

export type GetGtaResponsePurchaseAnyOfMaleDailyPrice = number | null;

export type GetGtaResponsePurchaseAnyOfFemaleProducedPrice = number | null;

export type GetGtaResponsePurchaseAnyOfFemaleFutureAnimalPrice = number | null;

export type GetGtaResponsePurchaseAnyOfFemaleEntryCarcassYield = number | null;

export type GetGtaResponsePurchaseAnyOfFemaleDailyPrice = number | null;

export type GetGtaResponsePurchaseAnyOfDiscountPercent = number | null;

export type GetGtaResponsePurchaseAnyOf = {
  buyerId: number;
  commission: number;
  discountPercent: GetGtaResponsePurchaseAnyOfDiscountPercent;
  femaleDailyPrice: GetGtaResponsePurchaseAnyOfFemaleDailyPrice;
  femaleEntryCarcassYield: GetGtaResponsePurchaseAnyOfFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: GetGtaResponsePurchaseAnyOfFemaleFutureAnimalPrice;
  femaleProducedPrice: GetGtaResponsePurchaseAnyOfFemaleProducedPrice;
  id: number;
  maleDailyPrice: GetGtaResponsePurchaseAnyOfMaleDailyPrice;
  maleEntryCarcassYield: GetGtaResponsePurchaseAnyOfMaleEntryCarcassYield;
  maleFutureAnimalPrice: GetGtaResponsePurchaseAnyOfMaleFutureAnimalPrice;
  maleProducedPrice: GetGtaResponsePurchaseAnyOfMaleProducedPrice;
  mapa: GetGtaResponsePurchaseAnyOfMapa;
  ownerId: number;
  oxenAmount: GetGtaResponsePurchaseAnyOfOxenAmount;
  partnerId: GetGtaResponsePurchaseAnyOfPartnerId;
  purchase: GetGtaResponsePurchaseAnyOfPurchase;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: GetGtaResponsePurchaseAnyOfWeighingAt;
  weightAverage: number;
};

export type GetGtaResponseOxenItemStartOfTreatment = string | null;

export type GetGtaResponseOxenItemSisbov = string | null;

export type GetGtaResponseOxenItemSalesMarketType = EnumsSalesMarketType | null;

export type GetGtaResponseOxenItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetGtaResponseOxenItemReversedDeathDetails = string | null;

export type GetGtaResponseOxenItemReversedDeathDate = string | null;

export type GetGtaResponseOxenItemReversedDeathCause = EnumsDeathCause | null;

export type GetGtaResponseOxenItemPurchaseId = number | null;

export type GetGtaResponseOxenItemPriceAtSignExit = number | null;

export type GetGtaResponseOxenItemPriceAtSignEntry = number | null;

export type GetGtaResponseOxenItemOwner = {
  id: number;
  name: string;
};

export type GetGtaResponseOxenItemOtherDeathCause = string | null;

export type GetGtaResponseOxenItemIsNecropsyPerformed = boolean | null;

export type GetGtaResponseOxenItemInvoice = string | null;

export type GetGtaResponseOxenItemInternalSaleId = number | null;

export type GetGtaResponseOxenItemIdentifier = string | null;

export type GetGtaResponseOxenItemIdentifiedAt = string | null;

export type GetGtaResponseOxenItemIdentificationSource =
  EnumsIdentificationSource | null;

export type GetGtaResponseOxenItemHasBirthAnnouncement = boolean | null;

export type GetGtaResponseOxenItemGtaId = number | null;

export type GetGtaResponseOxenItemExitTruckId = number | null;

export type GetGtaResponseOxenItemElectronic = string | null;

export type GetGtaResponseOxenItemDiedAt = string | null;

export type GetGtaResponseOxenItemDentitionStage = EnumsDentitionStage | null;

export type GetGtaResponseOxenItemDeathReason = EnumsDeathCause | null;

export type GetGtaResponseOxenItemDeathNecropsy = EnumsDeathNecropsy | null;

export type GetGtaResponseOxenItemDeathDetails = string | null;

export type GetGtaResponseOxenItemDeathCause = EnumsDeathCause | null;

export type GetGtaResponseOxenItemCorralName = string | null;

export type GetGtaResponseOxenItemComments = string | null;

export type GetGtaResponseOxenItemCertifierDate = string | null;

export type GetGtaResponseOxenItemCattleManifestId = number | null;

export type GetGtaResponseOxenItemCarcassWeight = number | null;

export type GetGtaResponseOxenItemCarcassType = EnumsCarcassType | null;

export type GetGtaResponseOxenItemCarcassPrice = number | null;

export type GetGtaResponseOxenItemCarcass = number | null;

export type GetGtaResponseOxenItemBornOnFarm = boolean | null;

export type GetGtaResponseOxenItemBndTracked = boolean | null;

export type GetGtaResponseOxenItemBatchName = string | null;

export type GetGtaResponseOxenItem = {
  batchName: GetGtaResponseOxenItemBatchName;
  birth: string;
  blockedUntil: string;
  bndTracked: GetGtaResponseOxenItemBndTracked;
  bornOnFarm: GetGtaResponseOxenItemBornOnFarm;
  breed: string;
  carcass: GetGtaResponseOxenItemCarcass;
  carcassPrice: GetGtaResponseOxenItemCarcassPrice;
  carcassType: GetGtaResponseOxenItemCarcassType;
  carcassWeight: GetGtaResponseOxenItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: GetGtaResponseOxenItemCattleManifestId;
  certifierDate: GetGtaResponseOxenItemCertifierDate;
  comments: GetGtaResponseOxenItemComments;
  corralName: GetGtaResponseOxenItemCorralName;
  deathCause: GetGtaResponseOxenItemDeathCause;
  deathDetails: GetGtaResponseOxenItemDeathDetails;
  deathNecropsy: GetGtaResponseOxenItemDeathNecropsy;
  deathReason: GetGtaResponseOxenItemDeathReason;
  dentitionStage: GetGtaResponseOxenItemDentitionStage;
  diedAt: GetGtaResponseOxenItemDiedAt;
  electronic: GetGtaResponseOxenItemElectronic;
  exitTruckId: GetGtaResponseOxenItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: GetGtaResponseOxenItemGtaId;
  hasBirthAnnouncement: GetGtaResponseOxenItemHasBirthAnnouncement;
  id: number;
  identificationSource: GetGtaResponseOxenItemIdentificationSource;
  identifiedAt: GetGtaResponseOxenItemIdentifiedAt;
  identifier: GetGtaResponseOxenItemIdentifier;
  includedAt: string;
  internalSaleId: GetGtaResponseOxenItemInternalSaleId;
  invoice: GetGtaResponseOxenItemInvoice;
  isNecropsyPerformed: GetGtaResponseOxenItemIsNecropsyPerformed;
  otherDeathCause: GetGtaResponseOxenItemOtherDeathCause;
  owner: GetGtaResponseOxenItemOwner;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: GetGtaResponseOxenItemPriceAtSignEntry;
  priceAtSignExit: GetGtaResponseOxenItemPriceAtSignExit;
  processed: boolean;
  purchaseId: GetGtaResponseOxenItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: GetGtaResponseOxenItemReversedDeathCause;
  reversedDeathDate: GetGtaResponseOxenItemReversedDeathDate;
  reversedDeathDetails: GetGtaResponseOxenItemReversedDeathDetails;
  reversedDeathNecropsy: GetGtaResponseOxenItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: GetGtaResponseOxenItemSalesMarketType;
  sisbov: GetGtaResponseOxenItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: GetGtaResponseOxenItemStartOfTreatment;
  variety: string;
};

export type GetGtaResponseOriginWeightAverage = number | null;

export type GetGtaResponseOriginResponsiblePhone = string | null;

export type GetGtaResponseOriginResponsibleDocument = string | null;

export type GetGtaResponseOriginResponsibleDescription = string | null;

export type GetGtaResponseOriginResponsibleCode = string | null;

export type GetGtaResponseOriginResponsible = {
  code: GetGtaResponseOriginResponsibleCode;
  createdAt: string;
  description: GetGtaResponseOriginResponsibleDescription;
  document: GetGtaResponseOriginResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetGtaResponseOriginResponsiblePhone;
  profiles: EnumsProfile[];
};

export type GetGtaResponseOriginCode = string | null;

export type GetGtaResponseOriginCattleManifestLayoutId = number | null;

export type GetGtaResponseOrigin = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: GetGtaResponseOriginCattleManifestLayoutId;
  code: GetGtaResponseOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetGtaResponseOriginResponsible;
  responsibleId: number;
};

export type GetGtaResponseInvoice = string | null;

export type GetGtaResponseHours = number | null;

export type GetGtaResponseFarmSenarPercent = number | null;

export type GetGtaResponseFarmMatinalReadTime = string | null;

export type GetGtaResponseFarmLastCertifierImport = string | null;

export type GetGtaResponseFarmLastBndImport = string | null;

export type GetGtaResponseFarmInstallRunId = string | null;

export type GetGtaResponseFarmCustomerId = string | null;

export type GetGtaResponseFarmCorrectionPercent = number | null;

export type GetGtaResponseFarmAlias = string | null;

export type GetGtaResponseFarm = {
  addressId: number;
  alias: GetGtaResponseFarmAlias;
  blockedDays: number;
  correctionPercent: GetGtaResponseFarmCorrectionPercent;
  createdAt: string;
  customerId: GetGtaResponseFarmCustomerId;
  dailyCost: number;
  day: string;
  divisionThreshold: number;
  factory: GlobalPrismaJsonLatLng[];
  gradeInfo: unknown;
  gradeMethod: EnumsGradeMethod;
  hasAutomation: boolean;
  hasTraceability: boolean;
  id: number;
  installRunId: GetGtaResponseFarmInstallRunId;
  interestRate: number;
  lastBndImport: GetGtaResponseFarmLastBndImport;
  lastCertifierImport: GetGtaResponseFarmLastCertifierImport;
  managementConfig: unknown;
  matinalReadTime: GetGtaResponseFarmMatinalReadTime;
  name: string;
  nightlyReadTimes: string[];
  position: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification: boolean;
  sapId: string;
  senarPercent: GetGtaResponseFarmSenarPercent;
  treatViewType: EnumsTreatViewType;
};

export type GetGtaResponseDistance = number | null;

export type GetGtaResponseDestinyId = number | null;

export type GetGtaResponseDestiny = GetGtaResponseDestinyAnyOf | null;

export type GetGtaResponseDestinyAnyOfResponsiblePhone = string | null;

export type GetGtaResponseDestinyAnyOfResponsibleDocument = string | null;

export type GetGtaResponseDestinyAnyOfResponsibleDescription = string | null;

export type GetGtaResponseDestinyAnyOfResponsibleCode = string | null;

export type GetGtaResponseDestinyAnyOfResponsible = {
  code: GetGtaResponseDestinyAnyOfResponsibleCode;
  createdAt: string;
  description: GetGtaResponseDestinyAnyOfResponsibleDescription;
  document: GetGtaResponseDestinyAnyOfResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetGtaResponseDestinyAnyOfResponsiblePhone;
  profiles: EnumsProfile[];
};

export type GetGtaResponseDestinyAnyOfCode = string | null;

export type GetGtaResponseDestinyAnyOfCattleManifestLayoutId = number | null;

export type GetGtaResponseDestinyAnyOf = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: GetGtaResponseDestinyAnyOfCattleManifestLayoutId;
  code: GetGtaResponseDestinyAnyOfCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetGtaResponseDestinyAnyOfResponsible;
  responsibleId: number;
};

export type GetGtaResponseDescription = string | null;

export type GetGtaResponseAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  oxen: GetGtaResponseAgesItemOxenItem[];
  yearsOld: number;
};

export type GetGtaResponseAgesItemOxenItemStartOfTreatment = string | null;

export type GetGtaResponseAgesItemOxenItemSisbov = string | null;

export type GetGtaResponseAgesItemOxenItemSalesMarketType =
  EnumsSalesMarketType | null;

export type GetGtaResponseAgesItemOxenItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetGtaResponseAgesItemOxenItemReversedDeathDetails = string | null;

export type GetGtaResponseAgesItemOxenItemReversedDeathDate = string | null;

export type GetGtaResponseAgesItemOxenItemReversedDeathCause =
  EnumsDeathCause | null;

export type GetGtaResponseAgesItemOxenItemPurchaseId = number | null;

export type GetGtaResponseAgesItemOxenItemPriceAtSignExit = number | null;

export type GetGtaResponseAgesItemOxenItemPriceAtSignEntry = number | null;

export type GetGtaResponseAgesItemOxenItemOwner = {
  id: number;
  name: string;
};

export type GetGtaResponseAgesItemOxenItemOtherDeathCause = string | null;

export type GetGtaResponseAgesItemOxenItemIsNecropsyPerformed = boolean | null;

export type GetGtaResponseAgesItemOxenItemInvoice = string | null;

export type GetGtaResponseAgesItemOxenItemInternalSaleId = number | null;

export type GetGtaResponseAgesItemOxenItemIdentifier = string | null;

export type GetGtaResponseAgesItemOxenItemIdentifiedAt = string | null;

export type GetGtaResponseAgesItemOxenItemIdentificationSource =
  EnumsIdentificationSource | null;

export type GetGtaResponseAgesItemOxenItemHasBirthAnnouncement = boolean | null;

export type GetGtaResponseAgesItemOxenItemGtaId = number | null;

export type GetGtaResponseAgesItemOxenItemExitTruckId = number | null;

export type GetGtaResponseAgesItemOxenItemElectronic = string | null;

export type GetGtaResponseAgesItemOxenItemDiedAt = string | null;

export type GetGtaResponseAgesItemOxenItemDentitionStage =
  EnumsDentitionStage | null;

export type GetGtaResponseAgesItemOxenItemDeathReason = EnumsDeathCause | null;

export type GetGtaResponseAgesItemOxenItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetGtaResponseAgesItemOxenItemDeathDetails = string | null;

export type GetGtaResponseAgesItemOxenItemDeathCause = EnumsDeathCause | null;

export type GetGtaResponseAgesItemOxenItemCorralName = string | null;

export type GetGtaResponseAgesItemOxenItemComments = string | null;

export type GetGtaResponseAgesItemOxenItemCertifierDate = string | null;

export type GetGtaResponseAgesItemOxenItemCattleManifestId = number | null;

export type GetGtaResponseAgesItemOxenItemCarcassWeight = number | null;

export type GetGtaResponseAgesItemOxenItemCarcassType = EnumsCarcassType | null;

export type GetGtaResponseAgesItemOxenItemCarcassPrice = number | null;

export type GetGtaResponseAgesItemOxenItemCarcass = number | null;

export type GetGtaResponseAgesItemOxenItemBornOnFarm = boolean | null;

export type GetGtaResponseAgesItemOxenItemBndTracked = boolean | null;

export type GetGtaResponseAgesItemOxenItemBatchName = string | null;

export type GetGtaResponseAgesItemOxenItem = {
  batchName: GetGtaResponseAgesItemOxenItemBatchName;
  birth: string;
  blockedUntil: string;
  bndTracked: GetGtaResponseAgesItemOxenItemBndTracked;
  bornOnFarm: GetGtaResponseAgesItemOxenItemBornOnFarm;
  breed: string;
  carcass: GetGtaResponseAgesItemOxenItemCarcass;
  carcassPrice: GetGtaResponseAgesItemOxenItemCarcassPrice;
  carcassType: GetGtaResponseAgesItemOxenItemCarcassType;
  carcassWeight: GetGtaResponseAgesItemOxenItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: GetGtaResponseAgesItemOxenItemCattleManifestId;
  certifierDate: GetGtaResponseAgesItemOxenItemCertifierDate;
  comments: GetGtaResponseAgesItemOxenItemComments;
  corralName: GetGtaResponseAgesItemOxenItemCorralName;
  deathCause: GetGtaResponseAgesItemOxenItemDeathCause;
  deathDetails: GetGtaResponseAgesItemOxenItemDeathDetails;
  deathNecropsy: GetGtaResponseAgesItemOxenItemDeathNecropsy;
  deathReason: GetGtaResponseAgesItemOxenItemDeathReason;
  dentitionStage: GetGtaResponseAgesItemOxenItemDentitionStage;
  diedAt: GetGtaResponseAgesItemOxenItemDiedAt;
  electronic: GetGtaResponseAgesItemOxenItemElectronic;
  exitTruckId: GetGtaResponseAgesItemOxenItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: GetGtaResponseAgesItemOxenItemGtaId;
  hasBirthAnnouncement: GetGtaResponseAgesItemOxenItemHasBirthAnnouncement;
  id: number;
  identificationSource: GetGtaResponseAgesItemOxenItemIdentificationSource;
  identifiedAt: GetGtaResponseAgesItemOxenItemIdentifiedAt;
  identifier: GetGtaResponseAgesItemOxenItemIdentifier;
  includedAt: string;
  internalSaleId: GetGtaResponseAgesItemOxenItemInternalSaleId;
  invoice: GetGtaResponseAgesItemOxenItemInvoice;
  isNecropsyPerformed: GetGtaResponseAgesItemOxenItemIsNecropsyPerformed;
  otherDeathCause: GetGtaResponseAgesItemOxenItemOtherDeathCause;
  owner: GetGtaResponseAgesItemOxenItemOwner;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: GetGtaResponseAgesItemOxenItemPriceAtSignEntry;
  priceAtSignExit: GetGtaResponseAgesItemOxenItemPriceAtSignExit;
  processed: boolean;
  purchaseId: GetGtaResponseAgesItemOxenItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: GetGtaResponseAgesItemOxenItemReversedDeathCause;
  reversedDeathDate: GetGtaResponseAgesItemOxenItemReversedDeathDate;
  reversedDeathDetails: GetGtaResponseAgesItemOxenItemReversedDeathDetails;
  reversedDeathNecropsy: GetGtaResponseAgesItemOxenItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: GetGtaResponseAgesItemOxenItemSalesMarketType;
  sisbov: GetGtaResponseAgesItemOxenItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: GetGtaResponseAgesItemOxenItemStartOfTreatment;
  variety: string;
};

export type GetFoodStockReportResponse = EfficiencyFood[];

export type GetFoodStockHistoryResponseHistoryItemOperation =
  (typeof GetFoodStockHistoryResponseHistoryItemOperation)[keyof typeof GetFoodStockHistoryResponseHistoryItemOperation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFoodStockHistoryResponseHistoryItemOperation = {
  EXIT: "EXIT",
  ENTRY: "ENTRY",
} as const;

export type GetFoodStockHistoryResponseHistoryItem = {
  date: string;
  description?: string;
  dryMatter: number;
  dryMatterInStock: number;
  dryMatterKilePrice: number;
  dryMatterPercentage: number;
  name: string;
  naturalMatter: number;
  naturalMatterInStock: number;
  naturalMatterKilePrice: number;
  operation: GetFoodStockHistoryResponseHistoryItemOperation;
  stockId: number;
};

export interface GetFoodStockHistoryResponse {
  history: GetFoodStockHistoryResponseHistoryItem[];
  name: string;
}

export type GetFoodReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetFoodReportXlsxResponse =
  | GetFoodReportXlsxResponseAnyOf
  | GetFoodReportXlsxResponseAnyOfThree;

export type GetFoodReportXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type GetFoodReportXlsxResponseAnyOf = {
  buffer: GetFoodReportXlsxResponseAnyOfBuffer;
};

export type GetFoodHistoryReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetFoodHistoryReportXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type GetFoodHistoryReportXlsxResponseAnyOf = {
  buffer: GetFoodHistoryReportXlsxResponseAnyOfBuffer;
};

export type GetFoodHistoryReportXlsxResponse =
  | GetFoodHistoryReportXlsxResponseAnyOf
  | GetFoodHistoryReportXlsxResponseAnyOfThree;

export type GetFoodEnergyHistoryReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GetFoodEnergyHistoryReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GetFoodEnergyHistoryReportExcelResponseAnyOf = {
  buffer: GetFoodEnergyHistoryReportExcelResponseAnyOfBuffer;
};

export type GetFoodEnergyHistoryReportExcelResponse =
  | GetFoodEnergyHistoryReportExcelResponseAnyOf
  | GetFoodEnergyHistoryReportExcelResponseAnyOfThree;

export interface GetFeedLinkIntegrityResponse {
  awaitingReview: number;
  future: number;
}

export interface GetFeedLinkDataV2Response {
  error: FeedLinkFile[];
  pending: FeedLinkFile[];
  review: FeedLinkFile[];
  success: FeedLinkFile[];
}

export type GetFeedLinkDataResponse = GetFeedLinkDataResponseItem[];

export type GetFeedLinkDataResponseItemTreatStatusesItemTRATOPREVHORAPREV =
  | string
  | null;

export type GetFeedLinkDataResponseItemTreatStatusesItemTRATOHORA =
  | string
  | null;

export type GetFeedLinkDataResponseItemTreatStatusesItemError = string | null;

export type GetFeedLinkDataResponseItemTreatStatusesItem = {
  error: GetFeedLinkDataResponseItemTreatStatusesItemError;
  feedLinkId: number;
  id: number;
  PIQ_AT_POS: number;
  status: EnumsFeedLinkStatus;
  TRATO_HORA: GetFeedLinkDataResponseItemTreatStatusesItemTRATOHORA;
  TRATOPREV_CONC: boolean;
  TRATOPREV_DATA: string;
  TRATOPREV_HORAPREV: GetFeedLinkDataResponseItemTreatStatusesItemTRATOPREVHORAPREV;
};

export type GetFeedLinkDataResponseItemTreatsItemTRATOHORAPREV = string | null;

export type GetFeedLinkDataResponseItemTreatsItemError = string | null;

export type GetFeedLinkDataResponseItemTreatsItem = {
  BAL_AT_COD: number;
  BAT_BAL_SEQ: number;
  DIETA_AT_COD: number;
  DISTR_AT_COD: number;
  error: GetFeedLinkDataResponseItemTreatsItemError;
  feedLinkId: number;
  FUNC_AT_NUM: number;
  id: number;
  PIQ_AT_POS: number;
  status: EnumsFeedLinkStatus;
  TRATO_CONC: boolean;
  TRATO_DATA: string;
  TRATO_DISTR_SEQ: number;
  TRATO_HORA: string;
  TRATO_HORAPREV: GetFeedLinkDataResponseItemTreatsItemTRATOHORAPREV;
  TRATO_PROPCONC: number;
  TRATO_QT: number;
  TRATO_QTCONC: number;
  TRATO_QTPREV: number;
  TRATO_QTPREVAJ: number;
};

export type GetFeedLinkDataResponseItemReview = EnumsFeedLinkReview | null;

export type GetFeedLinkDataResponseItemReferenceDay = string | null;

export type GetFeedLinkDataResponseItemError = string | null;

export type GetFeedLinkDataResponseItem = {
  beatIngredients: GetFeedLinkDataResponseItemBeatIngredientsItem[];
  beats: GetFeedLinkDataResponseItemBeatsItem[];
  createdAt: string;
  day: string;
  error: GetFeedLinkDataResponseItemError;
  filename: string;
  id: number;
  referenceDay: GetFeedLinkDataResponseItemReferenceDay;
  review: GetFeedLinkDataResponseItemReview;
  slug: EnumsFeedLinkSlug;
  treats: GetFeedLinkDataResponseItemTreatsItem[];
  treatStatuses: GetFeedLinkDataResponseItemTreatStatusesItem[];
  updatedAt: string;
};

export type GetFeedLinkDataResponseItemBeatsItemError = string | null;

export type GetFeedLinkDataResponseItemBeatsItem = {
  BAL_AT_COD: number;
  BAT_BAL_SEQ: number;
  BAT_DATA: string;
  BAT_HORA: string;
  BAT_MIXTEMPO: string;
  BAT_QTMO: number;
  BAT_QTMOPREV: number;
  DIETA_AT_COD: number;
  error: GetFeedLinkDataResponseItemBeatsItemError;
  feedLinkId: number;
  FUNC_AT_NUM: number;
  id: number;
  RCT_AT_COD: number;
  status: EnumsFeedLinkStatus;
};

export type GetFeedLinkDataResponseItemBeatIngredientsItemError = string | null;

export type GetFeedLinkDataResponseItemBeatIngredientsItemBATALIMQTMOPREV =
  | number
  | null;

export type GetFeedLinkDataResponseItemBeatIngredientsItem = {
  ALIM_COD: string;
  BAL_AT_COD: number;
  BAT_BAL_SEQ: number;
  BAT_DATA: string;
  BATALIM_QTMOPREV: GetFeedLinkDataResponseItemBeatIngredientsItemBATALIMQTMOPREV;
  BATALIM_QTMOREAL: number;
  error: GetFeedLinkDataResponseItemBeatIngredientsItemError;
  feedLinkId: number;
  id: number;
  PALIM_COD: string;
  status: EnumsFeedLinkStatus;
};

export type GetFarmDaysResponseItem = {
  beat: boolean;
  day: string;
  management: boolean;
  treatment: boolean;
};

export type GetFarmDaysResponse = GetFarmDaysResponseItem[];

export type GetExitTruckResponseSaleOrderId = number | null;

export type GetExitTruckResponseSaleId = number | null;

export type GetExitTruckResponsePlate = string | null;

export type GetExitTruckResponseName = string | null;

export interface GetExitTruckResponse {
  announcementId: GetExitTruckResponseAnnouncementId;
  bigWeighingMachineWeightKg: GetExitTruckResponseBigWeighingMachineWeightKg;
  boarding: GetExitTruckResponseBoardingItem[];
  capacity: number;
  destiny: GetExitTruckResponseDestiny;
  destinyId: GetExitTruckResponseDestinyId;
  exitAt: string;
  exitGta: GetExitTruckResponseExitGta;
  exitGtaSeries: GetExitTruckResponseExitGtaSeries;
  farmId: number;
  holdingSaleId: GetExitTruckResponseHoldingSaleId;
  id: number;
  info: GetExitTruckResponseInfo;
  invoices: GetExitTruckResponseInvoicesItem[];
  isVisible: boolean;
  name: GetExitTruckResponseName;
  oxenAmount: number;
  plate: GetExitTruckResponsePlate;
  reason: EnumsExitReason;
  saleId: GetExitTruckResponseSaleId;
  saleOrderId: GetExitTruckResponseSaleOrderId;
  status: EnumsExitTruckStatus;
  totalWeights: number;
}

export type GetExitTruckResponseInvoicesItemWeightingMapId = number | null;

export type GetExitTruckResponseInvoicesItemSaleOrderId = number | null;

export type GetExitTruckResponseInvoicesItemIsComplement = boolean | null;

export type GetExitTruckResponseInvoicesItemExitTruckId = number | null;

export type GetExitTruckResponseInvoicesItemEmittedAt = string | null;

export type GetExitTruckResponseInvoicesItem = {
  emittedAt: GetExitTruckResponseInvoicesItemEmittedAt;
  exitTruckId: GetExitTruckResponseInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: GetExitTruckResponseInvoicesItemIsComplement;
  number: string;
  saleOrderId: GetExitTruckResponseInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: GetExitTruckResponseInvoicesItemWeightingMapId;
};

export type GetExitTruckResponseInfo = string | null;

export type GetExitTruckResponseHoldingSaleId = number | null;

export type GetExitTruckResponseExitGtaSeries = string | null;

export type GetExitTruckResponseExitGta = string | null;

export type GetExitTruckResponseDestinyId = number | null;

export type GetExitTruckResponseDestinyAnyOfCode = string | null;

export type GetExitTruckResponseDestinyAnyOfCattleManifestLayoutId =
  | number
  | null;

export type GetExitTruckResponseDestinyAnyOf = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: GetExitTruckResponseDestinyAnyOfCattleManifestLayoutId;
  code: GetExitTruckResponseDestinyAnyOfCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsibleId: number;
};

export type GetExitTruckResponseDestiny =
  GetExitTruckResponseDestinyAnyOf | null;

export type GetExitTruckResponseBoardingItemWeightsItemType =
  EnumsWeightType | null;

export type GetExitTruckResponseBoardingItemWeightsItem = {
  date: string;
  id: number;
  oxId: number;
  source: EnumsWeightSource;
  type: GetExitTruckResponseBoardingItemWeightsItemType;
  weight: number;
};

export type GetExitTruckResponseBoardingItemStartOfTreatment = string | null;

export type GetExitTruckResponseBoardingItemSisbov = string | null;

export type GetExitTruckResponseBoardingItemSalesMarketType =
  EnumsSalesMarketType | null;

export type GetExitTruckResponseBoardingItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetExitTruckResponseBoardingItemReversedDeathDetails =
  | string
  | null;

export type GetExitTruckResponseBoardingItemReversedDeathDate = string | null;

export type GetExitTruckResponseBoardingItemReversedDeathCause =
  EnumsDeathCause | null;

export type GetExitTruckResponseBoardingItemPurchaseId = number | null;

export type GetExitTruckResponseBoardingItemPriceAtSignExit = number | null;

export type GetExitTruckResponseBoardingItemPriceAtSignEntry = number | null;

export type GetExitTruckResponseBoardingItemOtherDeathCause = string | null;

export type GetExitTruckResponseBoardingItemIsNecropsyPerformed =
  | boolean
  | null;

export type GetExitTruckResponseBoardingItemInvoice = string | null;

export type GetExitTruckResponseBoardingItemInternalSaleId = number | null;

export type GetExitTruckResponseBoardingItemIdentifier = string | null;

export type GetExitTruckResponseBoardingItemIdentifiedAt = string | null;

export type GetExitTruckResponseBoardingItemIdentificationSource =
  EnumsIdentificationSource | null;

export type GetExitTruckResponseBoardingItemHasBirthAnnouncement =
  | boolean
  | null;

export type GetExitTruckResponseBoardingItemGtaId = number | null;

export type GetExitTruckResponseBoardingItemExitTruckId = number | null;

export type GetExitTruckResponseBoardingItemElectronic = string | null;

export type GetExitTruckResponseBoardingItemDiedAt = string | null;

export type GetExitTruckResponseBoardingItemDentitionStage =
  EnumsDentitionStage | null;

export type GetExitTruckResponseBoardingItemDeathReason =
  EnumsDeathCause | null;

export type GetExitTruckResponseBoardingItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetExitTruckResponseBoardingItemDeathDetails = string | null;

export type GetExitTruckResponseBoardingItemDeathCause = EnumsDeathCause | null;

export type GetExitTruckResponseBoardingItemComments = string | null;

export type GetExitTruckResponseBoardingItemCertifierDate = string | null;

export type GetExitTruckResponseBoardingItemCattleManifestId = number | null;

export type GetExitTruckResponseBoardingItemCarcassWeight = number | null;

export type GetExitTruckResponseBoardingItemCarcassType =
  EnumsCarcassType | null;

export type GetExitTruckResponseBoardingItemCarcassPrice = number | null;

export type GetExitTruckResponseBoardingItemCarcass = number | null;

export type GetExitTruckResponseBoardingItemBornOnFarm = boolean | null;

export type GetExitTruckResponseBoardingItemBndTracked = boolean | null;

export type GetExitTruckResponseBoardingItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: GetExitTruckResponseBoardingItemBndTracked;
  bornOnFarm: GetExitTruckResponseBoardingItemBornOnFarm;
  breed: string;
  carcass: GetExitTruckResponseBoardingItemCarcass;
  carcassPrice: GetExitTruckResponseBoardingItemCarcassPrice;
  carcassType: GetExitTruckResponseBoardingItemCarcassType;
  carcassWeight: GetExitTruckResponseBoardingItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: GetExitTruckResponseBoardingItemCattleManifestId;
  certifierDate: GetExitTruckResponseBoardingItemCertifierDate;
  comments: GetExitTruckResponseBoardingItemComments;
  deathCause: GetExitTruckResponseBoardingItemDeathCause;
  deathDetails: GetExitTruckResponseBoardingItemDeathDetails;
  deathNecropsy: GetExitTruckResponseBoardingItemDeathNecropsy;
  deathReason: GetExitTruckResponseBoardingItemDeathReason;
  dentitionStage: GetExitTruckResponseBoardingItemDentitionStage;
  diedAt: GetExitTruckResponseBoardingItemDiedAt;
  electronic: GetExitTruckResponseBoardingItemElectronic;
  exitTruckId: GetExitTruckResponseBoardingItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: GetExitTruckResponseBoardingItemGtaId;
  hasBirthAnnouncement: GetExitTruckResponseBoardingItemHasBirthAnnouncement;
  id: number;
  identificationSource: GetExitTruckResponseBoardingItemIdentificationSource;
  identifiedAt: GetExitTruckResponseBoardingItemIdentifiedAt;
  identifier: GetExitTruckResponseBoardingItemIdentifier;
  includedAt: string;
  internalSaleId: GetExitTruckResponseBoardingItemInternalSaleId;
  invoice: GetExitTruckResponseBoardingItemInvoice;
  isNecropsyPerformed: GetExitTruckResponseBoardingItemIsNecropsyPerformed;
  otherDeathCause: GetExitTruckResponseBoardingItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: GetExitTruckResponseBoardingItemPriceAtSignEntry;
  priceAtSignExit: GetExitTruckResponseBoardingItemPriceAtSignExit;
  purchaseId: GetExitTruckResponseBoardingItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: GetExitTruckResponseBoardingItemReversedDeathCause;
  reversedDeathDate: GetExitTruckResponseBoardingItemReversedDeathDate;
  reversedDeathDetails: GetExitTruckResponseBoardingItemReversedDeathDetails;
  reversedDeathNecropsy: GetExitTruckResponseBoardingItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: GetExitTruckResponseBoardingItemSalesMarketType;
  sisbov: GetExitTruckResponseBoardingItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: GetExitTruckResponseBoardingItemStartOfTreatment;
  variety: string;
  weights: GetExitTruckResponseBoardingItemWeightsItem[];
};

export type GetExitTruckResponseBigWeighingMachineWeightKg = number | null;

export type GetExitTruckResponseAnnouncementId = number | null;

export type GetExitAnnouncementResponseTrucksItemPlate = string | null;

export type GetExitAnnouncementResponseTrucksItem = {
  exitAt: string;
  exitGta: GetExitAnnouncementResponseTrucksItemExitGta;
  exitGtaSeries: GetExitAnnouncementResponseTrucksItemExitGtaSeries;
  id: number;
  name: GetExitAnnouncementResponseTrucksItemName;
  oxen: GetExitAnnouncementResponseTrucksItemOxenItem[];
  plate: GetExitAnnouncementResponseTrucksItemPlate;
  reason: EnumsExitReason;
};

export interface GetExitAnnouncementResponse {
  destiny: GetExitAnnouncementResponseDestiny;
  origin: GetExitAnnouncementResponseOrigin;
  trucks: GetExitAnnouncementResponseTrucksItem[];
}

export type GetExitAnnouncementResponseTrucksItemOxenItemStartOfTreatment =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemSisbov = string | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemSalesMarketType =
  EnumsSalesMarketType | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathDetails =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathDate =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathCause =
  EnumsDeathCause | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemPurchaseId =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemPriceAtSignExit =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemPriceAtSignEntry =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemOwnerDocument =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemOwner = {
  document: GetExitAnnouncementResponseTrucksItemOxenItemOwnerDocument;
  name: string;
};

export type GetExitAnnouncementResponseTrucksItemOxenItemOtherDeathCause =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemIsNecropsyPerformed =
  | boolean
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemInvoice =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemInternalSaleId =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemIdentifier =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemIdentifiedAt =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemIdentificationSource =
  EnumsIdentificationSource | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemHasBirthAnnouncement =
  | boolean
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemGtaId = number | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemExitTruckId =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemElectronic =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemDiedAt = string | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemDentitionStage =
  EnumsDentitionStage | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemDeathReason =
  EnumsDeathCause | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemDeathDetails =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemDeathCause =
  EnumsDeathCause | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemComments =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemCertifierDate =
  | string
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemCattleManifestId =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemCarcassWeight =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemCarcassType =
  EnumsCarcassType | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemCarcassPrice =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemCarcass =
  | number
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemBornOnFarm =
  | boolean
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItemBndTracked =
  | boolean
  | null;

export type GetExitAnnouncementResponseTrucksItemOxenItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: GetExitAnnouncementResponseTrucksItemOxenItemBndTracked;
  bornOnFarm: GetExitAnnouncementResponseTrucksItemOxenItemBornOnFarm;
  breed: string;
  carcass: GetExitAnnouncementResponseTrucksItemOxenItemCarcass;
  carcassPrice: GetExitAnnouncementResponseTrucksItemOxenItemCarcassPrice;
  carcassType: GetExitAnnouncementResponseTrucksItemOxenItemCarcassType;
  carcassWeight: GetExitAnnouncementResponseTrucksItemOxenItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: GetExitAnnouncementResponseTrucksItemOxenItemCattleManifestId;
  certifierDate: GetExitAnnouncementResponseTrucksItemOxenItemCertifierDate;
  comments: GetExitAnnouncementResponseTrucksItemOxenItemComments;
  deathCause: GetExitAnnouncementResponseTrucksItemOxenItemDeathCause;
  deathDetails: GetExitAnnouncementResponseTrucksItemOxenItemDeathDetails;
  deathNecropsy: GetExitAnnouncementResponseTrucksItemOxenItemDeathNecropsy;
  deathReason: GetExitAnnouncementResponseTrucksItemOxenItemDeathReason;
  dentitionStage: GetExitAnnouncementResponseTrucksItemOxenItemDentitionStage;
  diedAt: GetExitAnnouncementResponseTrucksItemOxenItemDiedAt;
  electronic: GetExitAnnouncementResponseTrucksItemOxenItemElectronic;
  exitTruckId: GetExitAnnouncementResponseTrucksItemOxenItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: GetExitAnnouncementResponseTrucksItemOxenItemGtaId;
  hasBirthAnnouncement: GetExitAnnouncementResponseTrucksItemOxenItemHasBirthAnnouncement;
  id: number;
  identificationSource: GetExitAnnouncementResponseTrucksItemOxenItemIdentificationSource;
  identifiedAt: GetExitAnnouncementResponseTrucksItemOxenItemIdentifiedAt;
  identifier: GetExitAnnouncementResponseTrucksItemOxenItemIdentifier;
  includedAt: string;
  internalSaleId: GetExitAnnouncementResponseTrucksItemOxenItemInternalSaleId;
  invoice: GetExitAnnouncementResponseTrucksItemOxenItemInvoice;
  isNecropsyPerformed: GetExitAnnouncementResponseTrucksItemOxenItemIsNecropsyPerformed;
  otherDeathCause: GetExitAnnouncementResponseTrucksItemOxenItemOtherDeathCause;
  owner: GetExitAnnouncementResponseTrucksItemOxenItemOwner;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: GetExitAnnouncementResponseTrucksItemOxenItemPriceAtSignEntry;
  priceAtSignExit: GetExitAnnouncementResponseTrucksItemOxenItemPriceAtSignExit;
  purchaseId: GetExitAnnouncementResponseTrucksItemOxenItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathCause;
  reversedDeathDate: GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathDate;
  reversedDeathDetails: GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathDetails;
  reversedDeathNecropsy: GetExitAnnouncementResponseTrucksItemOxenItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: GetExitAnnouncementResponseTrucksItemOxenItemSalesMarketType;
  sisbov: GetExitAnnouncementResponseTrucksItemOxenItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: GetExitAnnouncementResponseTrucksItemOxenItemStartOfTreatment;
  variety: string;
};

export type GetExitAnnouncementResponseTrucksItemName = string | null;

export type GetExitAnnouncementResponseTrucksItemExitGtaSeries = string | null;

export type GetExitAnnouncementResponseTrucksItemExitGta = string | null;

export type GetExitAnnouncementResponseOriginOwnerItemDocument = string | null;

export type GetExitAnnouncementResponseOriginOwnerItem = {
  document: GetExitAnnouncementResponseOriginOwnerItemDocument;
  name: string;
};

export type GetExitAnnouncementResponseOriginAddress = {
  city: string;
  state: string;
};

export type GetExitAnnouncementResponseOrigin = {
  address: GetExitAnnouncementResponseOriginAddress;
  bndCode: string;
  id: number;
  name: string;
  owner: GetExitAnnouncementResponseOriginOwnerItem[];
};

export type GetExitAnnouncementResponseDestinyPropertyCode = string | null;

export type GetExitAnnouncementResponseDestiny = {
  address: GetExitAnnouncementResponseDestinyAddress;
  bndCode: string;
  id: number;
  name: string;
  owner: GetExitAnnouncementResponseDestinyOwner;
  propertyCode: GetExitAnnouncementResponseDestinyPropertyCode;
};

export type GetExitAnnouncementResponseDestinyOwnerPhone = string | null;

export type GetExitAnnouncementResponseDestinyOwnerDocument = string | null;

export type GetExitAnnouncementResponseDestinyOwnerDescription = string | null;

export type GetExitAnnouncementResponseDestinyOwnerCode = string | null;

export type GetExitAnnouncementResponseDestinyOwner = {
  code: GetExitAnnouncementResponseDestinyOwnerCode;
  createdAt: string;
  description: GetExitAnnouncementResponseDestinyOwnerDescription;
  document: GetExitAnnouncementResponseDestinyOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetExitAnnouncementResponseDestinyOwnerPhone;
  profiles: EnumsProfile[];
};

export type GetExitAnnouncementResponseDestinyAddress = {
  city: string;
  state: string;
};

export type GetEstablishmentForSaleAnnouncementResponseItemResponsible = {
  name: string;
};

export type GetEstablishmentForSaleAnnouncementResponseItem = {
  id: number;
  name: string;
  responsible: GetEstablishmentForSaleAnnouncementResponseItemResponsible;
};

export type GetEstablishmentForSaleAnnouncementResponse =
  GetEstablishmentForSaleAnnouncementResponseItem[];

export type GetEstablishmentByIdResponseResponsiblePhone = string | null;

export type GetEstablishmentByIdResponseResponsibleDocument = string | null;

export type GetEstablishmentByIdResponseResponsibleDescription = string | null;

export type GetEstablishmentByIdResponseResponsibleCode = string | null;

export type GetEstablishmentByIdResponseResponsible = {
  code: GetEstablishmentByIdResponseResponsibleCode;
  createdAt: string;
  description: GetEstablishmentByIdResponseResponsibleDescription;
  document: GetEstablishmentByIdResponseResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetEstablishmentByIdResponseResponsiblePhone;
  profiles: EnumsProfile[];
};

export type GetEstablishmentByIdResponseCode = string | null;

export type GetEstablishmentByIdResponseCattleManifestLayoutId = number | null;

export interface GetEstablishmentByIdResponse {
  active: boolean;
  address: GetEstablishmentByIdResponseAddress;
  addressId: number;
  cattleManifestLayoutId: GetEstablishmentByIdResponseCattleManifestLayoutId;
  code: GetEstablishmentByIdResponseCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetEstablishmentByIdResponseResponsible;
  responsibleId: number;
}

export type GetEstablishmentByIdResponseAddressStreet = string | null;

export type GetEstablishmentByIdResponseAddressNumber = string | null;

export type GetEstablishmentByIdResponseAddressNeighborhood = string | null;

export type GetEstablishmentByIdResponseAddressComplement = string | null;

export type GetEstablishmentByIdResponseAddress = {
  city: string;
  complement: GetEstablishmentByIdResponseAddressComplement;
  country: string;
  id: number;
  neighborhood: GetEstablishmentByIdResponseAddressNeighborhood;
  number: GetEstablishmentByIdResponseAddressNumber;
  state: string;
  street: GetEstablishmentByIdResponseAddressStreet;
  zip: string;
};

export interface GetEntryAnnouncementResult {
  destiny: GetEntryAnnouncementResultDestiny;
  origins: GetEntryAnnouncementResultOriginsItem[];
  oxen: GetEntryAnnouncementResultOxenItem[];
  purchases: unknown;
}

export type GetEntryAnnouncementResultOxenItemSisbov = string | null;

export type GetEntryAnnouncementResultOxenItemElectronic = string | null;

export type GetEntryAnnouncementResultOxenItem = {
  electronic: GetEntryAnnouncementResultOxenItemElectronic;
  sisbov: GetEntryAnnouncementResultOxenItemSisbov;
};

export type GetEntryAnnouncementResultOriginsItemOwnerDocument = string | null;

export type GetEntryAnnouncementResultOriginsItemOwner = {
  document: GetEntryAnnouncementResultOriginsItemOwnerDocument;
  name: string;
};

export type GetEntryAnnouncementResultOriginsItemAddress = {
  city: string;
  state: string;
};

export type GetEntryAnnouncementResultOriginsItem = {
  address: GetEntryAnnouncementResultOriginsItemAddress;
  bndCode?: GlobalPrismaJsonGovDocuments;
  name: string;
  owner: GetEntryAnnouncementResultOriginsItemOwner;
};

export type GetEntryAnnouncementResultDestinyOwnerItemGov =
  GlobalPrismaJsonGovDocuments | null;

export type GetEntryAnnouncementResultDestinyOwnerItemDocument = string | null;

export type GetEntryAnnouncementResultDestinyOwnerItem = {
  document: GetEntryAnnouncementResultDestinyOwnerItemDocument;
  gov?: GetEntryAnnouncementResultDestinyOwnerItemGov;
  id: number;
  name: string;
};

export type GetEntryAnnouncementResultDestinyAddress = {
  city: string;
  state: string;
};

export type GetEntryAnnouncementResultDestiny = {
  address: GetEntryAnnouncementResultDestinyAddress;
  name: string;
  owner: GetEntryAnnouncementResultDestinyOwnerItem[];
  propertyCode: GlobalPrismaJsonGovDocuments[];
};

export type GetEntryAnnouncementResponseOxenItemSisbov = string | null;

export type GetEntryAnnouncementResponseOxenItemElectronic = string | null;

export type GetEntryAnnouncementResponseOxenItem = {
  electronic: GetEntryAnnouncementResponseOxenItemElectronic;
  sisbov: GetEntryAnnouncementResponseOxenItemSisbov;
};

export interface GetEntryAnnouncementResponse {
  destiny: GetEntryAnnouncementResponseDestiny;
  gtas: GetEntryAnnouncementResponseGtasItem[];
  origins: GetEntryAnnouncementResponseOriginsItem[];
  oxen: GetEntryAnnouncementResponseOxenItem[];
  purchases: unknown;
}

export type GetEntryAnnouncementResponseOriginsItemOwnerDocument =
  | string
  | null;

export type GetEntryAnnouncementResponseOriginsItemOwner = {
  document: GetEntryAnnouncementResponseOriginsItemOwnerDocument;
  name: string;
};

export type GetEntryAnnouncementResponseOriginsItemAddress = {
  city: string;
  state: string;
};

export type GetEntryAnnouncementResponseOriginsItem = {
  address: GetEntryAnnouncementResponseOriginsItemAddress;
  bndCode?: GlobalPrismaJsonGovDocuments;
  name: string;
  owner: GetEntryAnnouncementResponseOriginsItemOwner;
};

export type GetEntryAnnouncementResponseGtasItemWeightingMapId = number | null;

export type GetEntryAnnouncementResponseGtasItemWeightingMap = string | null;

export type GetEntryAnnouncementResponseGtasItemWeightAverage = number | null;

export type GetEntryAnnouncementResponseGtasItemPurchaseId = number | null;

export type GetEntryAnnouncementResponseGtasItemOriginWeightAverage =
  | number
  | null;

export type GetEntryAnnouncementResponseGtasItem = {
  ages: GetEntryAnnouncementResponseGtasItemAgesItem[];
  announcementId: number;
  announcementNumber: string;
  completed: boolean;
  description: GetEntryAnnouncementResponseGtasItemDescription;
  destiny: GetEntryAnnouncementResponseGtasItemDestiny;
  destinyId: GetEntryAnnouncementResponseGtasItemDestinyId;
  distance: GetEntryAnnouncementResponseGtasItemDistance;
  emission: string;
  entry: string;
  entryDate: string;
  expiration: string;
  farm: GetEntryAnnouncementResponseGtasItemFarm;
  farmId: number;
  hours: GetEntryAnnouncementResponseGtasItemHours;
  id: number;
  invoice: GetEntryAnnouncementResponseGtasItemInvoice;
  number: string;
  origin: GetEntryAnnouncementResponseGtasItemOrigin;
  originId: number;
  originWeightAverage: GetEntryAnnouncementResponseGtasItemOriginWeightAverage;
  oxenManagedTotal: number;
  oxenProcessedTotal: number;
  oxenSisbovProcessedTotal: number;
  oxenSisbovTotal: number;
  oxenSystemTotal: number;
  oxenTotal: number;
  purchase?: string;
  purchaseId: GetEntryAnnouncementResponseGtasItemPurchaseId;
  remainingDays: number;
  series: string;
  weightAverage: GetEntryAnnouncementResponseGtasItemWeightAverage;
  weightingMap?: GetEntryAnnouncementResponseGtasItemWeightingMap;
  weightingMapId: GetEntryAnnouncementResponseGtasItemWeightingMapId;
};

export type GetEntryAnnouncementResponseGtasItemOriginResponsibleDocument =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemOriginResponsible = {
  document: GetEntryAnnouncementResponseGtasItemOriginResponsibleDocument;
  name: string;
};

export type GetEntryAnnouncementResponseGtasItemOriginCode = string | null;

export type GetEntryAnnouncementResponseGtasItemOriginCattleManifestLayoutId =
  | number
  | null;

export type GetEntryAnnouncementResponseGtasItemOrigin = {
  active: boolean;
  address: GetEntryAnnouncementResponseGtasItemOriginAddress;
  addressId: number;
  cattleManifestLayoutId: GetEntryAnnouncementResponseGtasItemOriginCattleManifestLayoutId;
  code: GetEntryAnnouncementResponseGtasItemOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetEntryAnnouncementResponseGtasItemOriginResponsible;
  responsibleId: number;
};

export type GetEntryAnnouncementResponseGtasItemOriginAddressStreet =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemOriginAddressNumber =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemOriginAddressNeighborhood =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemOriginAddressComplement =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemOriginAddress = {
  city: string;
  complement: GetEntryAnnouncementResponseGtasItemOriginAddressComplement;
  country: string;
  id: number;
  neighborhood: GetEntryAnnouncementResponseGtasItemOriginAddressNeighborhood;
  number: GetEntryAnnouncementResponseGtasItemOriginAddressNumber;
  state: string;
  street: GetEntryAnnouncementResponseGtasItemOriginAddressStreet;
  zip: string;
};

export type GetEntryAnnouncementResponseGtasItemInvoice = string | null;

export type GetEntryAnnouncementResponseGtasItemHours = number | null;

export type GetEntryAnnouncementResponseGtasItemFarm = {
  day: string;
  name: string;
};

export type GetEntryAnnouncementResponseGtasItemDistance = number | null;

export type GetEntryAnnouncementResponseGtasItemDestinyId = number | null;

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOfCattleManifestLayoutId =
  number | null;

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOf = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: GetEntryAnnouncementResponseGtasItemDestinyAnyOfCattleManifestLayoutId;
  code: GetEntryAnnouncementResponseGtasItemDestinyAnyOfCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsible: GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsible;
  responsibleId: number;
};

export type GetEntryAnnouncementResponseGtasItemDestiny =
  GetEntryAnnouncementResponseGtasItemDestinyAnyOf | null;

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsiblePhone =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsibleDocument =
  string | null;

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsibleDescription =
  string | null;

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsibleCode =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsible = {
  code: GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsibleCode;
  createdAt: string;
  description: GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsibleDescription;
  document: GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsibleDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: GetEntryAnnouncementResponseGtasItemDestinyAnyOfResponsiblePhone;
  profiles: EnumsProfile[];
};

export type GetEntryAnnouncementResponseGtasItemDestinyAnyOfCode =
  | string
  | null;

export type GetEntryAnnouncementResponseGtasItemDescription = string | null;

export type GetEntryAnnouncementResponseGtasItemAgesItemOxenItem = {
  birth: string;
  id: number;
};

export type GetEntryAnnouncementResponseGtasItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  oxen: GetEntryAnnouncementResponseGtasItemAgesItemOxenItem[];
  yearsOld: number;
};

export type GetEntryAnnouncementResponseDestinyOwnerItemGov =
  GlobalPrismaJsonGovDocuments | null;

export type GetEntryAnnouncementResponseDestinyOwnerItemDocument =
  | string
  | null;

export type GetEntryAnnouncementResponseDestinyOwnerItem = {
  document: GetEntryAnnouncementResponseDestinyOwnerItemDocument;
  gov?: GetEntryAnnouncementResponseDestinyOwnerItemGov;
  id: number;
  name: string;
};

export type GetEntryAnnouncementResponseDestinyAddress = {
  city: string;
  state: string;
};

export type GetEntryAnnouncementResponseDestiny = {
  address: GetEntryAnnouncementResponseDestinyAddress;
  name: string;
  owner: GetEntryAnnouncementResponseDestinyOwnerItem[];
  propertyCode: GlobalPrismaJsonGovDocuments[];
};

export type GetEconomicReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GetEconomicReportExcelResponseAnyOfBuffer = string | GlobalBuffer;

export type GetEconomicReportExcelResponseAnyOf = {
  buffer: GetEconomicReportExcelResponseAnyOfBuffer;
};

export type GetEconomicReportExcelResponse =
  | GetEconomicReportExcelResponseAnyOf
  | GetEconomicReportExcelResponseAnyOfThree;

export type GetEarringResponseOrder = string | null;

export interface GetEarringResponse {
  brand: string;
  cancelled: number[];
  finalSisbov: number;
  id: number;
  initialSisbov: number;
  order: GetEarringResponseOrder;
  ownerId: number;
  purchaseId: number;
}

export type GetEarringPurchaseXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetEarringPurchaseXlsxResponse =
  | GetEarringPurchaseXlsxResponseAnyOf
  | GetEarringPurchaseXlsxResponseAnyOfThree;

export type GetEarringPurchaseXlsxResponseAnyOfBuffer = string | GlobalBuffer;

export type GetEarringPurchaseXlsxResponseAnyOf = {
  buffer: GetEarringPurchaseXlsxResponseAnyOfBuffer;
};

export type GetDietResponsePremixId = number | null;

export type GetDietResponseObservation = string | null;

export type GetDietResponseIngredientsItem = {
  dietId: number;
  id: number;
  percentage: number;
  rotorOrder: number;
  stockId: number;
  topplingOrder: number;
};

export type GetDietResponseFixedElg = number | null;

export type GetDietResponseCode = string | null;

export type GetDietResponseCategory = EnumsDietCategory | null;

export interface GetDietResponse {
  active: boolean;
  category: GetDietResponseCategory;
  code: GetDietResponseCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: GetDietResponseFixedElg;
  id: number;
  ingredients: GetDietResponseIngredientsItem[];
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: GetDietResponseObservation;
  premixId: GetDietResponsePremixId;
  used: boolean;
}

export type GetDeathAnnouncementResponseOwnerUserAnyOfGov =
  GlobalPrismaJsonGovDocuments | null;

export type GetDeathAnnouncementResponseOwnerUserAnyOf = {
  gov: GetDeathAnnouncementResponseOwnerUserAnyOfGov;
};

export type GetDeathAnnouncementResponseOwnerUser =
  GetDeathAnnouncementResponseOwnerUserAnyOf | null;

export type GetDeathAnnouncementResponseOwnerDocument = string | null;

export type GetDeathAnnouncementResponseOwner = {
  document: GetDeathAnnouncementResponseOwnerDocument;
  id: number;
  name: string;
  user: GetDeathAnnouncementResponseOwnerUser;
};

export type GetDeathAnnouncementResponseFarm = {
  id: number;
  name: string;
};

export type GetDeathAnnouncementResponseCreatedAt = string | null;

export type GetDeathAnnouncementResponseAddress = {
  city: string;
  state: string;
};

export interface GetDeathAnnouncementResponse {
  address: GetDeathAnnouncementResponseAddress;
  createdAt: GetDeathAnnouncementResponseCreatedAt;
  deaths: DeathAnnouncement[];
  farm: GetDeathAnnouncementResponseFarm;
  owner?: GetDeathAnnouncementResponseOwner;
}

export type GetDailyFoodReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GetDailyFoodReportExcelResponse =
  | GetDailyFoodReportExcelResponseAnyOf
  | GetDailyFoodReportExcelResponseAnyOfThree;

export type GetDailyFoodReportExcelResponseAnyOfBuffer = string | GlobalBuffer;

export type GetDailyFoodReportExcelResponseAnyOf = {
  buffer: GetDailyFoodReportExcelResponseAnyOfBuffer;
};

export type GetCurrentFarmResponseAnyOfSenarPercent = number | null;

export type GetCurrentFarmResponseAnyOf = {
  addressId: number;
  alias: GetCurrentFarmResponseAnyOfAlias;
  blockedDays: number;
  correctionPercent: GetCurrentFarmResponseAnyOfCorrectionPercent;
  createdAt: string;
  customerId: GetCurrentFarmResponseAnyOfCustomerId;
  dailyCost: number;
  day: string;
  divisionThreshold: number;
  factory: GlobalPrismaJsonLatLng[];
  gradeInfo: unknown;
  gradeMethod: EnumsGradeMethod;
  hasAutomation: boolean;
  hasTraceability: boolean;
  id: number;
  installRunId: GetCurrentFarmResponseAnyOfInstallRunId;
  interestRate: number;
  lastBndImport: GetCurrentFarmResponseAnyOfLastBndImport;
  lastCertifierImport: GetCurrentFarmResponseAnyOfLastCertifierImport;
  managementConfig: unknown;
  matinalReadTime: GetCurrentFarmResponseAnyOfMatinalReadTime;
  name: string;
  nightlyReadTimes: string[];
  position: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification: boolean;
  sapId: string;
  senarPercent: GetCurrentFarmResponseAnyOfSenarPercent;
  treatViewType: EnumsTreatViewType;
};

export type GetCurrentFarmResponse = GetCurrentFarmResponseAnyOf | null;

export type GetCurrentFarmResponseAnyOfMatinalReadTime = string | null;

export type GetCurrentFarmResponseAnyOfLastCertifierImport = string | null;

export type GetCurrentFarmResponseAnyOfLastBndImport = string | null;

export type GetCurrentFarmResponseAnyOfInstallRunId = string | null;

export type GetCurrentFarmResponseAnyOfCustomerId = string | null;

export type GetCurrentFarmResponseAnyOfCorrectionPercent = number | null;

export type GetCurrentFarmResponseAnyOfAlias = string | null;

export type GetCorralResponsePosition = number | null;

export type GetCorralResponseBatch = GetCorralResponseBatchAnyOf | null;

export interface GetCorralResponse {
  area: number;
  batch: GetCorralResponseBatch;
  capacity: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: GetCorralResponsePosition;
}

export type GetCorralResponseBatchAnyOfScaledToSlaughter = boolean | null;

export type GetCorralResponseBatchAnyOfOperationalCostGroupId = number | null;

export type GetCorralResponseBatchAnyOfOldCorralId = number | null;

export type GetCorralResponseBatchAnyOfHideFromTreatmentUntil = string | null;

export type GetCorralResponseBatchAnyOfHideFromTreatment = boolean | null;

export type GetCorralResponseBatchAnyOfForeseenSlaughterDate = string | null;

export type GetCorralResponseBatchAnyOfFinalizedAt = string | null;

export type GetCorralResponseBatchAnyOfDescrption = string | null;

export type GetCorralResponseBatchAnyOfCorralId = number | null;

export type GetCorralResponseBatchAnyOfCarcassUniform = number | null;

export type GetCorralResponseBatchAnyOfCarcassThin = number | null;

export type GetCorralResponseBatchAnyOfCarcassMissing = number | null;

export type GetCorralResponseBatchAnyOfCarcassMedium = number | null;

export type GetCorralResponseBatchAnyOfCarcassExcessive = number | null;

export type GetCorralResponseBatchAnyOfAdjustedPurchaseCost = number | null;

export type GetCorralResponseBatchAnyOfActivationEditedAt = string | null;

export type GetCorralResponseBatchAnyOfActivatedAt = string | null;

export type GetCorralResponseBatchAnyOf = {
  activatedAt: GetCorralResponseBatchAnyOfActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: GetCorralResponseBatchAnyOfActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: GetCorralResponseBatchAnyOfAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: GetCorralResponseBatchAnyOfCarcassExcessive;
  carcassMedium: GetCorralResponseBatchAnyOfCarcassMedium;
  carcassMissing: GetCorralResponseBatchAnyOfCarcassMissing;
  carcassThin: GetCorralResponseBatchAnyOfCarcassThin;
  carcassUniform: GetCorralResponseBatchAnyOfCarcassUniform;
  corralId: GetCorralResponseBatchAnyOfCorralId;
  createdAt: string;
  descrption: GetCorralResponseBatchAnyOfDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: GetCorralResponseBatchAnyOfFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: GetCorralResponseBatchAnyOfForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: GetCorralResponseBatchAnyOfHideFromTreatment;
  hideFromTreatmentUntil: GetCorralResponseBatchAnyOfHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: GetCorralResponseBatchAnyOfOldCorralId;
  operationalCostGroupId: GetCorralResponseBatchAnyOfOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: GetCorralResponseBatchAnyOfScaledToSlaughter;
};

export type GetConsolidatedInternalSaleReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetConsolidatedInternalSaleReportXlsxResponse =
  | GetConsolidatedInternalSaleReportXlsxResponseAnyOf
  | GetConsolidatedInternalSaleReportXlsxResponseAnyOfThree;

export type GetConsolidatedInternalSaleReportXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GetConsolidatedInternalSaleReportXlsxResponseAnyOf = {
  buffer: GetConsolidatedInternalSaleReportXlsxResponseAnyOfBuffer;
};

export interface GetConsolidatedInternalSaleReportResponse {
  isCompleted: boolean;
  report: ConsolidatedInternalSaleResponse;
}

export type GetChangeOfCharacteristicAnnouncementResponseOwnerItemDocument =
  | string
  | null;

export type GetChangeOfCharacteristicAnnouncementResponseOwnerItem = {
  document: GetChangeOfCharacteristicAnnouncementResponseOwnerItemDocument;
  name: string;
};

export type GetChangeOfCharacteristicAnnouncementResponseFarm = {
  id: number;
  name: string;
};

export type GetChangeOfCharacteristicAnnouncementResponseChangesItem = {
  age: number;
  birth: string;
  newBreed?: string;
  newGender?: EnumsOxGender;
  oldBreed?: string;
  oldGender?: EnumsOxGender;
  oxId: number;
};

export type GetChangeOfCharacteristicAnnouncementResponseAddress = {
  city: string;
  state: string;
};

export interface GetChangeOfCharacteristicAnnouncementResponse {
  address: GetChangeOfCharacteristicAnnouncementResponseAddress;
  changes: GetChangeOfCharacteristicAnnouncementResponseChangesItem[];
  farm: GetChangeOfCharacteristicAnnouncementResponseFarm;
  id: number;
  owner: GetChangeOfCharacteristicAnnouncementResponseOwnerItem[];
}

export type GetCattleManifestLayoutResponse = CattleManifestLayoutDetail;

export type GetCattleManifestLayoutFinishingMappingResponse =
  | CattleManifestLayoutFinishingMappingItem[]
  | null;

export type GetCattleManifestLayoutFieldMappingResponse =
  GetCattleManifestLayoutFieldMappingResponseAnyOf | null;

export type GetCattleManifestLayoutFieldMappingResponseAnyOfSourceMode =
  CattleManifestSourceModeValue | null;

export type GetCattleManifestLayoutFieldMappingResponseAnyOfHeaderRowsToSkip =
  | number
  | null;

export type GetCattleManifestLayoutFieldMappingResponseAnyOf = {
  headerRowsToSkip: GetCattleManifestLayoutFieldMappingResponseAnyOfHeaderRowsToSkip;
  mappings: CattleManifestLayoutFieldMappingItem[];
  sourceMode: GetCattleManifestLayoutFieldMappingResponseAnyOfSourceMode;
};

export type GetCattleEntryPerCategoryReportResponsePerDistance = {
  females: PerDistanceItem[];
  males: PerDistanceItem[];
};

export type GetCattleEntryPerCategoryReportResponsePerContract = {
  females: PerContractItem[];
  males: PerContractItem[];
};

export type GetCattleEntryPerCategoryReportResponsePerCategory = {
  females: PerCategoryItem[];
  males: PerCategoryItem[];
};

export interface GetCattleEntryPerCategoryReportResponse {
  perCategory: GetCattleEntryPerCategoryReportResponsePerCategory;
  perContract: GetCattleEntryPerCategoryReportResponsePerContract;
  perDistance: GetCattleEntryPerCategoryReportResponsePerDistance;
}

export interface GetCattleEntryPerCategoryReportFilter {
  category?: EnumsOxCategory;
  endDate?: string;
  gender?: EnumsOxGender;
  maximumDistance?: number;
  minimumDistance?: number;
  startDate?: string;
}

export type GetBirthAnnouncementResponseSisbovPurchasesItemOrder =
  | string
  | null;

export type GetBirthAnnouncementResponseSisbovPurchasesItem = {
  finalSisbov: number;
  initialSisbov: number;
  order: GetBirthAnnouncementResponseSisbovPurchasesItemOrder;
};

export interface GetBirthAnnouncementResponse {
  eras?: string;
  farmCity: string;
  farmName: string;
  farmState: string;
  incra?: string;
  is?: string;
  issuedAt: string;
  nirf?: string;
  oxen: BirthAnnouncement[];
  person: GetBirthAnnouncementResponsePerson;
  sisbovPurchases: GetBirthAnnouncementResponseSisbovPurchasesItem[];
}

export type GetBirthAnnouncementResponsePersonGov =
  GlobalPrismaJsonGovDocuments | null;

export type GetBirthAnnouncementResponsePerson = {
  document: string;
  gov?: GetBirthAnnouncementResponsePersonGov;
  name: string;
};

export type GetBatchWeightsResponseProcessingWeightBlockedReason =
  | string
  | null;

export type GetBatchWeightsResponseProcessingWeightAverage = number | null;

export type GetBatchWeightsResponseEntryWeightAverage = number | null;

export interface GetBatchWeightsResponse {
  entryWeightAverage: GetBatchWeightsResponseEntryWeightAverage;
  processingWeightAverage: GetBatchWeightsResponseProcessingWeightAverage;
  processingWeightBlocked: boolean;
  processingWeightBlockedReason: GetBatchWeightsResponseProcessingWeightBlockedReason;
}

export type GetBatchTransferResponseItem = {
  date: string;
  entries: number;
  exits: number;
  total: number;
};

export type GetBatchTransferResponse = GetBatchTransferResponseItem[];

export type GetBatchResponseScaledToSlaughter = boolean | null;

export type GetBatchResponseOperationalCostGroupId = number | null;

export type GetBatchResponseOldCorralId = number | null;

export type GetBatchResponseHideFromTreatmentUntil = string | null;

export type GetBatchResponseHideFromTreatment = boolean | null;

export type GetBatchResponseForeseenSlaughterDate = string | null;

export type GetBatchResponseFinalizedAt = string | null;

export type GetBatchResponseDescrption = string | null;

export type GetBatchResponseCorralId = number | null;

export type GetBatchResponseCarcassUniform = number | null;

export type GetBatchResponseCarcassThin = number | null;

export type GetBatchResponseCarcassMissing = number | null;

export type GetBatchResponseCarcassMedium = number | null;

export type GetBatchResponseCarcassExcessive = number | null;

export type GetBatchResponseAdjustedPurchaseCost = number | null;

export type GetBatchResponseActivationEditedAt = string | null;

export type GetBatchResponseActivatedAt = string | null;

export interface GetBatchResponse {
  activatedAt: GetBatchResponseActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: GetBatchResponseActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: GetBatchResponseAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: GetBatchResponseCarcassExcessive;
  carcassMedium: GetBatchResponseCarcassMedium;
  carcassMissing: GetBatchResponseCarcassMissing;
  carcassThin: GetBatchResponseCarcassThin;
  carcassUniform: GetBatchResponseCarcassUniform;
  corralId: GetBatchResponseCorralId;
  createdAt: string;
  descrption: GetBatchResponseDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: GetBatchResponseFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: GetBatchResponseForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: GetBatchResponseHideFromTreatment;
  hideFromTreatmentUntil: GetBatchResponseHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: GetBatchResponseOldCorralId;
  operationalCostGroupId: GetBatchResponseOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: GetBatchResponseScaledToSlaughter;
}

export interface GetBatchLogsResponse {
  batchId: number;
  batchName: string;
  logs: GetBatchLogsResponseLogsItem[];
}

export type GetBatchLogsResponseLogsItemMacAddress = string | null;

export type GetBatchLogsResponseLogsItemCreatedAt = string | null;

export type GetBatchLogsResponseLogsItemComputerName = string | null;

export type GetBatchLogsResponseLogsItem = {
  batchId: number;
  computerName: GetBatchLogsResponseLogsItemComputerName;
  createdAt: GetBatchLogsResponseLogsItemCreatedAt;
  current: unknown;
  id: number;
  macAddress: GetBatchLogsResponseLogsItemMacAddress;
  userAuthenticatedName: string;
  userId: string;
};

export type GetBatchLifecycleResponseBatchFinalizedAt = string | null;

export type GetBatchLifecycleResponseBatchActivatedAt = string | null;

export type GetBatchLifecycleResponseBatch = {
  activatedAt: GetBatchLifecycleResponseBatchActivatedAt;
  createdAt: string;
  finalizedAt: GetBatchLifecycleResponseBatchFinalizedAt;
  id: number;
  name: string;
};

export interface GetBatchLifecycleResponse {
  batch: GetBatchLifecycleResponseBatch;
  events: BatchLifecycleEvent[];
  farmCreatedAt: string;
  farmDay: string;
}

export interface GetBakingEfficiencyReportResponse {
  day: string;
  isCompleted: boolean;
  report: BakingEfficiencyReportDataResponseItem[];
}

export type GetAnnouncementsNotificationsResponse =
  GetAnnouncementsNotificationsResponseItem[];

export type GetAnnouncementsNotificationsResponseItemExpiresAt = string | null;

export type GetAnnouncementsNotificationsResponseItemEmittedAt = string | null;

export type GetAnnouncementsNotificationsResponseItemCreatedAt = string | null;

export type GetAnnouncementsNotificationsResponseItem = {
  createdAt: GetAnnouncementsNotificationsResponseItemCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: GetAnnouncementsNotificationsResponseItemEmittedAt;
  expiresAt: GetAnnouncementsNotificationsResponseItemExpiresAt;
  farmId: number;
  type: EnumsAnnouncementType;
};

export type GetAnalyticalReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GetAnalyticalReportExcelResponse =
  | GetAnalyticalReportExcelResponseAnyOf
  | GetAnalyticalReportExcelResponseAnyOfThree;

export type GetAnalyticalReportExcelResponseAnyOfBuffer = string | GlobalBuffer;

export type GetAnalyticalReportExcelResponseAnyOf = {
  buffer: GetAnalyticalReportExcelResponseAnyOfBuffer;
};

export type GetAnalyticalBatchDaysDetailsXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GetAnalyticalBatchDaysDetailsXlsxResponse =
  | GetAnalyticalBatchDaysDetailsXlsxResponseAnyOf
  | GetAnalyticalBatchDaysDetailsXlsxResponseAnyOfThree;

export type GetAnalyticalBatchDaysDetailsXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GetAnalyticalBatchDaysDetailsXlsxResponseAnyOf = {
  buffer: GetAnalyticalBatchDaysDetailsXlsxResponseAnyOfBuffer;
};

export type GetAddressResponseStreet = string | null;

export type GetAddressResponseNumber = string | null;

export type GetAddressResponseNeighborhood = string | null;

export type GetAddressResponseComplement = string | null;

export interface GetAddressResponse {
  city: string;
  complement: GetAddressResponseComplement;
  country: string;
  id: number;
  neighborhood: GetAddressResponseNeighborhood;
  number: GetAddressResponseNumber;
  state: string;
  street: GetAddressResponseStreet;
  zip: string;
}

export type GenerateUnusabilityResponseUnusabilitiesItem = {
  brand: string;
  observation?: string;
  sisbov: number;
};

export type GenerateUnusabilityResponseOriginOwnerItemDocument = string | null;

export type GenerateUnusabilityResponseOriginOwnerItem = {
  document: GenerateUnusabilityResponseOriginOwnerItemDocument;
  name: string;
};

export type GenerateUnusabilityResponseOriginAddress = {
  city: string;
  state: string;
};

export type GenerateUnusabilityResponseOrigin = {
  address: GenerateUnusabilityResponseOriginAddress;
  id: number;
  name: string;
  owner: GenerateUnusabilityResponseOriginOwnerItem[];
  propertyCode: string[];
};

export interface GenerateUnusabilityResponse {
  origin: GenerateUnusabilityResponseOrigin;
  unusabilities: GenerateUnusabilityResponseUnusabilitiesItem[];
}

export type GenerateTreatEfficiencyReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateTreatEfficiencyReportExcelResponse =
  | GenerateTreatEfficiencyReportExcelResponseAnyOf
  | GenerateTreatEfficiencyReportExcelResponseAnyOfThree;

export type GenerateTreatEfficiencyReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateTreatEfficiencyReportExcelResponseAnyOf = {
  buffer: GenerateTreatEfficiencyReportExcelResponseAnyOfBuffer;
};

export type GenerateSlaughterScaleReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateSlaughterScaleReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateSlaughterScaleReportExcelResponseAnyOf = {
  buffer: GenerateSlaughterScaleReportExcelResponseAnyOfBuffer;
};

export type GenerateSlaughterScaleReportExcelResponse =
  | GenerateSlaughterScaleReportExcelResponseAnyOf
  | GenerateSlaughterScaleReportExcelResponseAnyOfThree;

/**
 * The return type of the controller method.
 */
export type GenerateSalesReportResponse = unknown;

export interface GenerateReIdentificationAnnouncementResponse {
  announcements: GenerateReIdentificationAnnouncementResponseAnnouncementsItem[];
}

export type GenerateReIdentificationAnnouncementResponseAnnouncementsItemReIdentificationsItem =
  {
    age: number;
    birth: string;
    createdAt?: string;
    earringBrand?: string;
    newSisbov: number;
    oldSisbov: number;
    oxId: number;
  };

export type GenerateReIdentificationAnnouncementResponseAnnouncementsItemOwnerItemDocument =
  string | null;

export type GenerateReIdentificationAnnouncementResponseAnnouncementsItemOwnerItem =
  {
    document: GenerateReIdentificationAnnouncementResponseAnnouncementsItemOwnerItemDocument;
    name: string;
  };

export type GenerateReIdentificationAnnouncementResponseAnnouncementsItemFarm =
  {
    id: number;
    name: string;
  };

export type GenerateReIdentificationAnnouncementResponseAnnouncementsItemAddress =
  {
    city: string;
    state: string;
  };

export type GenerateReIdentificationAnnouncementResponseAnnouncementsItem = {
  address: GenerateReIdentificationAnnouncementResponseAnnouncementsItemAddress;
  farm: GenerateReIdentificationAnnouncementResponseAnnouncementsItemFarm;
  id: number;
  owner: GenerateReIdentificationAnnouncementResponseAnnouncementsItemOwnerItem[];
  reIdentifications: GenerateReIdentificationAnnouncementResponseAnnouncementsItemReIdentificationsItem[];
};

export interface GenerateReIdentificationAnnouncementBody {
  announcementIds: number[];
  date: string;
}

export type GeneratePartnerSlaughterReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GeneratePartnerSlaughterReportXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GeneratePartnerSlaughterReportXlsxResponseAnyOf = {
  buffer: GeneratePartnerSlaughterReportXlsxResponseAnyOfBuffer;
};

export type GeneratePartnerSlaughterReportXlsxResponse =
  | GeneratePartnerSlaughterReportXlsxResponseAnyOf
  | GeneratePartnerSlaughterReportXlsxResponseAnyOfThree;

export type GenerateOxenEntranceReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GenerateOxenEntranceReportXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateOxenEntranceReportXlsxResponseAnyOf = {
  buffer: GenerateOxenEntranceReportXlsxResponseAnyOfBuffer;
};

export type GenerateOxenEntranceReportXlsxResponse =
  | GenerateOxenEntranceReportXlsxResponseAnyOf
  | GenerateOxenEntranceReportXlsxResponseAnyOfThree;

export type GenerateMovementHistoryReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateMovementHistoryReportExcelResponse =
  | GenerateMovementHistoryReportExcelResponseAnyOf
  | GenerateMovementHistoryReportExcelResponseAnyOfThree;

export type GenerateMovementHistoryReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateMovementHistoryReportExcelResponseAnyOf = {
  buffer: GenerateMovementHistoryReportExcelResponseAnyOfBuffer;
};

export type GenerateInternalSalesRealizedExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateInternalSalesRealizedExcelResponse =
  | GenerateInternalSalesRealizedExcelResponseAnyOf
  | GenerateInternalSalesRealizedExcelResponseAnyOfThree;

export type GenerateInternalSalesRealizedExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateInternalSalesRealizedExcelResponseAnyOf = {
  buffer: GenerateInternalSalesRealizedExcelResponseAnyOfBuffer;
};

export type GenerateForeseenGtaDataExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateForeseenGtaDataExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateForeseenGtaDataExcelResponseAnyOf = {
  buffer: GenerateForeseenGtaDataExcelResponseAnyOfBuffer;
};

export type GenerateForeseenGtaDataExcelResponse =
  | GenerateForeseenGtaDataExcelResponseAnyOf
  | GenerateForeseenGtaDataExcelResponseAnyOfThree;

export type GenerateForecastReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateForecastReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateForecastReportExcelResponseAnyOf = {
  buffer: GenerateForecastReportExcelResponseAnyOfBuffer;
};

export type GenerateForecastReportExcelResponse =
  | GenerateForecastReportExcelResponseAnyOf
  | GenerateForecastReportExcelResponseAnyOfThree;

export type GenerateFinancialBatchesReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateFinancialBatchesReportExcelResponse =
  | GenerateFinancialBatchesReportExcelResponseAnyOf
  | GenerateFinancialBatchesReportExcelResponseAnyOfThree;

export type GenerateFinancialBatchesReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateFinancialBatchesReportExcelResponseAnyOf = {
  buffer: GenerateFinancialBatchesReportExcelResponseAnyOfBuffer;
};

export type GenerateEntryAnnouncementExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateEntryAnnouncementExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateEntryAnnouncementExcelResponseAnyOf = {
  buffer: GenerateEntryAnnouncementExcelResponseAnyOfBuffer;
};

export type GenerateEntryAnnouncementExcelResponse =
  | GenerateEntryAnnouncementExcelResponseAnyOf
  | GenerateEntryAnnouncementExcelResponseAnyOfThree;

export type GenerateDeathAnnouncementResponse =
  GenerateDeathAnnouncementResponseItem[];

export type GenerateDeathAnnouncementResponseItemOwnerDocument = string | null;

export type GenerateDeathAnnouncementResponseItemOwner = {
  document: GenerateDeathAnnouncementResponseItemOwnerDocument;
  id: number;
  name: string;
};

export type GenerateDeathAnnouncementResponseItemFarm = {
  id: number;
  name: string;
};

export type GenerateDeathAnnouncementResponseItemAddress = {
  city: string;
  state: string;
};

export type GenerateDeathAnnouncementResponseItem = {
  address: GenerateDeathAnnouncementResponseItemAddress;
  deaths: DeathAnnouncement[];
  farm: GenerateDeathAnnouncementResponseItemFarm;
  owner?: GenerateDeathAnnouncementResponseItemOwner;
};

export type GenerateComissionReportXlsxResponseAnyOfThree = {
  buffer: null;
};

export type GenerateComissionReportXlsxResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateComissionReportXlsxResponseAnyOf = {
  buffer: GenerateComissionReportXlsxResponseAnyOfBuffer;
};

export type GenerateComissionReportXlsxResponse =
  | GenerateComissionReportXlsxResponseAnyOf
  | GenerateComissionReportXlsxResponseAnyOfThree;

export type GenerateChangeOfCharacteristicsResponseOwnerItemDocument =
  | string
  | null;

export type GenerateChangeOfCharacteristicsResponseOwnerItem = {
  document: GenerateChangeOfCharacteristicsResponseOwnerItemDocument;
  name: string;
};

export type GenerateChangeOfCharacteristicsResponseFarm = {
  id: number;
  name: string;
};

export type GenerateChangeOfCharacteristicsResponseChangesItem = {
  age: number;
  birth: string;
  newBreed?: string;
  newGender?: EnumsOxGender;
  oldBreed?: string;
  oldGender?: EnumsOxGender;
  oxId: number;
};

export type GenerateChangeOfCharacteristicsResponseAddress = {
  city: string;
  state: string;
};

export interface GenerateChangeOfCharacteristicsResponse {
  address: GenerateChangeOfCharacteristicsResponseAddress;
  changes: GenerateChangeOfCharacteristicsResponseChangesItem[];
  farm: GenerateChangeOfCharacteristicsResponseFarm;
  id: number;
  owner: GenerateChangeOfCharacteristicsResponseOwnerItem[];
}

export type GenerateCattleEntryPerCategoryReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateCattleEntryPerCategoryReportExcelResponse =
  | GenerateCattleEntryPerCategoryReportExcelResponseAnyOf
  | GenerateCattleEntryPerCategoryReportExcelResponseAnyOfThree;

export type GenerateCattleEntryPerCategoryReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateCattleEntryPerCategoryReportExcelResponseAnyOf = {
  buffer: GenerateCattleEntryPerCategoryReportExcelResponseAnyOfBuffer;
};

export type GenerateBakingEfficiencyReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateBakingEfficiencyReportExcelResponse =
  | GenerateBakingEfficiencyReportExcelResponseAnyOf
  | GenerateBakingEfficiencyReportExcelResponseAnyOfThree;

export type GenerateBakingEfficiencyReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateBakingEfficiencyReportExcelResponseAnyOf = {
  buffer: GenerateBakingEfficiencyReportExcelResponseAnyOfBuffer;
};

export type GenerateActiveBatchesReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type GenerateActiveBatchesReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type GenerateActiveBatchesReportExcelResponseAnyOf = {
  buffer: GenerateActiveBatchesReportExcelResponseAnyOfBuffer;
};

export type GenerateActiveBatchesReportExcelResponse =
  | GenerateActiveBatchesReportExcelResponseAnyOf
  | GenerateActiveBatchesReportExcelResponseAnyOfThree;

export type GeneralLogMetadataChangesItemOldValue = string | null;

export type GeneralLogMetadataChangesItemNewValue = string | null;

export type GeneralLogMetadataChangesItem = {
  fieldLabel: string;
  fieldName: string;
  formattedNew: string;
  formattedOld: string;
  newValue: GeneralLogMetadataChangesItemNewValue;
  oldValue: GeneralLogMetadataChangesItemOldValue;
};

export interface GeneralLogMetadata {
  changes?: GeneralLogMetadataChangesItem[];
}

export type GeneralLogItemMetadata = GeneralLogMetadata | null;

export type GeneralLogItemEntityId = number | null;

export interface GeneralLogItem {
  category: EnumsGeneralLogCategory;
  createdAt: string;
  description: string;
  entityId: GeneralLogItemEntityId;
  id: number;
  logType: string;
  metadata: GeneralLogItemMetadata;
  userId: number;
  userName: string;
}

export type GeneralLogCategory = EnumsGeneralLogCategory;

export type GeneralInfoIdentifiedAt = string | null;

export interface GeneralInfo {
  arrivalAverageWeight: number;
  atProducedWeight: number;
  buyer: string;
  confinedDaysAverage: number;
  fridgeLocation: string;
  fridgePaidAt?: string;
  identificationWeight: number;
  identifiedAt: GeneralInfoIdentifiedAt;
  liveStockFarmerPaidAt?: string;
  oxenAmount: number;
  priceOnSaleDate: number;
  purchaseWeight: number;
  slaughterDate: string;
}

export type ForseenGtaDataExcelRequestDataItem = {
  atSalePrice: number;
  averageEntryDate: string;
  averageEntryWeight: number;
  averageGmd: number;
  averageProcessingWeight: number;
  averageProjectedWeight: number;
  daysSinceEmission: number;
  femaleTotal: number;
  gtaEmissionDate: string;
  gtaNumber: string;
  maleTotal: number;
  owners: string;
  purchase: string;
  totalProjectedWeight: number;
  totalSalePrice: number;
};

export interface ForseenGtaDataExcelRequest {
  data: ForseenGtaDataExcelRequestDataItem[];
  filename: string;
}

export type ForeseenGtaDataResponse = ListGtasWithForeseenResponse[];

export type ForecastStateResponseError = string | null;

export interface ForecastStateResponse {
  error: ForecastStateResponseError;
  jobId: string;
  progress: ReportJobProgress;
  result: ForecastStateResponseResult;
  status: ReportJobStatus;
}

export interface ForecastResult {
  day: string;
  rows: ForecastGetReportDataResponse[];
}

export type ForecastStateResponseResult = ForecastResult | null;

/**
 * Velocidade do vento (km/h) — não disponível no sistema, retorna null
 */
export type ForecastGetReportDataResponseWindSpeed = number | null;

/**
 * Custo do frete (R$/cab)
 */
export type ForecastGetReportDataResponseShippingCostPerHead = number | null;

/**
 * Custo de processamento (R$/cab) — não disponível no sistema, retorna null
 */
export type ForecastGetReportDataResponseProcessingCostPerHead = number | null;

/**
 * Raça predominante dos animais ativos
 */
export type ForecastGetReportDataResponsePredominantBreed = string | null;

export type ForecastGetReportDataResponsePosition = number | null;

/**
 * Data inicial do período
 */
export type ForecastGetReportDataResponsePeriodStartDate = string | null;

/**
 * Outros custos (R$/cab)
 */
export type ForecastGetReportDataResponseOtherCostsPerHead = number | null;

/**
 * Custo operacional (R$/cab/dia)
 */
export type ForecastGetReportDataResponseOperationalCostPerHeadDay =
  | number
  | null;

/**
 * Presença de lama — não disponível no sistema, retorna null
 */
export type ForecastGetReportDataResponseMudPresence = string | null;

/**
 * Peso médio inicial (kg)
 */
export type ForecastGetReportDataResponseInitialWeightKg = number | null;

/**
 * Peso médio inicial (@)
 */
export type ForecastGetReportDataResponseInitialWeightAtSign = number | null;

/**
 * Custo inicial (R$/@)
 */
export type ForecastGetReportDataResponseInitialCostPerArroba = number | null;

/**
 * Item de consumo (ingrediente) em kg de matéria seca no período.
 */
export type ForecastGetReportDataResponseFoodsItem = {
  dryMatter: number;
  name: string;
};

/**
 * Data da entrada média dos animais
 */
export type ForecastGetReportDataResponseEntryDate = string | null;

/**
 * Temperatura média (°C) — não disponível no sistema, retorna null
 */
export type ForecastGetReportDataResponseAverageTemperature = number | null;

export interface ForecastGetReportDataResponse {
  /** Temperatura média (°C) — não disponível no sistema, retorna null */
  averageTemperature: ForecastGetReportDataResponseAverageTemperature;
  /** Baia/Pen */
  corral?: string;
  /** Mortes no período */
  deathCount: number;
  /** Data da entrada média dos animais */
  entryDate: ForecastGetReportDataResponseEntryDate;
  /** Consumo por ingrediente (kg MS) no período */
  foods: ForecastGetReportDataResponseFoodsItem[];
  /** Sexo dos animais ativos */
  gender: EnumsOxGender[];
  id: number;
  /** Custo inicial (R$/@) */
  initialCostPerArroba: ForecastGetReportDataResponseInitialCostPerArroba;
  /** Peso médio inicial (@) */
  initialWeightAtSign: ForecastGetReportDataResponseInitialWeightAtSign;
  /** Peso médio inicial (kg) */
  initialWeightKg: ForecastGetReportDataResponseInitialWeightKg;
  /** Presença de lama — não disponível no sistema, retorna null */
  mudPresence: ForecastGetReportDataResponseMudPresence;
  /** Nome do lote */
  name: string;
  /** Custo operacional (R$/cab/dia) */
  operationalCostPerHeadDay: ForecastGetReportDataResponseOperationalCostPerHeadDay;
  /** Outros custos (R$/cab) */
  otherCostsPerHead: ForecastGetReportDataResponseOtherCostsPerHead;
  /** Nº de cabeças ativas */
  oxenAmount: number;
  /** Número do período de 7 dias com animais no lote (1 = primeira semana com cabeças) */
  period: number;
  /** Data final do período (início + 6 dias, cortada no dia da fazenda) */
  periodEndDate: string;
  /** Data inicial do período */
  periodStartDate: ForecastGetReportDataResponsePeriodStartDate;
  position: ForecastGetReportDataResponsePosition;
  /** Raça predominante dos animais ativos */
  predominantBreed: ForecastGetReportDataResponsePredominantBreed;
  /** Custo de processamento (R$/cab) — não disponível no sistema, retorna null */
  processingCostPerHead: ForecastGetReportDataResponseProcessingCostPerHead;
  /** Custo do frete (R$/cab) */
  shippingCostPerHead: ForecastGetReportDataResponseShippingCostPerHead;
  /** Velocidade do vento (km/h) — não disponível no sistema, retorna null */
  windSpeed: ForecastGetReportDataResponseWindSpeed;
}

export type ForecastGenerateExcelRequestAppVersion = string | null;

export interface ForecastGenerateExcelRequest {
  appVersion?: ForecastGenerateExcelRequestAppVersion;
  filename: string;
  report: ForecastGetReportDataResponse[];
}

export interface FoodHistoryFilter {
  end?: string;
  start: string;
  stockId: number;
}

export type FoodEnergyHistoryStatus =
  (typeof FoodEnergyHistoryStatus)[keyof typeof FoodEnergyHistoryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FoodEnergyHistoryStatus = {
  Alterado: "Alterado",
  Atual: "Atual",
  Sem_alteração: "Sem alteração",
} as const;

export type FoodEnergyHistoryReportResponse = FoodEnergyHistoryReportItem[];

export interface FoodEnergyHistoryReportQuery {
  end: string;
  start: string;
  stockId?: number;
}

export type FoodEnergyHistoryReportItemElgVariation = number | null;

export interface FoodEnergyHistoryReportItem {
  effectiveDays: number;
  elg: number;
  elgVariation: FoodEnergyHistoryReportItemElgVariation;
  elm: number;
  endsAt: string;
  food: string;
  startsAt: string;
  status: FoodEnergyHistoryStatus;
  stockId: number;
}

export interface FindSapIdResponse {
  day: string;
  name: string;
  position: GlobalPrismaJsonLatLng;
}

export interface FindSapId {
  sapId: string;
  schema: string;
}

export type FindOxenBySisbovsResponseFoundItem = {
  oxId: number;
  sisbov: string;
};

export interface FindOxenBySisbovsResponse {
  found: FindOxenBySisbovsResponseFoundItem[];
  notFound: string[];
}

export type FindOxResponseWeightsItemType = EnumsWeightType | null;

export type FindOxResponseWeightsItem = {
  date: string;
  id: number;
  oxId: number;
  source: EnumsWeightSource;
  type: FindOxResponseWeightsItemType;
  weight: number;
};

export type FindOxResponseStartOfTreatment = string | null;

export type FindOxResponseSisbov = string | null;

export type FindOxResponseSalesMarketType = EnumsSalesMarketType | null;

export type FindOxResponseReversedDeathNecropsy = EnumsDeathNecropsy | null;

export type FindOxResponseReversedDeathDetails = string | null;

export type FindOxResponseReversedDeathDate = string | null;

export type FindOxResponseReversedDeathCause = EnumsDeathCause | null;

export type FindOxResponsePurchaseId = number | null;

export type FindOxResponsePriceAtSignExit = number | null;

export type FindOxResponsePriceAtSignEntry = number | null;

export interface FindOxResponse {
  batch?: FindOxResponseBatch;
  batches: FindOxResponseBatchesItem[];
  birth: string;
  blockedUntil: string;
  bndTracked: FindOxResponseBndTracked;
  bornOnFarm: FindOxResponseBornOnFarm;
  breed: string;
  carcass: FindOxResponseCarcass;
  carcassPrice: FindOxResponseCarcassPrice;
  carcassType: FindOxResponseCarcassType;
  carcassWeight: FindOxResponseCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: FindOxResponseCattleManifestId;
  certifierDate: FindOxResponseCertifierDate;
  comments: FindOxResponseComments;
  corral?: FindOxResponseCorral;
  currentWeight: number;
  deathCause: FindOxResponseDeathCause;
  deathDetails: FindOxResponseDeathDetails;
  deathNecropsy: FindOxResponseDeathNecropsy;
  deathReason: FindOxResponseDeathReason;
  dentitionStage: FindOxResponseDentitionStage;
  diedAt: FindOxResponseDiedAt;
  electronic: FindOxResponseElectronic;
  entryWeight: number;
  exitTruckId: FindOxResponseExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gmdEstimated: number;
  gmdReal: number;
  gmdRealLastWeight: number;
  gpd: number;
  gta: FindOxResponseGta;
  gtaId: FindOxResponseGtaId;
  hasBirthAnnouncement: FindOxResponseHasBirthAnnouncement;
  hiltonQuota?: boolean;
  id: number;
  identificationDate: FindOxResponseIdentificationDate;
  identificationSource: FindOxResponseIdentificationSource;
  identifiedAt: FindOxResponseIdentifiedAt;
  identifier: FindOxResponseIdentifier;
  includedAt: string;
  intermediateWeights: FindOxResponseIntermediateWeightsItem[];
  internalSaleId: FindOxResponseInternalSaleId;
  invoice: FindOxResponseInvoice;
  isNecropsyPerformed: FindOxResponseIsNecropsyPerformed;
  otherDeathCause: FindOxResponseOtherDeathCause;
  owner: FindOxResponseOwner;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: FindOxResponsePriceAtSignEntry;
  priceAtSignExit: FindOxResponsePriceAtSignExit;
  purchaseId: FindOxResponsePurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: FindOxResponseReversedDeathCause;
  reversedDeathDate: FindOxResponseReversedDeathDate;
  reversedDeathDetails: FindOxResponseReversedDeathDetails;
  reversedDeathNecropsy: FindOxResponseReversedDeathNecropsy;
  runtime: number;
  salesMarketType: FindOxResponseSalesMarketType;
  sisbov: FindOxResponseSisbov;
  sisbovHistory: string[];
  startOfTreatment: FindOxResponseStartOfTreatment;
  variety: string;
  weights: FindOxResponseWeightsItem[];
  withdrawals: GetOxWithdrawalsResponse[];
}

export type FindOxResponseOwnerPhone = string | null;

export type FindOxResponseOwnerDocument = string | null;

export type FindOxResponseOwnerDescription = string | null;

export type FindOxResponseOwnerCode = string | null;

export type FindOxResponseOwner = {
  code: FindOxResponseOwnerCode;
  createdAt: string;
  description: FindOxResponseOwnerDescription;
  document: FindOxResponseOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: FindOxResponseOwnerPhone;
  profiles: EnumsProfile[];
};

export type FindOxResponseOtherDeathCause = string | null;

export type FindOxResponseIsNecropsyPerformed = boolean | null;

export type FindOxResponseInvoice = string | null;

export type FindOxResponseInternalSaleId = number | null;

export type FindOxResponseIntermediateWeightsItem = {
  date: string;
  weight: number;
};

export type FindOxResponseIdentifier = string | null;

export type FindOxResponseIdentifiedAt = string | null;

export type FindOxResponseIdentificationSource =
  EnumsIdentificationSource | null;

export type FindOxResponseIdentificationDate = string | null;

export type FindOxResponseHasBirthAnnouncement = boolean | null;

export type FindOxResponseGtaId = number | null;

export type FindOxResponseGta = FindOxResponseGtaAnyOf | null;

export type FindOxResponseGtaAnyOfWeightingMapId = number | null;

export type FindOxResponseGtaAnyOfWeightAverage = number | null;

export type FindOxResponseGtaAnyOfPurchaseId = number | null;

export type FindOxResponseGtaAnyOfPurchase =
  FindOxResponseGtaAnyOfPurchaseAnyOf | null;

export type FindOxResponseGtaAnyOf = {
  completed: boolean;
  description: FindOxResponseGtaAnyOfDescription;
  destinyId: FindOxResponseGtaAnyOfDestinyId;
  distance: FindOxResponseGtaAnyOfDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: FindOxResponseGtaAnyOfHours;
  id: number;
  invoice: FindOxResponseGtaAnyOfInvoice;
  number: string;
  origin: FindOxResponseGtaAnyOfOrigin;
  originId: number;
  originWeightAverage: FindOxResponseGtaAnyOfOriginWeightAverage;
  purchase: FindOxResponseGtaAnyOfPurchase;
  purchaseId: FindOxResponseGtaAnyOfPurchaseId;
  series: string;
  weightAverage: FindOxResponseGtaAnyOfWeightAverage;
  weightingMapId: FindOxResponseGtaAnyOfWeightingMapId;
};

export type FindOxResponseGtaAnyOfPurchaseAnyOfWeighingAt = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfPurchase = {
  name: string;
};

export type FindOxResponseGtaAnyOfPurchaseAnyOfPartnerId = number | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfOxenAmount = number | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfOwnerPhone = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfOwnerDocument = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfOwnerDescription = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfOwnerCode = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfOwner = {
  code: FindOxResponseGtaAnyOfPurchaseAnyOfOwnerCode;
  createdAt: string;
  description: FindOxResponseGtaAnyOfPurchaseAnyOfOwnerDescription;
  document: FindOxResponseGtaAnyOfPurchaseAnyOfOwnerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: FindOxResponseGtaAnyOfPurchaseAnyOfOwnerPhone;
  profiles: EnumsProfile[];
};

export type FindOxResponseGtaAnyOfPurchaseAnyOfMapa = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfMaleProducedPrice =
  | number
  | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfMaleFutureAnimalPrice =
  | number
  | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfMaleEntryCarcassYield =
  | number
  | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfMaleDailyPrice = number | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfFemaleProducedPrice =
  | number
  | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfFemaleFutureAnimalPrice =
  | number
  | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfFemaleEntryCarcassYield =
  | number
  | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfFemaleDailyPrice = number | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfDiscountPercent = number | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOf = {
  buyer: FindOxResponseGtaAnyOfPurchaseAnyOfBuyer;
  buyerId: number;
  commission: number;
  discountPercent: FindOxResponseGtaAnyOfPurchaseAnyOfDiscountPercent;
  femaleDailyPrice: FindOxResponseGtaAnyOfPurchaseAnyOfFemaleDailyPrice;
  femaleEntryCarcassYield: FindOxResponseGtaAnyOfPurchaseAnyOfFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: FindOxResponseGtaAnyOfPurchaseAnyOfFemaleFutureAnimalPrice;
  femaleProducedPrice: FindOxResponseGtaAnyOfPurchaseAnyOfFemaleProducedPrice;
  id: number;
  maleDailyPrice: FindOxResponseGtaAnyOfPurchaseAnyOfMaleDailyPrice;
  maleEntryCarcassYield: FindOxResponseGtaAnyOfPurchaseAnyOfMaleEntryCarcassYield;
  maleFutureAnimalPrice: FindOxResponseGtaAnyOfPurchaseAnyOfMaleFutureAnimalPrice;
  maleProducedPrice: FindOxResponseGtaAnyOfPurchaseAnyOfMaleProducedPrice;
  mapa: FindOxResponseGtaAnyOfPurchaseAnyOfMapa;
  owner: FindOxResponseGtaAnyOfPurchaseAnyOfOwner;
  ownerId: number;
  oxenAmount: FindOxResponseGtaAnyOfPurchaseAnyOfOxenAmount;
  partnerId: FindOxResponseGtaAnyOfPurchaseAnyOfPartnerId;
  purchase: FindOxResponseGtaAnyOfPurchaseAnyOfPurchase;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: FindOxResponseGtaAnyOfPurchaseAnyOfWeighingAt;
  weightAverage: number;
};

export type FindOxResponseGtaAnyOfPurchaseAnyOfBuyerPhone = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfBuyerDocument = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfBuyerDescription = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfBuyerCode = string | null;

export type FindOxResponseGtaAnyOfPurchaseAnyOfBuyer = {
  code: FindOxResponseGtaAnyOfPurchaseAnyOfBuyerCode;
  createdAt: string;
  description: FindOxResponseGtaAnyOfPurchaseAnyOfBuyerDescription;
  document: FindOxResponseGtaAnyOfPurchaseAnyOfBuyerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: FindOxResponseGtaAnyOfPurchaseAnyOfBuyerPhone;
  profiles: EnumsProfile[];
};

export type FindOxResponseGtaAnyOfOriginWeightAverage = number | null;

export type FindOxResponseGtaAnyOfOriginCode = string | null;

export type FindOxResponseGtaAnyOfOriginCattleManifestLayoutId = number | null;

export type FindOxResponseGtaAnyOfOrigin = {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: FindOxResponseGtaAnyOfOriginCattleManifestLayoutId;
  code: FindOxResponseGtaAnyOfOriginCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsibleId: number;
};

export type FindOxResponseGtaAnyOfInvoice = string | null;

export type FindOxResponseGtaAnyOfHours = number | null;

export type FindOxResponseGtaAnyOfDistance = number | null;

export type FindOxResponseGtaAnyOfDestinyId = number | null;

export type FindOxResponseGtaAnyOfDescription = string | null;

export type FindOxResponseExitTruckId = number | null;

export type FindOxResponseElectronic = string | null;

export type FindOxResponseDiedAt = string | null;

export type FindOxResponseDentitionStage = EnumsDentitionStage | null;

export type FindOxResponseDeathReason = EnumsDeathCause | null;

export type FindOxResponseDeathNecropsy = EnumsDeathNecropsy | null;

export type FindOxResponseDeathDetails = string | null;

export type FindOxResponseDeathCause = EnumsDeathCause | null;

export type FindOxResponseCorralAnyOfPosition = number | null;

export type FindOxResponseCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: FindOxResponseCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type FindOxResponseCorral = FindOxResponseCorralAnyOf | null;

export type FindOxResponseComments = string | null;

export type FindOxResponseCertifierDate = string | null;

export type FindOxResponseCattleManifestId = number | null;

export type FindOxResponseCarcassWeight = number | null;

export type FindOxResponseCarcassType = EnumsCarcassType | null;

export type FindOxResponseCarcassPrice = number | null;

export type FindOxResponseCarcass = number | null;

export type FindOxResponseBornOnFarm = boolean | null;

export type FindOxResponseBndTracked = boolean | null;

export type FindOxResponseBatchesItemFinalizedAt = string | null;

export type FindOxResponseBatchesItemDescription = string | null;

export type FindOxResponseBatchesItem = {
  batch: FindOxResponseBatchesItemBatch;
  batchId: number;
  createdAt: string;
  description: FindOxResponseBatchesItemDescription;
  finalizedAt: FindOxResponseBatchesItemFinalizedAt;
  id: number;
  oxId: number;
};

export type FindOxResponseBatchesItemBatchScaledToSlaughter = boolean | null;

export type FindOxResponseBatchesItemBatchOperationalCostGroupId =
  | number
  | null;

export type FindOxResponseBatchesItemBatchOldCorralId = number | null;

export type FindOxResponseBatchesItemBatchHideFromTreatmentUntil =
  | string
  | null;

export type FindOxResponseBatchesItemBatchHideFromTreatment = boolean | null;

export type FindOxResponseBatchesItemBatchForeseenSlaughterDate = string | null;

export type FindOxResponseBatchesItemBatchFinalizedAt = string | null;

export type FindOxResponseBatchesItemBatchDescrption = string | null;

export type FindOxResponseBatchesItemBatchCorralId = number | null;

export type FindOxResponseBatchesItemBatch = {
  activatedAt: FindOxResponseBatchesItemBatchActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: FindOxResponseBatchesItemBatchActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: FindOxResponseBatchesItemBatchAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: FindOxResponseBatchesItemBatchCarcassExcessive;
  carcassMedium: FindOxResponseBatchesItemBatchCarcassMedium;
  carcassMissing: FindOxResponseBatchesItemBatchCarcassMissing;
  carcassThin: FindOxResponseBatchesItemBatchCarcassThin;
  carcassUniform: FindOxResponseBatchesItemBatchCarcassUniform;
  corral: FindOxResponseBatchesItemBatchCorral;
  corralId: FindOxResponseBatchesItemBatchCorralId;
  createdAt: string;
  descrption: FindOxResponseBatchesItemBatchDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: FindOxResponseBatchesItemBatchFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: FindOxResponseBatchesItemBatchForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: FindOxResponseBatchesItemBatchHideFromTreatment;
  hideFromTreatmentUntil: FindOxResponseBatchesItemBatchHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: FindOxResponseBatchesItemBatchOldCorralId;
  operationalCostGroupId: FindOxResponseBatchesItemBatchOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: FindOxResponseBatchesItemBatchScaledToSlaughter;
};

export type FindOxResponseBatchesItemBatchCorralAnyOfPosition = number | null;

export type FindOxResponseBatchesItemBatchCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: FindOxResponseBatchesItemBatchCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type FindOxResponseBatchesItemBatchCorral =
  FindOxResponseBatchesItemBatchCorralAnyOf | null;

export type FindOxResponseBatchesItemBatchCarcassUniform = number | null;

export type FindOxResponseBatchesItemBatchCarcassThin = number | null;

export type FindOxResponseBatchesItemBatchCarcassMissing = number | null;

export type FindOxResponseBatchesItemBatchCarcassMedium = number | null;

export type FindOxResponseBatchesItemBatchCarcassExcessive = number | null;

export type FindOxResponseBatchesItemBatchAdjustedPurchaseCost = number | null;

export type FindOxResponseBatchesItemBatchActivationEditedAt = string | null;

export type FindOxResponseBatchesItemBatchActivatedAt = string | null;

export type FindOxResponseBatchScaledToSlaughter = boolean | null;

export type FindOxResponseBatchOperationalCostGroupId = number | null;

export type FindOxResponseBatchOldCorralId = number | null;

export type FindOxResponseBatchHideFromTreatmentUntil = string | null;

export type FindOxResponseBatchHideFromTreatment = boolean | null;

export type FindOxResponseBatchForeseenSlaughterDate = string | null;

export type FindOxResponseBatchFinalizedAt = string | null;

export type FindOxResponseBatchDescrption = string | null;

export type FindOxResponseBatchCorralId = number | null;

export type FindOxResponseBatchCorralAnyOfPosition = number | null;

export type FindOxResponseBatchCorralAnyOf = {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: FindOxResponseBatchCorralAnyOfPosition;
  type: EnumsCorralType;
};

export type FindOxResponseBatchCorral = FindOxResponseBatchCorralAnyOf | null;

export type FindOxResponseBatchCarcassUniform = number | null;

export type FindOxResponseBatchCarcassThin = number | null;

export type FindOxResponseBatchCarcassMissing = number | null;

export type FindOxResponseBatchCarcassMedium = number | null;

export type FindOxResponseBatchCarcassExcessive = number | null;

export type FindOxResponseBatchAdjustedPurchaseCost = number | null;

export type FindOxResponseBatchActivationEditedAt = string | null;

export type FindOxResponseBatchActivatedAt = string | null;

export type FindOxResponseBatch = {
  activatedAt: FindOxResponseBatchActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: FindOxResponseBatchActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: FindOxResponseBatchAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: FindOxResponseBatchCarcassExcessive;
  carcassMedium: FindOxResponseBatchCarcassMedium;
  carcassMissing: FindOxResponseBatchCarcassMissing;
  carcassThin: FindOxResponseBatchCarcassThin;
  carcassUniform: FindOxResponseBatchCarcassUniform;
  corral: FindOxResponseBatchCorral;
  corralId: FindOxResponseBatchCorralId;
  createdAt: string;
  descrption: FindOxResponseBatchDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: FindOxResponseBatchFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: FindOxResponseBatchForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: FindOxResponseBatchHideFromTreatment;
  hideFromTreatmentUntil: FindOxResponseBatchHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: FindOxResponseBatchOldCorralId;
  operationalCostGroupId: FindOxResponseBatchOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: FindOxResponseBatchScaledToSlaughter;
};

export type FindBndInfoBySisbovResponse =
  FindBndInfoBySisbovResponseAnyOf | null;

export type FindBndInfoBySisbovResponseAnyOfStatus = EnumsBndStatus | null;

export type FindBndInfoBySisbovResponseAnyOfOwnerId = number | null;

export type FindBndInfoBySisbovResponseAnyOfCode = string | null;

export type FindBndInfoBySisbovResponseAnyOf = {
  birth: string;
  breed: string;
  code: FindBndInfoBySisbovResponseAnyOfCode;
  expedition: string;
  gender: EnumsOxGender;
  id: number;
  inclusion: string;
  inventory: boolean;
  ownerId: FindBndInfoBySisbovResponseAnyOfOwnerId;
  sisbov: number;
  status: FindBndInfoBySisbovResponseAnyOfStatus;
};

export interface FindBndInfoBySisbovQuery {
  sisbov: number;
}

export type FinancialSummaryConfinementExpenses = {
  classicPartnershipPurchasePrice?: number;
  dailyBoitelPrice?: number;
  producedWeightExpense?: number;
};

export interface FinancialSummary {
  advance?: number;
  confinementExpenses: FinancialSummaryConfinementExpenses;
  discounts?: number;
  netIncome: number;
  netIncomePerSlaughter: number;
  slaughteringRevenue: number;
  taxesAndFees?: number;
}

export type FinancialBatchesStateResponseResult = FinancialBatchesResult | null;

export type FinancialBatchesStateResponseError = string | null;

export interface FinancialBatchesStateResponse {
  error: FinancialBatchesStateResponseError;
  jobId: string;
  progress: ReportJobProgress;
  result: FinancialBatchesStateResponseResult;
  status: ReportJobStatus;
}

/**
 * Posição do curral — só para ordenar a tabela.
 */
export type FinancialBatchesRowPosition = number | null;

/**
 * Data de entrada/processamento, pela precedência identificação → casual/entrada.
 */
export type FinancialBatchesRowEntryDate = string | null;

/**
 * Uma linha por lote. O relatório é o retrato atual, então não há agregação por período.

## Origem de cada campo (para validação futura)

| Campo                                                            | Fonte da regra                          | Observação                                                                                        | | ---------------------------------------------------------------- | --------------------------------------- | ------------------------------------------------------------------------------------------------- | | `name`, `corral`, `oxenAmount`, `variety`, `gender`, `ownerName` | Lotes Ativos                            | `oxenAmount` é contagem direta; o Lotes Ativos chega ao mesmo número por subtração                | | `entryDate`, `entryWeight`                                       | Analítico (`getProcessingAverageInfo`)  | Precedência: pesagem de IDENTIFICAÇÃO vence; senão CASUAL/ENTRY, sempre com a data correspondente | | `estimatedWeight`, `estimatedWeightGain`                         | Lotes Ativos                            | Reescritos com `DISTINCT ON`; números idênticos                                                   | | `confinementDays`                                                | Lotes Ativos                            | `BY_OX_FIRST_ACTIVATION`                                                                          | | `treatmentDays`                                                  | **Relatório Analítico**                 | Trajetória do animal em todos os lotes — ver `treatmentDaysByBatches`                             | | `cms`, `cmn`                                                     | Lotes Ativos (`MS Medio`/`MO Medio`)    | Mesmo `getBatchConsumeStats`: `Σ matéria ÷ Σ animais-dia` do lote                                 | | `dailyFeedCost`                                                  | Lotes Ativos (`Cst Alim`)               | Média das diárias do período — ver `getBatchesAverageDailyFeedCost`                               | | `totalTreatCost`                                                 | Lotes Ativos                            | Restrito aos dias em que os animais atuais estavam no lote                                        | | `totalOperationalCost`                                           | Analítico / Fechamento Individual       | Total do período, por animal desde a primeira entrada em confinamento                             | | `healthCost`                                                     | **Fechamento Individual**               | `Σ appliedDose × dosePrice` do histórico completo do animal                                       | | `totalManagementCost`                                            | Econômico (`economic-service.ts`)       | operacional + trato + sanidade                                                                    | | `shippingCost`, `commissionCost`                                 | **Fechamento Individual**               | Valores conferidos idênticos aos do `BatchEntryCostsService`, que é quem calcula                  | | `totalPurchaseValue`, `purchaseValuePerHead`                     | Lotes Ativos (`BatchEntryCostsService`) |                                                                                                   |
 */
export interface FinancialBatchesRow {
  batchId: number;
  /** Consumo médio de matéria natural do lote no período (kg/cab/dia). */
  cmn: number;
  /** Consumo médio de matéria seca do lote no período (kg/cab/dia). */
  cms: number;
  commissionCost: number;
  confinementDays: number;
  corral?: string;
  /** Média das diárias alimentares ao longo do período do lote (R$/cab/dia). */
  dailyFeedCost: number;
  /** Data de entrada/processamento, pela precedência identificação → casual/entrada. */
  entryDate: FinancialBatchesRowEntryDate;
  /** Peso de entrada/processamento, pela mesma precedência da data. */
  entryWeight: number;
  estimatedWeight: number;
  estimatedWeightGain: number;
  gender: EnumsOxGender[];
  healthCost: number;
  name: string;
  ownerName: string;
  oxenAmount: number;
  /** Posição do curral — só para ordenar a tabela. */
  position: FinancialBatchesRowPosition;
  purchaseValuePerHead: number;
  shippingCost: number;
  totalManagementCost: number;
  totalOperationalCost: number;
  totalPurchaseValue: number;
  totalTreatCost: number;
  treatmentDays: number;
  variety: string[];
}

export interface FinancialBatchesResult {
  /** Dia da fazenda a que o retrato se refere. */
  day: string;
  rows: FinancialBatchesRow[];
}

export type FinalizedBatchesDetailsResponse =
  FinalizedBatchesDetailsResponseItem[];

export type FinalizedBatchesDetailsResponseItemFinalizedAt = string | null;

export type FinalizedBatchesDetailsResponseItemCorralName = string | null;

export type FinalizedBatchesDetailsResponseItemActivatedAt = string | null;

export type FinalizedBatchesDetailsResponseItem = {
  activatedAt: FinalizedBatchesDetailsResponseItemActivatedAt;
  corralName: FinalizedBatchesDetailsResponseItemCorralName;
  createdAt: string;
  finalizedAt: FinalizedBatchesDetailsResponseItemFinalizedAt;
  id: number;
  name: string;
};

export type FinalizedBatchDetailsResponseFinalizedAt = string | null;

export type FinalizedBatchDetailsResponseCorralName = string | null;

export type FinalizedBatchDetailsResponseAdjustedPurchaseCost = number | null;

export interface FinalizedBatchDetailsResponse {
  adjustedPurchaseCost: FinalizedBatchDetailsResponseAdjustedPurchaseCost;
  carcass: number;
  corralName: FinalizedBatchDetailsResponseCorralName;
  createdAt: string;
  deadOxenAmount: number;
  exitPrice: number;
  finalizedAt: FinalizedBatchDetailsResponseFinalizedAt;
  foreseenCarcass: number;
  id: number;
  name: string;
  otherCost: number;
  oxenAmount: number;
  varieties: string[];
}

export type FinalizeManagementSessionResponseFinishedById = number | null;

export interface FinalizeManagementSessionResponse {
  createdAt: string;
  data: unknown;
  farmId: number;
  finishedById: FinalizeManagementSessionResponseFinishedById;
  id: number;
  name: string;
  status: EnumsManagementStatus;
  type: EnumsTypeManagement;
  updatedAt: string;
  uuid: string;
}

export interface FilterTreatment {
  batchIds?: number[];
  hideTreatment?: boolean;
}

export interface FilterMedicine {
  active?: boolean;
}

export interface FilterHealthProtocol {
  active?: boolean;
}

export interface FilterDietTransition {
  divisions?: number;
}

export type FilterBatchStatus =
  (typeof FilterBatchStatus)[keyof typeof FilterBatchStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterBatchStatus = {
  active: "active",
  inactive: "inactive",
} as const;

export type FilterBatchCreatedAt =
  (typeof FilterBatchCreatedAt)[keyof typeof FilterBatchCreatedAt];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterBatchCreatedAt = {
  activatedAt: "activatedAt",
  createdAt: "createdAt",
} as const;

export interface FilterBatch {
  createdAt?: FilterBatchCreatedAt;
  status?: FilterBatchStatus;
  type?: EnumsCorralType;
}

export interface FillBatchIdentityBody {
  oxen: OxFillIdentity[];
}

export type FieldDiffBefore = string | number | null;

export type FieldDiffAfter = string | number | null;

export interface FieldDiff {
  after: FieldDiffAfter;
  before: FieldDiffBefore;
  field: string;
  label: string;
}

export type FeedLinkStatus = EnumsFeedLinkStatus;

export interface FeedLinkSource {
  filename: string;
  lines: FeedLinkLine[];
}

export type FeedLinkSlug = EnumsFeedLinkSlug;

export type FeedLinkReview = EnumsFeedLinkReview;

export type FeedLinkRecipesResponseRecipesItem = {
  code: number;
  dietId: number;
  id: number;
  mixerId: number;
};

export type FeedLinkRecipesResponseMixersItem = {
  id: number;
  name: string;
};

export type FeedLinkRecipesResponseDietsItem = {
  id: number;
  name: string;
};

export interface FeedLinkRecipesResponse {
  diets: FeedLinkRecipesResponseDietsItem[];
  mixers: FeedLinkRecipesResponseMixersItem[];
  recipes: FeedLinkRecipesResponseRecipesItem[];
}

export type FeedLinkLineType =
  (typeof FeedLinkLineType)[keyof typeof FeedLinkLineType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedLinkLineType = {
  treats: "treats",
  beats: "beats",
  beatIngredients: "beatIngredients",
  treatStatuses: "treatStatuses",
} as const;

export type FeedLinkLineError = string | null;

export type FeedLinkLineCorralPosition = number | null;

export type FeedLinkLineConcluded = boolean | null;

export type FeedLinkLineAt = string | null;

export type FeedLinkLineAmount = number | null;

export interface FeedLinkLine {
  amount: FeedLinkLineAmount;
  at: FeedLinkLineAt;
  concluded: FeedLinkLineConcluded;
  corralPosition: FeedLinkLineCorralPosition;
  error: FeedLinkLineError;
  id: number;
  title: string;
  token: string;
  type: FeedLinkLineType;
}

export type FeedLinkFileWarning = string | null;

/**
 * Revisão do arquivo de dia passado. Nulo quando o arquivo não passou por revisão.
 */
export type FeedLinkFileReview = EnumsFeedLinkReview | null;

/**
 * Dia a que as linhas se referem. Nulo em arquivo sem linha e nos anteriores à revisão de dia.
 */
export type FeedLinkFileReferenceDay = string | null;

export type FeedLinkFileKind =
  (typeof FeedLinkFileKind)[keyof typeof FeedLinkFileKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedLinkFileKind = {
  TREAT: "TREAT",
  BEAT: "BEAT",
  TREAT_STATUS: "TREAT_STATUS",
  INVALID: "INVALID",
} as const;

export type FeedLinkFileError = string | null;

export type FeedLinkFileAt = string | null;

export interface FeedLinkFile {
  at: FeedLinkFileAt;
  count: number;
  error: FeedLinkFileError;
  /** Registros que formam o item. É por eles que a revisão aceita ou recusa o arquivo. */
  ids: number[];
  key: string;
  kind: FeedLinkFileKind;
  processedAt: string;
  /** Dia a que as linhas se referem. Nulo em arquivo sem linha e nos anteriores à revisão de dia. */
  referenceDay: FeedLinkFileReferenceDay;
  /** Revisão do arquivo de dia passado. Nulo quando o arquivo não passou por revisão. */
  review: FeedLinkFileReview;
  sources: FeedLinkSource[];
  warning: FeedLinkFileWarning;
}

export interface FeedLinkConfigResponse {
  active: boolean;
  interval: number;
}

export interface FarmStartDateAffected {
  batchesUpdated: number;
  batchHistoriesRedated: number;
  beatsRealizedUpdated: number;
  consumesUpdated: number;
  corralOnBatchesUpdated: number;
  corralsUpdated: number;
  dietOnBatchesUpdated: number;
  dietsUpdated: number;
  dietTransitionOnBatchesUpdated: number;
  exitTrucksUpdated: number;
  healthProtocolsUpdated: number;
  holdingSalesUpdated: number;
  medicinesUpdated: number;
  mixersUpdated: number;
  oxenUpdated: number;
  oxOnBatchesUpdated: number;
  oxWeightsUpdated: number;
  peopleUpdated: number;
  purchasesUpdated: number;
  recipesUpdated: number;
  saleOrdersUpdated: number;
  structuresUpdated: number;
  treatmentOnBatchesUpdated: number;
  treatmentsUpdated: number;
  treatsRealizedUpdated: number;
  weightBreakGoalsUpdated: number;
  weightGainCurveOnBatchesUpdated: number;
  weightGainCurvesUpdated: number;
}

export interface FarmCredentialsLookupQuery {
  customerId: string;
  dbPort: number;
  serverIp: string;
}

export interface FactoryEdit {
  polygon: GlobalPrismaJsonLatLng[];
}

export type ExportSalesReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type ExportSalesReportExcelResponse =
  | ExportSalesReportExcelResponseAnyOf
  | ExportSalesReportExcelResponseAnyOfThree;

export type ExportSalesReportExcelResponseAnyOfBuffer = string | GlobalBuffer;

export type ExportSalesReportExcelResponseAnyOf = {
  buffer: ExportSalesReportExcelResponseAnyOfBuffer;
};

export type ExportSaleOrderOxenToExcelResponseBuffer =
  | string
  | GlobalBuffer
  | null;

export interface ExportSaleOrderOxenToExcelResponse {
  buffer: ExportSaleOrderOxenToExcelResponseBuffer;
  filename: string;
}

export interface ExportSaleOrderOxenToExcelBody {
  filename: string;
}

export type ExportOxenFromInternalSaleResponseBuffer = string | null;

export interface ExportOxenFromInternalSaleResponse {
  buffer: ExportOxenFromInternalSaleResponseBuffer;
  salesWithoutAnimals: number[];
}

export type ExportOxSearchResponseBuffer = string | null;

export interface ExportOxSearchResponse {
  buffer: ExportOxSearchResponseBuffer;
}

export type ExportMedicineApplicationsReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type ExportMedicineApplicationsReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type ExportMedicineApplicationsReportExcelResponseAnyOf = {
  buffer: ExportMedicineApplicationsReportExcelResponseAnyOfBuffer;
};

export type ExportMedicineApplicationsReportExcelResponse =
  | ExportMedicineApplicationsReportExcelResponseAnyOf
  | ExportMedicineApplicationsReportExcelResponseAnyOfThree;

export type ExportManagementSessionExtractExcelResponseAnyOfThree = {
  buffer: null;
};

export type ExportManagementSessionExtractExcelResponse =
  | ExportManagementSessionExtractExcelResponseAnyOf
  | ExportManagementSessionExtractExcelResponseAnyOfThree;

export type ExportManagementSessionExtractExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type ExportManagementSessionExtractExcelResponseAnyOf = {
  buffer: ExportManagementSessionExtractExcelResponseAnyOfBuffer;
};

export type ExportGtaOverviewExcelResponseBuffer = string | null;

export interface ExportGtaOverviewExcelResponse {
  buffer: ExportGtaOverviewExcelResponseBuffer;
}

export type ExportGtaOverviewExcelItemWeightingMap = string | null;

export type ExportGtaOverviewExcelItemPurchaseId = number | null;

export type ExportGtaOverviewExcelItemPurchase = string | null;

export type ExportGtaOverviewExcelItemOriginState = string | null;

export type ExportGtaOverviewExcelItemInvoice = string | null;

export interface ExportGtaOverviewExcelItem {
  entry: string;
  farmName: string;
  invoice?: ExportGtaOverviewExcelItemInvoice;
  number: string;
  originName: string;
  originState?: ExportGtaOverviewExcelItemOriginState;
  oxenManagedTotal: number;
  oxenProcessedTotal: number;
  oxenSystemTotal: number;
  oxenTotal: number;
  purchase?: ExportGtaOverviewExcelItemPurchase;
  purchaseId?: ExportGtaOverviewExcelItemPurchaseId;
  series: string;
  weightingMap?: ExportGtaOverviewExcelItemWeightingMap;
}

export interface ExportGtaOverviewExcelBody {
  data: ExportGtaOverviewExcelItem[];
  filename: string;
}

export type ExportFeedDataResponseAnyOfThree = {
  buffer: null;
};

export type ExportFeedDataResponse =
  | ExportFeedDataResponseAnyOf
  | ExportFeedDataResponseAnyOfThree;

export type ExportFeedDataResponseAnyOfBuffer = string | GlobalBuffer;

export type ExportFeedDataResponseAnyOf = {
  buffer: ExportFeedDataResponseAnyOfBuffer;
};

export type ExportDiedOxenReportExcelResponseAnyOfThree = {
  buffer: null;
};

export type ExportDiedOxenReportExcelResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type ExportDiedOxenReportExcelResponseAnyOf = {
  buffer: ExportDiedOxenReportExcelResponseAnyOfBuffer;
};

export type ExportDiedOxenReportExcelResponse =
  | ExportDiedOxenReportExcelResponseAnyOf
  | ExportDiedOxenReportExcelResponseAnyOfThree;

export type ExportCattleManifestResponseBuffer = string | GlobalBuffer | null;

export interface ExportCattleManifestResponse {
  buffer: ExportCattleManifestResponseBuffer;
  filename: string;
}

export interface ExportCattleManifestBody {
  filename: string;
}

export type ExportAllOxenToExcelResultSisbov = string | null;

export type ExportAllOxenToExcelResultIdentifier = string | null;

export type ExportAllOxenToExcelResultElectronic = string | null;

export interface ExportAllOxenToExcelResult {
  batch: string;
  birth: string;
  breed: string;
  corral: string;
  currentAge: number;
  currentWeight: number;
  electronic: ExportAllOxenToExcelResultElectronic;
  entryAge: number;
  entryDate: string;
  entryWeight: number;
  gender: EnumsOxGender;
  gtaEntryDate: string;
  gtaNumber: string;
  gtaSeries: string;
  identifier: ExportAllOxenToExcelResultIdentifier;
  origin: string;
  originOwner: string;
  oxOwner: string;
  purchaseCommission: number;
  purchaseInvoice: string;
  purchasePrice: number;
  purchaseShipping: number;
  sisbov: ExportAllOxenToExcelResultSisbov;
  variety: string;
}

export type ExportAllOxenToExcelResponse = ExportAllOxenToExcelResult[];

export type ExportAllOxenSimplifiedResultSisbov = string | null;

export type ExportAllOxenSimplifiedResultIdentifier = string | null;

export type ExportAllOxenSimplifiedResultElectronic = string | null;

export interface ExportAllOxenSimplifiedResult {
  batch: string;
  birth: string;
  breed: string;
  corral: string;
  currentAge: number;
  electronic: ExportAllOxenSimplifiedResultElectronic;
  entryAge: number;
  entryDate: string;
  gender: EnumsOxGender;
  identifier: ExportAllOxenSimplifiedResultIdentifier;
  sisbov: ExportAllOxenSimplifiedResultSisbov;
  variety: string;
}

export type ExportAllOxenSimplifiedResponse = ExportAllOxenSimplifiedResult[];

export type ExportAllOxenIdentificationToExcelResultSisbov = string | null;

export type ExportAllOxenIdentificationToExcelResultIdentifier = string | null;

export type ExportAllOxenIdentificationToExcelResultElectronic = string | null;

export interface ExportAllOxenIdentificationToExcelResult {
  batch: string;
  birth: string;
  breed: string;
  corral: string;
  currentAge: number;
  currentWeight: number;
  electronic: ExportAllOxenIdentificationToExcelResultElectronic;
  entryAge: number;
  entryDate: string;
  entryWeight: number;
  gender: EnumsOxGender;
  gtaEntryDate: string;
  gtaNumber: string;
  gtaSeries: string;
  identifiedAt: string;
  identifier: ExportAllOxenIdentificationToExcelResultIdentifier;
  origin: string;
  originOwner: string;
  oxOwner: string;
  purchaseCommission: number;
  purchaseInvoice: string;
  purchasePrice: number;
  purchaseShipping: number;
  sisbov: ExportAllOxenIdentificationToExcelResultSisbov;
  variety: string;
}

export type ExportAllOxenDiedToExcelResultTruckPlate = string | null;

export type ExportAllOxenDiedToExcelResultTruckName = string | null;

export type ExportAllOxenDiedToExcelResultTruckExitGta = string | null;

export type ExportAllOxenDiedToExcelResultTruckExitAt = string | null;

export type ExportAllOxenDiedToExcelResultSisbov = string | null;

export type ExportAllOxenDiedToExcelResultIdentifier = string | null;

export type ExportAllOxenDiedToExcelResultElectronic = string | null;

export type ExportAllOxenDiedToExcelResultDeathNecropsy =
  EnumsDeathNecropsy | null;

export type ExportAllOxenDiedToExcelResultDeathDetails = string | null;

export type ExportAllOxenDiedToExcelResultDeathCause = EnumsDeathCause | null;

export interface ExportAllOxenDiedToExcelResult {
  batch: string;
  birth: string;
  breed: string;
  corral: string;
  currentAge: number;
  currentWeight: number;
  deathCause: ExportAllOxenDiedToExcelResultDeathCause;
  deathDetails: ExportAllOxenDiedToExcelResultDeathDetails;
  deathNecropsy: ExportAllOxenDiedToExcelResultDeathNecropsy;
  diedAt: string;
  electronic: ExportAllOxenDiedToExcelResultElectronic;
  entryAge: number;
  entryDate: string;
  entryWeight: number;
  gender: EnumsOxGender;
  gtaEntryDate: string;
  gtaNumber: string;
  gtaSeries: string;
  identifier: ExportAllOxenDiedToExcelResultIdentifier;
  origin: string;
  originOwner: string;
  oxOwner: string;
  processingWeight: number;
  purchaseCommission: number;
  purchaseInvoice: string;
  purchasePrice: number;
  purchaseShipping: number;
  sisbov: ExportAllOxenDiedToExcelResultSisbov;
  truckExitAt: ExportAllOxenDiedToExcelResultTruckExitAt;
  truckExitGta: ExportAllOxenDiedToExcelResultTruckExitGta;
  truckName: ExportAllOxenDiedToExcelResultTruckName;
  truckPlate: ExportAllOxenDiedToExcelResultTruckPlate;
  truckStatus: EnumsExitTruckStatus;
  variety: string;
}

export type ExportAllIdentificationOxenToExcelResponse =
  ExportAllOxenIdentificationToExcelResult[];

export type ExportAllDiedOxenToExcelResponse = ExportAllOxenDiedToExcelResult[];

export type ExitTruckStatus = EnumsExitTruckStatus;

export type ExitReason = EnumsExitReason;

export interface ExitAnnouncement {
  driver: string;
  exitGta?: string;
  exitGtaSeries?: string;
  exitTruckId: number;
  plate: string;
}

export type EstablishmentWithLayoutCattleManifestLayoutName = string | null;

export type EstablishmentWithLayoutCattleManifestLayoutId = number | null;

export interface EstablishmentWithLayout {
  cattleManifestLayoutId: EstablishmentWithLayoutCattleManifestLayoutId;
  cattleManifestLayoutName: EstablishmentWithLayoutCattleManifestLayoutName;
  id: number;
  name: string;
}

export type ErrorOxWeight = number | null;

export type ErrorOxStatus = (typeof ErrorOxStatus)[keyof typeof ErrorOxStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorOxStatus = {
  ERROR: "ERROR",
} as const;

export type ErrorOxSisbov = string | null;

export type ErrorOxIdentifier = string | null;

export type ErrorOxExtraEarring = string | null;

export type ErrorOxElectronic = string | null;

export type ErrorOxDentition = string | null;

export interface ErrorOx {
  canForceExit?: boolean;
  dentition?: ErrorOxDentition;
  electronic?: ErrorOxElectronic;
  extraEarring?: ErrorOxExtraEarring;
  identifier: ErrorOxIdentifier;
  line: number;
  oxId?: number;
  reason: string;
  sisbov?: ErrorOxSisbov;
  status: ErrorOxStatus;
  weight?: ErrorOxWeight;
}

export type EntryWeightDiffBefore = number | null;

export interface EntryWeightDiff {
  after: number;
  before: EntryWeightDiffBefore;
  oxId: number;
}

export type EntryManagementViewResponseOxenItemWeightsItemWeight =
  | number
  | null;

export type EntryManagementViewResponseOxenItemWeightsItem = {
  weight: EntryManagementViewResponseOxenItemWeightsItemWeight;
};

export type EntryManagementViewResponseOxenItemSisbov = string | null;

export type EntryManagementViewResponseOxenItem = {
  breed: string;
  gender: EnumsOxGender;
  id: number;
  sisbov: EntryManagementViewResponseOxenItemSisbov;
  weights: EntryManagementViewResponseOxenItemWeightsItem[];
};

export interface EntryManagementViewResponse {
  averageWeight: number;
  cov: number;
  oxen: EntryManagementViewResponseOxenItem[];
  totalOxenCount: number;
}

export interface EntryExecutionSyncResponse {
  data: EntryExecutionSyncResponseData;
  meta: EntryExecutionSyncResponseMeta;
}

export type EntryExecutionSyncResponseMetaPhasesItem = {
  ms: number;
  name: string;
  rows: number;
};

export type EntryExecutionSyncResponseMetaCounts = {
  batches: number;
  corrals: number;
  earringPurchases: number;
  gtas: number;
  healthProtocols: number;
  medicines: number;
  oxen: number;
  purchases: number;
  usedElectronic: number;
  usedIdentifier: number;
  usedSisbov: number;
  weights: number;
};

export type EntryExecutionSyncResponseMeta = {
  concurrency: number;
  counts: EntryExecutionSyncResponseMetaCounts;
  day: string;
  phases: EntryExecutionSyncResponseMetaPhasesItem[];
  totalMs: number;
};

export type EntryExecutionSyncResponseDataWeightsItemLastWeight = number | null;

export type EntryExecutionSyncResponseDataWeightsItemLastDate = string | null;

export type EntryExecutionSyncResponseDataWeightsItem = {
  lastDate: EntryExecutionSyncResponseDataWeightsItemLastDate;
  lastWeight: EntryExecutionSyncResponseDataWeightsItemLastWeight;
  oxId: number;
};

export type EntryExecutionSyncResponseDataUsedIdentifications = {
  electronic: string[];
  identifier: string[];
  sisbov: string[];
};

export type EntryExecutionSyncResponseData = {
  batches: EntryExecutionSyncResponseDataBatchesItem[];
  corrals: EntryExecutionSyncResponseDataCorralsItem[];
  earringPurchases: EntryExecutionSyncResponseDataEarringPurchasesItem[];
  gtas: EntryExecutionSyncResponseDataGtasItem[];
  healthProtocols: EntryExecutionSyncResponseDataHealthProtocolsItem[];
  medicines: EntryExecutionSyncResponseDataMedicinesItem[];
  oxen: EntryExecutionSyncResponseDataOxenItem[];
  purchases: EntryExecutionSyncResponseDataPurchasesItem[];
  usedIdentifications: EntryExecutionSyncResponseDataUsedIdentifications;
  weights: EntryExecutionSyncResponseDataWeightsItem[];
};

export type EntryExecutionSyncResponseDataPurchasesItemWeighingAt =
  | string
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemReceivedAt =
  | string
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemPartnerId =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemOxenAmount =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemMapa = string | null;

export type EntryExecutionSyncResponseDataPurchasesItemMaleProducedPrice =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemMaleFutureAnimalPrice =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemMaleEntryCarcassYield =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemMaleDailyPrice =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemFemaleProducedPrice =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemFemaleFutureAnimalPrice =
  number | null;

export type EntryExecutionSyncResponseDataPurchasesItemFemaleEntryCarcassYield =
  number | null;

export type EntryExecutionSyncResponseDataPurchasesItemFemaleDailyPrice =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItemDiscountPercent =
  | number
  | null;

export type EntryExecutionSyncResponseDataPurchasesItem = {
  buyerId: number;
  commission: number;
  discountPercent: EntryExecutionSyncResponseDataPurchasesItemDiscountPercent;
  femaleDailyPrice: EntryExecutionSyncResponseDataPurchasesItemFemaleDailyPrice;
  femaleEntryCarcassYield: EntryExecutionSyncResponseDataPurchasesItemFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: EntryExecutionSyncResponseDataPurchasesItemFemaleFutureAnimalPrice;
  femaleProducedPrice: EntryExecutionSyncResponseDataPurchasesItemFemaleProducedPrice;
  id: number;
  maleDailyPrice: EntryExecutionSyncResponseDataPurchasesItemMaleDailyPrice;
  maleEntryCarcassYield: EntryExecutionSyncResponseDataPurchasesItemMaleEntryCarcassYield;
  maleFutureAnimalPrice: EntryExecutionSyncResponseDataPurchasesItemMaleFutureAnimalPrice;
  maleProducedPrice: EntryExecutionSyncResponseDataPurchasesItemMaleProducedPrice;
  mapa: EntryExecutionSyncResponseDataPurchasesItemMapa;
  ownerId: number;
  oxenAmount: EntryExecutionSyncResponseDataPurchasesItemOxenAmount;
  partnerId: EntryExecutionSyncResponseDataPurchasesItemPartnerId;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purchaseName: string;
  purchaseStatus: EnumsPurchaseStatus;
  purpose: EnumsOxPurpose;
  receivedAt: EntryExecutionSyncResponseDataPurchasesItemReceivedAt;
  shipping: number;
  traceable: boolean;
  weighingAt: EntryExecutionSyncResponseDataPurchasesItemWeighingAt;
  weightAverage: number;
};

export type EntryExecutionSyncResponseDataOxenItemSisbov = string | null;

export type EntryExecutionSyncResponseDataOxenItemIdentifier = string | null;

export type EntryExecutionSyncResponseDataOxenItemElectronic = string | null;

export type EntryExecutionSyncResponseDataOxenItem = {
  batchId: number;
  electronic: EntryExecutionSyncResponseDataOxenItemElectronic;
  id: number;
  identifier: EntryExecutionSyncResponseDataOxenItemIdentifier;
  sisbov: EntryExecutionSyncResponseDataOxenItemSisbov;
};

export type EntryExecutionSyncResponseDataMedicinesItemPerKg = number | null;

export type EntryExecutionSyncResponseDataMedicinesItemKiloDose = number | null;

export type EntryExecutionSyncResponseDataMedicinesItemApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export type EntryExecutionSyncResponseDataMedicinesItem = {
  active: boolean;
  applicationSuggestion: EntryExecutionSyncResponseDataMedicinesItemApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: EntryExecutionSyncResponseDataMedicinesItemKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: EntryExecutionSyncResponseDataMedicinesItemPerKg;
  type: EnumsMedicineType;
};

export type EntryExecutionSyncResponseDataHealthProtocolsItem = {
  active: boolean;
  id: number;
  medicines: EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItem[];
  name: string;
};

export type EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItemPerKg =
  number | null;

export type EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItemKiloDose =
  number | null;

export type EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItemApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export type EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItem = {
  active: boolean;
  applicationSuggestion: EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItemApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItemKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: EntryExecutionSyncResponseDataHealthProtocolsItemMedicinesItemPerKg;
  type: EnumsMedicineType;
};

export type EntryExecutionSyncResponseDataGtasItemWeightingMapId =
  | number
  | null;

export type EntryExecutionSyncResponseDataGtasItemWeightAverage = number | null;

export type EntryExecutionSyncResponseDataGtasItemPurchaseId = number | null;

export type EntryExecutionSyncResponseDataGtasItemOriginWeightAverage =
  | number
  | null;

export type EntryExecutionSyncResponseDataGtasItemInvoice = string | null;

export type EntryExecutionSyncResponseDataGtasItemHours = number | null;

export type EntryExecutionSyncResponseDataGtasItemDistance = number | null;

export type EntryExecutionSyncResponseDataGtasItemDestinyId = number | null;

export type EntryExecutionSyncResponseDataGtasItemDescription = string | null;

export type EntryExecutionSyncResponseDataGtasItemAgesItem = {
  femaleManaged: number;
  femaleTotal: number;
  gtaId: number;
  id: number;
  maleManaged: number;
  maleTotal: number;
  yearsOld: number;
};

export type EntryExecutionSyncResponseDataGtasItem = {
  ages: EntryExecutionSyncResponseDataGtasItemAgesItem[];
  completed: boolean;
  description: EntryExecutionSyncResponseDataGtasItemDescription;
  destinyId: EntryExecutionSyncResponseDataGtasItemDestinyId;
  distance: EntryExecutionSyncResponseDataGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: EntryExecutionSyncResponseDataGtasItemHours;
  id: number;
  invoice: EntryExecutionSyncResponseDataGtasItemInvoice;
  number: string;
  originId: number;
  originWeightAverage: EntryExecutionSyncResponseDataGtasItemOriginWeightAverage;
  purchaseId: EntryExecutionSyncResponseDataGtasItemPurchaseId;
  series: string;
  weightAverage: EntryExecutionSyncResponseDataGtasItemWeightAverage;
  weightingMapId: EntryExecutionSyncResponseDataGtasItemWeightingMapId;
};

export type EntryExecutionSyncResponseDataEarringPurchasesItemOrder =
  | string
  | null;

export type EntryExecutionSyncResponseDataEarringPurchasesItem = {
  brand: string;
  cancelled: number[];
  finalSisbov: number;
  id: number;
  initialSisbov: number;
  order: EntryExecutionSyncResponseDataEarringPurchasesItemOrder;
  ownerId: number;
  purchaseId: number;
  purchaseName: string;
};

export type EntryExecutionSyncResponseDataCorralsItemPosition = number | null;

export type EntryExecutionSyncResponseDataCorralsItem = {
  capacity: number;
  id: number;
  name: string;
  position: EntryExecutionSyncResponseDataCorralsItemPosition;
  type: EnumsCorralType;
};

export type EntryExecutionSyncResponseDataBatchesItemScaledToSlaughter =
  | boolean
  | null;

export type EntryExecutionSyncResponseDataBatchesItemOperationalCostGroupId =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemOldCorralId =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemHideFromTreatmentUntil =
  | string
  | null;

export type EntryExecutionSyncResponseDataBatchesItemHideFromTreatment =
  | boolean
  | null;

export type EntryExecutionSyncResponseDataBatchesItemForeseenSlaughterDate =
  | string
  | null;

export type EntryExecutionSyncResponseDataBatchesItemFinalizedAt =
  | string
  | null;

export type EntryExecutionSyncResponseDataBatchesItemDescrption = string | null;

export type EntryExecutionSyncResponseDataBatchesItemCorralId = number | null;

export type EntryExecutionSyncResponseDataBatchesItemCarcassUniform =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemCarcassThin =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemCarcassMissing =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemCarcassMedium =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemCarcassExcessive =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemAdjustedPurchaseCost =
  | number
  | null;

export type EntryExecutionSyncResponseDataBatchesItemActivationEditedAt =
  | string
  | null;

export type EntryExecutionSyncResponseDataBatchesItemActivatedAt =
  | string
  | null;

export type EntryExecutionSyncResponseDataBatchesItem = {
  activatedAt: EntryExecutionSyncResponseDataBatchesItemActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: EntryExecutionSyncResponseDataBatchesItemActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: EntryExecutionSyncResponseDataBatchesItemAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: EntryExecutionSyncResponseDataBatchesItemCarcassExcessive;
  carcassMedium: EntryExecutionSyncResponseDataBatchesItemCarcassMedium;
  carcassMissing: EntryExecutionSyncResponseDataBatchesItemCarcassMissing;
  carcassThin: EntryExecutionSyncResponseDataBatchesItemCarcassThin;
  carcassUniform: EntryExecutionSyncResponseDataBatchesItemCarcassUniform;
  corralId: EntryExecutionSyncResponseDataBatchesItemCorralId;
  createdAt: string;
  descrption: EntryExecutionSyncResponseDataBatchesItemDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: EntryExecutionSyncResponseDataBatchesItemFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: EntryExecutionSyncResponseDataBatchesItemForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: EntryExecutionSyncResponseDataBatchesItemHideFromTreatment;
  hideFromTreatmentUntil: EntryExecutionSyncResponseDataBatchesItemHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: EntryExecutionSyncResponseDataBatchesItemOldCorralId;
  operationalCostGroupId: EntryExecutionSyncResponseDataBatchesItemOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: EntryExecutionSyncResponseDataBatchesItemScaledToSlaughter;
};

export type EntryAnnouncementPurchaseId = number | null;

export type EntryAnnouncementEstablishmentId = number | null;

export interface EntryAnnouncement {
  date: string;
  establishmentId?: EntryAnnouncementEstablishmentId;
  gtasIds?: number[];
  oxenIds: number[];
  purchaseId?: EntryAnnouncementPurchaseId;
}

export type EntranceReportXlsxQueryAppVersion = string | null;

export interface EntranceReportXlsxQuery {
  appVersion?: EntranceReportXlsxQueryAppVersion;
  end?: string;
  filename: string;
  gender?: EnumsOxGender;
  partnerId?: number;
  purchaseName?: string;
  start?: string;
  type?: EnumsOxPurpose;
}

export interface EntranceReportResume {
  /** Peso médio (@) na origem */
  atSignAvgWeight: number;
  /** Preço por @ (exceto frete) */
  atSignPrice: number;
  /** Preço total por @ */
  atSignTotalPrice: number;
  /** Peso total em @ */
  atSignTotalWeight: number;
  /** Distância (km) */
  distance: number;
  /** Meta de quebra de peso (%) */
  expectedWeightBreak: number;
  /** Horas da GTA */
  hours: number;
  /** Quantidade de animais */
  oxenAmount: number;
  /** Quantidade de animais (%) */
  oxenAmountPercentage: number;
  /** Quebra de peso real (%) */
  realWeightBreak: number;
  /** Frete por @ */
  shippingAtSignPrice: number;
  /** Preço total em R$ */
  totalPrice: number;
  /** Quebra de peso por @ */
  weightBreakAtSign: number;
  /** Diferença na quebra de peso da meta e real (%) */
  weightBreakDiff: number;
}

/**
 * Data
 */
export type EntranceReportPurchaseItemDay = string | null;

export interface EntranceReportPurchaseItem {
  /** Peso médio (@) na origem */
  atSignAvgWeight: number;
  /** Preço por @ (exceto frete) */
  atSignPrice: number;
  /** Preço total por @ */
  atSignTotalPrice: number;
  /** Peso total em @ */
  atSignTotalWeight: number;
  /** Comprador */
  buyer: string;
  /** Data */
  day: EntranceReportPurchaseItemDay;
  /** Distância (km) */
  distance: number;
  /** Meta de quebra de peso (%) */
  expectedWeightBreak: number;
  /** Horas da GTA */
  hours: number;
  /** Fornecedor (fazenda de origem) */
  origin: string;
  /** Quantidade de animais */
  oxenAmount: number;
  /** Quantidade de animais (%) */
  oxenAmountPercentage: number;
  /** Parceiro */
  partner: string;
  /** Contrato (número do pedido) */
  purchaseName: string;
  /** Quebra de peso real (%) */
  realWeightBreak: number;
  /** Frete por @ */
  shippingAtSignPrice: number;
  /** Preço total em R$ */
  totalPrice: number;
  /** Tipo */
  type: EnumsOxPurpose;
  /** Quebra de peso por @ */
  weightBreakAtSign: number;
  /** Diferença na quebra de peso da meta e real (%) */
  weightBreakDiff: number;
}

export interface EntranceReportFilter {
  end?: string;
  gender?: EnumsOxGender;
  partnerId?: number;
  purchaseName?: string;
  start?: string;
  type?: EnumsOxPurpose;
}

export interface EntranceReportDistanceItem {
  /** Peso médio (@) na origem */
  atSignAvgWeight: number;
  /** Preço por @ (exceto frete) */
  atSignPrice: number;
  /** Preço total por @ */
  atSignTotalPrice: number;
  /** Peso total em @ */
  atSignTotalWeight: number;
  /** Distância (km) */
  distance: number;
  /** Meta de quebra de peso (%) */
  expectedWeightBreak: number;
  /** Horas da GTA */
  hours: number;
  /** Distância inicial da faixa (km) */
  lowerDistance: number;
  /** Quantidade de animais */
  oxenAmount: number;
  /** Quantidade de animais (%) */
  oxenAmountPercentage: number;
  /** Quebra de peso real (%) */
  realWeightBreak: number;
  /** Frete por @ */
  shippingAtSignPrice: number;
  /** Preço total em R$ */
  totalPrice: number;
  /** Distância final da faixa (km) */
  upperDistance: number;
  /** Quebra de peso por @ */
  weightBreakAtSign: number;
  /** Diferença na quebra de peso da meta e real (%) */
  weightBreakDiff: number;
}

export interface EntranceReportCategoryItem {
  /** Peso médio (@) na origem */
  atSignAvgWeight: number;
  /** Preço por @ (exceto frete) */
  atSignPrice: number;
  /** Preço total por @ */
  atSignTotalPrice: number;
  /** Peso total em @ */
  atSignTotalWeight: number;
  /** Categoria */
  category: EnumsOxCategory;
  /** Distância (km) */
  distance: number;
  /** Meta de quebra de peso (%) */
  expectedWeightBreak: number;
  /** Horas da GTA */
  hours: number;
  /** Quantidade de animais */
  oxenAmount: number;
  /** Quantidade de animais (%) */
  oxenAmountPercentage: number;
  /** Quebra de peso real (%) */
  realWeightBreak: number;
  /** Frete por @ */
  shippingAtSignPrice: number;
  /** Preço total em R$ */
  totalPrice: number;
  /** Quebra de peso por @ */
  weightBreakAtSign: number;
  /** Diferença na quebra de peso da meta e real (%) */
  weightBreakDiff: number;
  /** Faixa de peso (@) */
  weightRange: number;
}

export interface EntranceReportBaseItem {
  /** Peso médio (@) na origem */
  atSignAvgWeight: number;
  /** Preço por @ (exceto frete) */
  atSignPrice: number;
  /** Preço total por @ */
  atSignTotalPrice: number;
  /** Peso total em @ */
  atSignTotalWeight: number;
  /** Distância (km) */
  distance: number;
  /** Meta de quebra de peso (%) */
  expectedWeightBreak: number;
  /** Horas da GTA */
  hours: number;
  /** Quantidade de animais */
  oxenAmount: number;
  /** Quantidade de animais (%) */
  oxenAmountPercentage: number;
  /** Quebra de peso real (%) */
  realWeightBreak: number;
  /** Frete por @ */
  shippingAtSignPrice: number;
  /** Preço total em R$ */
  totalPrice: number;
  /** Quebra de peso por @ */
  weightBreakAtSign: number;
  /** Diferença na quebra de peso da meta e real (%) */
  weightBreakDiff: number;
}

export interface EntranceReport {
  categories: EntranceReportCategoryItem[];
  distances: EntranceReportDistanceItem[];
  purchases: EntranceReportPurchaseItem[];
  resume: EntranceReportResume;
}

export type EfficiencyReportResultOxenCount = number | null;

/**
 * Mantém o mesmo nome do tipo legado (`src/models/report-efficiency.ts`) — é o formato de linha que o frontend já consome; renomear geraria um diff de contrato não pedido.
 */
export interface EfficiencyReportResult {
  batch: string;
  batchId: number;
  corral: string;
  day: string;
  diets: string[];
  feeders: string[];
  foreseenWeight: number;
  order: number;
  owners: string[];
  oxenCount: EfficiencyReportResultOxenCount;
  partners: string[];
  realWeight: number;
  sequence: number;
  weightDifference: number;
  weightDifferencePercentage: number;
}

export interface EfficiencyFood {
  daysInStock: number;
  food: string;
  matter: number;
  naturalMatter: number;
  naturalMatterFactor: number;
  naturalMatterPrice: number;
}

export interface EditOxLastTransferResponse {
  action: OxLastTransferAction;
  affected: OxLastTransferAffected;
  after: OxLastTransferSnapshot;
  applied: boolean;
  before: OxLastTransferSnapshot;
  dryRun: boolean;
  oxId: number;
  warnings: string[];
}

export interface EditOxLastTransferBulkResponse {
  action: OxLastTransferAction;
  affected: OxLastTransferAffected;
  after: OxLastTransferSnapshot;
  applied: boolean;
  before: OxLastTransferSnapshot;
  dryRun: boolean;
  oxIds: number[];
  warnings: string[];
}

export interface EditOxLastTransferBulkBody {
  action: OxLastTransferAction;
  destinyBatchId?: number;
  dryRun: boolean;
  originBatchId?: number;
  oxIds: number[];
  transferredAt?: string;
}

export interface EditOxLastTransferBody {
  action: OxLastTransferAction;
  destinyBatchId?: number;
  dryRun: boolean;
  originBatchId?: number;
  transferredAt?: string;
}

export interface EconomicResumeItem {
  admCost: number;
  animalPurchaseCost: number;
  animalPurchaseCostPerCarcass: number;
  averageOtherCosts: number;
  avgDailyGain: number;
  avgDaysOfConfinament: number;
  avgDaysOfTract: number;
  carcass: number;
  carcassGain: number;
  carcassWeightAtSign: number;
  carcassWeightKile: number;
  closedBatches: number;
  dailyCarcassGain: number;
  deaths: number;
  entryLiveWeight: number;
  estimatedWeigthCarcassEntryAtSign: number;
  estimatedWeigthCarcassEntryKile: number;
  exitLiveWeight: number;
  feedEfficiency: number;
  financialFeedback: number;
  foodConversion: number;
  foodCost: number;
  gainFoodCost: number;
  gainManagementCost: number;
  managementCost: number;
  mortality: number;
  oxenEntries: number;
  oxenExits: number;
  pastureReturnOxenAmount: number;
  relatedCorrals: number;
  result: number;
  sellingPrice: number;
  sellingPricePerCarcass: number;
  slaughteredOxen: number;
  veterinarySupplisCost: number;
}

export interface EconomicReportServiceResponse {
  history: EconomicHistoryItem[];
  operationalCostAlerts: OperationalCostAlert[];
  resume: EconomicResumeItem;
}

export type EconomicHistoryItemResults = {
  averageCarcassGain: number;
  averageConfinementDays: number;
  averageDaysWithoutProcessing: number;
  averageOtherCosts: number;
  averageProfit: number;
  averageSaleValuePerArroba: number;
  averageTreatmentDays: number;
  biologicalEfficiency: number;
  dailyOperationalCost: number;
  dailyOxenCost: number;
  deadOxenAmount: number;
  financialReturnRate: number;
  foodConversion: number;
  gainFoodCost: number;
  mortalityRate: number;
  slaughteredOxenAmount: number;
  totalCosts: number;
  totalGainCost: number;
  totalManagementCost: number;
  totalProfit: number;
  totalSaleValue: number;
  totalTreatedDietCost: number;
  totalVeterinarySuppliesCost: number;
};

export type EconomicHistoryItemIdentification = {
  batch: string;
  corral?: string;
};

export type EconomicHistoryItemExitsExitAverageDate = string | null;

export type EconomicHistoryItemExits = {
  averageCarcassPrice: number;
  averageGDC: number;
  averageGPD: number;
  exitAverageCarcassWeight: number;
  exitAverageCarcassWeightAtSign: number;
  exitAverageDate: EconomicHistoryItemExitsExitAverageDate;
  exitAverageWeight: number;
  exitCarcassYield: number;
  pastureReturnOxenAmount: number;
  slaughteredOxenAmount: number;
};

export type EconomicHistoryItemEntries = {
  averageCommission: number;
  averagePurchaseCostPerOxen: number;
  averageShipping: number;
  entryAverageCarcassYield: number;
  initialAverageDate: string;
  initialAverageWeight: number;
  totalEnteredOxenAmount: number;
  transferredInOxenAmount: number;
};

export interface EconomicHistoryItem {
  entries: EconomicHistoryItemEntries;
  exits: EconomicHistoryItemExits;
  identification: EconomicHistoryItemIdentification;
  results: EconomicHistoryItemResults;
}

export interface EarringPurchasesXlsx {
  filename: string;
  ids: number[];
}

export type DownloadVegasIntegrationForSaleOrderResponseAnyOfThree = {
  buffer: null;
};

export type DownloadVegasIntegrationForSaleOrderResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type DownloadVegasIntegrationForSaleOrderResponseAnyOf = {
  buffer: DownloadVegasIntegrationForSaleOrderResponseAnyOfBuffer;
};

export type DownloadVegasIntegrationForSaleOrderResponse =
  | DownloadVegasIntegrationForSaleOrderResponseAnyOf
  | DownloadVegasIntegrationForSaleOrderResponseAnyOfThree;

export interface DownloadVegasIntegrationForSaleOrder {
  filepath: string;
  saleOrderId: number;
}

export type DownloadVegasIntegrationForExitResponseAnyOfThree = {
  buffer: null;
};

export type DownloadVegasIntegrationForExitResponse =
  | DownloadVegasIntegrationForExitResponseAnyOf
  | DownloadVegasIntegrationForExitResponseAnyOfThree;

export type DownloadVegasIntegrationForExitResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type DownloadVegasIntegrationForExitResponseAnyOf = {
  buffer: DownloadVegasIntegrationForExitResponseAnyOfBuffer;
};

export type DownloadVegasIntegrationForEntryResponseAnyOfThree = {
  buffer: null;
};

export type DownloadVegasIntegrationForEntryResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type DownloadVegasIntegrationForEntryResponseAnyOf = {
  buffer: DownloadVegasIntegrationForEntryResponseAnyOfBuffer;
};

export type DownloadVegasIntegrationForEntryResponse =
  | DownloadVegasIntegrationForEntryResponseAnyOf
  | DownloadVegasIntegrationForEntryResponseAnyOfThree;

export type DownloadVegasIntegrationForDeathResponseAnyOfThree = {
  buffer: null;
};

export type DownloadVegasIntegrationForDeathResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type DownloadVegasIntegrationForDeathResponseAnyOf = {
  buffer: DownloadVegasIntegrationForDeathResponseAnyOfBuffer;
};

export type DownloadVegasIntegrationForDeathResponse =
  | DownloadVegasIntegrationForDeathResponseAnyOf
  | DownloadVegasIntegrationForDeathResponseAnyOfThree;

export type DownloadVegasIntegrationForBirthResponseAnyOfThree = {
  buffer: null;
};

export type DownloadVegasIntegrationForBirthResponseAnyOfBuffer =
  | string
  | GlobalBuffer;

export type DownloadVegasIntegrationForBirthResponseAnyOf = {
  buffer: DownloadVegasIntegrationForBirthResponseAnyOfBuffer;
};

export type DownloadVegasIntegrationForBirthResponse =
  | DownloadVegasIntegrationForBirthResponseAnyOf
  | DownloadVegasIntegrationForBirthResponseAnyOfThree;

export interface DownloadVegasIntegration {
  announcementId: number;
  filepath: string;
}

export type Disease = EnumsDisease;

export interface DisableMixerResponse {
  active: boolean;
  code: number;
  createdAt: string;
  distributor: boolean;
  farmId: number;
  id: number;
  mixer: boolean;
  mixerType: EnumsMixerType;
  mixTime: string;
  name: string;
  rounding: number;
}

export type DietTransitionListViewResponseItemEndsAt = string | null;

export type DietTransitionListViewResponseItem = {
  batchId: number;
  currentPhase: number;
  endingDietId: number;
  endingFormulation: string;
  endsAt: DietTransitionListViewResponseItemEndsAt;
  name?: string;
  startedAt: string;
  startingFormulation?: string;
  totalPhase: number;
  transitionId: number;
  transitionName: string;
};

export type DietTransitionListViewResponse =
  DietTransitionListViewResponseItem[];

/**
 * Uma alteração do preço por kg de MS da dieta. Cada linha vale da sua data até a próxima.
 */
export interface DietPriceEntry {
  date: string;
  id: number;
  kiloPriceDM: number;
  retroactive: boolean;
}

export interface DietPriceHistory {
  entries: DietPriceEntry[];
  manualPrice: boolean;
}

export interface DietFilter {
  active?: boolean;
  category?: EnumsDietCategory;
  inUse?: boolean;
  isPremix?: boolean;
}

export type DietCategory = EnumsDietCategory;

export type DentitionStage = EnumsDentitionStage;

export type DeletePurchaseResponseReceivedAt = string | null;

export type DeletePurchaseResponsePartnerHerd = string | null;

export type DeletePurchaseResponseObservation = string | null;

export type DeletePurchaseResponseEarringsPerPage = number | null;

export interface DeletePurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: DeletePurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: DeletePurchaseResponseObservation;
  partnerHerd: DeletePurchaseResponsePartnerHerd;
  price: number;
  receivedAt: DeletePurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export type DeleteManagementSessionResponseFinishedById = number | null;

export interface DeleteManagementSessionResponse {
  createdAt: string;
  data: unknown;
  farmId: number;
  finishedById: DeleteManagementSessionResponseFinishedById;
  id: number;
  name: string;
  status: EnumsManagementStatus;
  type: EnumsTypeManagement;
  updatedAt: string;
  uuid: string;
}

export type DeleteGtaResponseWeightingMapId = number | null;

export type DeleteGtaResponseWeightAverage = number | null;

export type DeleteGtaResponsePurchaseId = number | null;

export type DeleteGtaResponseOriginWeightAverage = number | null;

export type DeleteGtaResponseInvoice = string | null;

export type DeleteGtaResponseHours = number | null;

export type DeleteGtaResponseDistance = number | null;

export type DeleteGtaResponseDestinyId = number | null;

export type DeleteGtaResponseDescription = string | null;

export interface DeleteGtaResponse {
  completed: boolean;
  description: DeleteGtaResponseDescription;
  destinyId: DeleteGtaResponseDestinyId;
  distance: DeleteGtaResponseDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: DeleteGtaResponseHours;
  id: number;
  invoice: DeleteGtaResponseInvoice;
  number: string;
  originId: number;
  originWeightAverage: DeleteGtaResponseOriginWeightAverage;
  purchaseId: DeleteGtaResponsePurchaseId;
  series: string;
  weightAverage: DeleteGtaResponseWeightAverage;
  weightingMapId: DeleteGtaResponseWeightingMapId;
}

export type DeleteAnnouncementResponseExpiresAt = string | null;

export type DeleteAnnouncementResponseEmittedAt = string | null;

export type DeleteAnnouncementResponseCreatedAt = string | null;

export interface DeleteAnnouncementResponse {
  createdAt: DeleteAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: DeleteAnnouncementResponseEmittedAt;
  expiresAt: DeleteAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export type DeathNecropsy = EnumsDeathNecropsy;

export type DeathCause = EnumsDeathCause;

/**
 * Inicio tratamento
 */
export type DeathAnnouncementStartOfTreatment = string | null;

/**
 * Motivo da Morte
 */
export type DeathAnnouncementDeathReason = EnumsDeathCause | null;

export interface DeathAnnouncement {
  /** Se a morte foi acidental */
  accidental: boolean;
  cause: EnumsDeathCause;
  /** Dia da morte */
  date: string;
  /** Motivo da Morte */
  deathReason?: DeathAnnouncementDeathReason;
  /** Necrópsia */
  isNecropsyPerformed?: boolean;
  necropsy: EnumsDeathNecropsy;
  observation?: string;
  otherDeathCause?: string;
  sisbov?: number;
  /** Inicio tratamento */
  startOfTreatment?: DeathAnnouncementStartOfTreatment;
}

export interface DeactivateCattleManifestLayoutResponse {
  unlinkedEstablishmentIds: number[];
}

export interface DailyFoodReportDayItem {
  dailyFoodCost: number;
  date: string;
}

export type DailyFoodReportServiceResponse = DailyFoodReportDayItem[];

export type CreateWeightingMapResponseTotalWeight = number | null;

export type CreateWeightingMapResponseTotalPurchase = number | null;

export type CreateWeightingMapResponseSupplementedRearingModality =
  EnumsSupplementedRearingModality | null;

export type CreateWeightingMapResponseStartTime = string | null;

export type CreateWeightingMapResponseReferenceCode = string | null;

export type CreateWeightingMapResponsePurchaseId = number | null;

export type CreateWeightingMapResponsePricePerArroba = number | null;

export type CreateWeightingMapResponseNetWeight = number | null;

export interface CreateWeightingMapResponse {
  averageWeight: CreateWeightingMapResponseAverageWeight;
  buyer: CreateWeightingMapResponseBuyer;
  buyerId: number;
  carcassYield: CreateWeightingMapResponseCarcassYield;
  closingTime: CreateWeightingMapResponseClosingTime;
  commission: number;
  emissionDate: string;
  endTime: CreateWeightingMapResponseEndTime;
  farmId: number;
  fastingDate: CreateWeightingMapResponseFastingDate;
  grossWeight: CreateWeightingMapResponseGrossWeight;
  gtas: CreateWeightingMapResponseGtasItem[];
  id: number;
  invoices: CreateWeightingMapResponseInvoicesItem[];
  netWeight: CreateWeightingMapResponseNetWeight;
  pricePerArroba: CreateWeightingMapResponsePricePerArroba;
  purchaseId: CreateWeightingMapResponsePurchaseId;
  referenceCode: CreateWeightingMapResponseReferenceCode;
  shippingCost: number;
  startTime: CreateWeightingMapResponseStartTime;
  status: EnumsWeightingMapStatus;
  supplementedRearingModality: CreateWeightingMapResponseSupplementedRearingModality;
  totalPurchase: CreateWeightingMapResponseTotalPurchase;
  totalWeight: CreateWeightingMapResponseTotalWeight;
  weighingDate: string;
}

export type CreateWeightingMapResponseInvoicesItemWeightingMapId =
  | number
  | null;

export type CreateWeightingMapResponseInvoicesItemSaleOrderId = number | null;

export type CreateWeightingMapResponseInvoicesItemIsComplement = boolean | null;

export type CreateWeightingMapResponseInvoicesItemExitTruckId = number | null;

export type CreateWeightingMapResponseInvoicesItemEmittedAt = string | null;

export type CreateWeightingMapResponseInvoicesItem = {
  emittedAt: CreateWeightingMapResponseInvoicesItemEmittedAt;
  exitTruckId: CreateWeightingMapResponseInvoicesItemExitTruckId;
  farmId: number;
  id: number;
  isComplement: CreateWeightingMapResponseInvoicesItemIsComplement;
  number: string;
  saleOrderId: CreateWeightingMapResponseInvoicesItemSaleOrderId;
  series: string;
  value: number;
  weightingMapId: CreateWeightingMapResponseInvoicesItemWeightingMapId;
};

export type CreateWeightingMapResponseGtasItemWeightingMapId = number | null;

export type CreateWeightingMapResponseGtasItemWeightAverage = number | null;

export type CreateWeightingMapResponseGtasItemPurchaseId = number | null;

export type CreateWeightingMapResponseGtasItemOriginWeightAverage =
  | number
  | null;

export type CreateWeightingMapResponseGtasItemInvoice = string | null;

export type CreateWeightingMapResponseGtasItemHours = number | null;

export type CreateWeightingMapResponseGtasItemDistance = number | null;

export type CreateWeightingMapResponseGtasItemDestinyId = number | null;

export type CreateWeightingMapResponseGtasItemDescription = string | null;

export type CreateWeightingMapResponseGtasItem = {
  completed: boolean;
  description: CreateWeightingMapResponseGtasItemDescription;
  destinyId: CreateWeightingMapResponseGtasItemDestinyId;
  distance: CreateWeightingMapResponseGtasItemDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: CreateWeightingMapResponseGtasItemHours;
  id: number;
  invoice: CreateWeightingMapResponseGtasItemInvoice;
  number: string;
  originId: number;
  originWeightAverage: CreateWeightingMapResponseGtasItemOriginWeightAverage;
  purchaseId: CreateWeightingMapResponseGtasItemPurchaseId;
  series: string;
  weightAverage: CreateWeightingMapResponseGtasItemWeightAverage;
  weightingMapId: CreateWeightingMapResponseGtasItemWeightingMapId;
};

export type CreateWeightingMapResponseGrossWeight = number | null;

export type CreateWeightingMapResponseFastingDate = string | null;

export type CreateWeightingMapResponseEndTime = string | null;

export type CreateWeightingMapResponseClosingTime = string | null;

export type CreateWeightingMapResponseCarcassYield = number | null;

export type CreateWeightingMapResponseBuyerPhone = string | null;

export type CreateWeightingMapResponseBuyerDocument = string | null;

export type CreateWeightingMapResponseBuyerDescription = string | null;

export type CreateWeightingMapResponseBuyerCode = string | null;

export type CreateWeightingMapResponseBuyer = {
  code: CreateWeightingMapResponseBuyerCode;
  createdAt: string;
  description: CreateWeightingMapResponseBuyerDescription;
  document: CreateWeightingMapResponseBuyerDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: CreateWeightingMapResponseBuyerPhone;
  profiles: EnumsProfile[];
};

export type CreateWeightingMapResponseAverageWeight = number | null;

export type CreateUnusabilityAnnouncementResponseExpiresAt = string | null;

export type CreateUnusabilityAnnouncementResponseEmittedAt = string | null;

export type CreateUnusabilityAnnouncementResponseCreatedAt = string | null;

export interface CreateUnusabilityAnnouncementResponse {
  createdAt: CreateUnusabilityAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: CreateUnusabilityAnnouncementResponseEmittedAt;
  expiresAt: CreateUnusabilityAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export interface CreateUnusabilityAnnouncement {
  brand: string;
  observation?: string;
  sisbov: number;
}

export type CreateTruckResponseSaleOrderId = number | null;

export type CreateTruckResponseSaleId = number | null;

export type CreateTruckResponsePlate = string | null;

export type CreateTruckResponseName = string | null;

export type CreateTruckResponseInfo = string | null;

export type CreateTruckResponseHoldingSaleId = number | null;

export type CreateTruckResponseExitGtaSeries = string | null;

export type CreateTruckResponseExitGta = string | null;

export type CreateTruckResponseDestinyId = number | null;

export interface CreateTruckResponse {
  announcementId: CreateTruckResponseAnnouncementId;
  bigWeighingMachineWeightKg: CreateTruckResponseBigWeighingMachineWeightKg;
  boarding: CreateTruckResponseBoardingItem[];
  capacity: number;
  destinyId: CreateTruckResponseDestinyId;
  exitAt: string;
  exitGta: CreateTruckResponseExitGta;
  exitGtaSeries: CreateTruckResponseExitGtaSeries;
  farmId: number;
  holdingSaleId: CreateTruckResponseHoldingSaleId;
  id: number;
  info: CreateTruckResponseInfo;
  isVisible: boolean;
  name: CreateTruckResponseName;
  plate: CreateTruckResponsePlate;
  reason: EnumsExitReason;
  saleId: CreateTruckResponseSaleId;
  saleOrderId: CreateTruckResponseSaleOrderId;
  status: EnumsExitTruckStatus;
}

export type CreateTruckResponseBoardingItemWeightsItemType =
  EnumsWeightType | null;

export type CreateTruckResponseBoardingItemWeightsItem = {
  date: string;
  id: number;
  oxId: number;
  source: EnumsWeightSource;
  type: CreateTruckResponseBoardingItemWeightsItemType;
  weight: number;
};

export type CreateTruckResponseBoardingItemStartOfTreatment = string | null;

export type CreateTruckResponseBoardingItemSisbov = string | null;

export type CreateTruckResponseBoardingItemSalesMarketType =
  EnumsSalesMarketType | null;

export type CreateTruckResponseBoardingItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type CreateTruckResponseBoardingItemReversedDeathDetails = string | null;

export type CreateTruckResponseBoardingItemReversedDeathDate = string | null;

export type CreateTruckResponseBoardingItemReversedDeathCause =
  EnumsDeathCause | null;

export type CreateTruckResponseBoardingItemPurchaseId = number | null;

export type CreateTruckResponseBoardingItemPriceAtSignExit = number | null;

export type CreateTruckResponseBoardingItemPriceAtSignEntry = number | null;

export type CreateTruckResponseBoardingItemOtherDeathCause = string | null;

export type CreateTruckResponseBoardingItemIsNecropsyPerformed = boolean | null;

export type CreateTruckResponseBoardingItemInvoice = string | null;

export type CreateTruckResponseBoardingItemInternalSaleId = number | null;

export type CreateTruckResponseBoardingItemIdentifier = string | null;

export type CreateTruckResponseBoardingItemIdentifiedAt = string | null;

export type CreateTruckResponseBoardingItemIdentificationSource =
  EnumsIdentificationSource | null;

export type CreateTruckResponseBoardingItemHasBirthAnnouncement =
  | boolean
  | null;

export type CreateTruckResponseBoardingItemGtaId = number | null;

export type CreateTruckResponseBoardingItemExitTruckId = number | null;

export type CreateTruckResponseBoardingItemElectronic = string | null;

export type CreateTruckResponseBoardingItemDiedAt = string | null;

export type CreateTruckResponseBoardingItemDentitionStage =
  EnumsDentitionStage | null;

export type CreateTruckResponseBoardingItemDeathReason = EnumsDeathCause | null;

export type CreateTruckResponseBoardingItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type CreateTruckResponseBoardingItemDeathDetails = string | null;

export type CreateTruckResponseBoardingItemDeathCause = EnumsDeathCause | null;

export type CreateTruckResponseBoardingItemComments = string | null;

export type CreateTruckResponseBoardingItemCertifierDate = string | null;

export type CreateTruckResponseBoardingItemCattleManifestId = number | null;

export type CreateTruckResponseBoardingItemCarcassWeight = number | null;

export type CreateTruckResponseBoardingItemCarcassType =
  EnumsCarcassType | null;

export type CreateTruckResponseBoardingItemCarcassPrice = number | null;

export type CreateTruckResponseBoardingItemCarcass = number | null;

export type CreateTruckResponseBoardingItemBornOnFarm = boolean | null;

export type CreateTruckResponseBoardingItemBndTracked = boolean | null;

export type CreateTruckResponseBoardingItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: CreateTruckResponseBoardingItemBndTracked;
  bornOnFarm: CreateTruckResponseBoardingItemBornOnFarm;
  breed: string;
  carcass: CreateTruckResponseBoardingItemCarcass;
  carcassPrice: CreateTruckResponseBoardingItemCarcassPrice;
  carcassType: CreateTruckResponseBoardingItemCarcassType;
  carcassWeight: CreateTruckResponseBoardingItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: CreateTruckResponseBoardingItemCattleManifestId;
  certifierDate: CreateTruckResponseBoardingItemCertifierDate;
  comments: CreateTruckResponseBoardingItemComments;
  deathCause: CreateTruckResponseBoardingItemDeathCause;
  deathDetails: CreateTruckResponseBoardingItemDeathDetails;
  deathNecropsy: CreateTruckResponseBoardingItemDeathNecropsy;
  deathReason: CreateTruckResponseBoardingItemDeathReason;
  dentitionStage: CreateTruckResponseBoardingItemDentitionStage;
  diedAt: CreateTruckResponseBoardingItemDiedAt;
  electronic: CreateTruckResponseBoardingItemElectronic;
  exitTruckId: CreateTruckResponseBoardingItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: CreateTruckResponseBoardingItemGtaId;
  hasBirthAnnouncement: CreateTruckResponseBoardingItemHasBirthAnnouncement;
  id: number;
  identificationSource: CreateTruckResponseBoardingItemIdentificationSource;
  identifiedAt: CreateTruckResponseBoardingItemIdentifiedAt;
  identifier: CreateTruckResponseBoardingItemIdentifier;
  includedAt: string;
  internalSaleId: CreateTruckResponseBoardingItemInternalSaleId;
  invoice: CreateTruckResponseBoardingItemInvoice;
  isNecropsyPerformed: CreateTruckResponseBoardingItemIsNecropsyPerformed;
  otherDeathCause: CreateTruckResponseBoardingItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: CreateTruckResponseBoardingItemPriceAtSignEntry;
  priceAtSignExit: CreateTruckResponseBoardingItemPriceAtSignExit;
  purchaseId: CreateTruckResponseBoardingItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: CreateTruckResponseBoardingItemReversedDeathCause;
  reversedDeathDate: CreateTruckResponseBoardingItemReversedDeathDate;
  reversedDeathDetails: CreateTruckResponseBoardingItemReversedDeathDetails;
  reversedDeathNecropsy: CreateTruckResponseBoardingItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: CreateTruckResponseBoardingItemSalesMarketType;
  sisbov: CreateTruckResponseBoardingItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: CreateTruckResponseBoardingItemStartOfTreatment;
  variety: string;
  weights: CreateTruckResponseBoardingItemWeightsItem[];
};

export type CreateTruckResponseBigWeighingMachineWeightKg = number | null;

export type CreateTruckResponseAnnouncementId = number | null;

export interface CreateTruck {
  bigWeighingMachineWeightKg?: number;
  capacity: number;
  destinyId?: number;
  exitGta?: string;
  exitGtaSeries?: string;
  info?: string;
  invoicesIds?: number[];
  name?: string;
  plate?: string;
}

export interface CreateTreatmentResponse {
  active: boolean;
  createdAt: string;
  divisions: number[];
  farmId: number;
  hours: string[];
  id: number;
  name: string;
}

export interface CreateTreatment {
  divisions: number[];
  hours?: string[];
  name: string;
}

export interface CreateStructureResponse {
  category: EnumsStructureCategory;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
}

export interface CreateStructure {
  category: EnumsStructureCategory;
  name: string;
}

export type CreateStockResponsePremix = boolean | null;

export type CreateStockResponseActive = boolean | null;

export interface CreateStockResponse {
  active: CreateStockResponseActive;
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: CreateStockResponsePremix;
  supplement: boolean;
}

export type CreateStockRelativeTo = number | string;

export interface CreateStock {
  code: string;
  /** Energia Liquida de Ganho */
  elg?: number;
  /** Energia Liquida de Manuntenção */
  elm?: number;
  kiloPrice?: number;
  name: string;
  naturalMatterFactor?: number;
  relativeTo: CreateStockRelativeTo;
  supplement?: boolean;
}

export type CreateSaleOrderResponseTypeOfClosed = EnumsSaleOrderType | null;

export type CreateSaleOrderResponseSourceType = EnumsSaleOrderSourceType | null;

export type CreateSaleOrderResponsePartnerClosureId = number | null;

export type CreateSaleOrderResponsePartnerAtSignPriceM = number | null;

export type CreateSaleOrderResponsePartnerAtSignPriceF = number | null;

export type CreateSaleOrderResponseFreightPerAtSignBRL = number | null;

export type CreateSaleOrderResponseBonusPercent = number | null;

export type CreateSaleOrderResponseAtSignPrice = number | null;

export type CreateSaleOrderResponseAnnouncementId = number | null;

export interface CreateSaleOrderResponse {
  announcementId: CreateSaleOrderResponseAnnouncementId;
  atSignPrice: CreateSaleOrderResponseAtSignPrice;
  bonusPercent: CreateSaleOrderResponseBonusPercent;
  createdAt: string;
  createdBy: number;
  destinyId: number;
  expirationDay: string;
  farmId: number;
  freightPerAtSignBRL: CreateSaleOrderResponseFreightPerAtSignBRL;
  id: number;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF: CreateSaleOrderResponsePartnerAtSignPriceF;
  partnerAtSignPriceM: CreateSaleOrderResponsePartnerAtSignPriceM;
  partnerClosureId: CreateSaleOrderResponsePartnerClosureId;
  paymentMethod: string;
  saleDate: string;
  sourceType: CreateSaleOrderResponseSourceType;
  status: EnumsSaleOrderStatus;
  typeOfClosed: CreateSaleOrderResponseTypeOfClosed;
}

export type CreateSaleOrderRequestFreightPerAtSignBRL = number | null;

/**
 * Bônus (%) sobre o valor da venda
 */
export type CreateSaleOrderRequestBonusPercent = number | null;

export type CreateSaleOrderRequestAtSignPrice = number | null;

export interface CreateSaleOrderRequest {
  atSignPrice?: CreateSaleOrderRequestAtSignPrice;
  /** Bônus (%) sobre o valor da venda */
  bonusPercent?: CreateSaleOrderRequestBonusPercent;
  complementInvoiceIds?: number[];
  complementInvoices?: CreateInvoice[];
  destinyId: number;
  exitTrucksIds: number[];
  expirationDay: string;
  freightPerAtSignBRL?: CreateSaleOrderRequestFreightPerAtSignBRL;
  orderName: string;
  orderNumber: number;
  partnerAtSignPriceF?: number;
  partnerAtSignPriceM?: number;
  paymentMethod: string;
  saleDate: string;
  status?: EnumsSaleOrderStatus;
}

export interface CreateSaleFromExcelResult {
  exitTruckId: number;
  oxenAmount: number;
  saleOrderId: number;
}

export type CreateSaleFromExcelBodyOxenExitWeightsItem = {
  oxId: number;
  weight: number;
};

export interface CreateSaleFromExcelBody {
  atSignPrice: number;
  buyerId: number;
  dueDate: string;
  exitWeightAverage?: number;
  freightPriceAt: number;
  oxenExitWeights?: CreateSaleFromExcelBodyOxenExitWeightsItem[];
  oxenIds: number[];
  paymentMethod: string;
  saleDate: string;
  saleName: string;
  saleNumber: string;
}

export type CreateSaleAnnouncementResponseExpiresAt = string | null;

export type CreateSaleAnnouncementResponseEmittedAt = string | null;

export type CreateSaleAnnouncementResponseCreatedAt = string | null;

export interface CreateSaleAnnouncementResponse {
  createdAt: CreateSaleAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: CreateSaleAnnouncementResponseEmittedAt;
  expiresAt: CreateSaleAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export interface CreateRecipeResponse {
  capacityMn: number;
  code: number;
  createdAt: string;
  dietId: number;
  farmId: number;
  id: number;
  mixerId: number;
}

export interface CreateRecipe {
  capacityMn: number;
  code: number;
  dietId: number;
  mixerId: number;
}

export type CreateReIdentificationAnnouncementResponseExpiresAt = string | null;

export type CreateReIdentificationAnnouncementResponseEmittedAt = string | null;

export type CreateReIdentificationAnnouncementResponseCreatedAt = string | null;

export interface CreateReIdentificationAnnouncementResponse {
  createdAt: CreateReIdentificationAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: CreateReIdentificationAnnouncementResponseEmittedAt;
  expiresAt: CreateReIdentificationAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export interface CreateReIdentificationAnnouncement {
  createdAt?: string;
  newSisbov: number;
  oldSisbov: number;
  oxId: number;
}

export type CreatePremixStockIngredientsItem = {
  percentage: number;
  stockId: number;
};

export interface CreatePremixStock {
  dietCode: string;
  ingredients: CreatePremixStockIngredientsItem[];
  name: string;
  reflect: boolean;
  /** Código do estoque da pré-mistura (ALIM_COD): alfanumérico A–Z / 0–9, com espaços opcionais entre caracteres. */
  stockCode: string;
}

export type CreatePremixResponsePremix = boolean | null;

export type CreatePremixResponseChangesItemDescription = string | null;

export type CreatePremixResponseChangesItem = {
  date: string;
  description: CreatePremixResponseChangesItemDescription;
  elg: number;
  elm: number;
  id: number;
  kiloPrice: number;
  naturalMatterFactor: number;
  stockId: number;
};

export type CreatePremixResponseActive = boolean | null;

export interface CreatePremixResponse {
  active: CreatePremixResponseActive;
  changes: CreatePremixResponseChangesItem[];
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: CreatePremixResponsePremix;
  supplement: boolean;
}

export type CreatePersonResponsePhone = string | null;

export type CreatePersonResponseDocument = string | null;

export type CreatePersonResponseDescription = string | null;

export type CreatePersonResponseCode = string | null;

export interface CreatePersonResponse {
  code: CreatePersonResponseCode;
  createdAt: string;
  description: CreatePersonResponseDescription;
  document: CreatePersonResponseDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: CreatePersonResponsePhone;
  profiles: EnumsProfile[];
}

export type CreatePersonUserPassword = string | null;

export type CreatePersonUserEmail = string | null;

export type CreatePersonUser = {
  email: CreatePersonUserEmail;
  gov?: GlobalPrismaJsonGovDocuments;
  password: CreatePersonUserPassword;
};

export interface CreatePerson {
  /** Código do funcionário no tracer */
  code?: string;
  description?: string;
  document?: string;
  imageUrl?: string;
  name: string;
  phone?: string;
  profiles: EnumsProfile[];
  user?: CreatePersonUser;
}

export type CreatePartnerClosureV2ResponseObservation = string | null;

export interface CreatePartnerClosureV2Response {
  closingDate: string;
  createdAt: string;
  farmId: number;
  finalValue: number;
  id: number;
  observation: CreatePartnerClosureV2ResponseObservation;
  oxenPurchaseId: number;
  type: EnumsPartnerClosureV2Type;
}

export interface CreatePartnerClosureResponse {
  createdAt: string;
  farmId: number;
  finalSalePrice: number;
  id: number;
  oxenPurchaseId: number;
}

export interface CreatePartnerClosureFatCattleQuoteData {
  /** DATAGRO (referência B3 por dia) ou INTERNAL (mercado interno por frigorífico) */
  kind: string;
  /** Rótulo (frigorífico do mercado interno) */
  label?: string;
  /** Cotação da @ (R$) */
  price: number;
  /** Data da cotação (ISO date, Datagro) */
  quoteDate?: string;
}

export interface CreatePartnerClosureFatCattleLotData {
  /** Cabeças do lote */
  amount: number;
  /** Bônus (%) sobre a venda */
  bonusPercent?: number;
  /** Peso total de carcaça (kg) */
  carcassKg: number;
  /** Frete por arroba (R$/@) */
  freightPerAtSign?: number;
  /** Identificação do lote / ordem de venda */
  lotRef?: string;
  /** Faturamento da nota do frigorífico (R$) */
  revenue: number;
}

export interface CreatePartnerClosureFatCattleData {
  /** Desconto do parceiro (%) */
  discountPercent?: number;
  exitAtSignPrice?: number;
  /** Frete cobrado por arroba (R$/@) */
  freightAtSignPrice?: number;
  /** Custo por viagem (R$) */
  freightCostPerTrip?: number;
  /** Custo de desvio de rota por viagem (R$) */
  freightDetourPerTrip?: number;
  /** Peso vivo total transportado (kg) */
  freightTotalWeightKg?: number;
  /** Quantidade de cabeças transportadas pela Captar */
  freightTransportedAmount?: number;
  /** Número de viagens */
  freightTrips?: number;
  lots?: CreatePartnerClosureFatCattleLotData[];
  /** Data de pagamento (ISO date) — default calculado: abate + prazo */
  paymentDate?: string;
  /** Prazo de pagamento (dias, default 15) */
  paymentDays?: number;
  quotes?: CreatePartnerClosureFatCattleQuoteData[];
  /** Taxa Senar (%) — ex.: 0.2 = 0,2% */
  senarPercent?: number;
  /** Data do abate (ISO date) */
  slaughterDate?: string;
  /** Frigorífico do abate (nome, selecionado do cadastro de estabelecimentos) */
  slaughterhouse?: string;
}

export interface CreatePartnerClosureClassicSlaughterData {
  /** Data da antecipação (ISO date), se houve */
  advanceDate?: string;
  /** Cabeças do abate */
  amount: number;
  /** Contrato/romaneio da linha */
  contractRef?: string;
  /** Override manual da correção (R$) */
  correctionOverride?: number;
  /** Desconto (%) da linha */
  discountPercent?: number;
  /** MI (mercado interno) ou EXP (exportação) */
  marketType?: string;
  /** Data de pagamento (ISO date) — default calculado, editável */
  paymentDate?: string;
  /** R$/@ físico negociado */
  physicalAtSignPrice: number;
  /** Recebimento do frigorífico (ISO date) — default calculado, editável */
  receiptDate?: string;
  /** Data do abate (ISO date) */
  slaughterDate: string;
  slaughterhouse?: string;
}

export interface CreatePartnerClosureClassicData {
  bonusPercent?: number;
  /** Rendimento de carcaça fixo do contrato (%, ex.: 50 = 50%) */
  carcassYield?: number;
  /** Quantidade contratada (cab.) */
  contractedAmount?: number;
  /** Número do contrato de parceria (CTR) */
  contractNumber?: string;
  /** Taxa de correção/antecipação (% a.m.) — ex.: 2.5 = 2,5% */
  correctionPercent?: number;
  discountPercent?: number;
  exitAtSignPrice?: number;
  femaleExitCarcassYield?: number;
  maleExitCarcassYield?: number;
  /** Prazo de pagamento (dias) */
  paymentDays?: number;
  /** Prazo de recebimento do frigorífico (dias) */
  receiptDays?: number;
  /** Taxa Senar (%) — ex.: 0.2 = 0,2% */
  senarPercent?: number;
  slaughters?: CreatePartnerClosureClassicSlaughterData[];
  /** Peso vivo total de entrada (kg) */
  totalEntryLiveWeight?: number;
}

export interface CreatePartnerClosureBoitelData {
  atSignPrice: number;
  dailyRate: number;
  /** Valor da @ travada (R$/@) */
  lockedAtSignPrice?: number;
  /** Taxa da trava (R$/@) */
  lockedFee?: number;
  /** Data de pagamento do parceiro (ISO date) */
  partnerPaymentDate?: string;
  /** Custo sanitário (R$/cab.) */
  sanitaryCost?: number;
  /** Taxa Senar (%) — ex.: 0.2 = 0,2% */
  senarPercent?: number;
  totalAtSign: number;
  totalDays: number;
  /** Total travado (@) */
  totalLockedAtSign?: number;
}

export interface CreatePartnerClosureV2Request {
  boitel?: CreatePartnerClosureBoitelData;
  classic?: CreatePartnerClosureClassicData;
  closingDate: string;
  fatCattle?: CreatePartnerClosureFatCattleData;
  finalValue: number;
  observation?: string;
  oxenPurchaseId: number;
}

export type CreateOxenPurchaseResponseReceivedAt = string | null;

export type CreateOxenPurchaseResponsePartnerHerd = string | null;

export interface CreateOxenPurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: CreateOxenPurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: CreateOxenPurchaseResponseObservation;
  oxen: CreateOxenPurchaseResponseOxen;
  partnerHerd: CreateOxenPurchaseResponsePartnerHerd;
  price: number;
  receivedAt: CreateOxenPurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export type CreateOxenPurchaseResponseOxenWeighingAt = string | null;

export type CreateOxenPurchaseResponseOxenPartnerId = number | null;

export type CreateOxenPurchaseResponseOxenOxenAmount = number | null;

export type CreateOxenPurchaseResponseOxenMapa = string | null;

export type CreateOxenPurchaseResponseOxenMaleProducedPrice = number | null;

export type CreateOxenPurchaseResponseOxenMaleFutureAnimalPrice = number | null;

export type CreateOxenPurchaseResponseOxenMaleEntryCarcassYield = number | null;

export type CreateOxenPurchaseResponseOxenMaleDailyPrice = number | null;

export type CreateOxenPurchaseResponseOxenFemaleProducedPrice = number | null;

export type CreateOxenPurchaseResponseOxenFemaleFutureAnimalPrice =
  | number
  | null;

export type CreateOxenPurchaseResponseOxenFemaleEntryCarcassYield =
  | number
  | null;

export type CreateOxenPurchaseResponseOxenFemaleDailyPrice = number | null;

export type CreateOxenPurchaseResponseOxenDiscountPercent = number | null;

export type CreateOxenPurchaseResponseOxen = {
  buyerId: number;
  commission: number;
  discountPercent: CreateOxenPurchaseResponseOxenDiscountPercent;
  femaleDailyPrice: CreateOxenPurchaseResponseOxenFemaleDailyPrice;
  femaleEntryCarcassYield: CreateOxenPurchaseResponseOxenFemaleEntryCarcassYield;
  femaleFutureAnimalPrice: CreateOxenPurchaseResponseOxenFemaleFutureAnimalPrice;
  femaleProducedPrice: CreateOxenPurchaseResponseOxenFemaleProducedPrice;
  id: number;
  maleDailyPrice: CreateOxenPurchaseResponseOxenMaleDailyPrice;
  maleEntryCarcassYield: CreateOxenPurchaseResponseOxenMaleEntryCarcassYield;
  maleFutureAnimalPrice: CreateOxenPurchaseResponseOxenMaleFutureAnimalPrice;
  maleProducedPrice: CreateOxenPurchaseResponseOxenMaleProducedPrice;
  mapa: CreateOxenPurchaseResponseOxenMapa;
  ownerId: number;
  oxenAmount: CreateOxenPurchaseResponseOxenOxenAmount;
  partnerId: CreateOxenPurchaseResponseOxenPartnerId;
  purchaseCalculationType: EnumsPurchaseCalculationType;
  purchaseId: number;
  purpose: EnumsOxPurpose;
  shipping: number;
  traceable: boolean;
  weighingAt: CreateOxenPurchaseResponseOxenWeighingAt;
  weightAverage: number;
};

export type CreateOxenPurchaseResponseObservation = string | null;

export type CreateOxenPurchaseResponseEarringsPerPage = number | null;

export interface CreateOxenPurchase {
  buyerId: number;
  commission: number;
  /** Desconto (%) aplicado na parceria */
  discountPercent?: number;
  femaleDailyPrice?: number;
  femaleEntryCarcassYield?: number;
  femaleFutureAnimalPrice?: number;
  femaleProducedPrice?: number;
  gtaIds?: number[];
  invoice: string;
  issuedAt: string;
  maleDailyPrice?: number;
  maleEntryCarcassYield?: number;
  maleFutureAnimalPrice?: number;
  maleProducedPrice?: number;
  mapa?: string;
  name: string;
  observation?: string;
  ownerId: number;
  oxenAmount: number;
  partnerHerd?: string;
  partnerId?: number;
  price: number;
  purpose: EnumsOxPurpose;
  series: string;
  shipping: number;
  traceable: boolean;
  weighingAt?: string;
  weightAverage: number;
  weightingMapIds?: number[];
}

export type CreateOxResponseStartOfTreatment = string | null;

export type CreateOxResponseSisbov = string | null;

export type CreateOxResponseSalesMarketType = EnumsSalesMarketType | null;

export type CreateOxResponseReversedDeathNecropsy = EnumsDeathNecropsy | null;

export type CreateOxResponseReversedDeathDetails = string | null;

export type CreateOxResponseReversedDeathDate = string | null;

export type CreateOxResponseReversedDeathCause = EnumsDeathCause | null;

export type CreateOxResponsePurchaseId = number | null;

export type CreateOxResponsePriceAtSignExit = number | null;

export type CreateOxResponsePriceAtSignEntry = number | null;

export type CreateOxResponseOtherDeathCause = string | null;

export type CreateOxResponseIsNecropsyPerformed = boolean | null;

export type CreateOxResponseInvoice = string | null;

export type CreateOxResponseInternalSaleId = number | null;

export type CreateOxResponseIdentifier = string | null;

export type CreateOxResponseIdentifiedAt = string | null;

export type CreateOxResponseIdentificationSource =
  EnumsIdentificationSource | null;

export type CreateOxResponseHasBirthAnnouncement = boolean | null;

export type CreateOxResponseGtaId = number | null;

export type CreateOxResponseExitTruckId = number | null;

export type CreateOxResponseElectronic = string | null;

export type CreateOxResponseDiedAt = string | null;

export type CreateOxResponseDentitionStage = EnumsDentitionStage | null;

export type CreateOxResponseDeathReason = EnumsDeathCause | null;

export type CreateOxResponseDeathNecropsy = EnumsDeathNecropsy | null;

export type CreateOxResponseDeathDetails = string | null;

export type CreateOxResponseDeathCause = EnumsDeathCause | null;

export type CreateOxResponseComments = string | null;

export type CreateOxResponseCertifierDate = string | null;

export type CreateOxResponseCattleManifestId = number | null;

export type CreateOxResponseCarcassWeight = number | null;

export type CreateOxResponseCarcassType = EnumsCarcassType | null;

export type CreateOxResponseCarcassPrice = number | null;

export type CreateOxResponseCarcass = number | null;

export type CreateOxResponseBornOnFarm = boolean | null;

export type CreateOxResponseBndTracked = boolean | null;

export interface CreateOxResponse {
  birth: string;
  blockedUntil: string;
  bndTracked: CreateOxResponseBndTracked;
  bornOnFarm: CreateOxResponseBornOnFarm;
  breed: string;
  carcass: CreateOxResponseCarcass;
  carcassPrice: CreateOxResponseCarcassPrice;
  carcassType: CreateOxResponseCarcassType;
  carcassWeight: CreateOxResponseCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: CreateOxResponseCattleManifestId;
  certifierDate: CreateOxResponseCertifierDate;
  comments: CreateOxResponseComments;
  deathCause: CreateOxResponseDeathCause;
  deathDetails: CreateOxResponseDeathDetails;
  deathNecropsy: CreateOxResponseDeathNecropsy;
  deathReason: CreateOxResponseDeathReason;
  dentitionStage: CreateOxResponseDentitionStage;
  diedAt: CreateOxResponseDiedAt;
  electronic: CreateOxResponseElectronic;
  exitTruckId: CreateOxResponseExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: CreateOxResponseGtaId;
  hasBirthAnnouncement: CreateOxResponseHasBirthAnnouncement;
  id: number;
  identificationSource: CreateOxResponseIdentificationSource;
  identifiedAt: CreateOxResponseIdentifiedAt;
  identifier: CreateOxResponseIdentifier;
  includedAt: string;
  internalSaleId: CreateOxResponseInternalSaleId;
  invoice: CreateOxResponseInvoice;
  isNecropsyPerformed: CreateOxResponseIsNecropsyPerformed;
  otherDeathCause: CreateOxResponseOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: CreateOxResponsePriceAtSignEntry;
  priceAtSignExit: CreateOxResponsePriceAtSignExit;
  purchaseId: CreateOxResponsePurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: CreateOxResponseReversedDeathCause;
  reversedDeathDate: CreateOxResponseReversedDeathDate;
  reversedDeathDetails: CreateOxResponseReversedDeathDetails;
  reversedDeathNecropsy: CreateOxResponseReversedDeathNecropsy;
  runtime: number;
  salesMarketType: CreateOxResponseSalesMarketType;
  sisbov: CreateOxResponseSisbov;
  sisbovHistory: string[];
  startOfTreatment: CreateOxResponseStartOfTreatment;
  variety: string;
}

export interface CreateOxPriceTableRequest {
  FEMALE: Months;
  MALE: Months;
  year: number;
}

export type CreateOxPerformanceRequestGender =
  (typeof CreateOxPerformanceRequestGender)[keyof typeof CreateOxPerformanceRequestGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOxPerformanceRequestGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export interface CreateOxPerformanceRequest {
  exitCarcassYield: number;
  exitWeight: number;
  gender: CreateOxPerformanceRequestGender;
  gmd: number;
  minimumEntryWeight: number;
  referenceDays: number;
  slaughterWeight: number;
}

export interface CreateOxEntryResponse {
  affected: OxEntryAffected;
  applied: boolean;
  batchId: number;
  batchName: string;
  dryRun: boolean;
  entryDate: string;
  warnings: string[];
}

export interface CreateOxEntryBody {
  batchId: number;
  breed: string;
  category: EnumsOxCategory;
  dryRun: boolean;
  /** Dia em que os animais entraram no lote. Aceita dia passado. */
  entryDate: string;
  groups: OxEntryGroup[];
  healthProtocolId?: number;
  purchaseId: number;
  variety: string;
  weight: number;
}

export interface CreateOxBody {
  ageInMonths: number;
  /** O batch que o boi vai começar */
  batchId: number;
  /** Se o nascimento ocorreu na fazenda */
  bornOnFarm?: boolean;
  /** Raça da BND */
  breed: string;
  category: EnumsOxCategory;
  comments?: string;
  /** Dentição do animal */
  dentitionStage?: EnumsDentitionStage;
  /** Dados do brinco eletrônico */
  electronic?: string;
  /** Id do protocolo de saúde */
  extraMedicineIds?: number[];
  gender: EnumsOxGender;
  /** Id da gta */
  gtaId?: number;
  /** Id do protocolo de saúde */
  healthProtocolId?: number;
  /** Dados do brinco extra */
  identifier?: string;
  /** Se é uma entrada avulsa */
  isSimpleOx?: boolean;
  /** Id do proprietário */
  ownerId?: number;
  /** Id do pedido de compra */
  purchaseId?: number;
  runtime: number;
  sisbov?: number;
  /** Raça interna */
  variety: string;
  weight: number;
}

export interface CreateOtherDeathCauseResponse {
  active: boolean;
  id: number;
  name: string;
}

export interface CreateOrUpdateInvoices {
  invoiceEmittedAt?: string;
  invoiceId?: number;
  invoiceNumber: string;
  invoiceSeries: string;
  invoiceValue: number;
}

export type CreateOperationalCostRequestType =
  (typeof CreateOperationalCostRequestType)[keyof typeof CreateOperationalCostRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOperationalCostRequestType = {
  FIXED: "FIXED",
  CUSTOM: "CUSTOM",
} as const;

export interface CreateOperationalCostRequest {
  april?: number;
  august?: number;
  batchIds?: number[];
  december?: number;
  february?: number;
  january?: number;
  july?: number;
  june?: number;
  march?: number;
  may?: number;
  november?: number;
  october?: number;
  september?: number;
  type: CreateOperationalCostRequestType;
  year: number;
}

export type CreateOccurrenceResponseStockChangeId = number | null;

export type CreateOccurrenceResponseOldFactor = number | null;

export type CreateOccurrenceResponseNewFactor = number | null;

export type CreateOccurrenceResponseName = string | null;

export interface CreateOccurrenceResponse {
  category: EnumsOccurrenceCategory;
  date: string;
  description: string;
  farmId: number;
  id: number;
  name: CreateOccurrenceResponseName;
  newFactor: CreateOccurrenceResponseNewFactor;
  oldFactor: CreateOccurrenceResponseOldFactor;
  stockChangeId: CreateOccurrenceResponseStockChangeId;
  type: EnumsOccurrenceType;
}

export interface CreateOccurrence {
  category: EnumsOccurrenceCategory;
  corralIds?: number[];
  date: string;
  description: string;
  name?: string;
  newFactor?: number;
  oldFactor?: number;
  stockChangeId?: number;
  type: EnumsOccurrenceType;
}

export interface CreateMixerResponse {
  active: boolean;
  code: number;
  createdAt: string;
  distributor: boolean;
  farmId: number;
  id: number;
  mixer: boolean;
  mixerType: EnumsMixerType;
  mixTime: string;
  name: string;
  rounding: number;
}

export interface CreateMixer {
  code: number;
  distributor: boolean;
  mixer: boolean;
  mixerType: EnumsMixerType;
  mixTime: string;
  name: string;
  rounding: number;
}

export type CreateMedicineResponsePerKg = number | null;

export type CreateMedicineResponseKiloDose = number | null;

export type CreateMedicineResponseApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export interface CreateMedicineResponse {
  active: boolean;
  applicationSuggestion: CreateMedicineResponseApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: CreateMedicineResponseKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: CreateMedicineResponsePerKg;
  type: EnumsMedicineType;
}

export type CreateMedicinePerKg = number | null;

export interface CreateMedicine {
  applicationSuggestion: EnumsApplicationSuggestion;
  blockingDays: number;
  dosePrice: number;
  kiloDose: number;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: CreateMedicinePerKg;
  type: EnumsMedicineType;
}

export type CreateManagementSessionResponseFinishedById = number | null;

export interface CreateManagementSessionResponse {
  createdAt: string;
  data: unknown;
  farmId: number;
  finishedById: CreateManagementSessionResponseFinishedById;
  id: number;
  name: string;
  status: EnumsManagementStatus;
  type: EnumsTypeManagement;
  updatedAt: string;
  uuid: string;
}

export type CreateManagementSessionData = { [key: string]: any };

export interface CreateManagementSession {
  data: CreateManagementSessionData;
  name: string;
  status?: EnumsManagementStatus;
  type: EnumsTypeManagement;
  uuid: string;
}

export interface CreateInvoice {
  emittedAt: string;
  exitTruckId?: number;
  isComplement?: boolean;
  number: string;
  series: string;
  value: number;
}

export interface CreateInternalSaleBody {
  atSalePrice: number;
  dateCount: number;
  gtasIds: number[];
  internalSaleGtas: string[];
  internalSaleName: string;
  /** Proprietário de origem selecionado na busca — só os animais dele entram na venda. */
  originOwnerId: number;
  /** Proprietário de destino (comprador interno). */
  ownerId: number;
}

export interface CreateHealthProtocolResponse {
  active: boolean;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
}

export interface CreateHealthProtocol {
  medicineIds: number[];
  name: string;
}

export type CreateGtaResponseWeightingMapId = number | null;

export type CreateGtaResponseWeightAverage = number | null;

export type CreateGtaResponsePurchaseId = number | null;

export type CreateGtaResponseOriginWeightAverage = number | null;

export type CreateGtaResponseInvoice = string | null;

export type CreateGtaResponseHours = number | null;

export type CreateGtaResponseDistance = number | null;

export type CreateGtaResponseDestinyId = number | null;

export type CreateGtaResponseDescription = string | null;

export interface CreateGtaResponse {
  completed: boolean;
  description: CreateGtaResponseDescription;
  destinyId: CreateGtaResponseDestinyId;
  distance: CreateGtaResponseDistance;
  emission: string;
  entry: string;
  expiration: string;
  farmId: number;
  hours: CreateGtaResponseHours;
  id: number;
  invoice: CreateGtaResponseInvoice;
  number: string;
  originId: number;
  originWeightAverage: CreateGtaResponseOriginWeightAverage;
  purchaseId: CreateGtaResponsePurchaseId;
  series: string;
  weightAverage: CreateGtaResponseWeightAverage;
  weightingMapId: CreateGtaResponseWeightingMapId;
}

export type CreateGtaOxenAgesItem = {
  femaleTotal: number;
  maleTotal: number;
  yearsOld: number;
};

export interface CreateGta {
  description?: string;
  destinyId?: number;
  distance?: number;
  emission: string;
  entry: string;
  expiration: string;
  hours?: number;
  invoice?: string;
  number: string;
  originId: number;
  originWeightAverage?: number;
  oxenAges?: CreateGtaOxenAgesItem[];
  series: string;
  weightAverage?: number;
}

export type CreateFoodPurchaseResponseReceivedAt = string | null;

export type CreateFoodPurchaseResponsePartnerHerd = string | null;

export type CreateFoodPurchaseResponseObservation = string | null;

export type CreateFoodPurchaseResponseEarringsPerPage = number | null;

export interface CreateFoodPurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: CreateFoodPurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: CreateFoodPurchaseResponseObservation;
  partnerHerd: CreateFoodPurchaseResponsePartnerHerd;
  price: number;
  receivedAt: CreateFoodPurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export interface CreateFoodPurchase {
  amount: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation?: string;
  partnerHerd?: string;
  price: number;
  series: string;
  stockId: number;
}

export type CreateFeedLinkDataResponseReview = EnumsFeedLinkReview | null;

export type CreateFeedLinkDataResponseReferenceDay = string | null;

export type CreateFeedLinkDataResponseError = string | null;

export interface CreateFeedLinkDataResponse {
  createdAt: string;
  day: string;
  error: CreateFeedLinkDataResponseError;
  filename: string;
  id: number;
  referenceDay: CreateFeedLinkDataResponseReferenceDay;
  review: CreateFeedLinkDataResponseReview;
  slug: EnumsFeedLinkSlug;
  updatedAt: string;
}

export type CreateFarmResponseUserPersonPhone = string | null;

export type CreateFarmResponseUserPersonDocument = string | null;

export type CreateFarmResponseUserPersonDescription = string | null;

export type CreateFarmResponseUserPersonCode = string | null;

export type CreateFarmResponseUserPerson = {
  code: CreateFarmResponseUserPersonCode;
  createdAt: string;
  description: CreateFarmResponseUserPersonDescription;
  document: CreateFarmResponseUserPersonDocument;
  farmId: number;
  id: number;
  imageUrl: string;
  name: string;
  phone: CreateFarmResponseUserPersonPhone;
  profiles: EnumsProfile[];
};

export type CreateFarmResponseUserPassword = string | null;

export type CreateFarmResponseUserGov = GlobalPrismaJsonGovDocuments | null;

export type CreateFarmResponseUserEmailVerifiedAt = string | null;

export type CreateFarmResponseUserEmail = string | null;

export type CreateFarmResponseUser = {
  email: CreateFarmResponseUserEmail;
  emailVerifiedAt: CreateFarmResponseUserEmailVerifiedAt;
  farmId: number;
  gov: CreateFarmResponseUserGov;
  id: number;
  password: CreateFarmResponseUserPassword;
  person: CreateFarmResponseUserPerson;
  personId: number;
};

export interface CreateFarmResponse {
  farm: CreateFarmResponseFarm;
  license?: string;
  user: CreateFarmResponseUser;
}

export type CreateFarmResponseFarmSenarPercent = number | null;

export type CreateFarmResponseFarmMatinalReadTime = string | null;

export type CreateFarmResponseFarmLastCertifierImport = string | null;

export type CreateFarmResponseFarmLastBndImport = string | null;

export type CreateFarmResponseFarmInstallRunId = string | null;

export type CreateFarmResponseFarmCustomerId = string | null;

export type CreateFarmResponseFarmCorrectionPercent = number | null;

export type CreateFarmResponseFarmAlias = string | null;

export type CreateFarmResponseFarm = {
  addressId: number;
  alias: CreateFarmResponseFarmAlias;
  blockedDays: number;
  correctionPercent: CreateFarmResponseFarmCorrectionPercent;
  createdAt: string;
  customerId: CreateFarmResponseFarmCustomerId;
  dailyCost: number;
  day: string;
  divisionThreshold: number;
  factory: GlobalPrismaJsonLatLng[];
  gradeInfo: unknown;
  gradeMethod: EnumsGradeMethod;
  hasAutomation: boolean;
  hasTraceability: boolean;
  id: number;
  installRunId: CreateFarmResponseFarmInstallRunId;
  interestRate: number;
  lastBndImport: CreateFarmResponseFarmLastBndImport;
  lastCertifierImport: CreateFarmResponseFarmLastCertifierImport;
  managementConfig: unknown;
  matinalReadTime: CreateFarmResponseFarmMatinalReadTime;
  name: string;
  nightlyReadTimes: string[];
  position: GlobalPrismaJsonLatLng;
  requireSisbovOnIdentification: boolean;
  sapId: string;
  senarPercent: CreateFarmResponseFarmSenarPercent;
  treatViewType: EnumsTreatViewType;
};

export interface CreateFarmOwner {
  code?: string;
  document?: string;
  email?: string;
  ERAS?: string;
  image?: string;
  INCRA?: string;
  IS?: string;
  name: string;
  NIRF?: string;
  password: string;
}

export interface CreateFarmCredentialResponse {
  customerId: string;
}

export interface CreateFarmCredential {
  /** Código de cliente Cargill — até 6 dígitos numéricos. */
  customerId: string;
  dbPassword: string;
  dbPort: number;
  dbUser: string;
  farmName?: string;
  /** Nonce gerado pelo chamador (instalador ou app) só pra esta execução — nunca persistido em outro lugar. */
  installRunId: string;
  serverIp: string;
}

export interface CreateFarm {
  address: CreateAddress;
  alias?: string;
  channel?: string;
  /** Dia de operação inicial */
  day: string;
  factory: GlobalPrismaJsonLatLng[];
  hasAutomation: boolean;
  hasTraceability: boolean;
  name: string;
  owner: CreateFarmOwner;
  position: GlobalPrismaJsonLatLng;
  sapId: string;
  schema: string;
  shouldInitialize?: boolean;
  structures: CreateStructure[];
  token?: string;
}

export type CreateEstablishmentResponseCode = string | null;

export type CreateEstablishmentResponseCattleManifestLayoutId = number | null;

export interface CreateEstablishmentResponse {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: CreateEstablishmentResponseCattleManifestLayoutId;
  code: CreateEstablishmentResponseCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsibleId: number;
}

export type CreateEstablishmentResponsibleAnyOf = {
  description?: string;
  document?: string;
  imageUrl?: string;
  name: string;
  phone?: string;
};

/**
 * (EXTERN) Usuário responsável por este estabelecimento.
 */
export type CreateEstablishmentResponsible =
  | number
  | CreateEstablishmentResponsibleAnyOf;

export interface CreateEstablishment {
  address: CreateEstablishmentAddress;
  /** Código do proprietário (comunicado de caminhão) */
  code?: string;
  /** Se este estabelecimento pode ser usado como destino */
  destiny: boolean;
  /** [GovDocuments] Documentos deste estabelecimento */
  gov: GlobalPrismaJsonGovDocuments;
  /** Nome do estabelecimento */
  name: string;
  /** Se este estabelecimento pode ser usado como origem */
  origin: boolean;
  /** (EXTERN) Usuário responsável por este estabelecimento. */
  responsible: CreateEstablishmentResponsible;
}

export type CreateEstablishmentAddressAnyOf = {
  city: string;
  complement?: string;
  country: string;
  neighborhood?: string;
  number?: string;
  state: string;
  street?: string;
  zip: string;
};

export type CreateEstablishmentAddress =
  | number
  | CreateEstablishmentAddressAnyOf;

export interface CreateEntryAnnouncementsResponse {
  id: number;
}

export type CreateEntryAnnouncementPurchaseId = number | null;

export interface CreateEntryAnnouncement {
  date: string;
  gtasIds?: number[];
  purchaseId?: CreateEntryAnnouncementPurchaseId;
}

export type CreateEarringPurchaseResponseReceivedAt = string | null;

export type CreateEarringPurchaseResponsePartnerHerd = string | null;

export type CreateEarringPurchaseResponseObservation = string | null;

export type CreateEarringPurchaseResponseEarringsPerPage = number | null;

export interface CreateEarringPurchaseResponse {
  category: EnumsPurchaseCategory;
  earringsPerPage: CreateEarringPurchaseResponseEarringsPerPage;
  farmId: number;
  id: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation: CreateEarringPurchaseResponseObservation;
  partnerHerd: CreateEarringPurchaseResponsePartnerHerd;
  price: number;
  receivedAt: CreateEarringPurchaseResponseReceivedAt;
  series: string;
  status: EnumsPurchaseStatus;
}

export interface CreateEarringPurchase {
  brand: string;
  earringsPerPage: number;
  finalSisbov: number;
  initialSisbov: number;
  invoice: string;
  issuedAt: string;
  name: string;
  observation?: string;
  orderNumber?: string;
  ownerId: number;
  partnerHerd?: string;
  price: number;
  series: string;
}

export interface CreateDietTransitionResponse {
  days: GlobalPrismaJsonDietTransitionDay[];
  divisions: number;
  farmId: number;
  id: number;
  name: string;
}

export interface CreateDietTransition {
  /** Um array de boolean para como true -> novo trato e false -> trato antigo (length = quantia de dias). */
  days: GlobalPrismaJsonDietTransitionDay[];
  name: string;
}

export type CreateDietResponsePremixId = number | null;

export type CreateDietResponseObservation = string | null;

export type CreateDietResponseFixedElg = number | null;

export type CreateDietResponseCode = string | null;

export type CreateDietResponseCategory = EnumsDietCategory | null;

export interface CreateDietResponse {
  active: boolean;
  category: CreateDietResponseCategory;
  code: CreateDietResponseCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: CreateDietResponseFixedElg;
  id: number;
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: CreateDietResponseObservation;
  premixId: CreateDietResponsePremixId;
}

export interface CreateDiet {
  category: EnumsDietCategory;
  code?: string;
  estimatedWeightGain: number;
  expiry?: number;
  /** ELG fixo da dieta. Obrigatório quando `manualElg` está ativo. Substitui a média ponderada pelos ingredientes. */
  fixedElg?: number;
  ingredients: Ingredient[];
  isPremix?: boolean;
  /** Preço por kg de matéria seca (R$/kg MS). Obrigatório quando `manualPrice` está ativo, vale a partir do dia de criação da dieta. */
  kiloPriceDM?: number;
  manualElg?: boolean;
  manualPrice?: boolean;
  name: string;
  observation?: string;
  premixId?: number;
}

export type CreateDeathAnnouncementResponseExpiresAt = string | null;

export type CreateDeathAnnouncementResponseEmittedAt = string | null;

export type CreateDeathAnnouncementResponseCreatedAt = string | null;

export interface CreateDeathAnnouncementResponse {
  createdAt: CreateDeathAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: CreateDeathAnnouncementResponseEmittedAt;
  expiresAt: CreateDeathAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export type CreateCorralResponsePosition = number | null;

export interface CreateCorralResponse {
  area: number;
  capacity: number;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  position: CreateCorralResponsePosition;
  type: EnumsCorralType;
}

export interface CreateCorral {
  area: number;
  capacity: number;
  name: string;
  polygon: GlobalPrismaJsonLatLng[];
  /** Position auto preenchido, caso não fornecido. */
  position?: number;
  type: EnumsCorralType;
}

export interface CreateCattleManifestLayoutResponse {
  active: boolean;
  id: number;
  name: string;
}

export interface CreateCattleManifestLayoutBody {
  establishmentIds?: number[];
  fieldMapping?: UpdateCattleManifestLayoutFieldMappingBody;
  finishingMappings?: CattleManifestLayoutFinishingMappingItem[];
  name: string;
  transformationConfig?: UpdateCattleManifestLayoutTransformationConfigBody;
  useStandardFinishingNumbering?: boolean;
}

export type CreateBatchResponseScaledToSlaughter = boolean | null;

export type CreateBatchResponseOperationalCostGroupId = number | null;

export type CreateBatchResponseOldCorralId = number | null;

export type CreateBatchResponseHideFromTreatmentUntil = string | null;

export type CreateBatchResponseHideFromTreatment = boolean | null;

export type CreateBatchResponseForeseenSlaughterDate = string | null;

export type CreateBatchResponseFinalizedAt = string | null;

export type CreateBatchResponseDescrption = string | null;

export type CreateBatchResponseCorralId = number | null;

export type CreateBatchResponseCarcassUniform = number | null;

export type CreateBatchResponseCarcassThin = number | null;

export type CreateBatchResponseCarcassMissing = number | null;

export type CreateBatchResponseCarcassMedium = number | null;

export type CreateBatchResponseCarcassExcessive = number | null;

export type CreateBatchResponseAdjustedPurchaseCost = number | null;

export type CreateBatchResponseActivationEditedAt = string | null;

export type CreateBatchResponseActivatedAt = string | null;

export interface CreateBatchResponse {
  activatedAt: CreateBatchResponseActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: CreateBatchResponseActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: CreateBatchResponseAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: CreateBatchResponseCarcassExcessive;
  carcassMedium: CreateBatchResponseCarcassMedium;
  carcassMissing: CreateBatchResponseCarcassMissing;
  carcassThin: CreateBatchResponseCarcassThin;
  carcassUniform: CreateBatchResponseCarcassUniform;
  corralId: CreateBatchResponseCorralId;
  createdAt: string;
  descrption: CreateBatchResponseDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: CreateBatchResponseFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: CreateBatchResponseForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: CreateBatchResponseHideFromTreatment;
  hideFromTreatmentUntil: CreateBatchResponseHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: CreateBatchResponseOldCorralId;
  operationalCostGroupId: CreateBatchResponseOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: CreateBatchResponseScaledToSlaughter;
}

export interface CreateBatch {
  corralId: number;
  createdAt?: string;
  description?: string;
  isHospitalPen?: boolean;
  name: string;
}

export interface CreateBackupDataResponse {
  filename: string;
  location: string;
  success: boolean;
}

export type CreateAnnouncementResponseExpiresAt = string | null;

export type CreateAnnouncementResponseEmittedAt = string | null;

export type CreateAnnouncementResponseCreatedAt = string | null;

export interface CreateAnnouncementResponse {
  createdAt: CreateAnnouncementResponseCreatedAt;
  data: GlobalPrismaJsonAnnouncementData;
  emittedAt: CreateAnnouncementResponseEmittedAt;
  expiresAt: CreateAnnouncementResponseExpiresAt;
  farmId: number;
  id: number;
  type: EnumsAnnouncementType;
}

export type CreateAnnouncementSaleType =
  (typeof CreateAnnouncementSaleType)[keyof typeof CreateAnnouncementSaleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAnnouncementSaleType = {
  MANAGEMENT: "MANAGEMENT",
  ORDER: "ORDER",
} as const;

export interface CreateAnnouncement {
  data: GlobalPrismaJsonAnnouncementData;
  date: string;
  saleType?: CreateAnnouncementSaleType;
  type: EnumsAnnouncementType;
}

export interface CreateAddress {
  city: string;
  complement?: string;
  country: string;
  neighborhood?: string;
  number?: string;
  state: string;
  street?: string;
  zip: string;
}

export interface CountWeighingReportResponse {
  chunkKey: string;
  count: number;
  currentStep: number;
  report: WeighingReportResponse[];
}

export interface CountConsolidatedInternalSaleReportResponse {
  chunkKey: string;
  count: number;
  currentStep: number;
  report: ConsolidatedInternalSaleResponse[];
}

export interface CountBeatsForBakingEfficiencyReportResponse {
  chunkKey: string;
  count: number;
  currentStep: number;
  report: BakingEfficiencyReportDataResponseItem[];
}

export interface CountBatchesForSlaughterScaleReportResponse {
  chunkKey: string;
  count: number;
  currentStep: number;
  report: SlaughterScaleReportDataResponseItem[];
}

export type CorralType = EnumsCorralType;

export interface CorralFilter {
  day?: string;
  /** Não tem lotes no momento */
  empty?: boolean;
  type?: EnumsCorralType;
}

export interface ConversionResult {
  oxId: number;
  skipped: boolean;
  toTruckId: number;
}

export type ConsolidatedInternalSaleItemDeathDate = string | null;

export interface ConsolidatedInternalSaleItem {
  ageInMonths: number;
  atPrice: number;
  avgCalculatedWeight: number;
  avgEntryDate: string;
  avgEntryWeight: number;
  avgWeighingWeight: number;
  calculatedGmd: number;
  contract: string;
  countGtaDays: number;
  deathDate: ConsolidatedInternalSaleItemDeathDate;
  destinyOwner: string;
  entryGta: string;
  era: string;
  exitGta: string;
  exitOxPrice: number;
  gender: string;
  gtaPrice: number;
  internalSaleDate: string;
  originOwner: string;
  sisbov: string;
  status: string;
}

export interface ConsolidatedInternalSaleResponse {
  items: ConsolidatedInternalSaleItem[];
}

export interface ConfirmPasswordResetBody {
  password: string;
  resetToken: string;
}

export type ComissionReportXlsxQueryAppVersion = string | null;

export interface ComissionReportXlsxQuery {
  appVersion?: ComissionReportXlsxQueryAppVersion;
  buyerId?: number;
  end?: string;
  filename: string;
  purchaseName?: string;
  start?: string;
}

export interface ComissionReportResume {
  /** Peso médio (@) */
  atSignAvgWeight: number;
  /** Preço por arroba */
  atSignPrice: number;
  /** Valor da comissão por boi */
  commissionPerOx: number;
  /** Valor da comissão total */
  commissionTotal: number;
  /** Distância (km) */
  distance: number;
  /** Quantidade de animais */
  oxenAmount: number;
  /** Quebra de peso (%) */
  weightBreak: number;
}

/**
 * Data
 */
export type ComissionReportItemDay = string | null;

export interface ComissionReportItem {
  /** Peso médio (@) */
  atSignAvgWeight: number;
  /** Preço por arroba */
  atSignPrice: number;
  /** Comprador */
  buyer: string;
  /** Valor da comissão por boi */
  commissionPerOx: number;
  /** Valor da comissão total */
  commissionTotal: number;
  /** Data */
  day: ComissionReportItemDay;
  /** Fazenda de destino */
  destination: string;
  /** Distância (km) */
  distance: number;
  /** Sexos nas GTAs */
  gender: string[];
  /** Mapa (controle interno) */
  mapa: string;
  /** Fazendas de origem */
  origin: string[];
  /** Quantidade de animais */
  oxenAmount: number;
  /** Parceiro */
  partner: string;
  /** Contrato (número do pedido) */
  purchaseName: string;
  /** Quebra de peso (%) */
  weightBreak: number;
}

export interface ComissionReportFilter {
  buyerId?: number;
  end?: string;
  purchaseName?: string;
  start?: string;
}

export interface ComissionReport {
  data: ComissionReportItem[];
  resume: ComissionReportResume;
}

export interface CloseSaleOrderInBatchResponse {
  carcassWeightAverage: number;
  carcassYieldAverage: number;
  oxenUpdated: CloseSaleOrderInBatchResponseOxenUpdatedItem[];
  priceAtSignAverage: number;
}

export type CloseSaleOrderInBatchResponseOxenUpdatedItemStartOfTreatment =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemSisbov = string | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemSalesMarketType =
  EnumsSalesMarketType | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathDetails =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathDate =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathCause =
  EnumsDeathCause | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemPurchaseId =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemPriceAtSignExit =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemPriceAtSignEntry =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemOtherDeathCause =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemIsNecropsyPerformed =
  | boolean
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemInvoice = string | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemInternalSaleId =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemIdentifier =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemIdentifiedAt =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemIdentificationSource =
  EnumsIdentificationSource | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemHasBirthAnnouncement =
  | boolean
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemGtaId = number | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemExitTruckId =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemElectronic =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemDiedAt = string | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemDentitionStage =
  EnumsDentitionStage | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemDeathReason =
  EnumsDeathCause | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemDeathDetails =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemDeathCause =
  EnumsDeathCause | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemComments =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemCertifierDate =
  | string
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemCattleManifestId =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemCarcassWeight =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemCarcassType =
  EnumsCarcassType | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemCarcassPrice =
  | number
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemCarcass = number | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemBornOnFarm =
  | boolean
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItemBndTracked =
  | boolean
  | null;

export type CloseSaleOrderInBatchResponseOxenUpdatedItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: CloseSaleOrderInBatchResponseOxenUpdatedItemBndTracked;
  bornOnFarm: CloseSaleOrderInBatchResponseOxenUpdatedItemBornOnFarm;
  breed: string;
  carcass: CloseSaleOrderInBatchResponseOxenUpdatedItemCarcass;
  carcassPrice: CloseSaleOrderInBatchResponseOxenUpdatedItemCarcassPrice;
  carcassType: CloseSaleOrderInBatchResponseOxenUpdatedItemCarcassType;
  carcassWeight: CloseSaleOrderInBatchResponseOxenUpdatedItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: CloseSaleOrderInBatchResponseOxenUpdatedItemCattleManifestId;
  certifierDate: CloseSaleOrderInBatchResponseOxenUpdatedItemCertifierDate;
  comments: CloseSaleOrderInBatchResponseOxenUpdatedItemComments;
  deathCause: CloseSaleOrderInBatchResponseOxenUpdatedItemDeathCause;
  deathDetails: CloseSaleOrderInBatchResponseOxenUpdatedItemDeathDetails;
  deathNecropsy: CloseSaleOrderInBatchResponseOxenUpdatedItemDeathNecropsy;
  deathReason: CloseSaleOrderInBatchResponseOxenUpdatedItemDeathReason;
  dentitionStage: CloseSaleOrderInBatchResponseOxenUpdatedItemDentitionStage;
  diedAt: CloseSaleOrderInBatchResponseOxenUpdatedItemDiedAt;
  electronic: CloseSaleOrderInBatchResponseOxenUpdatedItemElectronic;
  exitTruckId: CloseSaleOrderInBatchResponseOxenUpdatedItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: CloseSaleOrderInBatchResponseOxenUpdatedItemGtaId;
  hasBirthAnnouncement: CloseSaleOrderInBatchResponseOxenUpdatedItemHasBirthAnnouncement;
  id: number;
  identificationSource: CloseSaleOrderInBatchResponseOxenUpdatedItemIdentificationSource;
  identifiedAt: CloseSaleOrderInBatchResponseOxenUpdatedItemIdentifiedAt;
  identifier: CloseSaleOrderInBatchResponseOxenUpdatedItemIdentifier;
  includedAt: string;
  internalSaleId: CloseSaleOrderInBatchResponseOxenUpdatedItemInternalSaleId;
  invoice: CloseSaleOrderInBatchResponseOxenUpdatedItemInvoice;
  isNecropsyPerformed: CloseSaleOrderInBatchResponseOxenUpdatedItemIsNecropsyPerformed;
  otherDeathCause: CloseSaleOrderInBatchResponseOxenUpdatedItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: CloseSaleOrderInBatchResponseOxenUpdatedItemPriceAtSignEntry;
  priceAtSignExit: CloseSaleOrderInBatchResponseOxenUpdatedItemPriceAtSignExit;
  purchaseId: CloseSaleOrderInBatchResponseOxenUpdatedItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathCause;
  reversedDeathDate: CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathDate;
  reversedDeathDetails: CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathDetails;
  reversedDeathNecropsy: CloseSaleOrderInBatchResponseOxenUpdatedItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: CloseSaleOrderInBatchResponseOxenUpdatedItemSalesMarketType;
  sisbov: CloseSaleOrderInBatchResponseOxenUpdatedItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: CloseSaleOrderInBatchResponseOxenUpdatedItemStartOfTreatment;
  variety: string;
};

export interface CloseSaleOrderInBatchRequest {
  carcassExcessive: number;
  carcassMedium: number;
  carcassMissing: number;
  carcassThin: number;
  carcassUniform: number;
  carcassWeight: number;
}

export type CloseSaleManagementResponseOxenUpdatedItemStartOfTreatment =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemSisbov = string | null;

export type CloseSaleManagementResponseOxenUpdatedItemSalesMarketType =
  EnumsSalesMarketType | null;

export type CloseSaleManagementResponseOxenUpdatedItemReversedDeathNecropsy =
  EnumsDeathNecropsy | null;

export type CloseSaleManagementResponseOxenUpdatedItemReversedDeathDetails =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemReversedDeathDate =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemReversedDeathCause =
  EnumsDeathCause | null;

export type CloseSaleManagementResponseOxenUpdatedItemPurchaseId =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemPriceAtSignExit =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemPriceAtSignEntry =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemOtherDeathCause =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemIsNecropsyPerformed =
  | boolean
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemInvoice = string | null;

export type CloseSaleManagementResponseOxenUpdatedItemInternalSaleId =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemIdentifier =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemIdentifiedAt =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemIdentificationSource =
  EnumsIdentificationSource | null;

export type CloseSaleManagementResponseOxenUpdatedItemHasBirthAnnouncement =
  | boolean
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemGtaId = number | null;

export type CloseSaleManagementResponseOxenUpdatedItemExitTruckId =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemElectronic =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemDiedAt = string | null;

export type CloseSaleManagementResponseOxenUpdatedItemDentitionStage =
  EnumsDentitionStage | null;

export type CloseSaleManagementResponseOxenUpdatedItemDeathReason =
  EnumsDeathCause | null;

export type CloseSaleManagementResponseOxenUpdatedItemDeathNecropsy =
  EnumsDeathNecropsy | null;

export type CloseSaleManagementResponseOxenUpdatedItemDeathDetails =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemDeathCause =
  EnumsDeathCause | null;

export type CloseSaleManagementResponseOxenUpdatedItemComments = string | null;

export type CloseSaleManagementResponseOxenUpdatedItemCertifierDate =
  | string
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemCattleManifestId =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemCarcassWeight =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemCarcassType =
  EnumsCarcassType | null;

export type CloseSaleManagementResponseOxenUpdatedItemCarcassPrice =
  | number
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemCarcass = number | null;

export type CloseSaleManagementResponseOxenUpdatedItemBornOnFarm =
  | boolean
  | null;

export type CloseSaleManagementResponseOxenUpdatedItemBndTracked =
  | boolean
  | null;

export type CloseSaleManagementResponseOxenUpdatedItem = {
  birth: string;
  blockedUntil: string;
  bndTracked: CloseSaleManagementResponseOxenUpdatedItemBndTracked;
  bornOnFarm: CloseSaleManagementResponseOxenUpdatedItemBornOnFarm;
  breed: string;
  carcass: CloseSaleManagementResponseOxenUpdatedItemCarcass;
  carcassPrice: CloseSaleManagementResponseOxenUpdatedItemCarcassPrice;
  carcassType: CloseSaleManagementResponseOxenUpdatedItemCarcassType;
  carcassWeight: CloseSaleManagementResponseOxenUpdatedItemCarcassWeight;
  category: EnumsOxCategory;
  cattleManifestId: CloseSaleManagementResponseOxenUpdatedItemCattleManifestId;
  certifierDate: CloseSaleManagementResponseOxenUpdatedItemCertifierDate;
  comments: CloseSaleManagementResponseOxenUpdatedItemComments;
  deathCause: CloseSaleManagementResponseOxenUpdatedItemDeathCause;
  deathDetails: CloseSaleManagementResponseOxenUpdatedItemDeathDetails;
  deathNecropsy: CloseSaleManagementResponseOxenUpdatedItemDeathNecropsy;
  deathReason: CloseSaleManagementResponseOxenUpdatedItemDeathReason;
  dentitionStage: CloseSaleManagementResponseOxenUpdatedItemDentitionStage;
  diedAt: CloseSaleManagementResponseOxenUpdatedItemDiedAt;
  electronic: CloseSaleManagementResponseOxenUpdatedItemElectronic;
  exitTruckId: CloseSaleManagementResponseOxenUpdatedItemExitTruckId;
  farmId: number;
  gender: EnumsOxGender;
  gtaId: CloseSaleManagementResponseOxenUpdatedItemGtaId;
  hasBirthAnnouncement: CloseSaleManagementResponseOxenUpdatedItemHasBirthAnnouncement;
  id: number;
  identificationSource: CloseSaleManagementResponseOxenUpdatedItemIdentificationSource;
  identifiedAt: CloseSaleManagementResponseOxenUpdatedItemIdentifiedAt;
  identifier: CloseSaleManagementResponseOxenUpdatedItemIdentifier;
  includedAt: string;
  internalSaleId: CloseSaleManagementResponseOxenUpdatedItemInternalSaleId;
  invoice: CloseSaleManagementResponseOxenUpdatedItemInvoice;
  isNecropsyPerformed: CloseSaleManagementResponseOxenUpdatedItemIsNecropsyPerformed;
  otherDeathCause: CloseSaleManagementResponseOxenUpdatedItemOtherDeathCause;
  ownerId: number;
  preConfinementDays: number;
  priceAtSignEntry: CloseSaleManagementResponseOxenUpdatedItemPriceAtSignEntry;
  priceAtSignExit: CloseSaleManagementResponseOxenUpdatedItemPriceAtSignExit;
  purchaseId: CloseSaleManagementResponseOxenUpdatedItemPurchaseId;
  purpose: EnumsOxPurpose;
  reversedDeathCause: CloseSaleManagementResponseOxenUpdatedItemReversedDeathCause;
  reversedDeathDate: CloseSaleManagementResponseOxenUpdatedItemReversedDeathDate;
  reversedDeathDetails: CloseSaleManagementResponseOxenUpdatedItemReversedDeathDetails;
  reversedDeathNecropsy: CloseSaleManagementResponseOxenUpdatedItemReversedDeathNecropsy;
  runtime: number;
  salesMarketType: CloseSaleManagementResponseOxenUpdatedItemSalesMarketType;
  sisbov: CloseSaleManagementResponseOxenUpdatedItemSisbov;
  sisbovHistory: string[];
  startOfTreatment: CloseSaleManagementResponseOxenUpdatedItemStartOfTreatment;
  variety: string;
};

export interface CloseSaleManagementResponse {
  carcassWeightAverage: number;
  carcassYieldAverage: number;
  oxenUpdated: CloseSaleManagementResponseOxenUpdatedItem[];
  priceAtSignAverage: number;
}

export interface ClearSpreadsheetIdentificationResponse {
  cleared: number;
}

export interface CheckPendingOxenForBirthAnnouncementCreationResponse {
  pendingOxenAmount: number;
}

export interface CheckOxIdentification {
  /** Dados do brinco eletrônico */
  electronic?: string;
  sisbov?: number;
}

export interface CheckGtasResponse {
  emitted: boolean;
  gtas: number[];
}

export interface ChargebackOxenPurchaseResponse {
  moved: number;
  success: boolean;
}

export type ChangeTreatmentResponseScaledToSlaughter = boolean | null;

export type ChangeTreatmentResponseOperationalCostGroupId = number | null;

export type ChangeTreatmentResponseOldCorralId = number | null;

export type ChangeTreatmentResponseHideFromTreatmentUntil = string | null;

export type ChangeTreatmentResponseHideFromTreatment = boolean | null;

export type ChangeTreatmentResponseForeseenSlaughterDate = string | null;

export type ChangeTreatmentResponseFinalizedAt = string | null;

export type ChangeTreatmentResponseDescrption = string | null;

export type ChangeTreatmentResponseCorralId = number | null;

export type ChangeTreatmentResponseCarcassUniform = number | null;

export type ChangeTreatmentResponseCarcassThin = number | null;

export type ChangeTreatmentResponseCarcassMissing = number | null;

export type ChangeTreatmentResponseCarcassMedium = number | null;

export type ChangeTreatmentResponseCarcassExcessive = number | null;

export type ChangeTreatmentResponseAdjustedPurchaseCost = number | null;

export type ChangeTreatmentResponseActivationEditedAt = string | null;

export type ChangeTreatmentResponseActivatedAt = string | null;

export interface ChangeTreatmentResponse {
  activatedAt: ChangeTreatmentResponseActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: ChangeTreatmentResponseActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: ChangeTreatmentResponseAdjustedPurchaseCost;
  admCost: number;
  carcass: number;
  carcassExcessive: ChangeTreatmentResponseCarcassExcessive;
  carcassMedium: ChangeTreatmentResponseCarcassMedium;
  carcassMissing: ChangeTreatmentResponseCarcassMissing;
  carcassThin: ChangeTreatmentResponseCarcassThin;
  carcassUniform: ChangeTreatmentResponseCarcassUniform;
  corralId: ChangeTreatmentResponseCorralId;
  createdAt: string;
  descrption: ChangeTreatmentResponseDescrption;
  exitPrice: number;
  farmId: number;
  finalizedAt: ChangeTreatmentResponseFinalizedAt;
  foodFinancing: boolean;
  foreseenCarcass: number;
  foreseenSlaughterDate: ChangeTreatmentResponseForeseenSlaughterDate;
  foreseenWeight: number;
  hideFromTreatment: ChangeTreatmentResponseHideFromTreatment;
  hideFromTreatmentUntil: ChangeTreatmentResponseHideFromTreatmentUntil;
  id: number;
  isHospitalPen: boolean;
  liveWeight: number;
  name: string;
  oldCorralId: ChangeTreatmentResponseOldCorralId;
  operationalCostGroupId: ChangeTreatmentResponseOperationalCostGroupId;
  otherCost: number;
  oxFinancing: boolean;
  scaledToSlaughter: ChangeTreatmentResponseScaledToSlaughter;
}

export interface ChangeTreatment {
  batchId: number;
  treatmentId: number;
}

export interface ChangeOxenAgeBody {
  ageInMonths: number;
  oxenIds: number[];
}

export interface ChangeOfCharacteristicAnnouncement {
  newBreed?: string;
  newGender?: EnumsOxGender;
  oldBreed?: string;
  oldGender?: EnumsOxGender;
  oxId: number;
}

export type CattleManifestTargetFieldValue =
  (typeof CattleManifestTargetFieldValue)[keyof typeof CattleManifestTargetFieldValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CattleManifestTargetFieldValue = {
  SISBOV: "SISBOV",
  ELECTRONIC_TAG: "ELECTRONIC_TAG",
  EXTRA_TAG: "EXTRA_TAG",
  CARCASS_WEIGHT: "CARCASS_WEIGHT",
  FINISHING: "FINISHING",
} as const;

export type CattleManifestSourceModeValue =
  (typeof CattleManifestSourceModeValue)[keyof typeof CattleManifestSourceModeValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CattleManifestSourceModeValue = {
  POSITION: "POSITION",
  HEADER_NAME: "HEADER_NAME",
} as const;

export interface CattleManifestRowError {
  reason: string;
  rows: number[];
}

export interface CattleManifestLayoutSummary {
  active: boolean;
  id: number;
  name: string;
}

export interface CattleManifestLayoutListItem {
  active: boolean;
  createdAt: string;
  establishmentsCount: number;
  id: number;
  name: string;
}

export interface CattleManifestLayoutFinishingMappingItem {
  rawValue: string;
  targetLevel: EnumsCarcassType;
}

export type CattleManifestLayoutFieldMappingItemHeaderName = string | null;

export type CattleManifestLayoutFieldMappingItemColumnIndex = number | null;

export interface CattleManifestLayoutFieldMappingItem {
  columnIndex: CattleManifestLayoutFieldMappingItemColumnIndex;
  headerName: CattleManifestLayoutFieldMappingItemHeaderName;
  targetField: CattleManifestTargetFieldValue;
}

export type CattleManifestLayoutDetailWeightAggregation =
  (typeof CattleManifestLayoutDetailWeightAggregation)[keyof typeof CattleManifestLayoutDetailWeightAggregation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CattleManifestLayoutDetailWeightAggregation = {
  SUM: "SUM",
  AVERAGE: "AVERAGE",
} as const;

export type CattleManifestLayoutDetailFinishingDivergencePolicy =
  (typeof CattleManifestLayoutDetailFinishingDivergencePolicy)[keyof typeof CattleManifestLayoutDetailFinishingDivergencePolicy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CattleManifestLayoutDetailFinishingDivergencePolicy = {
  BLOCK: "BLOCK",
  HIGHEST: "HIGHEST",
  LOWEST: "LOWEST",
} as const;

export type CattleManifestLayoutDetailBandGroupByField =
  CattleManifestTargetFieldValue | null;

export interface CattleManifestLayoutDetail {
  active: boolean;
  bandConsolidationEnabled: boolean;
  bandGroupByField: CattleManifestLayoutDetailBandGroupByField;
  createdAt: string;
  finishingDivergencePolicy: CattleManifestLayoutDetailFinishingDivergencePolicy;
  id: number;
  name: string;
  updatedAt: string;
  useStandardFinishingNumbering: boolean;
  weightAggregation: CattleManifestLayoutDetailWeightAggregation;
}

export type CattleManifestIdentifierField =
  (typeof CattleManifestIdentifierField)[keyof typeof CattleManifestIdentifierField];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CattleManifestIdentifierField = {
  SISBOV: "SISBOV",
  ELECTRONIC_TAG: "ELECTRONIC_TAG",
  EXTRA_TAG: "EXTRA_TAG",
} as const;

export interface CattleManifestConsolidatedAnimal {
  carcassWeight: number;
  finishingLevel: EnumsCarcassType;
  identifierField: CattleManifestIdentifierField;
  identifierValue: string;
  sourceRows: number[];
}

export type CattleEntryPerCategoryGenerateExcelRequestDistanceData = {
  females: PerDistanceItem[];
  males: PerDistanceItem[];
};

export type CattleEntryPerCategoryGenerateExcelRequestContractData = {
  females: PerContractItem[];
  males: PerContractItem[];
};

export type CattleEntryPerCategoryGenerateExcelRequestCategoryData = {
  females: PerCategoryItem[];
  males: PerCategoryItem[];
};

export interface CattleEntryPerCategoryGenerateExcelRequest {
  categoryData: CattleEntryPerCategoryGenerateExcelRequestCategoryData;
  contractData: CattleEntryPerCategoryGenerateExcelRequestContractData;
  distanceData: CattleEntryPerCategoryGenerateExcelRequestDistanceData;
}

export type CarcassType = EnumsCarcassType;

export type CarcassFinishingCategory =
  (typeof CarcassFinishingCategory)[keyof typeof CarcassFinishingCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CarcassFinishingCategory = {
  MISSING: "MISSING",
  THIN: "THIN",
  MEDIUM: "MEDIUM",
  UNIFORM: "UNIFORM",
  EXCESSIVE: "EXCESSIVE",
} as const;

/**
 * Distribuição percentual (0-1) do acabamento de carcaça dos animais abatidos no lote.
 */
export interface CarcassClassification {
  excessive: number;
  medium: number;
  missing: number;
  thin: number;
  uniform: number;
}

export interface CancelTestJobReportResponse {
  canceled: boolean;
}

export interface CancelForecastReportResponse {
  canceled: boolean;
}

export interface CancelFinancialBatchesReportResponse {
  canceled: boolean;
}

export interface CancelActiveBatchesReportResponse {
  canceled: boolean;
}

export interface CanAdvanceFarmDayResponse {
  can: boolean;
  reason: AdvanceDayReason;
  unusedBatches: UnusedBatch[];
}

/**
 * Motivo de um lote ficar de fora dos grupos
 */
export type BulkDietTransitionIgnoredReason =
  (typeof BulkDietTransitionIgnoredReason)[keyof typeof BulkDietTransitionIgnoredReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkDietTransitionIgnoredReason = {
  NO_DIET: "NO_DIET",
  NO_TREATMENT: "NO_TREATMENT",
  IN_TRANSITION: "IN_TRANSITION",
} as const;

export type BulkDietTransitionIgnoredCorralName = string | null;

export interface BulkDietTransitionIgnored {
  batchId: number;
  corralName: BulkDietTransitionIgnoredCorralName;
  name: string;
  reason: BulkDietTransitionIgnoredReason;
}

export interface BulkDietTransitionResult {
  groups: BulkDietTransitionGroup[];
  ignored: BulkDietTransitionIgnored[];
}

export type BulkDietTransitionBatchCorralName = string | null;

export interface BulkDietTransitionBatch {
  batchId: number;
  corralName: BulkDietTransitionBatchCorralName;
  /** Dias que o lote já está na dieta vigente */
  dietDays: number;
  /** "Lote - Descrição" */
  name: string;
}

export interface BulkDietTransitionGroup {
  batches: BulkDietTransitionBatch[];
  /** Dias de uso previstos da dieta vigente */
  dietExpiry: number;
  dietId: number;
  dietName: string;
  /** Quantidade de tratos do plano de trato vigente */
  divisions: number;
  /** `${dietId}-${divisions}` */
  key: string;
}

/**
 * Data de saída/abate mais recente do grupo
 */
export type BoitelClosureSummarySaleOrderSlaughterDate = string | null;

export type BoitelClosureSummarySaleOrderSaleOrderId = number | null;

export type BoitelClosureSummarySaleOrderOrderName = string | null;

/**
 * Frete/@ cadastrado na ordem de venda
 */
export type BoitelClosureSummarySaleOrderFreightPerAtSign = number | null;

export type BoitelClosureSummarySaleOrderDestiny = string | null;

/**
 * Bônus (%) cadastrado na ordem de venda (fração)
 */
export type BoitelClosureSummarySaleOrderBonusPercent = number | null;

/**
 * Resumo por ordem de venda (lote de abate) dos animais do pedido de compra
 */
export interface BoitelClosureSummarySaleOrder {
  /** P. Méd @ = P. Total @ / Cab. */
  averageCarcassAtSign: number;
  /** Bônus (%) cadastrado na ordem de venda (fração) */
  bonusPercent: BoitelClosureSummarySaleOrderBonusPercent;
  destiny: BoitelClosureSummarySaleOrderDestiny;
  /** Frete/@ cadastrado na ordem de venda */
  freightPerAtSign: BoitelClosureSummarySaleOrderFreightPerAtSign;
  orderName: BoitelClosureSummarySaleOrderOrderName;
  oxenCount: number;
  /** Faturamento = soma do valor de fechamento (carcassPrice) dos animais */
  revenue: number;
  /** R$/@ Fat. = Faturamento / P. Total @ */
  revenuePerAtSign: number;
  saleOrderId: BoitelClosureSummarySaleOrderSaleOrderId;
  /** Data de saída/abate mais recente do grupo */
  slaughterDate: BoitelClosureSummarySaleOrderSlaughterDate;
  /** P. Total @ = kg / 15 */
  totalCarcassAtSign: number;
  totalCarcassKg: number;
}

export interface BoitelClosureSummaryRequest {
  oxenPurchaseId: number;
}

export type BoitelClosureSummarySlaughterhouse = string | null;

export type BoitelClosureSummarySlaughterDate = string | null;

export type BoitelClosureSummarySenarPercent = number | null;

/**
 * Quantidade de animais negociados no pedido de compra (cab. contratadas)
 */
export type BoitelClosureSummaryPurchaseOxenAmount = number | null;

export type BoitelClosureSummaryPartnerName = string | null;

export type BoitelClosureSummaryGmd = number | null;

export type BoitelClosureSummaryGdc = number | null;

export type BoitelClosureSummaryEntryFreight = number | null;

export type BoitelClosureSummaryDiscountPercent = number | null;

export type BoitelClosureSummaryDailyRate = number | null;

/**
 * Taxa de correção/antecipação mensal (fração, ex.: 0.025)
 */
export type BoitelClosureSummaryCorrectionPercent = number | null;

export type BoitelClosureSummaryConfinementDays = number | null;

export type BoitelClosureSummaryCarcassYieldPercent = number | null;

export type BoitelClosureSummaryAtSignProduced = number | null;

/**
 * Dados FDM/PC/OV agregados para o fechamento Boitel
 */
export interface BoitelClosureSummary {
  atSignProduced: BoitelClosureSummaryAtSignProduced;
  averageCarcassAtSign: number;
  averageCarcassKg: number;
  averageEntryKg: number;
  averageExitKg: number;
  carcassYieldPercent: BoitelClosureSummaryCarcassYieldPercent;
  confinementDays: BoitelClosureSummaryConfinementDays;
  /** Taxa de correção/antecipação mensal (fração, ex.: 0.025) */
  correctionPercent: BoitelClosureSummaryCorrectionPercent;
  dailyRate: BoitelClosureSummaryDailyRate;
  discountPercent: BoitelClosureSummaryDiscountPercent;
  entryFreight: BoitelClosureSummaryEntryFreight;
  gdc: BoitelClosureSummaryGdc;
  gmd: BoitelClosureSummaryGmd;
  oxenCount: number;
  oxenPurchaseId: number;
  partnerName: BoitelClosureSummaryPartnerName;
  purchaseName: string;
  /** Quantidade de animais negociados no pedido de compra (cab. contratadas) */
  purchaseOxenAmount: BoitelClosureSummaryPurchaseOxenAmount;
  saleOrders: BoitelClosureSummarySaleOrder[];
  senarPercent: BoitelClosureSummarySenarPercent;
  slaughterDate: BoitelClosureSummarySlaughterDate;
  slaughterhouse: BoitelClosureSummarySlaughterhouse;
  totalCarcassAtSign: number;
  totalCarcassKg: number;
  /** Peso vivo total de entrada (kg) — soma dos pesos de entrada dos animais abatidos */
  totalEntryKg: number;
}

export interface BoardOxResponse {
  covWeight: number;
  gmd: number;
  totalBoarded: number;
  truck: BoardOxResponseTruck;
  weightAverage: number;
}

export type BoardOxResponseTruckSaleOrderId = number | null;

export type BoardOxResponseTruckSaleId = number | null;

export type BoardOxResponseTruckPlate = string | null;

export type BoardOxResponseTruckName = string | null;

export type BoardOxResponseTruckInfo = string | null;

export type BoardOxResponseTruckHoldingSaleId = number | null;

export type BoardOxResponseTruckExitGtaSeries = string | null;

export type BoardOxResponseTruckExitGta = string | null;

export type BoardOxResponseTruckDestinyId = number | null;

export type BoardOxResponseTruckBoardingItem = {
  id: number;
  ownerId: number;
};

export type BoardOxResponseTruckBigWeighingMachineWeightKg = number | null;

export type BoardOxResponseTruckAnnouncementId = number | null;

export type BoardOxResponseTruck = {
  announcementId: BoardOxResponseTruckAnnouncementId;
  bigWeighingMachineWeightKg: BoardOxResponseTruckBigWeighingMachineWeightKg;
  boarding: BoardOxResponseTruckBoardingItem[];
  capacity: number;
  destinyId: BoardOxResponseTruckDestinyId;
  exitAt: string;
  exitGta: BoardOxResponseTruckExitGta;
  exitGtaSeries: BoardOxResponseTruckExitGtaSeries;
  farmId: number;
  holdingSaleId: BoardOxResponseTruckHoldingSaleId;
  id: number;
  info: BoardOxResponseTruckInfo;
  isVisible: boolean;
  name: BoardOxResponseTruckName;
  plate: BoardOxResponseTruckPlate;
  reason: EnumsExitReason;
  saleId: BoardOxResponseTruckSaleId;
  saleOrderId: BoardOxResponseTruckSaleOrderId;
  status: EnumsExitTruckStatus;
};

export interface BoardOx {
  computerName: string;
  currentOxWeight: number;
  dentitionStage?: EnumsDentitionStage;
  macAddress: string;
  /** Opcional — UUID da sessão de manejo (`managements.uuid`) tipo SALE, para linha no comprovante/extrato. */
  managementSessionUuid?: string;
  oxId: number;
  salesMarketType?: EnumsSalesMarketType;
}

export interface BndVerificationQuery {
  ownerId: number;
}

export interface BndVerification {
  birth: string;
  birthBnd: string;
  breed: string;
  breedBnd: string;
  gender: EnumsOxGender;
  genderBnd: EnumsOxGender;
  sisbov: number;
}

export type BndVerificationResponse = BndVerification[];

export interface BndDesagreementBody {
  expedition: string;
  ownerId: number;
}

export interface BndAgreementBody {
  ownerId: number;
}

export interface BirthAnnouncement {
  birth: string;
  gender: EnumsOxGender;
  owner?: string;
  sisbov: number;
}

export type BiotypeWeightGainCurveVariety = string | null;

export type BiotypeWeightGainCurveType =
  (typeof BiotypeWeightGainCurveType)[keyof typeof BiotypeWeightGainCurveType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BiotypeWeightGainCurveType = {
  BIOTYPE: "BIOTYPE",
} as const;

export type BiotypeWeightGainCurvePointsItem = {
  gain: number;
  id: number;
  period: number;
};

export interface BiotypeWeightGainCurve {
  createdAt: string;
  farmId: number;
  gender: EnumsOxGender;
  id: number;
  isDefault: boolean;
  name: string;
  points: BiotypeWeightGainCurvePointsItem[];
  startedAt: string;
  type: BiotypeWeightGainCurveType;
  variety: BiotypeWeightGainCurveVariety;
}

export interface BeatViewResponse {
  avulsas: BeatRecipes;
  recipes: BeatRecipes;
}

export type BeatRecipesStocks = {
  [key: string]: {
    fabricated: number;
    foreseen: number;
    realized: number;
    stockName: string;
  };
};

export type BeatRecipesRecipesItemMixer = {
  code: number;
  name: string;
};

export type BeatRecipesRecipesItem = {
  code: number;
  mixer: BeatRecipesRecipesItemMixer;
};

export type BeatRecipesRealizedListItemStock = {
  name: string;
};

export type BeatRecipesRealizedListItemSequence = number | null;

export type BeatRecipesRealizedListItemRealizedAt = string | null;

export type BeatRecipesRealizedListItemMixerId = number | null;

export type BeatRecipesRealizedListItemForeseen = number | null;

export type BeatRecipesRealizedListItemFeederId = number | null;

export type BeatRecipesRealizedListItemDiet = {
  name: string;
};

export type BeatRecipesRealizedListItem = {
  day: string;
  diet: BeatRecipesRealizedListItemDiet;
  dietId: number;
  farmId: number;
  feederId: BeatRecipesRealizedListItemFeederId;
  foreseen?: BeatRecipesRealizedListItemForeseen;
  id: number;
  mixerId: BeatRecipesRealizedListItemMixerId;
  realizedAt: BeatRecipesRealizedListItemRealizedAt;
  realizedNaturalMatter: number;
  sequence: BeatRecipesRealizedListItemSequence;
  stock: BeatRecipesRealizedListItemStock;
  stockId: number;
};

export type BeatRecipesFabricated = {
  kiloPrice: number;
  naturalMatterFactor: number;
};

export type BeatRecipesCurrent = {
  kiloPrice: number;
  naturalMatterFactor: number;
};

export interface BeatRecipes {
  [key: string]: {
    current: BeatRecipesCurrent;
    dietName: string;
    fabricated: BeatRecipesFabricated;
    realizedList: BeatRecipesRealizedListItem[];
    recipes: BeatRecipesRecipesItem[];
    stocks: BeatRecipesStocks;
    totalFabricated: number;
    totalForeseen: number;
    totalRealized: number;
  };
}

export type BeatRealizedSnapshotSequence = number | null;

export type BeatRealizedSnapshotRealizedAt = string | null;

export type BeatRealizedSnapshotMixerId = number | null;

export type BeatRealizedSnapshotForeseen = number | null;

export type BeatRealizedSnapshotFeederId = number | null;

export interface BeatRealizedSnapshot {
  day: string;
  dietId: number;
  farmId: number;
  feederId: BeatRealizedSnapshotFeederId;
  foreseen: BeatRealizedSnapshotForeseen;
  id: number;
  key: string;
  mixerId: BeatRealizedSnapshotMixerId;
  realizedAt: BeatRealizedSnapshotRealizedAt;
  realizedNaturalMatter: number;
  sequence: BeatRealizedSnapshotSequence;
  stockId: number;
}

export type BatchesOxenResponseOwnerItem = string | unknown;

export interface BatchesOxenResponse {
  corral: BatchesOxenResponseCorral;
  id: number;
  name: string;
  owner: BatchesOxenResponseOwnerItem[];
  oxenAmount: number;
  weightAverage: number;
}

export type BatchesOxenResponseCorralAnyOf = {
  id: number;
  name: string;
  type: EnumsCorralType;
};

export type BatchesOxenResponseCorral = BatchesOxenResponseCorralAnyOf | null;

export type BatchesDetailsResponse = BatchesDetailsResponseItem[];

export type BatchesDetailsResponseItemScaledToSlaughter = boolean | null;

export type BatchesDetailsResponseItemForeseenSlaughterDate = string | null;

export type BatchesDetailsResponseItemDietDiet = {
  name: string;
};

export type BatchesDetailsResponseItemDiet = {
  diet: BatchesDetailsResponseItemDietDiet;
};

export type BatchesDetailsResponseItemCorralAnyOf = {
  name: string;
  type: EnumsCorralType;
};

export type BatchesDetailsResponseItemCorral =
  BatchesDetailsResponseItemCorralAnyOf | null;

export type BatchesDetailsResponseItemActivatedAt = string | null;

export type BatchesDetailsResponseItem = {
  activatedAt: BatchesDetailsResponseItemActivatedAt;
  breeds: string[];
  corral: BatchesDetailsResponseItemCorral;
  createdAt: string;
  diet?: BatchesDetailsResponseItemDiet;
  entryType: EnumsOxPurpose[];
  foreseenSlaughterDate: BatchesDetailsResponseItemForeseenSlaughterDate;
  genders: EnumsOxGender[];
  id: number;
  name: string;
  owner: string[];
  oxenAmount: number;
  price: number;
  scaledToSlaughter: BatchesDetailsResponseItemScaledToSlaughter;
  weightAverage?: number;
};

export type BatchWeightGainCurveType =
  (typeof BatchWeightGainCurveType)[keyof typeof BatchWeightGainCurveType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchWeightGainCurveType = {
  BATCH: "BATCH",
} as const;

export type BatchWeightGainCurvePointsItem = {
  gain: number;
  id: number;
  period: number;
};

export interface BatchWeightGainCurve {
  createdAt: string;
  farmId: number;
  id: number;
  isDefault: boolean;
  name: string;
  points: BatchWeightGainCurvePointsItem[];
  type: BatchWeightGainCurveType;
}

export type BatchStatsResponseOxenItemSisbov = string | null;

export type BatchStatsResponseOxenItemIdentifier = string | null;

export type BatchStatsResponseOxenItemElectronic = string | null;

export type BatchStatsResponseOxenItem = {
  breed: string;
  electronic: BatchStatsResponseOxenItemElectronic;
  gender: EnumsOxGender;
  identifier: BatchStatsResponseOxenItemIdentifier;
  sisbov: BatchStatsResponseOxenItemSisbov;
  weight: number;
};

export interface BatchStatsResponse {
  capacity?: number;
  cov: number;
  oxen: BatchStatsResponseOxenItem[];
  oxenAmount: number;
  weightAverage: number;
}

/**
 * Estado atual de venda de um lote.
 */
export interface BatchSaleState {
  /** Dados do lote relevantes para a correção. */
  batch: BatchSaleStateBatch;
  /** Caminhões/vendas que tocam este lote. */
  sales: SaleTruck[];
  /** Animais do lote sem caminhão (transferências / não embarcados). */
  unassignedOxen: SaleOxRow[];
}

export type BatchSaleStateBatchFinalizedAt = string | null;

/**
 * Custo de compra do lote (override). $/cab = custo / oxenCount.
 */
export type BatchSaleStateBatchAdjustedPurchaseCost = number | null;

/**
 * Dados do lote relevantes para a correção.
 */
export type BatchSaleStateBatch = {
  /** Custo de compra do lote (override). $/cab = custo / oxenCount. */
  adjustedPurchaseCost: BatchSaleStateBatchAdjustedPurchaseCost;
  /** Rendimento de carcaça de entrada (fração, ex.: 0.5). */
  carcass: number;
  /** Peso vivo médio de entrada (kg). */
  entryLiveWeightAvg: number;
  /** Valor de venda previsto ($/@). */
  exitPrice: number;
  finalizedAt: BatchSaleStateBatchFinalizedAt;
  /** Rendimento de carcaça previsto (fração). */
  foreseenCarcass: number;
  id: number;
  name: string;
  /** Total de vínculos OxOnBatches — divisor do custo $/cab. */
  oxenCount: number;
};

export type BatchSaleCorrectionResultDiff = {
  batch: FieldDiff[];
  conversions: ConversionResult[];
  entryWeights: EntryWeightDiff[];
  imports: ImportResult[];
  removals: RemovalResult[];
  sales: SaleDiff[];
};

export interface BatchSaleCorrectionResult {
  /** `true` quando as mudanças foram efetivamente gravadas. */
  applied: boolean;
  diff: BatchSaleCorrectionResultDiff;
  dryRun: boolean;
  warnings: string[];
}

export type BatchSaleCorrectionOptionFinalizedAt = string | null;

/**
 * Item do seletor de lotes.
 */
export interface BatchSaleCorrectionOption {
  finalizedAt: BatchSaleCorrectionOptionFinalizedAt;
  id: number;
  name: string;
}

/**
 * Resumo de quantos registros foram extraídos de cada tabela.
 */
export type BatchRestoreResultTablesItem = {
  count: number;
  label: string;
  table: string;
};

/**
 * Um lote incluído no arquivo de restauração.
 */
export type BatchRestoreResultBatchesItem = {
  id: number;
  name: string;
};

/**
 * Resultado da geração do SQL de restauração.
 */
export interface BatchRestoreResult {
  /** Lotes incluídos no arquivo. */
  batches: BatchRestoreResultBatchesItem[];
  /** Nome sugerido do arquivo `.sql`. */
  filename: string;
  /** Conteúdo completo do arquivo `.sql`. */
  sql: string;
  /** Quantidade de registros encontrados por tabela (somando todos os lotes). */
  tables: BatchRestoreResultTablesItem[];
}

export interface BatchReactivationSearchResult {
  groups: BatchReactivationGroup[];
  /** Sisbovs não encontrados, animais vivos ou sem lote */
  ignored: BatchReactivationSearchResultIgnoredItem[];
}

export interface BatchReactivationSearchBody {
  sisbovs: string[];
}

export type BatchReactivationIgnoredReason =
  (typeof BatchReactivationIgnoredReason)[keyof typeof BatchReactivationIgnoredReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchReactivationIgnoredReason = {
  NOT_FOUND: "NOT_FOUND",
  ALIVE: "ALIVE",
  NO_BATCH: "NO_BATCH",
} as const;

export type BatchReactivationSearchResultIgnoredItem = {
  reason: BatchReactivationIgnoredReason;
  sisbov: string;
};

export type BatchReactivationGroupTreatmentName = string | null;

/**
 * Último tratamento do lote (será reaproveitado na reativação). Null se nunca teve.
 */
export type BatchReactivationGroupTreatmentId = number | null;

export type BatchReactivationGroupOldCorralId = number | null;

export type BatchReactivationGroupDietName = string | null;

/**
 * Última dieta do lote (será reaproveitada na reativação). Null se nunca teve.
 */
export type BatchReactivationGroupDietId = number | null;

export type BatchReactivationGroupAnimalsItemSisbov = string | null;

export type BatchReactivationGroupAnimalsItem = {
  oxId: number;
  sisbov: BatchReactivationGroupAnimalsItemSisbov;
};

export interface BatchReactivationGroup {
  animals: BatchReactivationGroupAnimalsItem[];
  batchId: number;
  /** Última dieta do lote (será reaproveitada na reativação). Null se nunca teve. */
  dietId: BatchReactivationGroupDietId;
  dietName: BatchReactivationGroupDietName;
  finalized: boolean;
  /** "Curral - Lote - Descrição" */
  name: string;
  /** True se outro lote já usa o oldCorral como corralId → precisa escolher curral de destino */
  needsCorralSelection: boolean;
  /** True quando o lote não tem dieta anterior → front precisa informar uma */
  needsDietSelection: boolean;
  /** True quando o lote não tem tratamento anterior → front precisa informar um */
  needsTreatmentSelection: boolean;
  oldCorralId: BatchReactivationGroupOldCorralId;
  /** Último tratamento do lote (será reaproveitado na reativação). Null se nunca teve. */
  treatmentId: BatchReactivationGroupTreatmentId;
  treatmentName: BatchReactivationGroupTreatmentName;
}

export type BatchLifecycleEventType =
  (typeof BatchLifecycleEventType)[keyof typeof BatchLifecycleEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchLifecycleEventType = {
  ENTRY_HOLDING: "ENTRY_HOLDING",
  ENTRY_TRACEABLE: "ENTRY_TRACEABLE",
  TRANSFER_IN: "TRANSFER_IN",
  TRANSFER_OUT: "TRANSFER_OUT",
  DEATH: "DEATH",
  SLAUGHTER: "SLAUGHTER",
  CLOSING: "CLOSING",
  CORRAL_MOVE: "CORRAL_MOVE",
} as const;

export type BatchLifecycleEventSampleOxId = number | null;

export type BatchLifecycleEventSaleOrderId = number | null;

export type BatchLifecycleEventPurchaseId = number | null;

export type BatchLifecycleEventOtherBatchName = string | null;

export type BatchLifecycleEventOtherBatchId = number | null;

export type BatchLifecycleEventHoldingSaleId = number | null;

export type BatchLifecycleEventDeathCause = string | null;

export interface BatchLifecycleEvent {
  dateEditable: boolean;
  day: string;
  deathCause: BatchLifecycleEventDeathCause;
  editable: boolean;
  holdingSaleId: BatchLifecycleEventHoldingSaleId;
  isInitialEntry: boolean;
  label: string;
  otherBatchId: BatchLifecycleEventOtherBatchId;
  otherBatchName: BatchLifecycleEventOtherBatchName;
  oxenAmount: number;
  oxIds: number[];
  purchaseId: BatchLifecycleEventPurchaseId;
  quantityEditable: boolean;
  reversible: boolean;
  saleOrderId: BatchLifecycleEventSaleOrderId;
  sampleOxId: BatchLifecycleEventSampleOxId;
  type: BatchLifecycleEventType;
}

export type BatchHistoryReportResponseOperationalCostAlertsItem = {
  month: number;
  year: number;
};

export interface BatchHistoryReportResponse {
  carcass: number;
  corral?: string;
  history: BatchHistoryReport[];
  name: string;
  operationalCostAlerts: BatchHistoryReportResponseOperationalCostAlertsItem[];
}

export interface BatchHistoryReportFilter {
  batchId: number;
  end?: string;
  start: string;
}

/**
 * Total $ extra
 */
export type BatchHistoryReportTotalExtra = number | null;

export interface BatchHistoryReport {
  /** Compra de Animais (???) */
  animalsPurchase: number;
  /** Comissão da compra de animais */
  animalsPurchaseCommission: number;
  /** Frete da compra de animais */
  animalsPurchaseShipping: number;
  /** PV (kg/cab) */
  avgWeight?: number;
  /** Diária de trati ($/cab/d) */
  dailyTract?: number;
  day: string;
  /** Dias de uso da dieta atual */
  daysOfCurrentDiet: number;
  /** Morte de animais */
  deaths: number;
  /** Consumo ms (kg/cab) */
  dryMatterConsume?: number;
  /** Saldo */
  entryAndExitOxenBalance: number;
  /** Entrada de animais */
  entryOxen: number;
  /** Saida de animais */
  exitOxen: number;
  /** Consumo previsto ms (kg) */
  foreseenDryMatterConsume?: number;
  /** Consumo previsto mo (kg) */
  foreseenNaturalMatterConsume: number;
  /** PV Ini (kg/cab) */
  initialAvgWeight: number;
  /** Cons (kgMS/%PV) */
  liveWeightDryMatterConsume: number;
  /** Cons (kgMO/%PV) */
  liveWeightNaturalMatterConsume: number;
  /** Consumo mo (kg/cab) */
  naturalMatterConsume?: number;
  /** Cons Fabr MO(kg) */
  naturalMatterFabricationConsume?: number;
  /** Animais (cab) */
  oxenAmount?: number;
  /** Retorno à pasto */
  pastureReturns: number;
  /** Consumo real ms */
  realDryMatterConsume?: number;
  /** Consumo real mo */
  realNaturalMatterConsume?: number;
  /** Total $ administrativo */
  totalAdministrativeCost: number;
  /** Total $ Compra de Animais */
  totalAnimalPurchase: number;
  /** Total diaria */
  totalDaily: number;
  /** Total diaria de trato */
  totalDailyTract?: number;
  /** Total $ fabricação de dieta */
  totalDietFabrication: number;
  /** Total $ extra */
  totalExtra: BatchHistoryReportTotalExtra;
  /** Total consumo mo fabricação */
  totalNaturalMatterFabricationConsume?: number;
  /** Total $ total */
  totalTotal: number;
  /** Total $ custo de trato */
  totalTractCost: number;
  /** Tota consumo ms do trato */
  totalTractDryMatterConsume?: number;
  /** Total consumo mo do trato */
  totalTractNaturalMatterConsume?: number;
  /** Total de insumos veterinários */
  totalVeterinarySupplies: number;
  /** Total PV */
  totalWeight: number;
  /** Custo de trato */
  tractDayCost: number;
  /** Tratos */
  tracts?: number;
}

export type BatchForecastResponse = BatchForecastResponseItem[];

export type BatchForecastResponseItemPeriodCA = number | "-";

export type BatchForecastResponseItemAccumulatedCA = number | "-";

export type BatchForecastResponseItem = {
  accumulatedBiologicalEfficiency: number;
  accumulatedCA: BatchForecastResponseItemAccumulatedCA;
  accumulatedProductionCost: number;
  biologicalEfficiencyPeriod: number;
  breakeven: number;
  /** CMS (kg/dia) */
  cms: number;
  /** CMS acum. (kg) */
  cmsAccumulated: number;
  /** CMS (%PV) */
  cmsPv: number;
  dailyFoodCost: number;
  /** Dia */
  day: string;
  /** Dias conf. Per. */
  daysConfined: number;
  /** Dias conf. Acum. */
  daysConfinedAccumulated: number;
  /** ELg (Mcal/kg) */
  elg: number;
  estimatedCarcassWeight: number;
  finalWeight: number;
  foodContributionMargin: number;
  forecastRevenue: number;
  /** GMD Período (kg/dia) */
  gmd: number;
  /** GMD acum. (kg/dia) */
  gmdAccumulated: number;
  grossContributionMargin: number;
  initialWeight: number;
  /** Nº Cab. */
  oxenCount: number;
  periodCA: BatchForecastResponseItemPeriodCA;
  productionCost: number;
  yieldPct: number;
};

export type BatchEntryDateOptionActivatedAt = string | null;

/**
 * Item do seletor de lotes.
 */
export interface BatchEntryDateOption {
  activatedAt: BatchEntryDateOptionActivatedAt;
  createdAt: string;
  id: number;
  name: string;
  /** Total de vínculos OxOnBatches do lote. */
  oxenCount: number;
}

/**
 * Quantidade de registros afetados pela troca de data.
 */
export interface BatchEntryDateAffected {
  /** BatchHistory REPLICATED criados no gap. */
  batchHistoryCreated: number;
  /** BatchHistory DAY_0 re-datado (0 ou 1). */
  batchHistoryRedated: number;
  /** DietOnBatches.createdAt movidos. */
  dietLinks: number;
  /** Ox.includedAt/blockedUntil movidos. */
  oxen: number;
  /** OxOnBatches.createdAt movidos. */
  oxOnBatches: number;
  /** OxWeight de entrada movidos. */
  oxWeights: number;
  /** TreatmentOnBatches.createdAt movidos. */
  treatmentLinks: number;
  /** TreatRealized zerados criados no gap. */
  treatRealizedCreated: number;
}

export type BatchDetailsResponseSlaughter = string | 0;

export type BatchDetailsResponseScaledToSlaughter = boolean | null;

export type BatchDetailsResponseOwner = {
  id: number;
  name: string;
};

export type BatchDetailsResponseForeseenSlaughterDate = string | null;

export type BatchDetailsResponseDiet = {
  estimatedWeightGain: number;
  name: string;
};

export interface BatchDetailsResponse {
  activatedAt: BatchDetailsResponseActivatedAt;
  activationEditDeletedTreats: boolean;
  activationEditedAt: BatchDetailsResponseActivationEditedAt;
  activationEditRemovedOxen: boolean;
  adjustedPurchaseCost: BatchDetailsResponseAdjustedPurchaseCost;
  admCost: number;
  batchDescrption: BatchDetailsResponseBatchDescrption;
  batchName: string;
  breeds: string[];
  carcass: number;
  corral: BatchDetailsResponseCorral;
  createdAt: string;
  date: string;
  diet?: BatchDetailsResponseDiet;
  entryOxenAmount: number;
  exitPrice: number;
  foreseenCarcass: number;
  foreseenSlaughterDate: BatchDetailsResponseForeseenSlaughterDate;
  foreseenWeight: number;
  genders: EnumsOxGender[];
  id: number;
  initialWeightAverage: number;
  isUsingAdjustedCost: boolean;
  name: string;
  otherCost: number;
  owner?: BatchDetailsResponseOwner;
  oxenAmount: number;
  price: number;
  priceAtSign: number;
  scaledToSlaughter: BatchDetailsResponseScaledToSlaughter;
  slaughter: BatchDetailsResponseSlaughter;
  type?: EnumsOxPurpose;
  varieties: string[];
  weightAverage: number;
}

export type BatchDetailsResponseCorralAnyOf = {
  id: number;
  name: string;
  type: EnumsCorralType;
};

export type BatchDetailsResponseCorral = BatchDetailsResponseCorralAnyOf | null;

export type BatchDetailsResponseBatchDescrption = string | null;

export type BatchDetailsResponseAdjustedPurchaseCost = number | null;

export type BatchDetailsResponseActivationEditedAt = string | null;

export type BatchDetailsResponseActivatedAt = string | null;

export type BatchCurveOnBatchesItemTransitionWeightKg = number | null;

export type BatchCurveOnBatchesItemFinalizedAt = string | null;

export type BatchCurveOnBatchesItemCurve = {
  id: number;
  name: string;
  type: EnumsWeightGainCurveType;
};

export interface BatchCurveOnBatchesItem {
  batchId: number;
  createdAt: string;
  curve: BatchCurveOnBatchesItemCurve;
  curveId: number;
  finalizedAt: BatchCurveOnBatchesItemFinalizedAt;
  id: number;
  isVirtual?: boolean;
  transitionWeightKg?: BatchCurveOnBatchesItemTransitionWeightKg;
}

export interface BatchClosingDateAffected {
  batch: number;
  oxen: number;
  oxOnBatches: number;
}

export type BatchActivationOxenPolicy =
  (typeof BatchActivationOxenPolicy)[keyof typeof BatchActivationOxenPolicy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchActivationOxenPolicy = {
  KEEP_DATES: "KEEP_DATES",
  MOVE_TO_NEW_DATE: "MOVE_TO_NEW_DATE",
  REMOVE: "REMOVE",
} as const;

export interface BatchActivationDateAffected {
  batchCreatedAtUpdated: number;
  consumesDeleted: number;
  corralOnBatchesUpdated: number;
  dietOnBatchesUpdated: number;
  historiesDeleted: number;
  oxenUpdated: number;
  oxOnBatchesRemoved: number;
  oxOnBatchesUpdated: number;
  treatmentOnBatchesUpdated: number;
  treatsDeleted: number;
  weightGainCurveOnBatchesUpdated: number;
}

export type BakingEfficiencyReportDataResponseItemSequence = number | null;

export type BakingEfficiencyReportDataResponseItemMixer = string | null;

export type BakingEfficiencyReportDataResponseItemHour = number | null;

export type BakingEfficiencyReportDataResponseItemForeseen = {
  amount: number;
  food: number;
};

export type BakingEfficiencyReportDataResponseItemFeeder = string | null;

export interface BakingEfficiencyReportDataResponseItem {
  day: string;
  diet: string;
  diffFood: number;
  feeder: BakingEfficiencyReportDataResponseItemFeeder;
  food: string;
  foreseen: BakingEfficiencyReportDataResponseItemForeseen;
  hour: BakingEfficiencyReportDataResponseItemHour;
  mixer: BakingEfficiencyReportDataResponseItemMixer;
  producedFabrication: number;
  realDryMatterFood: number;
  realFood: number;
  sequence: BakingEfficiencyReportDataResponseItemSequence;
  treatedFabrication: number;
}

/**
 * Origem do backup, gravada no `metadata.json` só por rastreabilidade (não exibida em nenhuma tela).

- `FARM_INITIALIZATION`: backup automático da criação de uma fazenda nova.
- `FARM_MIGRATION`: backup inicial de uma fazenda já existente, no fluxo "subir backup de fazenda já existente" do   onboarding desktop.
- `DESKTOP` / `WEB`: botão "Salvar Backup" clicado manualmente em cada versão.
- `AUTO`: gerado por algum mecanismo automático (ainda sem implementação).
 */
export type BackupSource = (typeof BackupSource)[keyof typeof BackupSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupSource = {
  FARM_INITIALIZATION: "FARM_INITIALIZATION",
  FARM_MIGRATION: "FARM_MIGRATION",
  DESKTOP: "DESKTOP",
  WEB: "WEB",
  AUTO: "AUTO",
} as const;

export type BackupExportProgressStage =
  (typeof BackupExportProgressStage)[keyof typeof BackupExportProgressStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupExportProgressStage = {
  idle: "idle",
  preparing: "preparing",
  dumping: "dumping",
  compressing: "compressing",
  uploading: "uploading",
  done: "done",
  error: "error",
} as const;

export interface BackupExportProgress {
  current: number;
  message: string;
  stage: BackupExportProgressStage;
  total: number;
}

export interface AuditManagementDto {
  bacthOrigin: number;
  batchDestiny: number;
  electronic: string;
  gta: string;
  metadata: string;
  oxId: number;
  sisbov: string;
}

export interface AuditFinalizeBatchesResponse {
  checked: number;
  success: boolean;
}

export type ApplyWeighingEventResultOxWeightId = number | null;

/**
 * Mudança de raça/sexo ficou num comunicado pendente (fazenda com rastreabilidade)
 */
export type ApplyWeighingEventResultAnnouncementId = number | null;

export interface ApplyWeighingEventResult {
  /** Mudança de raça/sexo ficou num comunicado pendente (fazenda com rastreabilidade) */
  announcementId: ApplyWeighingEventResultAnnouncementId;
  /** False = evento já aplicado numa chamada anterior; nada foi tocado agora */
  applied: boolean;
  /** O animal trocou de lote */
  moved: boolean;
  oxWeightId: ApplyWeighingEventResultOxWeightId;
}

/**
 * Pesagem feita offline no manejo de pesagem, enviada pela auditoria
 */
export interface ApplyWeighingEvent {
  /** Nova raça; omitida ou igual à atual = mantida */
  breed?: string;
  /** Id do evento na máquina que pesou; a mesma chamada repetida não pesa de novo */
  clientEventId: string;
  computerName?: string;
  /** Lote da apartação */
  destinationBatchId: number;
  /** Novo sexo; omitido ou igual ao atual = mantido */
  gender?: EnumsOxGender;
  macAddress?: string;
  oxId: number;
  /** Quando a balança leu; vira a data do peso, limitada ao dia da fazenda */
  weighedAt: string;
  /** Peso lido na balança, em kg */
  weight: number;
}

export type ApplySaleDateEditResultKind =
  (typeof ApplySaleDateEditResultKind)[keyof typeof ApplySaleDateEditResultKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplySaleDateEditResultKind = {
  SALE_ORDER: "SALE_ORDER",
  HOLDING_SALE: "HOLDING_SALE",
} as const;

/**
 * Data antes da troca.
 */
export type ApplySaleDateEditResultBefore = string | null;

/**
 * Resultado da edição (ou pré-visualização, com `dryRun`).
 */
export interface ApplySaleDateEditResult {
  affected: SaleDateEditAffected;
  /** Data depois da troca. */
  after: string;
  /** `true` quando as mudanças foram efetivamente gravadas. */
  applied: boolean;
  /** Data antes da troca. */
  before: ApplySaleDateEditResultBefore;
  dryRun: boolean;
  id: number;
  kind: ApplySaleDateEditResultKind;
  label: string;
  warnings: string[];
}

export type ApplySaleDateEditBodyKind =
  (typeof ApplySaleDateEditBodyKind)[keyof typeof ApplySaleDateEditBodyKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplySaleDateEditBodyKind = {
  SALE_ORDER: "SALE_ORDER",
  HOLDING_SALE: "HOLDING_SALE",
} as const;

/**
 * Corpo da requisição de edição (preview + aplicação).
 */
export interface ApplySaleDateEditBody {
  /** `true` = apenas calcula o impacto, não grava nada. */
  dryRun: boolean;
  /** Id de SaleOrder ou HoldingSale. */
  id: number;
  kind: ApplySaleDateEditBodyKind;
  /** Nova data de saída (YYYY-MM-DD). */
  newDate: string;
}

export type ApplyRevertSaleOrderResultBatchesItemCorralId = number | null;

export type ApplyRevertSaleOrderResultBatchesItem = {
  batchId: number;
  corralId: ApplyRevertSaleOrderResultBatchesItemCorralId;
};

export interface ApplyRevertSaleOrderResult {
  batches: ApplyRevertSaleOrderResultBatchesItem[];
  historiesCreated: number;
  revivedOxCount: number;
  treatsCreated: number;
}

/**
 * Curral em que o lote reabriu; nulo quando o lote seguia ativo.
 */
export type ApplyRevertHoldingSaleResultCorralId = number | null;

export interface ApplyRevertHoldingSaleResult {
  batchId: number;
  /** Curral em que o lote reabriu; nulo quando o lote seguia ativo. */
  corralId: ApplyRevertHoldingSaleResultCorralId;
  historiesCreated: number;
  revivedOxCount: number;
  treatsCreated: number;
}

export interface ApplyPastureToPicketResult {
  batchId: number;
  corralId: number;
  filledDays: number;
}

export interface ApplyEntryEventResult {
  /** False = evento já aplicado numa chamada anterior; nada foi tocado agora */
  applied: boolean;
  /** Animal criado (ou reaproveitado numa chamada repetida) */
  oxId: number;
}

/**
 * Animal cadastrado offline no manejo de entrada, enviado pela auditoria
 */
export interface ApplyEntryEvent {
  ageInMonths: number;
  /** Raça da fazenda; a raça BND sai do padrão configurado no manejo */
  breed: string;
  category: EnumsOxCategory;
  /** Id do evento na máquina que cadastrou; a mesma chamada repetida não cria o animal de novo */
  clientEventId: string;
  /** Quando o operador confirmou; vira o dia de inclusão do animal, limitado ao dia da fazenda */
  collectedAt: string;
  computerName?: string;
  dentitionStage?: EnumsDentitionStage;
  /** Lote da apartação */
  destinationBatchId: number;
  /** Brinco eletrônico */
  electronic?: string;
  extraMedicineIds?: number[];
  gender: EnumsOxGender;
  /** GTA do pedido de compra do manejo que cede a vaga */
  gtaId: number;
  healthProtocolId?: number;
  /** Brinco extra */
  identifier?: string;
  macAddress?: string;
  /** SISBOV com 15 dígitos */
  sisbov?: string;
  /** Peso de entrada lido na balança, em kg */
  weight: number;
}

export interface ApplyBulkDietTransitionGroup {
  batchIds: number[];
  /** Dieta alvo, que passa a valer quando a transição terminar */
  dietId: number;
  transitionId: number;
}

export interface ApplyBulkDietTransitionFailure {
  batchId: number;
  message: string;
  name: string;
}

export interface ApplyBulkDietTransitionResult {
  applied: number;
  failures: ApplyBulkDietTransitionFailure[];
}

export interface ApplyBulkDietTransitionBody {
  groups: ApplyBulkDietTransitionGroup[];
}

/**
 * Edição dos dados de saída de uma venda (aplicada a todos os animais do caminhão).
 */
export type ApplyBatchSaleCorrectionBodySalesItem = {
  carcassWeight?: number;
  /** Rendimento de carcaça (fração, ex.: 0.56). */
  carcassYield?: number;
  exitLiveWeight?: number;
  priceAtSignExit?: number;
  truckId: number;
};

/**
 * Remoção de um animal de uma venda (estorno).
 */
export type ApplyBatchSaleCorrectionBodyRemovalsItem = {
  oxId: number;
  /** Lote de destino — obrigatório quando o lote do animal está finalizado. */
  targetBatchId?: number;
};

/**
 * Importa N animais de um lote ativo, abate-os e embarca-os num caminhão de venda.
 */
export type ApplyBatchSaleCorrectionBodyImportsItem = {
  /** Quantos animais trazer. */
  qty: number;
  /** Lote ativo de onde tirar os animais. */
  sourceBatchId: number;
  /** Caminhão de venda do lote atual que receberá os animais. */
  toTruckId: number;
};

/**
 * Edição do peso vivo de entrada de um animal.
 */
export type ApplyBatchSaleCorrectionBodyEntryWeightsItem = {
  entryLiveWeight: number;
  oxId: number;
};

/**
 * Conversão de um animal de transferência para venda (embarca num caminhão).
 */
export type ApplyBatchSaleCorrectionBodyConversionsItem = {
  oxId: number;
  /** Caminhão de venda em que o animal será embarcado. */
  toTruckId: number;
};

export type ApplyBatchSaleCorrectionBodyBatchAdjustedPurchaseCost =
  | number
  | null;

/**
 * Dados gerais do lote (entrada e previstos).
 */
export type ApplyBatchSaleCorrectionBodyBatch = {
  adjustedPurchaseCost?: ApplyBatchSaleCorrectionBodyBatchAdjustedPurchaseCost;
  carcass?: number;
  exitPrice?: number;
  foreseenCarcass?: number;
};

export interface ApplyBatchSaleCorrectionBody {
  /** Dados gerais do lote (entrada e previstos). */
  batch?: ApplyBatchSaleCorrectionBodyBatch;
  /** Animais transferência a converter em venda. */
  conversions?: ApplyBatchSaleCorrectionBodyConversionsItem[];
  /** `true` = apenas calcula o diff antes/depois, não grava nada. */
  dryRun: boolean;
  /** Peso vivo de entrada por animal. */
  entryWeights?: ApplyBatchSaleCorrectionBodyEntryWeightsItem[];
  /** Importações de animais de outros lotes ativos para uma venda. */
  imports?: ApplyBatchSaleCorrectionBodyImportsItem[];
  /** Animais a remover de uma venda (estorno via lote de destino). */
  removals?: ApplyBatchSaleCorrectionBodyRemovalsItem[];
  /** Dados de saída por venda/caminhão. */
  sales?: ApplyBatchSaleCorrectionBodySalesItem[];
}

export interface ApplyBatchReactivationResult {
  batchId: number;
  corralId: number;
  revivedOxIds: number[];
}

export interface ApplyBatchReactivationBody {
  batchId: number;
  /** Curral de destino. Obrigatório só quando needsCorralSelection = true. */
  corralId?: number;
  /** Dieta a usar. Se omitida, reaproveita a última do lote. Obrigatória quando o lote não tem nenhuma. */
  dietId?: number;
  oxIds: number[];
  /** Tratamento a usar. Se omitido, reaproveita o último do lote. Obrigatório quando o lote não tem nenhum. */
  treatmentId?: number;
}

export type ApplyBatchEntryDateEditResultBeforeActivatedAt = string | null;

/**
 * Datas atuais do lote (antes da troca).
 */
export type ApplyBatchEntryDateEditResultBefore = {
  activatedAt: ApplyBatchEntryDateEditResultBeforeActivatedAt;
  createdAt: string;
};

/**
 * Resultado da edição (ou pré-visualização, com `dryRun`).
 */
export interface ApplyBatchEntryDateEditResult {
  affected: BatchEntryDateAffected;
  /** Nova data. */
  after: string;
  /** `true` quando as mudanças foram efetivamente gravadas. */
  applied: boolean;
  batchId: number;
  batchLabel: string;
  /** Datas atuais do lote (antes da troca). */
  before: ApplyBatchEntryDateEditResultBefore;
  dryRun: boolean;
  /** Dias do gap que serão (ou foram) preenchidos. */
  gapDays: string[];
  warnings: string[];
}

/**
 * Corpo da requisição de edição (preview + aplicação).
 */
export interface ApplyBatchEntryDateEditBody {
  batchId: number;
  /** `true` = apenas calcula o impacto, não grava nada. */
  dryRun: boolean;
  /** Nova data de entrada/ativação (YYYY-MM-DD, deve ser anterior à atual). */
  newDate: string;
}

export type ApplyAnimalSwapResultTruckId = number | null;

export interface ApplyAnimalSwapResult {
  destinationBatchName: string;
  killedOxId: number;
  revivedOxId: number;
  truckId: ApplyAnimalSwapResultTruckId;
}

export interface ApplyAnimalSwapBody {
  aliveOxId: number;
  deadOxId: number;
  /** Lote destino do animal morto (que será revivido) */
  destinationBatchId: number;
  /** Peso de saída do animal vivo (que irá morrer) */
  exitWeight: number;
}

export type ApplicationType = EnumsApplicationType;

export type ApplicationSuggestion = EnumsApplicationSuggestion;

export type AnnouncementType = EnumsAnnouncementType;

export interface AnnouncementSearch {
  date?: string;
  emitted?: boolean;
  limit?: number;
  onlyExpired?: boolean;
  owner?: string;
  page?: number;
  sisbov?: string;
  type?: EnumsAnnouncementType;
}

export interface AnimalSwapSearchResult {
  aliveOx: AnimalSwapOxInfo;
  deadOx: AnimalSwapOxInfo;
}

export type AnimalSwapOxInfoSisbov = string | null;

export type AnimalSwapOxInfoIdentifier = string | null;

export type AnimalSwapOxInfoExitTruckId = number | null;

export type AnimalSwapOxInfoElectronic = string | null;

export type AnimalSwapOxInfoDiedAt = string | null;

export type AnimalSwapOxInfoCurrentBatchName = string | null;

export type AnimalSwapOxInfoCurrentBatchId = number | null;

export interface AnimalSwapOxInfo {
  currentBatchId: AnimalSwapOxInfoCurrentBatchId;
  currentBatchName: AnimalSwapOxInfoCurrentBatchName;
  diedAt: AnimalSwapOxInfoDiedAt;
  electronic: AnimalSwapOxInfoElectronic;
  exitTruckId: AnimalSwapOxInfoExitTruckId;
  id: number;
  identifier: AnimalSwapOxInfoIdentifier;
  sisbov: AnimalSwapOxInfoSisbov;
}

export type AnalyticalReportServiceResponseIngredientsItem = {
  name: string;
  usageDays: number;
  usedDryMatterAmount: number;
  usedNaturalMatterAmount: number;
};

export type AnalyticalReportServiceResponseDietsItem = {
  name: string;
  usageDays: number;
  usedDryMatterAmount: number;
  usedNaturalMatterAmount: number;
};

export interface AnalyticalReportServiceResponse {
  averageAdministrativeCost: number;
  averageCarcassGain: number;
  averageCommission: number;
  averageConfinementDays: number;
  /** Média de dias sem processamento (`identifiedAt` - `includedAt`) dos animais processados do lote. */
  averageDaysWithoutProcessing: number;
  averageDryMatterConsumption: number;
  averageGDC: number;
  averageGPD: number;
  averageLiveWeightRate: number;
  averageNaturalMatterConsumption: number;
  averageOtherCosts: number;
  averageProfit: number;
  averagePurchaseCostPerArroba: number;
  averagePurchaseCostPerOxen: number;
  averageSaleValuePerArroba: number;
  averageSaleValuePerOxen: number;
  averageShipping: number;
  averageTreatmentDays: number;
  batchName: string;
  biologicalEfficiency: number;
  /** Distribuição percentual (0-1) do acabamento de carcaça dos animais abatidos no lote. */
  carcassClassification: CarcassClassification;
  categories: EnumsOxCategory[];
  corralName: string;
  dailyFoodCost: number;
  dailyOxenCost: number;
  deadOxenAmount: number;
  diets: AnalyticalReportServiceResponseDietsItem[];
  entryAverageCarcassYield: number;
  entryOxenAmount: number;
  entryTypes: EnumsOxPurpose[];
  exitAverageCarcassWeight: number;
  exitAverageDate: string;
  exitAverageWeight: number;
  exitCarcassYield: number;
  exitOxenAmount: number;
  exitTotalWeight: number;
  farmName: string;
  financialReturnRate: number;
  firstEntryDate: string;
  firstExitDate: string;
  foodConversion: number;
  gainFoodCost: number;
  gateInMargin: number;
  gateOutMargin: number;
  genders: EnumsOxGender[];
  ingredients: AnalyticalReportServiceResponseIngredientsItem[];
  initialAverageDate: string;
  initialAverageWeight: number;
  initialTotalWeight: number;
  lastDietName: string;
  lastEntryDate: string;
  lastExitDate: string;
  monthlyFinancialReturnRate: number;
  mortalityRate: number;
  /** Meses do período do lote sem custo operacional cadastrado. */
  operationalCostAlerts: OperationalCostAlert[];
  ownersNames: string[];
  oxenStartedAtBatchAmount: number;
  pastureReturnOxenAmount: number;
  /** Quantidade de animais processados (identificados) do lote. */
  processedOxenAmount: number;
  projectedCarcassYield: number;
  projectedSaleValue: number;
  purchaseNames: string[];
  remainingOxenAmount: number;
  saleOrderNames: string[];
  slaughteredOxenAmount: number;
  totalCarcassGain: number;
  totalCosts: number;
  totalEnteredOxenAmount: number;
  totalExitedOxenAmount: number;
  totalGainCost: number;
  totalManagementCost: number;
  totalOperationalCost: number;
  /** Quantidade total de animais do lote considerados na rastreabilidade. */
  totalOxenAmount: number;
  totalOxenPurchaseCost: number;
  totalProfit: number;
  totalSaleValue: number;
  totalTreatedDietCost: number;
  totalTreatmentDays: number;
  totalVeterinarySuppliesCost: number;
  transferredInOxenAmount: number;
  transferredOutOxenAmount: number;
  varieties: string[];
}

export interface AnalyticalBatchDaysDetailsReturn {
  confinement: AnalyticalBatchDaysDetail;
  treatment: AnalyticalBatchDaysDetail;
}

/**
 * Data usada como início da contagem (no trato, o primeiro dia com trato lançado)
 */
export type AnalyticalBatchDaysDetailOxStartDate = string | null;

/**
 * Data usada como fim da contagem (no trato, o último dia com trato lançado)
 */
export type AnalyticalBatchDaysDetailOxEndDate = string | null;

/**
 * Dias sem trato lançado entre `startDate` e `endDate` (apenas nos dias de trato; nulo no confinamento)
 */
export type AnalyticalBatchDaysDetailOxDaysWithoutTreat = number | null;

export interface AnalyticalBatchDaysDetailOx {
  /** Total de dias apurado para o animal */
  days: number;
  /** Dias sem trato lançado entre `startDate` e `endDate` (apenas nos dias de trato; nulo no confinamento) */
  daysWithoutTreat: AnalyticalBatchDaysDetailOxDaysWithoutTreat;
  /** Data usada como fim da contagem (no trato, o último dia com trato lançado) */
  endDate: AnalyticalBatchDaysDetailOxEndDate;
  /** Identificação do animal, por precedência: SISBOV → brinco eletrônico → brinco extra → id */
  identification: string;
  oxId: number;
  /** Data usada como início da contagem (no trato, o primeiro dia com trato lançado) */
  startDate: AnalyticalBatchDaysDetailOxStartDate;
}

export interface AnalyticalBatchDaysDetail {
  /** Média exata por animal, sem arredondamento */
  averageDays: number;
  /** Composição do cálculo por animal */
  oxen: AnalyticalBatchDaysDetailOx[];
  /** Valor exibido no relatório */
  result: number;
  /** Quantidade de animais considerados no cálculo */
  totalAnimals: number;
  /** Soma dos dias de todos os animais */
  totalDays: number;
}

export type AdvanceDayReason =
  (typeof AdvanceDayReason)[keyof typeof AdvanceDayReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdvanceDayReason = {
  NO_HISTORY_DONE: "NO_HISTORY_DONE",
  NOT_ALL_BATCHES_WERE_MANAGED: "NOT_ALL_BATCHES_WERE_MANAGED",
  NOT_ALL_TRACTS_WERE_REALIZED: "NOT_ALL_TRACTS_WERE_REALIZED",
  NO_BEAT_CONFIRMATION_DONE: "NO_BEAT_CONFIRMATION_DONE",
  NOT_ALL_BEAT_CONFIRMATIONS_WERE_REALIZED:
    "NOT_ALL_BEAT_CONFIRMATIONS_WERE_REALIZED",
  ALL_REQUIREMENTS_WERE_MET: "ALL_REQUIREMENTS_WERE_MET",
  CANNOT_ADVANCE_CURRENT_DAY: "CANNOT_ADVANCE_CURRENT_DAY",
  INACTIVE_BATCHES: "INACTIVE_BATCHES",
  NO_BIOTYPE_CURVE_FOR_GENDER: "NO_BIOTYPE_CURVE_FOR_GENDER",
  FEED_LINK_FILES_AWAITING_REVIEW: "FEED_LINK_FILES_AWAITING_REVIEW",
} as const;

/**
 * O que o apply grava para a nova data informada.
 */
export interface AdjustHoldingSaleDateSummary {
  date: string;
  /** Dias cujos dados serão apagados (nova data+1 … data atual da venda); vazio quando o lote seguiu ativo. */
  daysToDelete: string[];
  /** Notas de cocho (BatchHistory) que serão apagadas. */
  historiesToDelete: number;
  /** Estoque devolvido pelos tratos apagados. */
  stockReversals: StockReversalItem[];
  /** Realizados de trato que serão apagados. */
  treatsToDelete: number;
  /** Pesos posteriores à nova data que serão apagados (o peso de saída é movido, não apagado). */
  weightsToDelete: number;
}

export interface AdjustHoldingSaleDateResult {
  date: string;
  historiesDeleted: number;
  stockReversals: StockReversalItem[];
  treatsDeleted: number;
  weightsDeleted: number;
}

/**
 * Resumo do que será feito; nulo enquanto a nova data não for informada.
 */
export type AdjustHoldingSaleDatePreviewResultSummary =
  AdjustHoldingSaleDateSummary | null;

export interface AdjustHoldingSaleDatePreviewResult {
  /** Lote foi fechado por esta saída — o período posterior à nova data será apagado e o fechamento re-datado. */
  batchFinalized: boolean;
  batchId: number;
  batchLabel: string;
  /** Data atual da saída — limite superior (exclusivo) da nova data. */
  currentDate: string;
  farmDay: string;
  /** Ativação do lote — limite inferior da nova data. */
  minDate: string;
  /** Animais na saída. */
  oxCount: number;
  /** Resumo do que será feito; nulo enquanto a nova data não for informada. */
  summary: AdjustHoldingSaleDatePreviewResultSummary;
  warnings: string[];
}

/**
 * Body compartilhado do preview e do apply do ajuste de data da saída avulsa.
 */
export interface AdjustHoldingSaleDateBody {
  /** Nova data da saída (YYYY-MM-DD), entre a ativação do lote e a data atual da venda. Ausente no preview → só os limites e o contexto, sem resumo. */
  date?: string;
}

export type AdjustCurrentForeseenResponseReadValue = number | null;

export type AdjustCurrentForeseenResponseReadType = EnumsReadType | null;

export type AdjustCurrentForeseenResponseManagedAt = string | null;

export interface AdjustCurrentForeseenResponse {
  batchId: number;
  clean: boolean;
  day: string;
  farmId: number;
  hideFromTreatment: boolean;
  id: number;
  managedAt: AdjustCurrentForeseenResponseManagedAt;
  matterVariation: number;
  nightlyReads: GlobalPrismaJsonNightlyRead[];
  readType: AdjustCurrentForeseenResponseReadType;
  readValue: AdjustCurrentForeseenResponseReadValue;
  resultingMatter: number;
}

/**
 * Todos os horários para um lote
 */
export interface AdjustCurrentForeseen {
  /** Pode ser undefined caso o ignore management for true */
  adjust?: number;
  /** Somente o ReadType.INVENTORY usa, no momento */
  clean?: boolean;
  /** Caso não devemos marcar o manejo como feito */
  ignoreManagement?: boolean;
  /** Caso queira informar a leitura noturna de */
  nightlyReads?: GlobalPrismaJsonNightlyRead[];
  readType?: EnumsReadType;
  /** Somente o ReadType.INVENTORY usa, no momento */
  readValue?: number;
}

export interface AdjustBatchEntryWeightsResponse {
  /** Pesos CASUAL criados para animais sem registro de entrada */
  created: number;
  /** Animais considerados no relatório analítico do lote */
  totalOxen: number;
  /** Pesos de entrada (ENTRY/CASUAL) atualizados */
  updated: number;
}

export interface AdjustBatchAverageWeightResponse {
  /** Pesos criados para animais sem registro de peso ou cujo último peso é de entrada/identificação/saída */
  created: number;
  /** Animais vivos considerados no lote */
  totalOxen: number;
  /** Últimos pesos atualizados */
  updated: number;
}

export type AddMedicineImagesResponse = AddMedicineImagesResponseItem[];

export type AddMedicineImagesResponseItemName = string | null;

export type AddMedicineImagesResponseItemMedicineId = number | null;

export type AddMedicineImagesResponseItemHealthProtocolId = number | null;

export type AddMedicineImagesResponseItem = {
  base64: string;
  farmId: number;
  healthProtocolId: AddMedicineImagesResponseItemHealthProtocolId;
  id: number;
  medicineId: AddMedicineImagesResponseItemMedicineId;
  name: AddMedicineImagesResponseItemName;
};

export interface AddMedicineImage {
  base64: string;
  name?: string;
}

export type AddHealthProtocolImagesResponse =
  AddHealthProtocolImagesResponseItem[];

export type AddHealthProtocolImagesResponseItemName = string | null;

export type AddHealthProtocolImagesResponseItemMedicineId = number | null;

export type AddHealthProtocolImagesResponseItemHealthProtocolId = number | null;

export type AddHealthProtocolImagesResponseItem = {
  base64: string;
  farmId: number;
  healthProtocolId: AddHealthProtocolImagesResponseItemHealthProtocolId;
  id: number;
  medicineId: AddHealthProtocolImagesResponseItemMedicineId;
  name: AddHealthProtocolImagesResponseItemName;
};

export interface AddHealthProtocolImage {
  base64: string;
  name?: string;
}

export type ActiveBatchesStateResponseResult = ActiveBatchesReportResult | null;

export type ActiveBatchesStateResponseError = string | null;

export interface ActiveBatchesStateResponse {
  error: ActiveBatchesStateResponseError;
  jobId: string;
  progress: ReportJobProgress;
  result: ActiveBatchesStateResponseResult;
  status: ReportJobStatus;
}

export type ActiveBatchesReportOrder =
  (typeof ActiveBatchesReportOrder)[keyof typeof ActiveBatchesReportOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActiveBatchesReportOrder = {
  BY_DAY: "BY_DAY",
  BY_BATCH: "BY_BATCH",
} as const;

export type ActiveBatchesReportItemRecreationDays = {
  ADAPTATION: number;
  FINISHING: number;
  GROWTH: number;
  RECREATION: number;
  SUPPLEMENT: number;
  TERMINATION: number;
};

export type ActiveBatchesReportItemPosition = number | null;

export type ActiveBatchesReportItemPartnerHerd = string | null;

export type ActiveBatchesReportItemForeseenSlaughter = string | null;

export type ActiveBatchesReportItemEntryDate = string | null;

export type ActiveBatchesReportItemConsume = {
  d1dm: number;
  d1nm: number;
  d1pv: number;
  d3dm: number;
  d3nm: number;
  d3pv: number;
  dm: number;
  nm: number;
  pv: number;
};

export interface ActiveBatchesReportItem {
  averageCurrentWeight: number;
  averagePricePerArroba: number;
  averagePurchasePrice: number;
  category: string[];
  confinementDays: number;
  consume: ActiveBatchesReportItemConsume;
  corral?: string;
  dailyCostPerHead: number;
  date: string;
  deathCount: number;
  dietDays: number;
  dietName: string;
  entryDate: ActiveBatchesReportItemEntryDate;
  entryType?: string;
  estimatedWeightGain: number;
  foodCost: number;
  foreseenSlaughter: ActiveBatchesReportItemForeseenSlaughter;
  foreseenWeight: number;
  gender: EnumsOxGender[];
  id: number;
  initialWeightAverage: number;
  name: string;
  ownerName: string;
  oxenAmount: number;
  partnerHerd: ActiveBatchesReportItemPartnerHerd;
  pastureReturn: number;
  position: ActiveBatchesReportItemPosition;
  recreationDays: ActiveBatchesReportItemRecreationDays;
  totalDaily: number;
  treatmentDays: number;
  variety: string[];
}

export interface ActiveBatchesConsumeStatusResponse {
  blocked: boolean;
  missing: number;
  pending: number;
  running: number;
}

export type ActiveBatchesAveragesConsume = {
  d1dm: number;
  d1nm: number;
  d1pv: number;
  d3dm: number;
  d3nm: number;
  d3pv: number;
  dm: number;
  nm: number;
  pv: number;
};

export interface ActiveBatchesAverages {
  averageCurrentWeight: number;
  averagePricePerArroba: number;
  averagePurchasePrice: number;
  confinementDays: number;
  consume: ActiveBatchesAveragesConsume;
  deathCount: number;
  estimatedWeightGain: number;
  foodCost: number;
  foreseenWeight: number;
  initialWeightAverage: number;
  mortality: number;
  operationalCost: number;
  oxenAmount: number;
  percentPastureReturns: number;
  totalCorrals: number;
  totalDaily: number;
  totalOxenAmount: number;
  totalPastureReturns: number;
  treatmentDays: number;
}

export interface ActiveBatchesDayAverages {
  averages: ActiveBatchesAverages;
  date: string;
}

export interface ActiveBatchesReportResult {
  averagesByDay: ActiveBatchesDayAverages[];
  end: string;
  operationalCostAlerts: OperationalCostAlert[];
  report: ActiveBatchesReportItem[];
  start: string;
}

export interface ActivateTreatmentResponse {
  active: boolean;
  createdAt: string;
  divisions: number[];
  farmId: number;
  hours: string[];
  id: number;
  name: string;
}

export type ActivateStockResponsePremix = boolean | null;

export type ActivateStockResponseActive = boolean | null;

export interface ActivateStockResponse {
  active: ActivateStockResponseActive;
  code: string;
  farmId: number;
  id: number;
  loadMode: EnumsLoadMode;
  name: string;
  premix: ActivateStockResponsePremix;
  supplement: boolean;
}

export type ActivateMedicineResponsePerKg = number | null;

export type ActivateMedicineResponseKiloDose = number | null;

export type ActivateMedicineResponseApplicationSuggestion =
  EnumsApplicationSuggestion | null;

export interface ActivateMedicineResponse {
  active: boolean;
  applicationSuggestion: ActivateMedicineResponseApplicationSuggestion;
  blockingDays: number;
  createdAt: string;
  dosePrice: number;
  farmId: number;
  id: number;
  kiloDose: ActivateMedicineResponseKiloDose;
  manufacturer: string;
  measurement: EnumsMeasurement;
  name: string;
  perKg: ActivateMedicineResponsePerKg;
  type: EnumsMedicineType;
}

export interface ActivateHealthProtocolResponse {
  active: boolean;
  createdAt: string;
  farmId: number;
  id: number;
  name: string;
}

export type ActivateEstablishmentResponseCode = string | null;

export type ActivateEstablishmentResponseCattleManifestLayoutId = number | null;

export interface ActivateEstablishmentResponse {
  active: boolean;
  addressId: number;
  cattleManifestLayoutId: ActivateEstablishmentResponseCattleManifestLayoutId;
  code: ActivateEstablishmentResponseCode;
  destiny: boolean;
  farmId: number;
  gov: GlobalPrismaJsonGovDocuments;
  id: number;
  name: string;
  origin: boolean;
  responsibleId: number;
}

export type ActivateBatchResponseOldCorralId = number | null;

export type ActivateBatchResponseFinalizedAt = string | null;

export interface ActivateBatchResponse {
  activatedAt: ActivateBatchResponseActivatedAt;
  corralId: ActivateBatchResponseCorralId;
  createdAt: string;
  descrption: ActivateBatchResponseDescrption;
  diets: ActivateBatchResponseDietsItem[];
  farmId: number;
  finalizedAt: ActivateBatchResponseFinalizedAt;
  id: number;
  liveWeight: number;
  name: string;
  oldCorralId: ActivateBatchResponseOldCorralId;
}

export type ActivateBatchResponseDietsItemFinalizedAt = string | null;

export type ActivateBatchResponseDietsItemDiet = {
  active: boolean;
  category: ActivateBatchResponseDietsItemDietCategory;
  code: ActivateBatchResponseDietsItemDietCode;
  createdAt: string;
  estimatedWeightGain: number;
  expiry: number;
  farmId: number;
  fixedElg: ActivateBatchResponseDietsItemDietFixedElg;
  id: number;
  isPremix: boolean;
  manualElg: boolean;
  manualPrice: boolean;
  name: string;
  observation: ActivateBatchResponseDietsItemDietObservation;
  premixId: ActivateBatchResponseDietsItemDietPremixId;
};

export type ActivateBatchResponseDietsItem = {
  batchId: number;
  createdAt: string;
  diet: ActivateBatchResponseDietsItemDiet;
  dietId: number;
  finalizedAt: ActivateBatchResponseDietsItemFinalizedAt;
  id: number;
};

export type ActivateBatchResponseDietsItemDietPremixId = number | null;

export type ActivateBatchResponseDietsItemDietObservation = string | null;

export type ActivateBatchResponseDietsItemDietFixedElg = number | null;

export type ActivateBatchResponseDietsItemDietCode = string | null;

export type ActivateBatchResponseDietsItemDietCategory =
  EnumsDietCategory | null;

export type ActivateBatchResponseDescrption = string | null;

export type ActivateBatchResponseCorralId = number | null;

export type ActivateBatchResponseActivatedAt = string | null;

export interface ActivateBatch {
  dietId: number;
  liveWeight: number;
  treatmentId?: number;
}

export type EnumsWeightingMapStatus =
  (typeof EnumsWeightingMapStatus)[keyof typeof EnumsWeightingMapStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsWeightingMapStatus = {
  AVAILABLE: "AVAILABLE",
  IN_USE: "IN_USE",
  FINISHED: "FINISHED",
} as const;

export type EnumsWeightType =
  (typeof EnumsWeightType)[keyof typeof EnumsWeightType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsWeightType = {
  CASUAL: "CASUAL",
  ENTRY: "ENTRY",
  MASSIVE_ENTRY: "MASSIVE_ENTRY",
  IDENTIFICATION: "IDENTIFICATION",
  WEIGHING: "WEIGHING",
  EXIT: "EXIT",
  CURVE_CHANGE: "CURVE_CHANGE",
} as const;

export type EnumsWeightSource =
  (typeof EnumsWeightSource)[keyof typeof EnumsWeightSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsWeightSource = {
  CALCULATED: "CALCULATED",
  WEIGHTED: "WEIGHTED",
} as const;

export type EnumsWeightGainCurveType =
  (typeof EnumsWeightGainCurveType)[keyof typeof EnumsWeightGainCurveType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsWeightGainCurveType = {
  BATCH: "BATCH",
  BIOTYPE: "BIOTYPE",
} as const;

export type EnumsTypeManagement =
  (typeof EnumsTypeManagement)[keyof typeof EnumsTypeManagement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsTypeManagement = {
  ENTRY: "ENTRY",
  IDENTIFICATION: "IDENTIFICATION",
  WEIGHING: "WEIGHING",
  SALE: "SALE",
} as const;

export type EnumsTreatViewType =
  (typeof EnumsTreatViewType)[keyof typeof EnumsTreatViewType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsTreatViewType = {
  DEFAULT: "DEFAULT",
  HOUR: "HOUR",
} as const;

export type EnumsSupplementedRearingModality =
  (typeof EnumsSupplementedRearingModality)[keyof typeof EnumsSupplementedRearingModality];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsSupplementedRearingModality = {
  PASTO_MINERAL: "PASTO_MINERAL",
  PASTO_0_1_TO_0_6: "PASTO_0_1_TO_0_6",
  RIP: "RIP",
  TIP: "TIP",
  SEM_HISTORICO: "SEM_HISTORICO",
} as const;

export type EnumsStructureCategory =
  (typeof EnumsStructureCategory)[keyof typeof EnumsStructureCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsStructureCategory = {
  BOX: "BOX",
  AERIAL_SILO: "AERIAL_SILO",
  TRENCH_SILO: "TRENCH_SILO",
  SURFACE_SILO: "SURFACE_SILO",
  MIXER: "MIXER",
  MILL: "MILL",
  OTHER: "OTHER",
} as const;

export type EnumsSalesMarketType =
  (typeof EnumsSalesMarketType)[keyof typeof EnumsSalesMarketType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsSalesMarketType = {
  EXPORT: "EXPORT",
  DOMESTIC: "DOMESTIC",
} as const;

export type EnumsSaleOrderType =
  (typeof EnumsSaleOrderType)[keyof typeof EnumsSaleOrderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsSaleOrderType = {
  BATCH: "BATCH",
  INDIVIDUAL: "INDIVIDUAL",
} as const;

export type EnumsSaleOrderStatus =
  (typeof EnumsSaleOrderStatus)[keyof typeof EnumsSaleOrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsSaleOrderStatus = {
  WAITING_FRIDGE_DATA: "WAITING_FRIDGE_DATA",
  CLOSED: "CLOSED",
} as const;

export type EnumsSaleOrderSourceType =
  (typeof EnumsSaleOrderSourceType)[keyof typeof EnumsSaleOrderSourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsSaleOrderSourceType = {
  VIA_SPREADSHEET: "VIA_SPREADSHEET",
  MANUAL_CLOSURE: "MANUAL_CLOSURE",
} as const;

export type EnumsReadType = (typeof EnumsReadType)[keyof typeof EnumsReadType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsReadType = {
  DRY: "DRY",
  CRUMB: "CRUMB",
  INVENTORY: "INVENTORY",
  DAY_0: "DAY_0",
  REPLICATED: "REPLICATED",
  GRADE: "GRADE",
  REVERSAL: "REVERSAL",
} as const;

export type EnumsPurchaseStatus =
  (typeof EnumsPurchaseStatus)[keyof typeof EnumsPurchaseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsPurchaseStatus = {
  PENDING: "PENDING",
  RECEIVED: "RECEIVED",
  STORED: "STORED",
} as const;

export type EnumsPurchaseCategory =
  (typeof EnumsPurchaseCategory)[keyof typeof EnumsPurchaseCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsPurchaseCategory = {
  FOODS: "FOODS",
  ANIMALS: "ANIMALS",
  EARRINGS: "EARRINGS",
} as const;

export type EnumsPurchaseCalculationType =
  (typeof EnumsPurchaseCalculationType)[keyof typeof EnumsPurchaseCalculationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsPurchaseCalculationType = {
  AVERAGE_PRICE: "AVERAGE_PRICE",
  APPORTIONMENT_PER_ANIMAL: "APPORTIONMENT_PER_ANIMAL",
  PROCESSING_WEIGHT: "PROCESSING_WEIGHT",
} as const;

export type EnumsProfile = (typeof EnumsProfile)[keyof typeof EnumsProfile];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsProfile = {
  CATTLE_BUYER: "CATTLE_BUYER",
  SHOVELMAN: "SHOVELMAN",
  TREATER: "TREATER",
  EXTERN: "EXTERN",
  CATTLE_OWNER: "CATTLE_OWNER",
  MEDICINE_APPLICATOR: "MEDICINE_APPLICATOR",
  PARTNER: "PARTNER",
} as const;

export type EnumsPartnerClosureV2Type =
  (typeof EnumsPartnerClosureV2Type)[keyof typeof EnumsPartnerClosureV2Type];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsPartnerClosureV2Type = {
  BOITEL: "BOITEL",
  CLASSIC: "CLASSIC",
  FAT_CATTLE: "FAT_CATTLE",
} as const;

export type EnumsOxPurpose =
  (typeof EnumsOxPurpose)[keyof typeof EnumsOxPurpose];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsOxPurpose = {
  IN_HOUSE: "IN_HOUSE",
  PURCHASE: "PURCHASE",
  PARTNERSHIP: "PARTNERSHIP",
  BOITEL: "BOITEL",
  RECREATE: "RECREATE",
  HERD: "HERD",
  PRODUCED_PARTNERSHIP: "PRODUCED_PARTNERSHIP",
  FAT_CATTLE: "FAT_CATTLE",
} as const;

export type EnumsOxGender = (typeof EnumsOxGender)[keyof typeof EnumsOxGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsOxGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
} as const;

export type EnumsOxCategory =
  (typeof EnumsOxCategory)[keyof typeof EnumsOxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsOxCategory = {
  BULL: "BULL",
  STEER: "STEER",
  COW: "COW",
  HEIFER: "HEIFER",
  CALF: "CALF",
  HEIFER_CALF: "HEIFER_CALF",
  STEER_CALF: "STEER_CALF",
} as const;

export type EnumsOperationalCostType =
  (typeof EnumsOperationalCostType)[keyof typeof EnumsOperationalCostType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsOperationalCostType = {
  FIXED: "FIXED",
  CUSTOM: "CUSTOM",
} as const;

export type EnumsOccurrenceType =
  (typeof EnumsOccurrenceType)[keyof typeof EnumsOccurrenceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsOccurrenceType = {
  CORRAL: "CORRAL",
  FARM: "FARM",
  LINE: "LINE",
} as const;

export type EnumsOccurrenceCategory =
  (typeof EnumsOccurrenceCategory)[keyof typeof EnumsOccurrenceCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsOccurrenceCategory = {
  CLIMATE: "CLIMATE",
  EQUIPMENT: "EQUIPMENT",
  INGREDIENTS: "INGREDIENTS",
  DRY_MATTER_CHANGE: "DRY_MATTER_CHANGE",
  SYSTEM_FAILURE: "SYSTEM_FAILURE",
  WATER: "WATER",
  RAIN: "RAIN",
  DIET: "DIET",
  INFRASTRUCTURE: "INFRASTRUCTURE",
  MACHINES: "MACHINES",
  PEOPLE: "PEOPLE",
  LAW_SUIT: "LAW_SUIT",
  OTHERS: "OTHERS",
  MANAGEMENT: "MANAGEMENT",
  BOARDING: "BOARDING",
  TRANSFER: "TRANSFER",
} as const;

export type EnumsMixerType =
  (typeof EnumsMixerType)[keyof typeof EnumsMixerType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsMixerType = {
  ROTOR_MIX_0: "ROTOR_MIX_0",
  TOMBAMENTO_1: "TOMBAMENTO_1",
} as const;

export type EnumsMedicineType =
  (typeof EnumsMedicineType)[keyof typeof EnumsMedicineType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsMedicineType = {
  ANTIPARASITIC: "ANTIPARASITIC",
  ANTIMICROBIALS: "ANTIMICROBIALS",
  OTHER: "OTHER",
  HORMONE: "HORMONE",
  VITAMINS_AND_MINERALS: "VITAMINS_AND_MINERALS",
  ANTISEPTIC: "ANTISEPTIC",
  NON_STEROIDAL_ANTI_INFLAMMATORY: "NON_STEROIDAL_ANTI_INFLAMMATORY",
  DISINFECTANT: "DISINFECTANT",
  ANTIMICROBIAL_PERFORMANCE_ENHANCING_ADDITIVES:
    "ANTIMICROBIAL_PERFORMANCE_ENHANCING_ADDITIVES",
  ANESTHETIC: "ANESTHETIC",
  ANALGESIC: "ANALGESIC",
  STEROIDAL_ANTI_INFLAMMATORY: "STEROIDAL_ANTI_INFLAMMATORY",
  ANTICOCCIDIAL: "ANTICOCCIDIAL",
  HYDRATION_AND_SUPPORTIVE_MEDICATION: "HYDRATION_AND_SUPPORTIVE_MEDICATION",
  ANTISPASMODIC: "ANTISPASMODIC",
  ANTICHOLINERGIC: "ANTICHOLINERGIC",
  MUSCLE_RELAXANT: "MUSCLE_RELAXANT",
  ANTIARRHYTHMIC: "ANTIARRHYTHMIC",
  ANTIPHYSETICS: "ANTIPHYSETICS",
  ANTIPYRETIC: "ANTIPYRETIC",
  ANTIVIRAL: "ANTIVIRAL",
  BRONCHODILATOR: "BRONCHODILATOR",
  CHOLINERGIC: "CHOLINERGIC",
  MUCOLYTIC: "MUCOLYTIC",
} as const;

export type EnumsMeasurement =
  (typeof EnumsMeasurement)[keyof typeof EnumsMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsMeasurement = {
  UNIT: "UNIT",
  MILLILITER: "MILLILITER",
  GRAMS: "GRAMS",
  IMPLANT: "IMPLANT",
  KILOGRAM: "KILOGRAM",
  LITER: "LITER",
  MILLIGRAM: "MILLIGRAM",
  MICROGRAMS: "MICROGRAMS",
  INTERNATIONAL_UNIT: "INTERNATIONAL_UNIT",
  DOSE: "DOSE",
} as const;

export type EnumsManagementStatus =
  (typeof EnumsManagementStatus)[keyof typeof EnumsManagementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsManagementStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

export type EnumsManagementSessionExtractLineSource =
  (typeof EnumsManagementSessionExtractLineSource)[keyof typeof EnumsManagementSessionExtractLineSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsManagementSessionExtractLineSource = {
  MANEJO: "MANEJO",
  AUDIT: "AUDIT",
} as const;

export type EnumsLogType = (typeof EnumsLogType)[keyof typeof EnumsLogType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsLogType = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
} as const;

export type EnumsLogCategory =
  (typeof EnumsLogCategory)[keyof typeof EnumsLogCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsLogCategory = {
  TRACER: "TRACER",
  BATCH: "BATCH",
  CORRAL: "CORRAL",
  TREATMENT: "TREATMENT",
  IDENTIFICATION: "IDENTIFICATION",
  ANNOUNCEMENT: "ANNOUNCEMENT",
  PURCHASE: "PURCHASE",
  SALE: "SALE",
  OTHER: "OTHER",
} as const;

export type EnumsLoadMode = (typeof EnumsLoadMode)[keyof typeof EnumsLoadMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsLoadMode = {
  WEIGHING: "WEIGHING",
  CONFIRMATION: "CONFIRMATION",
} as const;

export type EnumsIdentificationSource =
  (typeof EnumsIdentificationSource)[keyof typeof EnumsIdentificationSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsIdentificationSource = {
  SPREADSHEET: "SPREADSHEET",
  MANUAL: "MANUAL",
} as const;

export type EnumsGradeMethod =
  (typeof EnumsGradeMethod)[keyof typeof EnumsGradeMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsGradeMethod = {
  GRADES: "GRADES",
  CARGILL: "CARGILL",
} as const;

export type EnumsGeneralLogCategory =
  (typeof EnumsGeneralLogCategory)[keyof typeof EnumsGeneralLogCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsGeneralLogCategory = {
  FARM: "FARM",
  BATCH: "BATCH",
  OX: "OX",
} as const;

export type EnumsFeedLinkStatus =
  (typeof EnumsFeedLinkStatus)[keyof typeof EnumsFeedLinkStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsFeedLinkStatus = {
  SUCCESS: "SUCCESS",
  PENDING: "PENDING",
  IGNORED: "IGNORED",
} as const;

export type EnumsFeedLinkSlug =
  (typeof EnumsFeedLinkSlug)[keyof typeof EnumsFeedLinkSlug];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsFeedLinkSlug = {
  AT_REAL_TRATO: "AT_REAL_TRATO",
  AT_REAL_BATALIM: "AT_REAL_BATALIM",
  AT_REAL_BAT: "AT_REAL_BAT",
  AT_REAL_TRATOPREV_STT: "AT_REAL_TRATOPREV_STT",
  AT_REAL_ERROR: "AT_REAL_ERROR",
} as const;

export type EnumsFeedLinkReview =
  (typeof EnumsFeedLinkReview)[keyof typeof EnumsFeedLinkReview];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsFeedLinkReview = {
  AWAITING: "AWAITING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
} as const;

export type EnumsExitTruckStatus =
  (typeof EnumsExitTruckStatus)[keyof typeof EnumsExitTruckStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsExitTruckStatus = {
  PENDING: "PENDING",
  WAITING_FOR_EMISSION: "WAITING_FOR_EMISSION",
  EMITTED: "EMITTED",
} as const;

export type EnumsExitReason =
  (typeof EnumsExitReason)[keyof typeof EnumsExitReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsExitReason = {
  SALE: "SALE",
  TRANSFER: "TRANSFER",
  DONATION: "DONATION",
  OWN_CONSUMPTION: "OWN_CONSUMPTION",
} as const;

export type EnumsDisease = (typeof EnumsDisease)[keyof typeof EnumsDisease];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsDisease = {
  ENTRY_MANAGEMENT: "ENTRY_MANAGEMENT",
  NOT_SPECIFIED: "NOT_SPECIFIED",
  ABSCESSES: "ABSCESSES",
  MISCELLANEOUS_ACCIDENTS: "MISCELLANEOUS_ACCIDENTS",
  ACIDOSIS: "ACIDOSIS",
  BOTULISM: "BOTULISM",
  SYMPTOMATIC_CARBUNCLE_LAMENESS: "SYMPTOMATIC_CARBUNCLE_LAMENESS",
  COLIC: "COLIC",
  NEUROLOGICAL_DISEASE: "NEUROLOGICAL_DISEASE",
  ENTEROTOXEMIA: "ENTEROTOXEMIA",
  INJURIES: "INJURIES",
  WEAKNESS_CACHEXIA: "WEAKNESS_CACHEXIA",
  FRACTURES: "FRACTURES",
  GAS_GANGRENE: "GAS_GANGRENE",
  INTOXICATION: "INTOXICATION",
  LAMINITIS: "LAMINITIS",
  NOT_IDENTIFIED: "NOT_IDENTIFIED",
  OTHER_CAUSES: "OTHER_CAUSES",
  PARASITOSIS: "PARASITOSIS",
  PNEUMONIA: "PNEUMONIA",
  PODODERMATITIS_HOOF_PROBLEMS: "PODODERMATITIS_HOOF_PROBLEMS",
  POLYARTHRITIS: "POLYARTHRITIS",
  POLYENCEPHALOMALACIA_PEM: "POLYENCEPHALOMALACIA_PEM",
  TROUGH_REFUSE_INAPPETENCE: "TROUGH_REFUSE_INAPPETENCE",
  URINARY_RETENTION: "URINARY_RETENTION",
  PERITONITIS_RETICULUM: "PERITONITIS_RETICULUM",
  SODOMY: "SODOMY",
  BLOAT: "BLOAT",
  INTESTINAL_TWIST: "INTESTINAL_TWIST",
  TRANSPORT_TRAUMA: "TRANSPORT_TRAUMA",
  PARASITIC_SADNESS: "PARASITIC_SADNESS",
  ABSCESS: "ABSCESS",
  ACROPOSTITIS_PHIMOSIS: "ACROPOSTITIS_PHIMOSIS",
  CONJUNCTIVITIS: "CONJUNCTIVITIS",
  PHYSICAL_DEBILITY: "PHYSICAL_DEBILITY",
  DIARRHEA: "DIARRHEA",
  DEWLAP_EDEMA: "DEWLAP_EDEMA",
  PREPUCE_EDEMA: "PREPUCE_EDEMA",
  WOUND: "WOUND",
  FRACTURE: "FRACTURE",
  HERNIA: "HERNIA",
  METAPHYLAXIS: "METAPHYLAXIS",
  METAPHYLAXIS_CASTRATION: "METAPHYLAXIS_CASTRATION",
  EAR_WITH_WOUND: "EAR_WITH_WOUND",
  DYSTOCIC_BIRTH: "DYSTOCIC_BIRTH",
  POLIOENCEPHALOMALACIA: "POLIOENCEPHALOMALACIA",
  POST_SURGICAL: "POST_SURGICAL",
  HOOF_PROBLEM: "HOOF_PROBLEM",
  TROUGH_REFUSE: "TROUGH_REFUSE",
  PLACENTA_RETENTION: "PLACENTA_RETENTION",
  RETICULOPERICARDITIS: "RETICULOPERICARDITIS",
  TYMPANISM: "TYMPANISM",
  TRAUMATISM: "TRAUMATISM",
  BOVINE_PARASITIC_SADNESS: "BOVINE_PARASITIC_SADNESS",
  UMBILICAL_HERNIA: "UMBILICAL_HERNIA",
  UROLITHIASIS: "UROLITHIASIS",
  WART: "WART",
  INJURED_EAR: "INJURED_EAR",
  HYPOCALCEMIA: "HYPOCALCEMIA",
} as const;

export type EnumsDietCategory =
  (typeof EnumsDietCategory)[keyof typeof EnumsDietCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsDietCategory = {
  RECREATION: "RECREATION",
  ADAPTATION: "ADAPTATION",
  GROWTH: "GROWTH",
  TERMINATION: "TERMINATION",
  FINISHING: "FINISHING",
  SUPPLEMENT: "SUPPLEMENT",
} as const;

export type EnumsDentitionStage =
  (typeof EnumsDentitionStage)[keyof typeof EnumsDentitionStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsDentitionStage = {
  FIRST_CATEGORY: "FIRST_CATEGORY",
  SECOND_CATEGORY: "SECOND_CATEGORY",
  THIRD_CATEGORY: "THIRD_CATEGORY",
} as const;

export type EnumsDeathNecropsy =
  (typeof EnumsDeathNecropsy)[keyof typeof EnumsDeathNecropsy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsDeathNecropsy = {
  COWBOY: "COWBOY",
  VETERINARY: "VETERINARY",
  HEALTH_CONSULTANT: "HEALTH_CONSULTANT",
} as const;

export type EnumsDeathCause =
  (typeof EnumsDeathCause)[keyof typeof EnumsDeathCause];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsDeathCause = {
  NATURAL_DEATH: "NATURAL_DEATH",
  ACCIDENTAL_DEATH: "ACCIDENTAL_DEATH",
  SACRIFICE: "SACRIFICE",
  SLAUGHTER: "SLAUGHTER",
  OTHER: "OTHER",
  SLAUGHTER_FOR_CONSUMPTION_ON_THE_PROPERTY:
    "SLAUGHTER_FOR_CONSUMPTION_ON_THE_PROPERTY",
  ABIGEOUS_OR_DISAPPEARANCE: "ABIGEOUS_OR_DISAPPEARANCE",
  OPHIDIC_ACCIDENT: "OPHIDIC_ACCIDENT",
  DROWNING_OR_JAMMING: "DROWNING_OR_JAMMING",
  ANAPLASMOSIS_OR_BABESIOSIS_OR_PYROPLASMOSIS:
    "ANAPLASMOSIS_OR_BABESIOSIS_OR_PYROPLASMOSIS",
  ATTACK_BY_PREDATORS: "ATTACK_BY_PREDATORS",
  BOTULISM: "BOTULISM",
  POSTPARTUM_COMPLICATIONS_OR_DYSTOCYC_DELIVERY:
    "POSTPARTUM_COMPLICATIONS_OR_DYSTOCYC_DELIVERY",
  DEBILITY_BY_ADVANCED_AGE: "DEBILITY_BY_ADVANCED_AGE",
  NUTRITIONAL_DEFICIENCY: "NUTRITIONAL_DEFICIENCY",
  ELECTRICAL_DISCHARGE: "ELECTRICAL_DISCHARGE",
  DISPOSAL: "DISPOSAL",
  METABOLIC_DISORDERS: "METABOLIC_DISORDERS",
  PARASITARY_DISEASE: "PARASITARY_DISEASE",
  BACTERIAL_DISEASES: "BACTERIAL_DISEASES",
  INFORMATION_UNAVAILABLE: "INFORMATION_UNAVAILABLE",
  FOREIGN_BODY_INGESTION: "FOREIGN_BODY_INGESTION",
  CARDIAC_INSUFFICIENCY: "CARDIAC_INSUFFICIENCY",
  INTOXICATION: "INTOXICATION",
  LEUKOSIS: "LEUKOSIS",
  CHRONIC_MASTITIS: "CHRONIC_MASTITIS",
  SEPTICEMIC_OR_GANGRENOUS_MASTITIS: "SEPTICEMIC_OR_GANGRENOUS_MASTITIS",
  METRITE: "METRITE",
  NATURAL_DEATH_BY_ADVANCED_AGE: "NATURAL_DEATH_BY_ADVANCED_AGE",
  NEOPLASIA: "NEOPLASIA",
  PLEUROPNEUMONIA: "PLEUROPNEUMONIA",
  PODODERMATITIS: "PODODERMATITIS",
  SEPTICEMIA: "SEPTICEMIA",
  TIMPANISM: "TIMPANISM",
  ABOMASUM_TORSION: "ABOMASUM_TORSION",
  TRAUMA_OR_FRACTURE: "TRAUMA_OR_FRACTURE",
} as const;

export type EnumsCorralType =
  (typeof EnumsCorralType)[keyof typeof EnumsCorralType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsCorralType = {
  PICKET: "PICKET",
  PASTURE: "PASTURE",
} as const;

export type EnumsCarcassType =
  (typeof EnumsCarcassType)[keyof typeof EnumsCarcassType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsCarcassType = {
  MISSING: "MISSING",
  THIN: "THIN",
  MEDIUM: "MEDIUM",
  UNIFORM: "UNIFORM",
  EXCESSIVE: "EXCESSIVE",
} as const;

export type EnumsBndStatus =
  (typeof EnumsBndStatus)[keyof typeof EnumsBndStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsBndStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const;

export type EnumsAuditManagementStatus =
  (typeof EnumsAuditManagementStatus)[keyof typeof EnumsAuditManagementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsAuditManagementStatus = {
  CREATED: "CREATED",
  SYNC: "SYNC",
  REJECTED: "REJECTED",
  FINISHED: "FINISHED",
} as const;

export type EnumsApplicationType =
  (typeof EnumsApplicationType)[keyof typeof EnumsApplicationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsApplicationType = {
  BATCH: "BATCH",
  INDIVIDUAL: "INDIVIDUAL",
} as const;

export type EnumsApplicationSuggestion =
  (typeof EnumsApplicationSuggestion)[keyof typeof EnumsApplicationSuggestion];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsApplicationSuggestion = {
  FIXED_DOSE: "FIXED_DOSE",
  WEIGHT_BASED_DOSE: "WEIGHT_BASED_DOSE",
} as const;

export type EnumsAnnouncementType =
  (typeof EnumsAnnouncementType)[keyof typeof EnumsAnnouncementType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsAnnouncementType = {
  BIRTH: "BIRTH",
  DEATH: "DEATH",
  EXIT: "EXIT",
  ENTRY: "ENTRY",
  RE_IDENTIFICATION: "RE_IDENTIFICATION",
  CHANGE_OF_CHARACTERISTIC: "CHANGE_OF_CHARACTERISTIC",
  UNUSABILITY: "UNUSABILITY",
  SALE: "SALE",
} as const;

export const getAddress = (id: number, signal?: AbortSignal) => {
  return request<GetAddressResponse>({
    url: `/addresses/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAddressQueryKey = (id: number) => {
  return [`/addresses/${id}`] as const;
};

export const getGetAddressInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddress>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAddress>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAddressQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddress>>> = ({
    signal,
  }) => getAddress(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAddress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAddressInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddress>>
>;
export type GetAddressInfiniteQueryError = ErrorType<unknown>;

export const useGetAddressInfinite = <
  TData = Awaited<ReturnType<typeof getAddress>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAddress>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAddressInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddress>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAddress>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAddressQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddress>>> = ({
    signal,
  }) => getAddress(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAddress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddress>>
>;
export type GetAddressQueryError = ErrorType<unknown>;

export const useGetAddress = <
  TData = Awaited<ReturnType<typeof getAddress>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAddress>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAddressQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateAddress = (id: number, updateAddress: UpdateAddress) => {
  return request<UpdateAddressResponse>({
    url: `/addresses/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateAddress,
  });
};

export const getUpdateAddressMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAddress>>,
    TError,
    { id: number; data: UpdateAddress },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAddress>>,
  TError,
  { id: number; data: UpdateAddress },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAddress>>,
    { id: number; data: UpdateAddress }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAddress(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAddress>>
>;
export type UpdateAddressMutationBody = UpdateAddress;
export type UpdateAddressMutationError = ErrorType<unknown>;

export const useUpdateAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAddress>>,
    TError,
    { id: number; data: UpdateAddress },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateAddressMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista os lotes (piquete) ativados, disponíveis para a edição de data de entrada.
 */
export const listBatchesForEntryDateEdit = (signal?: AbortSignal) => {
  return request<ListBatchesForEntryDateEditResponse>({
    url: `/admin/batch-entry-date-edit`,
    method: "GET",
    signal,
  });
};

export const getListBatchesForEntryDateEditQueryKey = () => {
  return [`/admin/batch-entry-date-edit`] as const;
};

export const getListBatchesForEntryDateEditInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesForEntryDateEditQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>
  > = ({ signal }) => listBatchesForEntryDateEdit(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesForEntryDateEditInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>
>;
export type ListBatchesForEntryDateEditInfiniteQueryError = ErrorType<unknown>;

export const useListBatchesForEntryDateEditInfinite = <
  TData = Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListBatchesForEntryDateEditInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBatchesForEntryDateEditQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesForEntryDateEditQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>
  > = ({ signal }) => listBatchesForEntryDateEdit(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesForEntryDateEditQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>
>;
export type ListBatchesForEntryDateEditQueryError = ErrorType<unknown>;

export const useListBatchesForEntryDateEdit = <
  TData = Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForEntryDateEdit>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesForEntryDateEditQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Edita (ou pré-visualiza, com `dryRun`) a data de entrada/ativação de um lote, recuando-a e preenchendo o gap de dias
para o sistema não quebrar:

- Recua Batch.createdAt/activatedAt, OxOnBatches.createdAt, Ox.includedAt/blockedUntil, o peso de entrada dos animais e
  DietOnBatches/TreatmentOnBatches.createdAt.
- Re-data o BatchHistory DAY_0 para a nova data e cria BatchHistory REPLICATED (zerado, resultingMatter herdado) em
  cada dia do gap.
- Cria TreatRealized zerados em cada dia do gap (não toca nos realizados reais).
 */
export const applyBatchEntryDateEdit = (
  applyBatchEntryDateEditBody: ApplyBatchEntryDateEditBody,
) => {
  return request<ApplyBatchEntryDateEditResult>({
    url: `/admin/batch-entry-date-edit/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyBatchEntryDateEditBody,
  });
};

export const getApplyBatchEntryDateEditMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchEntryDateEdit>>,
    TError,
    { data: ApplyBatchEntryDateEditBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyBatchEntryDateEdit>>,
  TError,
  { data: ApplyBatchEntryDateEditBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyBatchEntryDateEdit>>,
    { data: ApplyBatchEntryDateEditBody }
  > = (props) => {
    const { data } = props ?? {};

    return applyBatchEntryDateEdit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyBatchEntryDateEditMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyBatchEntryDateEdit>>
>;
export type ApplyBatchEntryDateEditMutationBody = ApplyBatchEntryDateEditBody;
export type ApplyBatchEntryDateEditMutationError = ErrorType<HttpError>;

export const useApplyBatchEntryDateEdit = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchEntryDateEdit>>,
    TError,
    { data: ApplyBatchEntryDateEditBody },
    TContext
  >;
}) => {
  const mutationOptions = getApplyBatchEntryDateEditMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista os lotes (piquete) disponíveis para a ferramenta de correção de venda. Inclui lotes finalizados e ativos —
diferente do seletor do relatório analítico, que exige lote com animais finalizados.
 */
export const listBatchesForSaleCorrection = (signal?: AbortSignal) => {
  return request<ListBatchesForSaleCorrectionResponse>({
    url: `/admin/batch-sale-correction`,
    method: "GET",
    signal,
  });
};

export const getListBatchesForSaleCorrectionQueryKey = () => {
  return [`/admin/batch-sale-correction`] as const;
};

export const getListBatchesForSaleCorrectionInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesForSaleCorrectionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>
  > = ({ signal }) => listBatchesForSaleCorrection(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesForSaleCorrectionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesForSaleCorrection>>
>;
export type ListBatchesForSaleCorrectionInfiniteQueryError = ErrorType<unknown>;

export const useListBatchesForSaleCorrectionInfinite = <
  TData = Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListBatchesForSaleCorrectionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBatchesForSaleCorrectionQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesForSaleCorrectionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>
  > = ({ signal }) => listBatchesForSaleCorrection(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesForSaleCorrectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesForSaleCorrection>>
>;
export type ListBatchesForSaleCorrectionQueryError = ErrorType<unknown>;

export const useListBatchesForSaleCorrection = <
  TData = Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForSaleCorrection>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesForSaleCorrectionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Carrega o estado de venda de um lote: caminhões, animais por caminhão, dados por boi, e dados de
entrada/custo/previstos do lote.
 */
export const getBatchSaleState = (id: number, signal?: AbortSignal) => {
  return request<BatchSaleState>({
    url: `/admin/batch-sale-correction/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetBatchSaleStateQueryKey = (id: number) => {
  return [`/admin/batch-sale-correction/${id}`] as const;
};

export const getGetBatchSaleStateInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchSaleState>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchSaleState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchSaleStateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchSaleState>>
  > = ({ signal }) => getBatchSaleState(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBatchSaleState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchSaleStateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchSaleState>>
>;
export type GetBatchSaleStateInfiniteQueryError = ErrorType<HttpError>;

export const useGetBatchSaleStateInfinite = <
  TData = Awaited<ReturnType<typeof getBatchSaleState>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchSaleState>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchSaleStateInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBatchSaleStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchSaleState>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchSaleState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchSaleStateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchSaleState>>
  > = ({ signal }) => getBatchSaleState(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatchSaleState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchSaleStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchSaleState>>
>;
export type GetBatchSaleStateQueryError = ErrorType<HttpError>;

export const useGetBatchSaleState = <
  TData = Awaited<ReturnType<typeof getBatchSaleState>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchSaleState>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchSaleStateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aplica (ou pré-visualiza, com `dryRun`) a correção de venda de um lote: dados gerais do lote, dados de saída por
venda, peso de entrada por animal, conversões transferência→venda e remoções (estorno).
 */
export const applyBatchSaleCorrection = (
  id: number,
  applyBatchSaleCorrectionBody: ApplyBatchSaleCorrectionBody,
) => {
  return request<BatchSaleCorrectionResult>({
    url: `/admin/batch-sale-correction/${id}/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyBatchSaleCorrectionBody,
  });
};

export const getApplyBatchSaleCorrectionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchSaleCorrection>>,
    TError,
    { id: number; data: ApplyBatchSaleCorrectionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyBatchSaleCorrection>>,
  TError,
  { id: number; data: ApplyBatchSaleCorrectionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyBatchSaleCorrection>>,
    { id: number; data: ApplyBatchSaleCorrectionBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return applyBatchSaleCorrection(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyBatchSaleCorrectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyBatchSaleCorrection>>
>;
export type ApplyBatchSaleCorrectionMutationBody = ApplyBatchSaleCorrectionBody;
export type ApplyBatchSaleCorrectionMutationError = ErrorType<HttpError>;

export const useApplyBatchSaleCorrection = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchSaleCorrection>>,
    TError,
    { id: number; data: ApplyBatchSaleCorrectionBody },
    TContext
  >;
}) => {
  const mutationOptions = getApplyBatchSaleCorrectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista todos os lotes do banco para que o moderador escolha qual restaurar.
 */
export const listRestorableBatches = (signal?: AbortSignal) => {
  return request<ListRestorableBatchesResponse>({
    url: `/admin/restore-bacth`,
    method: "GET",
    signal,
  });
};

export const getListRestorableBatchesQueryKey = () => {
  return [`/admin/restore-bacth`] as const;
};

export const getListRestorableBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listRestorableBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listRestorableBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRestorableBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRestorableBatches>>
  > = ({ signal }) => listRestorableBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listRestorableBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRestorableBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRestorableBatches>>
>;
export type ListRestorableBatchesInfiniteQueryError = ErrorType<unknown>;

export const useListRestorableBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listRestorableBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listRestorableBatches>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListRestorableBatchesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListRestorableBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listRestorableBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listRestorableBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRestorableBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRestorableBatches>>
  > = ({ signal }) => listRestorableBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRestorableBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRestorableBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRestorableBatches>>
>;
export type ListRestorableBatchesQueryError = ErrorType<unknown>;

export const useListRestorableBatches = <
  TData = Awaited<ReturnType<typeof listRestorableBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listRestorableBatches>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListRestorableBatchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Gera um único arquivo `.sql` de restauração para um ou mais lotes, incluindo todas as relações apagadas por um delete
em cascata (histórico, tratos realizados, etc.) e as dependências referenciadas por foreign key.
 */
export const restoreBatch = (restoreBatchBody: RestoreBatchBody) => {
  return request<BatchRestoreResult>({
    url: `/admin/restore-bacth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: restoreBatchBody,
  });
};

export const getRestoreBatchMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreBatch>>,
    TError,
    { data: RestoreBatchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreBatch>>,
  TError,
  { data: RestoreBatchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreBatch>>,
    { data: RestoreBatchBody }
  > = (props) => {
    const { data } = props ?? {};

    return restoreBatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreBatch>>
>;
export type RestoreBatchMutationBody = RestoreBatchBody;
export type RestoreBatchMutationError = ErrorType<HttpError>;

export const useRestoreBatch = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreBatch>>,
    TError,
    { data: RestoreBatchBody },
    TContext
  >;
}) => {
  const mutationOptions = getRestoreBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista as vendas disponíveis para edição de data, separadas por tipo: vendas por venda (SaleOrder) e vendas avulsas
(HoldingSale).
 */
export const listSaleDates = (signal?: AbortSignal) => {
  return request<ListSaleDatesResult>({
    url: `/admin/sale-date-edit`,
    method: "GET",
    signal,
  });
};

export const getListSaleDatesQueryKey = () => {
  return [`/admin/sale-date-edit`] as const;
};

export const getListSaleDatesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleDates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSaleDates>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSaleDatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSaleDates>>> = ({
    signal,
  }) => listSaleDates(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSaleDates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleDatesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleDates>>
>;
export type ListSaleDatesInfiniteQueryError = ErrorType<unknown>;

export const useListSaleDatesInfinite = <
  TData = Awaited<ReturnType<typeof listSaleDates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSaleDates>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleDatesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSaleDatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleDates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSaleDates>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSaleDatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSaleDates>>> = ({
    signal,
  }) => listSaleDates(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSaleDates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleDatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleDates>>
>;
export type ListSaleDatesQueryError = ErrorType<unknown>;

export const useListSaleDates = <
  TData = Awaited<ReturnType<typeof listSaleDates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSaleDates>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleDatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Edita (ou pré-visualiza, com `dryRun`) a data de uma venda — por venda (SaleOrder) ou avulsa (HoldingSale). Propaga a
nova data para todos os campos relacionados: SaleOrder.createdAt/saleDate/expirationDay, HoldingSale.date,
ExitTruck.exitAt, Ox.diedAt e OxOnBatches.finalizedAt.
 */
export const applySaleDateEdit = (
  applySaleDateEditBody: ApplySaleDateEditBody,
) => {
  return request<ApplySaleDateEditResult>({
    url: `/admin/sale-date-edit/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applySaleDateEditBody,
  });
};

export const getApplySaleDateEditMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applySaleDateEdit>>,
    TError,
    { data: ApplySaleDateEditBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applySaleDateEdit>>,
  TError,
  { data: ApplySaleDateEditBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applySaleDateEdit>>,
    { data: ApplySaleDateEditBody }
  > = (props) => {
    const { data } = props ?? {};

    return applySaleDateEdit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplySaleDateEditMutationResult = NonNullable<
  Awaited<ReturnType<typeof applySaleDateEdit>>
>;
export type ApplySaleDateEditMutationBody = ApplySaleDateEditBody;
export type ApplySaleDateEditMutationError = ErrorType<HttpError>;

export const useApplySaleDateEdit = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applySaleDateEdit>>,
    TError,
    { data: ApplySaleDateEditBody },
    TContext
  >;
}) => {
  const mutationOptions = getApplySaleDateEditMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAnnouncements = (
  params?: ListAnnouncementsParams,
  signal?: AbortSignal,
) => {
  return request<ListAnnouncementsResponse>({
    url: `/announcements`,
    method: "GET",
    params,
    signal,
  });
};

export const getListAnnouncementsQueryKey = (
  params?: ListAnnouncementsParams,
) => {
  return [`/announcements`, ...(params ? [params] : [])] as const;
};

export const getListAnnouncementsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listAnnouncements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAnnouncementsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listAnnouncements>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAnnouncementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAnnouncements>>
  > = ({ signal }) => listAnnouncements(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAnnouncements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAnnouncementsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAnnouncements>>
>;
export type ListAnnouncementsInfiniteQueryError = ErrorType<unknown>;

export const useListAnnouncementsInfinite = <
  TData = Awaited<ReturnType<typeof listAnnouncements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAnnouncementsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listAnnouncements>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAnnouncementsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAnnouncements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAnnouncementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAnnouncements>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAnnouncementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAnnouncements>>
  > = ({ signal }) => listAnnouncements(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAnnouncements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAnnouncementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAnnouncements>>
>;
export type ListAnnouncementsQueryError = ErrorType<unknown>;

export const useListAnnouncements = <
  TData = Awaited<ReturnType<typeof listAnnouncements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAnnouncementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAnnouncements>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAnnouncementsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createAnnouncement = (createAnnouncement: CreateAnnouncement) => {
  return request<CreateAnnouncementResponse>({
    url: `/announcements`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createAnnouncement,
  });
};

export const getCreateAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnnouncement>>,
    TError,
    { data: CreateAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAnnouncement>>,
  TError,
  { data: CreateAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnnouncement>>,
    { data: CreateAnnouncement }
  > = (props) => {
    const { data } = props ?? {};

    return createAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAnnouncement>>
>;
export type CreateAnnouncementMutationBody = CreateAnnouncement;
export type CreateAnnouncementMutationError = ErrorType<HttpError>;

export const useCreateAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnnouncement>>,
    TError,
    { data: CreateAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions = getCreateAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checkPendingOxenForBirthAnnouncementCreation = (
  signal?: AbortSignal,
) => {
  return request<CheckPendingOxenForBirthAnnouncementCreationResponse>({
    url: `/announcements/birth`,
    method: "GET",
    signal,
  });
};

export const getCheckPendingOxenForBirthAnnouncementCreationQueryKey = () => {
  return [`/announcements/birth`] as const;
};

export const getCheckPendingOxenForBirthAnnouncementCreationInfiniteQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>
    >,
    TError = ErrorType<unknown>,
  >(options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>,
      TError,
      TData
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCheckPendingOxenForBirthAnnouncementCreationQueryKey();

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>
    > = ({ signal }) => checkPendingOxenForBirthAnnouncementCreation(signal);

    return {
      queryKey,
      queryFn,
      networkMode: "always",
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type CheckPendingOxenForBirthAnnouncementCreationInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>
  >;
export type CheckPendingOxenForBirthAnnouncementCreationInfiniteQueryError =
  ErrorType<unknown>;

export const useCheckPendingOxenForBirthAnnouncementCreationInfinite = <
  TData = Awaited<
    ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getCheckPendingOxenForBirthAnnouncementCreationInfiniteQueryOptions(
      options,
    );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCheckPendingOxenForBirthAnnouncementCreationQueryOptions = <
  TData = Awaited<
    ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCheckPendingOxenForBirthAnnouncementCreationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>
  > = ({ signal }) => checkPendingOxenForBirthAnnouncementCreation(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckPendingOxenForBirthAnnouncementCreationQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>
  >;
export type CheckPendingOxenForBirthAnnouncementCreationQueryError =
  ErrorType<unknown>;

export const useCheckPendingOxenForBirthAnnouncementCreation = <
  TData = Awaited<
    ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof checkPendingOxenForBirthAnnouncementCreation>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getCheckPendingOxenForBirthAnnouncementCreationQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createBirthAnnouncement = () => {
  return request<boolean>({ url: `/announcements/birth`, method: "POST" });
};

export const getCreateBirthAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBirthAnnouncement>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBirthAnnouncement>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBirthAnnouncement>>,
    void
  > = () => {
    return createBirthAnnouncement();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBirthAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBirthAnnouncement>>
>;

export type CreateBirthAnnouncementMutationError = ErrorType<HttpError>;

export const useCreateBirthAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBirthAnnouncement>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getCreateBirthAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createDeathAnnouncement = (
  deathAnnouncement: DeathAnnouncement,
) => {
  return request<CreateDeathAnnouncementResponse>({
    url: `/announcements/death`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: deathAnnouncement,
  });
};

export const getCreateDeathAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDeathAnnouncement>>,
    TError,
    { data: DeathAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDeathAnnouncement>>,
  TError,
  { data: DeathAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDeathAnnouncement>>,
    { data: DeathAnnouncement }
  > = (props) => {
    const { data } = props ?? {};

    return createDeathAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDeathAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDeathAnnouncement>>
>;
export type CreateDeathAnnouncementMutationBody = DeathAnnouncement;
export type CreateDeathAnnouncementMutationError = ErrorType<HttpError>;

export const useCreateDeathAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDeathAnnouncement>>,
    TError,
    { data: DeathAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions = getCreateDeathAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listDeadOxenWithoutAnnouncement = (
  params?: ListDeadOxenWithoutAnnouncementParams,
  signal?: AbortSignal,
) => {
  return request<ListDeadOxenWithoutAnnouncementResponse>({
    url: `/announcements/death/oxen`,
    method: "GET",
    params,
    signal,
  });
};

export const getListDeadOxenWithoutAnnouncementQueryKey = (
  params?: ListDeadOxenWithoutAnnouncementParams,
) => {
  return [`/announcements/death/oxen`, ...(params ? [params] : [])] as const;
};

export const getListDeadOxenWithoutAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDeadOxenWithoutAnnouncementParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDeadOxenWithoutAnnouncementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>
  > = ({ signal }) => listDeadOxenWithoutAnnouncement(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDeadOxenWithoutAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>
>;
export type ListDeadOxenWithoutAnnouncementInfiniteQueryError =
  ErrorType<unknown>;

export const useListDeadOxenWithoutAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDeadOxenWithoutAnnouncementParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDeadOxenWithoutAnnouncementInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListDeadOxenWithoutAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDeadOxenWithoutAnnouncementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDeadOxenWithoutAnnouncementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>
  > = ({ signal }) => listDeadOxenWithoutAnnouncement(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDeadOxenWithoutAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>
>;
export type ListDeadOxenWithoutAnnouncementQueryError = ErrorType<unknown>;

export const useListDeadOxenWithoutAnnouncement = <
  TData = Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDeadOxenWithoutAnnouncementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenWithoutAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDeadOxenWithoutAnnouncementQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createEntryAnnouncements = (
  createEntryAnnouncement: CreateEntryAnnouncement,
) => {
  return request<CreateEntryAnnouncementsResponse>({
    url: `/announcements/entry`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEntryAnnouncement,
  });
};

export const getCreateEntryAnnouncementsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntryAnnouncements>>,
    TError,
    { data: CreateEntryAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntryAnnouncements>>,
  TError,
  { data: CreateEntryAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEntryAnnouncements>>,
    { data: CreateEntryAnnouncement }
  > = (props) => {
    const { data } = props ?? {};

    return createEntryAnnouncements(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntryAnnouncementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEntryAnnouncements>>
>;
export type CreateEntryAnnouncementsMutationBody = CreateEntryAnnouncement;
export type CreateEntryAnnouncementsMutationError = ErrorType<HttpError>;

export const useCreateEntryAnnouncements = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntryAnnouncements>>,
    TError,
    { data: CreateEntryAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions = getCreateEntryAnnouncementsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checkGtas = (checkGtasBody: CheckGtasBody) => {
  return request<CheckGtasResponse>({
    url: `/announcements/entry`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: checkGtasBody,
  });
};

export const getCheckGtasMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkGtas>>,
    TError,
    { data: CheckGtasBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkGtas>>,
  TError,
  { data: CheckGtasBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkGtas>>,
    { data: CheckGtasBody }
  > = (props) => {
    const { data } = props ?? {};

    return checkGtas(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckGtasMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkGtas>>
>;
export type CheckGtasMutationBody = CheckGtasBody;
export type CheckGtasMutationError = ErrorType<unknown>;

export const useCheckGtas = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkGtas>>,
    TError,
    { data: CheckGtasBody },
    TContext
  >;
}) => {
  const mutationOptions = getCheckGtasMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Gera Excel da listagem de comunicados de entrada (pendentes ou emitidos).
 */
export const generateEntryAnnouncementExcel = (
  params: GenerateEntryAnnouncementExcelParams,
) => {
  return request<GenerateEntryAnnouncementExcelResponse>({
    url: `/announcements/entry/excel`,
    method: "POST",
    params,
  });
};

export const getGenerateEntryAnnouncementExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEntryAnnouncementExcel>>,
    TError,
    { params: GenerateEntryAnnouncementExcelParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateEntryAnnouncementExcel>>,
  TError,
  { params: GenerateEntryAnnouncementExcelParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateEntryAnnouncementExcel>>,
    { params: GenerateEntryAnnouncementExcelParams }
  > = (props) => {
    const { params } = props ?? {};

    return generateEntryAnnouncementExcel(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateEntryAnnouncementExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateEntryAnnouncementExcel>>
>;

export type GenerateEntryAnnouncementExcelMutationError = ErrorType<unknown>;

export const useGenerateEntryAnnouncementExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEntryAnnouncementExcel>>,
    TError,
    { params: GenerateEntryAnnouncementExcelParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateEntryAnnouncementExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateChangeOfCharacteristics = (
  generateChangeOfCharacteristicsBody: GenerateChangeOfCharacteristicsBody,
) => {
  return request<GenerateChangeOfCharacteristicsResponse>({
    url: `/announcements/generate/change-of-characteristics`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateChangeOfCharacteristicsBody,
  });
};

export const getGenerateChangeOfCharacteristicsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateChangeOfCharacteristics>>,
    TError,
    { data: GenerateChangeOfCharacteristicsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateChangeOfCharacteristics>>,
  TError,
  { data: GenerateChangeOfCharacteristicsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateChangeOfCharacteristics>>,
    { data: GenerateChangeOfCharacteristicsBody }
  > = (props) => {
    const { data } = props ?? {};

    return generateChangeOfCharacteristics(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateChangeOfCharacteristicsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateChangeOfCharacteristics>>
>;
export type GenerateChangeOfCharacteristicsMutationBody =
  GenerateChangeOfCharacteristicsBody;
export type GenerateChangeOfCharacteristicsMutationError = ErrorType<HttpError>;

export const useGenerateChangeOfCharacteristics = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateChangeOfCharacteristics>>,
    TError,
    { data: GenerateChangeOfCharacteristicsBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateChangeOfCharacteristicsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateDeathAnnouncement = () => {
  return request<GenerateDeathAnnouncementResponse>({
    url: `/announcements/generate/death`,
    method: "POST",
  });
};

export const getGenerateDeathAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDeathAnnouncement>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDeathAnnouncement>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDeathAnnouncement>>,
    void
  > = () => {
    return generateDeathAnnouncement();
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDeathAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDeathAnnouncement>>
>;

export type GenerateDeathAnnouncementMutationError = ErrorType<HttpError>;

export const useGenerateDeathAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDeathAnnouncement>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getGenerateDeathAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateReIdentificationAnnouncement = (
  generateReIdentificationAnnouncementBody: GenerateReIdentificationAnnouncementBody,
) => {
  return request<GenerateReIdentificationAnnouncementResponse>({
    url: `/announcements/generate/re-identification`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateReIdentificationAnnouncementBody,
  });
};

export const getGenerateReIdentificationAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReIdentificationAnnouncement>>,
    TError,
    { data: GenerateReIdentificationAnnouncementBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateReIdentificationAnnouncement>>,
  TError,
  { data: GenerateReIdentificationAnnouncementBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateReIdentificationAnnouncement>>,
    { data: GenerateReIdentificationAnnouncementBody }
  > = (props) => {
    const { data } = props ?? {};

    return generateReIdentificationAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateReIdentificationAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateReIdentificationAnnouncement>>
>;
export type GenerateReIdentificationAnnouncementMutationBody =
  GenerateReIdentificationAnnouncementBody;
export type GenerateReIdentificationAnnouncementMutationError =
  ErrorType<HttpError>;

export const useGenerateReIdentificationAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReIdentificationAnnouncement>>,
    TError,
    { data: GenerateReIdentificationAnnouncementBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateReIdentificationAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateUnusability = (
  generateUnusabilityBody: GenerateUnusabilityBody,
) => {
  return request<GenerateUnusabilityResponse>({
    url: `/announcements/generate/unusability`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateUnusabilityBody,
  });
};

export const getGenerateUnusabilityMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUnusability>>,
    TError,
    { data: GenerateUnusabilityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateUnusability>>,
  TError,
  { data: GenerateUnusabilityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateUnusability>>,
    { data: GenerateUnusabilityBody }
  > = (props) => {
    const { data } = props ?? {};

    return generateUnusability(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateUnusabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateUnusability>>
>;
export type GenerateUnusabilityMutationBody = GenerateUnusabilityBody;
export type GenerateUnusabilityMutationError = ErrorType<HttpError>;

export const useGenerateUnusability = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUnusability>>,
    TError,
    { data: GenerateUnusabilityBody },
    TContext
  >;
}) => {
  const mutationOptions = getGenerateUnusabilityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAnnouncementsNotifications = (signal?: AbortSignal) => {
  return request<GetAnnouncementsNotificationsResponse>({
    url: `/announcements/notifications`,
    method: "GET",
    signal,
  });
};

export const getGetAnnouncementsNotificationsQueryKey = () => {
  return [`/announcements/notifications`] as const;
};

export const getGetAnnouncementsNotificationsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnnouncementsNotificationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>
  > = ({ signal }) => getAnnouncementsNotifications(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnnouncementsNotificationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnnouncementsNotifications>>
>;
export type GetAnnouncementsNotificationsInfiniteQueryError =
  ErrorType<unknown>;

export const useGetAnnouncementsNotificationsInfinite = <
  TData = Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetAnnouncementsNotificationsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetAnnouncementsNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnnouncementsNotificationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>
  > = ({ signal }) => getAnnouncementsNotifications(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnnouncementsNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnnouncementsNotifications>>
>;
export type GetAnnouncementsNotificationsQueryError = ErrorType<unknown>;

export const useGetAnnouncementsNotifications = <
  TData = Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnnouncementsNotifications>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnnouncementsNotificationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createReIdentificationAnnouncement = (
  createReIdentificationAnnouncement: CreateReIdentificationAnnouncement,
) => {
  return request<CreateReIdentificationAnnouncementResponse>({
    url: `/announcements/re-identification`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createReIdentificationAnnouncement,
  });
};

export const getCreateReIdentificationAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReIdentificationAnnouncement>>,
    TError,
    { data: CreateReIdentificationAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReIdentificationAnnouncement>>,
  TError,
  { data: CreateReIdentificationAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReIdentificationAnnouncement>>,
    { data: CreateReIdentificationAnnouncement }
  > = (props) => {
    const { data } = props ?? {};

    return createReIdentificationAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReIdentificationAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReIdentificationAnnouncement>>
>;
export type CreateReIdentificationAnnouncementMutationBody =
  CreateReIdentificationAnnouncement;
export type CreateReIdentificationAnnouncementMutationError =
  ErrorType<HttpError>;

export const useCreateReIdentificationAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReIdentificationAnnouncement>>,
    TError,
    { data: CreateReIdentificationAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions =
    getCreateReIdentificationAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEstablishmentForSaleAnnouncement = (signal?: AbortSignal) => {
  return request<GetEstablishmentForSaleAnnouncementResponse>({
    url: `/announcements/sale`,
    method: "GET",
    signal,
  });
};

export const getGetEstablishmentForSaleAnnouncementQueryKey = () => {
  return [`/announcements/sale`] as const;
};

export const getGetEstablishmentForSaleAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEstablishmentForSaleAnnouncementQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>
  > = ({ signal }) => getEstablishmentForSaleAnnouncement(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEstablishmentForSaleAnnouncementInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>>;
export type GetEstablishmentForSaleAnnouncementInfiniteQueryError =
  ErrorType<unknown>;

export const useGetEstablishmentForSaleAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetEstablishmentForSaleAnnouncementInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetEstablishmentForSaleAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEstablishmentForSaleAnnouncementQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>
  > = ({ signal }) => getEstablishmentForSaleAnnouncement(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEstablishmentForSaleAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>
>;
export type GetEstablishmentForSaleAnnouncementQueryError = ErrorType<unknown>;

export const useGetEstablishmentForSaleAnnouncement = <
  TData = Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentForSaleAnnouncement>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetEstablishmentForSaleAnnouncementQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createSaleAnnouncement = (
  createAnnouncement: CreateAnnouncement,
) => {
  return request<CreateSaleAnnouncementResponse>({
    url: `/announcements/sale`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createAnnouncement,
  });
};

export const getCreateSaleAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSaleAnnouncement>>,
    TError,
    { data: CreateAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSaleAnnouncement>>,
  TError,
  { data: CreateAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSaleAnnouncement>>,
    { data: CreateAnnouncement }
  > = (props) => {
    const { data } = props ?? {};

    return createSaleAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSaleAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSaleAnnouncement>>
>;
export type CreateSaleAnnouncementMutationBody = CreateAnnouncement;
export type CreateSaleAnnouncementMutationError = ErrorType<HttpError>;

export const useCreateSaleAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSaleAnnouncement>>,
    TError,
    { data: CreateAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions = getCreateSaleAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createUnusabilityAnnouncement = (
  createUnusabilityAnnouncement: CreateUnusabilityAnnouncement,
) => {
  return request<CreateUnusabilityAnnouncementResponse>({
    url: `/announcements/unusability`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createUnusabilityAnnouncement,
  });
};

export const getCreateUnusabilityAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUnusabilityAnnouncement>>,
    TError,
    { data: CreateUnusabilityAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUnusabilityAnnouncement>>,
  TError,
  { data: CreateUnusabilityAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUnusabilityAnnouncement>>,
    { data: CreateUnusabilityAnnouncement }
  > = (props) => {
    const { data } = props ?? {};

    return createUnusabilityAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUnusabilityAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUnusabilityAnnouncement>>
>;
export type CreateUnusabilityAnnouncementMutationBody =
  CreateUnusabilityAnnouncement;
export type CreateUnusabilityAnnouncementMutationError = ErrorType<HttpError>;

export const useCreateUnusabilityAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUnusabilityAnnouncement>>,
    TError,
    { data: CreateUnusabilityAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions =
    getCreateUnusabilityAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAnnouncement = (id: number) => {
  return request<DeleteAnnouncementResponse>({
    url: `/announcements/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAnnouncementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnnouncement>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAnnouncement>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAnnouncement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAnnouncement(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAnnouncement>>
>;

export type DeleteAnnouncementMutationError = ErrorType<unknown>;

export const useDeleteAnnouncement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnnouncement>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateAnnouncement = (
  id: number,
  updateAnnouncement: UpdateAnnouncement,
) => {
  return request<UpdateAnnouncementResponse>({
    url: `/announcements/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateAnnouncement,
  });
};

export const getUpdateAnnouncementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnnouncement>>,
    TError,
    { id: number; data: UpdateAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAnnouncement>>,
  TError,
  { id: number; data: UpdateAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAnnouncement>>,
    { id: number; data: UpdateAnnouncement }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAnnouncement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAnnouncement>>
>;
export type UpdateAnnouncementMutationBody = UpdateAnnouncement;
export type UpdateAnnouncementMutationError = ErrorType<unknown>;

export const useUpdateAnnouncement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnnouncement>>,
    TError,
    { id: number; data: UpdateAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getBirthAnnouncement = (id: number, signal?: AbortSignal) => {
  return request<GetBirthAnnouncementResponse>({
    url: `/announcements/${id}/birth`,
    method: "GET",
    signal,
  });
};

export const getGetBirthAnnouncementQueryKey = (id: number) => {
  return [`/announcements/${id}/birth`] as const;
};

export const getGetBirthAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBirthAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBirthAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBirthAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBirthAnnouncement>>
  > = ({ signal }) => getBirthAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBirthAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBirthAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBirthAnnouncement>>
>;
export type GetBirthAnnouncementInfiniteQueryError = ErrorType<HttpError>;

export const useGetBirthAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getBirthAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBirthAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBirthAnnouncementInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBirthAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getBirthAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBirthAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBirthAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBirthAnnouncement>>
  > = ({ signal }) => getBirthAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBirthAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBirthAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBirthAnnouncement>>
>;
export type GetBirthAnnouncementQueryError = ErrorType<HttpError>;

export const useGetBirthAnnouncement = <
  TData = Awaited<ReturnType<typeof getBirthAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBirthAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBirthAnnouncementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getChangeOfCharacteristicAnnouncement = (
  id: number,
  signal?: AbortSignal,
) => {
  return request<GetChangeOfCharacteristicAnnouncementResponse>({
    url: `/announcements/${id}/change-of-characteristic`,
    method: "GET",
    signal,
  });
};

export const getGetChangeOfCharacteristicAnnouncementQueryKey = (
  id: number,
) => {
  return [`/announcements/${id}/change-of-characteristic`] as const;
};

export const getGetChangeOfCharacteristicAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetChangeOfCharacteristicAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>
  > = ({ signal }) => getChangeOfCharacteristicAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChangeOfCharacteristicAnnouncementInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>
  >;
export type GetChangeOfCharacteristicAnnouncementInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetChangeOfCharacteristicAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetChangeOfCharacteristicAnnouncementInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetChangeOfCharacteristicAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetChangeOfCharacteristicAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>
  > = ({ signal }) => getChangeOfCharacteristicAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChangeOfCharacteristicAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>
>;
export type GetChangeOfCharacteristicAnnouncementQueryError =
  ErrorType<HttpError>;

export const useGetChangeOfCharacteristicAnnouncement = <
  TData = Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChangeOfCharacteristicAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChangeOfCharacteristicAnnouncementQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getDeathAnnouncement = (id: number, signal?: AbortSignal) => {
  return request<GetDeathAnnouncementResponse>({
    url: `/announcements/${id}/death`,
    method: "GET",
    signal,
  });
};

export const getGetDeathAnnouncementQueryKey = (id: number) => {
  return [`/announcements/${id}/death`] as const;
};

export const getGetDeathAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeathAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDeathAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeathAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeathAnnouncement>>
  > = ({ signal }) => getDeathAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeathAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDeathAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeathAnnouncement>>
>;
export type GetDeathAnnouncementInfiniteQueryError = ErrorType<unknown>;

export const useGetDeathAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getDeathAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDeathAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDeathAnnouncementInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetDeathAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeathAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDeathAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeathAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeathAnnouncement>>
  > = ({ signal }) => getDeathAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeathAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDeathAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeathAnnouncement>>
>;
export type GetDeathAnnouncementQueryError = ErrorType<unknown>;

export const useGetDeathAnnouncement = <
  TData = Awaited<ReturnType<typeof getDeathAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDeathAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDeathAnnouncementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateDeathAnnouncement = (
  id: number,
  deathAnnouncement: DeathAnnouncement,
) => {
  return request<UpdateDeathAnnouncementResponse>({
    url: `/announcements/${id}/death`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: deathAnnouncement,
  });
};

export const getUpdateDeathAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeathAnnouncement>>,
    TError,
    { id: number; data: DeathAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDeathAnnouncement>>,
  TError,
  { id: number; data: DeathAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDeathAnnouncement>>,
    { id: number; data: DeathAnnouncement }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDeathAnnouncement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDeathAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDeathAnnouncement>>
>;
export type UpdateDeathAnnouncementMutationBody = DeathAnnouncement;
export type UpdateDeathAnnouncementMutationError = ErrorType<HttpError>;

export const useUpdateDeathAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeathAnnouncement>>,
    TError,
    { id: number; data: DeathAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateDeathAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEntryAnnouncement = (id: number, signal?: AbortSignal) => {
  return request<GetEntryAnnouncementResponse>({
    url: `/announcements/${id}/entry`,
    method: "GET",
    signal,
  });
};

export const getGetEntryAnnouncementQueryKey = (id: number) => {
  return [`/announcements/${id}/entry`] as const;
};

export const getGetEntryAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntryAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEntryAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEntryAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntryAnnouncement>>
  > = ({ signal }) => getEntryAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEntryAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEntryAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntryAnnouncement>>
>;
export type GetEntryAnnouncementInfiniteQueryError = ErrorType<unknown>;

export const useGetEntryAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getEntryAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEntryAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEntryAnnouncementInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetEntryAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntryAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEntryAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEntryAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntryAnnouncement>>
  > = ({ signal }) => getEntryAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntryAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEntryAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntryAnnouncement>>
>;
export type GetEntryAnnouncementQueryError = ErrorType<unknown>;

export const useGetEntryAnnouncement = <
  TData = Awaited<ReturnType<typeof getEntryAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEntryAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEntryAnnouncementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const removeGtasFromEntryAnnouncement = (
  id: number,
  removeGtasFromEntryAnnouncementBody: RemoveGtasFromEntryAnnouncementBody,
) => {
  return request<RemoveGtasFromEntryAnnouncementResponse>({
    url: `/announcements/${id}/entry/gtas`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: removeGtasFromEntryAnnouncementBody,
  });
};

export const getRemoveGtasFromEntryAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeGtasFromEntryAnnouncement>>,
    TError,
    { id: number; data: RemoveGtasFromEntryAnnouncementBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeGtasFromEntryAnnouncement>>,
  TError,
  { id: number; data: RemoveGtasFromEntryAnnouncementBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeGtasFromEntryAnnouncement>>,
    { id: number; data: RemoveGtasFromEntryAnnouncementBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return removeGtasFromEntryAnnouncement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveGtasFromEntryAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeGtasFromEntryAnnouncement>>
>;
export type RemoveGtasFromEntryAnnouncementMutationBody =
  RemoveGtasFromEntryAnnouncementBody;
export type RemoveGtasFromEntryAnnouncementMutationError = ErrorType<HttpError>;

export const useRemoveGtasFromEntryAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeGtasFromEntryAnnouncement>>,
    TError,
    { id: number; data: RemoveGtasFromEntryAnnouncementBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getRemoveGtasFromEntryAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getExitAnnouncement = (id: number, signal?: AbortSignal) => {
  return request<GetExitAnnouncementResponse>({
    url: `/announcements/${id}/exit`,
    method: "GET",
    signal,
  });
};

export const getGetExitAnnouncementQueryKey = (id: number) => {
  return [`/announcements/${id}/exit`] as const;
};

export const getGetExitAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getExitAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getExitAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExitAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExitAnnouncement>>
  > = ({ signal }) => getExitAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getExitAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExitAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExitAnnouncement>>
>;
export type GetExitAnnouncementInfiniteQueryError = ErrorType<unknown>;

export const useGetExitAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getExitAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getExitAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetExitAnnouncementInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetExitAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getExitAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExitAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExitAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExitAnnouncement>>
  > = ({ signal }) => getExitAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExitAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExitAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExitAnnouncement>>
>;
export type GetExitAnnouncementQueryError = ErrorType<unknown>;

export const useGetExitAnnouncement = <
  TData = Awaited<ReturnType<typeof getExitAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExitAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetExitAnnouncementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getReIdentificationAnnouncement = (
  id: number,
  signal?: AbortSignal,
) => {
  return request<GetReIdentificationAnnouncementResponse>({
    url: `/announcements/${id}/re-identification`,
    method: "GET",
    signal,
  });
};

export const getGetReIdentificationAnnouncementQueryKey = (id: number) => {
  return [`/announcements/${id}/re-identification`] as const;
};

export const getGetReIdentificationAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReIdentificationAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReIdentificationAnnouncement>>
  > = ({ signal }) => getReIdentificationAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReIdentificationAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReIdentificationAnnouncement>>
>;
export type GetReIdentificationAnnouncementInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetReIdentificationAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetReIdentificationAnnouncementInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetReIdentificationAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReIdentificationAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReIdentificationAnnouncement>>
  > = ({ signal }) => getReIdentificationAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReIdentificationAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReIdentificationAnnouncement>>
>;
export type GetReIdentificationAnnouncementQueryError = ErrorType<HttpError>;

export const useGetReIdentificationAnnouncement = <
  TData = Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReIdentificationAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetReIdentificationAnnouncementQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateReIdentificationAnnouncement = (
  id: number,
  updateReIdentificationAnnouncement: UpdateReIdentificationAnnouncement,
) => {
  return request<UpdateReIdentificationAnnouncementResponse>({
    url: `/announcements/${id}/re-identification`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateReIdentificationAnnouncement,
  });
};

export const getUpdateReIdentificationAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReIdentificationAnnouncement>>,
    TError,
    { id: number; data: UpdateReIdentificationAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReIdentificationAnnouncement>>,
  TError,
  { id: number; data: UpdateReIdentificationAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReIdentificationAnnouncement>>,
    { id: number; data: UpdateReIdentificationAnnouncement }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateReIdentificationAnnouncement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReIdentificationAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReIdentificationAnnouncement>>
>;
export type UpdateReIdentificationAnnouncementMutationBody =
  UpdateReIdentificationAnnouncement;
export type UpdateReIdentificationAnnouncementMutationError =
  ErrorType<HttpError>;

export const useUpdateReIdentificationAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReIdentificationAnnouncement>>,
    TError,
    { id: number; data: UpdateReIdentificationAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateReIdentificationAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSaleAnnouncement = (id: number, signal?: AbortSignal) => {
  return request<GetSaleAnnouncementResponse>({
    url: `/announcements/${id}/sale`,
    method: "GET",
    signal,
  });
};

export const getGetSaleAnnouncementQueryKey = (id: number) => {
  return [`/announcements/${id}/sale`] as const;
};

export const getGetSaleAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleAnnouncement>>
  > = ({ signal }) => getSaleAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSaleAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleAnnouncement>>
>;
export type GetSaleAnnouncementInfiniteQueryError = ErrorType<unknown>;

export const useGetSaleAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleAnnouncementInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSaleAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleAnnouncement>>
  > = ({ signal }) => getSaleAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSaleAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleAnnouncement>>
>;
export type GetSaleAnnouncementQueryError = ErrorType<unknown>;

export const useGetSaleAnnouncement = <
  TData = Awaited<ReturnType<typeof getSaleAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleAnnouncementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getUnusabilityAnnouncement = (
  id: number,
  signal?: AbortSignal,
) => {
  return request<GetUnusabilityAnnouncementResponse>({
    url: `/announcements/${id}/unusability`,
    method: "GET",
    signal,
  });
};

export const getGetUnusabilityAnnouncementQueryKey = (id: number) => {
  return [`/announcements/${id}/unusability`] as const;
};

export const getGetUnusabilityAnnouncementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUnusabilityAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUnusabilityAnnouncement>>
  > = ({ signal }) => getUnusabilityAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUnusabilityAnnouncementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnusabilityAnnouncement>>
>;
export type GetUnusabilityAnnouncementInfiniteQueryError = ErrorType<unknown>;

export const useGetUnusabilityAnnouncementInfinite = <
  TData = Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUnusabilityAnnouncementInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetUnusabilityAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUnusabilityAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUnusabilityAnnouncement>>
  > = ({ signal }) => getUnusabilityAnnouncement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUnusabilityAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnusabilityAnnouncement>>
>;
export type GetUnusabilityAnnouncementQueryError = ErrorType<unknown>;

export const useGetUnusabilityAnnouncement = <
  TData = Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUnusabilityAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUnusabilityAnnouncementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateUnusabilityAnnouncement = (
  id: number,
  updateUnusabilityAnnouncement: UpdateUnusabilityAnnouncement,
) => {
  return request<UpdateUnusabilityAnnouncementResponse>({
    url: `/announcements/${id}/unusability`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateUnusabilityAnnouncement,
  });
};

export const getUpdateUnusabilityAnnouncementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUnusabilityAnnouncement>>,
    TError,
    { id: number; data: UpdateUnusabilityAnnouncement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUnusabilityAnnouncement>>,
  TError,
  { id: number; data: UpdateUnusabilityAnnouncement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUnusabilityAnnouncement>>,
    { id: number; data: UpdateUnusabilityAnnouncement }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUnusabilityAnnouncement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUnusabilityAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUnusabilityAnnouncement>>
>;
export type UpdateUnusabilityAnnouncementMutationBody =
  UpdateUnusabilityAnnouncement;
export type UpdateUnusabilityAnnouncementMutationError = ErrorType<HttpError>;

export const useUpdateUnusabilityAnnouncement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUnusabilityAnnouncement>>,
    TError,
    { id: number; data: UpdateUnusabilityAnnouncement },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateUnusabilityAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAuditAnimal = (signal?: AbortSignal) => {
  return request<ListAuditAnimalResponse>({
    url: `/audit-management`,
    method: "GET",
    signal,
  });
};

export const getListAuditAnimalQueryKey = () => {
  return [`/audit-management`] as const;
};

export const getListAuditAnimalInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditAnimal>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAuditAnimal>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuditAnimalQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditAnimal>>> = ({
    signal,
  }) => listAuditAnimal(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAuditAnimal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuditAnimalInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuditAnimal>>
>;
export type ListAuditAnimalInfiniteQueryError = ErrorType<HttpError>;

export const useListAuditAnimalInfinite = <
  TData = Awaited<ReturnType<typeof listAuditAnimal>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAuditAnimal>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAuditAnimalInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListAuditAnimalQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditAnimal>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAuditAnimal>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuditAnimalQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditAnimal>>> = ({
    signal,
  }) => listAuditAnimal(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuditAnimal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuditAnimalQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuditAnimal>>
>;
export type ListAuditAnimalQueryError = ErrorType<HttpError>;

export const useListAuditAnimal = <
  TData = Awaited<ReturnType<typeof listAuditAnimal>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAuditAnimal>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAuditAnimalQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createAuditAnimal = (auditManagementDto: AuditManagementDto) => {
  return request<boolean>({
    url: `/audit-management`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: auditManagementDto,
  });
};

export const getCreateAuditAnimalMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAuditAnimal>>,
    TError,
    { data: AuditManagementDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAuditAnimal>>,
  TError,
  { data: AuditManagementDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAuditAnimal>>,
    { data: AuditManagementDto }
  > = (props) => {
    const { data } = props ?? {};

    return createAuditAnimal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAuditAnimalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAuditAnimal>>
>;
export type CreateAuditAnimalMutationBody = AuditManagementDto;
export type CreateAuditAnimalMutationError = ErrorType<HttpError>;

export const useCreateAuditAnimal = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAuditAnimal>>,
    TError,
    { data: AuditManagementDto },
    TContext
  >;
}) => {
  const mutationOptions = getCreateAuditAnimalMutationOptions(options);

  return useMutation(mutationOptions);
};

export const auditOxIdentification = (
  auditOxIdentificationBody: AuditOxIdentificationBody,
) => {
  return request<boolean>({
    url: `/audit-management/identification`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: auditOxIdentificationBody,
  });
};

export const getAuditOxIdentificationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof auditOxIdentification>>,
    TError,
    { data: AuditOxIdentificationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof auditOxIdentification>>,
  TError,
  { data: AuditOxIdentificationBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof auditOxIdentification>>,
    { data: AuditOxIdentificationBody }
  > = (props) => {
    const { data } = props ?? {};

    return auditOxIdentification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuditOxIdentificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof auditOxIdentification>>
>;
export type AuditOxIdentificationMutationBody = AuditOxIdentificationBody;
export type AuditOxIdentificationMutationError = ErrorType<HttpError>;

export const useAuditOxIdentification = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof auditOxIdentification>>,
    TError,
    { data: AuditOxIdentificationBody },
    TContext
  >;
}) => {
  const mutationOptions = getAuditOxIdentificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const auditMoveOx = (params: AuditMoveOxParams) => {
  return request<boolean>({
    url: `/audit-management/identification`,
    method: "PUT",
    params,
  });
};

export const getAuditMoveOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof auditMoveOx>>,
    TError,
    { params: AuditMoveOxParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof auditMoveOx>>,
  TError,
  { params: AuditMoveOxParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof auditMoveOx>>,
    { params: AuditMoveOxParams }
  > = (props) => {
    const { params } = props ?? {};

    return auditMoveOx(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuditMoveOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof auditMoveOx>>
>;

export type AuditMoveOxMutationError = ErrorType<HttpError>;

export const useAuditMoveOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof auditMoveOx>>,
    TError,
    { params: AuditMoveOxParams },
    TContext
  >;
}) => {
  const mutationOptions = getAuditMoveOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const auditFinalizeBatches = () => {
  return request<AuditFinalizeBatchesResponse>({
    url: `/audit/finalized-batch`,
    method: "POST",
  });
};

export const getAuditFinalizeBatchesMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof auditFinalizeBatches>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof auditFinalizeBatches>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof auditFinalizeBatches>>,
    void
  > = () => {
    return auditFinalizeBatches();
  };

  return { mutationFn, ...mutationOptions };
};

export type AuditFinalizeBatchesMutationResult = NonNullable<
  Awaited<ReturnType<typeof auditFinalizeBatches>>
>;

export type AuditFinalizeBatchesMutationError = ErrorType<HttpError>;

export const useAuditFinalizeBatches = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof auditFinalizeBatches>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getAuditFinalizeBatchesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const login = (login: Login) => {
  return request<LoginResponse>({
    url: `/auth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: login,
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: Login },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: Login },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: Login }
  > = (props) => {
    const { data } = props ?? {};

    return login(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = Login;
export type LoginMutationError = ErrorType<HttpError>;

export const useLogin = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: Login },
    TContext
  >;
}) => {
  const mutationOptions = getLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

export const refreshToken = (refreshTokenBody: RefreshTokenBody) => {
  return request<RefreshTokenResponse>({
    url: `/auth`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: refreshTokenBody,
  });
};

export const getRefreshTokenMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    { data: RefreshTokenBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  { data: RefreshTokenBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshToken>>,
    { data: RefreshTokenBody }
  > = (props) => {
    const { data } = props ?? {};

    return refreshToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshToken>>
>;
export type RefreshTokenMutationBody = RefreshTokenBody;
export type RefreshTokenMutationError = ErrorType<HttpError>;

export const useRefreshToken = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    { data: RefreshTokenBody },
    TContext
  >;
}) => {
  const mutationOptions = getRefreshTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listBatches = (
  params?: ListBatchesParams,
  signal?: AbortSignal,
) => {
  return request<ListBatchesResponse>({
    url: `/batches`,
    method: "GET",
    params,
    signal,
  });
};

export const getListBatchesQueryKey = (params?: ListBatchesParams) => {
  return [`/batches`, ...(params ? [params] : [])] as const;
};

export const getListBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBatchesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBatches>>> = ({
    signal,
  }) => listBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatches>>
>;
export type ListBatchesInfiniteQueryError = ErrorType<unknown>;

export const useListBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBatches>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBatchesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBatches>>> = ({
    signal,
  }) => listBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatches>>
>;
export type ListBatchesQueryError = ErrorType<unknown>;

export const useListBatches = <
  TData = Awaited<ReturnType<typeof listBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatches>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createBatch = (createBatch: CreateBatch) => {
  return request<CreateBatchResponse>({
    url: `/batches`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createBatch,
  });
};

export const getCreateBatchMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatch>>,
    TError,
    { data: CreateBatch },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBatch>>,
  TError,
  { data: CreateBatch },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBatch>>,
    { data: CreateBatch }
  > = (props) => {
    const { data } = props ?? {};

    return createBatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBatch>>
>;
export type CreateBatchMutationBody = CreateBatch;
export type CreateBatchMutationError = ErrorType<HttpError>;

export const useCreateBatch = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatch>>,
    TError,
    { data: CreateBatch },
    TContext
  >;
}) => {
  const mutationOptions = getCreateBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listActiveAndFinalizedBatches = (
  params?: ListActiveAndFinalizedBatchesParams,
  signal?: AbortSignal,
) => {
  return request<ListActiveAndFinalizedBatchesResponse>({
    url: `/batches/active-and-finalized-batches`,
    method: "GET",
    params,
    signal,
  });
};

export const getListActiveAndFinalizedBatchesQueryKey = (
  params?: ListActiveAndFinalizedBatchesParams,
) => {
  return [
    `/batches/active-and-finalized-batches`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListActiveAndFinalizedBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListActiveAndFinalizedBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListActiveAndFinalizedBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>
  > = ({ signal }) => listActiveAndFinalizedBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveAndFinalizedBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>
>;
export type ListActiveAndFinalizedBatchesInfiniteQueryError =
  ErrorType<unknown>;

export const useListActiveAndFinalizedBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListActiveAndFinalizedBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListActiveAndFinalizedBatchesInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListActiveAndFinalizedBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListActiveAndFinalizedBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListActiveAndFinalizedBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>
  > = ({ signal }) => listActiveAndFinalizedBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveAndFinalizedBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>
>;
export type ListActiveAndFinalizedBatchesQueryError = ErrorType<unknown>;

export const useListActiveAndFinalizedBatches = <
  TData = Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListActiveAndFinalizedBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listActiveAndFinalizedBatches>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListActiveAndFinalizedBatchesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listBatchesSimplified = (
  params?: ListBatchesSimplifiedParams,
  signal?: AbortSignal,
) => {
  return request<ListBatchesSimplifiedResponse>({
    url: `/batches/batches`,
    method: "GET",
    params,
    signal,
  });
};

export const getListBatchesSimplifiedQueryKey = (
  params?: ListBatchesSimplifiedParams,
) => {
  return [`/batches/batches`, ...(params ? [params] : [])] as const;
};

export const getListBatchesSimplifiedInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesSimplifiedParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBatchesSimplified>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesSimplifiedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesSimplified>>
  > = ({ signal }) => listBatchesSimplified(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesSimplified>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesSimplifiedInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesSimplified>>
>;
export type ListBatchesSimplifiedInfiniteQueryError = ErrorType<unknown>;

export const useListBatchesSimplifiedInfinite = <
  TData = Awaited<ReturnType<typeof listBatchesSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesSimplifiedParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBatchesSimplified>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesSimplifiedInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBatchesSimplifiedQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesSimplifiedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatchesSimplified>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesSimplifiedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesSimplified>>
  > = ({ signal }) => listBatchesSimplified(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesSimplified>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesSimplifiedQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesSimplified>>
>;
export type ListBatchesSimplifiedQueryError = ErrorType<unknown>;

export const useListBatchesSimplified = <
  TData = Awaited<ReturnType<typeof listBatchesSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBatchesSimplifiedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatchesSimplified>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesSimplifiedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const batchesDetails = (signal?: AbortSignal) => {
  return request<BatchesDetailsResponse>({
    url: `/batches/details`,
    method: "GET",
    signal,
  });
};

export const getBatchesDetailsQueryKey = () => {
  return [`/batches/details`] as const;
};

export const getBatchesDetailsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof batchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchesDetails>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchesDetailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchesDetails>>> = ({
    signal,
  }) => batchesDetails(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchesDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchesDetailsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchesDetails>>
>;
export type BatchesDetailsInfiniteQueryError = ErrorType<unknown>;

export const useBatchesDetailsInfinite = <
  TData = Awaited<ReturnType<typeof batchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchesDetails>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchesDetailsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchesDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof batchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof batchesDetails>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchesDetailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchesDetails>>> = ({
    signal,
  }) => batchesDetails(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof batchesDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchesDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchesDetails>>
>;
export type BatchesDetailsQueryError = ErrorType<unknown>;

export const useBatchesDetails = <
  TData = Awaited<ReturnType<typeof batchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof batchesDetails>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchesDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listFinalizedBatches = (
  params?: ListFinalizedBatchesParams,
  signal?: AbortSignal,
) => {
  return request<ListFinalizedBatchesResponse>({
    url: `/batches/finalize`,
    method: "GET",
    params,
    signal,
  });
};

export const getListFinalizedBatchesQueryKey = (
  params?: ListFinalizedBatchesParams,
) => {
  return [`/batches/finalize`, ...(params ? [params] : [])] as const;
};

export const getListFinalizedBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFinalizedBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listFinalizedBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFinalizedBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFinalizedBatches>>
  > = ({ signal }) => listFinalizedBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listFinalizedBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFinalizedBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFinalizedBatches>>
>;
export type ListFinalizedBatchesInfiniteQueryError = ErrorType<unknown>;

export const useListFinalizedBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFinalizedBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listFinalizedBatches>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListFinalizedBatchesInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListFinalizedBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFinalizedBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFinalizedBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFinalizedBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFinalizedBatches>>
  > = ({ signal }) => listFinalizedBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listFinalizedBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFinalizedBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFinalizedBatches>>
>;
export type ListFinalizedBatchesQueryError = ErrorType<unknown>;

export const useListFinalizedBatches = <
  TData = Awaited<ReturnType<typeof listFinalizedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFinalizedBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFinalizedBatches>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListFinalizedBatchesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const finalizedBatchesDetails = (signal?: AbortSignal) => {
  return request<FinalizedBatchesDetailsResponse>({
    url: `/batches/finalized-details`,
    method: "GET",
    signal,
  });
};

export const getFinalizedBatchesDetailsQueryKey = () => {
  return [`/batches/finalized-details`] as const;
};

export const getFinalizedBatchesDetailsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof finalizedBatchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFinalizedBatchesDetailsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>
  > = ({ signal }) => finalizedBatchesDetails(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FinalizedBatchesDetailsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof finalizedBatchesDetails>>
>;
export type FinalizedBatchesDetailsInfiniteQueryError = ErrorType<unknown>;

export const useFinalizedBatchesDetailsInfinite = <
  TData = Awaited<ReturnType<typeof finalizedBatchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFinalizedBatchesDetailsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFinalizedBatchesDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof finalizedBatchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFinalizedBatchesDetailsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>
  > = ({ signal }) => finalizedBatchesDetails(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FinalizedBatchesDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof finalizedBatchesDetails>>
>;
export type FinalizedBatchesDetailsQueryError = ErrorType<unknown>;

export const useFinalizedBatchesDetails = <
  TData = Awaited<ReturnType<typeof finalizedBatchesDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchesDetails>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFinalizedBatchesDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listHoldingBatches = (signal?: AbortSignal) => {
  return request<ListHoldingBatchesResponse>({
    url: `/batches/list-holding-batches`,
    method: "GET",
    signal,
  });
};

export const getListHoldingBatchesQueryKey = () => {
  return [`/batches/list-holding-batches`] as const;
};

export const getListHoldingBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listHoldingBatches>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listHoldingBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHoldingBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHoldingBatches>>
  > = ({ signal }) => listHoldingBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listHoldingBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHoldingBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHoldingBatches>>
>;
export type ListHoldingBatchesInfiniteQueryError = ErrorType<HttpError>;

export const useListHoldingBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listHoldingBatches>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listHoldingBatches>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListHoldingBatchesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListHoldingBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listHoldingBatches>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listHoldingBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHoldingBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHoldingBatches>>
  > = ({ signal }) => listHoldingBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listHoldingBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHoldingBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHoldingBatches>>
>;
export type ListHoldingBatchesQueryError = ErrorType<HttpError>;

export const useListHoldingBatches = <
  TData = Awaited<ReturnType<typeof listHoldingBatches>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listHoldingBatches>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListHoldingBatchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listPastureBatches = (signal?: AbortSignal) => {
  return request<ListPastureBatchesResponse>({
    url: `/batches/list-pasture-batches`,
    method: "GET",
    signal,
  });
};

export const getListPastureBatchesQueryKey = () => {
  return [`/batches/list-pasture-batches`] as const;
};

export const getListPastureBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPastureBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPastureBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPastureBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPastureBatches>>
  > = ({ signal }) => listPastureBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPastureBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPastureBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPastureBatches>>
>;
export type ListPastureBatchesInfiniteQueryError = ErrorType<unknown>;

export const useListPastureBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listPastureBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPastureBatches>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPastureBatchesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPastureBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPastureBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPastureBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPastureBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPastureBatches>>
  > = ({ signal }) => listPastureBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPastureBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPastureBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPastureBatches>>
>;
export type ListPastureBatchesQueryError = ErrorType<unknown>;

export const useListPastureBatches = <
  TData = Awaited<ReturnType<typeof listPastureBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPastureBatches>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPastureBatchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listBatchesWithNonIdentifiedOxen = (signal?: AbortSignal) => {
  return request<ListBatchesWithNonIdentifiedOxenResponse>({
    url: `/batches/non-identified`,
    method: "GET",
    signal,
  });
};

export const getListBatchesWithNonIdentifiedOxenQueryKey = () => {
  return [`/batches/non-identified`] as const;
};

export const getListBatchesWithNonIdentifiedOxenInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesWithNonIdentifiedOxenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>
  > = ({ signal }) => listBatchesWithNonIdentifiedOxen(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesWithNonIdentifiedOxenInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>
>;
export type ListBatchesWithNonIdentifiedOxenInfiniteQueryError =
  ErrorType<unknown>;

export const useListBatchesWithNonIdentifiedOxenInfinite = <
  TData = Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListBatchesWithNonIdentifiedOxenInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBatchesWithNonIdentifiedOxenQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesWithNonIdentifiedOxenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>
  > = ({ signal }) => listBatchesWithNonIdentifiedOxen(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesWithNonIdentifiedOxenQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>
>;
export type ListBatchesWithNonIdentifiedOxenQueryError = ErrorType<unknown>;

export const useListBatchesWithNonIdentifiedOxen = <
  TData = Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesWithNonIdentifiedOxen>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesWithNonIdentifiedOxenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const batchesOxen = (
  params: BatchesOxenParams,
  signal?: AbortSignal,
) => {
  return request<BatchesOxenResponse>({
    url: `/batches/oxen`,
    method: "GET",
    params,
    signal,
  });
};

export const getBatchesOxenQueryKey = (params: BatchesOxenParams) => {
  return [`/batches/oxen`, ...(params ? [params] : [])] as const;
};

export const getBatchesOxenInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof batchesOxen>>,
  TError = ErrorType<unknown>,
>(
  params: BatchesOxenParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchesOxen>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchesOxenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchesOxen>>> = ({
    signal,
  }) => batchesOxen(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchesOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchesOxenInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchesOxen>>
>;
export type BatchesOxenInfiniteQueryError = ErrorType<unknown>;

export const useBatchesOxenInfinite = <
  TData = Awaited<ReturnType<typeof batchesOxen>>,
  TError = ErrorType<unknown>,
>(
  params: BatchesOxenParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchesOxen>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchesOxenInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchesOxenQueryOptions = <
  TData = Awaited<ReturnType<typeof batchesOxen>>,
  TError = ErrorType<unknown>,
>(
  params: BatchesOxenParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchesOxen>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchesOxenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchesOxen>>> = ({
    signal,
  }) => batchesOxen(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof batchesOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchesOxenQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchesOxen>>
>;
export type BatchesOxenQueryError = ErrorType<unknown>;

export const useBatchesOxen = <
  TData = Awaited<ReturnType<typeof batchesOxen>>,
  TError = ErrorType<unknown>,
>(
  params: BatchesOxenParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchesOxen>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchesOxenQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const ensureBatchStatuses = (
  ensureBatchStatusesBody: EnsureBatchStatusesBody,
) => {
  return request<boolean>({
    url: `/batches/statuses`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: ensureBatchStatusesBody,
  });
};

export const getEnsureBatchStatusesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensureBatchStatuses>>,
    TError,
    { data: EnsureBatchStatusesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ensureBatchStatuses>>,
  TError,
  { data: EnsureBatchStatusesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ensureBatchStatuses>>,
    { data: EnsureBatchStatusesBody }
  > = (props) => {
    const { data } = props ?? {};

    return ensureBatchStatuses(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnsureBatchStatusesMutationResult = NonNullable<
  Awaited<ReturnType<typeof ensureBatchStatuses>>
>;
export type EnsureBatchStatusesMutationBody = EnsureBatchStatusesBody;
export type EnsureBatchStatusesMutationError = ErrorType<unknown>;

export const useEnsureBatchStatuses = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensureBatchStatuses>>,
    TError,
    { data: EnsureBatchStatusesBody },
    TContext
  >;
}) => {
  const mutationOptions = getEnsureBatchStatusesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listCorralsWithoutDiet = (signal?: AbortSignal) => {
  return request<ListCorralsWithoutDietResponse>({
    url: `/batches/without-diet-list`,
    method: "GET",
    signal,
  });
};

export const getListCorralsWithoutDietQueryKey = () => {
  return [`/batches/without-diet-list`] as const;
};

export const getListCorralsWithoutDietInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCorralsWithoutDietQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>
  > = ({ signal }) => listCorralsWithoutDiet(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralsWithoutDietInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralsWithoutDiet>>
>;
export type ListCorralsWithoutDietInfiniteQueryError = ErrorType<unknown>;

export const useListCorralsWithoutDietInfinite = <
  TData = Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralsWithoutDietInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCorralsWithoutDietQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCorralsWithoutDietQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>
  > = ({ signal }) => listCorralsWithoutDiet(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralsWithoutDietQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralsWithoutDiet>>
>;
export type ListCorralsWithoutDietQueryError = ErrorType<unknown>;

export const useListCorralsWithoutDiet = <
  TData = Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCorralsWithoutDiet>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralsWithoutDietQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatch = (id: number, signal?: AbortSignal) => {
  return request<GetBatchResponse>({
    url: `/batches/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetBatchQueryKey = (id: number) => {
  return [`/batches/${id}`] as const;
};

export const getGetBatchInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatch>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatch>>> = ({
    signal,
  }) => getBatch(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBatch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatch>>
>;
export type GetBatchInfiniteQueryError = ErrorType<HttpError>;

export const useGetBatchInfinite = <
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatch>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBatchQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatch>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatch>>> = ({
    signal,
  }) => getBatch(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetBatchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatch>>
>;
export type GetBatchQueryError = ErrorType<HttpError>;

export const useGetBatch = <
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatch>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateBatch = (id: number, updateBatch: UpdateBatch) => {
  return request<UpdateBatchResponse>({
    url: `/batches/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateBatch,
  });
};

export const getUpdateBatchMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatch>>,
    TError,
    { id: number; data: UpdateBatch },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatch>>,
  TError,
  { id: number; data: UpdateBatch },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatch>>,
    { id: number; data: UpdateBatch }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBatch(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatch>>
>;
export type UpdateBatchMutationBody = UpdateBatch;
export type UpdateBatchMutationError = ErrorType<HttpError>;

export const useUpdateBatch = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatch>>,
    TError,
    { id: number; data: UpdateBatch },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const activateBatch = (id: number, params: ActivateBatchParams) => {
  return request<ActivateBatchResponse>({
    url: `/batches/${id}/activate`,
    method: "POST",
    params,
  });
};

export const getActivateBatchMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateBatch>>,
    TError,
    { id: number; params: ActivateBatchParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateBatch>>,
  TError,
  { id: number; params: ActivateBatchParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateBatch>>,
    { id: number; params: ActivateBatchParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return activateBatch(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateBatch>>
>;

export type ActivateBatchMutationError = ErrorType<HttpError>;

export const useActivateBatch = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateBatch>>,
    TError,
    { id: number; params: ActivateBatchParams },
    TContext
  >;
}) => {
  const mutationOptions = getActivateBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateBatchActivationDate = (
  id: number,
  updateBatchActivationDateBody: UpdateBatchActivationDateBody,
) => {
  return request<UpdateBatchActivationDateResponse>({
    url: `/batches/${id}/activation-date`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateBatchActivationDateBody,
  });
};

export const getUpdateBatchActivationDateMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchActivationDate>>,
    TError,
    { id: number; data: UpdateBatchActivationDateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatchActivationDate>>,
  TError,
  { id: number; data: UpdateBatchActivationDateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatchActivationDate>>,
    { id: number; data: UpdateBatchActivationDateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBatchActivationDate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchActivationDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatchActivationDate>>
>;
export type UpdateBatchActivationDateMutationBody =
  UpdateBatchActivationDateBody;
export type UpdateBatchActivationDateMutationError = ErrorType<HttpError>;

export const useUpdateBatchActivationDate = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchActivationDate>>,
    TError,
    { id: number; data: UpdateBatchActivationDateBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateBatchActivationDateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ajusta o peso médio atual de todos os animais vivos do lote para o valor informado. Pega o último registro de peso de
cada animal vivo (vínculo com finalizedAt nulo) e o atualiza para o novo peso, marcando como source = WEIGHTED e type
= WEIGHING. Animais sem nenhum registro de peso, ou cujo último peso não é uma estimativa (CALCULATED) nem uma
pesagem intermediária (WEIGHING), recebem um novo peso criado na data atual — o peso de entrada nunca é sobrescrito.
 */
export const adjustBatchAverageWeight = (
  id: number,
  adjustBatchAverageWeightBody: AdjustBatchAverageWeightBody,
) => {
  return request<AdjustBatchAverageWeightResponse>({
    url: `/batches/${id}/adjust-average-weight`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: adjustBatchAverageWeightBody,
  });
};

export const getAdjustBatchAverageWeightMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustBatchAverageWeight>>,
    TError,
    { id: number; data: AdjustBatchAverageWeightBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustBatchAverageWeight>>,
  TError,
  { id: number; data: AdjustBatchAverageWeightBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustBatchAverageWeight>>,
    { id: number; data: AdjustBatchAverageWeightBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return adjustBatchAverageWeight(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdjustBatchAverageWeightMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustBatchAverageWeight>>
>;
export type AdjustBatchAverageWeightMutationBody = AdjustBatchAverageWeightBody;
export type AdjustBatchAverageWeightMutationError = ErrorType<HttpError>;

export const useAdjustBatchAverageWeight = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustBatchAverageWeight>>,
    TError,
    { id: number; data: AdjustBatchAverageWeightBody },
    TContext
  >;
}) => {
  const mutationOptions = getAdjustBatchAverageWeightMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ajusta o peso de entrada de todos os animais considerados no relatório analítico do lote para o valor informado.
Atualiza o primeiro peso do tipo ENTRY ou CASUAL de cada animal; animais sem nenhum dos dois recebem um peso CASUAL
criado na data da primeira entrada do animal neste lote.
 */
export const adjustBatchEntryWeights = (
  id: number,
  adjustBatchEntryWeightsBody: AdjustBatchEntryWeightsBody,
) => {
  return request<AdjustBatchEntryWeightsResponse>({
    url: `/batches/${id}/adjust-entry-weights`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: adjustBatchEntryWeightsBody,
  });
};

export const getAdjustBatchEntryWeightsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustBatchEntryWeights>>,
    TError,
    { id: number; data: AdjustBatchEntryWeightsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustBatchEntryWeights>>,
  TError,
  { id: number; data: AdjustBatchEntryWeightsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustBatchEntryWeights>>,
    { id: number; data: AdjustBatchEntryWeightsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return adjustBatchEntryWeights(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdjustBatchEntryWeightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustBatchEntryWeights>>
>;
export type AdjustBatchEntryWeightsMutationBody = AdjustBatchEntryWeightsBody;
export type AdjustBatchEntryWeightsMutationError = ErrorType<HttpError>;

export const useAdjustBatchEntryWeights = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustBatchEntryWeights>>,
    TError,
    { id: number; data: AdjustBatchEntryWeightsBody },
    TContext
  >;
}) => {
  const mutationOptions = getAdjustBatchEntryWeightsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateBatchAdjustedCost = (
  id: number,
  updateBatchAdjustedCostBody: UpdateBatchAdjustedCostBody,
) => {
  return request<UpdateBatchAdjustedCostResponse>({
    url: `/batches/${id}/adjusted-cost`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateBatchAdjustedCostBody,
  });
};

export const getUpdateBatchAdjustedCostMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchAdjustedCost>>,
    TError,
    { id: number; data: UpdateBatchAdjustedCostBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatchAdjustedCost>>,
  TError,
  { id: number; data: UpdateBatchAdjustedCostBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatchAdjustedCost>>,
    { id: number; data: UpdateBatchAdjustedCostBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBatchAdjustedCost(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchAdjustedCostMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatchAdjustedCost>>
>;
export type UpdateBatchAdjustedCostMutationBody = UpdateBatchAdjustedCostBody;
export type UpdateBatchAdjustedCostMutationError = ErrorType<HttpError>;

export const useUpdateBatchAdjustedCost = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchAdjustedCost>>,
    TError,
    { id: number; data: UpdateBatchAdjustedCostBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateBatchAdjustedCostMutationOptions(options);

  return useMutation(mutationOptions);
};

export const changeVariety = (
  id: number,
  changeVarietyBody: ChangeVarietyBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/change-variety`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: changeVarietyBody,
  });
};

export const getChangeVarietyMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeVariety>>,
    TError,
    { id: number; data: ChangeVarietyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeVariety>>,
  TError,
  { id: number; data: ChangeVarietyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeVariety>>,
    { id: number; data: ChangeVarietyBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return changeVariety(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeVarietyMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeVariety>>
>;
export type ChangeVarietyMutationBody = ChangeVarietyBody;
export type ChangeVarietyMutationError = ErrorType<HttpError>;

export const useChangeVariety = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeVariety>>,
    TError,
    { id: number; data: ChangeVarietyBody },
    TContext
  >;
}) => {
  const mutationOptions = getChangeVarietyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const changeVarietyDeadOxen = (
  id: number,
  changeVarietyDeadOxenBody: ChangeVarietyDeadOxenBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/change-variety-dead`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: changeVarietyDeadOxenBody,
  });
};

export const getChangeVarietyDeadOxenMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeVarietyDeadOxen>>,
    TError,
    { id: number; data: ChangeVarietyDeadOxenBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeVarietyDeadOxen>>,
  TError,
  { id: number; data: ChangeVarietyDeadOxenBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeVarietyDeadOxen>>,
    { id: number; data: ChangeVarietyDeadOxenBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return changeVarietyDeadOxen(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeVarietyDeadOxenMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeVarietyDeadOxen>>
>;
export type ChangeVarietyDeadOxenMutationBody = ChangeVarietyDeadOxenBody;
export type ChangeVarietyDeadOxenMutationError = ErrorType<HttpError>;

export const useChangeVarietyDeadOxen = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeVarietyDeadOxen>>,
    TError,
    { id: number; data: ChangeVarietyDeadOxenBody },
    TContext
  >;
}) => {
  const mutationOptions = getChangeVarietyDeadOxenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const fillBatchIdentity = (
  id: number,
  fillBatchIdentityBody: FillBatchIdentityBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/fill-identity`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: fillBatchIdentityBody,
  });
};

export const getFillBatchIdentityMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fillBatchIdentity>>,
    TError,
    { id: number; data: FillBatchIdentityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof fillBatchIdentity>>,
  TError,
  { id: number; data: FillBatchIdentityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fillBatchIdentity>>,
    { id: number; data: FillBatchIdentityBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return fillBatchIdentity(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FillBatchIdentityMutationResult = NonNullable<
  Awaited<ReturnType<typeof fillBatchIdentity>>
>;
export type FillBatchIdentityMutationBody = FillBatchIdentityBody;
export type FillBatchIdentityMutationError = ErrorType<HttpError>;

export const useFillBatchIdentity = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fillBatchIdentity>>,
    TError,
    { id: number; data: FillBatchIdentityBody },
    TContext
  >;
}) => {
  const mutationOptions = getFillBatchIdentityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const finalizedBatchDetails = (id: number, signal?: AbortSignal) => {
  return request<FinalizedBatchDetailsResponse>({
    url: `/batches/${id}/finalized`,
    method: "GET",
    signal,
  });
};

export const getFinalizedBatchDetailsQueryKey = (id: number) => {
  return [`/batches/${id}/finalized`] as const;
};

export const getFinalizedBatchDetailsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof finalizedBatchDetails>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof finalizedBatchDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFinalizedBatchDetailsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof finalizedBatchDetails>>
  > = ({ signal }) => finalizedBatchDetails(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FinalizedBatchDetailsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof finalizedBatchDetails>>
>;
export type FinalizedBatchDetailsInfiniteQueryError = ErrorType<HttpError>;

export const useFinalizedBatchDetailsInfinite = <
  TData = Awaited<ReturnType<typeof finalizedBatchDetails>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof finalizedBatchDetails>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFinalizedBatchDetailsInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFinalizedBatchDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof finalizedBatchDetails>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof finalizedBatchDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFinalizedBatchDetailsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof finalizedBatchDetails>>
  > = ({ signal }) => finalizedBatchDetails(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof finalizedBatchDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FinalizedBatchDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof finalizedBatchDetails>>
>;
export type FinalizedBatchDetailsQueryError = ErrorType<HttpError>;

export const useFinalizedBatchDetails = <
  TData = Awaited<ReturnType<typeof finalizedBatchDetails>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof finalizedBatchDetails>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFinalizedBatchDetailsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const batchForecast = (id: number, signal?: AbortSignal) => {
  return request<BatchForecastResponse>({
    url: `/batches/${id}/forecast`,
    method: "GET",
    signal,
  });
};

export const getBatchForecastQueryKey = (id: number) => {
  return [`/batches/${id}/forecast`] as const;
};

export const getBatchForecastInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof batchForecast>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchForecast>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchForecastQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchForecast>>> = ({
    signal,
  }) => batchForecast(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchForecast>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchForecastInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchForecast>>
>;
export type BatchForecastInfiniteQueryError = ErrorType<HttpError>;

export const useBatchForecastInfinite = <
  TData = Awaited<ReturnType<typeof batchForecast>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchForecast>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchForecastInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchForecastQueryOptions = <
  TData = Awaited<ReturnType<typeof batchForecast>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchForecast>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchForecastQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchForecast>>> = ({
    signal,
  }) => batchForecast(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof batchForecast>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchForecastQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchForecast>>
>;
export type BatchForecastQueryError = ErrorType<HttpError>;

export const useBatchForecast = <
  TData = Awaited<ReturnType<typeof batchForecast>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchForecast>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchForecastQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTroughManagementGraph = (
  id: number,
  params?: GetTroughManagementGraphParams,
  signal?: AbortSignal,
) => {
  return request<GetTroughManagementGraphResponse>({
    url: `/batches/${id}/graph`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTroughManagementGraphQueryKey = (
  id: number,
  params?: GetTroughManagementGraphParams,
) => {
  return [`/batches/${id}/graph`, ...(params ? [params] : [])] as const;
};

export const getGetTroughManagementGraphInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTroughManagementGraph>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetTroughManagementGraphParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTroughManagementGraph>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTroughManagementGraphQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTroughManagementGraph>>
  > = ({ signal }) => getTroughManagementGraph(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTroughManagementGraph>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTroughManagementGraphInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTroughManagementGraph>>
>;
export type GetTroughManagementGraphInfiniteQueryError = ErrorType<HttpError>;

export const useGetTroughManagementGraphInfinite = <
  TData = Awaited<ReturnType<typeof getTroughManagementGraph>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetTroughManagementGraphParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTroughManagementGraph>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTroughManagementGraphInfiniteQueryOptions(
    id,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTroughManagementGraphQueryOptions = <
  TData = Awaited<ReturnType<typeof getTroughManagementGraph>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetTroughManagementGraphParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTroughManagementGraph>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTroughManagementGraphQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTroughManagementGraph>>
  > = ({ signal }) => getTroughManagementGraph(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTroughManagementGraph>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTroughManagementGraphQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTroughManagementGraph>>
>;
export type GetTroughManagementGraphQueryError = ErrorType<HttpError>;

export const useGetTroughManagementGraph = <
  TData = Awaited<ReturnType<typeof getTroughManagementGraph>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetTroughManagementGraphParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTroughManagementGraph>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTroughManagementGraphQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Manejo de cocho do dia selecionado. Aceita dia anterior: o ajuste entra no previsto daquele dia, os dias seguintes já
foram fechados e não são recalculados.
 */
export const adjustCurrentForeseen = (
  id: number,
  adjustCurrentForeseen: AdjustCurrentForeseen,
) => {
  return request<AdjustCurrentForeseenResponse>({
    url: `/batches/${id}/histories/adjust`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: adjustCurrentForeseen,
  });
};

export const getAdjustCurrentForeseenMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustCurrentForeseen>>,
    TError,
    { id: number; data: AdjustCurrentForeseen },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustCurrentForeseen>>,
  TError,
  { id: number; data: AdjustCurrentForeseen },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustCurrentForeseen>>,
    { id: number; data: AdjustCurrentForeseen }
  > = (props) => {
    const { id, data } = props ?? {};

    return adjustCurrentForeseen(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdjustCurrentForeseenMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustCurrentForeseen>>
>;
export type AdjustCurrentForeseenMutationBody = AdjustCurrentForeseen;
export type AdjustCurrentForeseenMutationError = ErrorType<HttpError>;

export const useAdjustCurrentForeseen = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustCurrentForeseen>>,
    TError,
    { id: number; data: AdjustCurrentForeseen },
    TContext
  >;
}) => {
  const mutationOptions = getAdjustCurrentForeseenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Repete no dia selecionado o previsto da véspera. Aceita dia anterior, pelo mesmo motivo do manejo.
 */
export const replicateCurrentForeseen = (id: number) => {
  return request<ReplicateCurrentForeseenResponse>({
    url: `/batches/${id}/histories/adjust`,
    method: "PUT",
  });
};

export const getReplicateCurrentForeseenMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replicateCurrentForeseen>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replicateCurrentForeseen>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replicateCurrentForeseen>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return replicateCurrentForeseen(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplicateCurrentForeseenMutationResult = NonNullable<
  Awaited<ReturnType<typeof replicateCurrentForeseen>>
>;

export type ReplicateCurrentForeseenMutationError = ErrorType<HttpError>;

export const useReplicateCurrentForeseen = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replicateCurrentForeseen>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getReplicateCurrentForeseenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const holdingBatchSale = (
  id: number,
  saleHoldingBatch: SaleHoldingBatch,
) => {
  return request<HoldingBatchSaleResponse>({
    url: `/batches/${id}/holding-batch-closure`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: saleHoldingBatch,
  });
};

export const getHoldingBatchSaleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof holdingBatchSale>>,
    TError,
    { id: number; data: SaleHoldingBatch },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof holdingBatchSale>>,
  TError,
  { id: number; data: SaleHoldingBatch },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof holdingBatchSale>>,
    { id: number; data: SaleHoldingBatch }
  > = (props) => {
    const { id, data } = props ?? {};

    return holdingBatchSale(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldingBatchSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof holdingBatchSale>>
>;
export type HoldingBatchSaleMutationBody = SaleHoldingBatch;
export type HoldingBatchSaleMutationError = ErrorType<HttpError>;

export const useHoldingBatchSale = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof holdingBatchSale>>,
    TError,
    { id: number; data: SaleHoldingBatch },
    TContext
  >;
}) => {
  const mutationOptions = getHoldingBatchSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Prévia da saída avulsa retroativa: o que será apagado (notas de cocho, tratos, pesos) e devolvido ao estoque quando a
data da venda é anterior ao dia atual da fazenda. `hasChanges` falso = nada a confirmar, a venda segue direto.
 */
export const previewRetroactiveHoldingSale = (
  id: number,
  retroactiveHoldingSalePreviewBody: RetroactiveHoldingSalePreviewBody,
) => {
  return request<RetroactiveHoldingSalePreviewResult>({
    url: `/batches/${id}/holding-batch-closure/preview`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: retroactiveHoldingSalePreviewBody,
  });
};

export const getPreviewRetroactiveHoldingSaleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRetroactiveHoldingSale>>,
    TError,
    { id: number; data: RetroactiveHoldingSalePreviewBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewRetroactiveHoldingSale>>,
  TError,
  { id: number; data: RetroactiveHoldingSalePreviewBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewRetroactiveHoldingSale>>,
    { id: number; data: RetroactiveHoldingSalePreviewBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewRetroactiveHoldingSale(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewRetroactiveHoldingSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewRetroactiveHoldingSale>>
>;
export type PreviewRetroactiveHoldingSaleMutationBody =
  RetroactiveHoldingSalePreviewBody;
export type PreviewRetroactiveHoldingSaleMutationError = ErrorType<HttpError>;

export const usePreviewRetroactiveHoldingSale = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRetroactiveHoldingSale>>,
    TError,
    { id: number; data: RetroactiveHoldingSalePreviewBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getPreviewRetroactiveHoldingSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getHoldingEntry = (
  id: number,
  purchaseId: number,
  signal?: AbortSignal,
) => {
  return request<GetHoldingEntryResponse>({
    url: `/batches/${id}/holding-entry/${purchaseId}`,
    method: "GET",
    signal,
  });
};

export const getGetHoldingEntryQueryKey = (id: number, purchaseId: number) => {
  return [`/batches/${id}/holding-entry/${purchaseId}`] as const;
};

export const getGetHoldingEntryInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getHoldingEntry>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  purchaseId: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHoldingEntry>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHoldingEntryQueryKey(id, purchaseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHoldingEntry>>> = ({
    signal,
  }) => getHoldingEntry(id, purchaseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(id && purchaseId),
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getHoldingEntry>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHoldingEntryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHoldingEntry>>
>;
export type GetHoldingEntryInfiniteQueryError = ErrorType<HttpError>;

export const useGetHoldingEntryInfinite = <
  TData = Awaited<ReturnType<typeof getHoldingEntry>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  purchaseId: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHoldingEntry>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHoldingEntryInfiniteQueryOptions(
    id,
    purchaseId,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetHoldingEntryQueryOptions = <
  TData = Awaited<ReturnType<typeof getHoldingEntry>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  purchaseId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHoldingEntry>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHoldingEntryQueryKey(id, purchaseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHoldingEntry>>> = ({
    signal,
  }) => getHoldingEntry(id, purchaseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(id && purchaseId),
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHoldingEntry>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHoldingEntryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHoldingEntry>>
>;
export type GetHoldingEntryQueryError = ErrorType<HttpError>;

export const useGetHoldingEntry = <
  TData = Awaited<ReturnType<typeof getHoldingEntry>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  purchaseId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHoldingEntry>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHoldingEntryQueryOptions(id, purchaseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateHoldingEntryAges = (
  id: number,
  purchaseId: number,
  updateHoldingEntryAgesBody: UpdateHoldingEntryAgesBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/holding-entry/${purchaseId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateHoldingEntryAgesBody,
  });
};

export const getUpdateHoldingEntryAgesMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingEntryAges>>,
    TError,
    { id: number; purchaseId: number; data: UpdateHoldingEntryAgesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHoldingEntryAges>>,
  TError,
  { id: number; purchaseId: number; data: UpdateHoldingEntryAgesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHoldingEntryAges>>,
    { id: number; purchaseId: number; data: UpdateHoldingEntryAgesBody }
  > = (props) => {
    const { id, purchaseId, data } = props ?? {};

    return updateHoldingEntryAges(id, purchaseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHoldingEntryAgesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHoldingEntryAges>>
>;
export type UpdateHoldingEntryAgesMutationBody = UpdateHoldingEntryAgesBody;
export type UpdateHoldingEntryAgesMutationError = ErrorType<HttpError>;

export const useUpdateHoldingEntryAges = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingEntryAges>>,
    TError,
    { id: number; purchaseId: number; data: UpdateHoldingEntryAgesBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateHoldingEntryAgesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Linha do tempo agregada do lote: entradas, transferências, mortes, abates, fechamento e mudanças de piquete.
 */
export const getBatchLifecycle = (id: number, signal?: AbortSignal) => {
  return request<GetBatchLifecycleResponse>({
    url: `/batches/${id}/lifecycle`,
    method: "GET",
    signal,
  });
};

export const getGetBatchLifecycleQueryKey = (id: number) => {
  return [`/batches/${id}/lifecycle`] as const;
};

export const getGetBatchLifecycleInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchLifecycle>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchLifecycle>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchLifecycleQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchLifecycle>>
  > = ({ signal }) => getBatchLifecycle(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBatchLifecycle>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchLifecycleInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchLifecycle>>
>;
export type GetBatchLifecycleInfiniteQueryError = ErrorType<HttpError>;

export const useGetBatchLifecycleInfinite = <
  TData = Awaited<ReturnType<typeof getBatchLifecycle>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchLifecycle>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchLifecycleInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBatchLifecycleQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchLifecycle>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchLifecycle>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchLifecycleQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchLifecycle>>
  > = ({ signal }) => getBatchLifecycle(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatchLifecycle>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchLifecycleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchLifecycle>>
>;
export type GetBatchLifecycleQueryError = ErrorType<HttpError>;

export const useGetBatchLifecycle = <
  TData = Awaited<ReturnType<typeof getBatchLifecycle>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchLifecycle>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchLifecycleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recua ou avança a data de fechamento do lote quando não há venda amarrada.
 */
export const updateBatchClosingDate = (
  id: number,
  updateBatchClosingDateBody: UpdateBatchClosingDateBody,
) => {
  return request<UpdateBatchClosingDateResponse>({
    url: `/batches/${id}/lifecycle/closing-date`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateBatchClosingDateBody,
  });
};

export const getUpdateBatchClosingDateMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchClosingDate>>,
    TError,
    { id: number; data: UpdateBatchClosingDateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatchClosingDate>>,
  TError,
  { id: number; data: UpdateBatchClosingDateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatchClosingDate>>,
    { id: number; data: UpdateBatchClosingDateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBatchClosingDate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchClosingDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatchClosingDate>>
>;
export type UpdateBatchClosingDateMutationBody = UpdateBatchClosingDateBody;
export type UpdateBatchClosingDateMutationError = ErrorType<HttpError>;

export const useUpdateBatchClosingDate = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchClosingDate>>,
    TError,
    { id: number; data: UpdateBatchClosingDateBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateBatchClosingDateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Altera a data de um grupo de mortes ou abates no meio da vida do lote.
 */
export const updateDeathGroupDate = (
  id: number,
  updateDeathGroupDateBody: UpdateDeathGroupDateBody,
) => {
  return request<UpdateBatchClosingDateResponse>({
    url: `/batches/${id}/lifecycle/death-date`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateDeathGroupDateBody,
  });
};

export const getUpdateDeathGroupDateMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeathGroupDate>>,
    TError,
    { id: number; data: UpdateDeathGroupDateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDeathGroupDate>>,
  TError,
  { id: number; data: UpdateDeathGroupDateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDeathGroupDate>>,
    { id: number; data: UpdateDeathGroupDateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDeathGroupDate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDeathGroupDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDeathGroupDate>>
>;
export type UpdateDeathGroupDateMutationBody = UpdateDeathGroupDateBody;
export type UpdateDeathGroupDateMutationError = ErrorType<HttpError>;

export const useUpdateDeathGroupDate = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeathGroupDate>>,
    TError,
    { id: number; data: UpdateDeathGroupDateBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateDeathGroupDateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Altera a data de uma entrada avulsa que não é a entrada inicial do lote.
 */
export const updateHoldingEntryDate = (
  id: number,
  updateHoldingEntryDateBody: UpdateHoldingEntryDateBody,
) => {
  return request<UpdateBatchClosingDateResponse>({
    url: `/batches/${id}/lifecycle/holding-entry-date`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateHoldingEntryDateBody,
  });
};

export const getUpdateHoldingEntryDateMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingEntryDate>>,
    TError,
    { id: number; data: UpdateHoldingEntryDateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHoldingEntryDate>>,
  TError,
  { id: number; data: UpdateHoldingEntryDateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHoldingEntryDate>>,
    { id: number; data: UpdateHoldingEntryDateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHoldingEntryDate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHoldingEntryDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHoldingEntryDate>>
>;
export type UpdateHoldingEntryDateMutationBody = UpdateHoldingEntryDateBody;
export type UpdateHoldingEntryDateMutationError = ErrorType<HttpError>;

export const useUpdateHoldingEntryDate = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingEntryDate>>,
    TError,
    { id: number; data: UpdateHoldingEntryDateBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateHoldingEntryDateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listSimpleAnimal = (id: number, signal?: AbortSignal) => {
  return request<ListSimpleAnimalResponse>({
    url: `/batches/${id}/list-simple-animal`,
    method: "GET",
    signal,
  });
};

export const getListSimpleAnimalQueryKey = (id: number) => {
  return [`/batches/${id}/list-simple-animal`] as const;
};

export const getListSimpleAnimalInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimpleAnimal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimal>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSimpleAnimalQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimpleAnimal>>
  > = ({ signal }) => listSimpleAnimal(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSimpleAnimal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSimpleAnimalInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimpleAnimal>>
>;
export type ListSimpleAnimalInfiniteQueryError = ErrorType<unknown>;

export const useListSimpleAnimalInfinite = <
  TData = Awaited<ReturnType<typeof listSimpleAnimal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimal>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSimpleAnimalInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSimpleAnimalQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimpleAnimal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimal>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSimpleAnimalQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimpleAnimal>>
  > = ({ signal }) => listSimpleAnimal(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSimpleAnimal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSimpleAnimalQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimpleAnimal>>
>;
export type ListSimpleAnimalQueryError = ErrorType<unknown>;

export const useListSimpleAnimal = <
  TData = Awaited<ReturnType<typeof listSimpleAnimal>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimal>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSimpleAnimalQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listSimpleAnimalByGta = (id: number, signal?: AbortSignal) => {
  return request<ListSimpleAnimalByGtaResponse>({
    url: `/batches/${id}/list-simple-animal-by-gta`,
    method: "GET",
    signal,
  });
};

export const getListSimpleAnimalByGtaQueryKey = (id: number) => {
  return [`/batches/${id}/list-simple-animal-by-gta`] as const;
};

export const getListSimpleAnimalByGtaInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSimpleAnimalByGtaQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimpleAnimalByGta>>
  > = ({ signal }) => listSimpleAnimalByGta(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSimpleAnimalByGtaInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimpleAnimalByGta>>
>;
export type ListSimpleAnimalByGtaInfiniteQueryError = ErrorType<unknown>;

export const useListSimpleAnimalByGtaInfinite = <
  TData = Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSimpleAnimalByGtaInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSimpleAnimalByGtaQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSimpleAnimalByGtaQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimpleAnimalByGta>>
  > = ({ signal }) => listSimpleAnimalByGta(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSimpleAnimalByGtaQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimpleAnimalByGta>>
>;
export type ListSimpleAnimalByGtaQueryError = ErrorType<unknown>;

export const useListSimpleAnimalByGta = <
  TData = Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSimpleAnimalByGta>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSimpleAnimalByGtaQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchLogs = (id: number, signal?: AbortSignal) => {
  return request<GetBatchLogsResponse>({
    url: `/batches/${id}/logs`,
    method: "GET",
    signal,
  });
};

export const getGetBatchLogsQueryKey = (id: number) => {
  return [`/batches/${id}/logs`] as const;
};

export const getGetBatchLogsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchLogs>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchLogs>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchLogsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchLogs>>> = ({
    signal,
  }) => getBatchLogs(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBatchLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchLogsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchLogs>>
>;
export type GetBatchLogsInfiniteQueryError = ErrorType<HttpError>;

export const useGetBatchLogsInfinite = <
  TData = Awaited<ReturnType<typeof getBatchLogs>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchLogs>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchLogsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBatchLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchLogs>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchLogs>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchLogsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchLogs>>> = ({
    signal,
  }) => getBatchLogs(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatchLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchLogs>>
>;
export type GetBatchLogsQueryError = ErrorType<HttpError>;

export const useGetBatchLogs = <
  TData = Awaited<ReturnType<typeof getBatchLogs>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchLogs>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchLogsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const movimentOxenByBatchAndGtaId = (
  id: number,
  movimentOxenByBatchAndGtaIdBody: MovimentOxenByBatchAndGtaIdBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/moviment`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: movimentOxenByBatchAndGtaIdBody,
  });
};

export const getMovimentOxenByBatchAndGtaIdMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof movimentOxenByBatchAndGtaId>>,
    TError,
    { id: number; data: MovimentOxenByBatchAndGtaIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof movimentOxenByBatchAndGtaId>>,
  TError,
  { id: number; data: MovimentOxenByBatchAndGtaIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof movimentOxenByBatchAndGtaId>>,
    { id: number; data: MovimentOxenByBatchAndGtaIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return movimentOxenByBatchAndGtaId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MovimentOxenByBatchAndGtaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof movimentOxenByBatchAndGtaId>>
>;
export type MovimentOxenByBatchAndGtaIdMutationBody =
  MovimentOxenByBatchAndGtaIdBody;
export type MovimentOxenByBatchAndGtaIdMutationError = ErrorType<HttpError>;

export const useMovimentOxenByBatchAndGtaId = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof movimentOxenByBatchAndGtaId>>,
    TError,
    { id: number; data: MovimentOxenByBatchAndGtaIdBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getMovimentOxenByBatchAndGtaIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOxenByBatchId = (id: number, signal?: AbortSignal) => {
  return request<ListOxenByBatchIdResponse>({
    url: `/batches/${id}/oxen`,
    method: "GET",
    signal,
  });
};

export const getListOxenByBatchIdQueryKey = (id: number) => {
  return [`/batches/${id}/oxen`] as const;
};

export const getListOxenByBatchIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenByBatchId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxenByBatchId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenByBatchIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenByBatchId>>
  > = ({ signal }) => listOxenByBatchId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenByBatchId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenByBatchIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenByBatchId>>
>;
export type ListOxenByBatchIdInfiniteQueryError = ErrorType<unknown>;

export const useListOxenByBatchIdInfinite = <
  TData = Awaited<ReturnType<typeof listOxenByBatchId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxenByBatchId>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenByBatchIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxenByBatchIdQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenByBatchId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxenByBatchId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenByBatchIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenByBatchId>>
  > = ({ signal }) => listOxenByBatchId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOxenByBatchId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenByBatchIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenByBatchId>>
>;
export type ListOxenByBatchIdQueryError = ErrorType<unknown>;

export const useListOxenByBatchId = <
  TData = Awaited<ReturnType<typeof listOxenByBatchId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxenByBatchId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenByBatchIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const pastureSupplementation = (
  id: number,
  pastureSupplementationBody: PastureSupplementationBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/pasture-supplementation`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: pastureSupplementationBody,
  });
};

export const getPastureSupplementationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pastureSupplementation>>,
    TError,
    { id: number; data: PastureSupplementationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pastureSupplementation>>,
  TError,
  { id: number; data: PastureSupplementationBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pastureSupplementation>>,
    { id: number; data: PastureSupplementationBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return pastureSupplementation(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PastureSupplementationMutationResult = NonNullable<
  Awaited<ReturnType<typeof pastureSupplementation>>
>;
export type PastureSupplementationMutationBody = PastureSupplementationBody;
export type PastureSupplementationMutationError = ErrorType<HttpError>;

export const usePastureSupplementation = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pastureSupplementation>>,
    TError,
    { id: number; data: PastureSupplementationBody },
    TContext
  >;
}) => {
  const mutationOptions = getPastureSupplementationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeAllIdentifications = (id: number) => {
  return request<boolean>({
    url: `/batches/${id}/remove-all-identifications`,
    method: "DELETE",
  });
};

export const getRemoveAllIdentificationsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAllIdentifications>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeAllIdentifications>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeAllIdentifications>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return removeAllIdentifications(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveAllIdentificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeAllIdentifications>>
>;

export type RemoveAllIdentificationsMutationError = ErrorType<HttpError>;

export const useRemoveAllIdentifications = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAllIdentifications>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveAllIdentificationsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Tira/devolve o lote do trato. `until` ausente = indeterminado; preenchido = último dia fora do trato.
 */
export const removeBatchFromTreatment = (
  id: number,
  removeBatchFromTreatmentBody: RemoveBatchFromTreatmentBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/remove-foreseen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: removeBatchFromTreatmentBody,
  });
};

export const getRemoveBatchFromTreatmentMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeBatchFromTreatment>>,
    TError,
    { id: number; data: RemoveBatchFromTreatmentBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeBatchFromTreatment>>,
  TError,
  { id: number; data: RemoveBatchFromTreatmentBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeBatchFromTreatment>>,
    { id: number; data: RemoveBatchFromTreatmentBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return removeBatchFromTreatment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveBatchFromTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeBatchFromTreatment>>
>;
export type RemoveBatchFromTreatmentMutationBody = RemoveBatchFromTreatmentBody;
export type RemoveBatchFromTreatmentMutationError = ErrorType<HttpError>;

export const useRemoveBatchFromTreatment = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeBatchFromTreatment>>,
    TError,
    { id: number; data: RemoveBatchFromTreatmentBody },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveBatchFromTreatmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeInactiveBatch = (id: number) => {
  return request<boolean>({
    url: `/batches/${id}/remove-inactive`,
    method: "DELETE",
  });
};

export const getRemoveInactiveBatchMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeInactiveBatch>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeInactiveBatch>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeInactiveBatch>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return removeInactiveBatch(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveInactiveBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeInactiveBatch>>
>;

export type RemoveInactiveBatchMutationError = ErrorType<HttpError>;

export const useRemoveInactiveBatch = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeInactiveBatch>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveInactiveBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const revertBatchClosure = (id: number) => {
  return request<boolean>({
    url: `/batches/${id}/revert-closure`,
    method: "POST",
  });
};

export const getRevertBatchClosureMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertBatchClosure>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertBatchClosure>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertBatchClosure>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revertBatchClosure(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertBatchClosureMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertBatchClosure>>
>;

export type RevertBatchClosureMutationError = ErrorType<HttpError>;

export const useRevertBatchClosure = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertBatchClosure>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getRevertBatchClosureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const batchStats = (id: number, signal?: AbortSignal) => {
  return request<BatchStatsResponse>({
    url: `/batches/${id}/stats`,
    method: "GET",
    signal,
  });
};

export const getBatchStatsQueryKey = (id: number) => {
  return [`/batches/${id}/stats`] as const;
};

export const getBatchStatsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof batchStats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchStats>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchStatsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchStats>>> = ({
    signal,
  }) => batchStats(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchStatsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchStats>>
>;
export type BatchStatsInfiniteQueryError = ErrorType<unknown>;

export const useBatchStatsInfinite = <
  TData = Awaited<ReturnType<typeof batchStats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchStats>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchStatsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof batchStats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchStats>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchStatsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchStats>>> = ({
    signal,
  }) => batchStats(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof batchStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchStats>>
>;
export type BatchStatsQueryError = ErrorType<unknown>;

export const useBatchStats = <
  TData = Awaited<ReturnType<typeof batchStats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchStats>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchStatsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const transitionBatchDiet = (
  id: number,
  params: TransitionBatchDietParams,
) => {
  return request<TransitionBatchDietResponse>({
    url: `/batches/${id}/transition`,
    method: "POST",
    params,
  });
};

export const getTransitionBatchDietMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionBatchDiet>>,
    TError,
    { id: number; params: TransitionBatchDietParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionBatchDiet>>,
  TError,
  { id: number; params: TransitionBatchDietParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionBatchDiet>>,
    { id: number; params: TransitionBatchDietParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return transitionBatchDiet(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionBatchDietMutationResult = NonNullable<
  Awaited<ReturnType<typeof transitionBatchDiet>>
>;

export type TransitionBatchDietMutationError = ErrorType<HttpError>;

export const useTransitionBatchDiet = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionBatchDiet>>,
    TError,
    { id: number; params: TransitionBatchDietParams },
    TContext
  >;
}) => {
  const mutationOptions = getTransitionBatchDietMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rollbackBatchWeightGainCurve = (
  id: number,
  params?: RollbackBatchWeightGainCurveParams,
) => {
  return request<boolean>({
    url: `/batches/${id}/weight-gain-curve`,
    method: "DELETE",
    params,
  });
};

export const getRollbackBatchWeightGainCurveMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rollbackBatchWeightGainCurve>>,
    TError,
    { id: number; params?: RollbackBatchWeightGainCurveParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rollbackBatchWeightGainCurve>>,
  TError,
  { id: number; params?: RollbackBatchWeightGainCurveParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rollbackBatchWeightGainCurve>>,
    { id: number; params?: RollbackBatchWeightGainCurveParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return rollbackBatchWeightGainCurve(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RollbackBatchWeightGainCurveMutationResult = NonNullable<
  Awaited<ReturnType<typeof rollbackBatchWeightGainCurve>>
>;

export type RollbackBatchWeightGainCurveMutationError = ErrorType<HttpError>;

export const useRollbackBatchWeightGainCurve = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rollbackBatchWeightGainCurve>>,
    TError,
    { id: number; params?: RollbackBatchWeightGainCurveParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getRollbackBatchWeightGainCurveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listBatchWeightGainCurveHistory = (
  id: number,
  signal?: AbortSignal,
) => {
  return request<ListBatchWeightGainCurveHistoryResponse>({
    url: `/batches/${id}/weight-gain-curve`,
    method: "GET",
    signal,
  });
};

export const getListBatchWeightGainCurveHistoryQueryKey = (id: number) => {
  return [`/batches/${id}/weight-gain-curve`] as const;
};

export const getListBatchWeightGainCurveHistoryInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchWeightGainCurveHistoryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>
  > = ({ signal }) => listBatchWeightGainCurveHistory(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchWeightGainCurveHistoryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>
>;
export type ListBatchWeightGainCurveHistoryInfiniteQueryError =
  ErrorType<HttpError>;

export const useListBatchWeightGainCurveHistoryInfinite = <
  TData = Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchWeightGainCurveHistoryInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBatchWeightGainCurveHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchWeightGainCurveHistoryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>
  > = ({ signal }) => listBatchWeightGainCurveHistory(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchWeightGainCurveHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>
>;
export type ListBatchWeightGainCurveHistoryQueryError = ErrorType<HttpError>;

export const useListBatchWeightGainCurveHistory = <
  TData = Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatchWeightGainCurveHistory>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchWeightGainCurveHistoryQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const applyBatchWeightGainCurve = (
  id: number,
  params: ApplyBatchWeightGainCurveParams,
) => {
  return request<BatchCurveOnBatchesItem>({
    url: `/batches/${id}/weight-gain-curve`,
    method: "POST",
    params,
  });
};

export const getApplyBatchWeightGainCurveMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchWeightGainCurve>>,
    TError,
    { id: number; params: ApplyBatchWeightGainCurveParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyBatchWeightGainCurve>>,
  TError,
  { id: number; params: ApplyBatchWeightGainCurveParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyBatchWeightGainCurve>>,
    { id: number; params: ApplyBatchWeightGainCurveParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return applyBatchWeightGainCurve(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyBatchWeightGainCurveMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyBatchWeightGainCurve>>
>;

export type ApplyBatchWeightGainCurveMutationError = ErrorType<HttpError>;

export const useApplyBatchWeightGainCurve = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchWeightGainCurve>>,
    TError,
    { id: number; params: ApplyBatchWeightGainCurveParams },
    TContext
  >;
}) => {
  const mutationOptions = getApplyBatchWeightGainCurveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const previewCurveRecalculation = (
  id: number,
  params: PreviewCurveRecalculationParams,
  signal?: AbortSignal,
) => {
  return request<PreviewCurveRecalculationResponse>({
    url: `/batches/${id}/weight-gain-curve/recalculate`,
    method: "GET",
    params,
    signal,
  });
};

export const getPreviewCurveRecalculationQueryKey = (
  id: number,
  params: PreviewCurveRecalculationParams,
) => {
  return [
    `/batches/${id}/weight-gain-curve/recalculate`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPreviewCurveRecalculationInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof previewCurveRecalculation>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewCurveRecalculationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof previewCurveRecalculation>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPreviewCurveRecalculationQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof previewCurveRecalculation>>
  > = ({ signal }) => previewCurveRecalculation(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof previewCurveRecalculation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PreviewCurveRecalculationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewCurveRecalculation>>
>;
export type PreviewCurveRecalculationInfiniteQueryError = ErrorType<HttpError>;

export const usePreviewCurveRecalculationInfinite = <
  TData = Awaited<ReturnType<typeof previewCurveRecalculation>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewCurveRecalculationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof previewCurveRecalculation>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPreviewCurveRecalculationInfiniteQueryOptions(
    id,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPreviewCurveRecalculationQueryOptions = <
  TData = Awaited<ReturnType<typeof previewCurveRecalculation>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewCurveRecalculationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof previewCurveRecalculation>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPreviewCurveRecalculationQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof previewCurveRecalculation>>
  > = ({ signal }) => previewCurveRecalculation(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof previewCurveRecalculation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PreviewCurveRecalculationQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewCurveRecalculation>>
>;
export type PreviewCurveRecalculationQueryError = ErrorType<HttpError>;

export const usePreviewCurveRecalculation = <
  TData = Awaited<ReturnType<typeof previewCurveRecalculation>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewCurveRecalculationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof previewCurveRecalculation>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPreviewCurveRecalculationQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const applyCurveWithRecalculation = (
  id: number,
  params: ApplyCurveWithRecalculationParams,
) => {
  return request<boolean>({
    url: `/batches/${id}/weight-gain-curve/recalculate`,
    method: "POST",
    params,
  });
};

export const getApplyCurveWithRecalculationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyCurveWithRecalculation>>,
    TError,
    { id: number; params: ApplyCurveWithRecalculationParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyCurveWithRecalculation>>,
  TError,
  { id: number; params: ApplyCurveWithRecalculationParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyCurveWithRecalculation>>,
    { id: number; params: ApplyCurveWithRecalculationParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return applyCurveWithRecalculation(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyCurveWithRecalculationMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyCurveWithRecalculation>>
>;

export type ApplyCurveWithRecalculationMutationError = ErrorType<HttpError>;

export const useApplyCurveWithRecalculation = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyCurveWithRecalculation>>,
    TError,
    { id: number; params: ApplyCurveWithRecalculationParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getApplyCurveWithRecalculationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const previewBiotypeRollback = (
  id: number,
  params: PreviewBiotypeRollbackParams,
  signal?: AbortSignal,
) => {
  return request<PreviewBiotypeRollbackResponse>({
    url: `/batches/${id}/weight-gain-curve/rollback`,
    method: "GET",
    params,
    signal,
  });
};

export const getPreviewBiotypeRollbackQueryKey = (
  id: number,
  params: PreviewBiotypeRollbackParams,
) => {
  return [
    `/batches/${id}/weight-gain-curve/rollback`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPreviewBiotypeRollbackInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof previewBiotypeRollback>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewBiotypeRollbackParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof previewBiotypeRollback>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPreviewBiotypeRollbackQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof previewBiotypeRollback>>
  > = ({ signal }) => previewBiotypeRollback(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof previewBiotypeRollback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PreviewBiotypeRollbackInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewBiotypeRollback>>
>;
export type PreviewBiotypeRollbackInfiniteQueryError = ErrorType<HttpError>;

export const usePreviewBiotypeRollbackInfinite = <
  TData = Awaited<ReturnType<typeof previewBiotypeRollback>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewBiotypeRollbackParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof previewBiotypeRollback>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPreviewBiotypeRollbackInfiniteQueryOptions(
    id,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPreviewBiotypeRollbackQueryOptions = <
  TData = Awaited<ReturnType<typeof previewBiotypeRollback>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewBiotypeRollbackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof previewBiotypeRollback>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPreviewBiotypeRollbackQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof previewBiotypeRollback>>
  > = ({ signal }) => previewBiotypeRollback(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof previewBiotypeRollback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PreviewBiotypeRollbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewBiotypeRollback>>
>;
export type PreviewBiotypeRollbackQueryError = ErrorType<HttpError>;

export const usePreviewBiotypeRollback = <
  TData = Awaited<ReturnType<typeof previewBiotypeRollback>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params: PreviewBiotypeRollbackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof previewBiotypeRollback>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPreviewBiotypeRollbackQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchWeights = (id: number, signal?: AbortSignal) => {
  return request<GetBatchWeightsResponse>({
    url: `/batches/${id}/weights`,
    method: "GET",
    signal,
  });
};

export const getGetBatchWeightsQueryKey = (id: number) => {
  return [`/batches/${id}/weights`] as const;
};

export const getGetBatchWeightsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchWeightsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchWeights>>> = ({
    signal,
  }) => getBatchWeights(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBatchWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchWeightsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchWeights>>
>;
export type GetBatchWeightsInfiniteQueryError = ErrorType<unknown>;

export const useGetBatchWeightsInfinite = <
  TData = Awaited<ReturnType<typeof getBatchWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchWeights>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchWeightsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBatchWeightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchWeightsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatchWeights>>> = ({
    signal,
  }) => getBatchWeights(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatchWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchWeightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchWeights>>
>;
export type GetBatchWeightsQueryError = ErrorType<unknown>;

export const useGetBatchWeights = <
  TData = Awaited<ReturnType<typeof getBatchWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchWeights>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchWeightsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateBatchWeights = (
  id: number,
  updateBatchWeightsBody: UpdateBatchWeightsBody,
) => {
  return request<boolean>({
    url: `/batches/${id}/weights`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateBatchWeightsBody,
  });
};

export const getUpdateBatchWeightsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchWeights>>,
    TError,
    { id: number; data: UpdateBatchWeightsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatchWeights>>,
  TError,
  { id: number; data: UpdateBatchWeightsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatchWeights>>,
    { id: number; data: UpdateBatchWeightsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBatchWeights(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchWeightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatchWeights>>
>;
export type UpdateBatchWeightsMutationBody = UpdateBatchWeightsBody;
export type UpdateBatchWeightsMutationError = ErrorType<HttpError>;

export const useUpdateBatchWeights = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchWeights>>,
    TError,
    { id: number; data: UpdateBatchWeightsBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateBatchWeightsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const submitBeat = (submitBeat: SubmitBeat[]) => {
  return request<boolean>({
    url: `/beats`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitBeat,
  });
};

export const getSubmitBeatMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitBeat>>,
    TError,
    { data: SubmitBeat[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitBeat>>,
  TError,
  { data: SubmitBeat[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitBeat>>,
    { data: SubmitBeat[] }
  > = (props) => {
    const { data } = props ?? {};

    return submitBeat(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitBeatMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitBeat>>
>;
export type SubmitBeatMutationBody = SubmitBeat[];
export type SubmitBeatMutationError = ErrorType<unknown>;

export const useSubmitBeat = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitBeat>>,
    TError,
    { data: SubmitBeat[] },
    TContext
  >;
}) => {
  const mutationOptions = getSubmitBeatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteInvalidBeatRealizeds = (
  deleteInvalidBeatRealizedsBody: DeleteInvalidBeatRealizedsBody,
) => {
  return request<boolean>({
    url: `/beats/invalid-realizeds`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: deleteInvalidBeatRealizedsBody,
  });
};

export const getDeleteInvalidBeatRealizedsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInvalidBeatRealizeds>>,
    TError,
    { data: DeleteInvalidBeatRealizedsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInvalidBeatRealizeds>>,
  TError,
  { data: DeleteInvalidBeatRealizedsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInvalidBeatRealizeds>>,
    { data: DeleteInvalidBeatRealizedsBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteInvalidBeatRealizeds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInvalidBeatRealizedsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInvalidBeatRealizeds>>
>;
export type DeleteInvalidBeatRealizedsMutationBody =
  DeleteInvalidBeatRealizedsBody;
export type DeleteInvalidBeatRealizedsMutationError = ErrorType<unknown>;

export const useDeleteInvalidBeatRealizeds = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInvalidBeatRealizeds>>,
    TError,
    { data: DeleteInvalidBeatRealizedsBody },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteInvalidBeatRealizedsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listInvalidBeatRealizeds = (signal?: AbortSignal) => {
  return request<ListInvalidBeatRealizedsResponse>({
    url: `/beats/invalid-realizeds`,
    method: "GET",
    signal,
  });
};

export const getListInvalidBeatRealizedsQueryKey = () => {
  return [`/beats/invalid-realizeds`] as const;
};

export const getListInvalidBeatRealizedsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInvalidBeatRealizedsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>
  > = ({ signal }) => listInvalidBeatRealizeds(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvalidBeatRealizedsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvalidBeatRealizeds>>
>;
export type ListInvalidBeatRealizedsInfiniteQueryError = ErrorType<unknown>;

export const useListInvalidBeatRealizedsInfinite = <
  TData = Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListInvalidBeatRealizedsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListInvalidBeatRealizedsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInvalidBeatRealizedsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>
  > = ({ signal }) => listInvalidBeatRealizeds(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvalidBeatRealizedsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvalidBeatRealizeds>>
>;
export type ListInvalidBeatRealizedsQueryError = ErrorType<unknown>;

export const useListInvalidBeatRealizeds = <
  TData = Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvalidBeatRealizeds>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListInvalidBeatRealizedsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateInvalidBeatRealizeds = (
  updateInvalidBeatRealizedsBody: UpdateInvalidBeatRealizedsBody,
) => {
  return request<boolean>({
    url: `/beats/invalid-realizeds`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateInvalidBeatRealizedsBody,
  });
};

export const getUpdateInvalidBeatRealizedsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInvalidBeatRealizeds>>,
    TError,
    { data: UpdateInvalidBeatRealizedsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInvalidBeatRealizeds>>,
  TError,
  { data: UpdateInvalidBeatRealizedsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInvalidBeatRealizeds>>,
    { data: UpdateInvalidBeatRealizedsBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateInvalidBeatRealizeds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInvalidBeatRealizedsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInvalidBeatRealizeds>>
>;
export type UpdateInvalidBeatRealizedsMutationBody =
  UpdateInvalidBeatRealizedsBody;
export type UpdateInvalidBeatRealizedsMutationError = ErrorType<unknown>;

export const useUpdateInvalidBeatRealizeds = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInvalidBeatRealizeds>>,
    TError,
    { data: UpdateInvalidBeatRealizedsBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateInvalidBeatRealizedsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteBeat = (id: number) => {
  return request<boolean>({ url: `/beats/${id}`, method: "DELETE" });
};

export const getDeleteBeatMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBeat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBeat>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBeat>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBeat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBeatMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBeat>>
>;

export type DeleteBeatMutationError = ErrorType<HttpError>;

export const useDeleteBeat = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBeat>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteBeatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateBeat = (id: number, updateBeat: UpdateBeat) => {
  return request<BeatRealizedSnapshot>({
    url: `/beats/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateBeat,
  });
};

export const getUpdateBeatMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBeat>>,
    TError,
    { id: number; data: UpdateBeat },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBeat>>,
  TError,
  { id: number; data: UpdateBeat },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBeat>>,
    { id: number; data: UpdateBeat }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBeat(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBeatMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBeat>>
>;
export type UpdateBeatMutationBody = UpdateBeat;
export type UpdateBeatMutationError = ErrorType<HttpError>;

export const useUpdateBeat = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBeat>>,
    TError,
    { id: number; data: UpdateBeat },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateBeatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listCattleManifestLayouts = (
  params?: ListCattleManifestLayoutsParams,
  signal?: AbortSignal,
) => {
  return request<ListCattleManifestLayoutsResponse>({
    url: `/cattle-manifest-layouts`,
    method: "GET",
    params,
    signal,
  });
};

export const getListCattleManifestLayoutsQueryKey = (
  params?: ListCattleManifestLayoutsParams,
) => {
  return [`/cattle-manifest-layouts`, ...(params ? [params] : [])] as const;
};

export const getListCattleManifestLayoutsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCattleManifestLayoutsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayouts>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCattleManifestLayoutsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCattleManifestLayouts>>
  > = ({ signal }) => listCattleManifestLayouts(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCattleManifestLayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCattleManifestLayoutsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCattleManifestLayouts>>
>;
export type ListCattleManifestLayoutsInfiniteQueryError = ErrorType<unknown>;

export const useListCattleManifestLayoutsInfinite = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCattleManifestLayoutsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayouts>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCattleManifestLayoutsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCattleManifestLayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCattleManifestLayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayouts>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCattleManifestLayoutsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCattleManifestLayouts>>
  > = ({ signal }) => listCattleManifestLayouts(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCattleManifestLayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCattleManifestLayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCattleManifestLayouts>>
>;
export type ListCattleManifestLayoutsQueryError = ErrorType<unknown>;

export const useListCattleManifestLayouts = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCattleManifestLayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayouts>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCattleManifestLayoutsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createCattleManifestLayout = (
  createCattleManifestLayoutBody: CreateCattleManifestLayoutBody,
) => {
  return request<CreateCattleManifestLayoutResponse>({
    url: `/cattle-manifest-layouts`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCattleManifestLayoutBody,
  });
};

export const getCreateCattleManifestLayoutMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCattleManifestLayout>>,
    TError,
    { data: CreateCattleManifestLayoutBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCattleManifestLayout>>,
  TError,
  { data: CreateCattleManifestLayoutBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCattleManifestLayout>>,
    { data: CreateCattleManifestLayoutBody }
  > = (props) => {
    const { data } = props ?? {};

    return createCattleManifestLayout(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCattleManifestLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCattleManifestLayout>>
>;
export type CreateCattleManifestLayoutMutationBody =
  CreateCattleManifestLayoutBody;
export type CreateCattleManifestLayoutMutationError = ErrorType<HttpError>;

export const useCreateCattleManifestLayout = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCattleManifestLayout>>,
    TError,
    { data: CreateCattleManifestLayoutBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateCattleManifestLayoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCattleManifestLayout = (id: number) => {
  return request<boolean>({
    url: `/cattle-manifest-layouts/${id}`,
    method: "DELETE",
  });
};

export const getDeleteCattleManifestLayoutMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCattleManifestLayout>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCattleManifestLayout>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCattleManifestLayout>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCattleManifestLayout(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCattleManifestLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCattleManifestLayout>>
>;

export type DeleteCattleManifestLayoutMutationError = ErrorType<HttpError>;

export const useDeleteCattleManifestLayout = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCattleManifestLayout>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCattleManifestLayoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCattleManifestLayout = (id: number, signal?: AbortSignal) => {
  return request<CattleManifestLayoutDetail>({
    url: `/cattle-manifest-layouts/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetCattleManifestLayoutQueryKey = (id: number) => {
  return [`/cattle-manifest-layouts/${id}`] as const;
};

export const getGetCattleManifestLayoutInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayout>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayout>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCattleManifestLayoutQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleManifestLayout>>
  > = ({ signal }) => getCattleManifestLayout(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCattleManifestLayout>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleManifestLayoutInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCattleManifestLayout>>
>;
export type GetCattleManifestLayoutInfiniteQueryError = ErrorType<HttpError>;

export const useGetCattleManifestLayoutInfinite = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayout>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayout>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCattleManifestLayoutInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetCattleManifestLayoutQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayout>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayout>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCattleManifestLayoutQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleManifestLayout>>
  > = ({ signal }) => getCattleManifestLayout(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCattleManifestLayout>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleManifestLayoutQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCattleManifestLayout>>
>;
export type GetCattleManifestLayoutQueryError = ErrorType<HttpError>;

export const useGetCattleManifestLayout = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayout>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayout>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCattleManifestLayoutQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const renameCattleManifestLayout = (
  id: number,
  renameCattleManifestLayoutBody: RenameCattleManifestLayoutBody,
) => {
  return request<RenameCattleManifestLayoutResponse>({
    url: `/cattle-manifest-layouts/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: renameCattleManifestLayoutBody,
  });
};

export const getRenameCattleManifestLayoutMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameCattleManifestLayout>>,
    TError,
    { id: number; data: RenameCattleManifestLayoutBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameCattleManifestLayout>>,
  TError,
  { id: number; data: RenameCattleManifestLayoutBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameCattleManifestLayout>>,
    { id: number; data: RenameCattleManifestLayoutBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return renameCattleManifestLayout(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameCattleManifestLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameCattleManifestLayout>>
>;
export type RenameCattleManifestLayoutMutationBody =
  RenameCattleManifestLayoutBody;
export type RenameCattleManifestLayoutMutationError = ErrorType<HttpError>;

export const useRenameCattleManifestLayout = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameCattleManifestLayout>>,
    TError,
    { id: number; data: RenameCattleManifestLayoutBody },
    TContext
  >;
}) => {
  const mutationOptions = getRenameCattleManifestLayoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const activateCattleManifestLayout = (id: number) => {
  return request<boolean>({
    url: `/cattle-manifest-layouts/${id}/activate`,
    method: "POST",
  });
};

export const getActivateCattleManifestLayoutMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateCattleManifestLayout>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateCattleManifestLayout>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateCattleManifestLayout>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return activateCattleManifestLayout(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateCattleManifestLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateCattleManifestLayout>>
>;

export type ActivateCattleManifestLayoutMutationError = ErrorType<HttpError>;

export const useActivateCattleManifestLayout = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateCattleManifestLayout>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions =
    getActivateCattleManifestLayoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deactivateCattleManifestLayout = (id: number) => {
  return request<DeactivateCattleManifestLayoutResponse>({
    url: `/cattle-manifest-layouts/${id}/deactivate`,
    method: "POST",
  });
};

export const getDeactivateCattleManifestLayoutMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateCattleManifestLayout>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateCattleManifestLayout>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateCattleManifestLayout>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deactivateCattleManifestLayout(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateCattleManifestLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateCattleManifestLayout>>
>;

export type DeactivateCattleManifestLayoutMutationError = ErrorType<HttpError>;

export const useDeactivateCattleManifestLayout = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateCattleManifestLayout>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions =
    getDeactivateCattleManifestLayoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlinkCattleManifestLayoutEstablishments = (
  id: number,
  unlinkCattleManifestLayoutEstablishmentsBody: UnlinkCattleManifestLayoutEstablishmentsBody,
) => {
  return request<UnlinkCattleManifestLayoutEstablishmentsResponse>({
    url: `/cattle-manifest-layouts/${id}/establishments`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: unlinkCattleManifestLayoutEstablishmentsBody,
  });
};

export const getUnlinkCattleManifestLayoutEstablishmentsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkCattleManifestLayoutEstablishments>>,
    TError,
    { id: number; data: UnlinkCattleManifestLayoutEstablishmentsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlinkCattleManifestLayoutEstablishments>>,
  TError,
  { id: number; data: UnlinkCattleManifestLayoutEstablishmentsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlinkCattleManifestLayoutEstablishments>>,
    { id: number; data: UnlinkCattleManifestLayoutEstablishmentsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return unlinkCattleManifestLayoutEstablishments(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlinkCattleManifestLayoutEstablishmentsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof unlinkCattleManifestLayoutEstablishments>>
  >;
export type UnlinkCattleManifestLayoutEstablishmentsMutationBody =
  UnlinkCattleManifestLayoutEstablishmentsBody;
export type UnlinkCattleManifestLayoutEstablishmentsMutationError =
  ErrorType<HttpError>;

export const useUnlinkCattleManifestLayoutEstablishments = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkCattleManifestLayoutEstablishments>>,
    TError,
    { id: number; data: UnlinkCattleManifestLayoutEstablishmentsBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getUnlinkCattleManifestLayoutEstablishmentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listCattleManifestLayoutEstablishments = (
  id: number,
  params?: ListCattleManifestLayoutEstablishmentsParams,
  signal?: AbortSignal,
) => {
  return request<ListCattleManifestLayoutEstablishmentsResponse>({
    url: `/cattle-manifest-layouts/${id}/establishments`,
    method: "GET",
    params,
    signal,
  });
};

export const getListCattleManifestLayoutEstablishmentsQueryKey = (
  id: number,
  params?: ListCattleManifestLayoutEstablishmentsParams,
) => {
  return [
    `/cattle-manifest-layouts/${id}/establishments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCattleManifestLayoutEstablishmentsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: ListCattleManifestLayoutEstablishmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCattleManifestLayoutEstablishmentsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>
  > = ({ signal }) =>
    listCattleManifestLayoutEstablishments(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCattleManifestLayoutEstablishmentsInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>
  >;
export type ListCattleManifestLayoutEstablishmentsInfiniteQueryError =
  ErrorType<HttpError>;

export const useListCattleManifestLayoutEstablishmentsInfinite = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: ListCattleManifestLayoutEstablishmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListCattleManifestLayoutEstablishmentsInfiniteQueryOptions(
      id,
      params,
      options,
    );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCattleManifestLayoutEstablishmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: ListCattleManifestLayoutEstablishmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCattleManifestLayoutEstablishmentsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>
  > = ({ signal }) =>
    listCattleManifestLayoutEstablishments(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCattleManifestLayoutEstablishmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>
>;
export type ListCattleManifestLayoutEstablishmentsQueryError =
  ErrorType<HttpError>;

export const useListCattleManifestLayoutEstablishments = <
  TData = Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: ListCattleManifestLayoutEstablishmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCattleManifestLayoutEstablishments>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCattleManifestLayoutEstablishmentsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const linkCattleManifestLayoutEstablishments = (
  id: number,
  linkCattleManifestLayoutEstablishmentsBody: LinkCattleManifestLayoutEstablishmentsBody,
) => {
  return request<LinkCattleManifestLayoutEstablishmentsResponse>({
    url: `/cattle-manifest-layouts/${id}/establishments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: linkCattleManifestLayoutEstablishmentsBody,
  });
};

export const getLinkCattleManifestLayoutEstablishmentsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkCattleManifestLayoutEstablishments>>,
    TError,
    { id: number; data: LinkCattleManifestLayoutEstablishmentsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkCattleManifestLayoutEstablishments>>,
  TError,
  { id: number; data: LinkCattleManifestLayoutEstablishmentsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkCattleManifestLayoutEstablishments>>,
    { id: number; data: LinkCattleManifestLayoutEstablishmentsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return linkCattleManifestLayoutEstablishments(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkCattleManifestLayoutEstablishmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof linkCattleManifestLayoutEstablishments>>
>;
export type LinkCattleManifestLayoutEstablishmentsMutationBody =
  LinkCattleManifestLayoutEstablishmentsBody;
export type LinkCattleManifestLayoutEstablishmentsMutationError =
  ErrorType<HttpError>;

export const useLinkCattleManifestLayoutEstablishments = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkCattleManifestLayoutEstablishments>>,
    TError,
    { id: number; data: LinkCattleManifestLayoutEstablishmentsBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getLinkCattleManifestLayoutEstablishmentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCattleManifestLayoutFieldMapping = (
  id: number,
  signal?: AbortSignal,
) => {
  return request<GetCattleManifestLayoutFieldMappingResponse>({
    url: `/cattle-manifest-layouts/${id}/field-mapping`,
    method: "GET",
    signal,
  });
};

export const getGetCattleManifestLayoutFieldMappingQueryKey = (id: number) => {
  return [`/cattle-manifest-layouts/${id}/field-mapping`] as const;
};

export const getGetCattleManifestLayoutFieldMappingInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCattleManifestLayoutFieldMappingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>
  > = ({ signal }) => getCattleManifestLayoutFieldMapping(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleManifestLayoutFieldMappingInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>>;
export type GetCattleManifestLayoutFieldMappingInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetCattleManifestLayoutFieldMappingInfinite = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetCattleManifestLayoutFieldMappingInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetCattleManifestLayoutFieldMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCattleManifestLayoutFieldMappingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>
  > = ({ signal }) => getCattleManifestLayoutFieldMapping(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleManifestLayoutFieldMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>
>;
export type GetCattleManifestLayoutFieldMappingQueryError =
  ErrorType<HttpError>;

export const useGetCattleManifestLayoutFieldMapping = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFieldMapping>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCattleManifestLayoutFieldMappingQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateCattleManifestLayoutFieldMapping = (
  id: number,
  updateCattleManifestLayoutFieldMappingBody: UpdateCattleManifestLayoutFieldMappingBody,
) => {
  return request<boolean>({
    url: `/cattle-manifest-layouts/${id}/field-mapping`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateCattleManifestLayoutFieldMappingBody,
  });
};

export const getUpdateCattleManifestLayoutFieldMappingMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCattleManifestLayoutFieldMapping>>,
    TError,
    { id: number; data: UpdateCattleManifestLayoutFieldMappingBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCattleManifestLayoutFieldMapping>>,
  TError,
  { id: number; data: UpdateCattleManifestLayoutFieldMappingBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCattleManifestLayoutFieldMapping>>,
    { id: number; data: UpdateCattleManifestLayoutFieldMappingBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCattleManifestLayoutFieldMapping(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCattleManifestLayoutFieldMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCattleManifestLayoutFieldMapping>>
>;
export type UpdateCattleManifestLayoutFieldMappingMutationBody =
  UpdateCattleManifestLayoutFieldMappingBody;
export type UpdateCattleManifestLayoutFieldMappingMutationError =
  ErrorType<HttpError>;

export const useUpdateCattleManifestLayoutFieldMapping = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCattleManifestLayoutFieldMapping>>,
    TError,
    { id: number; data: UpdateCattleManifestLayoutFieldMappingBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateCattleManifestLayoutFieldMappingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCattleManifestLayoutFinishingMapping = (
  id: number,
  signal?: AbortSignal,
) => {
  return request<GetCattleManifestLayoutFinishingMappingResponse>({
    url: `/cattle-manifest-layouts/${id}/finishing-mapping`,
    method: "GET",
    signal,
  });
};

export const getGetCattleManifestLayoutFinishingMappingQueryKey = (
  id: number,
) => {
  return [`/cattle-manifest-layouts/${id}/finishing-mapping`] as const;
};

export const getGetCattleManifestLayoutFinishingMappingInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCattleManifestLayoutFinishingMappingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>
  > = ({ signal }) => getCattleManifestLayoutFinishingMapping(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleManifestLayoutFinishingMappingInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>
  >;
export type GetCattleManifestLayoutFinishingMappingInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetCattleManifestLayoutFinishingMappingInfinite = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetCattleManifestLayoutFinishingMappingInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetCattleManifestLayoutFinishingMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCattleManifestLayoutFinishingMappingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>
  > = ({ signal }) => getCattleManifestLayoutFinishingMapping(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleManifestLayoutFinishingMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>
>;
export type GetCattleManifestLayoutFinishingMappingQueryError =
  ErrorType<HttpError>;

export const useGetCattleManifestLayoutFinishingMapping = <
  TData = Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleManifestLayoutFinishingMapping>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCattleManifestLayoutFinishingMappingQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateCattleManifestLayoutFinishingMapping = (
  id: number,
  updateCattleManifestLayoutFinishingMappingBody: UpdateCattleManifestLayoutFinishingMappingBody,
) => {
  return request<boolean>({
    url: `/cattle-manifest-layouts/${id}/finishing-mapping`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateCattleManifestLayoutFinishingMappingBody,
  });
};

export const getUpdateCattleManifestLayoutFinishingMappingMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCattleManifestLayoutFinishingMapping>>,
    TError,
    { id: number; data: UpdateCattleManifestLayoutFinishingMappingBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCattleManifestLayoutFinishingMapping>>,
  TError,
  { id: number; data: UpdateCattleManifestLayoutFinishingMappingBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCattleManifestLayoutFinishingMapping>>,
    { id: number; data: UpdateCattleManifestLayoutFinishingMappingBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCattleManifestLayoutFinishingMapping(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCattleManifestLayoutFinishingMappingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateCattleManifestLayoutFinishingMapping>>
  >;
export type UpdateCattleManifestLayoutFinishingMappingMutationBody =
  UpdateCattleManifestLayoutFinishingMappingBody;
export type UpdateCattleManifestLayoutFinishingMappingMutationError =
  ErrorType<HttpError>;

export const useUpdateCattleManifestLayoutFinishingMapping = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCattleManifestLayoutFinishingMapping>>,
    TError,
    { id: number; data: UpdateCattleManifestLayoutFinishingMappingBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateCattleManifestLayoutFinishingMappingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateCattleManifestLayoutTransformationConfig = (
  id: number,
  updateCattleManifestLayoutTransformationConfigBody: UpdateCattleManifestLayoutTransformationConfigBody,
) => {
  return request<boolean>({
    url: `/cattle-manifest-layouts/${id}/transformation-config`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateCattleManifestLayoutTransformationConfigBody,
  });
};

export const getUpdateCattleManifestLayoutTransformationConfigMutationOptions =
  <TError = ErrorType<HttpError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateCattleManifestLayoutTransformationConfig>
      >,
      TError,
      { id: number; data: UpdateCattleManifestLayoutTransformationConfigBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateCattleManifestLayoutTransformationConfig>>,
    TError,
    { id: number; data: UpdateCattleManifestLayoutTransformationConfigBody },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateCattleManifestLayoutTransformationConfig>
      >,
      { id: number; data: UpdateCattleManifestLayoutTransformationConfigBody }
    > = (props) => {
      const { id, data } = props ?? {};

      return updateCattleManifestLayoutTransformationConfig(id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCattleManifestLayoutTransformationConfigMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateCattleManifestLayoutTransformationConfig>>
  >;
export type UpdateCattleManifestLayoutTransformationConfigMutationBody =
  UpdateCattleManifestLayoutTransformationConfigBody;
export type UpdateCattleManifestLayoutTransformationConfigMutationError =
  ErrorType<HttpError>;

export const useUpdateCattleManifestLayoutTransformationConfig = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCattleManifestLayoutTransformationConfig>>,
    TError,
    { id: number; data: UpdateCattleManifestLayoutTransformationConfigBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateCattleManifestLayoutTransformationConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const validateCattleManifestLayoutSample = (
  id: number,
  validateCattleManifestLayoutSampleBody: ValidateCattleManifestLayoutSampleBody,
) => {
  return request<ValidateCattleManifestLayoutSampleResponse>({
    url: `/cattle-manifest-layouts/${id}/validate-sample`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: validateCattleManifestLayoutSampleBody,
  });
};

export const getValidateCattleManifestLayoutSampleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateCattleManifestLayoutSample>>,
    TError,
    { id: number; data: ValidateCattleManifestLayoutSampleBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateCattleManifestLayoutSample>>,
  TError,
  { id: number; data: ValidateCattleManifestLayoutSampleBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateCattleManifestLayoutSample>>,
    { id: number; data: ValidateCattleManifestLayoutSampleBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return validateCattleManifestLayoutSample(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateCattleManifestLayoutSampleMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateCattleManifestLayoutSample>>
>;
export type ValidateCattleManifestLayoutSampleMutationBody =
  ValidateCattleManifestLayoutSampleBody;
export type ValidateCattleManifestLayoutSampleMutationError =
  ErrorType<HttpError>;

export const useValidateCattleManifestLayoutSample = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateCattleManifestLayoutSample>>,
    TError,
    { id: number; data: ValidateCattleManifestLayoutSampleBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getValidateCattleManifestLayoutSampleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeTenant = (params: RemoveTenantParams) => {
  return request<boolean>({ url: `/cloud/database`, method: "DELETE", params });
};

export const getRemoveTenantMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTenant>>,
    TError,
    { params: RemoveTenantParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeTenant>>,
  TError,
  { params: RemoveTenantParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeTenant>>,
    { params: RemoveTenantParams }
  > = (props) => {
    const { params } = props ?? {};

    return removeTenant(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeTenant>>
>;

export type RemoveTenantMutationError = ErrorType<HttpError>;

export const useRemoveTenant = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTenant>>,
    TError,
    { params: RemoveTenantParams },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveTenantMutationOptions(options);

  return useMutation(mutationOptions);
};

export const registerNewTenant = (
  registerNewTenantBody: RegisterNewTenantBody,
) => {
  return request<boolean>({
    url: `/cloud/database`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerNewTenantBody,
  });
};

export const getRegisterNewTenantMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerNewTenant>>,
    TError,
    { data: RegisterNewTenantBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerNewTenant>>,
  TError,
  { data: RegisterNewTenantBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerNewTenant>>,
    { data: RegisterNewTenantBody }
  > = (props) => {
    const { data } = props ?? {};

    return registerNewTenant(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterNewTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerNewTenant>>
>;
export type RegisterNewTenantMutationBody = RegisterNewTenantBody;
export type RegisterNewTenantMutationError = ErrorType<HttpError>;

export const useRegisterNewTenant = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerNewTenant>>,
    TError,
    { data: RegisterNewTenantBody },
    TContext
  >;
}) => {
  const mutationOptions = getRegisterNewTenantMutationOptions(options);

  return useMutation(mutationOptions);
};

export const registerCloudFarm = (registerCloudFarm: RegisterCloudFarm) => {
  return request<RegisterCloudFarmResponse>({
    url: `/cloud/farm`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerCloudFarm,
  });
};

export const getRegisterCloudFarmMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerCloudFarm>>,
    TError,
    { data: RegisterCloudFarm },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerCloudFarm>>,
  TError,
  { data: RegisterCloudFarm },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerCloudFarm>>,
    { data: RegisterCloudFarm }
  > = (props) => {
    const { data } = props ?? {};

    return registerCloudFarm(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterCloudFarmMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerCloudFarm>>
>;
export type RegisterCloudFarmMutationBody = RegisterCloudFarm;
export type RegisterCloudFarmMutationError = ErrorType<unknown>;

export const useRegisterCloudFarm = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerCloudFarm>>,
    TError,
    { data: RegisterCloudFarm },
    TContext
  >;
}) => {
  const mutationOptions = getRegisterCloudFarmMutationOptions(options);

  return useMutation(mutationOptions);
};

export const uploadFileToCloud = (
  uploadFileToCloudBody: UploadFileToCloudBody,
) => {
  const formData = new FormData();
  formData.append("file", uploadFileToCloudBody.file);

  return request<UploadFileToCloudResponse>({
    url: `/cloud/upload`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  });
};

export const getUploadFileToCloudMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFileToCloud>>,
    TError,
    { data: UploadFileToCloudBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFileToCloud>>,
  TError,
  { data: UploadFileToCloudBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFileToCloud>>,
    { data: UploadFileToCloudBody }
  > = (props) => {
    const { data } = props ?? {};

    return uploadFileToCloud(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileToCloudMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFileToCloud>>
>;
export type UploadFileToCloudMutationBody = UploadFileToCloudBody;
export type UploadFileToCloudMutationError = ErrorType<unknown>;

export const useUploadFileToCloud = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFileToCloud>>,
    TError,
    { data: UploadFileToCloudBody },
    TContext
  >;
}) => {
  const mutationOptions = getUploadFileToCloudMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Essa rota não tem filtragem pois sempre precisaremos da listagem completa.
 */
export const listCorral = (params?: ListCorralParams, signal?: AbortSignal) => {
  return request<ListCorralResponse>({
    url: `/corrals`,
    method: "GET",
    params,
    signal,
  });
};

export const getListCorralQueryKey = (params?: ListCorralParams) => {
  return [`/corrals`, ...(params ? [params] : [])] as const;
};

export const getListCorralInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorral>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorral>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCorralQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCorral>>> = ({
    signal,
  }) => listCorral(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorral>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorral>>
>;
export type ListCorralInfiniteQueryError = ErrorType<unknown>;

export const useListCorralInfinite = <
  TData = Awaited<ReturnType<typeof listCorral>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorral>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCorralQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorral>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorral>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCorralQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCorral>>> = ({
    signal,
  }) => listCorral(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCorral>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorral>>
>;
export type ListCorralQueryError = ErrorType<unknown>;

export const useListCorral = <
  TData = Awaited<ReturnType<typeof listCorral>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorral>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createCorral = (createCorral: CreateCorral) => {
  return request<CreateCorralResponse>({
    url: `/corrals`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCorral,
  });
};

export const getCreateCorralMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCorral>>,
    TError,
    { data: CreateCorral },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCorral>>,
  TError,
  { data: CreateCorral },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCorral>>,
    { data: CreateCorral }
  > = (props) => {
    const { data } = props ?? {};

    return createCorral(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCorralMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCorral>>
>;
export type CreateCorralMutationBody = CreateCorral;
export type CreateCorralMutationError = ErrorType<HttpError>;

export const useCreateCorral = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCorral>>,
    TError,
    { data: CreateCorral },
    TContext
  >;
}) => {
  const mutationOptions = getCreateCorralMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listActiveCorrals = (signal?: AbortSignal) => {
  return request<ListActiveCorralsResponse>({
    url: `/corrals/active`,
    method: "GET",
    signal,
  });
};

export const getListActiveCorralsQueryKey = () => {
  return [`/corrals/active`] as const;
};

export const getListActiveCorralsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveCorrals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listActiveCorrals>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveCorralsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveCorrals>>
  > = ({ signal }) => listActiveCorrals(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listActiveCorrals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveCorralsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveCorrals>>
>;
export type ListActiveCorralsInfiniteQueryError = ErrorType<unknown>;

export const useListActiveCorralsInfinite = <
  TData = Awaited<ReturnType<typeof listActiveCorrals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listActiveCorrals>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListActiveCorralsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListActiveCorralsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveCorrals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveCorrals>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveCorralsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveCorrals>>
  > = ({ signal }) => listActiveCorrals(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveCorrals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveCorralsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveCorrals>>
>;
export type ListActiveCorralsQueryError = ErrorType<unknown>;

export const useListActiveCorrals = <
  TData = Awaited<ReturnType<typeof listActiveCorrals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveCorrals>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListActiveCorralsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listCorralsAndBatches = (
  params: ListCorralsAndBatchesParams,
  signal?: AbortSignal,
) => {
  return request<ListCorralsAndBatchesResponse>({
    url: `/corrals/batch`,
    method: "GET",
    params,
    signal,
  });
};

export const getListCorralsAndBatchesQueryKey = (
  params: ListCorralsAndBatchesParams,
) => {
  return [`/corrals/batch`, ...(params ? [params] : [])] as const;
};

export const getListCorralsAndBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralsAndBatches>>,
  TError = ErrorType<unknown>,
>(
  params: ListCorralsAndBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorralsAndBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCorralsAndBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralsAndBatches>>
  > = ({ signal }) => listCorralsAndBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralsAndBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralsAndBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralsAndBatches>>
>;
export type ListCorralsAndBatchesInfiniteQueryError = ErrorType<unknown>;

export const useListCorralsAndBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listCorralsAndBatches>>,
  TError = ErrorType<unknown>,
>(
  params: ListCorralsAndBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorralsAndBatches>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralsAndBatchesInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCorralsAndBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralsAndBatches>>,
  TError = ErrorType<unknown>,
>(
  params: ListCorralsAndBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorralsAndBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCorralsAndBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralsAndBatches>>
  > = ({ signal }) => listCorralsAndBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCorralsAndBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralsAndBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralsAndBatches>>
>;
export type ListCorralsAndBatchesQueryError = ErrorType<unknown>;

export const useListCorralsAndBatches = <
  TData = Awaited<ReturnType<typeof listCorralsAndBatches>>,
  TError = ErrorType<unknown>,
>(
  params: ListCorralsAndBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorralsAndBatches>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralsAndBatchesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listCorralsSimplified = (
  params?: ListCorralsSimplifiedParams,
  signal?: AbortSignal,
) => {
  return request<ListCorralsSimplifiedResponse>({
    url: `/corrals/corrals`,
    method: "GET",
    params,
    signal,
  });
};

export const getListCorralsSimplifiedQueryKey = (
  params?: ListCorralsSimplifiedParams,
) => {
  return [`/corrals/corrals`, ...(params ? [params] : [])] as const;
};

export const getListCorralsSimplifiedInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralsSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralsSimplifiedParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorralsSimplified>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCorralsSimplifiedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralsSimplified>>
  > = ({ signal }) => listCorralsSimplified(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralsSimplified>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralsSimplifiedInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralsSimplified>>
>;
export type ListCorralsSimplifiedInfiniteQueryError = ErrorType<unknown>;

export const useListCorralsSimplifiedInfinite = <
  TData = Awaited<ReturnType<typeof listCorralsSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralsSimplifiedParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorralsSimplified>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralsSimplifiedInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCorralsSimplifiedQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralsSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralsSimplifiedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorralsSimplified>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCorralsSimplifiedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralsSimplified>>
  > = ({ signal }) => listCorralsSimplified(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCorralsSimplified>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralsSimplifiedQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralsSimplified>>
>;
export type ListCorralsSimplifiedQueryError = ErrorType<unknown>;

export const useListCorralsSimplified = <
  TData = Awaited<ReturnType<typeof listCorralsSimplified>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCorralsSimplifiedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorralsSimplified>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralsSimplifiedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listCorralPositions = (signal?: AbortSignal) => {
  return request<ListCorralPositionsResponse>({
    url: `/corrals/positions`,
    method: "GET",
    signal,
  });
};

export const getListCorralPositionsQueryKey = () => {
  return [`/corrals/positions`] as const;
};

export const getListCorralPositionsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralPositions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralPositions>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCorralPositionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralPositions>>
  > = ({ signal }) => listCorralPositions(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralPositions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralPositionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralPositions>>
>;
export type ListCorralPositionsInfiniteQueryError = ErrorType<unknown>;

export const useListCorralPositionsInfinite = <
  TData = Awaited<ReturnType<typeof listCorralPositions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralPositions>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralPositionsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCorralPositionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralPositions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCorralPositions>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCorralPositionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCorralPositions>>
  > = ({ signal }) => listCorralPositions(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCorralPositions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralPositionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralPositions>>
>;
export type ListCorralPositionsQueryError = ErrorType<unknown>;

export const useListCorralPositions = <
  TData = Awaited<ReturnType<typeof listCorralPositions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCorralPositions>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralPositionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateCorralPositionsOrder = (
  updateCorralPositionsOrderBody: number[],
) => {
  return request<UpdateCorralPositionsOrderResponse>({
    url: `/corrals/positions-order`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateCorralPositionsOrderBody,
  });
};

export const getUpdateCorralPositionsOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCorralPositionsOrder>>,
    TError,
    { data: number[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCorralPositionsOrder>>,
  TError,
  { data: number[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCorralPositionsOrder>>,
    { data: number[] }
  > = (props) => {
    const { data } = props ?? {};

    return updateCorralPositionsOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCorralPositionsOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCorralPositionsOrder>>
>;
export type UpdateCorralPositionsOrderMutationBody = number[];
export type UpdateCorralPositionsOrderMutationError = ErrorType<unknown>;

export const useUpdateCorralPositionsOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCorralPositionsOrder>>,
    TError,
    { data: number[] },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateCorralPositionsOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCorral = (id: number, signal?: AbortSignal) => {
  return request<GetCorralResponse>({
    url: `/corrals/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetCorralQueryKey = (id: number) => {
  return [`/corrals/${id}`] as const;
};

export const getGetCorralInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getCorral>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCorral>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCorralQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCorral>>> = ({
    signal,
  }) => getCorral(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCorral>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCorralInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCorral>>
>;
export type GetCorralInfiniteQueryError = ErrorType<unknown>;

export const useGetCorralInfinite = <
  TData = Awaited<ReturnType<typeof getCorral>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCorral>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCorralInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetCorralQueryOptions = <
  TData = Awaited<ReturnType<typeof getCorral>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCorral>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCorralQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCorral>>> = ({
    signal,
  }) => getCorral(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCorral>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetCorralQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCorral>>
>;
export type GetCorralQueryError = ErrorType<unknown>;

export const useGetCorral = <
  TData = Awaited<ReturnType<typeof getCorral>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCorral>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCorralQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateCorral = (id: number, updateCorral: UpdateCorral) => {
  return request<UpdateCorralResponse>({
    url: `/corrals/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateCorral,
  });
};

export const getUpdateCorralMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCorral>>,
    TError,
    { id: number; data: UpdateCorral },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCorral>>,
  TError,
  { id: number; data: UpdateCorral },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCorral>>,
    { id: number; data: UpdateCorral }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCorral(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCorralMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCorral>>
>;
export type UpdateCorralMutationBody = UpdateCorral;
export type UpdateCorralMutationError = ErrorType<unknown>;

export const useUpdateCorral = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCorral>>,
    TError,
    { id: number; data: UpdateCorral },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateCorralMutationOptions(options);

  return useMutation(mutationOptions);
};

export const moveBatch = (id: number, params: MoveBatchParams) => {
  return request<MoveBatchResponse>({
    url: `/corrals/${id}/movement`,
    method: "POST",
    params,
  });
};

export const getMoveBatchMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveBatch>>,
    TError,
    { id: number; params: MoveBatchParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveBatch>>,
  TError,
  { id: number; params: MoveBatchParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveBatch>>,
    { id: number; params: MoveBatchParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return moveBatch(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveBatch>>
>;

export type MoveBatchMutationError = ErrorType<HttpError>;

export const useMoveBatch = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveBatch>>,
    TError,
    { id: number; params: MoveBatchParams },
    TContext
  >;
}) => {
  const mutationOptions = getMoveBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listCorralOxen = (id: number, signal?: AbortSignal) => {
  return request<ListCorralOxenResponse>({
    url: `/corrals/${id}/oxen`,
    method: "GET",
    signal,
  });
};

export const getListCorralOxenQueryKey = (id: number) => {
  return [`/corrals/${id}/oxen`] as const;
};

export const getListCorralOxenInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralOxen>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorralOxen>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCorralOxenQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCorralOxen>>> = ({
    signal,
  }) => listCorralOxen(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listCorralOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralOxenInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralOxen>>
>;
export type ListCorralOxenInfiniteQueryError = ErrorType<HttpError>;

export const useListCorralOxenInfinite = <
  TData = Awaited<ReturnType<typeof listCorralOxen>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listCorralOxen>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralOxenInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListCorralOxenQueryOptions = <
  TData = Awaited<ReturnType<typeof listCorralOxen>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorralOxen>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCorralOxenQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCorralOxen>>> = ({
    signal,
  }) => listCorralOxen(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCorralOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCorralOxenQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCorralOxen>>
>;
export type ListCorralOxenQueryError = ErrorType<HttpError>;

export const useListCorralOxen = <
  TData = Awaited<ReturnType<typeof listCorralOxen>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCorralOxen>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCorralOxenQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listDietTransitions = (
  params?: ListDietTransitionsParams,
  signal?: AbortSignal,
) => {
  return request<ListDietTransitionsResponse>({
    url: `/diet-transitions`,
    method: "GET",
    params,
    signal,
  });
};

export const getListDietTransitionsQueryKey = (
  params?: ListDietTransitionsParams,
) => {
  return [`/diet-transitions`, ...(params ? [params] : [])] as const;
};

export const getListDietTransitionsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listDietTransitions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietTransitionsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDietTransitions>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDietTransitionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDietTransitions>>
  > = ({ signal }) => listDietTransitions(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDietTransitions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDietTransitionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDietTransitions>>
>;
export type ListDietTransitionsInfiniteQueryError = ErrorType<unknown>;

export const useListDietTransitionsInfinite = <
  TData = Awaited<ReturnType<typeof listDietTransitions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietTransitionsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDietTransitions>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDietTransitionsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListDietTransitionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDietTransitions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietTransitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDietTransitions>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDietTransitionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDietTransitions>>
  > = ({ signal }) => listDietTransitions(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDietTransitions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDietTransitionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDietTransitions>>
>;
export type ListDietTransitionsQueryError = ErrorType<unknown>;

export const useListDietTransitions = <
  TData = Awaited<ReturnType<typeof listDietTransitions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietTransitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDietTransitions>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDietTransitionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createDietTransition = (
  createDietTransition: CreateDietTransition,
) => {
  return request<CreateDietTransitionResponse>({
    url: `/diet-transitions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createDietTransition,
  });
};

export const getCreateDietTransitionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDietTransition>>,
    TError,
    { data: CreateDietTransition },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDietTransition>>,
  TError,
  { data: CreateDietTransition },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDietTransition>>,
    { data: CreateDietTransition }
  > = (props) => {
    const { data } = props ?? {};

    return createDietTransition(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDietTransitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDietTransition>>
>;
export type CreateDietTransitionMutationBody = CreateDietTransition;
export type CreateDietTransitionMutationError = ErrorType<HttpError>;

export const useCreateDietTransition = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDietTransition>>,
    TError,
    { data: CreateDietTransition },
    TContext
  >;
}) => {
  const mutationOptions = getCreateDietTransitionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Troca uma dieta usada por lotes que estão em transição de dieta.
 */
export const changeTransitionBatchesDiet = (
  changeTransitionBatchesDietBody: ChangeTransitionBatchesDietBody,
) => {
  return request<boolean>({
    url: `/diet-transitions/change-diet`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: changeTransitionBatchesDietBody,
  });
};

export const getChangeTransitionBatchesDietMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeTransitionBatchesDiet>>,
    TError,
    { data: ChangeTransitionBatchesDietBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeTransitionBatchesDiet>>,
  TError,
  { data: ChangeTransitionBatchesDietBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeTransitionBatchesDiet>>,
    { data: ChangeTransitionBatchesDietBody }
  > = (props) => {
    const { data } = props ?? {};

    return changeTransitionBatchesDiet(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeTransitionBatchesDietMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeTransitionBatchesDiet>>
>;
export type ChangeTransitionBatchesDietMutationBody =
  ChangeTransitionBatchesDietBody;
export type ChangeTransitionBatchesDietMutationError = ErrorType<HttpError>;

export const useChangeTransitionBatchesDiet = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeTransitionBatchesDiet>>,
    TError,
    { data: ChangeTransitionBatchesDietBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getChangeTransitionBatchesDietMutationOptions(options);

  return useMutation(mutationOptions);
};

export const finalizeDietTransition = (
  finalizeDietTransitionBody: FinalizeDietTransitionBody,
) => {
  return request<boolean>({
    url: `/diet-transitions/finalize`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: finalizeDietTransitionBody,
  });
};

export const getFinalizeDietTransitionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeDietTransition>>,
    TError,
    { data: FinalizeDietTransitionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeDietTransition>>,
  TError,
  { data: FinalizeDietTransitionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeDietTransition>>,
    { data: FinalizeDietTransitionBody }
  > = (props) => {
    const { data } = props ?? {};

    return finalizeDietTransition(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeDietTransitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeDietTransition>>
>;
export type FinalizeDietTransitionMutationBody = FinalizeDietTransitionBody;
export type FinalizeDietTransitionMutationError = ErrorType<HttpError>;

export const useFinalizeDietTransition = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeDietTransition>>,
    TError,
    { data: FinalizeDietTransitionBody },
    TContext
  >;
}) => {
  const mutationOptions = getFinalizeDietTransitionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const migratePhaseDietTransition = (
  migratePhaseDietTransitionBody: MigratePhaseDietTransitionBody,
) => {
  return request<boolean>({
    url: `/diet-transitions/migrate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: migratePhaseDietTransitionBody,
  });
};

export const getMigratePhaseDietTransitionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migratePhaseDietTransition>>,
    TError,
    { data: MigratePhaseDietTransitionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof migratePhaseDietTransition>>,
  TError,
  { data: MigratePhaseDietTransitionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof migratePhaseDietTransition>>,
    { data: MigratePhaseDietTransitionBody }
  > = (props) => {
    const { data } = props ?? {};

    return migratePhaseDietTransition(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MigratePhaseDietTransitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof migratePhaseDietTransition>>
>;
export type MigratePhaseDietTransitionMutationBody =
  MigratePhaseDietTransitionBody;
export type MigratePhaseDietTransitionMutationError = ErrorType<HttpError>;

export const useMigratePhaseDietTransition = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migratePhaseDietTransition>>,
    TError,
    { data: MigratePhaseDietTransitionBody },
    TContext
  >;
}) => {
  const mutationOptions = getMigratePhaseDietTransitionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const replaceTargetDietInDietTransition = (
  replaceTargetDietInDietTransitionBody: ReplaceTargetDietInDietTransitionBody,
) => {
  return request<boolean>({
    url: `/diet-transitions/replace`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: replaceTargetDietInDietTransitionBody,
  });
};

export const getReplaceTargetDietInDietTransitionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceTargetDietInDietTransition>>,
    TError,
    { data: ReplaceTargetDietInDietTransitionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceTargetDietInDietTransition>>,
  TError,
  { data: ReplaceTargetDietInDietTransitionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceTargetDietInDietTransition>>,
    { data: ReplaceTargetDietInDietTransitionBody }
  > = (props) => {
    const { data } = props ?? {};

    return replaceTargetDietInDietTransition(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceTargetDietInDietTransitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceTargetDietInDietTransition>>
>;
export type ReplaceTargetDietInDietTransitionMutationBody =
  ReplaceTargetDietInDietTransitionBody;
export type ReplaceTargetDietInDietTransitionMutationError =
  ErrorType<HttpError>;

export const useReplaceTargetDietInDietTransition = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceTargetDietInDietTransition>>,
    TError,
    { data: ReplaceTargetDietInDietTransitionBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getReplaceTargetDietInDietTransitionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listDiets = (params?: ListDietsParams, signal?: AbortSignal) => {
  return request<ListDietsResponse>({
    url: `/diets`,
    method: "GET",
    params,
    signal,
  });
};

export const getListDietsQueryKey = (params?: ListDietsParams) => {
  return [`/diets`, ...(params ? [params] : [])] as const;
};

export const getListDietsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDiets>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDietsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDiets>>> = ({
    signal,
  }) => listDiets(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDiets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDietsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDiets>>
>;
export type ListDietsInfiniteQueryError = ErrorType<unknown>;

export const useListDietsInfinite = <
  TData = Awaited<ReturnType<typeof listDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDiets>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDietsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListDietsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDiets>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDietsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDiets>>> = ({
    signal,
  }) => listDiets(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listDiets>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListDietsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDiets>>
>;
export type ListDietsQueryError = ErrorType<unknown>;

export const useListDiets = <
  TData = Awaited<ReturnType<typeof listDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDietsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDiets>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDietsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createDiet = (createDiet: CreateDiet) => {
  return request<CreateDietResponse>({
    url: `/diets`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createDiet,
  });
};

export const getCreateDietMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDiet>>,
    TError,
    { data: CreateDiet },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDiet>>,
  TError,
  { data: CreateDiet },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDiet>>,
    { data: CreateDiet }
  > = (props) => {
    const { data } = props ?? {};

    return createDiet(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDietMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDiet>>
>;
export type CreateDietMutationBody = CreateDiet;
export type CreateDietMutationError = ErrorType<HttpError>;

export const useCreateDiet = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDiet>>,
    TError,
    { data: CreateDiet },
    TContext
  >;
}) => {
  const mutationOptions = getCreateDietMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAllDiets = (
  params?: ListAllDietsParams,
  signal?: AbortSignal,
) => {
  return request<ListAllDietsResponse>({
    url: `/diets/all`,
    method: "GET",
    params,
    signal,
  });
};

export const getListAllDietsQueryKey = (params?: ListAllDietsParams) => {
  return [`/diets/all`, ...(params ? [params] : [])] as const;
};

export const getListAllDietsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAllDietsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listAllDiets>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllDietsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllDiets>>> = ({
    signal,
  }) => listAllDiets(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAllDiets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllDietsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllDiets>>
>;
export type ListAllDietsInfiniteQueryError = ErrorType<unknown>;

export const useListAllDietsInfinite = <
  TData = Awaited<ReturnType<typeof listAllDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAllDietsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listAllDiets>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAllDietsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListAllDietsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAllDietsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAllDiets>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllDietsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllDiets>>> = ({
    signal,
  }) => listAllDiets(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllDiets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllDietsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllDiets>>
>;
export type ListAllDietsQueryError = ErrorType<unknown>;

export const useListAllDiets = <
  TData = Awaited<ReturnType<typeof listAllDiets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAllDietsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAllDiets>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAllDietsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const changeBatchesDiet = (
  changeBatchesDietBody: ChangeBatchesDietBody,
) => {
  return request<boolean>({
    url: `/diets/change-batches-diet`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: changeBatchesDietBody,
  });
};

export const getChangeBatchesDietMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeBatchesDiet>>,
    TError,
    { data: ChangeBatchesDietBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeBatchesDiet>>,
  TError,
  { data: ChangeBatchesDietBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeBatchesDiet>>,
    { data: ChangeBatchesDietBody }
  > = (props) => {
    const { data } = props ?? {};

    return changeBatchesDiet(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeBatchesDietMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeBatchesDiet>>
>;
export type ChangeBatchesDietMutationBody = ChangeBatchesDietBody;
export type ChangeBatchesDietMutationError = ErrorType<HttpError>;

export const useChangeBatchesDiet = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeBatchesDiet>>,
    TError,
    { data: ChangeBatchesDietBody },
    TContext
  >;
}) => {
  const mutationOptions = getChangeBatchesDietMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista as dietas usadas por lotes que estão em transição de dieta, junto dos lotes de cada uma.
 */
export const listDietsInTransition = (signal?: AbortSignal) => {
  return request<ListDietsInTransitionResponse>({
    url: `/diets/in-transition`,
    method: "GET",
    signal,
  });
};

export const getListDietsInTransitionQueryKey = () => {
  return [`/diets/in-transition`] as const;
};

export const getListDietsInTransitionInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listDietsInTransition>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDietsInTransition>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDietsInTransitionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDietsInTransition>>
  > = ({ signal }) => listDietsInTransition(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDietsInTransition>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDietsInTransitionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDietsInTransition>>
>;
export type ListDietsInTransitionInfiniteQueryError = ErrorType<unknown>;

export const useListDietsInTransitionInfinite = <
  TData = Awaited<ReturnType<typeof listDietsInTransition>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDietsInTransition>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDietsInTransitionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListDietsInTransitionQueryOptions = <
  TData = Awaited<ReturnType<typeof listDietsInTransition>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDietsInTransition>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDietsInTransitionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDietsInTransition>>
  > = ({ signal }) => listDietsInTransition(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDietsInTransition>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDietsInTransitionQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDietsInTransition>>
>;
export type ListDietsInTransitionQueryError = ErrorType<unknown>;

export const useListDietsInTransition = <
  TData = Awaited<ReturnType<typeof listDietsInTransition>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDietsInTransition>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDietsInTransitionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getDiet = (id: number, signal?: AbortSignal) => {
  return request<GetDietResponse>({
    url: `/diets/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetDietQueryKey = (id: number) => {
  return [`/diets/${id}`] as const;
};

export const getGetDietInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiet>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDiet>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDietQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiet>>> = ({
    signal,
  }) => getDiet(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDiet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDietInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiet>>
>;
export type GetDietInfiniteQueryError = ErrorType<unknown>;

export const useGetDietInfinite = <
  TData = Awaited<ReturnType<typeof getDiet>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDiet>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDietInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetDietQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiet>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDiet>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDietQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiet>>> = ({
    signal,
  }) => getDiet(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDiet>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetDietQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiet>>
>;
export type GetDietQueryError = ErrorType<unknown>;

export const useGetDiet = <
  TData = Awaited<ReturnType<typeof getDiet>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDiet>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDietQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateDiet = (id: number, updateDiet: UpdateDiet) => {
  return request<UpdateDietResponse>({
    url: `/diets/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateDiet,
  });
};

export const getUpdateDietMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDiet>>,
    TError,
    { id: number; data: UpdateDiet },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDiet>>,
  TError,
  { id: number; data: UpdateDiet },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDiet>>,
    { id: number; data: UpdateDiet }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDiet(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDietMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDiet>>
>;
export type UpdateDietMutationBody = UpdateDiet;
export type UpdateDietMutationError = ErrorType<HttpError>;

export const useUpdateDiet = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDiet>>,
    TError,
    { id: number; data: UpdateDiet },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateDietMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ativa uma dieta para ser listada no frontend.
 */
export const activateDiet = (id: number, params: ActivateDietParams) => {
  return request<boolean>({
    url: `/diets/${id}/activate`,
    method: "POST",
    params,
  });
};

export const getActivateDietMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateDiet>>,
    TError,
    { id: number; params: ActivateDietParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateDiet>>,
  TError,
  { id: number; params: ActivateDietParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateDiet>>,
    { id: number; params: ActivateDietParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return activateDiet(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateDietMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateDiet>>
>;

export type ActivateDietMutationError = ErrorType<HttpError>;

export const useActivateDiet = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateDiet>>,
    TError,
    { id: number; params: ActivateDietParams },
    TContext
  >;
}) => {
  const mutationOptions = getActivateDietMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Fabricado = distribuído no dia selecionado. Aceita dia anterior: a batida e o estorno de estoque são gravados na data
do dia em que o usuário está.
 */
export const fabricatedEqualsRealized = (id: number) => {
  return request<boolean>({
    url: `/diets/${id}/foreseen-equals-realized`,
    method: "PUT",
  });
};

export const getFabricatedEqualsRealizedMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fabricatedEqualsRealized>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof fabricatedEqualsRealized>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fabricatedEqualsRealized>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return fabricatedEqualsRealized(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FabricatedEqualsRealizedMutationResult = NonNullable<
  Awaited<ReturnType<typeof fabricatedEqualsRealized>>
>;

export type FabricatedEqualsRealizedMutationError = ErrorType<HttpError>;

export const useFabricatedEqualsRealized = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fabricatedEqualsRealized>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getFabricatedEqualsRealizedMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Histórico do preço por kg de MS informado à mão para a dieta.
 */
export const getDietPrice = (id: number, signal?: AbortSignal) => {
  return request<DietPriceHistory>({
    url: `/diets/${id}/price`,
    method: "GET",
    signal,
  });
};

export const getGetDietPriceQueryKey = (id: number) => {
  return [`/diets/${id}/price`] as const;
};

export const getGetDietPriceInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getDietPrice>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDietPrice>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDietPriceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDietPrice>>> = ({
    signal,
  }) => getDietPrice(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDietPrice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDietPriceInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDietPrice>>
>;
export type GetDietPriceInfiniteQueryError = ErrorType<HttpError>;

export const useGetDietPriceInfinite = <
  TData = Awaited<ReturnType<typeof getDietPrice>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDietPrice>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDietPriceInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetDietPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof getDietPrice>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDietPrice>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDietPriceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDietPrice>>> = ({
    signal,
  }) => getDietPrice(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDietPrice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDietPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDietPrice>>
>;
export type GetDietPriceQueryError = ErrorType<HttpError>;

export const useGetDietPrice = <
  TData = Awaited<ReturnType<typeof getDietPrice>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDietPrice>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDietPriceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Liga/desliga o preço por kg de MS da dieta e lança uma nova alteração de preço.

A linha anterior nunca é sobrescrita: o preço lançado vale da sua data em diante e o histórico continua inteiro.
 */
export const setDietPrice = (id: number, setDietPrice: SetDietPrice) => {
  return request<boolean>({
    url: `/diets/${id}/price`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: setDietPrice,
  });
};

export const getSetDietPriceMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDietPrice>>,
    TError,
    { id: number; data: SetDietPrice },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDietPrice>>,
  TError,
  { id: number; data: SetDietPrice },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDietPrice>>,
    { id: number; data: SetDietPrice }
  > = (props) => {
    const { id, data } = props ?? {};

    return setDietPrice(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetDietPriceMutationResult = NonNullable<
  Awaited<ReturnType<typeof setDietPrice>>
>;
export type SetDietPriceMutationBody = SetDietPrice;
export type SetDietPriceMutationError = ErrorType<HttpError>;

export const useSetDietPrice = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDietPrice>>,
    TError,
    { id: number; data: SetDietPrice },
    TContext
  >;
}) => {
  const mutationOptions = getSetDietPriceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Move todos os lotes que usam a dieta atual no dia da fazenda para a dieta sucessora.
 */
export const succeedDiet = (id: number, params: SucceedDietParams) => {
  return request<boolean>({
    url: `/diets/${id}/succeed`,
    method: "POST",
    params,
  });
};

export const getSucceedDietMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof succeedDiet>>,
    TError,
    { id: number; params: SucceedDietParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof succeedDiet>>,
  TError,
  { id: number; params: SucceedDietParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof succeedDiet>>,
    { id: number; params: SucceedDietParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return succeedDiet(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SucceedDietMutationResult = NonNullable<
  Awaited<ReturnType<typeof succeedDiet>>
>;

export type SucceedDietMutationError = ErrorType<HttpError>;

export const useSucceedDiet = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof succeedDiet>>,
    TError,
    { id: number; params: SucceedDietParams },
    TContext
  >;
}) => {
  const mutationOptions = getSucceedDietMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listElectronicEarrings = (signal?: AbortSignal) => {
  return request<string[]>({
    url: `/earrings/electronic`,
    method: "GET",
    signal,
  });
};

export const getListElectronicEarringsQueryKey = () => {
  return [`/earrings/electronic`] as const;
};

export const getListElectronicEarringsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listElectronicEarrings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listElectronicEarrings>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListElectronicEarringsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listElectronicEarrings>>
  > = ({ signal }) => listElectronicEarrings(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listElectronicEarrings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListElectronicEarringsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listElectronicEarrings>>
>;
export type ListElectronicEarringsInfiniteQueryError = ErrorType<unknown>;

export const useListElectronicEarringsInfinite = <
  TData = Awaited<ReturnType<typeof listElectronicEarrings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listElectronicEarrings>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListElectronicEarringsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListElectronicEarringsQueryOptions = <
  TData = Awaited<ReturnType<typeof listElectronicEarrings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listElectronicEarrings>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListElectronicEarringsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listElectronicEarrings>>
  > = ({ signal }) => listElectronicEarrings(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listElectronicEarrings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListElectronicEarringsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listElectronicEarrings>>
>;
export type ListElectronicEarringsQueryError = ErrorType<unknown>;

export const useListElectronicEarrings = <
  TData = Awaited<ReturnType<typeof listElectronicEarrings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listElectronicEarrings>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListElectronicEarringsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const registerEarrings = (params: RegisterEarringsParams) => {
  return request<number[]>({
    url: `/earrings/register`,
    method: "PUT",
    params,
  });
};

export const getRegisterEarringsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerEarrings>>,
    TError,
    { params: RegisterEarringsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerEarrings>>,
  TError,
  { params: RegisterEarringsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerEarrings>>,
    { params: RegisterEarringsParams }
  > = (props) => {
    const { params } = props ?? {};

    return registerEarrings(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterEarringsMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerEarrings>>
>;

export type RegisterEarringsMutationError = ErrorType<HttpError>;

export const useRegisterEarrings = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerEarrings>>,
    TError,
    { params: RegisterEarringsParams },
    TContext
  >;
}) => {
  const mutationOptions = getRegisterEarringsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEarring = (sisbov: number, signal?: AbortSignal) => {
  return request<GetEarringResponse>({
    url: `/earrings/${sisbov}`,
    method: "GET",
    signal,
  });
};

export const getGetEarringQueryKey = (sisbov: number) => {
  return [`/earrings/${sisbov}`] as const;
};

export const getGetEarringInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getEarring>>,
  TError = ErrorType<HttpError>,
>(
  sisbov: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEarring>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEarringQueryKey(sisbov);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEarring>>> = ({
    signal,
  }) => getEarring(sisbov, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!sisbov,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEarring>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEarringInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEarring>>
>;
export type GetEarringInfiniteQueryError = ErrorType<HttpError>;

export const useGetEarringInfinite = <
  TData = Awaited<ReturnType<typeof getEarring>>,
  TError = ErrorType<HttpError>,
>(
  sisbov: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEarring>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEarringInfiniteQueryOptions(sisbov, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetEarringQueryOptions = <
  TData = Awaited<ReturnType<typeof getEarring>>,
  TError = ErrorType<HttpError>,
>(
  sisbov: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEarring>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEarringQueryKey(sisbov);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEarring>>> = ({
    signal,
  }) => getEarring(sisbov, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!sisbov,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEarring>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEarringQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEarring>>
>;
export type GetEarringQueryError = ErrorType<HttpError>;

export const useGetEarring = <
  TData = Awaited<ReturnType<typeof getEarring>>,
  TError = ErrorType<HttpError>,
>(
  sisbov: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEarring>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEarringQueryOptions(sisbov, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * (Re)envia o código de confirmação de e-mail de uma conta ainda não verificada. A resposta é sempre a mesma.
 */
export const requestEmailVerification = (
  requestEmailVerificationBody: RequestEmailVerificationBody,
) => {
  return request<RequestEmailVerificationResponse>({
    url: `/email-verification`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requestEmailVerificationBody,
  });
};

export const getRequestEmailVerificationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestEmailVerification>>,
    TError,
    { data: RequestEmailVerificationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestEmailVerification>>,
  TError,
  { data: RequestEmailVerificationBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestEmailVerification>>,
    { data: RequestEmailVerificationBody }
  > = (props) => {
    const { data } = props ?? {};

    return requestEmailVerification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestEmailVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestEmailVerification>>
>;
export type RequestEmailVerificationMutationBody = RequestEmailVerificationBody;
export type RequestEmailVerificationMutationError = ErrorType<HttpError>;

export const useRequestEmailVerification = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestEmailVerification>>,
    TError,
    { data: RequestEmailVerificationBody },
    TContext
  >;
}) => {
  const mutationOptions = getRequestEmailVerificationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Confirma o e-mail com o código recebido. Se válido, o código é removido e o login da conta é liberado.
 */
export const verifyEmail = (verifyEmailBody: VerifyEmailBody) => {
  return request<boolean>({
    url: `/email-verification/verify`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: verifyEmailBody,
  });
};

export const getVerifyEmailMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    { data: VerifyEmailBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyEmail>>,
  TError,
  { data: VerifyEmailBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyEmail>>,
    { data: VerifyEmailBody }
  > = (props) => {
    const { data } = props ?? {};

    return verifyEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyEmail>>
>;
export type VerifyEmailMutationBody = VerifyEmailBody;
export type VerifyEmailMutationError = ErrorType<HttpError>;

export const useVerifyEmail = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    { data: VerifyEmailBody },
    TContext
  >;
}) => {
  const mutationOptions = getVerifyEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listEstablishments = (
  params?: ListEstablishmentsParams,
  signal?: AbortSignal,
) => {
  return request<ListEstablishmentsResponse>({
    url: `/establishments`,
    method: "GET",
    params,
    signal,
  });
};

export const getListEstablishmentsQueryKey = (
  params?: ListEstablishmentsParams,
) => {
  return [`/establishments`, ...(params ? [params] : [])] as const;
};

export const getListEstablishmentsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listEstablishments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEstablishmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listEstablishments>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEstablishmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEstablishments>>
  > = ({ signal }) => listEstablishments(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEstablishments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEstablishmentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEstablishments>>
>;
export type ListEstablishmentsInfiniteQueryError = ErrorType<unknown>;

export const useListEstablishmentsInfinite = <
  TData = Awaited<ReturnType<typeof listEstablishments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEstablishmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listEstablishments>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListEstablishmentsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListEstablishmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEstablishments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEstablishmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEstablishments>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEstablishmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEstablishments>>
  > = ({ signal }) => listEstablishments(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEstablishments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEstablishmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEstablishments>>
>;
export type ListEstablishmentsQueryError = ErrorType<unknown>;

export const useListEstablishments = <
  TData = Awaited<ReturnType<typeof listEstablishments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEstablishmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEstablishments>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListEstablishmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createEstablishment = (
  createEstablishment: CreateEstablishment,
) => {
  return request<CreateEstablishmentResponse>({
    url: `/establishments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEstablishment,
  });
};

export const getCreateEstablishmentMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEstablishment>>,
    TError,
    { data: CreateEstablishment },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEstablishment>>,
  TError,
  { data: CreateEstablishment },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEstablishment>>,
    { data: CreateEstablishment }
  > = (props) => {
    const { data } = props ?? {};

    return createEstablishment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEstablishmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEstablishment>>
>;
export type CreateEstablishmentMutationBody = CreateEstablishment;
export type CreateEstablishmentMutationError = ErrorType<HttpError>;

export const useCreateEstablishment = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEstablishment>>,
    TError,
    { data: CreateEstablishment },
    TContext
  >;
}) => {
  const mutationOptions = getCreateEstablishmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEstablishmentById = (id: number, signal?: AbortSignal) => {
  return request<GetEstablishmentByIdResponse>({
    url: `/establishments/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetEstablishmentByIdQueryKey = (id: number) => {
  return [`/establishments/${id}`] as const;
};

export const getGetEstablishmentByIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getEstablishmentById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEstablishmentById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEstablishmentByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEstablishmentById>>
  > = ({ signal }) => getEstablishmentById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEstablishmentByIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEstablishmentById>>
>;
export type GetEstablishmentByIdInfiniteQueryError = ErrorType<unknown>;

export const useGetEstablishmentByIdInfinite = <
  TData = Awaited<ReturnType<typeof getEstablishmentById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEstablishmentById>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEstablishmentByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetEstablishmentByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEstablishmentById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEstablishmentById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEstablishmentByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEstablishmentById>>
  > = ({ signal }) => getEstablishmentById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEstablishmentById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEstablishmentByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEstablishmentById>>
>;
export type GetEstablishmentByIdQueryError = ErrorType<unknown>;

export const useGetEstablishmentById = <
  TData = Awaited<ReturnType<typeof getEstablishmentById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEstablishmentById>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEstablishmentByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateEstablishment = (
  id: number,
  updateEstablishment: UpdateEstablishment,
) => {
  return request<UpdateEstablishmentResponse>({
    url: `/establishments/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEstablishment,
  });
};

export const getUpdateEstablishmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEstablishment>>,
    TError,
    { id: number; data: UpdateEstablishment },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEstablishment>>,
  TError,
  { id: number; data: UpdateEstablishment },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEstablishment>>,
    { id: number; data: UpdateEstablishment }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEstablishment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEstablishmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEstablishment>>
>;
export type UpdateEstablishmentMutationBody = UpdateEstablishment;
export type UpdateEstablishmentMutationError = ErrorType<unknown>;

export const useUpdateEstablishment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEstablishment>>,
    TError,
    { id: number; data: UpdateEstablishment },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateEstablishmentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ativa ou desativa uma dieta para ser listada no frontend.
 */
export const activateEstablishment = (
  id: number,
  params: ActivateEstablishmentParams,
) => {
  return request<ActivateEstablishmentResponse>({
    url: `/establishments/${id}/activate`,
    method: "POST",
    params,
  });
};

export const getActivateEstablishmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateEstablishment>>,
    TError,
    { id: number; params: ActivateEstablishmentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateEstablishment>>,
  TError,
  { id: number; params: ActivateEstablishmentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateEstablishment>>,
    { id: number; params: ActivateEstablishmentParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return activateEstablishment(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateEstablishmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateEstablishment>>
>;

export type ActivateEstablishmentMutationError = ErrorType<unknown>;

export const useActivateEstablishment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateEstablishment>>,
    TError,
    { id: number; params: ActivateEstablishmentParams },
    TContext
  >;
}) => {
  const mutationOptions = getActivateEstablishmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listExitTrucks = (
  params?: ListExitTrucksParams,
  signal?: AbortSignal,
) => {
  return request<ListExitTrucksResponse>({
    url: `/exit-trucks`,
    method: "GET",
    params,
    signal,
  });
};

export const getListExitTrucksQueryKey = (params?: ListExitTrucksParams) => {
  return [`/exit-trucks`, ...(params ? [params] : [])] as const;
};

export const getListExitTrucksInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listExitTrucks>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListExitTrucksParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listExitTrucks>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExitTrucksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExitTrucks>>> = ({
    signal,
  }) => listExitTrucks(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listExitTrucks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExitTrucksInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExitTrucks>>
>;
export type ListExitTrucksInfiniteQueryError = ErrorType<HttpError>;

export const useListExitTrucksInfinite = <
  TData = Awaited<ReturnType<typeof listExitTrucks>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListExitTrucksParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listExitTrucks>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListExitTrucksInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListExitTrucksQueryOptions = <
  TData = Awaited<ReturnType<typeof listExitTrucks>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListExitTrucksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExitTrucks>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExitTrucksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExitTrucks>>> = ({
    signal,
  }) => listExitTrucks(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listExitTrucks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExitTrucksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExitTrucks>>
>;
export type ListExitTrucksQueryError = ErrorType<HttpError>;

export const useListExitTrucks = <
  TData = Awaited<ReturnType<typeof listExitTrucks>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListExitTrucksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExitTrucks>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListExitTrucksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createTruck = (createTruck: CreateTruck) => {
  return request<CreateTruckResponse>({
    url: `/exit-trucks`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTruck,
  });
};

export const getCreateTruckMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTruck>>,
    TError,
    { data: CreateTruck },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTruck>>,
  TError,
  { data: CreateTruck },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTruck>>,
    { data: CreateTruck }
  > = (props) => {
    const { data } = props ?? {};

    return createTruck(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTruckMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTruck>>
>;
export type CreateTruckMutationBody = CreateTruck;
export type CreateTruckMutationError = ErrorType<HttpError>;

export const useCreateTruck = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTruck>>,
    TError,
    { data: CreateTruck },
    TContext
  >;
}) => {
  const mutationOptions = getCreateTruckMutationOptions(options);

  return useMutation(mutationOptions);
};

export const findExitGtas = (findExitGtasBody: FindExitGtasBody) => {
  return request<boolean>({
    url: `/exit-trucks/find-exit-gta`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: findExitGtasBody,
  });
};

export const getFindExitGtasMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findExitGtas>>,
    TError,
    { data: FindExitGtasBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof findExitGtas>>,
  TError,
  { data: FindExitGtasBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof findExitGtas>>,
    { data: FindExitGtasBody }
  > = (props) => {
    const { data } = props ?? {};

    return findExitGtas(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FindExitGtasMutationResult = NonNullable<
  Awaited<ReturnType<typeof findExitGtas>>
>;
export type FindExitGtasMutationBody = FindExitGtasBody;
export type FindExitGtasMutationError = ErrorType<HttpError>;

export const useFindExitGtas = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findExitGtas>>,
    TError,
    { data: FindExitGtasBody },
    TContext
  >;
}) => {
  const mutationOptions = getFindExitGtasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getExitTruck = (id: number, signal?: AbortSignal) => {
  return request<GetExitTruckResponse>({
    url: `/exit-trucks/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetExitTruckQueryKey = (id: number) => {
  return [`/exit-trucks/${id}`] as const;
};

export const getGetExitTruckInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getExitTruck>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getExitTruck>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExitTruckQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExitTruck>>> = ({
    signal,
  }) => getExitTruck(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getExitTruck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExitTruckInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExitTruck>>
>;
export type GetExitTruckInfiniteQueryError = ErrorType<unknown>;

export const useGetExitTruckInfinite = <
  TData = Awaited<ReturnType<typeof getExitTruck>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getExitTruck>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetExitTruckInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetExitTruckQueryOptions = <
  TData = Awaited<ReturnType<typeof getExitTruck>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExitTruck>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExitTruckQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExitTruck>>> = ({
    signal,
  }) => getExitTruck(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExitTruck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExitTruckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExitTruck>>
>;
export type GetExitTruckQueryError = ErrorType<unknown>;

export const useGetExitTruck = <
  TData = Awaited<ReturnType<typeof getExitTruck>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExitTruck>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetExitTruckQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateExitTruck = (id: number, updateTruck: UpdateTruck) => {
  return request<UpdateExitTruckResponse>({
    url: `/exit-trucks/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateTruck,
  });
};

export const getUpdateExitTruckMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExitTruck>>,
    TError,
    { id: number; data: UpdateTruck },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExitTruck>>,
  TError,
  { id: number; data: UpdateTruck },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExitTruck>>,
    { id: number; data: UpdateTruck }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateExitTruck(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExitTruckMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExitTruck>>
>;
export type UpdateExitTruckMutationBody = UpdateTruck;
export type UpdateExitTruckMutationError = ErrorType<HttpError>;

export const useUpdateExitTruck = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExitTruck>>,
    TError,
    { id: number; data: UpdateTruck },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateExitTruckMutationOptions(options);

  return useMutation(mutationOptions);
};

export const boardOx = (id: number, boardOx: BoardOx) => {
  return request<BoardOxResponse>({
    url: `/exit-trucks/${id}/board`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: boardOx,
  });
};

export const getBoardOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof boardOx>>,
    TError,
    { id: number; data: BoardOx },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof boardOx>>,
  TError,
  { id: number; data: BoardOx },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof boardOx>>,
    { id: number; data: BoardOx }
  > = (props) => {
    const { id, data } = props ?? {};

    return boardOx(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BoardOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof boardOx>>
>;
export type BoardOxMutationBody = BoardOx;
export type BoardOxMutationError = ErrorType<HttpError>;

export const useBoardOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof boardOx>>,
    TError,
    { id: number; data: BoardOx },
    TContext
  >;
}) => {
  const mutationOptions = getBoardOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTuckDetails = (id: number, signal?: AbortSignal) => {
  return request<GetTuckDetailsResponse>({
    url: `/exit-trucks/${id}/details`,
    method: "GET",
    signal,
  });
};

export const getGetTuckDetailsQueryKey = (id: number) => {
  return [`/exit-trucks/${id}/details`] as const;
};

export const getGetTuckDetailsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTuckDetails>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTuckDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTuckDetailsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTuckDetails>>> = ({
    signal,
  }) => getTuckDetails(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTuckDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTuckDetailsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTuckDetails>>
>;
export type GetTuckDetailsInfiniteQueryError = ErrorType<unknown>;

export const useGetTuckDetailsInfinite = <
  TData = Awaited<ReturnType<typeof getTuckDetails>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTuckDetails>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTuckDetailsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTuckDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTuckDetails>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTuckDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTuckDetailsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTuckDetails>>> = ({
    signal,
  }) => getTuckDetails(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTuckDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTuckDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTuckDetails>>
>;
export type GetTuckDetailsQueryError = ErrorType<unknown>;

export const useGetTuckDetails = <
  TData = Awaited<ReturnType<typeof getTuckDetails>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTuckDetails>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTuckDetailsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const upsertTruckInvoices = (
  id: number,
  createOrUpdateInvoices: CreateOrUpdateInvoices[],
) => {
  return request<UpsertTruckInvoicesResponse>({
    url: `/exit-trucks/${id}/invoices`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: createOrUpdateInvoices,
  });
};

export const getUpsertTruckInvoicesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTruckInvoices>>,
    TError,
    { id: number; data: CreateOrUpdateInvoices[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertTruckInvoices>>,
  TError,
  { id: number; data: CreateOrUpdateInvoices[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertTruckInvoices>>,
    { id: number; data: CreateOrUpdateInvoices[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return upsertTruckInvoices(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertTruckInvoicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertTruckInvoices>>
>;
export type UpsertTruckInvoicesMutationBody = CreateOrUpdateInvoices[];
export type UpsertTruckInvoicesMutationError = ErrorType<unknown>;

export const useUpsertTruckInvoices = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTruckInvoices>>,
    TError,
    { id: number; data: CreateOrUpdateInvoices[] },
    TContext
  >;
}) => {
  const mutationOptions = getUpsertTruckInvoicesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createFarmCredential = (
  createFarmCredential: CreateFarmCredential,
) => {
  return request<CreateFarmCredentialResponse>({
    url: `/farm-credentials`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFarmCredential,
  });
};

export const getCreateFarmCredentialMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFarmCredential>>,
    TError,
    { data: CreateFarmCredential },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFarmCredential>>,
  TError,
  { data: CreateFarmCredential },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFarmCredential>>,
    { data: CreateFarmCredential }
  > = (props) => {
    const { data } = props ?? {};

    return createFarmCredential(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFarmCredentialMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFarmCredential>>
>;
export type CreateFarmCredentialMutationBody = CreateFarmCredential;
export type CreateFarmCredentialMutationError = ErrorType<HttpError>;

export const useCreateFarmCredential = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFarmCredential>>,
    TError,
    { data: CreateFarmCredential },
    TContext
  >;
}) => {
  const mutationOptions = getCreateFarmCredentialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const lookupFarmCredential = (
  params: LookupFarmCredentialParams,
  signal?: AbortSignal,
) => {
  return request<LookupFarmCredentialResponse>({
    url: `/farm-credentials/lookup`,
    method: "GET",
    params,
    signal,
  });
};

export const getLookupFarmCredentialQueryKey = (
  params: LookupFarmCredentialParams,
) => {
  return [`/farm-credentials/lookup`, ...(params ? [params] : [])] as const;
};

export const getLookupFarmCredentialInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupFarmCredential>>,
  TError = ErrorType<HttpError>,
>(
  params: LookupFarmCredentialParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof lookupFarmCredential>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupFarmCredentialQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupFarmCredential>>
  > = ({ signal }) => lookupFarmCredential(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof lookupFarmCredential>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LookupFarmCredentialInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupFarmCredential>>
>;
export type LookupFarmCredentialInfiniteQueryError = ErrorType<HttpError>;

export const useLookupFarmCredentialInfinite = <
  TData = Awaited<ReturnType<typeof lookupFarmCredential>>,
  TError = ErrorType<HttpError>,
>(
  params: LookupFarmCredentialParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof lookupFarmCredential>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getLookupFarmCredentialInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getLookupFarmCredentialQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupFarmCredential>>,
  TError = ErrorType<HttpError>,
>(
  params: LookupFarmCredentialParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupFarmCredential>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupFarmCredentialQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupFarmCredential>>
  > = ({ signal }) => lookupFarmCredential(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupFarmCredential>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LookupFarmCredentialQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupFarmCredential>>
>;
export type LookupFarmCredentialQueryError = ErrorType<HttpError>;

export const useLookupFarmCredential = <
  TData = Awaited<ReturnType<typeof lookupFarmCredential>>,
  TError = ErrorType<HttpError>,
>(
  params: LookupFarmCredentialParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupFarmCredential>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getLookupFarmCredentialQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCurrentFarm = (signal?: AbortSignal) => {
  return request<GetCurrentFarmResponse>({
    url: `/farms`,
    method: "GET",
    signal,
  });
};

export const getGetCurrentFarmQueryKey = () => {
  return [`/farms`] as const;
};

export const getGetCurrentFarmInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentFarm>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCurrentFarm>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentFarmQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentFarm>>> = ({
    signal,
  }) => getCurrentFarm(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCurrentFarm>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentFarmInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentFarm>>
>;
export type GetCurrentFarmInfiniteQueryError = ErrorType<unknown>;

export const useGetCurrentFarmInfinite = <
  TData = Awaited<ReturnType<typeof getCurrentFarm>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCurrentFarm>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCurrentFarmInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetCurrentFarmQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentFarm>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentFarm>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentFarmQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentFarm>>> = ({
    signal,
  }) => getCurrentFarm(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentFarm>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentFarmQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentFarm>>
>;
export type GetCurrentFarmQueryError = ErrorType<unknown>;

export const useGetCurrentFarm = <
  TData = Awaited<ReturnType<typeof getCurrentFarm>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentFarm>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCurrentFarmQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createFarm = (createFarm: CreateFarm) => {
  return request<CreateFarmResponse>({
    url: `/farms`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFarm,
  });
};

export const getCreateFarmMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFarm>>,
    TError,
    { data: CreateFarm },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFarm>>,
  TError,
  { data: CreateFarm },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFarm>>,
    { data: CreateFarm }
  > = (props) => {
    const { data } = props ?? {};

    return createFarm(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFarmMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFarm>>
>;
export type CreateFarmMutationBody = CreateFarm;
export type CreateFarmMutationError = ErrorType<HttpError>;

export const useCreateFarm = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFarm>>,
    TError,
    { data: CreateFarm },
    TContext
  >;
}) => {
  const mutationOptions = getCreateFarmMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateFarm = (updateFarm: UpdateFarm) => {
  return request<UpdateFarmResponse>({
    url: `/farms`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateFarm,
  });
};

export const getUpdateFarmMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFarm>>,
    TError,
    { data: UpdateFarm },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFarm>>,
  TError,
  { data: UpdateFarm },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFarm>>,
    { data: UpdateFarm }
  > = (props) => {
    const { data } = props ?? {};

    return updateFarm(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFarmMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFarm>>
>;
export type UpdateFarmMutationBody = UpdateFarm;
export type UpdateFarmMutationError = ErrorType<unknown>;

export const useUpdateFarm = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFarm>>,
    TError,
    { data: UpdateFarm },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateFarmMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateFarmConfig = (updateFarmConfig: UpdateFarmConfig) => {
  return request<UpdateFarmConfigResponse>({
    url: `/farms/config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateFarmConfig,
  });
};

export const getUpdateFarmConfigMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFarmConfig>>,
    TError,
    { data: UpdateFarmConfig },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFarmConfig>>,
  TError,
  { data: UpdateFarmConfig },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFarmConfig>>,
    { data: UpdateFarmConfig }
  > = (props) => {
    const { data } = props ?? {};

    return updateFarmConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFarmConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFarmConfig>>
>;
export type UpdateFarmConfigMutationBody = UpdateFarmConfig;
export type UpdateFarmConfigMutationError = ErrorType<HttpError>;

export const useUpdateFarmConfig = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFarmConfig>>,
    TError,
    { data: UpdateFarmConfig },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateFarmConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const feedLinkConfig = (signal?: AbortSignal) => {
  return request<FeedLinkConfigResponse>({
    url: `/farms/config-feed-link`,
    method: "GET",
    signal,
  });
};

export const getFeedLinkConfigQueryKey = () => {
  return [`/farms/config-feed-link`] as const;
};

export const getFeedLinkConfigInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof feedLinkConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof feedLinkConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeedLinkConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof feedLinkConfig>>> = ({
    signal,
  }) => feedLinkConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof feedLinkConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FeedLinkConfigInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof feedLinkConfig>>
>;
export type FeedLinkConfigInfiniteQueryError = ErrorType<unknown>;

export const useFeedLinkConfigInfinite = <
  TData = Awaited<ReturnType<typeof feedLinkConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof feedLinkConfig>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFeedLinkConfigInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFeedLinkConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof feedLinkConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof feedLinkConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeedLinkConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof feedLinkConfig>>> = ({
    signal,
  }) => feedLinkConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof feedLinkConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FeedLinkConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof feedLinkConfig>>
>;
export type FeedLinkConfigQueryError = ErrorType<unknown>;

export const useFeedLinkConfig = <
  TData = Awaited<ReturnType<typeof feedLinkConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof feedLinkConfig>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFeedLinkConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateFeedLinkConfig = (
  updateFeedLinkConfigBody: UpdateFeedLinkConfigBody,
) => {
  return request<UpdateFeedLinkConfigResponse>({
    url: `/farms/config-feed-link`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateFeedLinkConfigBody,
  });
};

export const getUpdateFeedLinkConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedLinkConfig>>,
    TError,
    { data: UpdateFeedLinkConfigBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFeedLinkConfig>>,
  TError,
  { data: UpdateFeedLinkConfigBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFeedLinkConfig>>,
    { data: UpdateFeedLinkConfigBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateFeedLinkConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFeedLinkConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFeedLinkConfig>>
>;
export type UpdateFeedLinkConfigMutationBody = UpdateFeedLinkConfigBody;
export type UpdateFeedLinkConfigMutationError = ErrorType<unknown>;

export const useUpdateFeedLinkConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedLinkConfig>>,
    TError,
    { data: UpdateFeedLinkConfigBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateFeedLinkConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFarmDays = (signal?: AbortSignal) => {
  return request<GetFarmDaysResponse>({
    url: `/farms/day`,
    method: "GET",
    signal,
  });
};

export const getGetFarmDaysQueryKey = () => {
  return [`/farms/day`] as const;
};

export const getGetFarmDaysInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFarmDays>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFarmDays>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFarmDaysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFarmDays>>> = ({
    signal,
  }) => getFarmDays(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFarmDays>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFarmDaysInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFarmDays>>
>;
export type GetFarmDaysInfiniteQueryError = ErrorType<unknown>;

export const useGetFarmDaysInfinite = <
  TData = Awaited<ReturnType<typeof getFarmDays>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFarmDays>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFarmDaysInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFarmDaysQueryOptions = <
  TData = Awaited<ReturnType<typeof getFarmDays>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFarmDays>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFarmDaysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFarmDays>>> = ({
    signal,
  }) => getFarmDays(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFarmDays>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFarmDaysQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFarmDays>>
>;
export type GetFarmDaysQueryError = ErrorType<unknown>;

export const useGetFarmDays = <
  TData = Awaited<ReturnType<typeof getFarmDays>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFarmDays>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFarmDaysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const canAdvanceFarmDay = (signal?: AbortSignal) => {
  return request<CanAdvanceFarmDayResponse>({
    url: `/farms/day/advance`,
    method: "GET",
    signal,
  });
};

export const getCanAdvanceFarmDayQueryKey = () => {
  return [`/farms/day/advance`] as const;
};

export const getCanAdvanceFarmDayInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof canAdvanceFarmDay>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCanAdvanceFarmDayQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>
  > = ({ signal }) => canAdvanceFarmDay(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CanAdvanceFarmDayInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof canAdvanceFarmDay>>
>;
export type CanAdvanceFarmDayInfiniteQueryError = ErrorType<unknown>;

export const useCanAdvanceFarmDayInfinite = <
  TData = Awaited<ReturnType<typeof canAdvanceFarmDay>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCanAdvanceFarmDayInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCanAdvanceFarmDayQueryOptions = <
  TData = Awaited<ReturnType<typeof canAdvanceFarmDay>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCanAdvanceFarmDayQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>
  > = ({ signal }) => canAdvanceFarmDay(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CanAdvanceFarmDayQueryResult = NonNullable<
  Awaited<ReturnType<typeof canAdvanceFarmDay>>
>;
export type CanAdvanceFarmDayQueryError = ErrorType<unknown>;

export const useCanAdvanceFarmDay = <
  TData = Awaited<ReturnType<typeof canAdvanceFarmDay>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof canAdvanceFarmDay>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCanAdvanceFarmDayQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const advanceFarmDay = () => {
  return request<string>({ url: `/farms/day/advance`, method: "POST" });
};

export const getAdvanceFarmDayMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof advanceFarmDay>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof advanceFarmDay>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof advanceFarmDay>>,
    void
  > = () => {
    return advanceFarmDay();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdvanceFarmDayMutationResult = NonNullable<
  Awaited<ReturnType<typeof advanceFarmDay>>
>;

export type AdvanceFarmDayMutationError = ErrorType<HttpError>;

export const useAdvanceFarmDay = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof advanceFarmDay>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getAdvanceFarmDayMutationOptions(options);

  return useMutation(mutationOptions);
};

export const factoryEdit = (factoryEdit: FactoryEdit) => {
  return request<boolean>({
    url: `/farms/factory-edit`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: factoryEdit,
  });
};

export const getFactoryEditMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof factoryEdit>>,
    TError,
    { data: FactoryEdit },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof factoryEdit>>,
  TError,
  { data: FactoryEdit },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof factoryEdit>>,
    { data: FactoryEdit }
  > = (props) => {
    const { data } = props ?? {};

    return factoryEdit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FactoryEditMutationResult = NonNullable<
  Awaited<ReturnType<typeof factoryEdit>>
>;
export type FactoryEditMutationBody = FactoryEdit;
export type FactoryEditMutationError = ErrorType<HttpError>;

export const useFactoryEdit = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof factoryEdit>>,
    TError,
    { data: FactoryEdit },
    TContext
  >;
}) => {
  const mutationOptions = getFactoryEditMutationOptions(options);

  return useMutation(mutationOptions);
};

export const findSapId = (findSapId: FindSapId) => {
  return request<FindSapIdResponse>({
    url: `/farms/find`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: findSapId,
  });
};

export const getFindSapIdMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findSapId>>,
    TError,
    { data: FindSapId },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof findSapId>>,
  TError,
  { data: FindSapId },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof findSapId>>,
    { data: FindSapId }
  > = (props) => {
    const { data } = props ?? {};

    return findSapId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FindSapIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof findSapId>>
>;
export type FindSapIdMutationBody = FindSapId;
export type FindSapIdMutationError = ErrorType<HttpError>;

export const useFindSapId = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findSapId>>,
    TError,
    { data: FindSapId },
    TContext
  >;
}) => {
  const mutationOptions = getFindSapIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateFarmStartDate = (
  updateFarmStartDateBody: UpdateFarmStartDateBody,
) => {
  return request<UpdateFarmStartDateResponse>({
    url: `/farms/start-date`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateFarmStartDateBody,
  });
};

export const getUpdateFarmStartDateMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFarmStartDate>>,
    TError,
    { data: UpdateFarmStartDateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFarmStartDate>>,
  TError,
  { data: UpdateFarmStartDateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFarmStartDate>>,
    { data: UpdateFarmStartDateBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateFarmStartDate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFarmStartDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFarmStartDate>>
>;
export type UpdateFarmStartDateMutationBody = UpdateFarmStartDateBody;
export type UpdateFarmStartDateMutationError = ErrorType<HttpError>;

export const useUpdateFarmStartDate = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFarmStartDate>>,
    TError,
    { data: UpdateFarmStartDateBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateFarmStartDateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTreatViewType = (signal?: AbortSignal) => {
  return request<GetTreatViewTypeResponse>({
    url: `/farms/treat-view-type`,
    method: "GET",
    signal,
  });
};

export const getGetTreatViewTypeQueryKey = () => {
  return [`/farms/treat-view-type`] as const;
};

export const getGetTreatViewTypeInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatViewType>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTreatViewType>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTreatViewTypeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTreatViewType>>
  > = ({ signal }) => getTreatViewType(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTreatViewType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTreatViewTypeInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatViewType>>
>;
export type GetTreatViewTypeInfiniteQueryError = ErrorType<unknown>;

export const useGetTreatViewTypeInfinite = <
  TData = Awaited<ReturnType<typeof getTreatViewType>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTreatViewType>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTreatViewTypeInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTreatViewTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatViewType>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTreatViewType>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTreatViewTypeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTreatViewType>>
  > = ({ signal }) => getTreatViewType(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTreatViewType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTreatViewTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatViewType>>
>;
export type GetTreatViewTypeQueryError = ErrorType<unknown>;

export const useGetTreatViewType = <
  TData = Awaited<ReturnType<typeof getTreatViewType>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTreatViewType>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTreatViewTypeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateTreatViewType = (
  updateTreatViewTypeBody: UpdateTreatViewTypeBody,
) => {
  return request<UpdateTreatViewTypeResponse>({
    url: `/farms/treat-view-type`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateTreatViewTypeBody,
  });
};

export const getUpdateTreatViewTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreatViewType>>,
    TError,
    { data: UpdateTreatViewTypeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTreatViewType>>,
  TError,
  { data: UpdateTreatViewTypeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTreatViewType>>,
    { data: UpdateTreatViewTypeBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateTreatViewType(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTreatViewTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTreatViewType>>
>;
export type UpdateTreatViewTypeMutationBody = UpdateTreatViewTypeBody;
export type UpdateTreatViewTypeMutationError = ErrorType<unknown>;

export const useUpdateTreatViewType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreatViewType>>,
    TError,
    { data: UpdateTreatViewTypeBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateTreatViewTypeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWeightBreakGoals = (signal?: AbortSignal) => {
  return request<GetWeightBreakGoalsResponse>({
    url: `/farms/weight-break`,
    method: "GET",
    signal,
  });
};

export const getGetWeightBreakGoalsQueryKey = () => {
  return [`/farms/weight-break`] as const;
};

export const getGetWeightBreakGoalsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightBreakGoals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightBreakGoals>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWeightBreakGoalsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWeightBreakGoals>>
  > = ({ signal }) => getWeightBreakGoals(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightBreakGoals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightBreakGoalsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightBreakGoals>>
>;
export type GetWeightBreakGoalsInfiniteQueryError = ErrorType<unknown>;

export const useGetWeightBreakGoalsInfinite = <
  TData = Awaited<ReturnType<typeof getWeightBreakGoals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightBreakGoals>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightBreakGoalsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetWeightBreakGoalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightBreakGoals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWeightBreakGoals>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWeightBreakGoalsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWeightBreakGoals>>
  > = ({ signal }) => getWeightBreakGoals(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWeightBreakGoals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightBreakGoalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightBreakGoals>>
>;
export type GetWeightBreakGoalsQueryError = ErrorType<unknown>;

export const useGetWeightBreakGoals = <
  TData = Awaited<ReturnType<typeof getWeightBreakGoals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWeightBreakGoals>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightBreakGoalsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateWeightBreakGoals = (
  params: UpdateWeightBreakGoalsParams,
) => {
  return request<boolean>({
    url: `/farms/weight-break`,
    method: "POST",
    params,
  });
};

export const getUpdateWeightBreakGoalsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWeightBreakGoals>>,
    TError,
    { params: UpdateWeightBreakGoalsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWeightBreakGoals>>,
  TError,
  { params: UpdateWeightBreakGoalsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWeightBreakGoals>>,
    { params: UpdateWeightBreakGoalsParams }
  > = (props) => {
    const { params } = props ?? {};

    return updateWeightBreakGoals(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWeightBreakGoalsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWeightBreakGoals>>
>;

export type UpdateWeightBreakGoalsMutationError = ErrorType<HttpError>;

export const useUpdateWeightBreakGoals = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWeightBreakGoals>>,
    TError,
    { params: UpdateWeightBreakGoalsParams },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateWeightBreakGoalsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateBiotypeWeightGainCurve = (
  params: UpdateBiotypeWeightGainCurveParams,
) => {
  return request<boolean>({
    url: `/farms/weight-gain`,
    method: "POST",
    params,
  });
};

export const getUpdateBiotypeWeightGainCurveMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBiotypeWeightGainCurve>>,
    TError,
    { params: UpdateBiotypeWeightGainCurveParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBiotypeWeightGainCurve>>,
  TError,
  { params: UpdateBiotypeWeightGainCurveParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBiotypeWeightGainCurve>>,
    { params: UpdateBiotypeWeightGainCurveParams }
  > = (props) => {
    const { params } = props ?? {};

    return updateBiotypeWeightGainCurve(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBiotypeWeightGainCurveMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBiotypeWeightGainCurve>>
>;

export type UpdateBiotypeWeightGainCurveMutationError = ErrorType<HttpError>;

export const useUpdateBiotypeWeightGainCurve = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBiotypeWeightGainCurve>>,
    TError,
    { params: UpdateBiotypeWeightGainCurveParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateBiotypeWeightGainCurveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createBatchWeightGainCurve = (
  params: CreateBatchWeightGainCurveParams,
) => {
  return request<BatchWeightGainCurve>({
    url: `/farms/weight-gain/batch`,
    method: "POST",
    params,
  });
};

export const getCreateBatchWeightGainCurveMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatchWeightGainCurve>>,
    TError,
    { params: CreateBatchWeightGainCurveParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBatchWeightGainCurve>>,
  TError,
  { params: CreateBatchWeightGainCurveParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBatchWeightGainCurve>>,
    { params: CreateBatchWeightGainCurveParams }
  > = (props) => {
    const { params } = props ?? {};

    return createBatchWeightGainCurve(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBatchWeightGainCurveMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBatchWeightGainCurve>>
>;

export type CreateBatchWeightGainCurveMutationError = ErrorType<HttpError>;

export const useCreateBatchWeightGainCurve = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatchWeightGainCurve>>,
    TError,
    { params: CreateBatchWeightGainCurveParams },
    TContext
  >;
}) => {
  const mutationOptions = getCreateBatchWeightGainCurveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listWeightGainCurves = (
  params?: ListWeightGainCurvesParams,
  signal?: AbortSignal,
) => {
  return request<ListWeightGainCurvesResponse>({
    url: `/farms/weight-gain/list`,
    method: "GET",
    params,
    signal,
  });
};

export const getListWeightGainCurvesQueryKey = (
  params?: ListWeightGainCurvesParams,
) => {
  return [`/farms/weight-gain/list`, ...(params ? [params] : [])] as const;
};

export const getListWeightGainCurvesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listWeightGainCurves>>,
  TError = ErrorType<unknown>,
>(
  params?: ListWeightGainCurvesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listWeightGainCurves>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWeightGainCurvesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWeightGainCurves>>
  > = ({ signal }) => listWeightGainCurves(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listWeightGainCurves>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWeightGainCurvesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWeightGainCurves>>
>;
export type ListWeightGainCurvesInfiniteQueryError = ErrorType<unknown>;

export const useListWeightGainCurvesInfinite = <
  TData = Awaited<ReturnType<typeof listWeightGainCurves>>,
  TError = ErrorType<unknown>,
>(
  params?: ListWeightGainCurvesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listWeightGainCurves>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListWeightGainCurvesInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListWeightGainCurvesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWeightGainCurves>>,
  TError = ErrorType<unknown>,
>(
  params?: ListWeightGainCurvesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWeightGainCurves>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWeightGainCurvesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWeightGainCurves>>
  > = ({ signal }) => listWeightGainCurves(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWeightGainCurves>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWeightGainCurvesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWeightGainCurves>>
>;
export type ListWeightGainCurvesQueryError = ErrorType<unknown>;

export const useListWeightGainCurves = <
  TData = Awaited<ReturnType<typeof listWeightGainCurves>>,
  TError = ErrorType<unknown>,
>(
  params?: ListWeightGainCurvesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWeightGainCurves>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListWeightGainCurvesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deleteWeightGainCurveById = (id: number) => {
  return request<boolean>({
    url: `/farms/weight-gain/${id}`,
    method: "DELETE",
  });
};

export const getDeleteWeightGainCurveByIdMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWeightGainCurveById>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWeightGainCurveById>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWeightGainCurveById>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteWeightGainCurveById(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWeightGainCurveByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWeightGainCurveById>>
>;

export type DeleteWeightGainCurveByIdMutationError = ErrorType<HttpError>;

export const useDeleteWeightGainCurveById = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWeightGainCurveById>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteWeightGainCurveByIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWeightGainCurveById = (id: number, signal?: AbortSignal) => {
  return request<GetWeightGainCurveByIdResponse>({
    url: `/farms/weight-gain/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetWeightGainCurveByIdQueryKey = (id: number) => {
  return [`/farms/weight-gain/${id}`] as const;
};

export const getGetWeightGainCurveByIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightGainCurveById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getWeightGainCurveById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWeightGainCurveByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWeightGainCurveById>>
  > = ({ signal }) => getWeightGainCurveById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightGainCurveById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightGainCurveByIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightGainCurveById>>
>;
export type GetWeightGainCurveByIdInfiniteQueryError = ErrorType<HttpError>;

export const useGetWeightGainCurveByIdInfinite = <
  TData = Awaited<ReturnType<typeof getWeightGainCurveById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getWeightGainCurveById>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightGainCurveByIdInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetWeightGainCurveByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightGainCurveById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWeightGainCurveById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWeightGainCurveByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWeightGainCurveById>>
  > = ({ signal }) => getWeightGainCurveById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWeightGainCurveById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightGainCurveByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightGainCurveById>>
>;
export type GetWeightGainCurveByIdQueryError = ErrorType<HttpError>;

export const useGetWeightGainCurveById = <
  TData = Awaited<ReturnType<typeof getWeightGainCurveById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWeightGainCurveById>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightGainCurveByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateWeightGainCurveStartedAt = (
  id: number,
  updateWeightGainCurveStartedAtBody: UpdateWeightGainCurveStartedAtBody,
) => {
  return request<boolean>({
    url: `/farms/weight-gain/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateWeightGainCurveStartedAtBody,
  });
};

export const getUpdateWeightGainCurveStartedAtMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWeightGainCurveStartedAt>>,
    TError,
    { id: number; data: UpdateWeightGainCurveStartedAtBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWeightGainCurveStartedAt>>,
  TError,
  { id: number; data: UpdateWeightGainCurveStartedAtBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWeightGainCurveStartedAt>>,
    { id: number; data: UpdateWeightGainCurveStartedAtBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWeightGainCurveStartedAt(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWeightGainCurveStartedAtMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWeightGainCurveStartedAt>>
>;
export type UpdateWeightGainCurveStartedAtMutationBody =
  UpdateWeightGainCurveStartedAtBody;
export type UpdateWeightGainCurveStartedAtMutationError = ErrorType<HttpError>;

export const useUpdateWeightGainCurveStartedAt = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWeightGainCurveStartedAt>>,
    TError,
    { id: number; data: UpdateWeightGainCurveStartedAtBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateWeightGainCurveStartedAtMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Fila do dia: só as linhas que ainda vão ser processadas. Sucesso e falha ficam com a v2, que é quem lista.
 */
export const getFeedLinkData = (signal?: AbortSignal) => {
  return request<GetFeedLinkDataResponse>({
    url: `/feed-link`,
    method: "GET",
    signal,
  });
};

export const getGetFeedLinkDataQueryKey = () => {
  return [`/feed-link`] as const;
};

export const getGetFeedLinkDataInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedLinkData>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkData>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedLinkDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedLinkData>>> = ({
    signal,
  }) => getFeedLinkData(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedLinkDataInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedLinkData>>
>;
export type GetFeedLinkDataInfiniteQueryError = ErrorType<HttpError>;

export const useGetFeedLinkDataInfinite = <
  TData = Awaited<ReturnType<typeof getFeedLinkData>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkData>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFeedLinkDataInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFeedLinkDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedLinkData>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkData>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedLinkDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedLinkData>>> = ({
    signal,
  }) => getFeedLinkData(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedLinkDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedLinkData>>
>;
export type GetFeedLinkDataQueryError = ErrorType<HttpError>;

export const useGetFeedLinkData = <
  TData = Awaited<ReturnType<typeof getFeedLinkData>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkData>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFeedLinkDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Arquivo com linhas de mais de um dia vira um registro por dia: o de hoje entra na fila, o de dia futuro espera na
fila do dia dele e o de dia passado fica aguardando revisão.
 */
export const createFeedLinkData = (
  createFeedLinkDataBody: CreateFeedLinkDataBody,
) => {
  return request<CreateFeedLinkDataResponse>({
    url: `/feed-link`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFeedLinkDataBody,
  });
};

export const getCreateFeedLinkDataMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeedLinkData>>,
    TError,
    { data: CreateFeedLinkDataBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFeedLinkData>>,
  TError,
  { data: CreateFeedLinkDataBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFeedLinkData>>,
    { data: CreateFeedLinkDataBody }
  > = (props) => {
    const { data } = props ?? {};

    return createFeedLinkData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeedLinkDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFeedLinkData>>
>;
export type CreateFeedLinkDataMutationBody = CreateFeedLinkDataBody;
export type CreateFeedLinkDataMutationError = ErrorType<HttpError>;

export const useCreateFeedLinkData = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeedLinkData>>,
    TError,
    { data: CreateFeedLinkDataBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateFeedLinkDataMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTreatmentHourByCorralPosition = (
  params: GetTreatmentHourByCorralPositionParams,
  signal?: AbortSignal,
) => {
  return request<string[][]>({
    url: `/feed-link/get-treatment-hour-by-corral-position`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTreatmentHourByCorralPositionQueryKey = (
  params: GetTreatmentHourByCorralPositionParams,
) => {
  return [
    `/feed-link/get-treatment-hour-by-corral-position`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTreatmentHourByCorralPositionInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatmentHourByCorralPositionParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTreatmentHourByCorralPositionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>
  > = ({ signal }) => getTreatmentHourByCorralPosition(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTreatmentHourByCorralPositionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>
>;
export type GetTreatmentHourByCorralPositionInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetTreatmentHourByCorralPositionInfinite = <
  TData = Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatmentHourByCorralPositionParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTreatmentHourByCorralPositionInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTreatmentHourByCorralPositionQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatmentHourByCorralPositionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTreatmentHourByCorralPositionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>
  > = ({ signal }) => getTreatmentHourByCorralPosition(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTreatmentHourByCorralPositionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>
>;
export type GetTreatmentHourByCorralPositionQueryError = ErrorType<HttpError>;

export const useGetTreatmentHourByCorralPosition = <
  TData = Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatmentHourByCorralPositionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTreatmentHourByCorralPosition>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTreatmentHourByCorralPositionQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Arquivos fora do dia da fazenda: os de dia passado esperando revisão e os de dia futuro esperando a fazenda chegar.
 */
export const getFeedLinkIntegrity = (signal?: AbortSignal) => {
  return request<GetFeedLinkIntegrityResponse>({
    url: `/feed-link/integrity`,
    method: "GET",
    signal,
  });
};

export const getGetFeedLinkIntegrityQueryKey = () => {
  return [`/feed-link/integrity`] as const;
};

export const getGetFeedLinkIntegrityInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedLinkIntegrityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>
  > = ({ signal }) => getFeedLinkIntegrity(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedLinkIntegrityInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedLinkIntegrity>>
>;
export type GetFeedLinkIntegrityInfiniteQueryError = ErrorType<unknown>;

export const useGetFeedLinkIntegrityInfinite = <
  TData = Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFeedLinkIntegrityInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFeedLinkIntegrityQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedLinkIntegrityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>
  > = ({ signal }) => getFeedLinkIntegrity(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedLinkIntegrityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedLinkIntegrity>>
>;
export type GetFeedLinkIntegrityQueryError = ErrorType<unknown>;

export const useGetFeedLinkIntegrity = <
  TData = Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkIntegrity>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFeedLinkIntegrityQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const proccessFeedLinkData = (
  proccessFeedLinkDataBody: ProccessFeedLinkDataBody,
) => {
  return request<boolean>({
    url: `/feed-link/process-data`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: proccessFeedLinkDataBody,
  });
};

export const getProccessFeedLinkDataMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proccessFeedLinkData>>,
    TError,
    { data: ProccessFeedLinkDataBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof proccessFeedLinkData>>,
  TError,
  { data: ProccessFeedLinkDataBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof proccessFeedLinkData>>,
    { data: ProccessFeedLinkDataBody }
  > = (props) => {
    const { data } = props ?? {};

    return proccessFeedLinkData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProccessFeedLinkDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof proccessFeedLinkData>>
>;
export type ProccessFeedLinkDataMutationBody = ProccessFeedLinkDataBody;
export type ProccessFeedLinkDataMutationError = ErrorType<HttpError>;

export const useProccessFeedLinkData = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proccessFeedLinkData>>,
    TError,
    { data: ProccessFeedLinkDataBody },
    TContext
  >;
}) => {
  const mutationOptions = getProccessFeedLinkDataMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Aplica o status de conclusão que o tratador marcou no painel do Feed Tracer (AT_real_TratoPrev_Stt).

As linhas são aplicadas uma a uma, em ordem de piquete e horário. Sequencial de propósito: concluir um horário muda o
previsto dos horários seguintes, e o `treatConclusion` congela o previsto do momento em que é chamado — em lote, o
segundo horário guardaria o previsto de antes da conclusão do primeiro.

Uma linha inválida não derruba o arquivo: ela volta como PENDING com o erro e as demais seguem.
 */
export const proccessFeedLinkTreatStatus = (
  proccessFeedLinkTreatStatusBody: ProccessFeedLinkTreatStatusBody,
) => {
  return request<ProccessFeedLinkTreatStatusResponse>({
    url: `/feed-link/process-treat-status`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: proccessFeedLinkTreatStatusBody,
  });
};

export const getProccessFeedLinkTreatStatusMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proccessFeedLinkTreatStatus>>,
    TError,
    { data: ProccessFeedLinkTreatStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof proccessFeedLinkTreatStatus>>,
  TError,
  { data: ProccessFeedLinkTreatStatusBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof proccessFeedLinkTreatStatus>>,
    { data: ProccessFeedLinkTreatStatusBody }
  > = (props) => {
    const { data } = props ?? {};

    return proccessFeedLinkTreatStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProccessFeedLinkTreatStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof proccessFeedLinkTreatStatus>>
>;
export type ProccessFeedLinkTreatStatusMutationBody =
  ProccessFeedLinkTreatStatusBody;
export type ProccessFeedLinkTreatStatusMutationError = ErrorType<HttpError>;

export const useProccessFeedLinkTreatStatus = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proccessFeedLinkTreatStatus>>,
    TError,
    { data: ProccessFeedLinkTreatStatusBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getProccessFeedLinkTreatStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeFeedLinkError = (
  removeFeedLinkErrorBody: RemoveFeedLinkErrorBody,
) => {
  return request<boolean>({
    url: `/feed-link/remove-error`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: removeFeedLinkErrorBody,
  });
};

export const getRemoveFeedLinkErrorMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFeedLinkError>>,
    TError,
    { data: RemoveFeedLinkErrorBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFeedLinkError>>,
  TError,
  { data: RemoveFeedLinkErrorBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFeedLinkError>>,
    { data: RemoveFeedLinkErrorBody }
  > = (props) => {
    const { data } = props ?? {};

    return removeFeedLinkError(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFeedLinkErrorMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFeedLinkError>>
>;
export type RemoveFeedLinkErrorMutationBody = RemoveFeedLinkErrorBody;
export type RemoveFeedLinkErrorMutationError = ErrorType<HttpError>;

export const useRemoveFeedLinkError = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFeedLinkError>>,
    TError,
    { data: RemoveFeedLinkErrorBody },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveFeedLinkErrorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Decisão sobre os arquivos de dia passado: por arquivo, ou todos os de um dia de uma vez. O aceito entra na fila e é
processado no dia a que se refere; o recusado vai para a falha.
 */
export const reviewFeedLinkFiles = (
  reviewFeedLinkFilesBody: ReviewFeedLinkFilesBody,
) => {
  return request<boolean>({
    url: `/feed-link/review`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: reviewFeedLinkFilesBody,
  });
};

export const getReviewFeedLinkFilesMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewFeedLinkFiles>>,
    TError,
    { data: ReviewFeedLinkFilesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reviewFeedLinkFiles>>,
  TError,
  { data: ReviewFeedLinkFilesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reviewFeedLinkFiles>>,
    { data: ReviewFeedLinkFilesBody }
  > = (props) => {
    const { data } = props ?? {};

    return reviewFeedLinkFiles(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviewFeedLinkFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reviewFeedLinkFiles>>
>;
export type ReviewFeedLinkFilesMutationBody = ReviewFeedLinkFilesBody;
export type ReviewFeedLinkFilesMutationError = ErrorType<HttpError>;

export const useReviewFeedLinkFiles = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewFeedLinkFiles>>,
    TError,
    { data: ReviewFeedLinkFilesBody },
    TContext
  >;
}) => {
  const mutationOptions = getReviewFeedLinkFilesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Uma linha por `id`, ou várias de uma vez por `ids`.
 */
export const updateFeedLinkStatus = (
  updateFeedLinkStatusBody: UpdateFeedLinkStatusBody,
) => {
  return request<boolean>({
    url: `/feed-link/update-status`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateFeedLinkStatusBody,
  });
};

export const getUpdateFeedLinkStatusMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedLinkStatus>>,
    TError,
    { data: UpdateFeedLinkStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFeedLinkStatus>>,
  TError,
  { data: UpdateFeedLinkStatusBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFeedLinkStatus>>,
    { data: UpdateFeedLinkStatusBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateFeedLinkStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFeedLinkStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFeedLinkStatus>>
>;
export type UpdateFeedLinkStatusMutationBody = UpdateFeedLinkStatusBody;
export type UpdateFeedLinkStatusMutationError = ErrorType<HttpError>;

export const useUpdateFeedLinkStatus = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedLinkStatus>>,
    TError,
    { data: UpdateFeedLinkStatusBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateFeedLinkStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateFeedLinkTreatmentHour = (
  updateFeedLinkTreatmentHourBody: UpdateFeedLinkTreatmentHourBody,
) => {
  return request<boolean>({
    url: `/feed-link/update-treatment-hour`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateFeedLinkTreatmentHourBody,
  });
};

export const getUpdateFeedLinkTreatmentHourMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedLinkTreatmentHour>>,
    TError,
    { data: UpdateFeedLinkTreatmentHourBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFeedLinkTreatmentHour>>,
  TError,
  { data: UpdateFeedLinkTreatmentHourBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFeedLinkTreatmentHour>>,
    { data: UpdateFeedLinkTreatmentHourBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateFeedLinkTreatmentHour(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFeedLinkTreatmentHourMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFeedLinkTreatmentHour>>
>;
export type UpdateFeedLinkTreatmentHourMutationBody =
  UpdateFeedLinkTreatmentHourBody;
export type UpdateFeedLinkTreatmentHourMutationError = ErrorType<HttpError>;

export const useUpdateFeedLinkTreatmentHour = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedLinkTreatmentHour>>,
    TError,
    { data: UpdateFeedLinkTreatmentHourBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateFeedLinkTreatmentHourMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Mesmos dados da v1, repartidos por situação. Aprovação parcial faz o mesmo arquivo aparecer em mais de uma lista,
cada uma só com as linhas daquela situação.
 */
export const getFeedLinkDataV2 = (signal?: AbortSignal) => {
  return request<GetFeedLinkDataV2Response>({
    url: `/feed-link/v2`,
    method: "GET",
    signal,
  });
};

export const getGetFeedLinkDataV2QueryKey = () => {
  return [`/feed-link/v2`] as const;
};

export const getGetFeedLinkDataV2InfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedLinkDataV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedLinkDataV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>
  > = ({ signal }) => getFeedLinkDataV2(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedLinkDataV2InfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedLinkDataV2>>
>;
export type GetFeedLinkDataV2InfiniteQueryError = ErrorType<unknown>;

export const useGetFeedLinkDataV2Infinite = <
  TData = Awaited<ReturnType<typeof getFeedLinkDataV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFeedLinkDataV2InfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFeedLinkDataV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedLinkDataV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedLinkDataV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>
  > = ({ signal }) => getFeedLinkDataV2(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedLinkDataV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedLinkDataV2>>
>;
export type GetFeedLinkDataV2QueryError = ErrorType<unknown>;

export const useGetFeedLinkDataV2 = <
  TData = Awaited<ReturnType<typeof getFeedLinkDataV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeedLinkDataV2>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFeedLinkDataV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listInvoices = (
  params?: ListInvoicesParams,
  signal?: AbortSignal,
) => {
  return request<ListInvoicesResponse>({
    url: `/financial/invoices`,
    method: "GET",
    params,
    signal,
  });
};

export const getListInvoicesQueryKey = (params?: ListInvoicesParams) => {
  return [`/financial/invoices`, ...(params ? [params] : [])] as const;
};

export const getListInvoicesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvoicesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listInvoices>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvoicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({
    signal,
  }) => listInvoices(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvoicesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvoices>>
>;
export type ListInvoicesInfiniteQueryError = ErrorType<unknown>;

export const useListInvoicesInfinite = <
  TData = Awaited<ReturnType<typeof listInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvoicesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listInvoices>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListInvoicesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvoices>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvoicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({
    signal,
  }) => listInvoices(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvoices>>
>;
export type ListInvoicesQueryError = ErrorType<unknown>;

export const useListInvoices = <
  TData = Awaited<ReturnType<typeof listInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvoices>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createInvoice = (createInvoice: CreateInvoice) => {
  return request<boolean>({
    url: `/financial/invoices`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createInvoice,
  });
};

export const getCreateInvoiceMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvoice>>,
    TError,
    { data: CreateInvoice },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvoice>>,
  TError,
  { data: CreateInvoice },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvoice>>,
    { data: CreateInvoice }
  > = (props) => {
    const { data } = props ?? {};

    return createInvoice(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInvoice>>
>;
export type CreateInvoiceMutationBody = CreateInvoice;
export type CreateInvoiceMutationError = ErrorType<HttpError>;

export const useCreateInvoice = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvoice>>,
    TError,
    { data: CreateInvoice },
    TContext
  >;
}) => {
  const mutationOptions = getCreateInvoiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getInvoiceById = (id: number, signal?: AbortSignal) => {
  return request<GetInvoiceByIdResponse>({
    url: `/financial/invoices/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetInvoiceByIdQueryKey = (id: number) => {
  return [`/financial/invoices/${id}`] as const;
};

export const getGetInvoiceByIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoiceById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getInvoiceById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceById>>> = ({
    signal,
  }) => getInvoiceById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getInvoiceById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceByIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoiceById>>
>;
export type GetInvoiceByIdInfiniteQueryError = ErrorType<HttpError>;

export const useGetInvoiceByIdInfinite = <
  TData = Awaited<ReturnType<typeof getInvoiceById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getInvoiceById>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInvoiceByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetInvoiceByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoiceById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvoiceById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceById>>> = ({
    signal,
  }) => getInvoiceById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoiceById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoiceById>>
>;
export type GetInvoiceByIdQueryError = ErrorType<HttpError>;

export const useGetInvoiceById = <
  TData = Awaited<ReturnType<typeof getInvoiceById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvoiceById>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInvoiceByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateInvoice = (id: number, updateInvoice: UpdateInvoice) => {
  return request<boolean>({
    url: `/financial/invoices/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateInvoice,
  });
};

export const getUpdateInvoiceMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInvoice>>,
    TError,
    { id: number; data: UpdateInvoice },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInvoice>>,
  TError,
  { id: number; data: UpdateInvoice },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInvoice>>,
    { id: number; data: UpdateInvoice }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInvoice(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInvoice>>
>;
export type UpdateInvoiceMutationBody = UpdateInvoice;
export type UpdateInvoiceMutationError = ErrorType<HttpError>;

export const useUpdateInvoice = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInvoice>>,
    TError,
    { id: number; data: UpdateInvoice },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateInvoiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const loadFinancialReport = (
  params: LoadFinancialReportParams,
  signal?: AbortSignal,
) => {
  return request<LoadFinancialReportResponse>({
    url: `/financial/report`,
    method: "GET",
    params,
    signal,
  });
};

export const getLoadFinancialReportQueryKey = (
  params: LoadFinancialReportParams,
) => {
  return [`/financial/report`, ...(params ? [params] : [])] as const;
};

export const getLoadFinancialReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof loadFinancialReport>>,
  TError = ErrorType<HttpError>,
>(
  params: LoadFinancialReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof loadFinancialReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLoadFinancialReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof loadFinancialReport>>
  > = ({ signal }) => loadFinancialReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof loadFinancialReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LoadFinancialReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof loadFinancialReport>>
>;
export type LoadFinancialReportInfiniteQueryError = ErrorType<HttpError>;

export const useLoadFinancialReportInfinite = <
  TData = Awaited<ReturnType<typeof loadFinancialReport>>,
  TError = ErrorType<HttpError>,
>(
  params: LoadFinancialReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof loadFinancialReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getLoadFinancialReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getLoadFinancialReportQueryOptions = <
  TData = Awaited<ReturnType<typeof loadFinancialReport>>,
  TError = ErrorType<HttpError>,
>(
  params: LoadFinancialReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof loadFinancialReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLoadFinancialReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof loadFinancialReport>>
  > = ({ signal }) => loadFinancialReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof loadFinancialReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LoadFinancialReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof loadFinancialReport>>
>;
export type LoadFinancialReportQueryError = ErrorType<HttpError>;

export const useLoadFinancialReport = <
  TData = Awaited<ReturnType<typeof loadFinancialReport>>,
  TError = ErrorType<HttpError>,
>(
  params: LoadFinancialReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof loadFinancialReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getLoadFinancialReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listGeneralLogs = (
  params: ListGeneralLogsParams,
  signal?: AbortSignal,
) => {
  return request<ListGeneralLogsResponse>({
    url: `/general-logs`,
    method: "GET",
    params,
    signal,
  });
};

export const getListGeneralLogsQueryKey = (params: ListGeneralLogsParams) => {
  return [`/general-logs`, ...(params ? [params] : [])] as const;
};

export const getListGeneralLogsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listGeneralLogs>>,
  TError = ErrorType<unknown>,
>(
  params: ListGeneralLogsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listGeneralLogs>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGeneralLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGeneralLogs>>> = ({
    signal,
  }) => listGeneralLogs(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listGeneralLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGeneralLogsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGeneralLogs>>
>;
export type ListGeneralLogsInfiniteQueryError = ErrorType<unknown>;

export const useListGeneralLogsInfinite = <
  TData = Awaited<ReturnType<typeof listGeneralLogs>>,
  TError = ErrorType<unknown>,
>(
  params: ListGeneralLogsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listGeneralLogs>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListGeneralLogsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListGeneralLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGeneralLogs>>,
  TError = ErrorType<unknown>,
>(
  params: ListGeneralLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGeneralLogs>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGeneralLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGeneralLogs>>> = ({
    signal,
  }) => listGeneralLogs(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listGeneralLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGeneralLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGeneralLogs>>
>;
export type ListGeneralLogsQueryError = ErrorType<unknown>;

export const useListGeneralLogs = <
  TData = Awaited<ReturnType<typeof listGeneralLogs>>,
  TError = ErrorType<unknown>,
>(
  params: ListGeneralLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGeneralLogs>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListGeneralLogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listGtas = (params?: ListGtasParams, signal?: AbortSignal) => {
  return request<ListGtasResponse>({
    url: `/gtas`,
    method: "GET",
    params,
    signal,
  });
};

export const getListGtasQueryKey = (params?: ListGtasParams) => {
  return [`/gtas`, ...(params ? [params] : [])] as const;
};

export const getListGtasInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listGtas>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGtasParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listGtas>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGtasQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGtas>>> = ({
    signal,
  }) => listGtas(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listGtas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGtasInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGtas>>
>;
export type ListGtasInfiniteQueryError = ErrorType<unknown>;

export const useListGtasInfinite = <
  TData = Awaited<ReturnType<typeof listGtas>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGtasParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listGtas>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListGtasInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListGtasQueryOptions = <
  TData = Awaited<ReturnType<typeof listGtas>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGtasParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGtas>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGtasQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGtas>>> = ({
    signal,
  }) => listGtas(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listGtas>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListGtasQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGtas>>
>;
export type ListGtasQueryError = ErrorType<unknown>;

export const useListGtas = <
  TData = Awaited<ReturnType<typeof listGtas>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGtasParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGtas>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListGtasQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createGta = (createGta: CreateGta) => {
  return request<CreateGtaResponse>({
    url: `/gtas`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createGta,
  });
};

export const getCreateGtaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGta>>,
    TError,
    { data: CreateGta },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGta>>,
  TError,
  { data: CreateGta },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGta>>,
    { data: CreateGta }
  > = (props) => {
    const { data } = props ?? {};

    return createGta(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGtaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGta>>
>;
export type CreateGtaMutationBody = CreateGta;
export type CreateGtaMutationError = ErrorType<unknown>;

export const useCreateGta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGta>>,
    TError,
    { data: CreateGta },
    TContext
  >;
}) => {
  const mutationOptions = getCreateGtaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOfGtasForChargeback = (
  params: ListOfGtasForChargebackParams,
  signal?: AbortSignal,
) => {
  return request<ListOfGtasForChargebackResponse>({
    url: `/gtas/chargeback`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOfGtasForChargebackQueryKey = (
  params: ListOfGtasForChargebackParams,
) => {
  return [`/gtas/chargeback`, ...(params ? [params] : [])] as const;
};

export const getListOfGtasForChargebackInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOfGtasForChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params: ListOfGtasForChargebackParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOfGtasForChargeback>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOfGtasForChargebackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOfGtasForChargeback>>
  > = ({ signal }) => listOfGtasForChargeback(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOfGtasForChargeback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOfGtasForChargebackInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOfGtasForChargeback>>
>;
export type ListOfGtasForChargebackInfiniteQueryError = ErrorType<HttpError>;

export const useListOfGtasForChargebackInfinite = <
  TData = Awaited<ReturnType<typeof listOfGtasForChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params: ListOfGtasForChargebackParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOfGtasForChargeback>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOfGtasForChargebackInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOfGtasForChargebackQueryOptions = <
  TData = Awaited<ReturnType<typeof listOfGtasForChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params: ListOfGtasForChargebackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOfGtasForChargeback>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOfGtasForChargebackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOfGtasForChargeback>>
  > = ({ signal }) => listOfGtasForChargeback(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOfGtasForChargeback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOfGtasForChargebackQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOfGtasForChargeback>>
>;
export type ListOfGtasForChargebackQueryError = ErrorType<HttpError>;

export const useListOfGtasForChargeback = <
  TData = Awaited<ReturnType<typeof listOfGtasForChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params: ListOfGtasForChargebackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOfGtasForChargeback>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOfGtasForChargebackQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Gera o Excel da visão geral de GTAs a partir dos dados já carregados na tela.
 */
export const exportGtaOverviewExcel = (
  exportGtaOverviewExcelBody: ExportGtaOverviewExcelBody,
) => {
  return request<ExportGtaOverviewExcelResponse>({
    url: `/gtas/export-excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: exportGtaOverviewExcelBody,
  });
};

export const getExportGtaOverviewExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportGtaOverviewExcel>>,
    TError,
    { data: ExportGtaOverviewExcelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportGtaOverviewExcel>>,
  TError,
  { data: ExportGtaOverviewExcelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportGtaOverviewExcel>>,
    { data: ExportGtaOverviewExcelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportGtaOverviewExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportGtaOverviewExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportGtaOverviewExcel>>
>;
export type ExportGtaOverviewExcelMutationBody = ExportGtaOverviewExcelBody;
export type ExportGtaOverviewExcelMutationError = ErrorType<unknown>;

export const useExportGtaOverviewExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportGtaOverviewExcel>>,
    TError,
    { data: ExportGtaOverviewExcelBody },
    TContext
  >;
}) => {
  const mutationOptions = getExportGtaOverviewExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista as GTAs com dados de previsão para venda interna
 */
export const foreseenGtaData = (
  params: ForeseenGtaDataParams,
  signal?: AbortSignal,
) => {
  return request<ForeseenGtaDataResponse>({
    url: `/gtas/foreseen`,
    method: "GET",
    params,
    signal,
  });
};

export const getForeseenGtaDataQueryKey = (params: ForeseenGtaDataParams) => {
  return [`/gtas/foreseen`, ...(params ? [params] : [])] as const;
};

export const getForeseenGtaDataInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof foreseenGtaData>>,
  TError = ErrorType<unknown>,
>(
  params: ForeseenGtaDataParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof foreseenGtaData>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForeseenGtaDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof foreseenGtaData>>> = ({
    signal,
  }) => foreseenGtaData(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof foreseenGtaData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForeseenGtaDataInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof foreseenGtaData>>
>;
export type ForeseenGtaDataInfiniteQueryError = ErrorType<unknown>;

export const useForeseenGtaDataInfinite = <
  TData = Awaited<ReturnType<typeof foreseenGtaData>>,
  TError = ErrorType<unknown>,
>(
  params: ForeseenGtaDataParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof foreseenGtaData>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getForeseenGtaDataInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getForeseenGtaDataQueryOptions = <
  TData = Awaited<ReturnType<typeof foreseenGtaData>>,
  TError = ErrorType<unknown>,
>(
  params: ForeseenGtaDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof foreseenGtaData>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForeseenGtaDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof foreseenGtaData>>> = ({
    signal,
  }) => foreseenGtaData(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof foreseenGtaData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForeseenGtaDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof foreseenGtaData>>
>;
export type ForeseenGtaDataQueryError = ErrorType<unknown>;

export const useForeseenGtaData = <
  TData = Awaited<ReturnType<typeof foreseenGtaData>>,
  TError = ErrorType<unknown>,
>(
  params: ForeseenGtaDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof foreseenGtaData>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getForeseenGtaDataQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateForeseenGtaDataExcel = (
  forseenGtaDataExcelRequest: ForseenGtaDataExcelRequest,
) => {
  return request<GenerateForeseenGtaDataExcelResponse>({
    url: `/gtas/foreseen/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: forseenGtaDataExcelRequest,
  });
};

export const getGenerateForeseenGtaDataExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateForeseenGtaDataExcel>>,
    TError,
    { data: ForseenGtaDataExcelRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateForeseenGtaDataExcel>>,
  TError,
  { data: ForseenGtaDataExcelRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateForeseenGtaDataExcel>>,
    { data: ForseenGtaDataExcelRequest }
  > = (props) => {
    const { data } = props ?? {};

    return generateForeseenGtaDataExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateForeseenGtaDataExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateForeseenGtaDataExcel>>
>;
export type GenerateForeseenGtaDataExcelMutationBody =
  ForseenGtaDataExcelRequest;
export type GenerateForeseenGtaDataExcelMutationError = ErrorType<unknown>;

export const useGenerateForeseenGtaDataExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateForeseenGtaDataExcel>>,
    TError,
    { data: ForseenGtaDataExcelRequest },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateForeseenGtaDataExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista as GTAs que foram emitidas há até N dias atrás
 */
export const listGtasFromNDaysAgo = (
  listGtasFromNDaysAgoRequestBody: ListGtasFromNDaysAgoRequestBody,
) => {
  return request<ListGtasFromNDaysAgoResponse>({
    url: `/gtas/n-days`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: listGtasFromNDaysAgoRequestBody,
  });
};

export const getListGtasFromNDaysAgoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listGtasFromNDaysAgo>>,
    TError,
    { data: ListGtasFromNDaysAgoRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listGtasFromNDaysAgo>>,
  TError,
  { data: ListGtasFromNDaysAgoRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listGtasFromNDaysAgo>>,
    { data: ListGtasFromNDaysAgoRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return listGtasFromNDaysAgo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListGtasFromNDaysAgoMutationResult = NonNullable<
  Awaited<ReturnType<typeof listGtasFromNDaysAgo>>
>;
export type ListGtasFromNDaysAgoMutationBody = ListGtasFromNDaysAgoRequestBody;
export type ListGtasFromNDaysAgoMutationError = ErrorType<unknown>;

export const useListGtasFromNDaysAgo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listGtasFromNDaysAgo>>,
    TError,
    { data: ListGtasFromNDaysAgoRequestBody },
    TContext
  >;
}) => {
  const mutationOptions = getListGtasFromNDaysAgoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listSimpleGtas = (signal?: AbortSignal) => {
  return request<ListSimpleGtasResponse>({
    url: `/gtas/simple`,
    method: "GET",
    signal,
  });
};

export const getListSimpleGtasQueryKey = () => {
  return [`/gtas/simple`] as const;
};

export const getListSimpleGtasInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimpleGtas>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSimpleGtas>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSimpleGtasQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSimpleGtas>>> = ({
    signal,
  }) => listSimpleGtas(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSimpleGtas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSimpleGtasInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimpleGtas>>
>;
export type ListSimpleGtasInfiniteQueryError = ErrorType<unknown>;

export const useListSimpleGtasInfinite = <
  TData = Awaited<ReturnType<typeof listSimpleGtas>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSimpleGtas>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSimpleGtasInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSimpleGtasQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimpleGtas>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSimpleGtas>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSimpleGtasQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSimpleGtas>>> = ({
    signal,
  }) => listSimpleGtas(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSimpleGtas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSimpleGtasQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimpleGtas>>
>;
export type ListSimpleGtasQueryError = ErrorType<unknown>;

export const useListSimpleGtas = <
  TData = Awaited<ReturnType<typeof listSimpleGtas>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSimpleGtas>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSimpleGtasQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deleteGta = (id: number) => {
  return request<DeleteGtaResponse>({ url: `/gtas/${id}`, method: "DELETE" });
};

export const getDeleteGtaMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGta>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGta>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGta>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteGta(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGtaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGta>>
>;

export type DeleteGtaMutationError = ErrorType<HttpError>;

export const useDeleteGta = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGta>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteGtaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getGta = (id: number, signal?: AbortSignal) => {
  return request<GetGtaResponse>({ url: `/gtas/${id}`, method: "GET", signal });
};

export const getGetGtaQueryKey = (id: number) => {
  return [`/gtas/${id}`] as const;
};

export const getGetGtaInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getGta>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getGta>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGtaQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGta>>> = ({
    signal,
  }) => getGta(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getGta>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGtaInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGta>>
>;
export type GetGtaInfiniteQueryError = ErrorType<HttpError>;

export const useGetGtaInfinite = <
  TData = Awaited<ReturnType<typeof getGta>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getGta>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGtaInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetGtaQueryOptions = <
  TData = Awaited<ReturnType<typeof getGta>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getGta>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGtaQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGta>>> = ({
    signal,
  }) => getGta(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getGta>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetGtaQueryResult = NonNullable<Awaited<ReturnType<typeof getGta>>>;
export type GetGtaQueryError = ErrorType<HttpError>;

export const useGetGta = <
  TData = Awaited<ReturnType<typeof getGta>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getGta>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGtaQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateGta = (id: number, updateGta: UpdateGta) => {
  return request<UpdateGtaResponse>({
    url: `/gtas/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateGta,
  });
};

export const getUpdateGtaMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGta>>,
    TError,
    { id: number; data: UpdateGta },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGta>>,
  TError,
  { id: number; data: UpdateGta },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGta>>,
    { id: number; data: UpdateGta }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGta(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGtaMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGta>>
>;
export type UpdateGtaMutationBody = UpdateGta;
export type UpdateGtaMutationError = ErrorType<HttpError>;

export const useUpdateGta = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGta>>,
    TError,
    { id: number; data: UpdateGta },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateGtaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listHealthProtocols = (
  params?: ListHealthProtocolsParams,
  signal?: AbortSignal,
) => {
  return request<ListHealthProtocolsResponse>({
    url: `/health-protocols`,
    method: "GET",
    params,
    signal,
  });
};

export const getListHealthProtocolsQueryKey = (
  params?: ListHealthProtocolsParams,
) => {
  return [`/health-protocols`, ...(params ? [params] : [])] as const;
};

export const getListHealthProtocolsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listHealthProtocols>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHealthProtocolsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listHealthProtocols>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListHealthProtocolsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHealthProtocols>>
  > = ({ signal }) => listHealthProtocols(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listHealthProtocols>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHealthProtocolsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHealthProtocols>>
>;
export type ListHealthProtocolsInfiniteQueryError = ErrorType<unknown>;

export const useListHealthProtocolsInfinite = <
  TData = Awaited<ReturnType<typeof listHealthProtocols>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHealthProtocolsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listHealthProtocols>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListHealthProtocolsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListHealthProtocolsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHealthProtocols>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHealthProtocolsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHealthProtocols>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListHealthProtocolsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHealthProtocols>>
  > = ({ signal }) => listHealthProtocols(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listHealthProtocols>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHealthProtocolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHealthProtocols>>
>;
export type ListHealthProtocolsQueryError = ErrorType<unknown>;

export const useListHealthProtocols = <
  TData = Awaited<ReturnType<typeof listHealthProtocols>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHealthProtocolsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHealthProtocols>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListHealthProtocolsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createHealthProtocol = (
  createHealthProtocol: CreateHealthProtocol,
) => {
  return request<CreateHealthProtocolResponse>({
    url: `/health-protocols`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createHealthProtocol,
  });
};

export const getCreateHealthProtocolMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHealthProtocol>>,
    TError,
    { data: CreateHealthProtocol },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHealthProtocol>>,
  TError,
  { data: CreateHealthProtocol },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHealthProtocol>>,
    { data: CreateHealthProtocol }
  > = (props) => {
    const { data } = props ?? {};

    return createHealthProtocol(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHealthProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHealthProtocol>>
>;
export type CreateHealthProtocolMutationBody = CreateHealthProtocol;
export type CreateHealthProtocolMutationError = ErrorType<HttpError>;

export const useCreateHealthProtocol = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHealthProtocol>>,
    TError,
    { data: CreateHealthProtocol },
    TContext
  >;
}) => {
  const mutationOptions = getCreateHealthProtocolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getHealthProtocol = (
  id: number,
  params?: GetHealthProtocolParams,
  signal?: AbortSignal,
) => {
  return request<GetHealthProtocolResponse>({
    url: `/health-protocols/${id}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetHealthProtocolQueryKey = (
  id: number,
  params?: GetHealthProtocolParams,
) => {
  return [`/health-protocols/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetHealthProtocolInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealthProtocol>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetHealthProtocolParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHealthProtocol>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHealthProtocolQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHealthProtocol>>
  > = ({ signal }) => getHealthProtocol(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getHealthProtocol>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHealthProtocolInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHealthProtocol>>
>;
export type GetHealthProtocolInfiniteQueryError = ErrorType<unknown>;

export const useGetHealthProtocolInfinite = <
  TData = Awaited<ReturnType<typeof getHealthProtocol>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetHealthProtocolParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHealthProtocol>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHealthProtocolInfiniteQueryOptions(
    id,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetHealthProtocolQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealthProtocol>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetHealthProtocolParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthProtocol>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHealthProtocolQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHealthProtocol>>
  > = ({ signal }) => getHealthProtocol(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHealthProtocol>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHealthProtocolQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHealthProtocol>>
>;
export type GetHealthProtocolQueryError = ErrorType<unknown>;

export const useGetHealthProtocol = <
  TData = Awaited<ReturnType<typeof getHealthProtocol>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetHealthProtocolParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthProtocol>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHealthProtocolQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const addHealthProtocolImages = (
  id: number,
  addHealthProtocolImage: AddHealthProtocolImage[],
) => {
  return request<AddHealthProtocolImagesResponse>({
    url: `/health-protocols/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addHealthProtocolImage,
  });
};

export const getAddHealthProtocolImagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addHealthProtocolImages>>,
    TError,
    { id: number; data: AddHealthProtocolImage[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addHealthProtocolImages>>,
  TError,
  { id: number; data: AddHealthProtocolImage[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addHealthProtocolImages>>,
    { id: number; data: AddHealthProtocolImage[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return addHealthProtocolImages(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddHealthProtocolImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof addHealthProtocolImages>>
>;
export type AddHealthProtocolImagesMutationBody = AddHealthProtocolImage[];
export type AddHealthProtocolImagesMutationError = ErrorType<unknown>;

export const useAddHealthProtocolImages = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addHealthProtocolImages>>,
    TError,
    { id: number; data: AddHealthProtocolImage[] },
    TContext
  >;
}) => {
  const mutationOptions = getAddHealthProtocolImagesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ativa ou desativa uma dieta para ser listada no frontend.
 */
export const activateHealthProtocol = (
  id: number,
  params: ActivateHealthProtocolParams,
) => {
  return request<ActivateHealthProtocolResponse>({
    url: `/health-protocols/${id}/active`,
    method: "POST",
    params,
  });
};

export const getActivateHealthProtocolMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateHealthProtocol>>,
    TError,
    { id: number; params: ActivateHealthProtocolParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateHealthProtocol>>,
  TError,
  { id: number; params: ActivateHealthProtocolParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateHealthProtocol>>,
    { id: number; params: ActivateHealthProtocolParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return activateHealthProtocol(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateHealthProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateHealthProtocol>>
>;

export type ActivateHealthProtocolMutationError = ErrorType<unknown>;

export const useActivateHealthProtocol = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateHealthProtocol>>,
    TError,
    { id: number; params: ActivateHealthProtocolParams },
    TContext
  >;
}) => {
  const mutationOptions = getActivateHealthProtocolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const healthCheck = (signal?: AbortSignal) => {
  return request<HealthCheckResponse>({
    url: `/healthcheck`,
    method: "GET",
    signal,
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/healthcheck`] as const;
};

export const getHealthCheckInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckInfiniteQueryError = ErrorType<unknown>;

export const useHealthCheckInfinite = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getHealthCheckInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

export const useHealthCheck = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listHoldingSales = (
  params?: ListHoldingSalesParams,
  signal?: AbortSignal,
) => {
  return request<ListHoldingSalesResponse>({
    url: `/holding-sale`,
    method: "GET",
    params,
    signal,
  });
};

export const getListHoldingSalesQueryKey = (
  params?: ListHoldingSalesParams,
) => {
  return [`/holding-sale`, ...(params ? [params] : [])] as const;
};

export const getListHoldingSalesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listHoldingSales>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHoldingSalesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listHoldingSales>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListHoldingSalesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHoldingSales>>
  > = ({ signal }) => listHoldingSales(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listHoldingSales>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHoldingSalesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHoldingSales>>
>;
export type ListHoldingSalesInfiniteQueryError = ErrorType<unknown>;

export const useListHoldingSalesInfinite = <
  TData = Awaited<ReturnType<typeof listHoldingSales>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHoldingSalesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listHoldingSales>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListHoldingSalesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListHoldingSalesQueryOptions = <
  TData = Awaited<ReturnType<typeof listHoldingSales>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHoldingSalesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHoldingSales>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListHoldingSalesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHoldingSales>>
  > = ({ signal }) => listHoldingSales(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listHoldingSales>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHoldingSalesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHoldingSales>>
>;
export type ListHoldingSalesQueryError = ErrorType<unknown>;

export const useListHoldingSales = <
  TData = Awaited<ReturnType<typeof listHoldingSales>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHoldingSalesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHoldingSales>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListHoldingSalesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createHoldingSaleFromExcel = (
  createSaleFromExcelBody: CreateSaleFromExcelBody,
) => {
  return request<CreateSaleFromExcelResult>({
    url: `/holding-sale/import-excel/create-sale`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSaleFromExcelBody,
  });
};

export const getCreateHoldingSaleFromExcelMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHoldingSaleFromExcel>>,
    TError,
    { data: CreateSaleFromExcelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHoldingSaleFromExcel>>,
  TError,
  { data: CreateSaleFromExcelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHoldingSaleFromExcel>>,
    { data: CreateSaleFromExcelBody }
  > = (props) => {
    const { data } = props ?? {};

    return createHoldingSaleFromExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHoldingSaleFromExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHoldingSaleFromExcel>>
>;
export type CreateHoldingSaleFromExcelMutationBody = CreateSaleFromExcelBody;
export type CreateHoldingSaleFromExcelMutationError = ErrorType<HttpError>;

export const useCreateHoldingSaleFromExcel = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHoldingSaleFromExcel>>,
    TError,
    { data: CreateSaleFromExcelBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateHoldingSaleFromExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const validateHoldingSaleExcel = (
  importExcelValidateBody: ImportExcelValidateBody,
) => {
  return request<ImportExcelValidationResult>({
    url: `/holding-sale/import-excel/validate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importExcelValidateBody,
  });
};

export const getValidateHoldingSaleExcelMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateHoldingSaleExcel>>,
    TError,
    { data: ImportExcelValidateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateHoldingSaleExcel>>,
  TError,
  { data: ImportExcelValidateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateHoldingSaleExcel>>,
    { data: ImportExcelValidateBody }
  > = (props) => {
    const { data } = props ?? {};

    return validateHoldingSaleExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateHoldingSaleExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateHoldingSaleExcel>>
>;
export type ValidateHoldingSaleExcelMutationBody = ImportExcelValidateBody;
export type ValidateHoldingSaleExcelMutationError = ErrorType<HttpError>;

export const useValidateHoldingSaleExcel = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateHoldingSaleExcel>>,
    TError,
    { data: ImportExcelValidateBody },
    TContext
  >;
}) => {
  const mutationOptions = getValidateHoldingSaleExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const validateSingleHoldingSaleRow = (
  validateSingleHoldingSaleRowBody: ValidateSingleHoldingSaleRowBody,
) => {
  return request<ImportExcelValidationResult>({
    url: `/holding-sale/import-excel/validate-single-row`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: validateSingleHoldingSaleRowBody,
  });
};

export const getValidateSingleHoldingSaleRowMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateSingleHoldingSaleRow>>,
    TError,
    { data: ValidateSingleHoldingSaleRowBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateSingleHoldingSaleRow>>,
  TError,
  { data: ValidateSingleHoldingSaleRowBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateSingleHoldingSaleRow>>,
    { data: ValidateSingleHoldingSaleRowBody }
  > = (props) => {
    const { data } = props ?? {};

    return validateSingleHoldingSaleRow(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateSingleHoldingSaleRowMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateSingleHoldingSaleRow>>
>;
export type ValidateSingleHoldingSaleRowMutationBody =
  ValidateSingleHoldingSaleRowBody;
export type ValidateSingleHoldingSaleRowMutationError = ErrorType<HttpError>;

export const useValidateSingleHoldingSaleRow = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateSingleHoldingSaleRow>>,
    TError,
    { data: ValidateSingleHoldingSaleRowBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getValidateSingleHoldingSaleRowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Exclui uma saída avulsa sem animais vinculados (caso tenha ficado vazia por algum caminho que não passou pelo estorno
normal, que já apaga a saída automaticamente quando zera os animais).
 */
export const deleteHoldingSale = (id: number) => {
  return request<boolean>({ url: `/holding-sale/${id}`, method: "DELETE" });
};

export const getDeleteHoldingSaleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHoldingSale>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHoldingSale>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHoldingSale>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteHoldingSale(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteHoldingSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHoldingSale>>
>;

export type DeleteHoldingSaleMutationError = ErrorType<HttpError>;

export const useDeleteHoldingSale = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHoldingSale>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteHoldingSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getHoldingSale = (id: number, signal?: AbortSignal) => {
  return request<GetHoldingSaleResponse>({
    url: `/holding-sale/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetHoldingSaleQueryKey = (id: number) => {
  return [`/holding-sale/${id}`] as const;
};

export const getGetHoldingSaleInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getHoldingSale>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHoldingSale>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHoldingSaleQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHoldingSale>>> = ({
    signal,
  }) => getHoldingSale(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getHoldingSale>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHoldingSaleInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHoldingSale>>
>;
export type GetHoldingSaleInfiniteQueryError = ErrorType<unknown>;

export const useGetHoldingSaleInfinite = <
  TData = Awaited<ReturnType<typeof getHoldingSale>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHoldingSale>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHoldingSaleInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetHoldingSaleQueryOptions = <
  TData = Awaited<ReturnType<typeof getHoldingSale>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHoldingSale>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHoldingSaleQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHoldingSale>>> = ({
    signal,
  }) => getHoldingSale(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHoldingSale>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHoldingSaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHoldingSale>>
>;
export type GetHoldingSaleQueryError = ErrorType<unknown>;

export const useGetHoldingSale = <
  TData = Awaited<ReturnType<typeof getHoldingSale>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHoldingSale>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHoldingSaleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateHoldingSale = (
  id: number,
  saleHoldingBatch: SaleHoldingBatch,
) => {
  return request<UpdateHoldingSaleResponse>({
    url: `/holding-sale/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: saleHoldingBatch,
  });
};

export const getUpdateHoldingSaleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingSale>>,
    TError,
    { id: number; data: SaleHoldingBatch },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHoldingSale>>,
  TError,
  { id: number; data: SaleHoldingBatch },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHoldingSale>>,
    { id: number; data: SaleHoldingBatch }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHoldingSale(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHoldingSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHoldingSale>>
>;
export type UpdateHoldingSaleMutationBody = SaleHoldingBatch;
export type UpdateHoldingSaleMutationError = ErrorType<HttpError>;

export const useUpdateHoldingSale = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingSale>>,
    TError,
    { id: number; data: SaleHoldingBatch },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateHoldingSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ajuste de data da saída avulsa: re-data a saída, o caminhão, a morte e o peso de saída dos animais e os vínculos
boi/lote; quando a saída fechou o lote, re-data o fechamento, apaga notas de cocho e tratos do período posterior e
devolve ao estoque o que esses tratos consumiram.
 */
export const adjustHoldingSaleDate = (
  id: number,
  adjustHoldingSaleDateBody: AdjustHoldingSaleDateBody,
) => {
  return request<AdjustHoldingSaleDateResult>({
    url: `/holding-sale/${id}/adjust-date`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: adjustHoldingSaleDateBody,
  });
};

export const getAdjustHoldingSaleDateMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustHoldingSaleDate>>,
    TError,
    { id: number; data: AdjustHoldingSaleDateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustHoldingSaleDate>>,
  TError,
  { id: number; data: AdjustHoldingSaleDateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustHoldingSaleDate>>,
    { id: number; data: AdjustHoldingSaleDateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return adjustHoldingSaleDate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdjustHoldingSaleDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustHoldingSaleDate>>
>;
export type AdjustHoldingSaleDateMutationBody = AdjustHoldingSaleDateBody;
export type AdjustHoldingSaleDateMutationError = ErrorType<HttpError>;

export const useAdjustHoldingSaleDate = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustHoldingSaleDate>>,
    TError,
    { id: number; data: AdjustHoldingSaleDateBody },
    TContext
  >;
}) => {
  const mutationOptions = getAdjustHoldingSaleDateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Prévia do ajuste de data da saída avulsa: limites da nova data e, quando ela é informada, o resumo do que será
apagado, ajustado e devolvido ao estoque.
 */
export const previewAdjustHoldingSaleDate = (
  id: number,
  adjustHoldingSaleDateBody: AdjustHoldingSaleDateBody,
) => {
  return request<AdjustHoldingSaleDatePreviewResult>({
    url: `/holding-sale/${id}/adjust-date/preview`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: adjustHoldingSaleDateBody,
  });
};

export const getPreviewAdjustHoldingSaleDateMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAdjustHoldingSaleDate>>,
    TError,
    { id: number; data: AdjustHoldingSaleDateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAdjustHoldingSaleDate>>,
  TError,
  { id: number; data: AdjustHoldingSaleDateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAdjustHoldingSaleDate>>,
    { id: number; data: AdjustHoldingSaleDateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewAdjustHoldingSaleDate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewAdjustHoldingSaleDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAdjustHoldingSaleDate>>
>;
export type PreviewAdjustHoldingSaleDateMutationBody =
  AdjustHoldingSaleDateBody;
export type PreviewAdjustHoldingSaleDateMutationError = ErrorType<HttpError>;

export const usePreviewAdjustHoldingSaleDate = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAdjustHoldingSaleDate>>,
    TError,
    { id: number; data: AdjustHoldingSaleDateBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getPreviewAdjustHoldingSaleDateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Estorno da saída avulsa: revive os animais (todos, seleção por `oxIds`, ou os primeiros `oxenAmount` no parcial por
quantidade), reabre o lote quando a saída o fechou (no curral original ou no informado) e preenche o gap com a nota
de estorno zerada e um trato zerado por dia. No estorno total o caminhão e a saída são apagados; no parcial a saída é
mantida com os animais restantes.
 */
export const revertHoldingSale = (
  id: number,
  revertHoldingSaleBody: RevertHoldingSaleBody,
) => {
  return request<ApplyRevertHoldingSaleResult>({
    url: `/holding-sale/${id}/revert`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: revertHoldingSaleBody,
  });
};

export const getRevertHoldingSaleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertHoldingSale>>,
    TError,
    { id: number; data: RevertHoldingSaleBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertHoldingSale>>,
  TError,
  { id: number; data: RevertHoldingSaleBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertHoldingSale>>,
    { id: number; data: RevertHoldingSaleBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return revertHoldingSale(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertHoldingSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertHoldingSale>>
>;
export type RevertHoldingSaleMutationBody = RevertHoldingSaleBody;
export type RevertHoldingSaleMutationError = ErrorType<HttpError>;

export const useRevertHoldingSale = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertHoldingSale>>,
    TError,
    { id: number; data: RevertHoldingSaleBody },
    TContext
  >;
}) => {
  const mutationOptions = getRevertHoldingSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Prévia do estorno da saída avulsa: animais na saída, dias que serão zerados e ocupação do curral original. `batch`
nulo = lote segue ativo, estorno direto.
 */
export const previewRevertHoldingSale = (
  id: number,
  revertHoldingSaleBody: RevertHoldingSaleBody,
) => {
  return request<RevertHoldingSalePreviewResult>({
    url: `/holding-sale/${id}/revert/preview`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: revertHoldingSaleBody,
  });
};

export const getPreviewRevertHoldingSaleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRevertHoldingSale>>,
    TError,
    { id: number; data: RevertHoldingSaleBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewRevertHoldingSale>>,
  TError,
  { id: number; data: RevertHoldingSaleBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewRevertHoldingSale>>,
    { id: number; data: RevertHoldingSaleBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewRevertHoldingSale(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewRevertHoldingSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewRevertHoldingSale>>
>;
export type PreviewRevertHoldingSaleMutationBody = RevertHoldingSaleBody;
export type PreviewRevertHoldingSaleMutationError = ErrorType<HttpError>;

export const usePreviewRevertHoldingSale = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRevertHoldingSale>>,
    TError,
    { id: number; data: RevertHoldingSaleBody },
    TContext
  >;
}) => {
  const mutationOptions = getPreviewRevertHoldingSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getHoldingSaleWeights = (id: number, signal?: AbortSignal) => {
  return request<GetHoldingSaleWeightsResponse>({
    url: `/holding-sale/${id}/weights`,
    method: "GET",
    signal,
  });
};

export const getGetHoldingSaleWeightsQueryKey = (id: number) => {
  return [`/holding-sale/${id}/weights`] as const;
};

export const getGetHoldingSaleWeightsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getHoldingSaleWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHoldingSaleWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHoldingSaleWeightsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHoldingSaleWeights>>
  > = ({ signal }) => getHoldingSaleWeights(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getHoldingSaleWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHoldingSaleWeightsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHoldingSaleWeights>>
>;
export type GetHoldingSaleWeightsInfiniteQueryError = ErrorType<unknown>;

export const useGetHoldingSaleWeightsInfinite = <
  TData = Awaited<ReturnType<typeof getHoldingSaleWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHoldingSaleWeights>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHoldingSaleWeightsInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetHoldingSaleWeightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getHoldingSaleWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHoldingSaleWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHoldingSaleWeightsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHoldingSaleWeights>>
  > = ({ signal }) => getHoldingSaleWeights(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHoldingSaleWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHoldingSaleWeightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHoldingSaleWeights>>
>;
export type GetHoldingSaleWeightsQueryError = ErrorType<unknown>;

export const useGetHoldingSaleWeights = <
  TData = Awaited<ReturnType<typeof getHoldingSaleWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHoldingSaleWeights>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHoldingSaleWeightsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateHoldingSaleWeights = (
  id: number,
  updateHoldingSaleWeightsBody: UpdateHoldingSaleWeightsBody,
) => {
  return request<boolean>({
    url: `/holding-sale/${id}/weights`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateHoldingSaleWeightsBody,
  });
};

export const getUpdateHoldingSaleWeightsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingSaleWeights>>,
    TError,
    { id: number; data: UpdateHoldingSaleWeightsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHoldingSaleWeights>>,
  TError,
  { id: number; data: UpdateHoldingSaleWeightsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHoldingSaleWeights>>,
    { id: number; data: UpdateHoldingSaleWeightsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHoldingSaleWeights(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHoldingSaleWeightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHoldingSaleWeights>>
>;
export type UpdateHoldingSaleWeightsMutationBody = UpdateHoldingSaleWeightsBody;
export type UpdateHoldingSaleWeightsMutationError = ErrorType<HttpError>;

export const useUpdateHoldingSaleWeights = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoldingSaleWeights>>,
    TError,
    { id: number; data: UpdateHoldingSaleWeightsBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateHoldingSaleWeightsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const internalSale = (
  createInternalSaleBody: CreateInternalSaleBody,
) => {
  return request<boolean>({
    url: `/internal-sale`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createInternalSaleBody,
  });
};

export const getInternalSaleMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof internalSale>>,
    TError,
    { data: CreateInternalSaleBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof internalSale>>,
  TError,
  { data: CreateInternalSaleBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof internalSale>>,
    { data: CreateInternalSaleBody }
  > = (props) => {
    const { data } = props ?? {};

    return internalSale(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InternalSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof internalSale>>
>;
export type InternalSaleMutationBody = CreateInternalSaleBody;
export type InternalSaleMutationError = ErrorType<HttpError>;

export const useInternalSale = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof internalSale>>,
    TError,
    { data: CreateInternalSaleBody },
    TContext
  >;
}) => {
  const mutationOptions = getInternalSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateInternalSalesRealizedExcel = (
  generateInternalSalesRealizedExcelBody: GenerateInternalSalesRealizedExcelBody,
) => {
  return request<GenerateInternalSalesRealizedExcelResponse>({
    url: `/internal-sale/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateInternalSalesRealizedExcelBody,
  });
};

export const getGenerateInternalSalesRealizedExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateInternalSalesRealizedExcel>>,
    TError,
    { data: GenerateInternalSalesRealizedExcelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateInternalSalesRealizedExcel>>,
  TError,
  { data: GenerateInternalSalesRealizedExcelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateInternalSalesRealizedExcel>>,
    { data: GenerateInternalSalesRealizedExcelBody }
  > = (props) => {
    const { data } = props ?? {};

    return generateInternalSalesRealizedExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateInternalSalesRealizedExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateInternalSalesRealizedExcel>>
>;
export type GenerateInternalSalesRealizedExcelMutationBody =
  GenerateInternalSalesRealizedExcelBody;
export type GenerateInternalSalesRealizedExcelMutationError =
  ErrorType<unknown>;

export const useGenerateInternalSalesRealizedExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateInternalSalesRealizedExcel>>,
    TError,
    { data: GenerateInternalSalesRealizedExcelBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateInternalSalesRealizedExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateInternalSaleGtas = (
  id: number,
  updateInternalSaleGtasBody: UpdateInternalSaleGtasBody,
) => {
  return request<UpdateInternalSaleGtasResponse>({
    url: `/internal-sale/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateInternalSaleGtasBody,
  });
};

export const getUpdateInternalSaleGtasMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInternalSaleGtas>>,
    TError,
    { id: number; data: UpdateInternalSaleGtasBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInternalSaleGtas>>,
  TError,
  { id: number; data: UpdateInternalSaleGtasBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInternalSaleGtas>>,
    { id: number; data: UpdateInternalSaleGtasBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInternalSaleGtas(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInternalSaleGtasMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInternalSaleGtas>>
>;
export type UpdateInternalSaleGtasMutationBody = UpdateInternalSaleGtasBody;
export type UpdateInternalSaleGtasMutationError = ErrorType<HttpError>;

export const useUpdateInternalSaleGtas = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInternalSaleGtas>>,
    TError,
    { id: number; data: UpdateInternalSaleGtasBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateInternalSaleGtasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteManagementOxenByManagementId = (
  params: DeleteManagementOxenByManagementIdParams,
) => {
  return request<boolean>({ url: `/managements`, method: "DELETE", params });
};

export const getDeleteManagementOxenByManagementIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteManagementOxenByManagementId>>,
    TError,
    { params: DeleteManagementOxenByManagementIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteManagementOxenByManagementId>>,
  TError,
  { params: DeleteManagementOxenByManagementIdParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteManagementOxenByManagementId>>,
    { params: DeleteManagementOxenByManagementIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteManagementOxenByManagementId(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteManagementOxenByManagementIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteManagementOxenByManagementId>>
>;

export type DeleteManagementOxenByManagementIdMutationError =
  ErrorType<unknown>;

export const useDeleteManagementOxenByManagementId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteManagementOxenByManagementId>>,
    TError,
    { params: DeleteManagementOxenByManagementIdParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getDeleteManagementOxenByManagementIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getManagementOxenByManagementId = (
  params: GetManagementOxenByManagementIdParams,
  signal?: AbortSignal,
) => {
  return request<GetManagementOxenByManagementIdResponse>({
    url: `/managements`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetManagementOxenByManagementIdQueryKey = (
  params: GetManagementOxenByManagementIdParams,
) => {
  return [`/managements`, ...(params ? [params] : [])] as const;
};

export const getGetManagementOxenByManagementIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
  TError = ErrorType<HttpError>,
>(
  params: GetManagementOxenByManagementIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetManagementOxenByManagementIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getManagementOxenByManagementId>>
  > = ({ signal }) => getManagementOxenByManagementId(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetManagementOxenByManagementIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getManagementOxenByManagementId>>
>;
export type GetManagementOxenByManagementIdInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetManagementOxenByManagementIdInfinite = <
  TData = Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
  TError = ErrorType<HttpError>,
>(
  params: GetManagementOxenByManagementIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetManagementOxenByManagementIdInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetManagementOxenByManagementIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
  TError = ErrorType<HttpError>,
>(
  params: GetManagementOxenByManagementIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetManagementOxenByManagementIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getManagementOxenByManagementId>>
  > = ({ signal }) => getManagementOxenByManagementId(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetManagementOxenByManagementIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getManagementOxenByManagementId>>
>;
export type GetManagementOxenByManagementIdQueryError = ErrorType<HttpError>;

export const useGetManagementOxenByManagementId = <
  TData = Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
  TError = ErrorType<HttpError>,
>(
  params: GetManagementOxenByManagementIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getManagementOxenByManagementId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetManagementOxenByManagementIdQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createManagementRow = (
  createManagementRowBody: CreateManagementRowBody,
) => {
  return request<boolean>({
    url: `/managements`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createManagementRowBody,
  });
};

export const getCreateManagementRowMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManagementRow>>,
    TError,
    { data: CreateManagementRowBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createManagementRow>>,
  TError,
  { data: CreateManagementRowBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createManagementRow>>,
    { data: CreateManagementRowBody }
  > = (props) => {
    const { data } = props ?? {};

    return createManagementRow(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateManagementRowMutationResult = NonNullable<
  Awaited<ReturnType<typeof createManagementRow>>
>;
export type CreateManagementRowMutationBody = CreateManagementRowBody;
export type CreateManagementRowMutationError = ErrorType<HttpError>;

export const useCreateManagementRow = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManagementRow>>,
    TError,
    { data: CreateManagementRowBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateManagementRowMutationOptions(options);

  return useMutation(mutationOptions);
};

export const entryExecutionSync = (signal?: AbortSignal) => {
  return request<EntryExecutionSyncResponse>({
    url: `/managements/entry-execution-sync`,
    method: "GET",
    signal,
  });
};

export const getEntryExecutionSyncQueryKey = () => {
  return [`/managements/entry-execution-sync`] as const;
};

export const getEntryExecutionSyncInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof entryExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof entryExecutionSync>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEntryExecutionSyncQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entryExecutionSync>>
  > = ({ signal }) => entryExecutionSync(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof entryExecutionSync>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntryExecutionSyncInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof entryExecutionSync>>
>;
export type EntryExecutionSyncInfiniteQueryError = ErrorType<unknown>;

export const useEntryExecutionSyncInfinite = <
  TData = Awaited<ReturnType<typeof entryExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof entryExecutionSync>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getEntryExecutionSyncInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEntryExecutionSyncQueryOptions = <
  TData = Awaited<ReturnType<typeof entryExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof entryExecutionSync>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEntryExecutionSyncQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entryExecutionSync>>
  > = ({ signal }) => entryExecutionSync(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof entryExecutionSync>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntryExecutionSyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof entryExecutionSync>>
>;
export type EntryExecutionSyncQueryError = ErrorType<unknown>;

export const useEntryExecutionSync = <
  TData = Awaited<ReturnType<typeof entryExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof entryExecutionSync>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getEntryExecutionSyncQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const saleExecutionSync = (signal?: AbortSignal) => {
  return request<SaleExecutionSyncResponse>({
    url: `/managements/sale-execution-sync`,
    method: "GET",
    signal,
  });
};

export const getSaleExecutionSyncQueryKey = () => {
  return [`/managements/sale-execution-sync`] as const;
};

export const getSaleExecutionSyncInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof saleExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof saleExecutionSync>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSaleExecutionSyncQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof saleExecutionSync>>
  > = ({ signal }) => saleExecutionSync(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof saleExecutionSync>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SaleExecutionSyncInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof saleExecutionSync>>
>;
export type SaleExecutionSyncInfiniteQueryError = ErrorType<unknown>;

export const useSaleExecutionSyncInfinite = <
  TData = Awaited<ReturnType<typeof saleExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof saleExecutionSync>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSaleExecutionSyncInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSaleExecutionSyncQueryOptions = <
  TData = Awaited<ReturnType<typeof saleExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof saleExecutionSync>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSaleExecutionSyncQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof saleExecutionSync>>
  > = ({ signal }) => saleExecutionSync(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof saleExecutionSync>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SaleExecutionSyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof saleExecutionSync>>
>;
export type SaleExecutionSyncQueryError = ErrorType<unknown>;

export const useSaleExecutionSync = <
  TData = Awaited<ReturnType<typeof saleExecutionSync>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof saleExecutionSync>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSaleExecutionSyncQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listManagementSessions = (
  params?: ListManagementSessionsParams,
  signal?: AbortSignal,
) => {
  return request<ListManagementSessionsResponse>({
    url: `/managements/sessions`,
    method: "GET",
    params,
    signal,
  });
};

export const getListManagementSessionsQueryKey = (
  params?: ListManagementSessionsParams,
) => {
  return [`/managements/sessions`, ...(params ? [params] : [])] as const;
};

export const getListManagementSessionsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listManagementSessions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagementSessionsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listManagementSessions>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListManagementSessionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listManagementSessions>>
  > = ({ signal }) => listManagementSessions(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listManagementSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListManagementSessionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listManagementSessions>>
>;
export type ListManagementSessionsInfiniteQueryError = ErrorType<unknown>;

export const useListManagementSessionsInfinite = <
  TData = Awaited<ReturnType<typeof listManagementSessions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagementSessionsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listManagementSessions>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListManagementSessionsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListManagementSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listManagementSessions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagementSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listManagementSessions>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListManagementSessionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listManagementSessions>>
  > = ({ signal }) => listManagementSessions(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listManagementSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListManagementSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listManagementSessions>>
>;
export type ListManagementSessionsQueryError = ErrorType<unknown>;

export const useListManagementSessions = <
  TData = Awaited<ReturnType<typeof listManagementSessions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagementSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listManagementSessions>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListManagementSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createManagementSession = (
  createManagementSession: CreateManagementSession,
) => {
  return request<CreateManagementSessionResponse>({
    url: `/managements/sessions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createManagementSession,
  });
};

export const getCreateManagementSessionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManagementSession>>,
    TError,
    { data: CreateManagementSession },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createManagementSession>>,
  TError,
  { data: CreateManagementSession },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createManagementSession>>,
    { data: CreateManagementSession }
  > = (props) => {
    const { data } = props ?? {};

    return createManagementSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateManagementSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createManagementSession>>
>;
export type CreateManagementSessionMutationBody = CreateManagementSession;
export type CreateManagementSessionMutationError = ErrorType<HttpError>;

export const useCreateManagementSession = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManagementSession>>,
    TError,
    { data: CreateManagementSession },
    TContext
  >;
}) => {
  const mutationOptions = getCreateManagementSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportManagementSessionExtractExcel = (
  managementSessionExtractExportRequest: ManagementSessionExtractExportRequest,
) => {
  return request<ExportManagementSessionExtractExcelResponse>({
    url: `/managements/sessions/export-excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: managementSessionExtractExportRequest,
  });
};

export const getExportManagementSessionExtractExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportManagementSessionExtractExcel>>,
    TError,
    { data: ManagementSessionExtractExportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportManagementSessionExtractExcel>>,
  TError,
  { data: ManagementSessionExtractExportRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportManagementSessionExtractExcel>>,
    { data: ManagementSessionExtractExportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportManagementSessionExtractExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportManagementSessionExtractExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportManagementSessionExtractExcel>>
>;
export type ExportManagementSessionExtractExcelMutationBody =
  ManagementSessionExtractExportRequest;
export type ExportManagementSessionExtractExcelMutationError =
  ErrorType<unknown>;

export const useExportManagementSessionExtractExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportManagementSessionExtractExcel>>,
    TError,
    { data: ManagementSessionExtractExportRequest },
    TContext
  >;
}) => {
  const mutationOptions =
    getExportManagementSessionExtractExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Soft delete da sessão: status INACTIVE + limpeza de `ManagementList`. Não preenche `finishedById` (diferencia
"excluído" de "finalizado"). As linhas em `ManagementSessionExtractLine` são preservadas para consulta histórica.
 */
export const deleteManagementSession = (uuid: string) => {
  return request<DeleteManagementSessionResponse>({
    url: `/managements/sessions/${uuid}`,
    method: "DELETE",
  });
};

export const getDeleteManagementSessionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteManagementSession>>,
    TError,
    { uuid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteManagementSession>>,
  TError,
  { uuid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteManagementSession>>,
    { uuid: string }
  > = (props) => {
    const { uuid } = props ?? {};

    return deleteManagementSession(uuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteManagementSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteManagementSession>>
>;

export type DeleteManagementSessionMutationError = ErrorType<HttpError>;

export const useDeleteManagementSession = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteManagementSession>>,
    TError,
    { uuid: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteManagementSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lê uma sessão de manejo pelo `uuid`. Usado pela página de extrato (`session/[id]`) sem precisar carregar a lista
inteira.
 */
export const getManagementSession = (uuid: string, signal?: AbortSignal) => {
  return request<GetManagementSessionResponse>({
    url: `/managements/sessions/${uuid}`,
    method: "GET",
    signal,
  });
};

export const getGetManagementSessionQueryKey = (uuid: string) => {
  return [`/managements/sessions/${uuid}`] as const;
};

export const getGetManagementSessionInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getManagementSession>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getManagementSession>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetManagementSessionQueryKey(uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getManagementSession>>
  > = ({ signal }) => getManagementSession(uuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!uuid,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getManagementSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetManagementSessionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getManagementSession>>
>;
export type GetManagementSessionInfiniteQueryError = ErrorType<HttpError>;

export const useGetManagementSessionInfinite = <
  TData = Awaited<ReturnType<typeof getManagementSession>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getManagementSession>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetManagementSessionInfiniteQueryOptions(
    uuid,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetManagementSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getManagementSession>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getManagementSession>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetManagementSessionQueryKey(uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getManagementSession>>
  > = ({ signal }) => getManagementSession(uuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!uuid,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getManagementSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetManagementSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getManagementSession>>
>;
export type GetManagementSessionQueryError = ErrorType<HttpError>;

export const useGetManagementSession = <
  TData = Awaited<ReturnType<typeof getManagementSession>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getManagementSession>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetManagementSessionQueryOptions(uuid, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateManagementSession = (
  uuid: string,
  updateManagementSession: UpdateManagementSession,
) => {
  return request<UpdateManagementSessionResponse>({
    url: `/managements/sessions/${uuid}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateManagementSession,
  });
};

export const getUpdateManagementSessionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateManagementSession>>,
    TError,
    { uuid: string; data: UpdateManagementSession },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateManagementSession>>,
  TError,
  { uuid: string; data: UpdateManagementSession },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateManagementSession>>,
    { uuid: string; data: UpdateManagementSession }
  > = (props) => {
    const { uuid, data } = props ?? {};

    return updateManagementSession(uuid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateManagementSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateManagementSession>>
>;
export type UpdateManagementSessionMutationBody = UpdateManagementSession;
export type UpdateManagementSessionMutationError = ErrorType<HttpError>;

export const useUpdateManagementSession = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateManagementSession>>,
    TError,
    { uuid: string; data: UpdateManagementSession },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateManagementSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Aplica no servidor um animal cadastrado offline no manejo de entrada, na ordem do cadastro presencial: cria o animal
pelo mesmo caminho do POST /oxen (validações, peso de entrada, sanidade, lote, vaga da GTA), põe na lista do manejo e
grava a linha `ml:` do extrato. Cada passo confere o que o anterior já deixou: uma chamada interrompida pode ser
repetida sem criar o animal duas vezes.
 */
export const applyEntryEvent = (
  uuid: string,
  applyEntryEvent: ApplyEntryEvent,
) => {
  return request<ApplyEntryEventResult>({
    url: `/managements/sessions/${uuid}/entry-events`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyEntryEvent,
  });
};

export const getApplyEntryEventMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyEntryEvent>>,
    TError,
    { uuid: string; data: ApplyEntryEvent },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyEntryEvent>>,
  TError,
  { uuid: string; data: ApplyEntryEvent },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyEntryEvent>>,
    { uuid: string; data: ApplyEntryEvent }
  > = (props) => {
    const { uuid, data } = props ?? {};

    return applyEntryEvent(uuid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyEntryEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyEntryEvent>>
>;
export type ApplyEntryEventMutationBody = ApplyEntryEvent;
export type ApplyEntryEventMutationError = ErrorType<HttpError>;

export const useApplyEntryEvent = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyEntryEvent>>,
    TError,
    { uuid: string; data: ApplyEntryEvent },
    TContext
  >;
}) => {
  const mutationOptions = getApplyEntryEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Comprovante do manejo: linhas arquivadas em `ManagementSessionExtractLine` (manejo + auditoria), sem filtro por dia
operacional; persistem após finalizar a sessão.
 */
export const listManagementSessionExtractAnimals = (
  uuid: string,
  signal?: AbortSignal,
) => {
  return request<ListManagementSessionExtractAnimalsResponse>({
    url: `/managements/sessions/${uuid}/extract-animals`,
    method: "GET",
    signal,
  });
};

export const getListManagementSessionExtractAnimalsQueryKey = (
  uuid: string,
) => {
  return [`/managements/sessions/${uuid}/extract-animals`] as const;
};

export const getListManagementSessionExtractAnimalsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListManagementSessionExtractAnimalsQueryKey(uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>
  > = ({ signal }) => listManagementSessionExtractAnimals(uuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!uuid,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListManagementSessionExtractAnimalsInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>>;
export type ListManagementSessionExtractAnimalsInfiniteQueryError =
  ErrorType<HttpError>;

export const useListManagementSessionExtractAnimalsInfinite = <
  TData = Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListManagementSessionExtractAnimalsInfiniteQueryOptions(uuid, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListManagementSessionExtractAnimalsQueryOptions = <
  TData = Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListManagementSessionExtractAnimalsQueryKey(uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>
  > = ({ signal }) => listManagementSessionExtractAnimals(uuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!uuid,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListManagementSessionExtractAnimalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>
>;
export type ListManagementSessionExtractAnimalsQueryError =
  ErrorType<HttpError>;

export const useListManagementSessionExtractAnimals = <
  TData = Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
  TError = ErrorType<HttpError>,
>(
  uuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listManagementSessionExtractAnimals>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListManagementSessionExtractAnimalsQueryOptions(
    uuid,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Finaliza a sessão de manejo: status INACTIVE, registra quem finalizou e remove linhas em ManagementList.
 */
export const finalizeManagementSession = (uuid: string) => {
  return request<FinalizeManagementSessionResponse>({
    url: `/managements/sessions/${uuid}/finalize`,
    method: "POST",
  });
};

export const getFinalizeManagementSessionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeManagementSession>>,
    TError,
    { uuid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeManagementSession>>,
  TError,
  { uuid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeManagementSession>>,
    { uuid: string }
  > = (props) => {
    const { uuid } = props ?? {};

    return finalizeManagementSession(uuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeManagementSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeManagementSession>>
>;

export type FinalizeManagementSessionMutationError = ErrorType<HttpError>;

export const useFinalizeManagementSession = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeManagementSession>>,
    TError,
    { uuid: string },
    TContext
  >;
}) => {
  const mutationOptions = getFinalizeManagementSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Aplica no servidor uma pesagem gravada offline, na ordem do manejo presencial: características, peso, apartação e
lista do manejo. O extrato ganha as mesmas linhas da pesagem presencial (`ow:` na origem, `ml:` no destino).
 */
export const applyWeighingEvent = (
  uuid: string,
  applyWeighingEvent: ApplyWeighingEvent,
) => {
  return request<ApplyWeighingEventResult>({
    url: `/managements/sessions/${uuid}/weighing-events`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyWeighingEvent,
  });
};

export const getApplyWeighingEventMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyWeighingEvent>>,
    TError,
    { uuid: string; data: ApplyWeighingEvent },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyWeighingEvent>>,
  TError,
  { uuid: string; data: ApplyWeighingEvent },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyWeighingEvent>>,
    { uuid: string; data: ApplyWeighingEvent }
  > = (props) => {
    const { uuid, data } = props ?? {};

    return applyWeighingEvent(uuid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyWeighingEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyWeighingEvent>>
>;
export type ApplyWeighingEventMutationBody = ApplyWeighingEvent;
export type ApplyWeighingEventMutationError = ErrorType<HttpError>;

export const useApplyWeighingEvent = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyWeighingEvent>>,
    TError,
    { uuid: string; data: ApplyWeighingEvent },
    TContext
  >;
}) => {
  const mutationOptions = getApplyWeighingEventMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMedicines = (
  params?: GetMedicinesParams,
  signal?: AbortSignal,
) => {
  return request<GetMedicinesResponse>({
    url: `/medicines`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMedicinesQueryKey = (params?: GetMedicinesParams) => {
  return [`/medicines`, ...(params ? [params] : [])] as const;
};

export const getGetMedicinesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicines>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicinesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMedicines>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicinesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicines>>> = ({
    signal,
  }) => getMedicines(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMedicines>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMedicinesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedicines>>
>;
export type GetMedicinesInfiniteQueryError = ErrorType<unknown>;

export const useGetMedicinesInfinite = <
  TData = Awaited<ReturnType<typeof getMedicines>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicinesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMedicines>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMedicinesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetMedicinesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicines>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicinesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMedicines>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicinesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicines>>> = ({
    signal,
  }) => getMedicines(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedicines>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMedicinesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedicines>>
>;
export type GetMedicinesQueryError = ErrorType<unknown>;

export const useGetMedicines = <
  TData = Awaited<ReturnType<typeof getMedicines>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicinesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMedicines>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMedicinesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createMedicine = (createMedicine: CreateMedicine) => {
  return request<CreateMedicineResponse>({
    url: `/medicines`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createMedicine,
  });
};

export const getCreateMedicineMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMedicine>>,
    TError,
    { data: CreateMedicine },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMedicine>>,
  TError,
  { data: CreateMedicine },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMedicine>>,
    { data: CreateMedicine }
  > = (props) => {
    const { data } = props ?? {};

    return createMedicine(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMedicineMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMedicine>>
>;
export type CreateMedicineMutationBody = CreateMedicine;
export type CreateMedicineMutationError = ErrorType<HttpError>;

export const useCreateMedicine = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMedicine>>,
    TError,
    { data: CreateMedicine },
    TContext
  >;
}) => {
  const mutationOptions = getCreateMedicineMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * ### ID string is name, number is ID.
 */
export const getMedicine = (id: number | string, signal?: AbortSignal) => {
  return request<GetMedicineResponse>({
    url: `/medicines/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetMedicineQueryKey = (id: number | string) => {
  return [`/medicines/${id}`] as const;
};

export const getGetMedicineInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicine>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMedicine>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicineQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicine>>> = ({
    signal,
  }) => getMedicine(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMedicine>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMedicineInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedicine>>
>;
export type GetMedicineInfiniteQueryError = ErrorType<unknown>;

export const useGetMedicineInfinite = <
  TData = Awaited<ReturnType<typeof getMedicine>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMedicine>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMedicineInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetMedicineQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicine>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMedicine>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicineQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicine>>> = ({
    signal,
  }) => getMedicine(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedicine>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMedicineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedicine>>
>;
export type GetMedicineQueryError = ErrorType<unknown>;

export const useGetMedicine = <
  TData = Awaited<ReturnType<typeof getMedicine>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMedicine>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMedicineQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const addMedicineImages = (
  id: number,
  addMedicineImage: AddMedicineImage[],
) => {
  return request<AddMedicineImagesResponse>({
    url: `/medicines/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addMedicineImage,
  });
};

export const getAddMedicineImagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addMedicineImages>>,
    TError,
    { id: number; data: AddMedicineImage[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addMedicineImages>>,
  TError,
  { id: number; data: AddMedicineImage[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addMedicineImages>>,
    { id: number; data: AddMedicineImage[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return addMedicineImages(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddMedicineImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof addMedicineImages>>
>;
export type AddMedicineImagesMutationBody = AddMedicineImage[];
export type AddMedicineImagesMutationError = ErrorType<unknown>;

export const useAddMedicineImages = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addMedicineImages>>,
    TError,
    { id: number; data: AddMedicineImage[] },
    TContext
  >;
}) => {
  const mutationOptions = getAddMedicineImagesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateMedicine = (id: number, updateMedicine: UpdateMedicine) => {
  return request<UpdateMedicineResponse>({
    url: `/medicines/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateMedicine,
  });
};

export const getUpdateMedicineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMedicine>>,
    TError,
    { id: number; data: UpdateMedicine },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMedicine>>,
  TError,
  { id: number; data: UpdateMedicine },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMedicine>>,
    { id: number; data: UpdateMedicine }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMedicine(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMedicineMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMedicine>>
>;
export type UpdateMedicineMutationBody = UpdateMedicine;
export type UpdateMedicineMutationError = ErrorType<unknown>;

export const useUpdateMedicine = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMedicine>>,
    TError,
    { id: number; data: UpdateMedicine },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateMedicineMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ativa ou desativa uma dieta para ser listada no frontend.
 */
export const activateMedicine = (
  id: number,
  params: ActivateMedicineParams,
) => {
  return request<ActivateMedicineResponse>({
    url: `/medicines/${id}/active`,
    method: "POST",
    params,
  });
};

export const getActivateMedicineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateMedicine>>,
    TError,
    { id: number; params: ActivateMedicineParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateMedicine>>,
  TError,
  { id: number; params: ActivateMedicineParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateMedicine>>,
    { id: number; params: ActivateMedicineParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return activateMedicine(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateMedicineMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateMedicine>>
>;

export type ActivateMedicineMutationError = ErrorType<unknown>;

export const useActivateMedicine = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateMedicine>>,
    TError,
    { id: number; params: ActivateMedicineParams },
    TContext
  >;
}) => {
  const mutationOptions = getActivateMedicineMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listMixers = (signal?: AbortSignal) => {
  return request<ListMixersResponse>({ url: `/mixer`, method: "GET", signal });
};

export const getListMixersQueryKey = () => {
  return [`/mixer`] as const;
};

export const getListMixersInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listMixers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listMixers>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMixersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMixers>>> = ({
    signal,
  }) => listMixers(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listMixers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMixersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMixers>>
>;
export type ListMixersInfiniteQueryError = ErrorType<unknown>;

export const useListMixersInfinite = <
  TData = Awaited<ReturnType<typeof listMixers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listMixers>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListMixersInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListMixersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMixers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMixers>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMixersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMixers>>> = ({
    signal,
  }) => listMixers(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMixers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMixersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMixers>>
>;
export type ListMixersQueryError = ErrorType<unknown>;

export const useListMixers = <
  TData = Awaited<ReturnType<typeof listMixers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMixers>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListMixersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createMixer = (createMixer: CreateMixer) => {
  return request<CreateMixerResponse>({
    url: `/mixer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createMixer,
  });
};

export const getCreateMixerMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMixer>>,
    TError,
    { data: CreateMixer },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMixer>>,
  TError,
  { data: CreateMixer },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMixer>>,
    { data: CreateMixer }
  > = (props) => {
    const { data } = props ?? {};

    return createMixer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMixerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMixer>>
>;
export type CreateMixerMutationBody = CreateMixer;
export type CreateMixerMutationError = ErrorType<HttpError>;

export const useCreateMixer = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMixer>>,
    TError,
    { data: CreateMixer },
    TContext
  >;
}) => {
  const mutationOptions = getCreateMixerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMixer = (id: number, signal?: AbortSignal) => {
  return request<GetMixerResponse>({
    url: `/mixer/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetMixerQueryKey = (id: number) => {
  return [`/mixer/${id}`] as const;
};

export const getGetMixerInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getMixer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMixer>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMixerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMixer>>> = ({
    signal,
  }) => getMixer(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMixer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMixerInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMixer>>
>;
export type GetMixerInfiniteQueryError = ErrorType<unknown>;

export const useGetMixerInfinite = <
  TData = Awaited<ReturnType<typeof getMixer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMixer>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMixerInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetMixerQueryOptions = <
  TData = Awaited<ReturnType<typeof getMixer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMixer>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMixerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMixer>>> = ({
    signal,
  }) => getMixer(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getMixer>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetMixerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMixer>>
>;
export type GetMixerQueryError = ErrorType<unknown>;

export const useGetMixer = <
  TData = Awaited<ReturnType<typeof getMixer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMixer>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMixerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateMixer = (id: number, updateMixer: UpdateMixer) => {
  return request<UpdateMixerResponse>({
    url: `/mixer/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateMixer,
  });
};

export const getUpdateMixerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMixer>>,
    TError,
    { id: number; data: UpdateMixer },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMixer>>,
  TError,
  { id: number; data: UpdateMixer },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMixer>>,
    { id: number; data: UpdateMixer }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMixer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMixerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMixer>>
>;
export type UpdateMixerMutationBody = UpdateMixer;
export type UpdateMixerMutationError = ErrorType<unknown>;

export const useUpdateMixer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMixer>>,
    TError,
    { id: number; data: UpdateMixer },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateMixerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const disableMixer = (id: string, params: DisableMixerParams) => {
  return request<DisableMixerResponse>({
    url: `/mixer/${id}/active`,
    method: "DELETE",
    params,
  });
};

export const getDisableMixerMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableMixer>>,
    TError,
    { id: string; params: DisableMixerParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableMixer>>,
  TError,
  { id: string; params: DisableMixerParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableMixer>>,
    { id: string; params: DisableMixerParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return disableMixer(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableMixerMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableMixer>>
>;

export type DisableMixerMutationError = ErrorType<HttpError>;

export const useDisableMixer = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableMixer>>,
    TError,
    { id: string; params: DisableMixerParams },
    TContext
  >;
}) => {
  const mutationOptions = getDisableMixerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const searchAnimalSwap = (
  params: SearchAnimalSwapParams,
  signal?: AbortSignal,
) => {
  return request<AnimalSwapSearchResult>({
    url: `/moderator/animal-swap`,
    method: "GET",
    params,
    signal,
  });
};

export const getSearchAnimalSwapQueryKey = (params: SearchAnimalSwapParams) => {
  return [`/moderator/animal-swap`, ...(params ? [params] : [])] as const;
};

export const getSearchAnimalSwapInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAnimalSwap>>,
  TError = ErrorType<HttpError>,
>(
  params: SearchAnimalSwapParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof searchAnimalSwap>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchAnimalSwapQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchAnimalSwap>>
  > = ({ signal }) => searchAnimalSwap(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof searchAnimalSwap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchAnimalSwapInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchAnimalSwap>>
>;
export type SearchAnimalSwapInfiniteQueryError = ErrorType<HttpError>;

export const useSearchAnimalSwapInfinite = <
  TData = Awaited<ReturnType<typeof searchAnimalSwap>>,
  TError = ErrorType<HttpError>,
>(
  params: SearchAnimalSwapParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof searchAnimalSwap>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchAnimalSwapInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSearchAnimalSwapQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAnimalSwap>>,
  TError = ErrorType<HttpError>,
>(
  params: SearchAnimalSwapParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchAnimalSwap>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchAnimalSwapQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchAnimalSwap>>
  > = ({ signal }) => searchAnimalSwap(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchAnimalSwap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchAnimalSwapQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchAnimalSwap>>
>;
export type SearchAnimalSwapQueryError = ErrorType<HttpError>;

export const useSearchAnimalSwap = <
  TData = Awaited<ReturnType<typeof searchAnimalSwap>>,
  TError = ErrorType<HttpError>,
>(
  params: SearchAnimalSwapParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchAnimalSwap>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchAnimalSwapQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const applyAnimalSwap = (applyAnimalSwapBody: ApplyAnimalSwapBody) => {
  return request<ApplyAnimalSwapResult>({
    url: `/moderator/animal-swap/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyAnimalSwapBody,
  });
};

export const getApplyAnimalSwapMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyAnimalSwap>>,
    TError,
    { data: ApplyAnimalSwapBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyAnimalSwap>>,
  TError,
  { data: ApplyAnimalSwapBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyAnimalSwap>>,
    { data: ApplyAnimalSwapBody }
  > = (props) => {
    const { data } = props ?? {};

    return applyAnimalSwap(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyAnimalSwapMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyAnimalSwap>>
>;
export type ApplyAnimalSwapMutationBody = ApplyAnimalSwapBody;
export type ApplyAnimalSwapMutationError = ErrorType<HttpError>;

export const useApplyAnimalSwap = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyAnimalSwap>>,
    TError,
    { data: ApplyAnimalSwapBody },
    TContext
  >;
}) => {
  const mutationOptions = getApplyAnimalSwapMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Busca os animais informados, mantém só os mortos e os agrupa pelo lote em que morreram (última passagem por lote).
Cada grupo informa se o lote está finalizado e se o curral original já está ocupado por outro lote.
 */
export const searchBatchReactivation = (
  batchReactivationSearchBody: BatchReactivationSearchBody,
) => {
  return request<BatchReactivationSearchResult>({
    url: `/moderator/batch-reactivation`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: batchReactivationSearchBody,
  });
};

export const getSearchBatchReactivationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchBatchReactivation>>,
    TError,
    { data: BatchReactivationSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchBatchReactivation>>,
  TError,
  { data: BatchReactivationSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchBatchReactivation>>,
    { data: BatchReactivationSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return searchBatchReactivation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchBatchReactivationMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchBatchReactivation>>
>;
export type SearchBatchReactivationMutationBody = BatchReactivationSearchBody;
export type SearchBatchReactivationMutationError = ErrorType<unknown>;

export const useSearchBatchReactivation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchBatchReactivation>>,
    TError,
    { data: BatchReactivationSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getSearchBatchReactivationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Estorna os animais informados (revive e reabre o vínculo no lote) e reativa o lote finalizado como um novo "dia 0":
escolhe o curral (original se livre, senão o informado), reaproveita o último tratamento/dieta (ou os informados), e
gera o histórico DAY_0 do dia.
 */
export const applyBatchReactivation = (
  applyBatchReactivationBody: ApplyBatchReactivationBody,
) => {
  return request<ApplyBatchReactivationResult>({
    url: `/moderator/batch-reactivation/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyBatchReactivationBody,
  });
};

export const getApplyBatchReactivationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchReactivation>>,
    TError,
    { data: ApplyBatchReactivationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyBatchReactivation>>,
  TError,
  { data: ApplyBatchReactivationBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyBatchReactivation>>,
    { data: ApplyBatchReactivationBody }
  > = (props) => {
    const { data } = props ?? {};

    return applyBatchReactivation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyBatchReactivationMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyBatchReactivation>>
>;
export type ApplyBatchReactivationMutationBody = ApplyBatchReactivationBody;
export type ApplyBatchReactivationMutationError = ErrorType<HttpError>;

export const useApplyBatchReactivation = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBatchReactivation>>,
    TError,
    { data: ApplyBatchReactivationBody },
    TContext
  >;
}) => {
  const mutationOptions = getApplyBatchReactivationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lotes ativos que ainda não entraram em transição de dieta, agrupados pela dieta vigente e pela quantidade de tratos.
Cada grupo recebe de uma vez só a mesma transição e a mesma dieta alvo.
 */
export const listBulkDietTransitionGroups = (signal?: AbortSignal) => {
  return request<BulkDietTransitionResult>({
    url: `/moderator/bulk-diet-transition`,
    method: "GET",
    signal,
  });
};

export const getListBulkDietTransitionGroupsQueryKey = () => {
  return [`/moderator/bulk-diet-transition`] as const;
};

export const getListBulkDietTransitionGroupsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBulkDietTransitionGroupsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>
  > = ({ signal }) => listBulkDietTransitionGroups(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBulkDietTransitionGroupsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBulkDietTransitionGroups>>
>;
export type ListBulkDietTransitionGroupsInfiniteQueryError = ErrorType<unknown>;

export const useListBulkDietTransitionGroupsInfinite = <
  TData = Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListBulkDietTransitionGroupsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBulkDietTransitionGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBulkDietTransitionGroupsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>
  > = ({ signal }) => listBulkDietTransitionGroups(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBulkDietTransitionGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBulkDietTransitionGroups>>
>;
export type ListBulkDietTransitionGroupsQueryError = ErrorType<unknown>;

export const useListBulkDietTransitionGroups = <
  TData = Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBulkDietTransitionGroups>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBulkDietTransitionGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aplica a mesma transição de dieta em todos os lotes de cada grupo. Cada lote é aplicado em sua própria transação: um
lote que falhar não impede os demais, e volta na lista de falhas.
 */
export const applyBulkDietTransition = (
  applyBulkDietTransitionBody: ApplyBulkDietTransitionBody,
) => {
  return request<ApplyBulkDietTransitionResult>({
    url: `/moderator/bulk-diet-transition/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyBulkDietTransitionBody,
  });
};

export const getApplyBulkDietTransitionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBulkDietTransition>>,
    TError,
    { data: ApplyBulkDietTransitionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyBulkDietTransition>>,
  TError,
  { data: ApplyBulkDietTransitionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyBulkDietTransition>>,
    { data: ApplyBulkDietTransitionBody }
  > = (props) => {
    const { data } = props ?? {};

    return applyBulkDietTransition(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyBulkDietTransitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyBulkDietTransition>>
>;
export type ApplyBulkDietTransitionMutationBody = ApplyBulkDietTransitionBody;
export type ApplyBulkDietTransitionMutationError = ErrorType<HttpError>;

export const useApplyBulkDietTransition = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyBulkDietTransition>>,
    TError,
    { data: ApplyBulkDietTransitionBody },
    TContext
  >;
}) => {
  const mutationOptions = getApplyBulkDietTransitionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMasterConfig = (signal?: AbortSignal) => {
  return request<GetMasterConfigResponse>({
    url: `/moderator/master-config`,
    method: "GET",
    signal,
  });
};

export const getGetMasterConfigQueryKey = () => {
  return [`/moderator/master-config`] as const;
};

export const getGetMasterConfigInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getMasterConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMasterConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMasterConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMasterConfig>>> = ({
    signal,
  }) => getMasterConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMasterConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMasterConfigInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMasterConfig>>
>;
export type GetMasterConfigInfiniteQueryError = ErrorType<unknown>;

export const useGetMasterConfigInfinite = <
  TData = Awaited<ReturnType<typeof getMasterConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMasterConfig>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMasterConfigInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetMasterConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getMasterConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMasterConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMasterConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMasterConfig>>> = ({
    signal,
  }) => getMasterConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMasterConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMasterConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMasterConfig>>
>;
export type GetMasterConfigQueryError = ErrorType<unknown>;

export const useGetMasterConfig = <
  TData = Awaited<ReturnType<typeof getMasterConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMasterConfig>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMasterConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const upsertMasterConfig = (
  upsertMasterConfigBody: UpsertMasterConfigBody,
) => {
  return request<boolean>({
    url: `/moderator/master-config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: upsertMasterConfigBody,
  });
};

export const getUpsertMasterConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertMasterConfig>>,
    TError,
    { data: UpsertMasterConfigBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertMasterConfig>>,
  TError,
  { data: UpsertMasterConfigBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertMasterConfig>>,
    { data: UpsertMasterConfigBody }
  > = (props) => {
    const { data } = props ?? {};

    return upsertMasterConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertMasterConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertMasterConfig>>
>;
export type UpsertMasterConfigMutationBody = UpsertMasterConfigBody;
export type UpsertMasterConfigMutationError = ErrorType<unknown>;

export const useUpsertMasterConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertMasterConfig>>,
    TError,
    { data: UpsertMasterConfigBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpsertMasterConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOperationalCostConfig = (signal?: AbortSignal) => {
  return request<GetOperationalCostConfigResponse>({
    url: `/moderator/operational-cost-config`,
    method: "GET",
    signal,
  });
};

export const getGetOperationalCostConfigQueryKey = () => {
  return [`/moderator/operational-cost-config`] as const;
};

export const getGetOperationalCostConfigInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationalCostConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOperationalCostConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOperationalCostConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOperationalCostConfig>>
  > = ({ signal }) => getOperationalCostConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOperationalCostConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOperationalCostConfigInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationalCostConfig>>
>;
export type GetOperationalCostConfigInfiniteQueryError = ErrorType<unknown>;

export const useGetOperationalCostConfigInfinite = <
  TData = Awaited<ReturnType<typeof getOperationalCostConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOperationalCostConfig>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOperationalCostConfigInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetOperationalCostConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationalCostConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOperationalCostConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOperationalCostConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOperationalCostConfig>>
  > = ({ signal }) => getOperationalCostConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOperationalCostConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOperationalCostConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationalCostConfig>>
>;
export type GetOperationalCostConfigQueryError = ErrorType<unknown>;

export const useGetOperationalCostConfig = <
  TData = Awaited<ReturnType<typeof getOperationalCostConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOperationalCostConfig>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOperationalCostConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const upsertOperationalCostConfig = (
  upsertOperationalCostConfigBody: UpsertOperationalCostConfigBody,
) => {
  return request<boolean>({
    url: `/moderator/operational-cost-config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: upsertOperationalCostConfigBody,
  });
};

export const getUpsertOperationalCostConfigMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertOperationalCostConfig>>,
    TError,
    { data: UpsertOperationalCostConfigBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertOperationalCostConfig>>,
  TError,
  { data: UpsertOperationalCostConfigBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertOperationalCostConfig>>,
    { data: UpsertOperationalCostConfigBody }
  > = (props) => {
    const { data } = props ?? {};

    return upsertOperationalCostConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertOperationalCostConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertOperationalCostConfig>>
>;
export type UpsertOperationalCostConfigMutationBody =
  UpsertOperationalCostConfigBody;
export type UpsertOperationalCostConfigMutationError = ErrorType<HttpError>;

export const useUpsertOperationalCostConfig = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertOperationalCostConfig>>,
    TError,
    { data: UpsertOperationalCostConfigBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpsertOperationalCostConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Prévia da conversão de pasto em piquete: lista os dias sem realizado de trato que serão preenchidos com 0/REPLICATED.
 */
export const previewPastureToPicket = (
  pastureToPicketBody: PastureToPicketBody,
) => {
  return request<PastureToPicketPreviewResult>({
    url: `/moderator/pasture-to-picket`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: pastureToPicketBody,
  });
};

export const getPreviewPastureToPicketMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPastureToPicket>>,
    TError,
    { data: PastureToPicketBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewPastureToPicket>>,
  TError,
  { data: PastureToPicketBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewPastureToPicket>>,
    { data: PastureToPicketBody }
  > = (props) => {
    const { data } = props ?? {};

    return previewPastureToPicket(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewPastureToPicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewPastureToPicket>>
>;
export type PreviewPastureToPicketMutationBody = PastureToPicketBody;
export type PreviewPastureToPicketMutationError = ErrorType<HttpError>;

export const usePreviewPastureToPicket = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPastureToPicket>>,
    TError,
    { data: PastureToPicketBody },
    TContext
  >;
}) => {
  const mutationOptions = getPreviewPastureToPicketMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Converte um lote de pasto em piquete: troca o tipo do curral para PICKET e preenche os dias sem realizado de trato
(entre a ativação e o dia da fazenda) com realizado 0 e tipo REPLICATED. Mesma ideia do ajuste retroativo de data.
 */
export const applyPastureToPicket = (
  pastureToPicketBody: PastureToPicketBody,
) => {
  return request<ApplyPastureToPicketResult>({
    url: `/moderator/pasture-to-picket/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: pastureToPicketBody,
  });
};

export const getApplyPastureToPicketMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyPastureToPicket>>,
    TError,
    { data: PastureToPicketBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyPastureToPicket>>,
  TError,
  { data: PastureToPicketBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyPastureToPicket>>,
    { data: PastureToPicketBody }
  > = (props) => {
    const { data } = props ?? {};

    return applyPastureToPicket(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyPastureToPicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyPastureToPicket>>
>;
export type ApplyPastureToPicketMutationBody = PastureToPicketBody;
export type ApplyPastureToPicketMutationError = ErrorType<HttpError>;

export const useApplyPastureToPicket = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyPastureToPicket>>,
    TError,
    { data: PastureToPicketBody },
    TContext
  >;
}) => {
  const mutationOptions = getApplyPastureToPicketMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPurchaseConfig = (signal?: AbortSignal) => {
  return request<GetPurchaseConfigResponse>({
    url: `/moderator/purchase-order-config`,
    method: "GET",
    signal,
  });
};

export const getGetPurchaseConfigQueryKey = () => {
  return [`/moderator/purchase-order-config`] as const;
};

export const getGetPurchaseConfigInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchaseConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPurchaseConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPurchaseConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPurchaseConfig>>
  > = ({ signal }) => getPurchaseConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPurchaseConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPurchaseConfigInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchaseConfig>>
>;
export type GetPurchaseConfigInfiniteQueryError = ErrorType<unknown>;

export const useGetPurchaseConfigInfinite = <
  TData = Awaited<ReturnType<typeof getPurchaseConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPurchaseConfig>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPurchaseConfigInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetPurchaseConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchaseConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPurchaseConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPurchaseConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPurchaseConfig>>
  > = ({ signal }) => getPurchaseConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchaseConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPurchaseConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchaseConfig>>
>;
export type GetPurchaseConfigQueryError = ErrorType<unknown>;

export const useGetPurchaseConfig = <
  TData = Awaited<ReturnType<typeof getPurchaseConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPurchaseConfig>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPurchaseConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const upsertPurchaseConfig = (
  upsertPurchaseConfigBody: UpsertPurchaseConfigBody,
) => {
  return request<boolean>({
    url: `/moderator/purchase-order-config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: upsertPurchaseConfigBody,
  });
};

export const getUpsertPurchaseConfigMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPurchaseConfig>>,
    TError,
    { data: UpsertPurchaseConfigBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertPurchaseConfig>>,
  TError,
  { data: UpsertPurchaseConfigBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertPurchaseConfig>>,
    { data: UpsertPurchaseConfigBody }
  > = (props) => {
    const { data } = props ?? {};

    return upsertPurchaseConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertPurchaseConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertPurchaseConfig>>
>;
export type UpsertPurchaseConfigMutationBody = UpsertPurchaseConfigBody;
export type UpsertPurchaseConfigMutationError = ErrorType<HttpError>;

export const useUpsertPurchaseConfig = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPurchaseConfig>>,
    TError,
    { data: UpsertPurchaseConfigBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpsertPurchaseConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWeightConfig = (signal?: AbortSignal) => {
  return request<GetWeightConfigResponse>({
    url: `/moderator/weight-config`,
    method: "GET",
    signal,
  });
};

export const getGetWeightConfigQueryKey = () => {
  return [`/moderator/weight-config`] as const;
};

export const getGetWeightConfigInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWeightConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeightConfig>>> = ({
    signal,
  }) => getWeightConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightConfigInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightConfig>>
>;
export type GetWeightConfigInfiniteQueryError = ErrorType<unknown>;

export const useGetWeightConfigInfinite = <
  TData = Awaited<ReturnType<typeof getWeightConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightConfig>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightConfigInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetWeightConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWeightConfig>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWeightConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeightConfig>>> = ({
    signal,
  }) => getWeightConfig(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWeightConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightConfig>>
>;
export type GetWeightConfigQueryError = ErrorType<unknown>;

export const useGetWeightConfig = <
  TData = Awaited<ReturnType<typeof getWeightConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWeightConfig>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const upsertWeightConfig = (
  upsertWeightConfigBody: UpsertWeightConfigBody,
) => {
  return request<boolean>({
    url: `/moderator/weight-config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: upsertWeightConfigBody,
  });
};

export const getUpsertWeightConfigMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertWeightConfig>>,
    TError,
    { data: UpsertWeightConfigBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertWeightConfig>>,
  TError,
  { data: UpsertWeightConfigBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertWeightConfig>>,
    { data: UpsertWeightConfigBody }
  > = (props) => {
    const { data } = props ?? {};

    return upsertWeightConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertWeightConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertWeightConfig>>
>;
export type UpsertWeightConfigMutationBody = UpsertWeightConfigBody;
export type UpsertWeightConfigMutationError = ErrorType<HttpError>;

export const useUpsertWeightConfig = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertWeightConfig>>,
    TError,
    { data: UpsertWeightConfigBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpsertWeightConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOccurrences = (
  params?: ListOccurrencesParams,
  signal?: AbortSignal,
) => {
  return request<ListOccurrencesResponse>({
    url: `/occurrences`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOccurrencesQueryKey = (params?: ListOccurrencesParams) => {
  return [`/occurrences`, ...(params ? [params] : [])] as const;
};

export const getListOccurrencesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOccurrences>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOccurrencesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOccurrences>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOccurrencesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOccurrences>>> = ({
    signal,
  }) => listOccurrences(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOccurrences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOccurrencesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOccurrences>>
>;
export type ListOccurrencesInfiniteQueryError = ErrorType<unknown>;

export const useListOccurrencesInfinite = <
  TData = Awaited<ReturnType<typeof listOccurrences>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOccurrencesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOccurrences>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOccurrencesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOccurrencesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOccurrences>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOccurrencesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOccurrences>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOccurrencesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOccurrences>>> = ({
    signal,
  }) => listOccurrences(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOccurrences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOccurrencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOccurrences>>
>;
export type ListOccurrencesQueryError = ErrorType<unknown>;

export const useListOccurrences = <
  TData = Awaited<ReturnType<typeof listOccurrences>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOccurrencesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOccurrences>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOccurrencesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createOccurrence = (createOccurrence: CreateOccurrence) => {
  return request<CreateOccurrenceResponse>({
    url: `/occurrences`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOccurrence,
  });
};

export const getCreateOccurrenceMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOccurrence>>,
    TError,
    { data: CreateOccurrence },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOccurrence>>,
  TError,
  { data: CreateOccurrence },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOccurrence>>,
    { data: CreateOccurrence }
  > = (props) => {
    const { data } = props ?? {};

    return createOccurrence(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOccurrenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOccurrence>>
>;
export type CreateOccurrenceMutationBody = CreateOccurrence;
export type CreateOccurrenceMutationError = ErrorType<HttpError>;

export const useCreateOccurrence = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOccurrence>>,
    TError,
    { data: CreateOccurrence },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOccurrenceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOccurrencesByBatchId = (
  params: ListOccurrencesByBatchIdParams,
  signal?: AbortSignal,
) => {
  return request<ListOccurrencesByBatchIdResponse>({
    url: `/occurrences/by-batch`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOccurrencesByBatchIdQueryKey = (
  params: ListOccurrencesByBatchIdParams,
) => {
  return [`/occurrences/by-batch`, ...(params ? [params] : [])] as const;
};

export const getListOccurrencesByBatchIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
  TError = ErrorType<unknown>,
>(
  params: ListOccurrencesByBatchIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOccurrencesByBatchIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOccurrencesByBatchId>>
  > = ({ signal }) => listOccurrencesByBatchId(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOccurrencesByBatchIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOccurrencesByBatchId>>
>;
export type ListOccurrencesByBatchIdInfiniteQueryError = ErrorType<unknown>;

export const useListOccurrencesByBatchIdInfinite = <
  TData = Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
  TError = ErrorType<unknown>,
>(
  params: ListOccurrencesByBatchIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOccurrencesByBatchIdInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOccurrencesByBatchIdQueryOptions = <
  TData = Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
  TError = ErrorType<unknown>,
>(
  params: ListOccurrencesByBatchIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOccurrencesByBatchIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOccurrencesByBatchId>>
  > = ({ signal }) => listOccurrencesByBatchId(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOccurrencesByBatchIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOccurrencesByBatchId>>
>;
export type ListOccurrencesByBatchIdQueryError = ErrorType<unknown>;

export const useListOccurrencesByBatchId = <
  TData = Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
  TError = ErrorType<unknown>,
>(
  params: ListOccurrencesByBatchIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOccurrencesByBatchId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOccurrencesByBatchIdQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getOperationalCosts = (
  params: GetOperationalCostsParams,
  signal?: AbortSignal,
) => {
  return request<GetOperationalCostsResponse>({
    url: `/operational-costs`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOperationalCostsQueryKey = (
  params: GetOperationalCostsParams,
) => {
  return [`/operational-costs`, ...(params ? [params] : [])] as const;
};

export const getGetOperationalCostsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationalCosts>>,
  TError = ErrorType<unknown>,
>(
  params: GetOperationalCostsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOperationalCosts>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOperationalCostsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOperationalCosts>>
  > = ({ signal }) => getOperationalCosts(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOperationalCosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOperationalCostsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationalCosts>>
>;
export type GetOperationalCostsInfiniteQueryError = ErrorType<unknown>;

export const useGetOperationalCostsInfinite = <
  TData = Awaited<ReturnType<typeof getOperationalCosts>>,
  TError = ErrorType<unknown>,
>(
  params: GetOperationalCostsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOperationalCosts>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOperationalCostsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetOperationalCostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationalCosts>>,
  TError = ErrorType<unknown>,
>(
  params: GetOperationalCostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOperationalCosts>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOperationalCostsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOperationalCosts>>
  > = ({ signal }) => getOperationalCosts(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOperationalCosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOperationalCostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationalCosts>>
>;
export type GetOperationalCostsQueryError = ErrorType<unknown>;

export const useGetOperationalCosts = <
  TData = Awaited<ReturnType<typeof getOperationalCosts>>,
  TError = ErrorType<unknown>,
>(
  params: GetOperationalCostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOperationalCosts>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOperationalCostsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createOperationalCosts = (
  createOperationalCostRequest: CreateOperationalCostRequest,
) => {
  return request<boolean>({
    url: `/operational-costs`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOperationalCostRequest,
  });
};

export const getCreateOperationalCostsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOperationalCosts>>,
    TError,
    { data: CreateOperationalCostRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOperationalCosts>>,
  TError,
  { data: CreateOperationalCostRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOperationalCosts>>,
    { data: CreateOperationalCostRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createOperationalCosts(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOperationalCostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOperationalCosts>>
>;
export type CreateOperationalCostsMutationBody = CreateOperationalCostRequest;
export type CreateOperationalCostsMutationError = ErrorType<unknown>;

export const useCreateOperationalCosts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOperationalCosts>>,
    TError,
    { data: CreateOperationalCostRequest },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOperationalCostsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOperationalCostGroups = (signal?: AbortSignal) => {
  return request<ListOperationalCostGroupsResponse>({
    url: `/operational-costs/list`,
    method: "GET",
    signal,
  });
};

export const getListOperationalCostGroupsQueryKey = () => {
  return [`/operational-costs/list`] as const;
};

export const getListOperationalCostGroupsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOperationalCostGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOperationalCostGroups>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOperationalCostGroupsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOperationalCostGroups>>
  > = ({ signal }) => listOperationalCostGroups(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOperationalCostGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOperationalCostGroupsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOperationalCostGroups>>
>;
export type ListOperationalCostGroupsInfiniteQueryError = ErrorType<unknown>;

export const useListOperationalCostGroupsInfinite = <
  TData = Awaited<ReturnType<typeof listOperationalCostGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOperationalCostGroups>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListOperationalCostGroupsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOperationalCostGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOperationalCostGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOperationalCostGroups>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOperationalCostGroupsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOperationalCostGroups>>
  > = ({ signal }) => listOperationalCostGroups(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOperationalCostGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOperationalCostGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOperationalCostGroups>>
>;
export type ListOperationalCostGroupsQueryError = ErrorType<unknown>;

export const useListOperationalCostGroups = <
  TData = Awaited<ReturnType<typeof listOperationalCostGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOperationalCostGroups>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOperationalCostGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateOperationalCostMonthValue = (
  updateOperationalCostMonthValueRequest: UpdateOperationalCostMonthValueRequest,
) => {
  return request<boolean>({
    url: `/operational-costs/update`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateOperationalCostMonthValueRequest,
  });
};

export const getUpdateOperationalCostMonthValueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOperationalCostMonthValue>>,
    TError,
    { data: UpdateOperationalCostMonthValueRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOperationalCostMonthValue>>,
  TError,
  { data: UpdateOperationalCostMonthValueRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOperationalCostMonthValue>>,
    { data: UpdateOperationalCostMonthValueRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateOperationalCostMonthValue(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOperationalCostMonthValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOperationalCostMonthValue>>
>;
export type UpdateOperationalCostMonthValueMutationBody =
  UpdateOperationalCostMonthValueRequest;
export type UpdateOperationalCostMonthValueMutationError = ErrorType<unknown>;

export const useUpdateOperationalCostMonthValue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOperationalCostMonthValue>>,
    TError,
    { data: UpdateOperationalCostMonthValueRequest },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateOperationalCostMonthValueMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateOperationalCostBatches = (
  updateOperationalCostBatchesRequest: UpdateOperationalCostBatchesRequest,
) => {
  return request<boolean>({
    url: `/operational-costs/update-batches`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateOperationalCostBatchesRequest,
  });
};

export const getUpdateOperationalCostBatchesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOperationalCostBatches>>,
    TError,
    { data: UpdateOperationalCostBatchesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOperationalCostBatches>>,
  TError,
  { data: UpdateOperationalCostBatchesRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOperationalCostBatches>>,
    { data: UpdateOperationalCostBatchesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateOperationalCostBatches(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOperationalCostBatchesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOperationalCostBatches>>
>;
export type UpdateOperationalCostBatchesMutationBody =
  UpdateOperationalCostBatchesRequest;
export type UpdateOperationalCostBatchesMutationError = ErrorType<unknown>;

export const useUpdateOperationalCostBatches = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOperationalCostBatches>>,
    TError,
    { data: UpdateOperationalCostBatchesRequest },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateOperationalCostBatchesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOtherDeathCause = (signal?: AbortSignal) => {
  return request<ListOtherDeathCauseResponse>({
    url: `/other-death-cause`,
    method: "GET",
    signal,
  });
};

export const getListOtherDeathCauseQueryKey = () => {
  return [`/other-death-cause`] as const;
};

export const getListOtherDeathCauseInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOtherDeathCause>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOtherDeathCause>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOtherDeathCauseQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOtherDeathCause>>
  > = ({ signal }) => listOtherDeathCause(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOtherDeathCause>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOtherDeathCauseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOtherDeathCause>>
>;
export type ListOtherDeathCauseInfiniteQueryError = ErrorType<unknown>;

export const useListOtherDeathCauseInfinite = <
  TData = Awaited<ReturnType<typeof listOtherDeathCause>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOtherDeathCause>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOtherDeathCauseInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOtherDeathCauseQueryOptions = <
  TData = Awaited<ReturnType<typeof listOtherDeathCause>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOtherDeathCause>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOtherDeathCauseQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOtherDeathCause>>
  > = ({ signal }) => listOtherDeathCause(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOtherDeathCause>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOtherDeathCauseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOtherDeathCause>>
>;
export type ListOtherDeathCauseQueryError = ErrorType<unknown>;

export const useListOtherDeathCause = <
  TData = Awaited<ReturnType<typeof listOtherDeathCause>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOtherDeathCause>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOtherDeathCauseQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createOtherDeathCause = (
  createOtherDeathCauseBody: CreateOtherDeathCauseBody,
) => {
  return request<CreateOtherDeathCauseResponse>({
    url: `/other-death-cause`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOtherDeathCauseBody,
  });
};

export const getCreateOtherDeathCauseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOtherDeathCause>>,
    TError,
    { data: CreateOtherDeathCauseBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOtherDeathCause>>,
  TError,
  { data: CreateOtherDeathCauseBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOtherDeathCause>>,
    { data: CreateOtherDeathCauseBody }
  > = (props) => {
    const { data } = props ?? {};

    return createOtherDeathCause(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOtherDeathCauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOtherDeathCause>>
>;
export type CreateOtherDeathCauseMutationBody = CreateOtherDeathCauseBody;
export type CreateOtherDeathCauseMutationError = ErrorType<unknown>;

export const useCreateOtherDeathCause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOtherDeathCause>>,
    TError,
    { data: CreateOtherDeathCauseBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOtherDeathCauseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOxen = (params?: ListOxenParams, signal?: AbortSignal) => {
  return request<ListOxenResponse>({
    url: `/oxen`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOxenQueryKey = (params?: ListOxenParams) => {
  return [`/oxen`, ...(params ? [params] : [])] as const;
};

export const getListOxenInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxen>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxenParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxen>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOxen>>> = ({
    signal,
  }) => listOxen(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxen>>
>;
export type ListOxenInfiniteQueryError = ErrorType<HttpError>;

export const useListOxenInfinite = <
  TData = Awaited<ReturnType<typeof listOxen>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxenParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxen>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxenQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxen>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxenParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxen>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOxen>>> = ({
    signal,
  }) => listOxen(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listOxen>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListOxenQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxen>>
>;
export type ListOxenQueryError = ErrorType<HttpError>;

export const useListOxen = <
  TData = Awaited<ReturnType<typeof listOxen>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxenParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxen>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createOx = (createOxBody: CreateOxBody) => {
  return request<CreateOxResponse>({
    url: `/oxen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOxBody,
  });
};

export const getCreateOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOx>>,
    TError,
    { data: CreateOxBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOx>>,
  TError,
  { data: CreateOxBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOx>>,
    { data: CreateOxBody }
  > = (props) => {
    const { data } = props ?? {};

    return createOx(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOx>>
>;
export type CreateOxMutationBody = CreateOxBody;
export type CreateOxMutationError = ErrorType<HttpError>;

export const useCreateOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOx>>,
    TError,
    { data: CreateOxBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const changeOxenAge = (changeOxenAgeBody: ChangeOxenAgeBody) => {
  return request<boolean>({
    url: `/oxen/change-age`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: changeOxenAgeBody,
  });
};

export const getChangeOxenAgeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOxenAge>>,
    TError,
    { data: ChangeOxenAgeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeOxenAge>>,
  TError,
  { data: ChangeOxenAgeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeOxenAge>>,
    { data: ChangeOxenAgeBody }
  > = (props) => {
    const { data } = props ?? {};

    return changeOxenAge(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeOxenAgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeOxenAge>>
>;
export type ChangeOxenAgeMutationBody = ChangeOxenAgeBody;
export type ChangeOxenAgeMutationError = ErrorType<HttpError>;

export const useChangeOxenAge = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOxenAge>>,
    TError,
    { data: ChangeOxenAgeBody },
    TContext
  >;
}) => {
  const mutationOptions = getChangeOxenAgeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const oxClosure = (oxClosureBody: OxClosureBody) => {
  return request<OxClosureResponse>({
    url: `/oxen/closure`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: oxClosureBody,
  });
};

export const getOxClosureMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oxClosure>>,
    TError,
    { data: OxClosureBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oxClosure>>,
  TError,
  { data: OxClosureBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oxClosure>>,
    { data: OxClosureBody }
  > = (props) => {
    const { data } = props ?? {};

    return oxClosure(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OxClosureMutationResult = NonNullable<
  Awaited<ReturnType<typeof oxClosure>>
>;
export type OxClosureMutationBody = OxClosureBody;
export type OxClosureMutationError = ErrorType<HttpError>;

export const useOxClosure = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oxClosure>>,
    TError,
    { data: OxClosureBody },
    TContext
  >;
}) => {
  const mutationOptions = getOxClosureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createOxEntry = (createOxEntryBody: CreateOxEntryBody) => {
  return request<CreateOxEntryResponse>({
    url: `/oxen/entry`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOxEntryBody,
  });
};

export const getCreateOxEntryMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxEntry>>,
    TError,
    { data: CreateOxEntryBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOxEntry>>,
  TError,
  { data: CreateOxEntryBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOxEntry>>,
    { data: CreateOxEntryBody }
  > = (props) => {
    const { data } = props ?? {};

    return createOxEntry(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOxEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOxEntry>>
>;
export type CreateOxEntryMutationBody = CreateOxEntryBody;
export type CreateOxEntryMutationError = ErrorType<HttpError>;

export const useCreateOxEntry = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxEntry>>,
    TError,
    { data: CreateOxEntryBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOxEntryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportAllDiedOxenToExcel = (
  params: ExportAllDiedOxenToExcelParams,
) => {
  return request<ExportAllDiedOxenToExcelResponse>({
    url: `/oxen/export-all-died-oxen-agromob`,
    method: "POST",
    params,
  });
};

export const getExportAllDiedOxenToExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAllDiedOxenToExcel>>,
    TError,
    { params: ExportAllDiedOxenToExcelParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAllDiedOxenToExcel>>,
  TError,
  { params: ExportAllDiedOxenToExcelParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAllDiedOxenToExcel>>,
    { params: ExportAllDiedOxenToExcelParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportAllDiedOxenToExcel(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAllDiedOxenToExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAllDiedOxenToExcel>>
>;

export type ExportAllDiedOxenToExcelMutationError = ErrorType<unknown>;

export const useExportAllDiedOxenToExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAllDiedOxenToExcel>>,
    TError,
    { params: ExportAllDiedOxenToExcelParams },
    TContext
  >;
}) => {
  const mutationOptions = getExportAllDiedOxenToExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportAllIdentificationOxenToExcel = (
  params: ExportAllIdentificationOxenToExcelParams,
) => {
  return request<ExportAllIdentificationOxenToExcelResponse>({
    url: `/oxen/export-all-identification-oxen-agromob`,
    method: "POST",
    params,
  });
};

export const getExportAllIdentificationOxenToExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAllIdentificationOxenToExcel>>,
    TError,
    { params: ExportAllIdentificationOxenToExcelParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAllIdentificationOxenToExcel>>,
  TError,
  { params: ExportAllIdentificationOxenToExcelParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAllIdentificationOxenToExcel>>,
    { params: ExportAllIdentificationOxenToExcelParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportAllIdentificationOxenToExcel(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAllIdentificationOxenToExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAllIdentificationOxenToExcel>>
>;

export type ExportAllIdentificationOxenToExcelMutationError =
  ErrorType<unknown>;

export const useExportAllIdentificationOxenToExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAllIdentificationOxenToExcel>>,
    TError,
    { params: ExportAllIdentificationOxenToExcelParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getExportAllIdentificationOxenToExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportAllOxenToExcel = (signal?: AbortSignal) => {
  return request<ExportAllOxenToExcelResponse>({
    url: `/oxen/export-all-oxen-agromob`,
    method: "GET",
    signal,
  });
};

export const getExportAllOxenToExcelQueryKey = () => {
  return [`/oxen/export-all-oxen-agromob`] as const;
};

export const getExportAllOxenToExcelInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAllOxenToExcel>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportAllOxenToExcelQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>
  > = ({ signal }) => exportAllOxenToExcel(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportAllOxenToExcelInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAllOxenToExcel>>
>;
export type ExportAllOxenToExcelInfiniteQueryError = ErrorType<unknown>;

export const useExportAllOxenToExcelInfinite = <
  TData = Awaited<ReturnType<typeof exportAllOxenToExcel>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getExportAllOxenToExcelInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getExportAllOxenToExcelQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAllOxenToExcel>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportAllOxenToExcelQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>
  > = ({ signal }) => exportAllOxenToExcel(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportAllOxenToExcelQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAllOxenToExcel>>
>;
export type ExportAllOxenToExcelQueryError = ErrorType<unknown>;

export const useExportAllOxenToExcel = <
  TData = Awaited<ReturnType<typeof exportAllOxenToExcel>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAllOxenToExcel>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getExportAllOxenToExcelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const exportAllOxenSimplified = () => {
  return request<ExportAllOxenSimplifiedResponse>({
    url: `/oxen/export-all-oxen-simplified`,
    method: "POST",
  });
};

export const getExportAllOxenSimplifiedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAllOxenSimplified>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAllOxenSimplified>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAllOxenSimplified>>,
    void
  > = () => {
    return exportAllOxenSimplified();
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAllOxenSimplifiedMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAllOxenSimplified>>
>;

export type ExportAllOxenSimplifiedMutationError = ErrorType<unknown>;

export const useExportAllOxenSimplified = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAllOxenSimplified>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getExportAllOxenSimplifiedMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportOxSearch = (
  params: ExportOxSearchParams,
  signal?: AbortSignal,
) => {
  return request<ExportOxSearchResponse>({
    url: `/oxen/export-ox-search`,
    method: "GET",
    params,
    signal,
  });
};

export const getExportOxSearchQueryKey = (params: ExportOxSearchParams) => {
  return [`/oxen/export-ox-search`, ...(params ? [params] : [])] as const;
};

export const getExportOxSearchInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof exportOxSearch>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportOxSearchParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof exportOxSearch>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportOxSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOxSearch>>> = ({
    signal,
  }) => exportOxSearch(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof exportOxSearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportOxSearchInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportOxSearch>>
>;
export type ExportOxSearchInfiniteQueryError = ErrorType<HttpError>;

export const useExportOxSearchInfinite = <
  TData = Awaited<ReturnType<typeof exportOxSearch>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportOxSearchParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof exportOxSearch>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getExportOxSearchInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getExportOxSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof exportOxSearch>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportOxSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportOxSearch>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportOxSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOxSearch>>> = ({
    signal,
  }) => exportOxSearch(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportOxSearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportOxSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportOxSearch>>
>;
export type ExportOxSearchQueryError = ErrorType<HttpError>;

export const useExportOxSearch = <
  TData = Awaited<ReturnType<typeof exportOxSearch>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportOxSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportOxSearch>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getExportOxSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const exportOxenFromInternalSale = (
  exportOxenFromInternalSaleBody: ExportOxenFromInternalSaleBody,
) => {
  return request<ExportOxenFromInternalSaleResponse>({
    url: `/oxen/export-oxen-from-internal-sale`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: exportOxenFromInternalSaleBody,
  });
};

export const getExportOxenFromInternalSaleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportOxenFromInternalSale>>,
    TError,
    { data: ExportOxenFromInternalSaleBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportOxenFromInternalSale>>,
  TError,
  { data: ExportOxenFromInternalSaleBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportOxenFromInternalSale>>,
    { data: ExportOxenFromInternalSaleBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportOxenFromInternalSale(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportOxenFromInternalSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportOxenFromInternalSale>>
>;
export type ExportOxenFromInternalSaleMutationBody =
  ExportOxenFromInternalSaleBody;
export type ExportOxenFromInternalSaleMutationError = ErrorType<unknown>;

export const useExportOxenFromInternalSale = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportOxenFromInternalSale>>,
    TError,
    { data: ExportOxenFromInternalSaleBody },
    TContext
  >;
}) => {
  const mutationOptions = getExportOxenFromInternalSaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const findOxenBySisbovs = (
  findOxenBySisbovsBody: FindOxenBySisbovsBody,
) => {
  return request<FindOxenBySisbovsResponse>({
    url: `/oxen/find-by-sisbovs`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: findOxenBySisbovsBody,
  });
};

export const getFindOxenBySisbovsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findOxenBySisbovs>>,
    TError,
    { data: FindOxenBySisbovsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof findOxenBySisbovs>>,
  TError,
  { data: FindOxenBySisbovsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof findOxenBySisbovs>>,
    { data: FindOxenBySisbovsBody }
  > = (props) => {
    const { data } = props ?? {};

    return findOxenBySisbovs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FindOxenBySisbovsMutationResult = NonNullable<
  Awaited<ReturnType<typeof findOxenBySisbovs>>
>;
export type FindOxenBySisbovsMutationBody = FindOxenBySisbovsBody;
export type FindOxenBySisbovsMutationError = ErrorType<unknown>;

export const useFindOxenBySisbovs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findOxenBySisbovs>>,
    TError,
    { data: FindOxenBySisbovsBody },
    TContext
  >;
}) => {
  const mutationOptions = getFindOxenBySisbovsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOxenHealth = (
  params?: ListOxenHealthParams,
  signal?: AbortSignal,
) => {
  return request<ListOxenHealthResponse>({
    url: `/oxen/health`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOxenHealthQueryKey = (params?: ListOxenHealthParams) => {
  return [`/oxen/health`, ...(params ? [params] : [])] as const;
};

export const getListOxenHealthInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOxenHealthParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxenHealth>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenHealthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOxenHealth>>> = ({
    signal,
  }) => listOxenHealth(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenHealthInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenHealth>>
>;
export type ListOxenHealthInfiniteQueryError = ErrorType<unknown>;

export const useListOxenHealthInfinite = <
  TData = Awaited<ReturnType<typeof listOxenHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOxenHealthParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxenHealth>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenHealthInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxenHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOxenHealthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxenHealth>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenHealthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOxenHealth>>> = ({
    signal,
  }) => listOxenHealth(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOxenHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenHealth>>
>;
export type ListOxenHealthQueryError = ErrorType<unknown>;

export const useListOxenHealth = <
  TData = Awaited<ReturnType<typeof listOxenHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOxenHealthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxenHealth>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenHealthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listOxenHealthBatches = (signal?: AbortSignal) => {
  return request<ListOxenHealthBatchesResponse>({
    url: `/oxen/health/batches`,
    method: "GET",
    signal,
  });
};

export const getListOxenHealthBatchesQueryKey = () => {
  return [`/oxen/health/batches`] as const;
};

export const getListOxenHealthBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenHealthBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenHealthBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenHealthBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenHealthBatches>>
  > = ({ signal }) => listOxenHealthBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenHealthBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenHealthBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenHealthBatches>>
>;
export type ListOxenHealthBatchesInfiniteQueryError = ErrorType<unknown>;

export const useListOxenHealthBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listOxenHealthBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenHealthBatches>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenHealthBatchesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxenHealthBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenHealthBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOxenHealthBatches>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenHealthBatchesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenHealthBatches>>
  > = ({ signal }) => listOxenHealthBatches(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOxenHealthBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenHealthBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenHealthBatches>>
>;
export type ListOxenHealthBatchesQueryError = ErrorType<unknown>;

export const useListOxenHealthBatches = <
  TData = Awaited<ReturnType<typeof listOxenHealthBatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOxenHealthBatches>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenHealthBatchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deleteOxHealth = (id: number) => {
  return request<boolean>({ url: `/oxen/health/${id}`, method: "DELETE" });
};

export const getDeleteOxHealthMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOxHealth>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOxHealth>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOxHealth>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOxHealth(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOxHealthMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOxHealth>>
>;

export type DeleteOxHealthMutationError = ErrorType<HttpError>;

export const useDeleteOxHealth = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOxHealth>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteOxHealthMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checkOxIdentification = (
  params?: CheckOxIdentificationParams,
  signal?: AbortSignal,
) => {
  return request<boolean>({
    url: `/oxen/identification`,
    method: "GET",
    params,
    signal,
  });
};

export const getCheckOxIdentificationQueryKey = (
  params?: CheckOxIdentificationParams,
) => {
  return [`/oxen/identification`, ...(params ? [params] : [])] as const;
};

export const getCheckOxIdentificationInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof checkOxIdentification>>,
  TError = ErrorType<HttpError>,
>(
  params?: CheckOxIdentificationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof checkOxIdentification>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckOxIdentificationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkOxIdentification>>
  > = ({ signal }) => checkOxIdentification(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof checkOxIdentification>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckOxIdentificationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkOxIdentification>>
>;
export type CheckOxIdentificationInfiniteQueryError = ErrorType<HttpError>;

export const useCheckOxIdentificationInfinite = <
  TData = Awaited<ReturnType<typeof checkOxIdentification>>,
  TError = ErrorType<HttpError>,
>(
  params?: CheckOxIdentificationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof checkOxIdentification>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCheckOxIdentificationInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCheckOxIdentificationQueryOptions = <
  TData = Awaited<ReturnType<typeof checkOxIdentification>>,
  TError = ErrorType<HttpError>,
>(
  params?: CheckOxIdentificationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkOxIdentification>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckOxIdentificationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkOxIdentification>>
  > = ({ signal }) => checkOxIdentification(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkOxIdentification>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckOxIdentificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkOxIdentification>>
>;
export type CheckOxIdentificationQueryError = ErrorType<HttpError>;

export const useCheckOxIdentification = <
  TData = Awaited<ReturnType<typeof checkOxIdentification>>,
  TError = ErrorType<HttpError>,
>(
  params?: CheckOxIdentificationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkOxIdentification>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCheckOxIdentificationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const oxIdentification = (
  identificationOx: IdentificationOx,
  params: OxIdentificationParams,
) => {
  return request<OxIdentificationResponse>({
    url: `/oxen/identification`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: identificationOx,
    params,
  });
};

export const getOxIdentificationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oxIdentification>>,
    TError,
    { data: IdentificationOx; params: OxIdentificationParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oxIdentification>>,
  TError,
  { data: IdentificationOx; params: OxIdentificationParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oxIdentification>>,
    { data: IdentificationOx; params: OxIdentificationParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return oxIdentification(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type OxIdentificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof oxIdentification>>
>;
export type OxIdentificationMutationBody = IdentificationOx;
export type OxIdentificationMutationError = ErrorType<HttpError>;

export const useOxIdentification = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oxIdentification>>,
    TError,
    { data: IdentificationOx; params: OxIdentificationParams },
    TContext
  >;
}) => {
  const mutationOptions = getOxIdentificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editOxLastTransferBulk = (
  editOxLastTransferBulkBody: EditOxLastTransferBulkBody,
) => {
  return request<EditOxLastTransferBulkResponse>({
    url: `/oxen/last-transfer-bulk`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: editOxLastTransferBulkBody,
  });
};

export const getEditOxLastTransferBulkMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOxLastTransferBulk>>,
    TError,
    { data: EditOxLastTransferBulkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editOxLastTransferBulk>>,
  TError,
  { data: EditOxLastTransferBulkBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editOxLastTransferBulk>>,
    { data: EditOxLastTransferBulkBody }
  > = (props) => {
    const { data } = props ?? {};

    return editOxLastTransferBulk(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditOxLastTransferBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof editOxLastTransferBulk>>
>;
export type EditOxLastTransferBulkMutationBody = EditOxLastTransferBulkBody;
export type EditOxLastTransferBulkMutationError = ErrorType<HttpError>;

export const useEditOxLastTransferBulk = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOxLastTransferBulk>>,
    TError,
    { data: EditOxLastTransferBulkBody },
    TContext
  >;
}) => {
  const mutationOptions = getEditOxLastTransferBulkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAndExportDailyLivestockInventoryOxen = (
  params: ListAndExportDailyLivestockInventoryOxenParams,
) => {
  return request<ListAndExportDailyLivestockInventoryOxenResponse>({
    url: `/oxen/list-and-export-daily-live-stock-inventory-oxen`,
    method: "POST",
    params,
  });
};

export const getListAndExportDailyLivestockInventoryOxenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAndExportDailyLivestockInventoryOxen>>,
    TError,
    { params: ListAndExportDailyLivestockInventoryOxenParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAndExportDailyLivestockInventoryOxen>>,
  TError,
  { params: ListAndExportDailyLivestockInventoryOxenParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAndExportDailyLivestockInventoryOxen>>,
    { params: ListAndExportDailyLivestockInventoryOxenParams }
  > = (props) => {
    const { params } = props ?? {};

    return listAndExportDailyLivestockInventoryOxen(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAndExportDailyLivestockInventoryOxenMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof listAndExportDailyLivestockInventoryOxen>>
  >;

export type ListAndExportDailyLivestockInventoryOxenMutationError =
  ErrorType<unknown>;

export const useListAndExportDailyLivestockInventoryOxen = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAndExportDailyLivestockInventoryOxen>>,
    TError,
    { params: ListAndExportDailyLivestockInventoryOxenParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getListAndExportDailyLivestockInventoryOxenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAndExportDiedOxen = (params: ListAndExportDiedOxenParams) => {
  return request<ListAndExportDiedOxenResponse>({
    url: `/oxen/list-and-export-died-oxen`,
    method: "POST",
    params,
  });
};

export const getListAndExportDiedOxenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAndExportDiedOxen>>,
    TError,
    { params: ListAndExportDiedOxenParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAndExportDiedOxen>>,
  TError,
  { params: ListAndExportDiedOxenParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAndExportDiedOxen>>,
    { params: ListAndExportDiedOxenParams }
  > = (props) => {
    const { params } = props ?? {};

    return listAndExportDiedOxen(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAndExportDiedOxenMutationResult = NonNullable<
  Awaited<ReturnType<typeof listAndExportDiedOxen>>
>;

export type ListAndExportDiedOxenMutationError = ErrorType<unknown>;

export const useListAndExportDiedOxen = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAndExportDiedOxen>>,
    TError,
    { params: ListAndExportDiedOxenParams },
    TContext
  >;
}) => {
  const mutationOptions = getListAndExportDiedOxenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAndExportMedicineApplicationsOxen = (
  params: ListAndExportMedicineApplicationsOxenParams,
) => {
  return request<ListAndExportMedicineApplicationsOxenResponse>({
    url: `/oxen/list-and-export-medicine-applications-oxen`,
    method: "POST",
    params,
  });
};

export const getListAndExportMedicineApplicationsOxenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAndExportMedicineApplicationsOxen>>,
    TError,
    { params: ListAndExportMedicineApplicationsOxenParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAndExportMedicineApplicationsOxen>>,
  TError,
  { params: ListAndExportMedicineApplicationsOxenParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAndExportMedicineApplicationsOxen>>,
    { params: ListAndExportMedicineApplicationsOxenParams }
  > = (props) => {
    const { params } = props ?? {};

    return listAndExportMedicineApplicationsOxen(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAndExportMedicineApplicationsOxenMutationResult = NonNullable<
  Awaited<ReturnType<typeof listAndExportMedicineApplicationsOxen>>
>;

export type ListAndExportMedicineApplicationsOxenMutationError =
  ErrorType<unknown>;

export const useListAndExportMedicineApplicationsOxen = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAndExportMedicineApplicationsOxen>>,
    TError,
    { params: ListAndExportMedicineApplicationsOxenParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getListAndExportMedicineApplicationsOxenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listDeadOxen = (signal?: AbortSignal) => {
  return request<ListDeadOxenResponse>({
    url: `/oxen/list-dead-oxen`,
    method: "GET",
    signal,
  });
};

export const getListDeadOxenQueryKey = () => {
  return [`/oxen/list-dead-oxen`] as const;
};

export const getListDeadOxenInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listDeadOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDeadOxen>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDeadOxenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeadOxen>>> = ({
    signal,
  }) => listDeadOxen(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDeadOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDeadOxenInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDeadOxen>>
>;
export type ListDeadOxenInfiniteQueryError = ErrorType<unknown>;

export const useListDeadOxenInfinite = <
  TData = Awaited<ReturnType<typeof listDeadOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDeadOxen>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDeadOxenInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListDeadOxenQueryOptions = <
  TData = Awaited<ReturnType<typeof listDeadOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDeadOxen>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDeadOxenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeadOxen>>> = ({
    signal,
  }) => listDeadOxen(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDeadOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDeadOxenQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDeadOxen>>
>;
export type ListDeadOxenQueryError = ErrorType<unknown>;

export const useListDeadOxen = <
  TData = Awaited<ReturnType<typeof listDeadOxen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDeadOxen>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDeadOxenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listOxenOfflineSale = (signal?: AbortSignal) => {
  return request<ListOxenOfflineSaleResponse>({
    url: `/oxen/list-offline-sale`,
    method: "GET",
    signal,
  });
};

export const getListOxenOfflineSaleQueryKey = () => {
  return [`/oxen/list-offline-sale`] as const;
};

export const getListOxenOfflineSaleInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenOfflineSale>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenOfflineSale>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenOfflineSaleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenOfflineSale>>
  > = ({ signal }) => listOxenOfflineSale(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenOfflineSale>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenOfflineSaleInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenOfflineSale>>
>;
export type ListOxenOfflineSaleInfiniteQueryError = ErrorType<unknown>;

export const useListOxenOfflineSaleInfinite = <
  TData = Awaited<ReturnType<typeof listOxenOfflineSale>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenOfflineSale>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenOfflineSaleInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxenOfflineSaleQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenOfflineSale>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOxenOfflineSale>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxenOfflineSaleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenOfflineSale>>
  > = ({ signal }) => listOxenOfflineSale(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOxenOfflineSale>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenOfflineSaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenOfflineSale>>
>;
export type ListOxenOfflineSaleQueryError = ErrorType<unknown>;

export const useListOxenOfflineSale = <
  TData = Awaited<ReturnType<typeof listOxenOfflineSale>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOxenOfflineSale>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenOfflineSaleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const checkRepeatedOxMedicineApplication = (
  params: CheckRepeatedOxMedicineApplicationParams,
  signal?: AbortSignal,
) => {
  return request<boolean>({
    url: `/oxen/medicate`,
    method: "GET",
    params,
    signal,
  });
};

export const getCheckRepeatedOxMedicineApplicationQueryKey = (
  params: CheckRepeatedOxMedicineApplicationParams,
) => {
  return [`/oxen/medicate`, ...(params ? [params] : [])] as const;
};

export const getCheckRepeatedOxMedicineApplicationInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
  TError = ErrorType<HttpError>,
>(
  params: CheckRepeatedOxMedicineApplicationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCheckRepeatedOxMedicineApplicationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>
  > = ({ signal }) => checkRepeatedOxMedicineApplication(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckRepeatedOxMedicineApplicationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>
>;
export type CheckRepeatedOxMedicineApplicationInfiniteQueryError =
  ErrorType<HttpError>;

export const useCheckRepeatedOxMedicineApplicationInfinite = <
  TData = Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
  TError = ErrorType<HttpError>,
>(
  params: CheckRepeatedOxMedicineApplicationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getCheckRepeatedOxMedicineApplicationInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCheckRepeatedOxMedicineApplicationQueryOptions = <
  TData = Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
  TError = ErrorType<HttpError>,
>(
  params: CheckRepeatedOxMedicineApplicationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCheckRepeatedOxMedicineApplicationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>
  > = ({ signal }) => checkRepeatedOxMedicineApplication(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckRepeatedOxMedicineApplicationQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>
>;
export type CheckRepeatedOxMedicineApplicationQueryError = ErrorType<HttpError>;

export const useCheckRepeatedOxMedicineApplication = <
  TData = Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
  TError = ErrorType<HttpError>,
>(
  params: CheckRepeatedOxMedicineApplicationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkRepeatedOxMedicineApplication>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCheckRepeatedOxMedicineApplicationQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const medicateOx = (medicateOx: MedicateOx) => {
  return request<MedicateOxResponse>({
    url: `/oxen/medicate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: medicateOx,
  });
};

export const getMedicateOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof medicateOx>>,
    TError,
    { data: MedicateOx },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof medicateOx>>,
  TError,
  { data: MedicateOx },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof medicateOx>>,
    { data: MedicateOx }
  > = (props) => {
    const { data } = props ?? {};

    return medicateOx(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MedicateOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof medicateOx>>
>;
export type MedicateOxMutationBody = MedicateOx;
export type MedicateOxMutationError = ErrorType<HttpError>;

export const useMedicateOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof medicateOx>>,
    TError,
    { data: MedicateOx },
    TContext
  >;
}) => {
  const mutationOptions = getMedicateOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const medicateBatchOx = (medicateBatchOxBody: MedicateBatchOxBody) => {
  return request<MedicateBatchOxResponse>({
    url: `/oxen/medicate-bacth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: medicateBatchOxBody,
  });
};

export const getMedicateBatchOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof medicateBatchOx>>,
    TError,
    { data: MedicateBatchOxBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof medicateBatchOx>>,
  TError,
  { data: MedicateBatchOxBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof medicateBatchOx>>,
    { data: MedicateBatchOxBody }
  > = (props) => {
    const { data } = props ?? {};

    return medicateBatchOx(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MedicateBatchOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof medicateBatchOx>>
>;
export type MedicateBatchOxMutationBody = MedicateBatchOxBody;
export type MedicateBatchOxMutationError = ErrorType<HttpError>;

export const useMedicateBatchOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof medicateBatchOx>>,
    TError,
    { data: MedicateBatchOxBody },
    TContext
  >;
}) => {
  const mutationOptions = getMedicateBatchOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const medicateBulkOx = (medicateBulkOx: MedicateBulkOx) => {
  return request<MedicateBulkOxResponse>({
    url: `/oxen/medicate-bulk`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: medicateBulkOx,
  });
};

export const getMedicateBulkOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof medicateBulkOx>>,
    TError,
    { data: MedicateBulkOx },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof medicateBulkOx>>,
  TError,
  { data: MedicateBulkOx },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof medicateBulkOx>>,
    { data: MedicateBulkOx }
  > = (props) => {
    const { data } = props ?? {};

    return medicateBulkOx(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MedicateBulkOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof medicateBulkOx>>
>;
export type MedicateBulkOxMutationBody = MedicateBulkOx;
export type MedicateBulkOxMutationError = ErrorType<HttpError>;

export const useMedicateBulkOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof medicateBulkOx>>,
    TError,
    { data: MedicateBulkOx },
    TContext
  >;
}) => {
  const mutationOptions = getMedicateBulkOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const moveOxen = (moveOxenBody: MoveOxenBody) => {
  return request<boolean>({
    url: `/oxen/movement`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: moveOxenBody,
  });
};

export const getMoveOxenMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveOxen>>,
    TError,
    { data: MoveOxenBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveOxen>>,
  TError,
  { data: MoveOxenBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveOxen>>,
    { data: MoveOxenBody }
  > = (props) => {
    const { data } = props ?? {};

    return moveOxen(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveOxenMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveOxen>>
>;
export type MoveOxenMutationBody = MoveOxenBody;
export type MoveOxenMutationError = ErrorType<HttpError>;

export const useMoveOxen = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveOxen>>,
    TError,
    { data: MoveOxenBody },
    TContext
  >;
}) => {
  const mutationOptions = getMoveOxenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const untraceableTransfer = (
  untraceableTransferBody: UntraceableTransferBody,
) => {
  return request<boolean>({
    url: `/oxen/movement`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: untraceableTransferBody,
  });
};

export const getUntraceableTransferMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof untraceableTransfer>>,
    TError,
    { data: UntraceableTransferBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof untraceableTransfer>>,
  TError,
  { data: UntraceableTransferBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof untraceableTransfer>>,
    { data: UntraceableTransferBody }
  > = (props) => {
    const { data } = props ?? {};

    return untraceableTransfer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UntraceableTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof untraceableTransfer>>
>;
export type UntraceableTransferMutationBody = UntraceableTransferBody;
export type UntraceableTransferMutationError = ErrorType<HttpError>;

export const useUntraceableTransfer = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof untraceableTransfer>>,
    TError,
    { data: UntraceableTransferBody },
    TContext
  >;
}) => {
  const mutationOptions = getUntraceableTransferMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Histórico operacional de movimentação: uma linha por animal em cada transferência ou troca de curral.
 */
export const listOxMovementHistory = (
  params?: ListOxMovementHistoryParams,
  signal?: AbortSignal,
) => {
  return request<ListOxMovementHistoryResponse>({
    url: `/oxen/movement-history`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOxMovementHistoryQueryKey = (
  params?: ListOxMovementHistoryParams,
) => {
  return [`/oxen/movement-history`, ...(params ? [params] : [])] as const;
};

export const getListOxMovementHistoryInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxMovementHistory>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxMovementHistoryParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxMovementHistory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOxMovementHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxMovementHistory>>
  > = ({ signal }) => listOxMovementHistory(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxMovementHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxMovementHistoryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxMovementHistory>>
>;
export type ListOxMovementHistoryInfiniteQueryError = ErrorType<HttpError>;

export const useListOxMovementHistoryInfinite = <
  TData = Awaited<ReturnType<typeof listOxMovementHistory>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxMovementHistoryParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxMovementHistory>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxMovementHistoryInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxMovementHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxMovementHistory>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxMovementHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxMovementHistory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOxMovementHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxMovementHistory>>
  > = ({ signal }) => listOxMovementHistory(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOxMovementHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxMovementHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxMovementHistory>>
>;
export type ListOxMovementHistoryQueryError = ErrorType<HttpError>;

export const useListOxMovementHistory = <
  TData = Awaited<ReturnType<typeof listOxMovementHistory>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListOxMovementHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxMovementHistory>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxMovementHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const multipleEntries = (multipleEntriesDto: MultipleEntriesDto) => {
  return request<MultipleEntriesResponse>({
    url: `/oxen/multiple-entries-file`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: multipleEntriesDto,
  });
};

export const getMultipleEntriesMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof multipleEntries>>,
    TError,
    { data: MultipleEntriesDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof multipleEntries>>,
  TError,
  { data: MultipleEntriesDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof multipleEntries>>,
    { data: MultipleEntriesDto }
  > = (props) => {
    const { data } = props ?? {};

    return multipleEntries(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MultipleEntriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof multipleEntries>>
>;
export type MultipleEntriesMutationBody = MultipleEntriesDto;
export type MultipleEntriesMutationError = ErrorType<HttpError>;

export const useMultipleEntries = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof multipleEntries>>,
    TError,
    { data: MultipleEntriesDto },
    TContext
  >;
}) => {
  const mutationOptions = getMultipleEntriesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listOxPerformance = (signal?: AbortSignal) => {
  return request<ListOxPerformanceResponse>({
    url: `/oxen/performance-info`,
    method: "GET",
    signal,
  });
};

export const getListOxPerformanceQueryKey = () => {
  return [`/oxen/performance-info`] as const;
};

export const getListOxPerformanceInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxPerformance>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxPerformance>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxPerformanceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxPerformance>>
  > = ({ signal }) => listOxPerformance(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxPerformance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxPerformanceInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxPerformance>>
>;
export type ListOxPerformanceInfiniteQueryError = ErrorType<HttpError>;

export const useListOxPerformanceInfinite = <
  TData = Awaited<ReturnType<typeof listOxPerformance>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxPerformance>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxPerformanceInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxPerformanceQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxPerformance>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOxPerformance>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOxPerformanceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxPerformance>>
  > = ({ signal }) => listOxPerformance(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOxPerformance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxPerformanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxPerformance>>
>;
export type ListOxPerformanceQueryError = ErrorType<HttpError>;

export const useListOxPerformance = <
  TData = Awaited<ReturnType<typeof listOxPerformance>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listOxPerformance>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxPerformanceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createOxPerformance = (
  createOxPerformanceRequest: CreateOxPerformanceRequest,
) => {
  return request<boolean>({
    url: `/oxen/performance-info`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOxPerformanceRequest,
  });
};

export const getCreateOxPerformanceMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxPerformance>>,
    TError,
    { data: CreateOxPerformanceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOxPerformance>>,
  TError,
  { data: CreateOxPerformanceRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOxPerformance>>,
    { data: CreateOxPerformanceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createOxPerformance(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOxPerformanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOxPerformance>>
>;
export type CreateOxPerformanceMutationBody = CreateOxPerformanceRequest;
export type CreateOxPerformanceMutationError = ErrorType<HttpError>;

export const useCreateOxPerformance = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxPerformance>>,
    TError,
    { data: CreateOxPerformanceRequest },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOxPerformanceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteOxPerformance = (id: number) => {
  return request<boolean>({
    url: `/oxen/performance-info/${id}`,
    method: "DELETE",
  });
};

export const getDeleteOxPerformanceMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOxPerformance>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOxPerformance>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOxPerformance>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOxPerformance(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOxPerformanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOxPerformance>>
>;

export type DeleteOxPerformanceMutationError = ErrorType<HttpError>;

export const useDeleteOxPerformance = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOxPerformance>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteOxPerformanceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateOxPerformance = (
  id: number,
  updateOxPerformanceRequest: UpdateOxPerformanceRequest,
) => {
  return request<boolean>({
    url: `/oxen/performance-info/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateOxPerformanceRequest,
  });
};

export const getUpdateOxPerformanceMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxPerformance>>,
    TError,
    { id: number; data: UpdateOxPerformanceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOxPerformance>>,
  TError,
  { id: number; data: UpdateOxPerformanceRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOxPerformance>>,
    { id: number; data: UpdateOxPerformanceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOxPerformance(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOxPerformanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOxPerformance>>
>;
export type UpdateOxPerformanceMutationBody = UpdateOxPerformanceRequest;
export type UpdateOxPerformanceMutationError = ErrorType<HttpError>;

export const useUpdateOxPerformance = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxPerformance>>,
    TError,
    { id: number; data: UpdateOxPerformanceRequest },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateOxPerformanceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOxPriceTable = (
  params: GetOxPriceTableParams,
  signal?: AbortSignal,
) => {
  return request<GetOxPriceTableResponse>({
    url: `/oxen/price-table`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOxPriceTableQueryKey = (params: GetOxPriceTableParams) => {
  return [`/oxen/price-table`, ...(params ? [params] : [])] as const;
};

export const getGetOxPriceTableInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getOxPriceTable>>,
  TError = ErrorType<unknown>,
>(
  params: GetOxPriceTableParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOxPriceTable>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOxPriceTableQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOxPriceTable>>> = ({
    signal,
  }) => getOxPriceTable(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOxPriceTable>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOxPriceTableInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOxPriceTable>>
>;
export type GetOxPriceTableInfiniteQueryError = ErrorType<unknown>;

export const useGetOxPriceTableInfinite = <
  TData = Awaited<ReturnType<typeof getOxPriceTable>>,
  TError = ErrorType<unknown>,
>(
  params: GetOxPriceTableParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOxPriceTable>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOxPriceTableInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetOxPriceTableQueryOptions = <
  TData = Awaited<ReturnType<typeof getOxPriceTable>>,
  TError = ErrorType<unknown>,
>(
  params: GetOxPriceTableParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOxPriceTable>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOxPriceTableQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOxPriceTable>>> = ({
    signal,
  }) => getOxPriceTable(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOxPriceTable>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOxPriceTableQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOxPriceTable>>
>;
export type GetOxPriceTableQueryError = ErrorType<unknown>;

export const useGetOxPriceTable = <
  TData = Awaited<ReturnType<typeof getOxPriceTable>>,
  TError = ErrorType<unknown>,
>(
  params: GetOxPriceTableParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOxPriceTable>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOxPriceTableQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateOxPriceMonthValue = (
  updateOxPriceTableMonthValueRequest: UpdateOxPriceTableMonthValueRequest,
) => {
  return request<boolean>({
    url: `/oxen/price-table`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateOxPriceTableMonthValueRequest,
  });
};

export const getUpdateOxPriceMonthValueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxPriceMonthValue>>,
    TError,
    { data: UpdateOxPriceTableMonthValueRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOxPriceMonthValue>>,
  TError,
  { data: UpdateOxPriceTableMonthValueRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOxPriceMonthValue>>,
    { data: UpdateOxPriceTableMonthValueRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateOxPriceMonthValue(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOxPriceMonthValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOxPriceMonthValue>>
>;
export type UpdateOxPriceMonthValueMutationBody =
  UpdateOxPriceTableMonthValueRequest;
export type UpdateOxPriceMonthValueMutationError = ErrorType<unknown>;

export const useUpdateOxPriceMonthValue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxPriceMonthValue>>,
    TError,
    { data: UpdateOxPriceTableMonthValueRequest },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateOxPriceMonthValueMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createOxPriceTable = (
  createOxPriceTableRequest: CreateOxPriceTableRequest,
) => {
  return request<boolean>({
    url: `/oxen/price-table`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOxPriceTableRequest,
  });
};

export const getCreateOxPriceTableMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxPriceTable>>,
    TError,
    { data: CreateOxPriceTableRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOxPriceTable>>,
  TError,
  { data: CreateOxPriceTableRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOxPriceTable>>,
    { data: CreateOxPriceTableRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createOxPriceTable(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOxPriceTableMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOxPriceTable>>
>;
export type CreateOxPriceTableMutationBody = CreateOxPriceTableRequest;
export type CreateOxPriceTableMutationError = ErrorType<unknown>;

export const useCreateOxPriceTable = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxPriceTable>>,
    TError,
    { data: CreateOxPriceTableRequest },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOxPriceTableMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPriceTableAvailableYears = (signal?: AbortSignal) => {
  return request<GetPriceTableAvailableYearsResponse>({
    url: `/oxen/price-table/years`,
    method: "GET",
    signal,
  });
};

export const getGetPriceTableAvailableYearsQueryKey = () => {
  return [`/oxen/price-table/years`] as const;
};

export const getGetPriceTableAvailableYearsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPriceTableAvailableYearsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>
  > = ({ signal }) => getPriceTableAvailableYears(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPriceTableAvailableYearsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPriceTableAvailableYears>>
>;
export type GetPriceTableAvailableYearsInfiniteQueryError = ErrorType<unknown>;

export const useGetPriceTableAvailableYearsInfinite = <
  TData = Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetPriceTableAvailableYearsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetPriceTableAvailableYearsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPriceTableAvailableYearsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>
  > = ({ signal }) => getPriceTableAvailableYears(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPriceTableAvailableYearsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPriceTableAvailableYears>>
>;
export type GetPriceTableAvailableYearsQueryError = ErrorType<unknown>;

export const useGetPriceTableAvailableYears = <
  TData = Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPriceTableAvailableYears>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPriceTableAvailableYearsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const reverseOxBulk = (reverseOxBulkBody: ReverseOxBulkBody) => {
  return request<boolean>({
    url: `/oxen/reverse-bulk`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: reverseOxBulkBody,
  });
};

export const getReverseOxBulkMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseOxBulk>>,
    TError,
    { data: ReverseOxBulkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reverseOxBulk>>,
  TError,
  { data: ReverseOxBulkBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reverseOxBulk>>,
    { data: ReverseOxBulkBody }
  > = (props) => {
    const { data } = props ?? {};

    return reverseOxBulk(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReverseOxBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof reverseOxBulk>>
>;
export type ReverseOxBulkMutationBody = ReverseOxBulkBody;
export type ReverseOxBulkMutationError = ErrorType<HttpError>;

export const useReverseOxBulk = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseOxBulk>>,
    TError,
    { data: ReverseOxBulkBody },
    TContext
  >;
}) => {
  const mutationOptions = getReverseOxBulkMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Limpa os dados de identificação dos bois de um curral que foram identificados via planilha, permitindo reimportação.
Grava log de cada animal antes da limpeza.
 */
export const clearSpreadsheetIdentification = (
  params: ClearSpreadsheetIdentificationParams,
) => {
  return request<ClearSpreadsheetIdentificationResponse>({
    url: `/oxen/spreadsheet-identification`,
    method: "DELETE",
    params,
  });
};

export const getClearSpreadsheetIdentificationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearSpreadsheetIdentification>>,
    TError,
    { params: ClearSpreadsheetIdentificationParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearSpreadsheetIdentification>>,
  TError,
  { params: ClearSpreadsheetIdentificationParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearSpreadsheetIdentification>>,
    { params: ClearSpreadsheetIdentificationParams }
  > = (props) => {
    const { params } = props ?? {};

    return clearSpreadsheetIdentification(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearSpreadsheetIdentificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearSpreadsheetIdentification>>
>;

export type ClearSpreadsheetIdentificationMutationError = ErrorType<HttpError>;

export const useClearSpreadsheetIdentification = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearSpreadsheetIdentification>>,
    TError,
    { params: ClearSpreadsheetIdentificationParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getClearSpreadsheetIdentificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const spreadsheetOxIdentification = (
  spreadsheetOxIdentification: SpreadsheetOxIdentification,
  params: SpreadsheetOxIdentificationParams,
) => {
  return request<boolean>({
    url: `/oxen/spreadsheet-identification`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: spreadsheetOxIdentification,
    params,
  });
};

export const getSpreadsheetOxIdentificationMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof spreadsheetOxIdentification>>,
    TError,
    {
      data: SpreadsheetOxIdentification;
      params: SpreadsheetOxIdentificationParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof spreadsheetOxIdentification>>,
  TError,
  {
    data: SpreadsheetOxIdentification;
    params: SpreadsheetOxIdentificationParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof spreadsheetOxIdentification>>,
    {
      data: SpreadsheetOxIdentification;
      params: SpreadsheetOxIdentificationParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return spreadsheetOxIdentification(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpreadsheetOxIdentificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof spreadsheetOxIdentification>>
>;
export type SpreadsheetOxIdentificationMutationBody =
  SpreadsheetOxIdentification;
export type SpreadsheetOxIdentificationMutationError = ErrorType<HttpError>;

export const useSpreadsheetOxIdentification = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof spreadsheetOxIdentification>>,
    TError,
    {
      data: SpreadsheetOxIdentification;
      params: SpreadsheetOxIdentificationParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getSpreadsheetOxIdentificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateIdentifier = (params: UpdateIdentifierParams) => {
  return request<boolean>({
    url: `/oxen/update-identifier`,
    method: "PUT",
    params,
  });
};

export const getUpdateIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateIdentifier>>,
    TError,
    { params: UpdateIdentifierParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateIdentifier>>,
  TError,
  { params: UpdateIdentifierParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateIdentifier>>,
    { params: UpdateIdentifierParams }
  > = (props) => {
    const { params } = props ?? {};

    return updateIdentifier(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateIdentifier>>
>;

export type UpdateIdentifierMutationError = ErrorType<unknown>;

export const useUpdateIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateIdentifier>>,
    TError,
    { params: UpdateIdentifierParams },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateIdentifierMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listRepeatedIdentifiers = (
  params?: ListRepeatedIdentifiersParams,
  signal?: AbortSignal,
) => {
  return request<ListRepeatedIdentifiersResponse>({
    url: `/oxen/update-identifier/list-identifiers`,
    method: "GET",
    params,
    signal,
  });
};

export const getListRepeatedIdentifiersQueryKey = (
  params?: ListRepeatedIdentifiersParams,
) => {
  return [
    `/oxen/update-identifier/list-identifiers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRepeatedIdentifiersInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRepeatedIdentifiersParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListRepeatedIdentifiersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRepeatedIdentifiers>>
  > = ({ signal }) => listRepeatedIdentifiers(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRepeatedIdentifiersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRepeatedIdentifiers>>
>;
export type ListRepeatedIdentifiersInfiniteQueryError = ErrorType<unknown>;

export const useListRepeatedIdentifiersInfinite = <
  TData = Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRepeatedIdentifiersParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListRepeatedIdentifiersInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListRepeatedIdentifiersQueryOptions = <
  TData = Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRepeatedIdentifiersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListRepeatedIdentifiersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRepeatedIdentifiers>>
  > = ({ signal }) => listRepeatedIdentifiers(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRepeatedIdentifiersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRepeatedIdentifiers>>
>;
export type ListRepeatedIdentifiersQueryError = ErrorType<unknown>;

export const useListRepeatedIdentifiers = <
  TData = Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRepeatedIdentifiersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRepeatedIdentifiers>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListRepeatedIdentifiersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const weighingOx = (weighingOx: WeighingOx) => {
  return request<boolean>({
    url: `/oxen/weighing`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: weighingOx,
  });
};

export const getWeighingOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weighingOx>>,
    TError,
    { data: WeighingOx },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weighingOx>>,
  TError,
  { data: WeighingOx },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weighingOx>>,
    { data: WeighingOx }
  > = (props) => {
    const { data } = props ?? {};

    return weighingOx(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeighingOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof weighingOx>>
>;
export type WeighingOxMutationBody = WeighingOx;
export type WeighingOxMutationError = ErrorType<HttpError>;

export const useWeighingOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weighingOx>>,
    TError,
    { data: WeighingOx },
    TContext
  >;
}) => {
  const mutationOptions = getWeighingOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOxWeights = (
  params: GetOxWeightsParams,
  signal?: AbortSignal,
) => {
  return request<GetOxWeightsResponse>({
    url: `/oxen/weights`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOxWeightsQueryKey = (params: GetOxWeightsParams) => {
  return [`/oxen/weights`, ...(params ? [params] : [])] as const;
};

export const getGetOxWeightsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getOxWeights>>,
  TError = ErrorType<HttpError>,
>(
  params: GetOxWeightsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOxWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOxWeightsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOxWeights>>> = ({
    signal,
  }) => getOxWeights(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOxWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOxWeightsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOxWeights>>
>;
export type GetOxWeightsInfiniteQueryError = ErrorType<HttpError>;

export const useGetOxWeightsInfinite = <
  TData = Awaited<ReturnType<typeof getOxWeights>>,
  TError = ErrorType<HttpError>,
>(
  params: GetOxWeightsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOxWeights>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOxWeightsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetOxWeightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOxWeights>>,
  TError = ErrorType<HttpError>,
>(
  params: GetOxWeightsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOxWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOxWeightsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOxWeights>>> = ({
    signal,
  }) => getOxWeights(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOxWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOxWeightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOxWeights>>
>;
export type GetOxWeightsQueryError = ErrorType<HttpError>;

export const useGetOxWeights = <
  TData = Awaited<ReturnType<typeof getOxWeights>>,
  TError = ErrorType<HttpError>,
>(
  params: GetOxWeightsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOxWeights>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOxWeightsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateOxWeights = (updateOxWeightsBody: UpdateOxWeightsBody) => {
  return request<boolean>({
    url: `/oxen/weights`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateOxWeightsBody,
  });
};

export const getUpdateOxWeightsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxWeights>>,
    TError,
    { data: UpdateOxWeightsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOxWeights>>,
  TError,
  { data: UpdateOxWeightsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOxWeights>>,
    { data: UpdateOxWeightsBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateOxWeights(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOxWeightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOxWeights>>
>;
export type UpdateOxWeightsMutationBody = UpdateOxWeightsBody;
export type UpdateOxWeightsMutationError = ErrorType<HttpError>;

export const useUpdateOxWeights = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxWeights>>,
    TError,
    { data: UpdateOxWeightsBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateOxWeightsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listDeadOxenXlsx = (
  params: ListDeadOxenXlsxParams,
  signal?: AbortSignal,
) => {
  return request<ListDeadOxenXlsxResponse>({
    url: `/oxen/xlsx/dead-oxen`,
    method: "GET",
    params,
    signal,
  });
};

export const getListDeadOxenXlsxQueryKey = (params: ListDeadOxenXlsxParams) => {
  return [`/oxen/xlsx/dead-oxen`, ...(params ? [params] : [])] as const;
};

export const getListDeadOxenXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listDeadOxenXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListDeadOxenXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDeadOxenXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDeadOxenXlsx>>
  > = ({ signal }) => listDeadOxenXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listDeadOxenXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDeadOxenXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDeadOxenXlsx>>
>;
export type ListDeadOxenXlsxInfiniteQueryError = ErrorType<unknown>;

export const useListDeadOxenXlsxInfinite = <
  TData = Awaited<ReturnType<typeof listDeadOxenXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListDeadOxenXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDeadOxenXlsxInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListDeadOxenXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof listDeadOxenXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListDeadOxenXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDeadOxenXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDeadOxenXlsx>>
  > = ({ signal }) => listDeadOxenXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDeadOxenXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDeadOxenXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDeadOxenXlsx>>
>;
export type ListDeadOxenXlsxQueryError = ErrorType<unknown>;

export const useListDeadOxenXlsx = <
  TData = Awaited<ReturnType<typeof listDeadOxenXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListDeadOxenXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDeadOxenXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListDeadOxenXlsxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateOx = (id: number, updateOxBody: UpdateOxBody) => {
  return request<boolean>({
    url: `/oxen/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateOxBody,
  });
};

export const getUpdateOxMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOx>>,
    TError,
    { id: number; data: UpdateOxBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOx>>,
  TError,
  { id: number; data: UpdateOxBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOx>>,
    { id: number; data: UpdateOxBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOx(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOx>>
>;
export type UpdateOxMutationBody = UpdateOxBody;
export type UpdateOxMutationError = ErrorType<HttpError>;

export const useUpdateOx = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOx>>,
    TError,
    { id: number; data: UpdateOxBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getLastBatchOx = (id: number, signal?: AbortSignal) => {
  return request<GetLastBatchOxResponse>({
    url: `/oxen/${id}/get-last-batch`,
    method: "GET",
    signal,
  });
};

export const getGetLastBatchOxQueryKey = (id: number) => {
  return [`/oxen/${id}/get-last-batch`] as const;
};

export const getGetLastBatchOxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getLastBatchOx>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getLastBatchOx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLastBatchOxQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastBatchOx>>> = ({
    signal,
  }) => getLastBatchOx(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getLastBatchOx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLastBatchOxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLastBatchOx>>
>;
export type GetLastBatchOxInfiniteQueryError = ErrorType<HttpError>;

export const useGetLastBatchOxInfinite = <
  TData = Awaited<ReturnType<typeof getLastBatchOx>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getLastBatchOx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLastBatchOxInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetLastBatchOxQueryOptions = <
  TData = Awaited<ReturnType<typeof getLastBatchOx>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLastBatchOx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLastBatchOxQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastBatchOx>>> = ({
    signal,
  }) => getLastBatchOx(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLastBatchOx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLastBatchOxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLastBatchOx>>
>;
export type GetLastBatchOxQueryError = ErrorType<HttpError>;

export const useGetLastBatchOx = <
  TData = Awaited<ReturnType<typeof getLastBatchOx>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLastBatchOx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLastBatchOxQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const killOx = (id: number, killOx: KillOx) => {
  return request<boolean>({
    url: `/oxen/${id}/kill`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: killOx,
  });
};

export const getKillOxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof killOx>>,
    TError,
    { id: number; data: KillOx },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof killOx>>,
  TError,
  { id: number; data: KillOx },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof killOx>>,
    { id: number; data: KillOx }
  > = (props) => {
    const { id, data } = props ?? {};

    return killOx(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KillOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof killOx>>
>;
export type KillOxMutationBody = KillOx;
export type KillOxMutationError = ErrorType<unknown>;

export const useKillOx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof killOx>>,
    TError,
    { id: number; data: KillOx },
    TContext
  >;
}) => {
  const mutationOptions = getKillOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getKillOx = (id: number, signal?: AbortSignal) => {
  return request<GetKillOxResponse>({
    url: `/oxen/${id}/kill`,
    method: "GET",
    signal,
  });
};

export const getGetKillOxQueryKey = (id: number) => {
  return [`/oxen/${id}/kill`] as const;
};

export const getGetKillOxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getKillOx>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getKillOx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKillOxQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKillOx>>> = ({
    signal,
  }) => getKillOx(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getKillOx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetKillOxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKillOx>>
>;
export type GetKillOxInfiniteQueryError = ErrorType<unknown>;

export const useGetKillOxInfinite = <
  TData = Awaited<ReturnType<typeof getKillOx>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getKillOx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetKillOxInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetKillOxQueryOptions = <
  TData = Awaited<ReturnType<typeof getKillOx>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getKillOx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKillOxQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKillOx>>> = ({
    signal,
  }) => getKillOx(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getKillOx>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetKillOxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKillOx>>
>;
export type GetKillOxQueryError = ErrorType<unknown>;

export const useGetKillOx = <
  TData = Awaited<ReturnType<typeof getKillOx>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getKillOx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetKillOxQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const editOxLastTransfer = (
  id: number,
  editOxLastTransferBody: EditOxLastTransferBody,
) => {
  return request<EditOxLastTransferResponse>({
    url: `/oxen/${id}/last-transfer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: editOxLastTransferBody,
  });
};

export const getEditOxLastTransferMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOxLastTransfer>>,
    TError,
    { id: number; data: EditOxLastTransferBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editOxLastTransfer>>,
  TError,
  { id: number; data: EditOxLastTransferBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editOxLastTransfer>>,
    { id: number; data: EditOxLastTransferBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return editOxLastTransfer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditOxLastTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof editOxLastTransfer>>
>;
export type EditOxLastTransferMutationBody = EditOxLastTransferBody;
export type EditOxLastTransferMutationError = ErrorType<HttpError>;

export const useEditOxLastTransfer = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOxLastTransfer>>,
    TError,
    { id: number; data: EditOxLastTransferBody },
    TContext
  >;
}) => {
  const mutationOptions = getEditOxLastTransferMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeOxFromTruck = (
  id: number,
  removeOxFromTruckBody: RemoveOxFromTruckBody,
) => {
  return request<boolean>({
    url: `/oxen/${id}/remove-ox-from-truck`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: removeOxFromTruckBody,
  });
};

export const getRemoveOxFromTruckMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeOxFromTruck>>,
    TError,
    { id: number; data: RemoveOxFromTruckBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeOxFromTruck>>,
  TError,
  { id: number; data: RemoveOxFromTruckBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeOxFromTruck>>,
    { id: number; data: RemoveOxFromTruckBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return removeOxFromTruck(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveOxFromTruckMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeOxFromTruck>>
>;
export type RemoveOxFromTruckMutationBody = RemoveOxFromTruckBody;
export type RemoveOxFromTruckMutationError = ErrorType<HttpError>;

export const useRemoveOxFromTruck = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeOxFromTruck>>,
    TError,
    { id: number; data: RemoveOxFromTruckBody },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveOxFromTruckMutationOptions(options);

  return useMutation(mutationOptions);
};

export const reverseOx = (id: number, reverseOxBody: ReverseOxBody) => {
  return request<boolean>({
    url: `/oxen/${id}/reverse-ox`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: reverseOxBody,
  });
};

export const getReverseOxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseOx>>,
    TError,
    { id: number; data: ReverseOxBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reverseOx>>,
  TError,
  { id: number; data: ReverseOxBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reverseOx>>,
    { id: number; data: ReverseOxBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return reverseOx(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReverseOxMutationResult = NonNullable<
  Awaited<ReturnType<typeof reverseOx>>
>;
export type ReverseOxMutationBody = ReverseOxBody;
export type ReverseOxMutationError = ErrorType<unknown>;

export const useReverseOx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseOx>>,
    TError,
    { id: number; data: ReverseOxBody },
    TContext
  >;
}) => {
  const mutationOptions = getReverseOxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateOxHealthByOxId = (
  id: number,
  updateOxHealthByOxIdBody: UpdateOxHealthByOxIdBody,
) => {
  return request<UpdateOxHealthByOxIdResponse>({
    url: `/oxen/${id}/update-health`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateOxHealthByOxIdBody,
  });
};

export const getUpdateOxHealthByOxIdMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxHealthByOxId>>,
    TError,
    { id: number; data: UpdateOxHealthByOxIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOxHealthByOxId>>,
  TError,
  { id: number; data: UpdateOxHealthByOxIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOxHealthByOxId>>,
    { id: number; data: UpdateOxHealthByOxIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOxHealthByOxId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOxHealthByOxIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOxHealthByOxId>>
>;
export type UpdateOxHealthByOxIdMutationBody = UpdateOxHealthByOxIdBody;
export type UpdateOxHealthByOxIdMutationError = ErrorType<HttpError>;

export const useUpdateOxHealthByOxId = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOxHealthByOxId>>,
    TError,
    { id: number; data: UpdateOxHealthByOxIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateOxHealthByOxIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPartnersWithClosures = (
  params: ListPartnersWithClosuresParams,
  signal?: AbortSignal,
) => {
  return request<ListPartnersWithClosuresResponse>({
    url: `/partner`,
    method: "GET",
    params,
    signal,
  });
};

export const getListPartnersWithClosuresQueryKey = (
  params: ListPartnersWithClosuresParams,
) => {
  return [`/partner`, ...(params ? [params] : [])] as const;
};

export const getListPartnersWithClosuresInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnersWithClosures>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersWithClosuresParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPartnersWithClosures>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPartnersWithClosuresQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnersWithClosures>>
  > = ({ signal }) => listPartnersWithClosures(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnersWithClosures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnersWithClosuresInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnersWithClosures>>
>;
export type ListPartnersWithClosuresInfiniteQueryError = ErrorType<HttpError>;

export const useListPartnersWithClosuresInfinite = <
  TData = Awaited<ReturnType<typeof listPartnersWithClosures>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersWithClosuresParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPartnersWithClosures>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnersWithClosuresInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPartnersWithClosuresQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnersWithClosures>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersWithClosuresParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPartnersWithClosures>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPartnersWithClosuresQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnersWithClosures>>
  > = ({ signal }) => listPartnersWithClosures(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnersWithClosures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnersWithClosuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnersWithClosures>>
>;
export type ListPartnersWithClosuresQueryError = ErrorType<HttpError>;

export const useListPartnersWithClosures = <
  TData = Awaited<ReturnType<typeof listPartnersWithClosures>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersWithClosuresParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPartnersWithClosures>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnersWithClosuresQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listPartnerClosuresV2 = (signal?: AbortSignal) => {
  return request<ListPartnerClosuresV2Response>({
    url: `/partner-closure-v2`,
    method: "GET",
    signal,
  });
};

export const getListPartnerClosuresV2QueryKey = () => {
  return [`/partner-closure-v2`] as const;
};

export const getListPartnerClosuresV2InfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPartnerClosuresV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>
  > = ({ signal }) => listPartnerClosuresV2(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerClosuresV2InfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerClosuresV2>>
>;
export type ListPartnerClosuresV2InfiniteQueryError = ErrorType<unknown>;

export const useListPartnerClosuresV2Infinite = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnerClosuresV2InfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPartnerClosuresV2QueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPartnerClosuresV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>
  > = ({ signal }) => listPartnerClosuresV2(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerClosuresV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerClosuresV2>>
>;
export type ListPartnerClosuresV2QueryError = ErrorType<unknown>;

export const useListPartnerClosuresV2 = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresV2>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnerClosuresV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createPartnerClosureV2 = (
  createPartnerClosureV2Request: CreatePartnerClosureV2Request,
) => {
  return request<CreatePartnerClosureV2Response>({
    url: `/partner-closure-v2`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPartnerClosureV2Request,
  });
};

export const getCreatePartnerClosureV2MutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartnerClosureV2>>,
    TError,
    { data: CreatePartnerClosureV2Request },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPartnerClosureV2>>,
  TError,
  { data: CreatePartnerClosureV2Request },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPartnerClosureV2>>,
    { data: CreatePartnerClosureV2Request }
  > = (props) => {
    const { data } = props ?? {};

    return createPartnerClosureV2(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePartnerClosureV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof createPartnerClosureV2>>
>;
export type CreatePartnerClosureV2MutationBody = CreatePartnerClosureV2Request;
export type CreatePartnerClosureV2MutationError = ErrorType<HttpError>;

export const useCreatePartnerClosureV2 = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartnerClosureV2>>,
    TError,
    { data: CreatePartnerClosureV2Request },
    TContext
  >;
}) => {
  const mutationOptions = getCreatePartnerClosureV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Dados FDM/PC/OV agregados para pré-preencher e conferir um fechamento Boitel.
 */
export const getBoitelClosureSummary = (
  params: GetBoitelClosureSummaryParams,
  signal?: AbortSignal,
) => {
  return request<BoitelClosureSummary>({
    url: `/partner-closure-v2/boitel-summary`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBoitelClosureSummaryQueryKey = (
  params: GetBoitelClosureSummaryParams,
) => {
  return [
    `/partner-closure-v2/boitel-summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBoitelClosureSummaryInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBoitelClosureSummary>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBoitelClosureSummaryParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBoitelClosureSummary>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBoitelClosureSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBoitelClosureSummary>>
  > = ({ signal }) => getBoitelClosureSummary(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBoitelClosureSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBoitelClosureSummaryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBoitelClosureSummary>>
>;
export type GetBoitelClosureSummaryInfiniteQueryError = ErrorType<HttpError>;

export const useGetBoitelClosureSummaryInfinite = <
  TData = Awaited<ReturnType<typeof getBoitelClosureSummary>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBoitelClosureSummaryParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBoitelClosureSummary>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBoitelClosureSummaryInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBoitelClosureSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getBoitelClosureSummary>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBoitelClosureSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBoitelClosureSummary>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBoitelClosureSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBoitelClosureSummary>>
  > = ({ signal }) => getBoitelClosureSummary(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBoitelClosureSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBoitelClosureSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBoitelClosureSummary>>
>;
export type GetBoitelClosureSummaryQueryError = ErrorType<HttpError>;

export const useGetBoitelClosureSummary = <
  TData = Awaited<ReturnType<typeof getBoitelClosureSummary>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBoitelClosureSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBoitelClosureSummary>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBoitelClosureSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPartnerClosureV2ById = (id: number, signal?: AbortSignal) => {
  return request<GetPartnerClosureV2ByIdResponse>({
    url: `/partner-closure-v2/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPartnerClosureV2ByIdQueryKey = (id: number) => {
  return [`/partner-closure-v2/${id}`] as const;
};

export const getGetPartnerClosureV2ByIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPartnerClosureV2ByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPartnerClosureV2ById>>
  > = ({ signal }) => getPartnerClosureV2ById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPartnerClosureV2ByIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerClosureV2ById>>
>;
export type GetPartnerClosureV2ByIdInfiniteQueryError = ErrorType<HttpError>;

export const useGetPartnerClosureV2ByIdInfinite = <
  TData = Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPartnerClosureV2ByIdInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetPartnerClosureV2ByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPartnerClosureV2ByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPartnerClosureV2ById>>
  > = ({ signal }) => getPartnerClosureV2ById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPartnerClosureV2ByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerClosureV2ById>>
>;
export type GetPartnerClosureV2ByIdQueryError = ErrorType<HttpError>;

export const useGetPartnerClosureV2ById = <
  TData = Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureV2ById>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPartnerClosureV2ByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updatePartnerClosureV2 = (
  id: number,
  updatePartnerClosureV2Request: UpdatePartnerClosureV2Request,
) => {
  return request<UpdatePartnerClosureV2Response>({
    url: `/partner-closure-v2/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updatePartnerClosureV2Request,
  });
};

export const getUpdatePartnerClosureV2MutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePartnerClosureV2>>,
    TError,
    { id: number; data: UpdatePartnerClosureV2Request },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePartnerClosureV2>>,
  TError,
  { id: number; data: UpdatePartnerClosureV2Request },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePartnerClosureV2>>,
    { id: number; data: UpdatePartnerClosureV2Request }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePartnerClosureV2(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePartnerClosureV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePartnerClosureV2>>
>;
export type UpdatePartnerClosureV2MutationBody = UpdatePartnerClosureV2Request;
export type UpdatePartnerClosureV2MutationError = ErrorType<HttpError>;

export const useUpdatePartnerClosureV2 = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePartnerClosureV2>>,
    TError,
    { id: number; data: UpdatePartnerClosureV2Request },
    TContext
  >;
}) => {
  const mutationOptions = getUpdatePartnerClosureV2MutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPartnerHerdsAvailable = (signal?: AbortSignal) => {
  return request<ListPartnerHerdsAvailableResponse>({
    url: `/partner-herd`,
    method: "GET",
    signal,
  });
};

export const getListPartnerHerdsAvailableQueryKey = () => {
  return [`/partner-herd`] as const;
};

export const getListPartnerHerdsAvailableInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPartnerHerdsAvailableQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>
  > = ({ signal }) => listPartnerHerdsAvailable(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerHerdsAvailableInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerHerdsAvailable>>
>;
export type ListPartnerHerdsAvailableInfiniteQueryError = ErrorType<unknown>;

export const useListPartnerHerdsAvailableInfinite = <
  TData = Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListPartnerHerdsAvailableInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPartnerHerdsAvailableQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPartnerHerdsAvailableQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>
  > = ({ signal }) => listPartnerHerdsAvailable(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerHerdsAvailableQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerHerdsAvailable>>
>;
export type ListPartnerHerdsAvailableQueryError = ErrorType<unknown>;

export const useListPartnerHerdsAvailable = <
  TData = Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerHerdsAvailable>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnerHerdsAvailableQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listPartnerClosures = (signal?: AbortSignal) => {
  return request<ListPartnerClosuresResponse>({
    url: `/partner/closure`,
    method: "GET",
    signal,
  });
};

export const getListPartnerClosuresQueryKey = () => {
  return [`/partner/closure`] as const;
};

export const getListPartnerClosuresInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerClosures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosures>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPartnerClosuresQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerClosures>>
  > = ({ signal }) => listPartnerClosures(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerClosuresInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerClosures>>
>;
export type ListPartnerClosuresInfiniteQueryError = ErrorType<unknown>;

export const useListPartnerClosuresInfinite = <
  TData = Awaited<ReturnType<typeof listPartnerClosures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosures>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnerClosuresInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPartnerClosuresQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerClosures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosures>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPartnerClosuresQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerClosures>>
  > = ({ signal }) => listPartnerClosures(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerClosuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerClosures>>
>;
export type ListPartnerClosuresQueryError = ErrorType<unknown>;

export const useListPartnerClosures = <
  TData = Awaited<ReturnType<typeof listPartnerClosures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosures>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnerClosuresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createPartnerClosure = (
  partnerClosureRequest: PartnerClosureRequest,
) => {
  return request<CreatePartnerClosureResponse>({
    url: `/partner/closure`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: partnerClosureRequest,
  });
};

export const getCreatePartnerClosureMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartnerClosure>>,
    TError,
    { data: PartnerClosureRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPartnerClosure>>,
  TError,
  { data: PartnerClosureRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPartnerClosure>>,
    { data: PartnerClosureRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createPartnerClosure(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePartnerClosureMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPartnerClosure>>
>;
export type CreatePartnerClosureMutationBody = PartnerClosureRequest;
export type CreatePartnerClosureMutationError = ErrorType<HttpError>;

export const useCreatePartnerClosure = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartnerClosure>>,
    TError,
    { data: PartnerClosureRequest },
    TContext
  >;
}) => {
  const mutationOptions = getCreatePartnerClosureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPartnerClosureById = (id: number, signal?: AbortSignal) => {
  return request<GetPartnerClosureByIdResponse>({
    url: `/partner/closure/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPartnerClosureByIdQueryKey = (id: number) => {
  return [`/partner/closure/${id}`] as const;
};

export const getGetPartnerClosureByIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerClosureById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPartnerClosureByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPartnerClosureById>>
  > = ({ signal }) => getPartnerClosureById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPartnerClosureById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPartnerClosureByIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerClosureById>>
>;
export type GetPartnerClosureByIdInfiniteQueryError = ErrorType<unknown>;

export const useGetPartnerClosureByIdInfinite = <
  TData = Awaited<ReturnType<typeof getPartnerClosureById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureById>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPartnerClosureByIdInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetPartnerClosureByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerClosureById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPartnerClosureByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPartnerClosureById>>
  > = ({ signal }) => getPartnerClosureById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerClosureById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPartnerClosureByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerClosureById>>
>;
export type GetPartnerClosureByIdQueryError = ErrorType<unknown>;

export const useGetPartnerClosureById = <
  TData = Awaited<ReturnType<typeof getPartnerClosureById>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartnerClosureById>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPartnerClosureByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updatePartnerClosure = (
  id: number,
  partnerClosureUpdateRequest: PartnerClosureUpdateRequest,
) => {
  return request<UpdatePartnerClosureResponse>({
    url: `/partner/closure/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: partnerClosureUpdateRequest,
  });
};

export const getUpdatePartnerClosureMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePartnerClosure>>,
    TError,
    { id: number; data: PartnerClosureUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePartnerClosure>>,
  TError,
  { id: number; data: PartnerClosureUpdateRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePartnerClosure>>,
    { id: number; data: PartnerClosureUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePartnerClosure(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePartnerClosureMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePartnerClosure>>
>;
export type UpdatePartnerClosureMutationBody = PartnerClosureUpdateRequest;
export type UpdatePartnerClosureMutationError = ErrorType<HttpError>;

export const useUpdatePartnerClosure = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePartnerClosure>>,
    TError,
    { id: number; data: PartnerClosureUpdateRequest },
    TContext
  >;
}) => {
  const mutationOptions = getUpdatePartnerClosureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPartnerClosuresByPartnerId = (
  id: string,
  params: ListPartnerClosuresByPartnerIdParams,
  signal?: AbortSignal,
) => {
  return request<ListPartnerClosuresByPartnerIdResponse>({
    url: `/partner/${id}/closure`,
    method: "GET",
    params,
    signal,
  });
};

export const getListPartnerClosuresByPartnerIdQueryKey = (
  id: string,
  params: ListPartnerClosuresByPartnerIdParams,
) => {
  return [`/partner/${id}/closure`, ...(params ? [params] : [])] as const;
};

export const getListPartnerClosuresByPartnerIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
  TError = ErrorType<HttpError>,
>(
  id: string,
  params: ListPartnerClosuresByPartnerIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPartnerClosuresByPartnerIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>
  > = ({ signal }) => listPartnerClosuresByPartnerId(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerClosuresByPartnerIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>
>;
export type ListPartnerClosuresByPartnerIdInfiniteQueryError =
  ErrorType<HttpError>;

export const useListPartnerClosuresByPartnerIdInfinite = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
  TError = ErrorType<HttpError>,
>(
  id: string,
  params: ListPartnerClosuresByPartnerIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnerClosuresByPartnerIdInfiniteQueryOptions(
    id,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPartnerClosuresByPartnerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
  TError = ErrorType<HttpError>,
>(
  id: string,
  params: ListPartnerClosuresByPartnerIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPartnerClosuresByPartnerIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>
  > = ({ signal }) => listPartnerClosuresByPartnerId(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnerClosuresByPartnerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>
>;
export type ListPartnerClosuresByPartnerIdQueryError = ErrorType<HttpError>;

export const useListPartnerClosuresByPartnerId = <
  TData = Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
  TError = ErrorType<HttpError>,
>(
  id: string,
  params: ListPartnerClosuresByPartnerIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPartnerClosuresByPartnerId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnerClosuresByPartnerIdQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Envia por e-mail um código (OTP) para redefinir a senha. A resposta é a mesma exista ou não o e-mail.
 */
export const requestPasswordReset = (
  requestPasswordResetBody: RequestPasswordResetBody,
) => {
  return request<RequestPasswordResetResponse>({
    url: `/password-reset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requestPasswordResetBody,
  });
};

export const getRequestPasswordResetMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: RequestPasswordResetBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: RequestPasswordResetBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    { data: RequestPasswordResetBody }
  > = (props) => {
    const { data } = props ?? {};

    return requestPasswordReset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody = RequestPasswordResetBody;
export type RequestPasswordResetMutationError = ErrorType<HttpError>;

export const useRequestPasswordReset = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: RequestPasswordResetBody },
    TContext
  >;
}) => {
  const mutationOptions = getRequestPasswordResetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Define a nova senha usando o token devolvido pela validação do código.
 */
export const confirmPasswordReset = (
  confirmPasswordResetBody: ConfirmPasswordResetBody,
) => {
  return request<boolean>({
    url: `/password-reset/confirm`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: confirmPasswordResetBody,
  });
};

export const getConfirmPasswordResetMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPasswordReset>>,
    TError,
    { data: ConfirmPasswordResetBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmPasswordReset>>,
  TError,
  { data: ConfirmPasswordResetBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmPasswordReset>>,
    { data: ConfirmPasswordResetBody }
  > = (props) => {
    const { data } = props ?? {};

    return confirmPasswordReset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmPasswordReset>>
>;
export type ConfirmPasswordResetMutationBody = ConfirmPasswordResetBody;
export type ConfirmPasswordResetMutationError = ErrorType<HttpError>;

export const useConfirmPasswordReset = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPasswordReset>>,
    TError,
    { data: ConfirmPasswordResetBody },
    TContext
  >;
}) => {
  const mutationOptions = getConfirmPasswordResetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Valida o código recebido por e-mail. Se válido, o código é removido e é devolvido o token para definir a nova senha.
 */
export const verifyPasswordResetCode = (
  verifyPasswordResetCodeBody: VerifyPasswordResetCodeBody,
) => {
  return request<VerifyPasswordResetCodeResponse>({
    url: `/password-reset/verify`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: verifyPasswordResetCodeBody,
  });
};

export const getVerifyPasswordResetCodeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPasswordResetCode>>,
    TError,
    { data: VerifyPasswordResetCodeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyPasswordResetCode>>,
  TError,
  { data: VerifyPasswordResetCodeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyPasswordResetCode>>,
    { data: VerifyPasswordResetCodeBody }
  > = (props) => {
    const { data } = props ?? {};

    return verifyPasswordResetCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyPasswordResetCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyPasswordResetCode>>
>;
export type VerifyPasswordResetCodeMutationBody = VerifyPasswordResetCodeBody;
export type VerifyPasswordResetCodeMutationError = ErrorType<HttpError>;

export const useVerifyPasswordResetCode = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPasswordResetCode>>,
    TError,
    { data: VerifyPasswordResetCodeBody },
    TContext
  >;
}) => {
  const mutationOptions = getVerifyPasswordResetCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const searchPeople = (personFilter: PersonFilter) => {
  return request<SearchPeopleResponse>({
    url: `/person`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: personFilter,
  });
};

export const getSearchPeopleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchPeople>>,
    TError,
    { data: PersonFilter },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchPeople>>,
  TError,
  { data: PersonFilter },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchPeople>>,
    { data: PersonFilter }
  > = (props) => {
    const { data } = props ?? {};

    return searchPeople(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchPeopleMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchPeople>>
>;
export type SearchPeopleMutationBody = PersonFilter;
export type SearchPeopleMutationError = ErrorType<unknown>;

export const useSearchPeople = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchPeople>>,
    TError,
    { data: PersonFilter },
    TContext
  >;
}) => {
  const mutationOptions = getSearchPeopleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createPerson = (createPerson: CreatePerson) => {
  return request<CreatePersonResponse>({
    url: `/person`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: createPerson,
  });
};

export const getCreatePersonMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPerson>>,
    TError,
    { data: CreatePerson },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPerson>>,
  TError,
  { data: CreatePerson },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPerson>>,
    { data: CreatePerson }
  > = (props) => {
    const { data } = props ?? {};

    return createPerson(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePersonMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPerson>>
>;
export type CreatePersonMutationBody = CreatePerson;
export type CreatePersonMutationError = ErrorType<HttpError>;

export const useCreatePerson = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPerson>>,
    TError,
    { data: CreatePerson },
    TContext
  >;
}) => {
  const mutationOptions = getCreatePersonMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPerson = (id: number, signal?: AbortSignal) => {
  return request<GetPersonResponse>({
    url: `/person/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPersonQueryKey = (id: number) => {
  return [`/person/${id}`] as const;
};

export const getGetPersonInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getPerson>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPerson>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPersonQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({
    signal,
  }) => getPerson(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPerson>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPersonInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPerson>>
>;
export type GetPersonInfiniteQueryError = ErrorType<unknown>;

export const useGetPersonInfinite = <
  TData = Awaited<ReturnType<typeof getPerson>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPerson>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPersonInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetPersonQueryOptions = <
  TData = Awaited<ReturnType<typeof getPerson>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPerson>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPersonQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({
    signal,
  }) => getPerson(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetPersonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPerson>>
>;
export type GetPersonQueryError = ErrorType<unknown>;

export const useGetPerson = <
  TData = Awaited<ReturnType<typeof getPerson>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPerson>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPersonQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updatePerson = (id: number, updatePerson: UpdatePerson) => {
  return request<UpdatePersonResponse>({
    url: `/person/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updatePerson,
  });
};

export const getUpdatePersonMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePerson>>,
    TError,
    { id: number; data: UpdatePerson },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePerson>>,
  TError,
  { id: number; data: UpdatePerson },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePerson>>,
    { id: number; data: UpdatePerson }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePerson(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePersonMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePerson>>
>;
export type UpdatePersonMutationBody = UpdatePerson;
export type UpdatePersonMutationError = ErrorType<HttpError>;

export const useUpdatePerson = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePerson>>,
    TError,
    { id: number; data: UpdatePerson },
    TContext
  >;
}) => {
  const mutationOptions = getUpdatePersonMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createDietWithPremix = (createPremixStock: CreatePremixStock) => {
  return request<boolean>({
    url: `/premix/premix`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPremixStock,
  });
};

export const getCreateDietWithPremixMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDietWithPremix>>,
    TError,
    { data: CreatePremixStock },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDietWithPremix>>,
  TError,
  { data: CreatePremixStock },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDietWithPremix>>,
    { data: CreatePremixStock }
  > = (props) => {
    const { data } = props ?? {};

    return createDietWithPremix(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDietWithPremixMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDietWithPremix>>
>;
export type CreateDietWithPremixMutationBody = CreatePremixStock;
export type CreateDietWithPremixMutationError = ErrorType<unknown>;

export const useCreateDietWithPremix = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDietWithPremix>>,
    TError,
    { data: CreatePremixStock },
    TContext
  >;
}) => {
  const mutationOptions = getCreateDietWithPremixMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPurchases = (
  params?: ListPurchasesParams,
  signal?: AbortSignal,
) => {
  return request<ListPurchasesResponse>({
    url: `/purchases`,
    method: "GET",
    params,
    signal,
  });
};

export const getListPurchasesQueryKey = (params?: ListPurchasesParams) => {
  return [`/purchases`, ...(params ? [params] : [])] as const;
};

export const getListPurchasesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPurchases>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPurchasesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPurchases>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPurchasesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchases>>> = ({
    signal,
  }) => listPurchases(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPurchases>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPurchasesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPurchases>>
>;
export type ListPurchasesInfiniteQueryError = ErrorType<unknown>;

export const useListPurchasesInfinite = <
  TData = Awaited<ReturnType<typeof listPurchases>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPurchasesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPurchases>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPurchasesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPurchasesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPurchases>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPurchasesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPurchases>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPurchasesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchases>>> = ({
    signal,
  }) => listPurchases(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPurchases>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPurchasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPurchases>>
>;
export type ListPurchasesQueryError = ErrorType<unknown>;

export const useListPurchases = <
  TData = Awaited<ReturnType<typeof listPurchases>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPurchasesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPurchases>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPurchasesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listEarringPurchases = (signal?: AbortSignal) => {
  return request<ListEarringPurchasesResponse>({
    url: `/purchases/earring`,
    method: "GET",
    signal,
  });
};

export const getListEarringPurchasesQueryKey = () => {
  return [`/purchases/earring`] as const;
};

export const getListEarringPurchasesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listEarringPurchases>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEarringPurchases>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEarringPurchasesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEarringPurchases>>
  > = ({ signal }) => listEarringPurchases(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEarringPurchases>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEarringPurchasesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEarringPurchases>>
>;
export type ListEarringPurchasesInfiniteQueryError = ErrorType<HttpError>;

export const useListEarringPurchasesInfinite = <
  TData = Awaited<ReturnType<typeof listEarringPurchases>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEarringPurchases>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListEarringPurchasesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListEarringPurchasesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEarringPurchases>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listEarringPurchases>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEarringPurchasesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEarringPurchases>>
  > = ({ signal }) => listEarringPurchases(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEarringPurchases>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEarringPurchasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEarringPurchases>>
>;
export type ListEarringPurchasesQueryError = ErrorType<HttpError>;

export const useListEarringPurchases = <
  TData = Awaited<ReturnType<typeof listEarringPurchases>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listEarringPurchases>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListEarringPurchasesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createEarringPurchase = (
  createEarringPurchase: CreateEarringPurchase,
) => {
  return request<CreateEarringPurchaseResponse>({
    url: `/purchases/earring`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEarringPurchase,
  });
};

export const getCreateEarringPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEarringPurchase>>,
    TError,
    { data: CreateEarringPurchase },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEarringPurchase>>,
  TError,
  { data: CreateEarringPurchase },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEarringPurchase>>,
    { data: CreateEarringPurchase }
  > = (props) => {
    const { data } = props ?? {};

    return createEarringPurchase(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEarringPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEarringPurchase>>
>;
export type CreateEarringPurchaseMutationBody = CreateEarringPurchase;
export type CreateEarringPurchaseMutationError = ErrorType<HttpError>;

export const useCreateEarringPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEarringPurchase>>,
    TError,
    { data: CreateEarringPurchase },
    TContext
  >;
}) => {
  const mutationOptions = getCreateEarringPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const purchasesAvailableEarrings = (
  params?: PurchasesAvailableEarringsParams,
  signal?: AbortSignal,
) => {
  return request<PurchasesAvailableEarringsResponse>({
    url: `/purchases/earring/available`,
    method: "GET",
    params,
    signal,
  });
};

export const getPurchasesAvailableEarringsQueryKey = (
  params?: PurchasesAvailableEarringsParams,
) => {
  return [`/purchases/earring/available`, ...(params ? [params] : [])] as const;
};

export const getPurchasesAvailableEarringsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
  TError = ErrorType<unknown>,
>(
  params?: PurchasesAvailableEarringsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurchasesAvailableEarringsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof purchasesAvailableEarrings>>
  > = ({ signal }) => purchasesAvailableEarrings(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PurchasesAvailableEarringsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchasesAvailableEarrings>>
>;
export type PurchasesAvailableEarringsInfiniteQueryError = ErrorType<unknown>;

export const usePurchasesAvailableEarringsInfinite = <
  TData = Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
  TError = ErrorType<unknown>,
>(
  params?: PurchasesAvailableEarringsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPurchasesAvailableEarringsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPurchasesAvailableEarringsQueryOptions = <
  TData = Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
  TError = ErrorType<unknown>,
>(
  params?: PurchasesAvailableEarringsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurchasesAvailableEarringsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof purchasesAvailableEarrings>>
  > = ({ signal }) => purchasesAvailableEarrings(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PurchasesAvailableEarringsQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchasesAvailableEarrings>>
>;
export type PurchasesAvailableEarringsQueryError = ErrorType<unknown>;

export const usePurchasesAvailableEarrings = <
  TData = Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
  TError = ErrorType<unknown>,
>(
  params?: PurchasesAvailableEarringsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof purchasesAvailableEarrings>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPurchasesAvailableEarringsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const sisbovExists = (
  params: SisbovExistsParams,
  signal?: AbortSignal,
) => {
  return request<boolean>({
    url: `/purchases/earring/exists`,
    method: "GET",
    params,
    signal,
  });
};

export const getSisbovExistsQueryKey = (params: SisbovExistsParams) => {
  return [`/purchases/earring/exists`, ...(params ? [params] : [])] as const;
};

export const getSisbovExistsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof sisbovExists>>,
  TError = ErrorType<unknown>,
>(
  params: SisbovExistsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof sisbovExists>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSisbovExistsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sisbovExists>>> = ({
    signal,
  }) => sisbovExists(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof sisbovExists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SisbovExistsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof sisbovExists>>
>;
export type SisbovExistsInfiniteQueryError = ErrorType<unknown>;

export const useSisbovExistsInfinite = <
  TData = Awaited<ReturnType<typeof sisbovExists>>,
  TError = ErrorType<unknown>,
>(
  params: SisbovExistsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof sisbovExists>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSisbovExistsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSisbovExistsQueryOptions = <
  TData = Awaited<ReturnType<typeof sisbovExists>>,
  TError = ErrorType<unknown>,
>(
  params: SisbovExistsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof sisbovExists>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSisbovExistsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sisbovExists>>> = ({
    signal,
  }) => sisbovExists(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sisbovExists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SisbovExistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sisbovExists>>
>;
export type SisbovExistsQueryError = ErrorType<unknown>;

export const useSisbovExists = <
  TData = Awaited<ReturnType<typeof sisbovExists>>,
  TError = ErrorType<unknown>,
>(
  params: SisbovExistsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof sisbovExists>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSisbovExistsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createFoodPurchase = (createFoodPurchase: CreateFoodPurchase) => {
  return request<CreateFoodPurchaseResponse>({
    url: `/purchases/foods`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFoodPurchase,
  });
};

export const getCreateFoodPurchaseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFoodPurchase>>,
    TError,
    { data: CreateFoodPurchase },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFoodPurchase>>,
  TError,
  { data: CreateFoodPurchase },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFoodPurchase>>,
    { data: CreateFoodPurchase }
  > = (props) => {
    const { data } = props ?? {};

    return createFoodPurchase(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFoodPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFoodPurchase>>
>;
export type CreateFoodPurchaseMutationBody = CreateFoodPurchase;
export type CreateFoodPurchaseMutationError = ErrorType<unknown>;

export const useCreateFoodPurchase = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFoodPurchase>>,
    TError,
    { data: CreateFoodPurchase },
    TContext
  >;
}) => {
  const mutationOptions = getCreateFoodPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const purchaseNameExists = (
  params: PurchaseNameExistsParams,
  signal?: AbortSignal,
) => {
  return request<boolean>({
    url: `/purchases/name-exists`,
    method: "GET",
    params,
    signal,
  });
};

export const getPurchaseNameExistsQueryKey = (
  params: PurchaseNameExistsParams,
) => {
  return [`/purchases/name-exists`, ...(params ? [params] : [])] as const;
};

export const getPurchaseNameExistsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseNameExists>>,
  TError = ErrorType<unknown>,
>(
  params: PurchaseNameExistsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof purchaseNameExists>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurchaseNameExistsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof purchaseNameExists>>
  > = ({ signal }) => purchaseNameExists(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof purchaseNameExists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PurchaseNameExistsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchaseNameExists>>
>;
export type PurchaseNameExistsInfiniteQueryError = ErrorType<unknown>;

export const usePurchaseNameExistsInfinite = <
  TData = Awaited<ReturnType<typeof purchaseNameExists>>,
  TError = ErrorType<unknown>,
>(
  params: PurchaseNameExistsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof purchaseNameExists>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPurchaseNameExistsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPurchaseNameExistsQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseNameExists>>,
  TError = ErrorType<unknown>,
>(
  params: PurchaseNameExistsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof purchaseNameExists>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurchaseNameExistsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof purchaseNameExists>>
  > = ({ signal }) => purchaseNameExists(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof purchaseNameExists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PurchaseNameExistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchaseNameExists>>
>;
export type PurchaseNameExistsQueryError = ErrorType<unknown>;

export const usePurchaseNameExists = <
  TData = Awaited<ReturnType<typeof purchaseNameExists>>,
  TError = ErrorType<unknown>,
>(
  params: PurchaseNameExistsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof purchaseNameExists>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPurchaseNameExistsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listOxenPurchase = (
  params: ListOxenPurchaseParams,
  signal?: AbortSignal,
) => {
  return request<ListOxenPurchaseResponse>({
    url: `/purchases/oxen`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOxenPurchaseQueryKey = (params: ListOxenPurchaseParams) => {
  return [`/purchases/oxen`, ...(params ? [params] : [])] as const;
};

export const getListOxenPurchaseInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenPurchase>>,
  TError = ErrorType<unknown>,
>(
  params: ListOxenPurchaseParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxenPurchase>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOxenPurchaseQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenPurchase>>
  > = ({ signal }) => listOxenPurchase(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOxenPurchase>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenPurchaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenPurchase>>
>;
export type ListOxenPurchaseInfiniteQueryError = ErrorType<unknown>;

export const useListOxenPurchaseInfinite = <
  TData = Awaited<ReturnType<typeof listOxenPurchase>>,
  TError = ErrorType<unknown>,
>(
  params: ListOxenPurchaseParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listOxenPurchase>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenPurchaseInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListOxenPurchaseQueryOptions = <
  TData = Awaited<ReturnType<typeof listOxenPurchase>>,
  TError = ErrorType<unknown>,
>(
  params: ListOxenPurchaseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxenPurchase>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOxenPurchaseQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOxenPurchase>>
  > = ({ signal }) => listOxenPurchase(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOxenPurchase>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOxenPurchaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOxenPurchase>>
>;
export type ListOxenPurchaseQueryError = ErrorType<unknown>;

export const useListOxenPurchase = <
  TData = Awaited<ReturnType<typeof listOxenPurchase>>,
  TError = ErrorType<unknown>,
>(
  params: ListOxenPurchaseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOxenPurchase>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListOxenPurchaseQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createOxenPurchase = (createOxenPurchase: CreateOxenPurchase) => {
  return request<CreateOxenPurchaseResponse>({
    url: `/purchases/oxen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOxenPurchase,
  });
};

export const getCreateOxenPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxenPurchase>>,
    TError,
    { data: CreateOxenPurchase },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOxenPurchase>>,
  TError,
  { data: CreateOxenPurchase },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOxenPurchase>>,
    { data: CreateOxenPurchase }
  > = (props) => {
    const { data } = props ?? {};

    return createOxenPurchase(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOxenPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOxenPurchase>>
>;
export type CreateOxenPurchaseMutationBody = CreateOxenPurchase;
export type CreateOxenPurchaseMutationError = ErrorType<HttpError>;

export const useCreateOxenPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOxenPurchase>>,
    TError,
    { data: CreateOxenPurchase },
    TContext
  >;
}) => {
  const mutationOptions = getCreateOxenPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const chargebackOxenPurchase = (
  chargebackOxenPurchaseBody: ChargebackOxenPurchaseBody,
  params?: ChargebackOxenPurchaseParams,
) => {
  return request<ChargebackOxenPurchaseResponse>({
    url: `/purchases/oxen/orderMovement`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: chargebackOxenPurchaseBody,
    params,
  });
};

export const getChargebackOxenPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chargebackOxenPurchase>>,
    TError,
    { data: ChargebackOxenPurchaseBody; params?: ChargebackOxenPurchaseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chargebackOxenPurchase>>,
  TError,
  { data: ChargebackOxenPurchaseBody; params?: ChargebackOxenPurchaseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chargebackOxenPurchase>>,
    { data: ChargebackOxenPurchaseBody; params?: ChargebackOxenPurchaseParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return chargebackOxenPurchase(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChargebackOxenPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof chargebackOxenPurchase>>
>;
export type ChargebackOxenPurchaseMutationBody = ChargebackOxenPurchaseBody;
export type ChargebackOxenPurchaseMutationError = ErrorType<HttpError>;

export const useChargebackOxenPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chargebackOxenPurchase>>,
    TError,
    { data: ChargebackOxenPurchaseBody; params?: ChargebackOxenPurchaseParams },
    TContext
  >;
}) => {
  const mutationOptions = getChargebackOxenPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const storedPurchaseChargeback = (
  params?: StoredPurchaseChargebackParams,
  signal?: AbortSignal,
) => {
  return request<StoredPurchaseChargebackResponse>({
    url: `/purchases/oxen/storedStatus`,
    method: "GET",
    params,
    signal,
  });
};

export const getStoredPurchaseChargebackQueryKey = (
  params?: StoredPurchaseChargebackParams,
) => {
  return [`/purchases/oxen/storedStatus`, ...(params ? [params] : [])] as const;
};

export const getStoredPurchaseChargebackInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof storedPurchaseChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params?: StoredPurchaseChargebackParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof storedPurchaseChargeback>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStoredPurchaseChargebackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof storedPurchaseChargeback>>
  > = ({ signal }) => storedPurchaseChargeback(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof storedPurchaseChargeback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StoredPurchaseChargebackInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof storedPurchaseChargeback>>
>;
export type StoredPurchaseChargebackInfiniteQueryError = ErrorType<HttpError>;

export const useStoredPurchaseChargebackInfinite = <
  TData = Awaited<ReturnType<typeof storedPurchaseChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params?: StoredPurchaseChargebackParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof storedPurchaseChargeback>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getStoredPurchaseChargebackInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getStoredPurchaseChargebackQueryOptions = <
  TData = Awaited<ReturnType<typeof storedPurchaseChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params?: StoredPurchaseChargebackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof storedPurchaseChargeback>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStoredPurchaseChargebackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof storedPurchaseChargeback>>
  > = ({ signal }) => storedPurchaseChargeback(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof storedPurchaseChargeback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StoredPurchaseChargebackQueryResult = NonNullable<
  Awaited<ReturnType<typeof storedPurchaseChargeback>>
>;
export type StoredPurchaseChargebackQueryError = ErrorType<HttpError>;

export const useStoredPurchaseChargeback = <
  TData = Awaited<ReturnType<typeof storedPurchaseChargeback>>,
  TError = ErrorType<HttpError>,
>(
  params?: StoredPurchaseChargebackParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof storedPurchaseChargeback>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getStoredPurchaseChargebackQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Pedidos de compra que ainda têm ao menos um animal vivo.
 */
export const listPurchasesWithLiveOxen = (signal?: AbortSignal) => {
  return request<ListPurchasesWithLiveOxenResponse>({
    url: `/purchases/with-live-oxen`,
    method: "GET",
    signal,
  });
};

export const getListPurchasesWithLiveOxenQueryKey = () => {
  return [`/purchases/with-live-oxen`] as const;
};

export const getListPurchasesWithLiveOxenInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPurchasesWithLiveOxenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>
  > = ({ signal }) => listPurchasesWithLiveOxen(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPurchasesWithLiveOxenInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>
>;
export type ListPurchasesWithLiveOxenInfiniteQueryError = ErrorType<HttpError>;

export const useListPurchasesWithLiveOxenInfinite = <
  TData = Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListPurchasesWithLiveOxenInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPurchasesWithLiveOxenQueryOptions = <
  TData = Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPurchasesWithLiveOxenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>
  > = ({ signal }) => listPurchasesWithLiveOxen(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPurchasesWithLiveOxenQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>
>;
export type ListPurchasesWithLiveOxenQueryError = ErrorType<HttpError>;

export const useListPurchasesWithLiveOxen = <
  TData = Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPurchasesWithLiveOxen>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPurchasesWithLiveOxenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deletePurchase = (id: number, params: DeletePurchaseParams) => {
  return request<DeletePurchaseResponse>({
    url: `/purchases/${id}`,
    method: "DELETE",
    params,
  });
};

export const getDeletePurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePurchase>>,
    TError,
    { id: number; params: DeletePurchaseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePurchase>>,
  TError,
  { id: number; params: DeletePurchaseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePurchase>>,
    { id: number; params: DeletePurchaseParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return deletePurchase(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePurchase>>
>;

export type DeletePurchaseMutationError = ErrorType<HttpError>;

export const useDeletePurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePurchase>>,
    TError,
    { id: number; params: DeletePurchaseParams },
    TContext
  >;
}) => {
  const mutationOptions = getDeletePurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPurchase = (id: number, signal?: AbortSignal) => {
  return request<GetPurchaseResponse>({
    url: `/purchases/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPurchaseQueryKey = (id: number) => {
  return [`/purchases/${id}`] as const;
};

export const getGetPurchaseInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchase>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPurchase>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPurchaseQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchase>>> = ({
    signal,
  }) => getPurchase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPurchase>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPurchaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchase>>
>;
export type GetPurchaseInfiniteQueryError = ErrorType<unknown>;

export const useGetPurchaseInfinite = <
  TData = Awaited<ReturnType<typeof getPurchase>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPurchase>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPurchaseInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetPurchaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchase>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPurchase>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPurchaseQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchase>>> = ({
    signal,
  }) => getPurchase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchase>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPurchaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchase>>
>;
export type GetPurchaseQueryError = ErrorType<unknown>;

export const useGetPurchase = <
  TData = Awaited<ReturnType<typeof getPurchase>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPurchase>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPurchaseQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const receivePurchase = (id: number) => {
  return request<ReceivePurchaseResponse>({
    url: `/purchases/${id}`,
    method: "POST",
  });
};

export const getReceivePurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receivePurchase>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receivePurchase>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receivePurchase>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return receivePurchase(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceivePurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof receivePurchase>>
>;

export type ReceivePurchaseMutationError = ErrorType<HttpError>;

export const useReceivePurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receivePurchase>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getReceivePurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPurchasesEarrings = (id: number, signal?: AbortSignal) => {
  return request<ListPurchasesEarringsResponse>({
    url: `/purchases/${id}/earrings`,
    method: "GET",
    signal,
  });
};

export const getListPurchasesEarringsQueryKey = (id: number) => {
  return [`/purchases/${id}/earrings`] as const;
};

export const getListPurchasesEarringsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPurchasesEarrings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPurchasesEarrings>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPurchasesEarringsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPurchasesEarrings>>
  > = ({ signal }) => listPurchasesEarrings(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPurchasesEarrings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPurchasesEarringsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPurchasesEarrings>>
>;
export type ListPurchasesEarringsInfiniteQueryError = ErrorType<unknown>;

export const useListPurchasesEarringsInfinite = <
  TData = Awaited<ReturnType<typeof listPurchasesEarrings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPurchasesEarrings>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPurchasesEarringsInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPurchasesEarringsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPurchasesEarrings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPurchasesEarrings>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPurchasesEarringsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPurchasesEarrings>>
  > = ({ signal }) => listPurchasesEarrings(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPurchasesEarrings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPurchasesEarringsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPurchasesEarrings>>
>;
export type ListPurchasesEarringsQueryError = ErrorType<unknown>;

export const useListPurchasesEarrings = <
  TData = Awaited<ReturnType<typeof listPurchasesEarrings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPurchasesEarrings>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPurchasesEarringsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateEarringPurchase = (
  id: number,
  updateEarringPurchase: UpdateEarringPurchase,
) => {
  return request<UpdateEarringPurchaseResponse>({
    url: `/purchases/${id}/earrings`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEarringPurchase,
  });
};

export const getUpdateEarringPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEarringPurchase>>,
    TError,
    { id: number; data: UpdateEarringPurchase },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEarringPurchase>>,
  TError,
  { id: number; data: UpdateEarringPurchase },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEarringPurchase>>,
    { id: number; data: UpdateEarringPurchase }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEarringPurchase(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEarringPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEarringPurchase>>
>;
export type UpdateEarringPurchaseMutationBody = UpdateEarringPurchase;
export type UpdateEarringPurchaseMutationError = ErrorType<HttpError>;

export const useUpdateEarringPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEarringPurchase>>,
    TError,
    { id: number; data: UpdateEarringPurchase },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateEarringPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEarringPurchaseXlsx = (
  id: string,
  earringPurchasesXlsx: EarringPurchasesXlsx,
) => {
  return request<GetEarringPurchaseXlsxResponse>({
    url: `/purchases/${id}/earrings/xlsx`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: earringPurchasesXlsx,
  });
};

export const getGetEarringPurchaseXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getEarringPurchaseXlsx>>,
    TError,
    { id: string; data: EarringPurchasesXlsx },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getEarringPurchaseXlsx>>,
  TError,
  { id: string; data: EarringPurchasesXlsx },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getEarringPurchaseXlsx>>,
    { id: string; data: EarringPurchasesXlsx }
  > = (props) => {
    const { id, data } = props ?? {};

    return getEarringPurchaseXlsx(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetEarringPurchaseXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof getEarringPurchaseXlsx>>
>;
export type GetEarringPurchaseXlsxMutationBody = EarringPurchasesXlsx;
export type GetEarringPurchaseXlsxMutationError = ErrorType<unknown>;

export const useGetEarringPurchaseXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getEarringPurchaseXlsx>>,
    TError,
    { id: string; data: EarringPurchasesXlsx },
    TContext
  >;
}) => {
  const mutationOptions = getGetEarringPurchaseXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateFoodPurchase = (
  id: number,
  updateFoodPurchase: UpdateFoodPurchase,
) => {
  return request<UpdateFoodPurchaseResponse>({
    url: `/purchases/${id}/foods`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateFoodPurchase,
  });
};

export const getUpdateFoodPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFoodPurchase>>,
    TError,
    { id: number; data: UpdateFoodPurchase },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFoodPurchase>>,
  TError,
  { id: number; data: UpdateFoodPurchase },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFoodPurchase>>,
    { id: number; data: UpdateFoodPurchase }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFoodPurchase(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFoodPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFoodPurchase>>
>;
export type UpdateFoodPurchaseMutationBody = UpdateFoodPurchase;
export type UpdateFoodPurchaseMutationError = ErrorType<HttpError>;

export const useUpdateFoodPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFoodPurchase>>,
    TError,
    { id: number; data: UpdateFoodPurchase },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateFoodPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Exclui uma entrada (nota) já recebida de um pedido de compra de alimento e estorna a quantidade pro saldo do pedido.
Se o pedido estava Finalizado e o saldo recebido volta a ficar abaixo da quantidade contratada, o status volta pra
Recebido.
 */
export const deleteFoodPurchaseEntry = (id: number, invoiceId: number) => {
  return request<boolean>({
    url: `/purchases/${id}/foods/${invoiceId}`,
    method: "DELETE",
  });
};

export const getDeleteFoodPurchaseEntryMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFoodPurchaseEntry>>,
    TError,
    { id: number; invoiceId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFoodPurchaseEntry>>,
  TError,
  { id: number; invoiceId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFoodPurchaseEntry>>,
    { id: number; invoiceId: number }
  > = (props) => {
    const { id, invoiceId } = props ?? {};

    return deleteFoodPurchaseEntry(id, invoiceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFoodPurchaseEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFoodPurchaseEntry>>
>;

export type DeleteFoodPurchaseEntryMutationError = ErrorType<HttpError>;

export const useDeleteFoodPurchaseEntry = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFoodPurchaseEntry>>,
    TError,
    { id: number; invoiceId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteFoodPurchaseEntryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateAnimalPurchase = (
  id: number,
  updateOxenPurchase: UpdateOxenPurchase,
) => {
  return request<UpdateAnimalPurchaseResponse>({
    url: `/purchases/${id}/oxen`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateOxenPurchase,
  });
};

export const getUpdateAnimalPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnimalPurchase>>,
    TError,
    { id: number; data: UpdateOxenPurchase },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAnimalPurchase>>,
  TError,
  { id: number; data: UpdateOxenPurchase },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAnimalPurchase>>,
    { id: number; data: UpdateOxenPurchase }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAnimalPurchase(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAnimalPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAnimalPurchase>>
>;
export type UpdateAnimalPurchaseMutationBody = UpdateOxenPurchase;
export type UpdateAnimalPurchaseMutationError = ErrorType<HttpError>;

export const useUpdateAnimalPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnimalPurchase>>,
    TError,
    { id: number; data: UpdateOxenPurchase },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateAnimalPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const finishBatchPurchase = (id: number) => {
  return request<boolean>({
    url: `/purchases/${id}/oxen/finish-batch-purchase`,
    method: "POST",
  });
};

export const getFinishBatchPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finishBatchPurchase>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finishBatchPurchase>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finishBatchPurchase>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return finishBatchPurchase(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinishBatchPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof finishBatchPurchase>>
>;

export type FinishBatchPurchaseMutationError = ErrorType<HttpError>;

export const useFinishBatchPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finishBatchPurchase>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getFinishBatchPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listGtasByPurchaseId = (id: number, signal?: AbortSignal) => {
  return request<ListGtasByPurchaseIdResponse>({
    url: `/purchases/${id}/oxen/gtas`,
    method: "GET",
    signal,
  });
};

export const getListGtasByPurchaseIdQueryKey = (id: number) => {
  return [`/purchases/${id}/oxen/gtas`] as const;
};

export const getListGtasByPurchaseIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listGtasByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listGtasByPurchaseId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListGtasByPurchaseIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGtasByPurchaseId>>
  > = ({ signal }) => listGtasByPurchaseId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listGtasByPurchaseId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGtasByPurchaseIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGtasByPurchaseId>>
>;
export type ListGtasByPurchaseIdInfiniteQueryError = ErrorType<unknown>;

export const useListGtasByPurchaseIdInfinite = <
  TData = Awaited<ReturnType<typeof listGtasByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listGtasByPurchaseId>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListGtasByPurchaseIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListGtasByPurchaseIdQueryOptions = <
  TData = Awaited<ReturnType<typeof listGtasByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGtasByPurchaseId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListGtasByPurchaseIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGtasByPurchaseId>>
  > = ({ signal }) => listGtasByPurchaseId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listGtasByPurchaseId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGtasByPurchaseIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGtasByPurchaseId>>
>;
export type ListGtasByPurchaseIdQueryError = ErrorType<unknown>;

export const useListGtasByPurchaseId = <
  TData = Awaited<ReturnType<typeof listGtasByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGtasByPurchaseId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListGtasByPurchaseIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const storageOxenPurchase = (id: number) => {
  return request<StorageOxenPurchaseResponse>({
    url: `/purchases/${id}/oxen/gtas`,
    method: "POST",
  });
};

export const getStorageOxenPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof storageOxenPurchase>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof storageOxenPurchase>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof storageOxenPurchase>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return storageOxenPurchase(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type StorageOxenPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof storageOxenPurchase>>
>;

export type StorageOxenPurchaseMutationError = ErrorType<HttpError>;

export const useStorageOxenPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof storageOxenPurchase>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getStorageOxenPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lista mapas de pesagem vinculados a um pedido de compra. Se status não for informado, retorna todos (IN_USE e
FINISHED) para edição.
 */
export const listWeightingMapsByPurchaseId = (
  id: number,
  params?: ListWeightingMapsByPurchaseIdParams,
  signal?: AbortSignal,
) => {
  return request<ListWeightingMapsByPurchaseIdResponse>({
    url: `/purchases/${id}/weighting-maps`,
    method: "GET",
    params,
    signal,
  });
};

export const getListWeightingMapsByPurchaseIdQueryKey = (
  id: number,
  params?: ListWeightingMapsByPurchaseIdParams,
) => {
  return [
    `/purchases/${id}/weighting-maps`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListWeightingMapsByPurchaseIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ListWeightingMapsByPurchaseIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWeightingMapsByPurchaseIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>
  > = ({ signal }) => listWeightingMapsByPurchaseId(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWeightingMapsByPurchaseIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>
>;
export type ListWeightingMapsByPurchaseIdInfiniteQueryError =
  ErrorType<unknown>;

export const useListWeightingMapsByPurchaseIdInfinite = <
  TData = Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ListWeightingMapsByPurchaseIdParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListWeightingMapsByPurchaseIdInfiniteQueryOptions(
    id,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListWeightingMapsByPurchaseIdQueryOptions = <
  TData = Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ListWeightingMapsByPurchaseIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWeightingMapsByPurchaseIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>
  > = ({ signal }) => listWeightingMapsByPurchaseId(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWeightingMapsByPurchaseIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>
>;
export type ListWeightingMapsByPurchaseIdQueryError = ErrorType<unknown>;

export const useListWeightingMapsByPurchaseId = <
  TData = Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ListWeightingMapsByPurchaseIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWeightingMapsByPurchaseId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListWeightingMapsByPurchaseIdQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Desvincula um mapa de pesagem do pedido de compra. Só permite se o mapa não estiver FINISHED. Após desvincular, se
todos os mapas restantes do pedido estiverem FINISHED, o pedido é marcado como STORED.
 */
export const unlinkWeightingMapFromPurchase = (id: number, mapId: number) => {
  return request<UnlinkWeightingMapFromPurchaseResponse>({
    url: `/purchases/${id}/weighting-maps/${mapId}`,
    method: "DELETE",
  });
};

export const getUnlinkWeightingMapFromPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkWeightingMapFromPurchase>>,
    TError,
    { id: number; mapId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlinkWeightingMapFromPurchase>>,
  TError,
  { id: number; mapId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlinkWeightingMapFromPurchase>>,
    { id: number; mapId: number }
  > = (props) => {
    const { id, mapId } = props ?? {};

    return unlinkWeightingMapFromPurchase(id, mapId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlinkWeightingMapFromPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlinkWeightingMapFromPurchase>>
>;

export type UnlinkWeightingMapFromPurchaseMutationError = ErrorType<HttpError>;

export const useUnlinkWeightingMapFromPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkWeightingMapFromPurchase>>,
    TError,
    { id: number; mapId: number },
    TContext
  >;
}) => {
  const mutationOptions =
    getUnlinkWeightingMapFromPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listRecipes = (
  params?: ListRecipesParams,
  signal?: AbortSignal,
) => {
  return request<ListRecipesResponse>({
    url: `/recipes`,
    method: "GET",
    params,
    signal,
  });
};

export const getListRecipesQueryKey = (params?: ListRecipesParams) => {
  return [`/recipes`, ...(params ? [params] : [])] as const;
};

export const getListRecipesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listRecipes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecipesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listRecipes>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRecipesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecipes>>> = ({
    signal,
  }) => listRecipes(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listRecipes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRecipesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRecipes>>
>;
export type ListRecipesInfiniteQueryError = ErrorType<unknown>;

export const useListRecipesInfinite = <
  TData = Awaited<ReturnType<typeof listRecipes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecipesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listRecipes>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListRecipesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListRecipesQueryOptions = <
  TData = Awaited<ReturnType<typeof listRecipes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecipesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRecipes>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRecipesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecipes>>> = ({
    signal,
  }) => listRecipes(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRecipes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRecipesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRecipes>>
>;
export type ListRecipesQueryError = ErrorType<unknown>;

export const useListRecipes = <
  TData = Awaited<ReturnType<typeof listRecipes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecipesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRecipes>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListRecipesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createRecipe = (createRecipe: CreateRecipe) => {
  return request<CreateRecipeResponse>({
    url: `/recipes`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createRecipe,
  });
};

export const getCreateRecipeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRecipe>>,
    TError,
    { data: CreateRecipe },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRecipe>>,
  TError,
  { data: CreateRecipe },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRecipe>>,
    { data: CreateRecipe }
  > = (props) => {
    const { data } = props ?? {};

    return createRecipe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRecipe>>
>;
export type CreateRecipeMutationBody = CreateRecipe;
export type CreateRecipeMutationError = ErrorType<HttpError>;

export const useCreateRecipe = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRecipe>>,
    TError,
    { data: CreateRecipe },
    TContext
  >;
}) => {
  const mutationOptions = getCreateRecipeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteRecipe = (id: number) => {
  return request<boolean>({ url: `/recipes/${id}`, method: "DELETE" });
};

export const getDeleteRecipeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecipe>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRecipe>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRecipe>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRecipe(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRecipe>>
>;

export type DeleteRecipeMutationError = ErrorType<HttpError>;

export const useDeleteRecipe = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecipe>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteRecipeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getRecipe = (id: number, signal?: AbortSignal) => {
  return request<GetRecipeResponse>({
    url: `/recipes/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetRecipeQueryKey = (id: number) => {
  return [`/recipes/${id}`] as const;
};

export const getGetRecipeInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecipe>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRecipe>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecipeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipe>>> = ({
    signal,
  }) => getRecipe(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRecipe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecipeInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecipe>>
>;
export type GetRecipeInfiniteQueryError = ErrorType<unknown>;

export const useGetRecipeInfinite = <
  TData = Awaited<ReturnType<typeof getRecipe>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRecipe>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRecipeInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetRecipeQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecipe>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecipe>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecipeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipe>>> = ({
    signal,
  }) => getRecipe(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetRecipeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecipe>>
>;
export type GetRecipeQueryError = ErrorType<unknown>;

export const useGetRecipe = <
  TData = Awaited<ReturnType<typeof getRecipe>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecipe>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRecipeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateRecipe = (id: number, updateRecipe: UpdateRecipe) => {
  return request<UpdateRecipeResponse>({
    url: `/recipes/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateRecipe,
  });
};

export const getUpdateRecipeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRecipe>>,
    TError,
    { id: number; data: UpdateRecipe },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRecipe>>,
  TError,
  { id: number; data: UpdateRecipe },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRecipe>>,
    { id: number; data: UpdateRecipe }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRecipe(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRecipe>>
>;
export type UpdateRecipeMutationBody = UpdateRecipe;
export type UpdateRecipeMutationError = ErrorType<HttpError>;

export const useUpdateRecipe = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRecipe>>,
    TError,
    { id: number; data: UpdateRecipe },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateRecipeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getActiveBatchesReport = (
  params?: GetActiveBatchesReportParams,
) => {
  return request<StartActiveBatchesResponse>({
    url: `/reports/active-batches`,
    method: "POST",
    params,
  });
};

export const getGetActiveBatchesReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getActiveBatchesReport>>,
    TError,
    { params?: GetActiveBatchesReportParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getActiveBatchesReport>>,
  TError,
  { params?: GetActiveBatchesReportParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getActiveBatchesReport>>,
    { params?: GetActiveBatchesReportParams }
  > = (props) => {
    const { params } = props ?? {};

    return getActiveBatchesReport(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetActiveBatchesReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof getActiveBatchesReport>>
>;

export type GetActiveBatchesReportMutationError = ErrorType<HttpError>;

export const useGetActiveBatchesReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getActiveBatchesReport>>,
    TError,
    { params?: GetActiveBatchesReportParams },
    TContext
  >;
}) => {
  const mutationOptions = getGetActiveBatchesReportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Estado do cálculo de consumo pedido pelo usuário. Jobs `SYSTEM` (trato, dieta, cache miss) não entram aqui.
 */
export const getActiveBatchesConsumeStatus = (
  params?: GetActiveBatchesConsumeStatusParams,
  signal?: AbortSignal,
) => {
  return request<ActiveBatchesConsumeStatusResponse>({
    url: `/reports/active-batches/consume`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetActiveBatchesConsumeStatusQueryKey = (
  params?: GetActiveBatchesConsumeStatusParams,
) => {
  return [
    `/reports/active-batches/consume`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetActiveBatchesConsumeStatusInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
  TError = ErrorType<unknown>,
>(
  params?: GetActiveBatchesConsumeStatusParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveBatchesConsumeStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>
  > = ({ signal }) => getActiveBatchesConsumeStatus(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveBatchesConsumeStatusInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>
>;
export type GetActiveBatchesConsumeStatusInfiniteQueryError =
  ErrorType<unknown>;

export const useGetActiveBatchesConsumeStatusInfinite = <
  TData = Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
  TError = ErrorType<unknown>,
>(
  params?: GetActiveBatchesConsumeStatusParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActiveBatchesConsumeStatusInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetActiveBatchesConsumeStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
  TError = ErrorType<unknown>,
>(
  params?: GetActiveBatchesConsumeStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveBatchesConsumeStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>
  > = ({ signal }) => getActiveBatchesConsumeStatus(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveBatchesConsumeStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>
>;
export type GetActiveBatchesConsumeStatusQueryError = ErrorType<unknown>;

export const useGetActiveBatchesConsumeStatus = <
  TData = Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
  TError = ErrorType<unknown>,
>(
  params?: GetActiveBatchesConsumeStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesConsumeStatus>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActiveBatchesConsumeStatusQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Enfileira o cálculo de consumo dos lotes ativos no período (`Job.origin = MANUAL`). Enquanto esses jobs estão
`PENDING`/`RUNNING`, `POST /reports/active-batches` responde 409.
 */
export const warmupActiveBatchesConsume = (
  params?: WarmupActiveBatchesConsumeParams,
) => {
  return request<WarmupActiveBatchesConsumeResponse>({
    url: `/reports/active-batches/consume`,
    method: "POST",
    params,
  });
};

export const getWarmupActiveBatchesConsumeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof warmupActiveBatchesConsume>>,
    TError,
    { params?: WarmupActiveBatchesConsumeParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof warmupActiveBatchesConsume>>,
  TError,
  { params?: WarmupActiveBatchesConsumeParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof warmupActiveBatchesConsume>>,
    { params?: WarmupActiveBatchesConsumeParams }
  > = (props) => {
    const { params } = props ?? {};

    return warmupActiveBatchesConsume(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type WarmupActiveBatchesConsumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof warmupActiveBatchesConsume>>
>;

export type WarmupActiveBatchesConsumeMutationError = ErrorType<unknown>;

export const useWarmupActiveBatchesConsume = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof warmupActiveBatchesConsume>>,
    TError,
    { params?: WarmupActiveBatchesConsumeParams },
    TContext
  >;
}) => {
  const mutationOptions = getWarmupActiveBatchesConsumeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateActiveBatchesReportExcel = (
  generateActiveBatchesReportExcelBody: GenerateActiveBatchesReportExcelBody,
) => {
  return request<GenerateActiveBatchesReportExcelResponse>({
    url: `/reports/active-batches/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateActiveBatchesReportExcelBody,
  });
};

export const getGenerateActiveBatchesReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateActiveBatchesReportExcel>>,
    TError,
    { data: GenerateActiveBatchesReportExcelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateActiveBatchesReportExcel>>,
  TError,
  { data: GenerateActiveBatchesReportExcelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateActiveBatchesReportExcel>>,
    { data: GenerateActiveBatchesReportExcelBody }
  > = (props) => {
    const { data } = props ?? {};

    return generateActiveBatchesReportExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateActiveBatchesReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateActiveBatchesReportExcel>>
>;
export type GenerateActiveBatchesReportExcelMutationBody =
  GenerateActiveBatchesReportExcelBody;
export type GenerateActiveBatchesReportExcelMutationError = ErrorType<unknown>;

export const useGenerateActiveBatchesReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateActiveBatchesReportExcel>>,
    TError,
    { data: GenerateActiveBatchesReportExcelBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateActiveBatchesReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cancelActiveBatchesReport = (jobId: string) => {
  return request<CancelActiveBatchesReportResponse>({
    url: `/reports/active-batches/${jobId}`,
    method: "DELETE",
  });
};

export const getCancelActiveBatchesReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelActiveBatchesReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelActiveBatchesReport>>,
  TError,
  { jobId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelActiveBatchesReport>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return cancelActiveBatchesReport(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelActiveBatchesReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelActiveBatchesReport>>
>;

export type CancelActiveBatchesReportMutationError = ErrorType<HttpError>;

export const useCancelActiveBatchesReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelActiveBatchesReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}) => {
  const mutationOptions = getCancelActiveBatchesReportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getActiveBatchesReportState = (
  jobId: string,
  signal?: AbortSignal,
) => {
  return request<ActiveBatchesStateResponse>({
    url: `/reports/active-batches/${jobId}`,
    method: "GET",
    signal,
  });
};

export const getGetActiveBatchesReportStateQueryKey = (jobId: string) => {
  return [`/reports/active-batches/${jobId}`] as const;
};

export const getGetActiveBatchesReportStateInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveBatchesReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveBatchesReportState>>
  > = ({ signal }) => getActiveBatchesReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getActiveBatchesReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveBatchesReportStateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveBatchesReportState>>
>;
export type GetActiveBatchesReportStateInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetActiveBatchesReportStateInfinite = <
  TData = Awaited<ReturnType<typeof getActiveBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesReportState>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActiveBatchesReportStateInfiniteQueryOptions(
    jobId,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetActiveBatchesReportStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveBatchesReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveBatchesReportState>>
  > = ({ signal }) => getActiveBatchesReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveBatchesReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveBatchesReportStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveBatchesReportState>>
>;
export type GetActiveBatchesReportStateQueryError = ErrorType<HttpError>;

export const useGetActiveBatchesReportState = <
  TData = Awaited<ReturnType<typeof getActiveBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActiveBatchesReportState>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActiveBatchesReportStateQueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getAnalyticalReport = (
  params: GetAnalyticalReportParams,
  signal?: AbortSignal,
) => {
  return request<void>({
    url: `/reports/analytical`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAnalyticalReportQueryKey = (
  params: GetAnalyticalReportParams,
) => {
  return [`/reports/analytical`, ...(params ? [params] : [])] as const;
};

export const getGetAnalyticalReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetAnalyticalReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticalReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticalReport>>
  > = ({ signal }) => getAnalyticalReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAnalyticalReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticalReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticalReport>>
>;
export type GetAnalyticalReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetAnalyticalReportInfinite = <
  TData = Awaited<ReturnType<typeof getAnalyticalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetAnalyticalReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnalyticalReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetAnalyticalReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetAnalyticalReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticalReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticalReport>>
  > = ({ signal }) => getAnalyticalReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticalReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticalReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticalReport>>
>;
export type GetAnalyticalReportQueryError = ErrorType<HttpError>;

export const useGetAnalyticalReport = <
  TData = Awaited<ReturnType<typeof getAnalyticalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetAnalyticalReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnalyticalReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listBatchesForAnalyticalReport = (signal?: AbortSignal) => {
  return request<ListBatchesForAnalyticalReportResponse>({
    url: `/reports/analytical/available-batches`,
    method: "GET",
    signal,
  });
};

export const getListBatchesForAnalyticalReportQueryKey = () => {
  return [`/reports/analytical/available-batches`] as const;
};

export const getListBatchesForAnalyticalReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesForAnalyticalReportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>
  > = ({ signal }) => listBatchesForAnalyticalReport(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesForAnalyticalReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>
>;
export type ListBatchesForAnalyticalReportInfiniteQueryError =
  ErrorType<unknown>;

export const useListBatchesForAnalyticalReportInfinite = <
  TData = Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListBatchesForAnalyticalReportInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBatchesForAnalyticalReportQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesForAnalyticalReportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>
  > = ({ signal }) => listBatchesForAnalyticalReport(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchesForAnalyticalReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>
>;
export type ListBatchesForAnalyticalReportQueryError = ErrorType<unknown>;

export const useListBatchesForAnalyticalReport = <
  TData = Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesForAnalyticalReport>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBatchesForAnalyticalReportQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Detalhamento por animal dos dias de confinamento e dias de trato exibidos no relatório analítico de lote. O resumo do
relatório é a agregação deste mesmo retorno — uma única fonte de verdade.
 */
export const analyticalBatchDaysDetails = (
  params: AnalyticalBatchDaysDetailsParams,
  signal?: AbortSignal,
) => {
  return request<AnalyticalBatchDaysDetailsReturn>({
    url: `/reports/analytical/days-details`,
    method: "GET",
    params,
    signal,
  });
};

export const getAnalyticalBatchDaysDetailsQueryKey = (
  params: AnalyticalBatchDaysDetailsParams,
) => {
  return [
    `/reports/analytical/days-details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAnalyticalBatchDaysDetailsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
  TError = ErrorType<unknown>,
>(
  params: AnalyticalBatchDaysDetailsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAnalyticalBatchDaysDetailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof analyticalBatchDaysDetails>>
  > = ({ signal }) => analyticalBatchDaysDetails(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AnalyticalBatchDaysDetailsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof analyticalBatchDaysDetails>>
>;
export type AnalyticalBatchDaysDetailsInfiniteQueryError = ErrorType<unknown>;

export const useAnalyticalBatchDaysDetailsInfinite = <
  TData = Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
  TError = ErrorType<unknown>,
>(
  params: AnalyticalBatchDaysDetailsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAnalyticalBatchDaysDetailsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getAnalyticalBatchDaysDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
  TError = ErrorType<unknown>,
>(
  params: AnalyticalBatchDaysDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAnalyticalBatchDaysDetailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof analyticalBatchDaysDetails>>
  > = ({ signal }) => analyticalBatchDaysDetails(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AnalyticalBatchDaysDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof analyticalBatchDaysDetails>>
>;
export type AnalyticalBatchDaysDetailsQueryError = ErrorType<unknown>;

export const useAnalyticalBatchDaysDetails = <
  TData = Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
  TError = ErrorType<unknown>,
>(
  params: AnalyticalBatchDaysDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof analyticalBatchDaysDetails>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAnalyticalBatchDaysDetailsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getAnalyticalReportExcel = (
  analyticalReportServiceResponse: AnalyticalReportServiceResponse,
  params: GetAnalyticalReportExcelParams,
) => {
  return request<GetAnalyticalReportExcelResponse>({
    url: `/reports/analytical/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: analyticalReportServiceResponse,
    params,
  });
};

export const getGetAnalyticalReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnalyticalReportExcel>>,
    TError,
    {
      data: AnalyticalReportServiceResponse;
      params: GetAnalyticalReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAnalyticalReportExcel>>,
  TError,
  {
    data: AnalyticalReportServiceResponse;
    params: GetAnalyticalReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAnalyticalReportExcel>>,
    {
      data: AnalyticalReportServiceResponse;
      params: GetAnalyticalReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return getAnalyticalReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAnalyticalReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticalReportExcel>>
>;
export type GetAnalyticalReportExcelMutationBody =
  AnalyticalReportServiceResponse;
export type GetAnalyticalReportExcelMutationError = ErrorType<unknown>;

export const useGetAnalyticalReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnalyticalReportExcel>>,
    TError,
    {
      data: AnalyticalReportServiceResponse;
      params: GetAnalyticalReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions = getGetAnalyticalReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getStackedAnalyticalReportExcel = (
  getStackedAnalyticalReportExcelBody: GetStackedAnalyticalReportExcelBody,
  params: GetStackedAnalyticalReportExcelParams,
) => {
  return request<GetStackedAnalyticalReportExcelResponse>({
    url: `/reports/analytical/excel/stacked`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: getStackedAnalyticalReportExcelBody,
    params,
  });
};

export const getGetStackedAnalyticalReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getStackedAnalyticalReportExcel>>,
    TError,
    {
      data: GetStackedAnalyticalReportExcelBody;
      params: GetStackedAnalyticalReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getStackedAnalyticalReportExcel>>,
  TError,
  {
    data: GetStackedAnalyticalReportExcelBody;
    params: GetStackedAnalyticalReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getStackedAnalyticalReportExcel>>,
    {
      data: GetStackedAnalyticalReportExcelBody;
      params: GetStackedAnalyticalReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return getStackedAnalyticalReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetStackedAnalyticalReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof getStackedAnalyticalReportExcel>>
>;
export type GetStackedAnalyticalReportExcelMutationBody =
  GetStackedAnalyticalReportExcelBody;
export type GetStackedAnalyticalReportExcelMutationError = ErrorType<unknown>;

export const useGetStackedAnalyticalReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getStackedAnalyticalReportExcel>>,
    TError,
    {
      data: GetStackedAnalyticalReportExcelBody;
      params: GetStackedAnalyticalReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGetStackedAnalyticalReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const countBeatsForBakingEfficiencyReport = (
  params: CountBeatsForBakingEfficiencyReportParams,
  signal?: AbortSignal,
) => {
  return request<CountBeatsForBakingEfficiencyReportResponse>({
    url: `/reports/baking-efficiency/count`,
    method: "GET",
    params,
    signal,
  });
};

export const getCountBeatsForBakingEfficiencyReportQueryKey = (
  params: CountBeatsForBakingEfficiencyReportParams,
) => {
  return [
    `/reports/baking-efficiency/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountBeatsForBakingEfficiencyReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBeatsForBakingEfficiencyReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountBeatsForBakingEfficiencyReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>
  > = ({ signal }) => countBeatsForBakingEfficiencyReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountBeatsForBakingEfficiencyReportInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>>;
export type CountBeatsForBakingEfficiencyReportInfiniteQueryError =
  ErrorType<HttpError>;

export const useCountBeatsForBakingEfficiencyReportInfinite = <
  TData = Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBeatsForBakingEfficiencyReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getCountBeatsForBakingEfficiencyReportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCountBeatsForBakingEfficiencyReportQueryOptions = <
  TData = Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBeatsForBakingEfficiencyReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountBeatsForBakingEfficiencyReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>
  > = ({ signal }) => countBeatsForBakingEfficiencyReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountBeatsForBakingEfficiencyReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>
>;
export type CountBeatsForBakingEfficiencyReportQueryError =
  ErrorType<HttpError>;

export const useCountBeatsForBakingEfficiencyReport = <
  TData = Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBeatsForBakingEfficiencyReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countBeatsForBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCountBeatsForBakingEfficiencyReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateBakingEfficiencyReportExcel = (
  generateBakingEfficiencyReportExcelBody: GenerateBakingEfficiencyReportExcelBody,
  params: GenerateBakingEfficiencyReportExcelParams,
) => {
  return request<GenerateBakingEfficiencyReportExcelResponse>({
    url: `/reports/baking-efficiency/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateBakingEfficiencyReportExcelBody,
    params,
  });
};

export const getGenerateBakingEfficiencyReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBakingEfficiencyReportExcel>>,
    TError,
    {
      data: GenerateBakingEfficiencyReportExcelBody;
      params: GenerateBakingEfficiencyReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateBakingEfficiencyReportExcel>>,
  TError,
  {
    data: GenerateBakingEfficiencyReportExcelBody;
    params: GenerateBakingEfficiencyReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateBakingEfficiencyReportExcel>>,
    {
      data: GenerateBakingEfficiencyReportExcelBody;
      params: GenerateBakingEfficiencyReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return generateBakingEfficiencyReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateBakingEfficiencyReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateBakingEfficiencyReportExcel>>
>;
export type GenerateBakingEfficiencyReportExcelMutationBody =
  GenerateBakingEfficiencyReportExcelBody;
export type GenerateBakingEfficiencyReportExcelMutationError =
  ErrorType<unknown>;

export const useGenerateBakingEfficiencyReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBakingEfficiencyReportExcel>>,
    TError,
    {
      data: GenerateBakingEfficiencyReportExcelBody;
      params: GenerateBakingEfficiencyReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateBakingEfficiencyReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getBakingEfficiencyReport = (
  params: GetBakingEfficiencyReportParams,
  signal?: AbortSignal,
) => {
  return request<GetBakingEfficiencyReportResponse>({
    url: `/reports/baking-efficiency/report`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBakingEfficiencyReportQueryKey = (
  params: GetBakingEfficiencyReportParams,
) => {
  return [
    `/reports/baking-efficiency/report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBakingEfficiencyReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBakingEfficiencyReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBakingEfficiencyReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBakingEfficiencyReport>>
  > = ({ signal }) => getBakingEfficiencyReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBakingEfficiencyReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBakingEfficiencyReport>>
>;
export type GetBakingEfficiencyReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetBakingEfficiencyReportInfinite = <
  TData = Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBakingEfficiencyReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBakingEfficiencyReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBakingEfficiencyReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBakingEfficiencyReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBakingEfficiencyReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBakingEfficiencyReport>>
  > = ({ signal }) => getBakingEfficiencyReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBakingEfficiencyReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBakingEfficiencyReport>>
>;
export type GetBakingEfficiencyReportQueryError = ErrorType<HttpError>;

export const useGetBakingEfficiencyReport = <
  TData = Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetBakingEfficiencyReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBakingEfficiencyReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBakingEfficiencyReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateCattleEntryPerCategoryReportExcel = (
  cattleEntryPerCategoryGenerateExcelRequest: CattleEntryPerCategoryGenerateExcelRequest,
  params: GenerateCattleEntryPerCategoryReportExcelParams,
) => {
  return request<GenerateCattleEntryPerCategoryReportExcelResponse>({
    url: `/reports/cattle-entry-per-category/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cattleEntryPerCategoryGenerateExcelRequest,
    params,
  });
};

export const getGenerateCattleEntryPerCategoryReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCattleEntryPerCategoryReportExcel>>,
    TError,
    {
      data: CattleEntryPerCategoryGenerateExcelRequest;
      params: GenerateCattleEntryPerCategoryReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateCattleEntryPerCategoryReportExcel>>,
  TError,
  {
    data: CattleEntryPerCategoryGenerateExcelRequest;
    params: GenerateCattleEntryPerCategoryReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateCattleEntryPerCategoryReportExcel>>,
    {
      data: CattleEntryPerCategoryGenerateExcelRequest;
      params: GenerateCattleEntryPerCategoryReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return generateCattleEntryPerCategoryReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateCattleEntryPerCategoryReportExcelMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof generateCattleEntryPerCategoryReportExcel>>
  >;
export type GenerateCattleEntryPerCategoryReportExcelMutationBody =
  CattleEntryPerCategoryGenerateExcelRequest;
export type GenerateCattleEntryPerCategoryReportExcelMutationError =
  ErrorType<unknown>;

export const useGenerateCattleEntryPerCategoryReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCattleEntryPerCategoryReportExcel>>,
    TError,
    {
      data: CattleEntryPerCategoryGenerateExcelRequest;
      params: GenerateCattleEntryPerCategoryReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateCattleEntryPerCategoryReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCattleEntryPerCategoryReport = (
  params?: GetCattleEntryPerCategoryReportParams,
  signal?: AbortSignal,
) => {
  return request<GetCattleEntryPerCategoryReportResponse>({
    url: `/reports/cattle-entry-per-category/report`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCattleEntryPerCategoryReportQueryKey = (
  params?: GetCattleEntryPerCategoryReportParams,
) => {
  return [
    `/reports/cattle-entry-per-category/report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCattleEntryPerCategoryReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCattleEntryPerCategoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCattleEntryPerCategoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>
  > = ({ signal }) => getCattleEntryPerCategoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleEntryPerCategoryReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>
>;
export type GetCattleEntryPerCategoryReportInfiniteQueryError =
  ErrorType<unknown>;

export const useGetCattleEntryPerCategoryReportInfinite = <
  TData = Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCattleEntryPerCategoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCattleEntryPerCategoryReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetCattleEntryPerCategoryReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCattleEntryPerCategoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCattleEntryPerCategoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>
  > = ({ signal }) => getCattleEntryPerCategoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCattleEntryPerCategoryReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>
>;
export type GetCattleEntryPerCategoryReportQueryError = ErrorType<unknown>;

export const useGetCattleEntryPerCategoryReport = <
  TData = Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCattleEntryPerCategoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCattleEntryPerCategoryReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCattleEntryPerCategoryReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getComissionReport = (
  params?: GetComissionReportParams,
  signal?: AbortSignal,
) => {
  return request<ComissionReport>({
    url: `/reports/comission`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetComissionReportQueryKey = (
  params?: GetComissionReportParams,
) => {
  return [`/reports/comission`, ...(params ? [params] : [])] as const;
};

export const getGetComissionReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getComissionReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetComissionReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getComissionReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetComissionReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getComissionReport>>
  > = ({ signal }) => getComissionReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getComissionReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetComissionReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getComissionReport>>
>;
export type GetComissionReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetComissionReportInfinite = <
  TData = Awaited<ReturnType<typeof getComissionReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetComissionReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getComissionReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetComissionReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetComissionReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getComissionReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetComissionReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getComissionReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetComissionReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getComissionReport>>
  > = ({ signal }) => getComissionReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getComissionReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetComissionReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getComissionReport>>
>;
export type GetComissionReportQueryError = ErrorType<HttpError>;

export const useGetComissionReport = <
  TData = Awaited<ReturnType<typeof getComissionReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetComissionReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getComissionReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetComissionReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const countConsolidatedInternalSaleReport = (
  params: CountConsolidatedInternalSaleReportParams,
  signal?: AbortSignal,
) => {
  return request<CountConsolidatedInternalSaleReportResponse>({
    url: `/reports/consolidated-internal-sale/count`,
    method: "GET",
    params,
    signal,
  });
};

export const getCountConsolidatedInternalSaleReportQueryKey = (
  params: CountConsolidatedInternalSaleReportParams,
) => {
  return [
    `/reports/consolidated-internal-sale/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountConsolidatedInternalSaleReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountConsolidatedInternalSaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>
  > = ({ signal }) => countConsolidatedInternalSaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountConsolidatedInternalSaleReportInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>>;
export type CountConsolidatedInternalSaleReportInfiniteQueryError =
  ErrorType<HttpError>;

export const useCountConsolidatedInternalSaleReportInfinite = <
  TData = Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getCountConsolidatedInternalSaleReportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCountConsolidatedInternalSaleReportQueryOptions = <
  TData = Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountConsolidatedInternalSaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>
  > = ({ signal }) => countConsolidatedInternalSaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountConsolidatedInternalSaleReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>
>;
export type CountConsolidatedInternalSaleReportQueryError =
  ErrorType<HttpError>;

export const useCountConsolidatedInternalSaleReport = <
  TData = Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCountConsolidatedInternalSaleReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getConsolidatedInternalSaleReportXlsx = (
  consolidatedInternalSaleResponse: ConsolidatedInternalSaleResponse,
  params: GetConsolidatedInternalSaleReportXlsxParams,
) => {
  return request<GetConsolidatedInternalSaleReportXlsxResponse>({
    url: `/reports/consolidated-internal-sale/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: consolidatedInternalSaleResponse,
    params,
  });
};

export const getGetConsolidatedInternalSaleReportXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConsolidatedInternalSaleReportXlsx>>,
    TError,
    {
      data: ConsolidatedInternalSaleResponse;
      params: GetConsolidatedInternalSaleReportXlsxParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getConsolidatedInternalSaleReportXlsx>>,
  TError,
  {
    data: ConsolidatedInternalSaleResponse;
    params: GetConsolidatedInternalSaleReportXlsxParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getConsolidatedInternalSaleReportXlsx>>,
    {
      data: ConsolidatedInternalSaleResponse;
      params: GetConsolidatedInternalSaleReportXlsxParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return getConsolidatedInternalSaleReportXlsx(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetConsolidatedInternalSaleReportXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof getConsolidatedInternalSaleReportXlsx>>
>;
export type GetConsolidatedInternalSaleReportXlsxMutationBody =
  ConsolidatedInternalSaleResponse;
export type GetConsolidatedInternalSaleReportXlsxMutationError =
  ErrorType<unknown>;

export const useGetConsolidatedInternalSaleReportXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConsolidatedInternalSaleReportXlsx>>,
    TError,
    {
      data: ConsolidatedInternalSaleResponse;
      params: GetConsolidatedInternalSaleReportXlsxParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGetConsolidatedInternalSaleReportXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getConsolidatedInternalSaleReport = (
  params: GetConsolidatedInternalSaleReportParams,
  signal?: AbortSignal,
) => {
  return request<GetConsolidatedInternalSaleReportResponse>({
    url: `/reports/consolidated-internal-sale/report`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetConsolidatedInternalSaleReportQueryKey = (
  params: GetConsolidatedInternalSaleReportParams,
) => {
  return [
    `/reports/consolidated-internal-sale/report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConsolidatedInternalSaleReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConsolidatedInternalSaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>
  > = ({ signal }) => getConsolidatedInternalSaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConsolidatedInternalSaleReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>
>;
export type GetConsolidatedInternalSaleReportInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetConsolidatedInternalSaleReportInfinite = <
  TData = Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetConsolidatedInternalSaleReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetConsolidatedInternalSaleReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConsolidatedInternalSaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>
  > = ({ signal }) => getConsolidatedInternalSaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConsolidatedInternalSaleReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>
>;
export type GetConsolidatedInternalSaleReportQueryError = ErrorType<HttpError>;

export const useGetConsolidatedInternalSaleReport = <
  TData = Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetConsolidatedInternalSaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getConsolidatedInternalSaleReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetConsolidatedInternalSaleReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getDailyFoodReport = (
  params: GetDailyFoodReportParams,
  signal?: AbortSignal,
) => {
  return request<DailyFoodReportServiceResponse>({
    url: `/reports/daily-food`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDailyFoodReportQueryKey = (
  params: GetDailyFoodReportParams,
) => {
  return [`/reports/daily-food`, ...(params ? [params] : [])] as const;
};

export const getGetDailyFoodReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyFoodReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetDailyFoodReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDailyFoodReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyFoodReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyFoodReport>>
  > = ({ signal }) => getDailyFoodReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDailyFoodReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyFoodReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyFoodReport>>
>;
export type GetDailyFoodReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetDailyFoodReportInfinite = <
  TData = Awaited<ReturnType<typeof getDailyFoodReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetDailyFoodReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDailyFoodReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDailyFoodReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetDailyFoodReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyFoodReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetDailyFoodReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyFoodReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyFoodReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyFoodReport>>
  > = ({ signal }) => getDailyFoodReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyFoodReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyFoodReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyFoodReport>>
>;
export type GetDailyFoodReportQueryError = ErrorType<HttpError>;

export const useGetDailyFoodReport = <
  TData = Awaited<ReturnType<typeof getDailyFoodReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetDailyFoodReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyFoodReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDailyFoodReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getDailyFoodReportExcel = (
  dailyFoodReportServiceResponse: DailyFoodReportServiceResponse,
  params: GetDailyFoodReportExcelParams,
) => {
  return request<GetDailyFoodReportExcelResponse>({
    url: `/reports/daily-food/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: dailyFoodReportServiceResponse,
    params,
  });
};

export const getGetDailyFoodReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDailyFoodReportExcel>>,
    TError,
    {
      data: DailyFoodReportServiceResponse;
      params: GetDailyFoodReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getDailyFoodReportExcel>>,
  TError,
  {
    data: DailyFoodReportServiceResponse;
    params: GetDailyFoodReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getDailyFoodReportExcel>>,
    {
      data: DailyFoodReportServiceResponse;
      params: GetDailyFoodReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return getDailyFoodReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetDailyFoodReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof getDailyFoodReportExcel>>
>;
export type GetDailyFoodReportExcelMutationBody =
  DailyFoodReportServiceResponse;
export type GetDailyFoodReportExcelMutationError = ErrorType<unknown>;

export const useGetDailyFoodReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDailyFoodReportExcel>>,
    TError,
    {
      data: DailyFoodReportServiceResponse;
      params: GetDailyFoodReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions = getGetDailyFoodReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEconomicReport = (
  params: GetEconomicReportParams,
  signal?: AbortSignal,
) => {
  return request<void>({
    url: `/reports/economic`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetEconomicReportQueryKey = (
  params: GetEconomicReportParams,
) => {
  return [`/reports/economic`, ...(params ? [params] : [])] as const;
};

export const getGetEconomicReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getEconomicReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetEconomicReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEconomicReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEconomicReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEconomicReport>>
  > = ({ signal }) => getEconomicReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEconomicReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEconomicReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEconomicReport>>
>;
export type GetEconomicReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetEconomicReportInfinite = <
  TData = Awaited<ReturnType<typeof getEconomicReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetEconomicReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getEconomicReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEconomicReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetEconomicReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getEconomicReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetEconomicReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEconomicReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEconomicReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEconomicReport>>
  > = ({ signal }) => getEconomicReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEconomicReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEconomicReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEconomicReport>>
>;
export type GetEconomicReportQueryError = ErrorType<HttpError>;

export const useGetEconomicReport = <
  TData = Awaited<ReturnType<typeof getEconomicReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetEconomicReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEconomicReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEconomicReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEconomicReportExcel = (
  economicReportServiceResponse: EconomicReportServiceResponse,
  params: GetEconomicReportExcelParams,
) => {
  return request<GetEconomicReportExcelResponse>({
    url: `/reports/economic/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: economicReportServiceResponse,
    params,
  });
};

export const getGetEconomicReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getEconomicReportExcel>>,
    TError,
    {
      data: EconomicReportServiceResponse;
      params: GetEconomicReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getEconomicReportExcel>>,
  TError,
  { data: EconomicReportServiceResponse; params: GetEconomicReportExcelParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getEconomicReportExcel>>,
    {
      data: EconomicReportServiceResponse;
      params: GetEconomicReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return getEconomicReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetEconomicReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof getEconomicReportExcel>>
>;
export type GetEconomicReportExcelMutationBody = EconomicReportServiceResponse;
export type GetEconomicReportExcelMutationError = ErrorType<unknown>;

export const useGetEconomicReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getEconomicReportExcel>>,
    TError,
    {
      data: EconomicReportServiceResponse;
      params: GetEconomicReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions = getGetEconomicReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOxenEntranceReport = (
  params?: GetOxenEntranceReportParams,
  signal?: AbortSignal,
) => {
  return request<EntranceReport>({
    url: `/reports/entrance`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOxenEntranceReportQueryKey = (
  params?: GetOxenEntranceReportParams,
) => {
  return [`/reports/entrance`, ...(params ? [params] : [])] as const;
};

export const getGetOxenEntranceReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getOxenEntranceReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetOxenEntranceReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOxenEntranceReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOxenEntranceReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOxenEntranceReport>>
  > = ({ signal }) => getOxenEntranceReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOxenEntranceReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOxenEntranceReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOxenEntranceReport>>
>;
export type GetOxenEntranceReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetOxenEntranceReportInfinite = <
  TData = Awaited<ReturnType<typeof getOxenEntranceReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetOxenEntranceReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOxenEntranceReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOxenEntranceReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetOxenEntranceReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getOxenEntranceReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetOxenEntranceReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOxenEntranceReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOxenEntranceReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOxenEntranceReport>>
  > = ({ signal }) => getOxenEntranceReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOxenEntranceReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOxenEntranceReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOxenEntranceReport>>
>;
export type GetOxenEntranceReportQueryError = ErrorType<HttpError>;

export const useGetOxenEntranceReport = <
  TData = Awaited<ReturnType<typeof getOxenEntranceReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetOxenEntranceReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOxenEntranceReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOxenEntranceReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dispara o relatório financeiro de lotes em segundo plano e responde na hora com o `jobId`.

O processamento **não** é aguardado aqui; o frontend acompanha por `GET /reports/financial-batches/:jobId`. Mecanismo
descrito em `docs/viabilidade-relatorio-em-segundo-plano.md`.
 */
export const startFinancialBatchesReport = () => {
  return request<StartFinancialBatchesResponse>({
    url: `/reports/financial-batches`,
    method: "POST",
  });
};

export const getStartFinancialBatchesReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startFinancialBatchesReport>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startFinancialBatchesReport>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startFinancialBatchesReport>>,
    void
  > = () => {
    return startFinancialBatchesReport();
  };

  return { mutationFn, ...mutationOptions };
};

export type StartFinancialBatchesReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof startFinancialBatchesReport>>
>;

export type StartFinancialBatchesReportMutationError = ErrorType<HttpError>;

export const useStartFinancialBatchesReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startFinancialBatchesReport>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions =
    getStartFinancialBatchesReportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Exporta o relatório financeiro de lotes para Excel.

O cliente devolve no corpo o relatório **já computado** — este endpoint só formata. É o mesmo desenho das demais
exportações da casa (ver `reports/weighing/excel.ts`): evita reprocessar em segundo plano só para exportar, e garante
que a planilha contém exatamente o que a tela mostrou.

No app o arquivo é gravado direto no caminho escolhido no diálogo e o retorno é `buffer: null`; na web volta em
base64 para o navegador baixar (`checkIfIsWeb` decide por User-Agent).
 */
export const generateFinancialBatchesReportExcel = (
  financialBatchesRow: FinancialBatchesRow[],
  params: GenerateFinancialBatchesReportExcelParams,
) => {
  return request<GenerateFinancialBatchesReportExcelResponse>({
    url: `/reports/financial-batches/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: financialBatchesRow,
    params,
  });
};

export const getGenerateFinancialBatchesReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateFinancialBatchesReportExcel>>,
    TError,
    {
      data: FinancialBatchesRow[];
      params: GenerateFinancialBatchesReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateFinancialBatchesReportExcel>>,
  TError,
  {
    data: FinancialBatchesRow[];
    params: GenerateFinancialBatchesReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateFinancialBatchesReportExcel>>,
    {
      data: FinancialBatchesRow[];
      params: GenerateFinancialBatchesReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return generateFinancialBatchesReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateFinancialBatchesReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateFinancialBatchesReportExcel>>
>;
export type GenerateFinancialBatchesReportExcelMutationBody =
  FinancialBatchesRow[];
export type GenerateFinancialBatchesReportExcelMutationError =
  ErrorType<unknown>;

export const useGenerateFinancialBatchesReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateFinancialBatchesReportExcel>>,
    TError,
    {
      data: FinancialBatchesRow[];
      params: GenerateFinancialBatchesReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateFinancialBatchesReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Cancela o relatório. O processamento para na fronteira da próxima fatia, não no meio dela.
 */
export const cancelFinancialBatchesReport = (jobId: string) => {
  return request<CancelFinancialBatchesReportResponse>({
    url: `/reports/financial-batches/${jobId}`,
    method: "DELETE",
  });
};

export const getCancelFinancialBatchesReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelFinancialBatchesReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelFinancialBatchesReport>>,
  TError,
  { jobId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelFinancialBatchesReport>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return cancelFinancialBatchesReport(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelFinancialBatchesReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelFinancialBatchesReport>>
>;

export type CancelFinancialBatchesReportMutationError = ErrorType<HttpError>;

export const useCancelFinancialBatchesReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelFinancialBatchesReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}) => {
  const mutationOptions =
    getCancelFinancialBatchesReportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Estado do relatório financeiro. É esta rota que o frontend consulta em intervalo enquanto o relatório roda.

Job ausente = expirado pelo TTL (1 h) ou de outro processo. O frontend trata isso como "gere novamente", não como
erro técnico.
 */
export const getFinancialBatchesReportState = (
  jobId: string,
  signal?: AbortSignal,
) => {
  return request<FinancialBatchesStateResponse>({
    url: `/reports/financial-batches/${jobId}`,
    method: "GET",
    signal,
  });
};

export const getGetFinancialBatchesReportStateQueryKey = (jobId: string) => {
  return [`/reports/financial-batches/${jobId}`] as const;
};

export const getGetFinancialBatchesReportStateInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFinancialBatchesReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFinancialBatchesReportState>>
  > = ({ signal }) => getFinancialBatchesReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFinancialBatchesReportStateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinancialBatchesReportState>>
>;
export type GetFinancialBatchesReportStateInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetFinancialBatchesReportStateInfinite = <
  TData = Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFinancialBatchesReportStateInfiniteQueryOptions(
    jobId,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFinancialBatchesReportStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFinancialBatchesReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFinancialBatchesReportState>>
  > = ({ signal }) => getFinancialBatchesReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFinancialBatchesReportStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinancialBatchesReportState>>
>;
export type GetFinancialBatchesReportStateQueryError = ErrorType<HttpError>;

export const useGetFinancialBatchesReportState = <
  TData = Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFinancialBatchesReportState>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFinancialBatchesReportStateQueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFoodStockReport = (signal?: AbortSignal) => {
  return request<GetFoodStockReportResponse>({
    url: `/reports/food`,
    method: "GET",
    signal,
  });
};

export const getGetFoodStockReportQueryKey = () => {
  return [`/reports/food`] as const;
};

export const getGetFoodStockReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodStockReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFoodStockReport>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFoodStockReportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodStockReport>>
  > = ({ signal }) => getFoodStockReport(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFoodStockReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodStockReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodStockReport>>
>;
export type GetFoodStockReportInfiniteQueryError = ErrorType<unknown>;

export const useGetFoodStockReportInfinite = <
  TData = Awaited<ReturnType<typeof getFoodStockReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFoodStockReport>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodStockReportInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFoodStockReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodStockReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFoodStockReport>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFoodStockReportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodStockReport>>
  > = ({ signal }) => getFoodStockReport(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFoodStockReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodStockReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodStockReport>>
>;
export type GetFoodStockReportQueryError = ErrorType<unknown>;

export const useGetFoodStockReport = <
  TData = Awaited<ReturnType<typeof getFoodStockReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFoodStockReport>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodStockReportQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFoodEnergyHistoryReport = (
  params: GetFoodEnergyHistoryReportParams,
  signal?: AbortSignal,
) => {
  return request<FoodEnergyHistoryReportResponse>({
    url: `/reports/food-energy-history`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFoodEnergyHistoryReportQueryKey = (
  params: GetFoodEnergyHistoryReportParams,
) => {
  return [`/reports/food-energy-history`, ...(params ? [params] : [])] as const;
};

export const getGetFoodEnergyHistoryReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodEnergyHistoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodEnergyHistoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>
  > = ({ signal }) => getFoodEnergyHistoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodEnergyHistoryReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>
>;
export type GetFoodEnergyHistoryReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetFoodEnergyHistoryReportInfinite = <
  TData = Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodEnergyHistoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodEnergyHistoryReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFoodEnergyHistoryReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodEnergyHistoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodEnergyHistoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>
  > = ({ signal }) => getFoodEnergyHistoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodEnergyHistoryReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>
>;
export type GetFoodEnergyHistoryReportQueryError = ErrorType<HttpError>;

export const useGetFoodEnergyHistoryReport = <
  TData = Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodEnergyHistoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodEnergyHistoryReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodEnergyHistoryReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFoodEnergyHistoryReportExcel = (
  foodEnergyHistoryReportResponse: FoodEnergyHistoryReportResponse,
  params: GetFoodEnergyHistoryReportExcelParams,
) => {
  return request<GetFoodEnergyHistoryReportExcelResponse>({
    url: `/reports/food-energy-history/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: foodEnergyHistoryReportResponse,
    params,
  });
};

export const getGetFoodEnergyHistoryReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getFoodEnergyHistoryReportExcel>>,
    TError,
    {
      data: FoodEnergyHistoryReportResponse;
      params: GetFoodEnergyHistoryReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getFoodEnergyHistoryReportExcel>>,
  TError,
  {
    data: FoodEnergyHistoryReportResponse;
    params: GetFoodEnergyHistoryReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getFoodEnergyHistoryReportExcel>>,
    {
      data: FoodEnergyHistoryReportResponse;
      params: GetFoodEnergyHistoryReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return getFoodEnergyHistoryReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetFoodEnergyHistoryReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof getFoodEnergyHistoryReportExcel>>
>;
export type GetFoodEnergyHistoryReportExcelMutationBody =
  FoodEnergyHistoryReportResponse;
export type GetFoodEnergyHistoryReportExcelMutationError = ErrorType<unknown>;

export const useGetFoodEnergyHistoryReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getFoodEnergyHistoryReportExcel>>,
    TError,
    {
      data: FoodEnergyHistoryReportResponse;
      params: GetFoodEnergyHistoryReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGetFoodEnergyHistoryReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFoodStockHistory = (
  params: GetFoodStockHistoryParams,
  signal?: AbortSignal,
) => {
  return request<GetFoodStockHistoryResponse>({
    url: `/reports/food-history`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFoodStockHistoryQueryKey = (
  params: GetFoodStockHistoryParams,
) => {
  return [`/reports/food-history`, ...(params ? [params] : [])] as const;
};

export const getGetFoodStockHistoryInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodStockHistory>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodStockHistoryParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodStockHistory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodStockHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodStockHistory>>
  > = ({ signal }) => getFoodStockHistory(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFoodStockHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodStockHistoryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodStockHistory>>
>;
export type GetFoodStockHistoryInfiniteQueryError = ErrorType<HttpError>;

export const useGetFoodStockHistoryInfinite = <
  TData = Awaited<ReturnType<typeof getFoodStockHistory>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodStockHistoryParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodStockHistory>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodStockHistoryInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFoodStockHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodStockHistory>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodStockHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodStockHistory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodStockHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodStockHistory>>
  > = ({ signal }) => getFoodStockHistory(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFoodStockHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodStockHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodStockHistory>>
>;
export type GetFoodStockHistoryQueryError = ErrorType<HttpError>;

export const useGetFoodStockHistory = <
  TData = Awaited<ReturnType<typeof getFoodStockHistory>>,
  TError = ErrorType<HttpError>,
>(
  params: GetFoodStockHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodStockHistory>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodStockHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dispara a Exportação Forecast em segundo plano e responde na hora com o `jobId`.

O processamento não é aguardado aqui; o frontend acompanha por `GET /reports/forecast/:jobId`.
 */
export const startForecastReport = () => {
  return request<StartForecastResponse>({
    url: `/reports/forecast`,
    method: "POST",
  });
};

export const getStartForecastReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startForecastReport>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startForecastReport>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startForecastReport>>,
    void
  > = () => {
    return startForecastReport();
  };

  return { mutationFn, ...mutationOptions };
};

export type StartForecastReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof startForecastReport>>
>;

export type StartForecastReportMutationError = ErrorType<HttpError>;

export const useStartForecastReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startForecastReport>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getStartForecastReportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateForecastReportExcel = (
  forecastGenerateExcelRequest: ForecastGenerateExcelRequest,
) => {
  return request<GenerateForecastReportExcelResponse>({
    url: `/reports/forecast/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: forecastGenerateExcelRequest,
  });
};

export const getGenerateForecastReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateForecastReportExcel>>,
    TError,
    { data: ForecastGenerateExcelRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateForecastReportExcel>>,
  TError,
  { data: ForecastGenerateExcelRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateForecastReportExcel>>,
    { data: ForecastGenerateExcelRequest }
  > = (props) => {
    const { data } = props ?? {};

    return generateForecastReportExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateForecastReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateForecastReportExcel>>
>;
export type GenerateForecastReportExcelMutationBody =
  ForecastGenerateExcelRequest;
export type GenerateForecastReportExcelMutationError = ErrorType<unknown>;

export const useGenerateForecastReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateForecastReportExcel>>,
    TError,
    { data: ForecastGenerateExcelRequest },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateForecastReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Cancela a Exportação Forecast. O processamento para na fronteira da próxima fatia, não no meio dela.
 */
export const cancelForecastReport = (jobId: string) => {
  return request<CancelForecastReportResponse>({
    url: `/reports/forecast/${jobId}`,
    method: "DELETE",
  });
};

export const getCancelForecastReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelForecastReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelForecastReport>>,
  TError,
  { jobId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelForecastReport>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return cancelForecastReport(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelForecastReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelForecastReport>>
>;

export type CancelForecastReportMutationError = ErrorType<HttpError>;

export const useCancelForecastReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelForecastReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}) => {
  const mutationOptions = getCancelForecastReportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Estado da Exportação Forecast. É esta rota que o frontend consulta em intervalo enquanto o relatório roda.

Job ausente = expirado pelo TTL (1 h) ou de outro processo. O frontend trata isso como "gere novamente", não como
erro técnico.
 */
export const getForecastReportState = (jobId: string, signal?: AbortSignal) => {
  return request<ForecastStateResponse>({
    url: `/reports/forecast/${jobId}`,
    method: "GET",
    signal,
  });
};

export const getGetForecastReportStateQueryKey = (jobId: string) => {
  return [`/reports/forecast/${jobId}`] as const;
};

export const getGetForecastReportStateInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getForecastReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getForecastReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetForecastReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getForecastReportState>>
  > = ({ signal }) => getForecastReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getForecastReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetForecastReportStateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getForecastReportState>>
>;
export type GetForecastReportStateInfiniteQueryError = ErrorType<HttpError>;

export const useGetForecastReportStateInfinite = <
  TData = Awaited<ReturnType<typeof getForecastReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getForecastReportState>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetForecastReportStateInfiniteQueryOptions(
    jobId,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetForecastReportStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getForecastReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getForecastReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetForecastReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getForecastReportState>>
  > = ({ signal }) => getForecastReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getForecastReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetForecastReportStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getForecastReportState>>
>;
export type GetForecastReportStateQueryError = ErrorType<HttpError>;

export const useGetForecastReportState = <
  TData = Awaited<ReturnType<typeof getForecastReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getForecastReportState>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetForecastReportStateQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const batchHistoryReport = (
  params: BatchHistoryReportParams,
  signal?: AbortSignal,
) => {
  return request<BatchHistoryReportResponse>({
    url: `/reports/history`,
    method: "GET",
    params,
    signal,
  });
};

export const getBatchHistoryReportQueryKey = (
  params: BatchHistoryReportParams,
) => {
  return [`/reports/history`, ...(params ? [params] : [])] as const;
};

export const getBatchHistoryReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof batchHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: BatchHistoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchHistoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBatchHistoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof batchHistoryReport>>
  > = ({ signal }) => batchHistoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchHistoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchHistoryReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchHistoryReport>>
>;
export type BatchHistoryReportInfiniteQueryError = ErrorType<HttpError>;

export const useBatchHistoryReportInfinite = <
  TData = Awaited<ReturnType<typeof batchHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: BatchHistoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchHistoryReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchHistoryReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchHistoryReportQueryOptions = <
  TData = Awaited<ReturnType<typeof batchHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: BatchHistoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchHistoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBatchHistoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof batchHistoryReport>>
  > = ({ signal }) => batchHistoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof batchHistoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchHistoryReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchHistoryReport>>
>;
export type BatchHistoryReportQueryError = ErrorType<HttpError>;

export const useBatchHistoryReport = <
  TData = Awaited<ReturnType<typeof batchHistoryReport>>,
  TError = ErrorType<HttpError>,
>(
  params: BatchHistoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchHistoryReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchHistoryReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const individualCattleClosingReport = (
  params?: IndividualCattleClosingReportParams,
  signal?: AbortSignal,
) => {
  return request<IndividualCattleClosingReportResponse>({
    url: `/reports/individual-cattle-closing`,
    method: "GET",
    params,
    signal,
  });
};

export const getIndividualCattleClosingReportQueryKey = (
  params?: IndividualCattleClosingReportParams,
) => {
  return [
    `/reports/individual-cattle-closing`,
    ...(params ? [params] : []),
  ] as const;
};

export const getIndividualCattleClosingReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof individualCattleClosingReport>>,
  TError = ErrorType<unknown>,
>(
  params?: IndividualCattleClosingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof individualCattleClosingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getIndividualCattleClosingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof individualCattleClosingReport>>
  > = ({ signal }) => individualCattleClosingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof individualCattleClosingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type IndividualCattleClosingReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof individualCattleClosingReport>>
>;
export type IndividualCattleClosingReportInfiniteQueryError =
  ErrorType<unknown>;

export const useIndividualCattleClosingReportInfinite = <
  TData = Awaited<ReturnType<typeof individualCattleClosingReport>>,
  TError = ErrorType<unknown>,
>(
  params?: IndividualCattleClosingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof individualCattleClosingReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getIndividualCattleClosingReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getIndividualCattleClosingReportQueryOptions = <
  TData = Awaited<ReturnType<typeof individualCattleClosingReport>>,
  TError = ErrorType<unknown>,
>(
  params?: IndividualCattleClosingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof individualCattleClosingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getIndividualCattleClosingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof individualCattleClosingReport>>
  > = ({ signal }) => individualCattleClosingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof individualCattleClosingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type IndividualCattleClosingReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof individualCattleClosingReport>>
>;
export type IndividualCattleClosingReportQueryError = ErrorType<unknown>;

export const useIndividualCattleClosingReport = <
  TData = Awaited<ReturnType<typeof individualCattleClosingReport>>,
  TError = ErrorType<unknown>,
>(
  params?: IndividualCattleClosingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof individualCattleClosingReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getIndividualCattleClosingReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getInventoryControl = (
  params?: GetInventoryControlParams,
  signal?: AbortSignal,
) => {
  return request<GetInventoryControlResponse>({
    url: `/reports/inventory-control`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetInventoryControlQueryKey = (
  params?: GetInventoryControlParams,
) => {
  return [`/reports/inventory-control`, ...(params ? [params] : [])] as const;
};

export const getGetInventoryControlInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryControl>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetInventoryControlParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getInventoryControl>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryControlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryControl>>
  > = ({ signal }) => getInventoryControl(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getInventoryControl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryControlInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryControl>>
>;
export type GetInventoryControlInfiniteQueryError = ErrorType<HttpError>;

export const useGetInventoryControlInfinite = <
  TData = Awaited<ReturnType<typeof getInventoryControl>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetInventoryControlParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getInventoryControl>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInventoryControlInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetInventoryControlQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryControl>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetInventoryControlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryControl>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryControlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryControl>>
  > = ({ signal }) => getInventoryControl(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryControl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryControlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryControl>>
>;
export type GetInventoryControlQueryError = ErrorType<HttpError>;

export const useGetInventoryControl = <
  TData = Awaited<ReturnType<typeof getInventoryControl>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetInventoryControlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryControl>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInventoryControlQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const movementHistoryReport = (
  params: MovementHistoryReportParams,
  signal?: AbortSignal,
) => {
  return request<MovementHistoryReportResult>({
    url: `/reports/movement-history`,
    method: "GET",
    params,
    signal,
  });
};

export const getMovementHistoryReportQueryKey = (
  params: MovementHistoryReportParams,
) => {
  return [`/reports/movement-history`, ...(params ? [params] : [])] as const;
};

export const getMovementHistoryReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof movementHistoryReport>>,
  TError = ErrorType<unknown>,
>(
  params: MovementHistoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof movementHistoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMovementHistoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof movementHistoryReport>>
  > = ({ signal }) => movementHistoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof movementHistoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MovementHistoryReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof movementHistoryReport>>
>;
export type MovementHistoryReportInfiniteQueryError = ErrorType<unknown>;

export const useMovementHistoryReportInfinite = <
  TData = Awaited<ReturnType<typeof movementHistoryReport>>,
  TError = ErrorType<unknown>,
>(
  params: MovementHistoryReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof movementHistoryReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMovementHistoryReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getMovementHistoryReportQueryOptions = <
  TData = Awaited<ReturnType<typeof movementHistoryReport>>,
  TError = ErrorType<unknown>,
>(
  params: MovementHistoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof movementHistoryReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMovementHistoryReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof movementHistoryReport>>
  > = ({ signal }) => movementHistoryReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof movementHistoryReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MovementHistoryReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof movementHistoryReport>>
>;
export type MovementHistoryReportQueryError = ErrorType<unknown>;

export const useMovementHistoryReport = <
  TData = Awaited<ReturnType<typeof movementHistoryReport>>,
  TError = ErrorType<unknown>,
>(
  params: MovementHistoryReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof movementHistoryReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMovementHistoryReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateMovementHistoryReportExcel = (
  movementHistoryGenerateExcelRequest: MovementHistoryGenerateExcelRequest,
) => {
  return request<GenerateMovementHistoryReportExcelResponse>({
    url: `/reports/movement-history/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: movementHistoryGenerateExcelRequest,
  });
};

export const getGenerateMovementHistoryReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMovementHistoryReportExcel>>,
    TError,
    { data: MovementHistoryGenerateExcelRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateMovementHistoryReportExcel>>,
  TError,
  { data: MovementHistoryGenerateExcelRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateMovementHistoryReportExcel>>,
    { data: MovementHistoryGenerateExcelRequest }
  > = (props) => {
    const { data } = props ?? {};

    return generateMovementHistoryReportExcel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateMovementHistoryReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateMovementHistoryReportExcel>>
>;
export type GenerateMovementHistoryReportExcelMutationBody =
  MovementHistoryGenerateExcelRequest;
export type GenerateMovementHistoryReportExcelMutationError =
  ErrorType<unknown>;

export const useGenerateMovementHistoryReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMovementHistoryReportExcel>>,
    TError,
    { data: MovementHistoryGenerateExcelRequest },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateMovementHistoryReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPartnerSlaughterResultReport = (
  params: GetPartnerSlaughterResultReportParams,
  signal?: AbortSignal,
) => {
  return request<GetPartnerSlaughterResultReportResponse>({
    url: `/reports/partner-slaughter-result`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPartnerSlaughterResultReportQueryKey = (
  params: GetPartnerSlaughterResultReportParams,
) => {
  return [
    `/reports/partner-slaughter-result`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPartnerSlaughterResultReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetPartnerSlaughterResultReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPartnerSlaughterResultReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>
  > = ({ signal }) => getPartnerSlaughterResultReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPartnerSlaughterResultReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>
>;
export type GetPartnerSlaughterResultReportInfiniteQueryError =
  ErrorType<HttpError>;

export const useGetPartnerSlaughterResultReportInfinite = <
  TData = Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetPartnerSlaughterResultReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPartnerSlaughterResultReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetPartnerSlaughterResultReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetPartnerSlaughterResultReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPartnerSlaughterResultReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>
  > = ({ signal }) => getPartnerSlaughterResultReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPartnerSlaughterResultReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>
>;
export type GetPartnerSlaughterResultReportQueryError = ErrorType<HttpError>;

export const useGetPartnerSlaughterResultReport = <
  TData = Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetPartnerSlaughterResultReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartnerSlaughterResultReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPartnerSlaughterResultReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const pasturesReport = (signal?: AbortSignal) => {
  return request<PasturesReportResponse>({
    url: `/reports/pastures-report`,
    method: "GET",
    signal,
  });
};

export const getPasturesReportQueryKey = () => {
  return [`/reports/pastures-report`] as const;
};

export const getPasturesReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof pasturesReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof pasturesReport>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPasturesReportQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pasturesReport>>> = ({
    signal,
  }) => pasturesReport(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof pasturesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PasturesReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof pasturesReport>>
>;
export type PasturesReportInfiniteQueryError = ErrorType<unknown>;

export const usePasturesReportInfinite = <
  TData = Awaited<ReturnType<typeof pasturesReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof pasturesReport>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPasturesReportInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPasturesReportQueryOptions = <
  TData = Awaited<ReturnType<typeof pasturesReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof pasturesReport>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPasturesReportQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pasturesReport>>> = ({
    signal,
  }) => pasturesReport(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof pasturesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PasturesReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof pasturesReport>>
>;
export type PasturesReportQueryError = ErrorType<unknown>;

export const usePasturesReport = <
  TData = Awaited<ReturnType<typeof pasturesReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof pasturesReport>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPasturesReportQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const resetAllReportsCache = () => {
  return request<ResetAllReportsCacheResponse>({
    url: `/reports/reset-cache`,
    method: "POST",
  });
};

export const getResetAllReportsCacheMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAllReportsCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetAllReportsCache>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetAllReportsCache>>,
    void
  > = () => {
    return resetAllReportsCache();
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetAllReportsCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetAllReportsCache>>
>;

export type ResetAllReportsCacheMutationError = ErrorType<unknown>;

export const useResetAllReportsCache = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAllReportsCache>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getResetAllReportsCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateSalesReport = (
  params: GenerateSalesReportParams,
  signal?: AbortSignal,
) => {
  return request<GenerateSalesReportResponse>({
    url: `/reports/sales`,
    method: "GET",
    params,
    signal,
  });
};

export const getGenerateSalesReportQueryKey = (
  params: GenerateSalesReportParams,
) => {
  return [`/reports/sales`, ...(params ? [params] : [])] as const;
};

export const getGenerateSalesReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof generateSalesReport>>,
  TError = ErrorType<unknown>,
>(
  params: GenerateSalesReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof generateSalesReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGenerateSalesReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof generateSalesReport>>
  > = ({ signal }) => generateSalesReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof generateSalesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GenerateSalesReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateSalesReport>>
>;
export type GenerateSalesReportInfiniteQueryError = ErrorType<unknown>;

export const useGenerateSalesReportInfinite = <
  TData = Awaited<ReturnType<typeof generateSalesReport>>,
  TError = ErrorType<unknown>,
>(
  params: GenerateSalesReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof generateSalesReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGenerateSalesReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGenerateSalesReportQueryOptions = <
  TData = Awaited<ReturnType<typeof generateSalesReport>>,
  TError = ErrorType<unknown>,
>(
  params: GenerateSalesReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof generateSalesReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGenerateSalesReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof generateSalesReport>>
  > = ({ signal }) => generateSalesReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof generateSalesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GenerateSalesReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateSalesReport>>
>;
export type GenerateSalesReportQueryError = ErrorType<unknown>;

export const useGenerateSalesReport = <
  TData = Awaited<ReturnType<typeof generateSalesReport>>,
  TError = ErrorType<unknown>,
>(
  params: GenerateSalesReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof generateSalesReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGenerateSalesReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listEstablishmentsForSalesReport = (
  params: ListEstablishmentsForSalesReportParams,
  signal?: AbortSignal,
) => {
  return request<ListEstablishmentsForSalesReportResponse>({
    url: `/reports/sales/establishments`,
    method: "GET",
    params,
    signal,
  });
};

export const getListEstablishmentsForSalesReportQueryKey = (
  params: ListEstablishmentsForSalesReportParams,
) => {
  return [
    `/reports/sales/establishments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEstablishmentsForSalesReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListEstablishmentsForSalesReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEstablishmentsForSalesReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>
  > = ({ signal }) => listEstablishmentsForSalesReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEstablishmentsForSalesReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>
>;
export type ListEstablishmentsForSalesReportInfiniteQueryError =
  ErrorType<HttpError>;

export const useListEstablishmentsForSalesReportInfinite = <
  TData = Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListEstablishmentsForSalesReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListEstablishmentsForSalesReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListEstablishmentsForSalesReportQueryOptions = <
  TData = Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListEstablishmentsForSalesReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEstablishmentsForSalesReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>
  > = ({ signal }) => listEstablishmentsForSalesReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEstablishmentsForSalesReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>
>;
export type ListEstablishmentsForSalesReportQueryError = ErrorType<HttpError>;

export const useListEstablishmentsForSalesReport = <
  TData = Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListEstablishmentsForSalesReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEstablishmentsForSalesReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListEstablishmentsForSalesReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const exportSalesReportExcel = (
  generateSalesReportResponse: GenerateSalesReportResponse,
  params: ExportSalesReportExcelParams,
) => {
  return request<ExportSalesReportExcelResponse>({
    url: `/reports/sales/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateSalesReportResponse,
    params,
  });
};

export const getExportSalesReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportSalesReportExcel>>,
    TError,
    { data: GenerateSalesReportResponse; params: ExportSalesReportExcelParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportSalesReportExcel>>,
  TError,
  { data: GenerateSalesReportResponse; params: ExportSalesReportExcelParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportSalesReportExcel>>,
    { data: GenerateSalesReportResponse; params: ExportSalesReportExcelParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return exportSalesReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportSalesReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportSalesReportExcel>>
>;
export type ExportSalesReportExcelMutationBody = GenerateSalesReportResponse;
export type ExportSalesReportExcelMutationError = ErrorType<unknown>;

export const useExportSalesReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportSalesReportExcel>>,
    TError,
    { data: GenerateSalesReportResponse; params: ExportSalesReportExcelParams },
    TContext
  >;
}) => {
  const mutationOptions = getExportSalesReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPartnersForSalesReport = (
  params: ListPartnersForSalesReportParams,
  signal?: AbortSignal,
) => {
  return request<ListPartnersForSalesReportResponse>({
    url: `/reports/sales/partners`,
    method: "GET",
    params,
    signal,
  });
};

export const getListPartnersForSalesReportQueryKey = (
  params: ListPartnersForSalesReportParams,
) => {
  return [`/reports/sales/partners`, ...(params ? [params] : [])] as const;
};

export const getListPartnersForSalesReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnersForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersForSalesReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPartnersForSalesReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPartnersForSalesReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnersForSalesReport>>
  > = ({ signal }) => listPartnersForSalesReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listPartnersForSalesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnersForSalesReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnersForSalesReport>>
>;
export type ListPartnersForSalesReportInfiniteQueryError = ErrorType<HttpError>;

export const useListPartnersForSalesReportInfinite = <
  TData = Awaited<ReturnType<typeof listPartnersForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersForSalesReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listPartnersForSalesReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnersForSalesReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListPartnersForSalesReportQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnersForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersForSalesReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPartnersForSalesReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPartnersForSalesReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartnersForSalesReport>>
  > = ({ signal }) => listPartnersForSalesReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnersForSalesReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPartnersForSalesReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnersForSalesReport>>
>;
export type ListPartnersForSalesReportQueryError = ErrorType<HttpError>;

export const useListPartnersForSalesReport = <
  TData = Awaited<ReturnType<typeof listPartnersForSalesReport>>,
  TError = ErrorType<HttpError>,
>(
  params: ListPartnersForSalesReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPartnersForSalesReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPartnersForSalesReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listSlaughters = (signal?: AbortSignal) => {
  return request<ListSlaughtersResponse>({
    url: `/reports/slaughter`,
    method: "GET",
    signal,
  });
};

export const getListSlaughtersQueryKey = () => {
  return [`/reports/slaughter`] as const;
};

export const getListSlaughtersInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSlaughters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSlaughters>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSlaughtersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSlaughters>>> = ({
    signal,
  }) => listSlaughters(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSlaughters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSlaughtersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSlaughters>>
>;
export type ListSlaughtersInfiniteQueryError = ErrorType<unknown>;

export const useListSlaughtersInfinite = <
  TData = Awaited<ReturnType<typeof listSlaughters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSlaughters>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSlaughtersInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSlaughtersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSlaughters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSlaughters>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSlaughtersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSlaughters>>> = ({
    signal,
  }) => listSlaughters(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSlaughters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSlaughtersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSlaughters>>
>;
export type ListSlaughtersQueryError = ErrorType<unknown>;

export const useListSlaughters = <
  TData = Awaited<ReturnType<typeof listSlaughters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSlaughters>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSlaughtersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSlaughterResultReport = (
  params: GetSlaughterResultReportParams,
  signal?: AbortSignal,
) => {
  return request<ReportSlaughterResultResponse>({
    url: `/reports/slaughter-result`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSlaughterResultReportQueryKey = (
  params: GetSlaughterResultReportParams,
) => {
  return [`/reports/slaughter-result`, ...(params ? [params] : [])] as const;
};

export const getGetSlaughterResultReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterResultReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSlaughterResultReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSlaughterResultReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSlaughterResultReport>>
  > = ({ signal }) => getSlaughterResultReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSlaughterResultReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSlaughterResultReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSlaughterResultReport>>
>;
export type GetSlaughterResultReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetSlaughterResultReportInfinite = <
  TData = Awaited<ReturnType<typeof getSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterResultReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSlaughterResultReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSlaughterResultReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSlaughterResultReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterResultReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSlaughterResultReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSlaughterResultReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSlaughterResultReport>>
  > = ({ signal }) => getSlaughterResultReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSlaughterResultReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSlaughterResultReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSlaughterResultReport>>
>;
export type GetSlaughterResultReportQueryError = ErrorType<HttpError>;

export const useGetSlaughterResultReport = <
  TData = Awaited<ReturnType<typeof getSlaughterResultReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterResultReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSlaughterResultReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSlaughterResultReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const countBatchesForSlaughterScaleReport = (
  params: CountBatchesForSlaughterScaleReportParams,
  signal?: AbortSignal,
) => {
  return request<CountBatchesForSlaughterScaleReportResponse>({
    url: `/reports/slaughter-scale/count`,
    method: "GET",
    params,
    signal,
  });
};

export const getCountBatchesForSlaughterScaleReportQueryKey = (
  params: CountBatchesForSlaughterScaleReportParams,
) => {
  return [
    `/reports/slaughter-scale/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountBatchesForSlaughterScaleReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBatchesForSlaughterScaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountBatchesForSlaughterScaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>
  > = ({ signal }) => countBatchesForSlaughterScaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountBatchesForSlaughterScaleReportInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>>;
export type CountBatchesForSlaughterScaleReportInfiniteQueryError =
  ErrorType<HttpError>;

export const useCountBatchesForSlaughterScaleReportInfinite = <
  TData = Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBatchesForSlaughterScaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getCountBatchesForSlaughterScaleReportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCountBatchesForSlaughterScaleReportQueryOptions = <
  TData = Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBatchesForSlaughterScaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountBatchesForSlaughterScaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>
  > = ({ signal }) => countBatchesForSlaughterScaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountBatchesForSlaughterScaleReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>
>;
export type CountBatchesForSlaughterScaleReportQueryError =
  ErrorType<HttpError>;

export const useCountBatchesForSlaughterScaleReport = <
  TData = Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountBatchesForSlaughterScaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countBatchesForSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCountBatchesForSlaughterScaleReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateSlaughterScaleReportExcel = (
  generateSlaughterScaleReportExcelBody: GenerateSlaughterScaleReportExcelBody,
  params: GenerateSlaughterScaleReportExcelParams,
) => {
  return request<GenerateSlaughterScaleReportExcelResponse>({
    url: `/reports/slaughter-scale/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateSlaughterScaleReportExcelBody,
    params,
  });
};

export const getGenerateSlaughterScaleReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSlaughterScaleReportExcel>>,
    TError,
    {
      data: GenerateSlaughterScaleReportExcelBody;
      params: GenerateSlaughterScaleReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSlaughterScaleReportExcel>>,
  TError,
  {
    data: GenerateSlaughterScaleReportExcelBody;
    params: GenerateSlaughterScaleReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSlaughterScaleReportExcel>>,
    {
      data: GenerateSlaughterScaleReportExcelBody;
      params: GenerateSlaughterScaleReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return generateSlaughterScaleReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSlaughterScaleReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSlaughterScaleReportExcel>>
>;
export type GenerateSlaughterScaleReportExcelMutationBody =
  GenerateSlaughterScaleReportExcelBody;
export type GenerateSlaughterScaleReportExcelMutationError = ErrorType<unknown>;

export const useGenerateSlaughterScaleReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSlaughterScaleReportExcel>>,
    TError,
    {
      data: GenerateSlaughterScaleReportExcelBody;
      params: GenerateSlaughterScaleReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateSlaughterScaleReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSlaughterScaleReport = (
  params: GetSlaughterScaleReportParams,
  signal?: AbortSignal,
) => {
  return request<GetSlaughterScaleReportResponse>({
    url: `/reports/slaughter-scale/report`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSlaughterScaleReportQueryKey = (
  params: GetSlaughterScaleReportParams,
) => {
  return [
    `/reports/slaughter-scale/report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSlaughterScaleReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterScaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSlaughterScaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSlaughterScaleReport>>
  > = ({ signal }) => getSlaughterScaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSlaughterScaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSlaughterScaleReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSlaughterScaleReport>>
>;
export type GetSlaughterScaleReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetSlaughterScaleReportInfinite = <
  TData = Awaited<ReturnType<typeof getSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterScaleReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSlaughterScaleReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSlaughterScaleReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterScaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSlaughterScaleReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSlaughterScaleReport>>
  > = ({ signal }) => getSlaughterScaleReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSlaughterScaleReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSlaughterScaleReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSlaughterScaleReport>>
>;
export type GetSlaughterScaleReportQueryError = ErrorType<HttpError>;

export const useGetSlaughterScaleReport = <
  TData = Awaited<ReturnType<typeof getSlaughterScaleReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSlaughterScaleReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSlaughterScaleReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSlaughterScaleReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dispara o relatório de teste em segundo plano e responde na hora com o `jobId`.

Prova de conceito do mecanismo descrito em `docs/viabilidade-relatorio-em-segundo-plano.md`: o processamento **não**
é aguardado aqui; o frontend acompanha por `GET /reports/test-job/:jobId`.
 */
export const startTestJobReport = (params?: StartTestJobReportParams) => {
  return request<StartTestJobResponse>({
    url: `/reports/test-job`,
    method: "POST",
    params,
  });
};

export const getStartTestJobReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startTestJobReport>>,
    TError,
    { params?: StartTestJobReportParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startTestJobReport>>,
  TError,
  { params?: StartTestJobReportParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startTestJobReport>>,
    { params?: StartTestJobReportParams }
  > = (props) => {
    const { params } = props ?? {};

    return startTestJobReport(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartTestJobReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof startTestJobReport>>
>;

export type StartTestJobReportMutationError = ErrorType<HttpError>;

export const useStartTestJobReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startTestJobReport>>,
    TError,
    { params?: StartTestJobReportParams },
    TContext
  >;
}) => {
  const mutationOptions = getStartTestJobReportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Cancela o job. O processamento para na fronteira da próxima fatia, não no meio dela.
 */
export const cancelTestJobReport = (jobId: string) => {
  return request<CancelTestJobReportResponse>({
    url: `/reports/test-job/${jobId}`,
    method: "DELETE",
  });
};

export const getCancelTestJobReportMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTestJobReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelTestJobReport>>,
  TError,
  { jobId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelTestJobReport>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return cancelTestJobReport(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelTestJobReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelTestJobReport>>
>;

export type CancelTestJobReportMutationError = ErrorType<HttpError>;

export const useCancelTestJobReport = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTestJobReport>>,
    TError,
    { jobId: string },
    TContext
  >;
}) => {
  const mutationOptions = getCancelTestJobReportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Estado do job de teste. É esta rota que o frontend consulta em intervalo enquanto o relatório roda.

Job ausente = expirado pelo TTL (1 h) ou de outro processo. O frontend trata isso como "gere novamente", não como
erro técnico.
 */
export const getTestJobReportState = (jobId: string, signal?: AbortSignal) => {
  return request<TestJobStateResponse>({
    url: `/reports/test-job/${jobId}`,
    method: "GET",
    signal,
  });
};

export const getGetTestJobReportStateQueryKey = (jobId: string) => {
  return [`/reports/test-job/${jobId}`] as const;
};

export const getGetTestJobReportStateInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTestJobReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTestJobReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTestJobReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTestJobReportState>>
  > = ({ signal }) => getTestJobReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTestJobReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestJobReportStateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTestJobReportState>>
>;
export type GetTestJobReportStateInfiniteQueryError = ErrorType<HttpError>;

export const useGetTestJobReportStateInfinite = <
  TData = Awaited<ReturnType<typeof getTestJobReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTestJobReportState>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTestJobReportStateInfiniteQueryOptions(
    jobId,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTestJobReportStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTestJobReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTestJobReportState>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTestJobReportStateQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTestJobReportState>>
  > = ({ signal }) => getTestJobReportState(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTestJobReportState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestJobReportStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTestJobReportState>>
>;
export type GetTestJobReportStateQueryError = ErrorType<HttpError>;

export const useGetTestJobReportState = <
  TData = Awaited<ReturnType<typeof getTestJobReportState>>,
  TError = ErrorType<HttpError>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTestJobReportState>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTestJobReportStateQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchTransfer = (
  params?: GetBatchTransferParams,
  signal?: AbortSignal,
) => {
  return request<GetBatchTransferResponse>({
    url: `/reports/transfer`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBatchTransferQueryKey = (
  params?: GetBatchTransferParams,
) => {
  return [`/reports/transfer`, ...(params ? [params] : [])] as const;
};

export const getGetBatchTransferInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchTransfer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBatchTransferParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchTransfer>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBatchTransferQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchTransfer>>
  > = ({ signal }) => getBatchTransfer(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBatchTransfer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchTransferInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchTransfer>>
>;
export type GetBatchTransferInfiniteQueryError = ErrorType<unknown>;

export const useGetBatchTransferInfinite = <
  TData = Awaited<ReturnType<typeof getBatchTransfer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBatchTransferParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getBatchTransfer>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchTransferInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBatchTransferQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchTransfer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBatchTransferParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchTransfer>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBatchTransferQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchTransfer>>
  > = ({ signal }) => getBatchTransfer(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatchTransfer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchTransferQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchTransfer>>
>;
export type GetBatchTransferQueryError = ErrorType<unknown>;

export const useGetBatchTransfer = <
  TData = Awaited<ReturnType<typeof getBatchTransfer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBatchTransferParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchTransfer>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBatchTransferQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTreatEfficiencyReport = (
  params: GetTreatEfficiencyReportParams,
  signal?: AbortSignal,
) => {
  return request<void>({
    url: `/reports/treat-efficiency`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTreatEfficiencyReportQueryKey = (
  params: GetTreatEfficiencyReportParams,
) => {
  return [`/reports/treat-efficiency`, ...(params ? [params] : [])] as const;
};

export const getGetTreatEfficiencyReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatEfficiencyReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTreatEfficiencyReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTreatEfficiencyReport>>
  > = ({ signal }) => getTreatEfficiencyReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTreatEfficiencyReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatEfficiencyReport>>
>;
export type GetTreatEfficiencyReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetTreatEfficiencyReportInfinite = <
  TData = Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatEfficiencyReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTreatEfficiencyReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTreatEfficiencyReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatEfficiencyReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTreatEfficiencyReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTreatEfficiencyReport>>
  > = ({ signal }) => getTreatEfficiencyReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTreatEfficiencyReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatEfficiencyReport>>
>;
export type GetTreatEfficiencyReportQueryError = ErrorType<HttpError>;

export const useGetTreatEfficiencyReport = <
  TData = Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetTreatEfficiencyReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTreatEfficiencyReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTreatEfficiencyReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateTreatEfficiencyReportExcel = (
  generateTreatEfficiencyReportExcelBody: GenerateTreatEfficiencyReportExcelBody,
  params: GenerateTreatEfficiencyReportExcelParams,
) => {
  return request<GenerateTreatEfficiencyReportExcelResponse>({
    url: `/reports/treat-efficiency/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateTreatEfficiencyReportExcelBody,
    params,
  });
};

export const getGenerateTreatEfficiencyReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateTreatEfficiencyReportExcel>>,
    TError,
    {
      data: GenerateTreatEfficiencyReportExcelBody;
      params: GenerateTreatEfficiencyReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateTreatEfficiencyReportExcel>>,
  TError,
  {
    data: GenerateTreatEfficiencyReportExcelBody;
    params: GenerateTreatEfficiencyReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateTreatEfficiencyReportExcel>>,
    {
      data: GenerateTreatEfficiencyReportExcelBody;
      params: GenerateTreatEfficiencyReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return generateTreatEfficiencyReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateTreatEfficiencyReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateTreatEfficiencyReportExcel>>
>;
export type GenerateTreatEfficiencyReportExcelMutationBody =
  GenerateTreatEfficiencyReportExcelBody;
export type GenerateTreatEfficiencyReportExcelMutationError =
  ErrorType<unknown>;

export const useGenerateTreatEfficiencyReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateTreatEfficiencyReportExcel>>,
    TError,
    {
      data: GenerateTreatEfficiencyReportExcelBody;
      params: GenerateTreatEfficiencyReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateTreatEfficiencyReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTroughReadingReport = (
  params?: GetTroughReadingReportParams,
  signal?: AbortSignal,
) => {
  return request<GetTroughReadingReportResponse>({
    url: `/reports/trough-reading-report`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTroughReadingReportQueryKey = (
  params?: GetTroughReadingReportParams,
) => {
  return [
    `/reports/trough-reading-report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTroughReadingReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTroughReadingReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetTroughReadingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTroughReadingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTroughReadingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTroughReadingReport>>
  > = ({ signal }) => getTroughReadingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTroughReadingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTroughReadingReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTroughReadingReport>>
>;
export type GetTroughReadingReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetTroughReadingReportInfinite = <
  TData = Awaited<ReturnType<typeof getTroughReadingReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetTroughReadingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTroughReadingReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTroughReadingReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTroughReadingReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getTroughReadingReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetTroughReadingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTroughReadingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTroughReadingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTroughReadingReport>>
  > = ({ signal }) => getTroughReadingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTroughReadingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTroughReadingReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTroughReadingReport>>
>;
export type GetTroughReadingReportQueryError = ErrorType<HttpError>;

export const useGetTroughReadingReport = <
  TData = Awaited<ReturnType<typeof getTroughReadingReport>>,
  TError = ErrorType<HttpError>,
>(
  params?: GetTroughReadingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTroughReadingReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTroughReadingReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const countWeighingReport = (
  params: CountWeighingReportParams,
  signal?: AbortSignal,
) => {
  return request<CountWeighingReportResponse>({
    url: `/reports/weighing/count`,
    method: "GET",
    params,
    signal,
  });
};

export const getCountWeighingReportQueryKey = (
  params: CountWeighingReportParams,
) => {
  return [`/reports/weighing/count`, ...(params ? [params] : [])] as const;
};

export const getCountWeighingReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof countWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountWeighingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countWeighingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCountWeighingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countWeighingReport>>
  > = ({ signal }) => countWeighingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof countWeighingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountWeighingReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof countWeighingReport>>
>;
export type CountWeighingReportInfiniteQueryError = ErrorType<HttpError>;

export const useCountWeighingReportInfinite = <
  TData = Awaited<ReturnType<typeof countWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountWeighingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof countWeighingReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCountWeighingReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCountWeighingReportQueryOptions = <
  TData = Awaited<ReturnType<typeof countWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountWeighingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countWeighingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCountWeighingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countWeighingReport>>
  > = ({ signal }) => countWeighingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countWeighingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CountWeighingReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof countWeighingReport>>
>;
export type CountWeighingReportQueryError = ErrorType<HttpError>;

export const useCountWeighingReport = <
  TData = Awaited<ReturnType<typeof countWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: CountWeighingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof countWeighingReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCountWeighingReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getWeighingReportXlsx = (
  weighingReportResponse: WeighingReportResponse,
  params: GetWeighingReportXlsxParams,
) => {
  return request<GetWeighingReportXlsxResponse>({
    url: `/reports/weighing/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: weighingReportResponse,
    params,
  });
};

export const getGetWeighingReportXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getWeighingReportXlsx>>,
    TError,
    { data: WeighingReportResponse; params: GetWeighingReportXlsxParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getWeighingReportXlsx>>,
  TError,
  { data: WeighingReportResponse; params: GetWeighingReportXlsxParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getWeighingReportXlsx>>,
    { data: WeighingReportResponse; params: GetWeighingReportXlsxParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return getWeighingReportXlsx(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetWeighingReportXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof getWeighingReportXlsx>>
>;
export type GetWeighingReportXlsxMutationBody = WeighingReportResponse;
export type GetWeighingReportXlsxMutationError = ErrorType<unknown>;

export const useGetWeighingReportXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getWeighingReportXlsx>>,
    TError,
    { data: WeighingReportResponse; params: GetWeighingReportXlsxParams },
    TContext
  >;
}) => {
  const mutationOptions = getGetWeighingReportXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWeighingReport = (
  params: GetWeighingReportParams,
  signal?: AbortSignal,
) => {
  return request<GetWeighingReportResponse>({
    url: `/reports/weighing/report`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWeighingReportQueryKey = (
  params: GetWeighingReportParams,
) => {
  return [`/reports/weighing/report`, ...(params ? [params] : [])] as const;
};

export const getGetWeighingReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetWeighingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getWeighingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWeighingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWeighingReport>>
  > = ({ signal }) => getWeighingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeighingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeighingReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeighingReport>>
>;
export type GetWeighingReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetWeighingReportInfinite = <
  TData = Awaited<ReturnType<typeof getWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetWeighingReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getWeighingReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeighingReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetWeighingReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetWeighingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWeighingReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWeighingReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWeighingReport>>
  > = ({ signal }) => getWeighingReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWeighingReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeighingReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeighingReport>>
>;
export type GetWeighingReportQueryError = ErrorType<HttpError>;

export const useGetWeighingReport = <
  TData = Awaited<ReturnType<typeof getWeighingReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetWeighingReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWeighingReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeighingReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Exporta o detalhamento dos dias de confinamento/trato do lote para Excel.

Os campos calculáveis saem como fórmulas nativas (diferença de datas, soma e média), auditáveis ao abrir o arquivo —
os dados vêm da mesma rota que alimenta o drawer (`analyticalBatchDaysDetails`).
 */
export const getAnalyticalBatchDaysDetailsXlsx = (
  params: GetAnalyticalBatchDaysDetailsXlsxParams,
  signal?: AbortSignal,
) => {
  return request<GetAnalyticalBatchDaysDetailsXlsxResponse>({
    url: `/reports/xlsx/analytical-days-details`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAnalyticalBatchDaysDetailsXlsxQueryKey = (
  params: GetAnalyticalBatchDaysDetailsXlsxParams,
) => {
  return [
    `/reports/xlsx/analytical-days-details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAnalyticalBatchDaysDetailsXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetAnalyticalBatchDaysDetailsXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAnalyticalBatchDaysDetailsXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>
  > = ({ signal }) => getAnalyticalBatchDaysDetailsXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticalBatchDaysDetailsXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>
>;
export type GetAnalyticalBatchDaysDetailsXlsxInfiniteQueryError =
  ErrorType<unknown>;

export const useGetAnalyticalBatchDaysDetailsXlsxInfinite = <
  TData = Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetAnalyticalBatchDaysDetailsXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnalyticalBatchDaysDetailsXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetAnalyticalBatchDaysDetailsXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetAnalyticalBatchDaysDetailsXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAnalyticalBatchDaysDetailsXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>
  > = ({ signal }) => getAnalyticalBatchDaysDetailsXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticalBatchDaysDetailsXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>
>;
export type GetAnalyticalBatchDaysDetailsXlsxQueryError = ErrorType<unknown>;

export const useGetAnalyticalBatchDaysDetailsXlsx = <
  TData = Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetAnalyticalBatchDaysDetailsXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticalBatchDaysDetailsXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnalyticalBatchDaysDetailsXlsxQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateComissionReportXlsx = (
  params: GenerateComissionReportXlsxParams,
) => {
  return request<GenerateComissionReportXlsxResponse>({
    url: `/reports/xlsx/comission`,
    method: "POST",
    params,
  });
};

export const getGenerateComissionReportXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateComissionReportXlsx>>,
    TError,
    { params: GenerateComissionReportXlsxParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateComissionReportXlsx>>,
  TError,
  { params: GenerateComissionReportXlsxParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateComissionReportXlsx>>,
    { params: GenerateComissionReportXlsxParams }
  > = (props) => {
    const { params } = props ?? {};

    return generateComissionReportXlsx(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateComissionReportXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateComissionReportXlsx>>
>;

export type GenerateComissionReportXlsxMutationError = ErrorType<unknown>;

export const useGenerateComissionReportXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateComissionReportXlsx>>,
    TError,
    { params: GenerateComissionReportXlsxParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateComissionReportXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateOxenEntranceReportXlsx = (
  params: GenerateOxenEntranceReportXlsxParams,
) => {
  return request<GenerateOxenEntranceReportXlsxResponse>({
    url: `/reports/xlsx/entrance`,
    method: "POST",
    params,
  });
};

export const getGenerateOxenEntranceReportXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOxenEntranceReportXlsx>>,
    TError,
    { params: GenerateOxenEntranceReportXlsxParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateOxenEntranceReportXlsx>>,
  TError,
  { params: GenerateOxenEntranceReportXlsxParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateOxenEntranceReportXlsx>>,
    { params: GenerateOxenEntranceReportXlsxParams }
  > = (props) => {
    const { params } = props ?? {};

    return generateOxenEntranceReportXlsx(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateOxenEntranceReportXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateOxenEntranceReportXlsx>>
>;

export type GenerateOxenEntranceReportXlsxMutationError = ErrorType<unknown>;

export const useGenerateOxenEntranceReportXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOxenEntranceReportXlsx>>,
    TError,
    { params: GenerateOxenEntranceReportXlsxParams },
    TContext
  >;
}) => {
  const mutationOptions =
    getGenerateOxenEntranceReportXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportDiedOxenReportExcel = (
  listAndExportDiedOxenResponse: ListAndExportDiedOxenResponse,
  params: ExportDiedOxenReportExcelParams,
) => {
  return request<ExportDiedOxenReportExcelResponse>({
    url: `/reports/xlsx/export-died-oxen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: listAndExportDiedOxenResponse,
    params,
  });
};

export const getExportDiedOxenReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportDiedOxenReportExcel>>,
    TError,
    {
      data: ListAndExportDiedOxenResponse;
      params: ExportDiedOxenReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportDiedOxenReportExcel>>,
  TError,
  {
    data: ListAndExportDiedOxenResponse;
    params: ExportDiedOxenReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportDiedOxenReportExcel>>,
    {
      data: ListAndExportDiedOxenResponse;
      params: ExportDiedOxenReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return exportDiedOxenReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportDiedOxenReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportDiedOxenReportExcel>>
>;
export type ExportDiedOxenReportExcelMutationBody =
  ListAndExportDiedOxenResponse;
export type ExportDiedOxenReportExcelMutationError = ErrorType<unknown>;

export const useExportDiedOxenReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportDiedOxenReportExcel>>,
    TError,
    {
      data: ListAndExportDiedOxenResponse;
      params: ExportDiedOxenReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions = getExportDiedOxenReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFoodHistoryReportXlsx = (
  params: GetFoodHistoryReportXlsxParams,
  signal?: AbortSignal,
) => {
  return request<GetFoodHistoryReportXlsxResponse>({
    url: `/reports/xlsx/food-history`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFoodHistoryReportXlsxQueryKey = (
  params: GetFoodHistoryReportXlsxParams,
) => {
  return [`/reports/xlsx/food-history`, ...(params ? [params] : [])] as const;
};

export const getGetFoodHistoryReportXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodHistoryReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodHistoryReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>
  > = ({ signal }) => getFoodHistoryReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodHistoryReportXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>
>;
export type GetFoodHistoryReportXlsxInfiniteQueryError = ErrorType<unknown>;

export const useGetFoodHistoryReportXlsxInfinite = <
  TData = Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodHistoryReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodHistoryReportXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFoodHistoryReportXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodHistoryReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodHistoryReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>
  > = ({ signal }) => getFoodHistoryReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodHistoryReportXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>
>;
export type GetFoodHistoryReportXlsxQueryError = ErrorType<unknown>;

export const useGetFoodHistoryReportXlsx = <
  TData = Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodHistoryReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodHistoryReportXlsxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFoodReportXlsx = (
  params: GetFoodReportXlsxParams,
  signal?: AbortSignal,
) => {
  return request<GetFoodReportXlsxResponse>({
    url: `/reports/xlsx/foods`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFoodReportXlsxQueryKey = (
  params: GetFoodReportXlsxParams,
) => {
  return [`/reports/xlsx/foods`, ...(params ? [params] : [])] as const;
};

export const getGetFoodReportXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodReportXlsx>>
  > = ({ signal }) => getFoodReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFoodReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodReportXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodReportXlsx>>
>;
export type GetFoodReportXlsxInfiniteQueryError = ErrorType<unknown>;

export const useGetFoodReportXlsxInfinite = <
  TData = Awaited<ReturnType<typeof getFoodReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFoodReportXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodReportXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetFoodReportXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoodReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFoodReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFoodReportXlsx>>
  > = ({ signal }) => getFoodReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFoodReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFoodReportXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoodReportXlsx>>
>;
export type GetFoodReportXlsxQueryError = ErrorType<unknown>;

export const useGetFoodReportXlsx = <
  TData = Awaited<ReturnType<typeof getFoodReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetFoodReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFoodReportXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFoodReportXlsxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getHistoryReportXlsx = (
  params: GetHistoryReportXlsxParams,
  signal?: AbortSignal,
) => {
  return request<GetHistoryReportXlsxResponse>({
    url: `/reports/xlsx/history`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetHistoryReportXlsxQueryKey = (
  params: GetHistoryReportXlsxParams,
) => {
  return [`/reports/xlsx/history`, ...(params ? [params] : [])] as const;
};

export const getGetHistoryReportXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetHistoryReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHistoryReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHistoryReportXlsx>>
  > = ({ signal }) => getHistoryReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getHistoryReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHistoryReportXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHistoryReportXlsx>>
>;
export type GetHistoryReportXlsxInfiniteQueryError = ErrorType<unknown>;

export const useGetHistoryReportXlsxInfinite = <
  TData = Awaited<ReturnType<typeof getHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetHistoryReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHistoryReportXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetHistoryReportXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetHistoryReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHistoryReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHistoryReportXlsx>>
  > = ({ signal }) => getHistoryReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHistoryReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHistoryReportXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHistoryReportXlsx>>
>;
export type GetHistoryReportXlsxQueryError = ErrorType<unknown>;

export const useGetHistoryReportXlsx = <
  TData = Awaited<ReturnType<typeof getHistoryReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetHistoryReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHistoryReportXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHistoryReportXlsxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getIndividualCattleClosingReportXlsx = (
  params: GetIndividualCattleClosingReportXlsxParams,
  signal?: AbortSignal,
) => {
  return request<GetIndividualCattleClosingReportXlsxResponse>({
    url: `/reports/xlsx/individual-cattle-closing`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetIndividualCattleClosingReportXlsxQueryKey = (
  params: GetIndividualCattleClosingReportXlsxParams,
) => {
  return [
    `/reports/xlsx/individual-cattle-closing`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIndividualCattleClosingReportXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetIndividualCattleClosingReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIndividualCattleClosingReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>
  > = ({ signal }) => getIndividualCattleClosingReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIndividualCattleClosingReportXlsxInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>>;
export type GetIndividualCattleClosingReportXlsxInfiniteQueryError =
  ErrorType<unknown>;

export const useGetIndividualCattleClosingReportXlsxInfinite = <
  TData = Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetIndividualCattleClosingReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetIndividualCattleClosingReportXlsxInfiniteQueryOptions(
      params,
      options,
    );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetIndividualCattleClosingReportXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetIndividualCattleClosingReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIndividualCattleClosingReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>
  > = ({ signal }) => getIndividualCattleClosingReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIndividualCattleClosingReportXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>
>;
export type GetIndividualCattleClosingReportXlsxQueryError = ErrorType<unknown>;

export const useGetIndividualCattleClosingReportXlsx = <
  TData = Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetIndividualCattleClosingReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIndividualCattleClosingReportXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIndividualCattleClosingReportXlsxQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getInventoryControlReportXlsx = (
  params: GetInventoryControlReportXlsxParams,
  signal?: AbortSignal,
) => {
  return request<GetInventoryControlReportXlsxResponse>({
    url: `/reports/xlsx/inventory-control`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetInventoryControlReportXlsxQueryKey = (
  params: GetInventoryControlReportXlsxParams,
) => {
  return [
    `/reports/xlsx/inventory-control`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInventoryControlReportXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetInventoryControlReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryControlReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryControlReportXlsx>>
  > = ({ signal }) => getInventoryControlReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryControlReportXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryControlReportXlsx>>
>;
export type GetInventoryControlReportXlsxInfiniteQueryError =
  ErrorType<unknown>;

export const useGetInventoryControlReportXlsxInfinite = <
  TData = Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetInventoryControlReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInventoryControlReportXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetInventoryControlReportXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetInventoryControlReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryControlReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryControlReportXlsx>>
  > = ({ signal }) => getInventoryControlReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryControlReportXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryControlReportXlsx>>
>;
export type GetInventoryControlReportXlsxQueryError = ErrorType<unknown>;

export const useGetInventoryControlReportXlsx = <
  TData = Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetInventoryControlReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryControlReportXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInventoryControlReportXlsxQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const exportMedicineApplicationsReportExcel = (
  listAndExportMedicineApplicationsOxenResponse: ListAndExportMedicineApplicationsOxenResponse,
  params: ExportMedicineApplicationsReportExcelParams,
) => {
  return request<ExportMedicineApplicationsReportExcelResponse>({
    url: `/reports/xlsx/medicine-applications`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: listAndExportMedicineApplicationsOxenResponse,
    params,
  });
};

export const getExportMedicineApplicationsReportExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportMedicineApplicationsReportExcel>>,
    TError,
    {
      data: ListAndExportMedicineApplicationsOxenResponse;
      params: ExportMedicineApplicationsReportExcelParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportMedicineApplicationsReportExcel>>,
  TError,
  {
    data: ListAndExportMedicineApplicationsOxenResponse;
    params: ExportMedicineApplicationsReportExcelParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportMedicineApplicationsReportExcel>>,
    {
      data: ListAndExportMedicineApplicationsOxenResponse;
      params: ExportMedicineApplicationsReportExcelParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return exportMedicineApplicationsReportExcel(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportMedicineApplicationsReportExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportMedicineApplicationsReportExcel>>
>;
export type ExportMedicineApplicationsReportExcelMutationBody =
  ListAndExportMedicineApplicationsOxenResponse;
export type ExportMedicineApplicationsReportExcelMutationError =
  ErrorType<unknown>;

export const useExportMedicineApplicationsReportExcel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportMedicineApplicationsReportExcel>>,
    TError,
    {
      data: ListAndExportMedicineApplicationsOxenResponse;
      params: ExportMedicineApplicationsReportExcelParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getExportMedicineApplicationsReportExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOccurrencesReportXlsx = (
  params: GetOccurrencesReportXlsxParams,
  signal?: AbortSignal,
) => {
  return request<GetOccurrencesReportXlsxResponse>({
    url: `/reports/xlsx/occurrences`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOccurrencesReportXlsxQueryKey = (
  params: GetOccurrencesReportXlsxParams,
) => {
  return [`/reports/xlsx/occurrences`, ...(params ? [params] : [])] as const;
};

export const getGetOccurrencesReportXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetOccurrencesReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOccurrencesReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOccurrencesReportXlsx>>
  > = ({ signal }) => getOccurrencesReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOccurrencesReportXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOccurrencesReportXlsx>>
>;
export type GetOccurrencesReportXlsxInfiniteQueryError = ErrorType<unknown>;

export const useGetOccurrencesReportXlsxInfinite = <
  TData = Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetOccurrencesReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOccurrencesReportXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetOccurrencesReportXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetOccurrencesReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOccurrencesReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOccurrencesReportXlsx>>
  > = ({ signal }) => getOccurrencesReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOccurrencesReportXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOccurrencesReportXlsx>>
>;
export type GetOccurrencesReportXlsxQueryError = ErrorType<unknown>;

export const useGetOccurrencesReportXlsx = <
  TData = Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: GetOccurrencesReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOccurrencesReportXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOccurrencesReportXlsxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generatePartnerSlaughterReportXlsx = (
  partnerSlaughterResult: PartnerSlaughterResult[],
  params: GeneratePartnerSlaughterReportXlsxParams,
) => {
  return request<GeneratePartnerSlaughterReportXlsxResponse>({
    url: `/reports/xlsx/partner-slaughter-result`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: partnerSlaughterResult,
    params,
  });
};

export const getGeneratePartnerSlaughterReportXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePartnerSlaughterReportXlsx>>,
    TError,
    {
      data: PartnerSlaughterResult[];
      params: GeneratePartnerSlaughterReportXlsxParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generatePartnerSlaughterReportXlsx>>,
  TError,
  {
    data: PartnerSlaughterResult[];
    params: GeneratePartnerSlaughterReportXlsxParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generatePartnerSlaughterReportXlsx>>,
    {
      data: PartnerSlaughterResult[];
      params: GeneratePartnerSlaughterReportXlsxParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return generatePartnerSlaughterReportXlsx(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GeneratePartnerSlaughterReportXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof generatePartnerSlaughterReportXlsx>>
>;
export type GeneratePartnerSlaughterReportXlsxMutationBody =
  PartnerSlaughterResult[];
export type GeneratePartnerSlaughterReportXlsxMutationError =
  ErrorType<unknown>;

export const useGeneratePartnerSlaughterReportXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePartnerSlaughterReportXlsx>>,
    TError,
    {
      data: PartnerSlaughterResult[];
      params: GeneratePartnerSlaughterReportXlsxParams;
    },
    TContext
  >;
}) => {
  const mutationOptions =
    getGeneratePartnerSlaughterReportXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const pasturesReportXlsx = (
  params: PasturesReportXlsxParams,
  signal?: AbortSignal,
) => {
  return request<PasturesReportXlsxResponse>({
    url: `/reports/xlsx/pastures-report`,
    method: "GET",
    params,
    signal,
  });
};

export const getPasturesReportXlsxQueryKey = (
  params: PasturesReportXlsxParams,
) => {
  return [
    `/reports/xlsx/pastures-report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPasturesReportXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof pasturesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: PasturesReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof pasturesReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPasturesReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof pasturesReportXlsx>>
  > = ({ signal }) => pasturesReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof pasturesReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PasturesReportXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof pasturesReportXlsx>>
>;
export type PasturesReportXlsxInfiniteQueryError = ErrorType<unknown>;

export const usePasturesReportXlsxInfinite = <
  TData = Awaited<ReturnType<typeof pasturesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: PasturesReportXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof pasturesReportXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPasturesReportXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPasturesReportXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof pasturesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: PasturesReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof pasturesReportXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPasturesReportXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof pasturesReportXlsx>>
  > = ({ signal }) => pasturesReportXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof pasturesReportXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PasturesReportXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof pasturesReportXlsx>>
>;
export type PasturesReportXlsxQueryError = ErrorType<unknown>;

export const usePasturesReportXlsx = <
  TData = Awaited<ReturnType<typeof pasturesReportXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: PasturesReportXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof pasturesReportXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPasturesReportXlsxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listStocksRetroactiveXlsx = (
  params: ListStocksRetroactiveXlsxParams,
  signal?: AbortSignal,
) => {
  return request<ListStocksRetroactiveXlsxResponse>({
    url: `/reports/xlsx/retroactive-food`,
    method: "GET",
    params,
    signal,
  });
};

export const getListStocksRetroactiveXlsxQueryKey = (
  params: ListStocksRetroactiveXlsxParams,
) => {
  return [
    `/reports/xlsx/retroactive-food`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListStocksRetroactiveXlsxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListStocksRetroactiveXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStocksRetroactiveXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>
  > = ({ signal }) => listStocksRetroactiveXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStocksRetroactiveXlsxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>
>;
export type ListStocksRetroactiveXlsxInfiniteQueryError = ErrorType<unknown>;

export const useListStocksRetroactiveXlsxInfinite = <
  TData = Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListStocksRetroactiveXlsxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStocksRetroactiveXlsxInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListStocksRetroactiveXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListStocksRetroactiveXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStocksRetroactiveXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>
  > = ({ signal }) => listStocksRetroactiveXlsx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStocksRetroactiveXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>
>;
export type ListStocksRetroactiveXlsxQueryError = ErrorType<unknown>;

export const useListStocksRetroactiveXlsx = <
  TData = Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
  TError = ErrorType<unknown>,
>(
  params: ListStocksRetroactiveXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactiveXlsx>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStocksRetroactiveXlsxQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getZootechnicalReport = (
  params: GetZootechnicalReportParams,
  signal?: AbortSignal,
) => {
  return request<void>({
    url: `/reports/zootechnical`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetZootechnicalReportQueryKey = (
  params: GetZootechnicalReportParams,
) => {
  return [`/reports/zootechnical`, ...(params ? [params] : [])] as const;
};

export const getGetZootechnicalReportInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getZootechnicalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetZootechnicalReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getZootechnicalReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetZootechnicalReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getZootechnicalReport>>
  > = ({ signal }) => getZootechnicalReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getZootechnicalReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetZootechnicalReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getZootechnicalReport>>
>;
export type GetZootechnicalReportInfiniteQueryError = ErrorType<HttpError>;

export const useGetZootechnicalReportInfinite = <
  TData = Awaited<ReturnType<typeof getZootechnicalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetZootechnicalReportParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getZootechnicalReport>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetZootechnicalReportInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetZootechnicalReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getZootechnicalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetZootechnicalReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getZootechnicalReport>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetZootechnicalReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getZootechnicalReport>>
  > = ({ signal }) => getZootechnicalReport(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getZootechnicalReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetZootechnicalReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getZootechnicalReport>>
>;
export type GetZootechnicalReportQueryError = ErrorType<HttpError>;

export const useGetZootechnicalReport = <
  TData = Awaited<ReturnType<typeof getZootechnicalReport>>,
  TError = ErrorType<HttpError>,
>(
  params: GetZootechnicalReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getZootechnicalReport>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetZootechnicalReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getZootechnicalReportXlsx = (
  zootechnicalReportServiceResponse: ZootechnicalReportServiceResponse,
  params: GetZootechnicalReportXlsxParams,
) => {
  return request<GetZootechnicalReportXlsxResponse>({
    url: `/reports/zootechnical/excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: zootechnicalReportServiceResponse,
    params,
  });
};

export const getGetZootechnicalReportXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getZootechnicalReportXlsx>>,
    TError,
    {
      data: ZootechnicalReportServiceResponse;
      params: GetZootechnicalReportXlsxParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getZootechnicalReportXlsx>>,
  TError,
  {
    data: ZootechnicalReportServiceResponse;
    params: GetZootechnicalReportXlsxParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getZootechnicalReportXlsx>>,
    {
      data: ZootechnicalReportServiceResponse;
      params: GetZootechnicalReportXlsxParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return getZootechnicalReportXlsx(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetZootechnicalReportXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof getZootechnicalReportXlsx>>
>;
export type GetZootechnicalReportXlsxMutationBody =
  ZootechnicalReportServiceResponse;
export type GetZootechnicalReportXlsxMutationError = ErrorType<unknown>;

export const useGetZootechnicalReportXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getZootechnicalReportXlsx>>,
    TError,
    {
      data: ZootechnicalReportServiceResponse;
      params: GetZootechnicalReportXlsxParams;
    },
    TContext
  >;
}) => {
  const mutationOptions = getGetZootechnicalReportXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listSaleManagements = (
  params?: ListSaleManagementsParams,
  signal?: AbortSignal,
) => {
  return request<ListSaleManagementsResponse>({
    url: `/sale-management`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSaleManagementsQueryKey = (
  params?: ListSaleManagementsParams,
) => {
  return [`/sale-management`, ...(params ? [params] : [])] as const;
};

export const getListSaleManagementsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleManagements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleManagementsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSaleManagements>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSaleManagementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSaleManagements>>
  > = ({ signal }) => listSaleManagements(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSaleManagements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleManagementsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleManagements>>
>;
export type ListSaleManagementsInfiniteQueryError = ErrorType<unknown>;

export const useListSaleManagementsInfinite = <
  TData = Awaited<ReturnType<typeof listSaleManagements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleManagementsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSaleManagements>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleManagementsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSaleManagementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleManagements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleManagementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSaleManagements>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSaleManagementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSaleManagements>>
  > = ({ signal }) => listSaleManagements(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSaleManagements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleManagementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleManagements>>
>;
export type ListSaleManagementsQueryError = ErrorType<unknown>;

export const useListSaleManagements = <
  TData = Awaited<ReturnType<typeof listSaleManagements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleManagementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSaleManagements>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleManagementsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listInternalSales = (
  params?: ListInternalSalesParams,
  signal?: AbortSignal,
) => {
  return request<ListInternalSalesResponse>({
    url: `/sale-management/list-internal-sales`,
    method: "GET",
    params,
    signal,
  });
};

export const getListInternalSalesQueryKey = (
  params?: ListInternalSalesParams,
) => {
  return [
    `/sale-management/list-internal-sales`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListInternalSalesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listInternalSales>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListInternalSalesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listInternalSales>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInternalSalesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInternalSales>>
  > = ({ signal }) => listInternalSales(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listInternalSales>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInternalSalesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInternalSales>>
>;
export type ListInternalSalesInfiniteQueryError = ErrorType<HttpError>;

export const useListInternalSalesInfinite = <
  TData = Awaited<ReturnType<typeof listInternalSales>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListInternalSalesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listInternalSales>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListInternalSalesInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListInternalSalesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInternalSales>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListInternalSalesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInternalSales>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInternalSalesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInternalSales>>
  > = ({ signal }) => listInternalSales(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInternalSales>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInternalSalesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInternalSales>>
>;
export type ListInternalSalesQueryError = ErrorType<HttpError>;

export const useListInternalSales = <
  TData = Awaited<ReturnType<typeof listInternalSales>>,
  TError = ErrorType<HttpError>,
>(
  params?: ListInternalSalesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInternalSales>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListInternalSalesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSaleManagement = (id: number, signal?: AbortSignal) => {
  return request<GetSaleManagementResponse>({
    url: `/sale-management/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSaleManagementQueryKey = (id: number) => {
  return [`/sale-management/${id}`] as const;
};

export const getGetSaleManagementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleManagement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleManagement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleManagementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleManagement>>
  > = ({ signal }) => getSaleManagement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSaleManagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleManagementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleManagement>>
>;
export type GetSaleManagementInfiniteQueryError = ErrorType<unknown>;

export const useGetSaleManagementInfinite = <
  TData = Awaited<ReturnType<typeof getSaleManagement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleManagement>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleManagementInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSaleManagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleManagement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleManagement>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleManagementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleManagement>>
  > = ({ signal }) => getSaleManagement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSaleManagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleManagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleManagement>>
>;
export type GetSaleManagementQueryError = ErrorType<unknown>;

export const useGetSaleManagement = <
  TData = Awaited<ReturnType<typeof getSaleManagement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleManagement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleManagementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const closeSaleManagement = (
  id: number,
  closeSaleManagementBody: CloseSaleManagementBody,
) => {
  return request<CloseSaleManagementResponse>({
    url: `/sale-management/${id}/closure`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: closeSaleManagementBody,
  });
};

export const getCloseSaleManagementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeSaleManagement>>,
    TError,
    { id: number; data: CloseSaleManagementBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeSaleManagement>>,
  TError,
  { id: number; data: CloseSaleManagementBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeSaleManagement>>,
    { id: number; data: CloseSaleManagementBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return closeSaleManagement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseSaleManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeSaleManagement>>
>;
export type CloseSaleManagementMutationBody = CloseSaleManagementBody;
export type CloseSaleManagementMutationError = ErrorType<HttpError>;

export const useCloseSaleManagement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeSaleManagement>>,
    TError,
    { id: number; data: CloseSaleManagementBody },
    TContext
  >;
}) => {
  const mutationOptions = getCloseSaleManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listSaleOrders = (
  params?: ListSaleOrdersParams,
  signal?: AbortSignal,
) => {
  return request<ListSaleOrdersResponse>({
    url: `/sale-orders`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSaleOrdersQueryKey = (params?: ListSaleOrdersParams) => {
  return [`/sale-orders`, ...(params ? [params] : [])] as const;
};

export const getListSaleOrdersInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleOrdersParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSaleOrders>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSaleOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSaleOrders>>> = ({
    signal,
  }) => listSaleOrders(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSaleOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleOrdersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleOrders>>
>;
export type ListSaleOrdersInfiniteQueryError = ErrorType<unknown>;

export const useListSaleOrdersInfinite = <
  TData = Awaited<ReturnType<typeof listSaleOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleOrdersParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSaleOrders>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleOrdersInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSaleOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSaleOrders>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSaleOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSaleOrders>>> = ({
    signal,
  }) => listSaleOrders(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSaleOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleOrders>>
>;
export type ListSaleOrdersQueryError = ErrorType<unknown>;

export const useListSaleOrders = <
  TData = Awaited<ReturnType<typeof listSaleOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSaleOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSaleOrders>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createSaleOrder = (
  createSaleOrderRequest: CreateSaleOrderRequest,
) => {
  return request<CreateSaleOrderResponse>({
    url: `/sale-orders`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSaleOrderRequest,
  });
};

export const getCreateSaleOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSaleOrder>>,
    TError,
    { data: CreateSaleOrderRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSaleOrder>>,
  TError,
  { data: CreateSaleOrderRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSaleOrder>>,
    { data: CreateSaleOrderRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createSaleOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSaleOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSaleOrder>>
>;
export type CreateSaleOrderMutationBody = CreateSaleOrderRequest;
export type CreateSaleOrderMutationError = ErrorType<HttpError>;

export const useCreateSaleOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSaleOrder>>,
    TError,
    { data: CreateSaleOrderRequest },
    TContext
  >;
}) => {
  const mutationOptions = getCreateSaleOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteSaleOrderPenalty = (
  deleteSaleOrderPenaltyBody: DeleteSaleOrderPenaltyBody,
) => {
  return request<boolean>({
    url: `/sale-orders/penality`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: deleteSaleOrderPenaltyBody,
  });
};

export const getDeleteSaleOrderPenaltyMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSaleOrderPenalty>>,
    TError,
    { data: DeleteSaleOrderPenaltyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSaleOrderPenalty>>,
  TError,
  { data: DeleteSaleOrderPenaltyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSaleOrderPenalty>>,
    { data: DeleteSaleOrderPenaltyBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteSaleOrderPenalty(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSaleOrderPenaltyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSaleOrderPenalty>>
>;
export type DeleteSaleOrderPenaltyMutationBody = DeleteSaleOrderPenaltyBody;
export type DeleteSaleOrderPenaltyMutationError = ErrorType<HttpError>;

export const useDeleteSaleOrderPenalty = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSaleOrderPenalty>>,
    TError,
    { data: DeleteSaleOrderPenaltyBody },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteSaleOrderPenaltyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listSaleOrderPenalties = (
  params: ListSaleOrderPenaltiesParams,
  signal?: AbortSignal,
) => {
  return request<ListSaleOrderPenaltiesResponse>({
    url: `/sale-orders/penality`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSaleOrderPenaltiesQueryKey = (
  params: ListSaleOrderPenaltiesParams,
) => {
  return [`/sale-orders/penality`, ...(params ? [params] : [])] as const;
};

export const getListSaleOrderPenaltiesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleOrderPenalties>>,
  TError = ErrorType<unknown>,
>(
  params: ListSaleOrderPenaltiesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSaleOrderPenalties>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSaleOrderPenaltiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSaleOrderPenalties>>
  > = ({ signal }) => listSaleOrderPenalties(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSaleOrderPenalties>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleOrderPenaltiesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleOrderPenalties>>
>;
export type ListSaleOrderPenaltiesInfiniteQueryError = ErrorType<unknown>;

export const useListSaleOrderPenaltiesInfinite = <
  TData = Awaited<ReturnType<typeof listSaleOrderPenalties>>,
  TError = ErrorType<unknown>,
>(
  params: ListSaleOrderPenaltiesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSaleOrderPenalties>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleOrderPenaltiesInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSaleOrderPenaltiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSaleOrderPenalties>>,
  TError = ErrorType<unknown>,
>(
  params: ListSaleOrderPenaltiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSaleOrderPenalties>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSaleOrderPenaltiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSaleOrderPenalties>>
  > = ({ signal }) => listSaleOrderPenalties(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSaleOrderPenalties>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSaleOrderPenaltiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSaleOrderPenalties>>
>;
export type ListSaleOrderPenaltiesQueryError = ErrorType<unknown>;

export const useListSaleOrderPenalties = <
  TData = Awaited<ReturnType<typeof listSaleOrderPenalties>>,
  TError = ErrorType<unknown>,
>(
  params: ListSaleOrderPenaltiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSaleOrderPenalties>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSaleOrderPenaltiesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createSaleOrderPenalty = (
  createSaleOrderPenaltyBody: CreateSaleOrderPenaltyBody,
) => {
  return request<boolean>({
    url: `/sale-orders/penality`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSaleOrderPenaltyBody,
  });
};

export const getCreateSaleOrderPenaltyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSaleOrderPenalty>>,
    TError,
    { data: CreateSaleOrderPenaltyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSaleOrderPenalty>>,
  TError,
  { data: CreateSaleOrderPenaltyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSaleOrderPenalty>>,
    { data: CreateSaleOrderPenaltyBody }
  > = (props) => {
    const { data } = props ?? {};

    return createSaleOrderPenalty(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSaleOrderPenaltyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSaleOrderPenalty>>
>;
export type CreateSaleOrderPenaltyMutationBody = CreateSaleOrderPenaltyBody;
export type CreateSaleOrderPenaltyMutationError = ErrorType<unknown>;

export const useCreateSaleOrderPenalty = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSaleOrderPenalty>>,
    TError,
    { data: CreateSaleOrderPenaltyBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateSaleOrderPenaltyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateSaleOrderPenalty = (
  updateSaleOrderPenaltyBody: UpdateSaleOrderPenaltyBody,
) => {
  return request<boolean>({
    url: `/sale-orders/penality`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateSaleOrderPenaltyBody,
  });
};

export const getUpdateSaleOrderPenaltyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderPenalty>>,
    TError,
    { data: UpdateSaleOrderPenaltyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSaleOrderPenalty>>,
  TError,
  { data: UpdateSaleOrderPenaltyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSaleOrderPenalty>>,
    { data: UpdateSaleOrderPenaltyBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateSaleOrderPenalty(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSaleOrderPenaltyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSaleOrderPenalty>>
>;
export type UpdateSaleOrderPenaltyMutationBody = UpdateSaleOrderPenaltyBody;
export type UpdateSaleOrderPenaltyMutationError = ErrorType<unknown>;

export const useUpdateSaleOrderPenalty = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderPenalty>>,
    TError,
    { data: UpdateSaleOrderPenaltyBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateSaleOrderPenaltyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateSaleOrderType = (
  updateSaleOrderTypeBody: UpdateSaleOrderTypeBody,
) => {
  return request<boolean>({
    url: `/sale-orders/penalityUpdateType`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateSaleOrderTypeBody,
  });
};

export const getUpdateSaleOrderTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderType>>,
    TError,
    { data: UpdateSaleOrderTypeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSaleOrderType>>,
  TError,
  { data: UpdateSaleOrderTypeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSaleOrderType>>,
    { data: UpdateSaleOrderTypeBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateSaleOrderType(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSaleOrderTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSaleOrderType>>
>;
export type UpdateSaleOrderTypeMutationBody = UpdateSaleOrderTypeBody;
export type UpdateSaleOrderTypeMutationError = ErrorType<unknown>;

export const useUpdateSaleOrderType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderType>>,
    TError,
    { data: UpdateSaleOrderTypeBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateSaleOrderTypeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const transferOxenBetweenSaleOrders = (
  transferOxenBetweenSaleOrdersBody: TransferOxenBetweenSaleOrdersBody,
) => {
  return request<TransferOxenBetweenSaleOrdersResponse>({
    url: `/sale-orders/transfer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: transferOxenBetweenSaleOrdersBody,
  });
};

export const getTransferOxenBetweenSaleOrdersMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferOxenBetweenSaleOrders>>,
    TError,
    { data: TransferOxenBetweenSaleOrdersBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferOxenBetweenSaleOrders>>,
  TError,
  { data: TransferOxenBetweenSaleOrdersBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferOxenBetweenSaleOrders>>,
    { data: TransferOxenBetweenSaleOrdersBody }
  > = (props) => {
    const { data } = props ?? {};

    return transferOxenBetweenSaleOrders(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferOxenBetweenSaleOrdersMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferOxenBetweenSaleOrders>>
>;
export type TransferOxenBetweenSaleOrdersMutationBody =
  TransferOxenBetweenSaleOrdersBody;
export type TransferOxenBetweenSaleOrdersMutationError = ErrorType<HttpError>;

export const useTransferOxenBetweenSaleOrders = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferOxenBetweenSaleOrders>>,
    TError,
    { data: TransferOxenBetweenSaleOrdersBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getTransferOxenBetweenSaleOrdersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Exclui uma ordem de venda sem animais vinculados (ex.: depois de um estorno individual pelo `reverse-oxen` que
esvaziou todos os caminhões, mas manteve a ordem em aberto).
 */
export const deleteSaleOrder = (id: number) => {
  return request<boolean>({ url: `/sale-orders/${id}`, method: "DELETE" });
};

export const getDeleteSaleOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSaleOrder>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSaleOrder>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSaleOrder>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSaleOrder(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSaleOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSaleOrder>>
>;

export type DeleteSaleOrderMutationError = ErrorType<HttpError>;

export const useDeleteSaleOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSaleOrder>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteSaleOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSaleOrderById = (id: number, signal?: AbortSignal) => {
  return request<GetSaleOrderByIdResponse>({
    url: `/sale-orders/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSaleOrderByIdQueryKey = (id: number) => {
  return [`/sale-orders/${id}`] as const;
};

export const getGetSaleOrderByIdInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleOrderById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleOrderByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleOrderById>>
  > = ({ signal }) => getSaleOrderById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSaleOrderById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleOrderByIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleOrderById>>
>;
export type GetSaleOrderByIdInfiniteQueryError = ErrorType<HttpError>;

export const useGetSaleOrderByIdInfinite = <
  TData = Awaited<ReturnType<typeof getSaleOrderById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderById>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleOrderByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSaleOrderByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleOrderById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderById>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleOrderByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleOrderById>>
  > = ({ signal }) => getSaleOrderById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSaleOrderById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleOrderByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleOrderById>>
>;
export type GetSaleOrderByIdQueryError = ErrorType<HttpError>;

export const useGetSaleOrderById = <
  TData = Awaited<ReturnType<typeof getSaleOrderById>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderById>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleOrderByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateSaleOrder = (
  id: number,
  updateSaleOrderBody: UpdateSaleOrderBody,
) => {
  return request<UpdateSaleOrderResponse>({
    url: `/sale-orders/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateSaleOrderBody,
  });
};

export const getUpdateSaleOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrder>>,
    TError,
    { id: number; data: UpdateSaleOrderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSaleOrder>>,
  TError,
  { id: number; data: UpdateSaleOrderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSaleOrder>>,
    { id: number; data: UpdateSaleOrderBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSaleOrder(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSaleOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSaleOrder>>
>;
export type UpdateSaleOrderMutationBody = UpdateSaleOrderBody;
export type UpdateSaleOrderMutationError = ErrorType<HttpError>;

export const useUpdateSaleOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrder>>,
    TError,
    { id: number; data: UpdateSaleOrderBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateSaleOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const closeSaleOrderInBatch = (
  id: number,
  closeSaleOrderInBatchRequest: CloseSaleOrderInBatchRequest,
) => {
  return request<CloseSaleOrderInBatchResponse>({
    url: `/sale-orders/${id}/closure`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: closeSaleOrderInBatchRequest,
  });
};

export const getCloseSaleOrderInBatchMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeSaleOrderInBatch>>,
    TError,
    { id: number; data: CloseSaleOrderInBatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeSaleOrderInBatch>>,
  TError,
  { id: number; data: CloseSaleOrderInBatchRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeSaleOrderInBatch>>,
    { id: number; data: CloseSaleOrderInBatchRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return closeSaleOrderInBatch(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseSaleOrderInBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeSaleOrderInBatch>>
>;
export type CloseSaleOrderInBatchMutationBody = CloseSaleOrderInBatchRequest;
export type CloseSaleOrderInBatchMutationError = ErrorType<HttpError>;

export const useCloseSaleOrderInBatch = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeSaleOrderInBatch>>,
    TError,
    { id: number; data: CloseSaleOrderInBatchRequest },
    TContext
  >;
}) => {
  const mutationOptions = getCloseSaleOrderInBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateSaleOrderBatchClosure = (
  id: number,
  closeSaleOrderInBatchRequest: CloseSaleOrderInBatchRequest,
) => {
  return request<boolean>({
    url: `/sale-orders/${id}/closure`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: closeSaleOrderInBatchRequest,
  });
};

export const getUpdateSaleOrderBatchClosureMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderBatchClosure>>,
    TError,
    { id: number; data: CloseSaleOrderInBatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSaleOrderBatchClosure>>,
  TError,
  { id: number; data: CloseSaleOrderInBatchRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSaleOrderBatchClosure>>,
    { id: number; data: CloseSaleOrderInBatchRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSaleOrderBatchClosure(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSaleOrderBatchClosureMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSaleOrderBatchClosure>>
>;
export type UpdateSaleOrderBatchClosureMutationBody =
  CloseSaleOrderInBatchRequest;
export type UpdateSaleOrderBatchClosureMutationError = ErrorType<HttpError>;

export const useUpdateSaleOrderBatchClosure = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderBatchClosure>>,
    TError,
    { id: number; data: CloseSaleOrderInBatchRequest },
    TContext
  >;
}) => {
  const mutationOptions =
    getUpdateSaleOrderBatchClosureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportCattleManifest = (
  id: number,
  exportCattleManifestBody: ExportCattleManifestBody,
) => {
  return request<ExportCattleManifestResponse>({
    url: `/sale-orders/${id}/export-cattle-manifest`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: exportCattleManifestBody,
  });
};

export const getExportCattleManifestMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportCattleManifest>>,
    TError,
    { id: number; data: ExportCattleManifestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportCattleManifest>>,
  TError,
  { id: number; data: ExportCattleManifestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportCattleManifest>>,
    { id: number; data: ExportCattleManifestBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return exportCattleManifest(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportCattleManifestMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportCattleManifest>>
>;
export type ExportCattleManifestMutationBody = ExportCattleManifestBody;
export type ExportCattleManifestMutationError = ErrorType<HttpError>;

export const useExportCattleManifest = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportCattleManifest>>,
    TError,
    { id: number; data: ExportCattleManifestBody },
    TContext
  >;
}) => {
  const mutationOptions = getExportCattleManifestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportSaleOrderOxenToExcel = (
  id: number,
  exportSaleOrderOxenToExcelBody: ExportSaleOrderOxenToExcelBody,
) => {
  return request<ExportSaleOrderOxenToExcelResponse>({
    url: `/sale-orders/${id}/export-excel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: exportSaleOrderOxenToExcelBody,
  });
};

export const getExportSaleOrderOxenToExcelMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportSaleOrderOxenToExcel>>,
    TError,
    { id: number; data: ExportSaleOrderOxenToExcelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportSaleOrderOxenToExcel>>,
  TError,
  { id: number; data: ExportSaleOrderOxenToExcelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportSaleOrderOxenToExcel>>,
    { id: number; data: ExportSaleOrderOxenToExcelBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return exportSaleOrderOxenToExcel(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportSaleOrderOxenToExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportSaleOrderOxenToExcel>>
>;
export type ExportSaleOrderOxenToExcelMutationBody =
  ExportSaleOrderOxenToExcelBody;
export type ExportSaleOrderOxenToExcelMutationError = ErrorType<HttpError>;

export const useExportSaleOrderOxenToExcel = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportSaleOrderOxenToExcel>>,
    TError,
    { id: number; data: ExportSaleOrderOxenToExcelBody },
    TContext
  >;
}) => {
  const mutationOptions = getExportSaleOrderOxenToExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const importCattleManifest = (
  id: number,
  importCattleManifestBody: ImportCattleManifestBody,
) => {
  return request<ImportCattleManifestResponse>({
    url: `/sale-orders/${id}/import-cattle-manifest`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importCattleManifestBody,
  });
};

export const getImportCattleManifestMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importCattleManifest>>,
    TError,
    { id: number; data: ImportCattleManifestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importCattleManifest>>,
  TError,
  { id: number; data: ImportCattleManifestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importCattleManifest>>,
    { id: number; data: ImportCattleManifestBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return importCattleManifest(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportCattleManifestMutationResult = NonNullable<
  Awaited<ReturnType<typeof importCattleManifest>>
>;
export type ImportCattleManifestMutationBody = ImportCattleManifestBody;
export type ImportCattleManifestMutationError = ErrorType<HttpError>;

export const useImportCattleManifest = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importCattleManifest>>,
    TError,
    { id: number; data: ImportCattleManifestBody },
    TContext
  >;
}) => {
  const mutationOptions = getImportCattleManifestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const reverseOxenBulk = (
  id: number,
  reverseOxenBulkBody: ReverseOxenBulkBody,
) => {
  return request<boolean>({
    url: `/sale-orders/${id}/reverse-oxen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: reverseOxenBulkBody,
  });
};

export const getReverseOxenBulkMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseOxenBulk>>,
    TError,
    { id: number; data: ReverseOxenBulkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reverseOxenBulk>>,
  TError,
  { id: number; data: ReverseOxenBulkBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reverseOxenBulk>>,
    { id: number; data: ReverseOxenBulkBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return reverseOxenBulk(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReverseOxenBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof reverseOxenBulk>>
>;
export type ReverseOxenBulkMutationBody = ReverseOxenBulkBody;
export type ReverseOxenBulkMutationError = ErrorType<HttpError>;

export const useReverseOxenBulk = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseOxenBulk>>,
    TError,
    { id: number; data: ReverseOxenBulkBody },
    TContext
  >;
}) => {
  const mutationOptions = getReverseOxenBulkMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Estorno total da venda: revive os animais, reabre os lotes (no curral original ou no informado), preenche o gap com a
nota de estorno zerada e um trato zerado por dia, e apaga caminhões, romaneios e a ordem de venda.
 */
export const revertSaleOrder = (
  id: number,
  revertSaleOrderBody: RevertSaleOrderBody,
) => {
  return request<ApplyRevertSaleOrderResult>({
    url: `/sale-orders/${id}/revert`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: revertSaleOrderBody,
  });
};

export const getRevertSaleOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertSaleOrder>>,
    TError,
    { id: number; data: RevertSaleOrderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertSaleOrder>>,
  TError,
  { id: number; data: RevertSaleOrderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertSaleOrder>>,
    { id: number; data: RevertSaleOrderBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return revertSaleOrder(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertSaleOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertSaleOrder>>
>;
export type RevertSaleOrderMutationBody = RevertSaleOrderBody;
export type RevertSaleOrderMutationError = ErrorType<HttpError>;

export const useRevertSaleOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertSaleOrder>>,
    TError,
    { id: number; data: RevertSaleOrderBody },
    TContext
  >;
}) => {
  const mutationOptions = getRevertSaleOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Prévia do estorno total: dias que serão zerados por lote e ocupação do curral original.
 */
export const previewRevertSaleOrder = (
  id: number,
  revertSaleOrderBody: RevertSaleOrderBody,
) => {
  return request<RevertSaleOrderPreviewResult>({
    url: `/sale-orders/${id}/revert/preview`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: revertSaleOrderBody,
  });
};

export const getPreviewRevertSaleOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRevertSaleOrder>>,
    TError,
    { id: number; data: RevertSaleOrderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewRevertSaleOrder>>,
  TError,
  { id: number; data: RevertSaleOrderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewRevertSaleOrder>>,
    { id: number; data: RevertSaleOrderBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewRevertSaleOrder(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewRevertSaleOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewRevertSaleOrder>>
>;
export type PreviewRevertSaleOrderMutationBody = RevertSaleOrderBody;
export type PreviewRevertSaleOrderMutationError = ErrorType<HttpError>;

export const usePreviewRevertSaleOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRevertSaleOrder>>,
    TError,
    { id: number; data: RevertSaleOrderBody },
    TContext
  >;
}) => {
  const mutationOptions = getPreviewRevertSaleOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateSaleOrderByExcel = (
  id: number,
  updateSaleOrderByExcelBody: UpdateSaleOrderByExcelBody,
) => {
  return request<boolean>({
    url: `/sale-orders/${id}/update-sale-order-by-excel`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateSaleOrderByExcelBody,
  });
};

export const getUpdateSaleOrderByExcelMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderByExcel>>,
    TError,
    { id: number; data: UpdateSaleOrderByExcelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSaleOrderByExcel>>,
  TError,
  { id: number; data: UpdateSaleOrderByExcelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSaleOrderByExcel>>,
    { id: number; data: UpdateSaleOrderByExcelBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSaleOrderByExcel(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSaleOrderByExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSaleOrderByExcel>>
>;
export type UpdateSaleOrderByExcelMutationBody = UpdateSaleOrderByExcelBody;
export type UpdateSaleOrderByExcelMutationError = ErrorType<HttpError>;

export const useUpdateSaleOrderByExcel = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderByExcel>>,
    TError,
    { id: number; data: UpdateSaleOrderByExcelBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateSaleOrderByExcelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSaleOrderWeights = (id: number, signal?: AbortSignal) => {
  return request<GetSaleOrderWeightsResponse>({
    url: `/sale-orders/${id}/weights`,
    method: "GET",
    signal,
  });
};

export const getGetSaleOrderWeightsQueryKey = (id: number) => {
  return [`/sale-orders/${id}/weights`] as const;
};

export const getGetSaleOrderWeightsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleOrderWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleOrderWeightsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleOrderWeights>>
  > = ({ signal }) => getSaleOrderWeights(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSaleOrderWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleOrderWeightsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleOrderWeights>>
>;
export type GetSaleOrderWeightsInfiniteQueryError = ErrorType<unknown>;

export const useGetSaleOrderWeightsInfinite = <
  TData = Awaited<ReturnType<typeof getSaleOrderWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderWeights>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleOrderWeightsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSaleOrderWeightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleOrderWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderWeights>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSaleOrderWeightsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSaleOrderWeights>>
  > = ({ signal }) => getSaleOrderWeights(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSaleOrderWeights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSaleOrderWeightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSaleOrderWeights>>
>;
export type GetSaleOrderWeightsQueryError = ErrorType<unknown>;

export const useGetSaleOrderWeights = <
  TData = Awaited<ReturnType<typeof getSaleOrderWeights>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSaleOrderWeights>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSaleOrderWeightsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateSaleOrderWeights = (
  id: number,
  updateSaleOrderWeightsBody: UpdateSaleOrderWeightsBody,
) => {
  return request<boolean>({
    url: `/sale-orders/${id}/weights`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateSaleOrderWeightsBody,
  });
};

export const getUpdateSaleOrderWeightsMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderWeights>>,
    TError,
    { id: number; data: UpdateSaleOrderWeightsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSaleOrderWeights>>,
  TError,
  { id: number; data: UpdateSaleOrderWeightsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSaleOrderWeights>>,
    { id: number; data: UpdateSaleOrderWeightsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSaleOrderWeights(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSaleOrderWeightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSaleOrderWeights>>
>;
export type UpdateSaleOrderWeightsMutationBody = UpdateSaleOrderWeightsBody;
export type UpdateSaleOrderWeightsMutationError = ErrorType<HttpError>;

export const useUpdateSaleOrderWeights = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSaleOrderWeights>>,
    TError,
    { id: number; data: UpdateSaleOrderWeightsBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateSaleOrderWeightsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const internalSeedAdvanceFarm = (
  adjustCurrentForeseen: AdjustCurrentForeseen,
  params?: InternalSeedAdvanceFarmParams,
) => {
  return request<boolean>({
    url: `/seed`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: adjustCurrentForeseen,
    params,
  });
};

export const getInternalSeedAdvanceFarmMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof internalSeedAdvanceFarm>>,
    TError,
    { data: AdjustCurrentForeseen; params?: InternalSeedAdvanceFarmParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof internalSeedAdvanceFarm>>,
  TError,
  { data: AdjustCurrentForeseen; params?: InternalSeedAdvanceFarmParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof internalSeedAdvanceFarm>>,
    { data: AdjustCurrentForeseen; params?: InternalSeedAdvanceFarmParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return internalSeedAdvanceFarm(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type InternalSeedAdvanceFarmMutationResult = NonNullable<
  Awaited<ReturnType<typeof internalSeedAdvanceFarm>>
>;
export type InternalSeedAdvanceFarmMutationBody = AdjustCurrentForeseen;
export type InternalSeedAdvanceFarmMutationError = ErrorType<unknown>;

export const useInternalSeedAdvanceFarm = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof internalSeedAdvanceFarm>>,
    TError,
    { data: AdjustCurrentForeseen; params?: InternalSeedAdvanceFarmParams },
    TContext
  >;
}) => {
  const mutationOptions = getInternalSeedAdvanceFarmMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSheetData = (
  params: GetSheetDataParams,
  signal?: AbortSignal,
) => {
  return request<GetSheetDataResponse>({
    url: `/sheets`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSheetDataQueryKey = (params: GetSheetDataParams) => {
  return [`/sheets`, ...(params ? [params] : [])] as const;
};

export const getGetSheetDataInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSheetData>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSheetDataParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSheetData>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSheetDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSheetData>>> = ({
    signal,
  }) => getSheetData(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSheetData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSheetDataInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSheetData>>
>;
export type GetSheetDataInfiniteQueryError = ErrorType<HttpError>;

export const useGetSheetDataInfinite = <
  TData = Awaited<ReturnType<typeof getSheetData>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSheetDataParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSheetData>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSheetDataInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetSheetDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getSheetData>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSheetDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSheetData>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSheetDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSheetData>>> = ({
    signal,
  }) => getSheetData(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSheetData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSheetDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSheetData>>
>;
export type GetSheetDataQueryError = ErrorType<HttpError>;

export const useGetSheetData = <
  TData = Awaited<ReturnType<typeof getSheetData>>,
  TError = ErrorType<HttpError>,
>(
  params: GetSheetDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSheetData>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSheetDataQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Exclui um cadastro de MS: a ocorrência cai junto e as pré-misturas voltam ao valor anterior.
 */
export const deleteDryMatterChange = (id: number) => {
  return request<boolean>({ url: `/stock-changes/${id}`, method: "DELETE" });
};

export const getDeleteDryMatterChangeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDryMatterChange>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDryMatterChange>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDryMatterChange>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDryMatterChange(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDryMatterChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDryMatterChange>>
>;

export type DeleteDryMatterChangeMutationError = ErrorType<HttpError>;

export const useDeleteDryMatterChange = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDryMatterChange>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteDryMatterChangeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Altera o fator de matéria seca de um cadastro de MS já feito.
 */
export const updateDryMatterChange = (
  id: number,
  updateDryMatterChangeBody: number,
) => {
  return request<boolean>({
    url: `/stock-changes/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateDryMatterChangeBody,
  });
};

export const getUpdateDryMatterChangeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDryMatterChange>>,
    TError,
    { id: number; data: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDryMatterChange>>,
  TError,
  { id: number; data: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDryMatterChange>>,
    { id: number; data: number }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDryMatterChange(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDryMatterChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDryMatterChange>>
>;
export type UpdateDryMatterChangeMutationBody = number;
export type UpdateDryMatterChangeMutationError = ErrorType<HttpError>;

export const useUpdateDryMatterChange = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDryMatterChange>>,
    TError,
    { id: number; data: number },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateDryMatterChangeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listStocks = (params?: ListStocksParams, signal?: AbortSignal) => {
  return request<ListStocksResponse>({
    url: `/stocks`,
    method: "GET",
    params,
    signal,
  });
};

export const getListStocksQueryKey = (params?: ListStocksParams) => {
  return [`/stocks`, ...(params ? [params] : [])] as const;
};

export const getListStocksInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listStocks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStocksParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listStocks>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStocksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStocks>>> = ({
    signal,
  }) => listStocks(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listStocks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStocksInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStocks>>
>;
export type ListStocksInfiniteQueryError = ErrorType<unknown>;

export const useListStocksInfinite = <
  TData = Awaited<ReturnType<typeof listStocks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStocksParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listStocks>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStocksInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListStocksQueryOptions = <
  TData = Awaited<ReturnType<typeof listStocks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStocksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStocks>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStocksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStocks>>> = ({
    signal,
  }) => listStocks(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listStocks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStocksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStocks>>
>;
export type ListStocksQueryError = ErrorType<unknown>;

export const useListStocks = <
  TData = Awaited<ReturnType<typeof listStocks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStocksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStocks>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStocksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateStockCode = (updateStockCode: UpdateStockCode) => {
  return request<UpdateStockCodeResponse>({
    url: `/stocks`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateStockCode,
  });
};

export const getUpdateStockCodeMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockCode>>,
    TError,
    { data: UpdateStockCode },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockCode>>,
  TError,
  { data: UpdateStockCode },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockCode>>,
    { data: UpdateStockCode }
  > = (props) => {
    const { data } = props ?? {};

    return updateStockCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockCode>>
>;
export type UpdateStockCodeMutationBody = UpdateStockCode;
export type UpdateStockCodeMutationError = ErrorType<HttpError>;

export const useUpdateStockCode = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockCode>>,
    TError,
    { data: UpdateStockCode },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateStockCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createStock = (createStock: CreateStock) => {
  return request<CreateStockResponse>({
    url: `/stocks`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createStock,
  });
};

export const getCreateStockMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStock>>,
    TError,
    { data: CreateStock },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStock>>,
  TError,
  { data: CreateStock },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStock>>,
    { data: CreateStock }
  > = (props) => {
    const { data } = props ?? {};

    return createStock(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStock>>
>;
export type CreateStockMutationBody = CreateStock;
export type CreateStockMutationError = ErrorType<HttpError>;

export const useCreateStock = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStock>>,
    TError,
    { data: CreateStock },
    TContext
  >;
}) => {
  const mutationOptions = getCreateStockMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listStocksRetroactive = (
  params: ListStocksRetroactiveParams,
  signal?: AbortSignal,
) => {
  return request<ListStocksRetroactiveResponse>({
    url: `/stocks/list-stock-retroactive`,
    method: "GET",
    params,
    signal,
  });
};

export const getListStocksRetroactiveQueryKey = (
  params: ListStocksRetroactiveParams,
) => {
  return [
    `/stocks/list-stock-retroactive`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListStocksRetroactiveInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listStocksRetroactive>>,
  TError = ErrorType<HttpError>,
>(
  params: ListStocksRetroactiveParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactive>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStocksRetroactiveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStocksRetroactive>>
  > = ({ signal }) => listStocksRetroactive(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listStocksRetroactive>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStocksRetroactiveInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStocksRetroactive>>
>;
export type ListStocksRetroactiveInfiniteQueryError = ErrorType<HttpError>;

export const useListStocksRetroactiveInfinite = <
  TData = Awaited<ReturnType<typeof listStocksRetroactive>>,
  TError = ErrorType<HttpError>,
>(
  params: ListStocksRetroactiveParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactive>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStocksRetroactiveInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListStocksRetroactiveQueryOptions = <
  TData = Awaited<ReturnType<typeof listStocksRetroactive>>,
  TError = ErrorType<HttpError>,
>(
  params: ListStocksRetroactiveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactive>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStocksRetroactiveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStocksRetroactive>>
  > = ({ signal }) => listStocksRetroactive(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listStocksRetroactive>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStocksRetroactiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStocksRetroactive>>
>;
export type ListStocksRetroactiveQueryError = ErrorType<HttpError>;

export const useListStocksRetroactive = <
  TData = Awaited<ReturnType<typeof listStocksRetroactive>>,
  TError = ErrorType<HttpError>,
>(
  params: ListStocksRetroactiveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStocksRetroactive>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStocksRetroactiveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createPremix = (createPremixStock: CreatePremixStock) => {
  return request<CreatePremixResponse>({
    url: `/stocks/premix`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPremixStock,
  });
};

export const getCreatePremixMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPremix>>,
    TError,
    { data: CreatePremixStock },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPremix>>,
  TError,
  { data: CreatePremixStock },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPremix>>,
    { data: CreatePremixStock }
  > = (props) => {
    const { data } = props ?? {};

    return createPremix(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePremixMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPremix>>
>;
export type CreatePremixMutationBody = CreatePremixStock;
export type CreatePremixMutationError = ErrorType<unknown>;

export const useCreatePremix = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPremix>>,
    TError,
    { data: CreatePremixStock },
    TContext
  >;
}) => {
  const mutationOptions = getCreatePremixMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getStockAverageInfo = (
  getStockAverageInfoBody: GetStockAverageInfoBody,
) => {
  return request<GetStockAverageInfoResponse>({
    url: `/stocks/premix`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: getStockAverageInfoBody,
  });
};

export const getGetStockAverageInfoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getStockAverageInfo>>,
    TError,
    { data: GetStockAverageInfoBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getStockAverageInfo>>,
  TError,
  { data: GetStockAverageInfoBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getStockAverageInfo>>,
    { data: GetStockAverageInfoBody }
  > = (props) => {
    const { data } = props ?? {};

    return getStockAverageInfo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetStockAverageInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof getStockAverageInfo>>
>;
export type GetStockAverageInfoMutationBody = GetStockAverageInfoBody;
export type GetStockAverageInfoMutationError = ErrorType<unknown>;

export const useGetStockAverageInfo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getStockAverageInfo>>,
    TError,
    { data: GetStockAverageInfoBody },
    TContext
  >;
}) => {
  const mutationOptions = getGetStockAverageInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * ### ID string is name, number is ID.
 */
export const getStock = (id: number | string, signal?: AbortSignal) => {
  return request<GetStockResponse>({
    url: `/stocks/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetStockQueryKey = (id: number | string) => {
  return [`/stocks/${id}`] as const;
};

export const getGetStockInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getStock>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getStock>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStock>>> = ({
    signal,
  }) => getStock(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getStock>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStock>>
>;
export type GetStockInfiniteQueryError = ErrorType<unknown>;

export const useGetStockInfinite = <
  TData = Awaited<ReturnType<typeof getStock>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getStock>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetStockQueryOptions = <
  TData = Awaited<ReturnType<typeof getStock>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStock>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStock>>> = ({
    signal,
  }) => getStock(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getStock>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetStockQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStock>>
>;
export type GetStockQueryError = ErrorType<unknown>;

export const useGetStock = <
  TData = Awaited<ReturnType<typeof getStock>>,
  TError = ErrorType<unknown>,
>(
  id: number | string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStock>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ativa ou desativa uma dieta para ser listada no frontend.
 */
export const activateStock = (id: number, params: ActivateStockParams) => {
  return request<ActivateStockResponse>({
    url: `/stocks/${id}/activate`,
    method: "POST",
    params,
  });
};

export const getActivateStockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateStock>>,
    TError,
    { id: number; params: ActivateStockParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateStock>>,
  TError,
  { id: number; params: ActivateStockParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateStock>>,
    { id: number; params: ActivateStockParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return activateStock(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateStockMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateStock>>
>;

export type ActivateStockMutationError = ErrorType<unknown>;

export const useActivateStock = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateStock>>,
    TError,
    { id: number; params: ActivateStockParams },
    TContext
  >;
}) => {
  const mutationOptions = getActivateStockMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updatePremix = (id: number, updatePremix: UpdatePremix) => {
  return request<UpdatePremixResponse>({
    url: `/stocks/${id}/edit-premix`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updatePremix,
  });
};

export const getUpdatePremixMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePremix>>,
    TError,
    { id: number; data: UpdatePremix },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePremix>>,
  TError,
  { id: number; data: UpdatePremix },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePremix>>,
    { id: number; data: UpdatePremix }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePremix(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePremixMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePremix>>
>;
export type UpdatePremixMutationBody = UpdatePremix;
export type UpdatePremixMutationError = ErrorType<HttpError>;

export const useUpdatePremix = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePremix>>,
    TError,
    { id: number; data: UpdatePremix },
    TContext
  >;
}) => {
  const mutationOptions = getUpdatePremixMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateElgOrElm = (id: number, updateElgOrElm: UpdateElgOrElm) => {
  return request<boolean>({
    url: `/stocks/${id}/elg-elm`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateElgOrElm,
  });
};

export const getUpdateElgOrElmMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateElgOrElm>>,
    TError,
    { id: number; data: UpdateElgOrElm },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateElgOrElm>>,
  TError,
  { id: number; data: UpdateElgOrElm },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateElgOrElm>>,
    { id: number; data: UpdateElgOrElm }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateElgOrElm(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateElgOrElmMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateElgOrElm>>
>;
export type UpdateElgOrElmMutationBody = UpdateElgOrElm;
export type UpdateElgOrElmMutationError = ErrorType<HttpError>;

export const useUpdateElgOrElm = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateElgOrElm>>,
    TError,
    { id: number; data: UpdateElgOrElm },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateElgOrElmMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateStockNmFactor = (
  id: number,
  updateStockNmFactorBody: number,
) => {
  return request<boolean>({
    url: `/stocks/${id}/nm-factor`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateStockNmFactorBody,
  });
};

export const getUpdateStockNmFactorMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockNmFactor>>,
    TError,
    { id: number; data: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockNmFactor>>,
  TError,
  { id: number; data: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockNmFactor>>,
    { id: number; data: number }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStockNmFactor(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockNmFactorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockNmFactor>>
>;
export type UpdateStockNmFactorMutationBody = number;
export type UpdateStockNmFactorMutationError = ErrorType<HttpError>;

export const useUpdateStockNmFactor = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockNmFactor>>,
    TError,
    { id: number; data: number },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateStockNmFactorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const receiveStockPurchase = (
  id: number,
  receiveStockPurchaseBody: ReceiveStockPurchaseBody,
) => {
  return request<boolean>({
    url: `/stocks/${id}/receive`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: receiveStockPurchaseBody,
  });
};

export const getReceiveStockPurchaseMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveStockPurchase>>,
    TError,
    { id: number; data: ReceiveStockPurchaseBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiveStockPurchase>>,
  TError,
  { id: number; data: ReceiveStockPurchaseBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiveStockPurchase>>,
    { id: number; data: ReceiveStockPurchaseBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return receiveStockPurchase(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiveStockPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiveStockPurchase>>
>;
export type ReceiveStockPurchaseMutationBody = ReceiveStockPurchaseBody;
export type ReceiveStockPurchaseMutationError = ErrorType<HttpError>;

export const useReceiveStockPurchase = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveStockPurchase>>,
    TError,
    { id: number; data: ReceiveStockPurchaseBody },
    TContext
  >;
}) => {
  const mutationOptions = getReceiveStockPurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const receiveStock = (id: number, params: ReceiveStockParams) => {
  return request<ReceiveStockResponse>({
    url: `/stocks/${id}/receive`,
    method: "PUT",
    params,
  });
};

export const getReceiveStockMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveStock>>,
    TError,
    { id: number; params: ReceiveStockParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiveStock>>,
  TError,
  { id: number; params: ReceiveStockParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiveStock>>,
    { id: number; params: ReceiveStockParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return receiveStock(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiveStockMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiveStock>>
>;

export type ReceiveStockMutationError = ErrorType<HttpError>;

export const useReceiveStock = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveStock>>,
    TError,
    { id: number; params: ReceiveStockParams },
    TContext
  >;
}) => {
  const mutationOptions = getReceiveStockMutationOptions(options);

  return useMutation(mutationOptions);
};

export const receivePremix = (
  id: number,
  receivePremixBody: ReceivePremixBody,
) => {
  return request<ReceivePremixResponse>({
    url: `/stocks/${id}/receive-premix`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: receivePremixBody,
  });
};

export const getReceivePremixMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receivePremix>>,
    TError,
    { id: number; data: ReceivePremixBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receivePremix>>,
  TError,
  { id: number; data: ReceivePremixBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receivePremix>>,
    { id: number; data: ReceivePremixBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return receivePremix(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceivePremixMutationResult = NonNullable<
  Awaited<ReturnType<typeof receivePremix>>
>;
export type ReceivePremixMutationBody = ReceivePremixBody;
export type ReceivePremixMutationError = ErrorType<unknown>;

export const useReceivePremix = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receivePremix>>,
    TError,
    { id: number; data: ReceivePremixBody },
    TContext
  >;
}) => {
  const mutationOptions = getReceivePremixMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeStock = (id: number, params: RemoveStockParams) => {
  return request<RemoveStockResponse>({
    url: `/stocks/${id}/remove`,
    method: "DELETE",
    params,
  });
};

export const getRemoveStockMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStock>>,
    TError,
    { id: number; params: RemoveStockParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeStock>>,
  TError,
  { id: number; params: RemoveStockParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeStock>>,
    { id: number; params: RemoveStockParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return removeStock(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveStockMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeStock>>
>;

export type RemoveStockMutationError = ErrorType<HttpError>;

export const useRemoveStock = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStock>>,
    TError,
    { id: number; params: RemoveStockParams },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveStockMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Zera o estoque de um insumo: remove todas as movimentações (entradas e saídas) e todos os pedidos de compra
vinculados, junto com suas notas fiscais. O histórico de preço/fator de matéria seca (StockChange) é preservado para
não quebrar cálculos de dietas e relatórios históricos.
 */
export const resetStock = (id: number) => {
  return request<ResetStockResponse>({
    url: `/stocks/${id}/reset`,
    method: "POST",
  });
};

export const getResetStockMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetStock>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetStock>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetStock>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return resetStock(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetStockMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetStock>>
>;

export type ResetStockMutationError = ErrorType<HttpError>;

export const useResetStock = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetStock>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getResetStockMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Linha do tempo do alimento: preço e saldo de cada dia do intervalo.
 */
export const getStockTimeline = (
  id: number,
  params?: GetStockTimelineParams,
  signal?: AbortSignal,
) => {
  return request<GetStockTimelineResponse>({
    url: `/stocks/${id}/timeline`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStockTimelineQueryKey = (
  id: number,
  params?: GetStockTimelineParams,
) => {
  return [`/stocks/${id}/timeline`, ...(params ? [params] : [])] as const;
};

export const getGetStockTimelineInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockTimeline>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetStockTimelineParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getStockTimeline>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockTimelineQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockTimeline>>
  > = ({ signal }) => getStockTimeline(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getStockTimeline>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockTimelineInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockTimeline>>
>;
export type GetStockTimelineInfiniteQueryError = ErrorType<HttpError>;

export const useGetStockTimelineInfinite = <
  TData = Awaited<ReturnType<typeof getStockTimeline>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetStockTimelineParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getStockTimeline>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockTimelineInfiniteQueryOptions(
    id,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetStockTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockTimeline>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetStockTimelineParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockTimeline>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockTimelineQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockTimeline>>
  > = ({ signal }) => getStockTimeline(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockTimeline>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockTimelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockTimeline>>
>;
export type GetStockTimelineQueryError = ErrorType<HttpError>;

export const useGetStockTimeline = <
  TData = Awaited<ReturnType<typeof getStockTimeline>>,
  TError = ErrorType<HttpError>,
>(
  id: number,
  params?: GetStockTimelineParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockTimeline>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockTimelineQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Corrige a linha do tempo do alimento. Cada entrada informada vira uma alteração de preço e/ou uma movimentação de
ajuste de saldo naquela data.
 */
export const updateStockTimeline = (
  id: number,
  updateStockTimeline: UpdateStockTimeline,
) => {
  return request<boolean>({
    url: `/stocks/${id}/timeline`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateStockTimeline,
  });
};

export const getUpdateStockTimelineMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockTimeline>>,
    TError,
    { id: number; data: UpdateStockTimeline },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockTimeline>>,
  TError,
  { id: number; data: UpdateStockTimeline },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockTimeline>>,
    { id: number; data: UpdateStockTimeline }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStockTimeline(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockTimelineMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockTimeline>>
>;
export type UpdateStockTimelineMutationBody = UpdateStockTimeline;
export type UpdateStockTimelineMutationError = ErrorType<HttpError>;

export const useUpdateStockTimeline = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockTimeline>>,
    TError,
    { id: number; data: UpdateStockTimeline },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateStockTimelineMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listStructures = (signal?: AbortSignal) => {
  return request<ListStructuresResponse>({
    url: `/structures`,
    method: "GET",
    signal,
  });
};

export const getListStructuresQueryKey = () => {
  return [`/structures`] as const;
};

export const getListStructuresInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listStructures>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStructuresQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStructures>>> = ({
    signal,
  }) => listStructures(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listStructures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStructuresInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStructures>>
>;
export type ListStructuresInfiniteQueryError = ErrorType<unknown>;

export const useListStructuresInfinite = <
  TData = Awaited<ReturnType<typeof listStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listStructures>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStructuresInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListStructuresQueryOptions = <
  TData = Awaited<ReturnType<typeof listStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listStructures>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStructuresQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStructures>>> = ({
    signal,
  }) => listStructures(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listStructures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStructuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStructures>>
>;
export type ListStructuresQueryError = ErrorType<unknown>;

export const useListStructures = <
  TData = Awaited<ReturnType<typeof listStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listStructures>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListStructuresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createStructure = (createStructure: CreateStructure) => {
  return request<CreateStructureResponse>({
    url: `/structures`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createStructure,
  });
};

export const getCreateStructureMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStructure>>,
    TError,
    { data: CreateStructure },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStructure>>,
  TError,
  { data: CreateStructure },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStructure>>,
    { data: CreateStructure }
  > = (props) => {
    const { data } = props ?? {};

    return createStructure(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStructure>>
>;
export type CreateStructureMutationBody = CreateStructure;
export type CreateStructureMutationError = ErrorType<HttpError>;

export const useCreateStructure = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStructure>>,
    TError,
    { data: CreateStructure },
    TContext
  >;
}) => {
  const mutationOptions = getCreateStructureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateStructure = (
  id: number,
  updateStructure: UpdateStructure,
) => {
  return request<UpdateStructureResponse>({
    url: `/structures/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateStructure,
  });
};

export const getUpdateStructureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStructure>>,
    TError,
    { id: number; data: UpdateStructure },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStructure>>,
  TError,
  { id: number; data: UpdateStructure },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStructure>>,
    { id: number; data: UpdateStructure }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStructure(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStructure>>
>;
export type UpdateStructureMutationBody = UpdateStructure;
export type UpdateStructureMutationError = ErrorType<unknown>;

export const useUpdateStructure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStructure>>,
    TError,
    { id: number; data: UpdateStructure },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateStructureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTracerStatus = (signal?: AbortSignal) => {
  return request<boolean>({ url: `/tracer/service`, method: "GET", signal });
};

export const getGetTracerStatusQueryKey = () => {
  return [`/tracer/service`] as const;
};

export const getGetTracerStatusInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracerStatus>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTracerStatus>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracerStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracerStatus>>> = ({
    signal,
  }) => getTracerStatus(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTracerStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTracerStatusInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTracerStatus>>
>;
export type GetTracerStatusInfiniteQueryError = ErrorType<HttpError>;

export const useGetTracerStatusInfinite = <
  TData = Awaited<ReturnType<typeof getTracerStatus>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTracerStatus>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTracerStatusInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetTracerStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracerStatus>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTracerStatus>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracerStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracerStatus>>> = ({
    signal,
  }) => getTracerStatus(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTracerStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTracerStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTracerStatus>>
>;
export type GetTracerStatusQueryError = ErrorType<HttpError>;

export const useGetTracerStatus = <
  TData = Awaited<ReturnType<typeof getTracerStatus>>,
  TError = ErrorType<HttpError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTracerStatus>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTracerStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const startTracer = (params: StartTracerParams) => {
  return request<boolean>({ url: `/tracer/service`, method: "POST", params });
};

export const getStartTracerMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startTracer>>,
    TError,
    { params: StartTracerParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startTracer>>,
  TError,
  { params: StartTracerParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startTracer>>,
    { params: StartTracerParams }
  > = (props) => {
    const { params } = props ?? {};

    return startTracer(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartTracerMutationResult = NonNullable<
  Awaited<ReturnType<typeof startTracer>>
>;

export type StartTracerMutationError = ErrorType<HttpError>;

export const useStartTracer = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startTracer>>,
    TError,
    { params: StartTracerParams },
    TContext
  >;
}) => {
  const mutationOptions = getStartTracerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const stopTracer = () => {
  return request<boolean>({ url: `/tracer/service`, method: "PUT" });
};

export const getStopTracerMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopTracer>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stopTracer>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stopTracer>>,
    void
  > = () => {
    return stopTracer();
  };

  return { mutationFn, ...mutationOptions };
};

export type StopTracerMutationResult = NonNullable<
  Awaited<ReturnType<typeof stopTracer>>
>;

export type StopTracerMutationError = ErrorType<HttpError>;

export const useStopTracer = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopTracer>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getStopTracerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listTreatments = (
  params?: ListTreatmentsParams,
  signal?: AbortSignal,
) => {
  return request<ListTreatmentsResponse>({
    url: `/treatments`,
    method: "GET",
    params,
    signal,
  });
};

export const getListTreatmentsQueryKey = (params?: ListTreatmentsParams) => {
  return [`/treatments`, ...(params ? [params] : [])] as const;
};

export const getListTreatmentsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listTreatments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTreatmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listTreatments>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTreatmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTreatments>>> = ({
    signal,
  }) => listTreatments(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listTreatments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTreatmentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTreatments>>
>;
export type ListTreatmentsInfiniteQueryError = ErrorType<unknown>;

export const useListTreatmentsInfinite = <
  TData = Awaited<ReturnType<typeof listTreatments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTreatmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listTreatments>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListTreatmentsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListTreatmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTreatments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTreatmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTreatments>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTreatmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTreatments>>> = ({
    signal,
  }) => listTreatments(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTreatments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTreatmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTreatments>>
>;
export type ListTreatmentsQueryError = ErrorType<unknown>;

export const useListTreatments = <
  TData = Awaited<ReturnType<typeof listTreatments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTreatmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTreatments>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListTreatmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createTreatment = (createTreatment: CreateTreatment) => {
  return request<CreateTreatmentResponse>({
    url: `/treatments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTreatment,
  });
};

export const getCreateTreatmentMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTreatment>>,
    TError,
    { data: CreateTreatment },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTreatment>>,
  TError,
  { data: CreateTreatment },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTreatment>>,
    { data: CreateTreatment }
  > = (props) => {
    const { data } = props ?? {};

    return createTreatment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTreatment>>
>;
export type CreateTreatmentMutationBody = CreateTreatment;
export type CreateTreatmentMutationError = ErrorType<HttpError>;

export const useCreateTreatment = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTreatment>>,
    TError,
    { data: CreateTreatment },
    TContext
  >;
}) => {
  const mutationOptions = getCreateTreatmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const changeTreatment = (changeTreatment: ChangeTreatment) => {
  return request<ChangeTreatmentResponse>({
    url: `/treatments/change`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: changeTreatment,
  });
};

export const getChangeTreatmentMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeTreatment>>,
    TError,
    { data: ChangeTreatment },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeTreatment>>,
  TError,
  { data: ChangeTreatment },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeTreatment>>,
    { data: ChangeTreatment }
  > = (props) => {
    const { data } = props ?? {};

    return changeTreatment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeTreatment>>
>;
export type ChangeTreatmentMutationBody = ChangeTreatment;
export type ChangeTreatmentMutationError = ErrorType<HttpError>;

export const useChangeTreatment = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeTreatment>>,
    TError,
    { data: ChangeTreatment },
    TContext
  >;
}) => {
  const mutationOptions = getChangeTreatmentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Automação: edita um trato no log de tratos. Aceita dia anterior — o trato editado é sempre o do dia selecionado, e o
previsto dos dias seguintes não é recalculado.
 */
export const updateTreatRealized = (
  id: number,
  updateTreatRealizedDto: UpdateTreatRealizedDto,
) => {
  return request<UpdateTreatRealizedResponse>({
    url: `/treatments/realized/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateTreatRealizedDto,
  });
};

export const getUpdateTreatRealizedMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreatRealized>>,
    TError,
    { id: number; data: UpdateTreatRealizedDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTreatRealized>>,
  TError,
  { id: number; data: UpdateTreatRealizedDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTreatRealized>>,
    { id: number; data: UpdateTreatRealizedDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTreatRealized(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTreatRealizedMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTreatRealized>>
>;
export type UpdateTreatRealizedMutationBody = UpdateTreatRealizedDto;
export type UpdateTreatRealizedMutationError = ErrorType<HttpError>;

export const useUpdateTreatRealized = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreatRealized>>,
    TError,
    { id: number; data: UpdateTreatRealizedDto },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateTreatRealizedMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Ativa ou desativa uma dieta para ser listada no frontend.
 */
export const activateTreatment = (
  id: number,
  params: ActivateTreatmentParams,
) => {
  return request<ActivateTreatmentResponse>({
    url: `/treatments/${id}/active`,
    method: "POST",
    params,
  });
};

export const getActivateTreatmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateTreatment>>,
    TError,
    { id: number; params: ActivateTreatmentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateTreatment>>,
  TError,
  { id: number; params: ActivateTreatmentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateTreatment>>,
    { id: number; params: ActivateTreatmentParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return activateTreatment(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateTreatment>>
>;

export type ActivateTreatmentMutationError = ErrorType<unknown>;

export const useActivateTreatment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateTreatment>>,
    TError,
    { id: number; params: ActivateTreatmentParams },
    TContext
  >;
}) => {
  const mutationOptions = getActivateTreatmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTreatmentPlan = (id: number) => {
  return request<boolean>({
    url: `/treatments/${id}/delete`,
    method: "DELETE",
  });
};

export const getDeleteTreatmentPlanMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTreatmentPlan>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTreatmentPlan>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTreatmentPlan>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTreatmentPlan(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTreatmentPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTreatmentPlan>>
>;

export type DeleteTreatmentPlanMutationError = ErrorType<HttpError>;

export const useDeleteTreatmentPlan = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTreatmentPlan>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteTreatmentPlanMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateTreatmentPlan = (
  id: number,
  updateTreatmentPlanBody: UpdateTreatmentPlanBody,
) => {
  return request<boolean>({
    url: `/treatments/${id}/update`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateTreatmentPlanBody,
  });
};

export const getUpdateTreatmentPlanMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreatmentPlan>>,
    TError,
    { id: number; data: UpdateTreatmentPlanBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTreatmentPlan>>,
  TError,
  { id: number; data: UpdateTreatmentPlanBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTreatmentPlan>>,
    { id: number; data: UpdateTreatmentPlanBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTreatmentPlan(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTreatmentPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTreatmentPlan>>
>;
export type UpdateTreatmentPlanMutationBody = UpdateTreatmentPlanBody;
export type UpdateTreatmentPlanMutationError = ErrorType<HttpError>;

export const useUpdateTreatmentPlan = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreatmentPlan>>,
    TError,
    { id: number; data: UpdateTreatmentPlanBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateTreatmentPlanMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTreatConclusion = (
  treatConclusionBody: TreatConclusionBody,
) => {
  return request<boolean>({
    url: `/treats/conclusion`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: treatConclusionBody,
  });
};

export const getDeleteTreatConclusionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTreatConclusion>>,
    TError,
    { data: TreatConclusionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTreatConclusion>>,
  TError,
  { data: TreatConclusionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTreatConclusion>>,
    { data: TreatConclusionBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteTreatConclusion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTreatConclusionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTreatConclusion>>
>;
export type DeleteTreatConclusionMutationBody = TreatConclusionBody;
export type DeleteTreatConclusionMutationError = ErrorType<unknown>;

export const useDeleteTreatConclusion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTreatConclusion>>,
    TError,
    { data: TreatConclusionBody },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteTreatConclusionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const treatConclusion = (treatConclusionBody: TreatConclusionBody) => {
  return request<boolean>({
    url: `/treats/conclusion`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: treatConclusionBody,
  });
};

export const getTreatConclusionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof treatConclusion>>,
    TError,
    { data: TreatConclusionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof treatConclusion>>,
  TError,
  { data: TreatConclusionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof treatConclusion>>,
    { data: TreatConclusionBody }
  > = (props) => {
    const { data } = props ?? {};

    return treatConclusion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TreatConclusionMutationResult = NonNullable<
  Awaited<ReturnType<typeof treatConclusion>>
>;
export type TreatConclusionMutationBody = TreatConclusionBody;
export type TreatConclusionMutationError = ErrorType<unknown>;

export const useTreatConclusion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof treatConclusion>>,
    TError,
    { data: TreatConclusionBody },
    TContext
  >;
}) => {
  const mutationOptions = getTreatConclusionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const treatConclusionByHour = (
  treatConclusionByHourBody: TreatConclusionByHourBody,
) => {
  return request<TreatConclusionByHourResponse>({
    url: `/treats/conclusion-by-hour`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: treatConclusionByHourBody,
  });
};

export const getTreatConclusionByHourMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof treatConclusionByHour>>,
    TError,
    { data: TreatConclusionByHourBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof treatConclusionByHour>>,
  TError,
  { data: TreatConclusionByHourBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof treatConclusionByHour>>,
    { data: TreatConclusionByHourBody }
  > = (props) => {
    const { data } = props ?? {};

    return treatConclusionByHour(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TreatConclusionByHourMutationResult = NonNullable<
  Awaited<ReturnType<typeof treatConclusionByHour>>
>;
export type TreatConclusionByHourMutationBody = TreatConclusionByHourBody;
export type TreatConclusionByHourMutationError = ErrorType<HttpError>;

export const useTreatConclusionByHour = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof treatConclusionByHour>>,
    TError,
    { data: TreatConclusionByHourBody },
    TContext
  >;
}) => {
  const mutationOptions = getTreatConclusionByHourMutationOptions(options);

  return useMutation(mutationOptions);
};

export const treatConclusionByOrder = (
  treatConclusionByOrderBody: TreatConclusionByOrderBody,
) => {
  return request<TreatConclusionByOrderResponse>({
    url: `/treats/conclusion-by-order`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: treatConclusionByOrderBody,
  });
};

export const getTreatConclusionByOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof treatConclusionByOrder>>,
    TError,
    { data: TreatConclusionByOrderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof treatConclusionByOrder>>,
  TError,
  { data: TreatConclusionByOrderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof treatConclusionByOrder>>,
    { data: TreatConclusionByOrderBody }
  > = (props) => {
    const { data } = props ?? {};

    return treatConclusionByOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TreatConclusionByOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof treatConclusionByOrder>>
>;
export type TreatConclusionByOrderMutationBody = TreatConclusionByOrderBody;
export type TreatConclusionByOrderMutationError = ErrorType<HttpError>;

export const useTreatConclusionByOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof treatConclusionByOrder>>,
    TError,
    { data: TreatConclusionByOrderBody },
    TContext
  >;
}) => {
  const mutationOptions = getTreatConclusionByOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeDuplicatedTreats = (
  params: RemoveDuplicatedTreatsParams,
) => {
  return request<boolean>({
    url: `/treats/duplicates`,
    method: "DELETE",
    params,
  });
};

export const getRemoveDuplicatedTreatsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeDuplicatedTreats>>,
    TError,
    { params: RemoveDuplicatedTreatsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeDuplicatedTreats>>,
  TError,
  { params: RemoveDuplicatedTreatsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeDuplicatedTreats>>,
    { params: RemoveDuplicatedTreatsParams }
  > = (props) => {
    const { params } = props ?? {};

    return removeDuplicatedTreats(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveDuplicatedTreatsMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeDuplicatedTreats>>
>;

export type RemoveDuplicatedTreatsMutationError = ErrorType<unknown>;

export const useRemoveDuplicatedTreats = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeDuplicatedTreats>>,
    TError,
    { params: RemoveDuplicatedTreatsParams },
    TContext
  >;
}) => {
  const mutationOptions = getRemoveDuplicatedTreatsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const replaceFeederByBatchTreatOrder = (
  replaceFeederBody: ReplaceFeederBody,
) => {
  return request<PrismaBatchPayload>({
    url: `/treats/replace-feeder-by-batch-treat-order`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: replaceFeederBody,
  });
};

export const getReplaceFeederByBatchTreatOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceFeederByBatchTreatOrder>>,
    TError,
    { data: ReplaceFeederBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceFeederByBatchTreatOrder>>,
  TError,
  { data: ReplaceFeederBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceFeederByBatchTreatOrder>>,
    { data: ReplaceFeederBody }
  > = (props) => {
    const { data } = props ?? {};

    return replaceFeederByBatchTreatOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceFeederByBatchTreatOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceFeederByBatchTreatOrder>>
>;
export type ReplaceFeederByBatchTreatOrderMutationBody = ReplaceFeederBody;
export type ReplaceFeederByBatchTreatOrderMutationError = ErrorType<HttpError>;

export const useReplaceFeederByBatchTreatOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceFeederByBatchTreatOrder>>,
    TError,
    { data: ReplaceFeederBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getReplaceFeederByBatchTreatOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const submitTreat = (submitTreat: SubmitTreat[]) => {
  return request<SubmitTreatResponse>({
    url: `/treats/treat`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitTreat,
  });
};

export const getSubmitTreatMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitTreat>>,
    TError,
    { data: SubmitTreat[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitTreat>>,
  TError,
  { data: SubmitTreat[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitTreat>>,
    { data: SubmitTreat[] }
  > = (props) => {
    const { data } = props ?? {};

    return submitTreat(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitTreatMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitTreat>>
>;
export type SubmitTreatMutationBody = SubmitTreat[];
export type SubmitTreatMutationError = ErrorType<unknown>;

export const useSubmitTreat = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitTreat>>,
    TError,
    { data: SubmitTreat[] },
    TContext
  >;
}) => {
  const mutationOptions = getSubmitTreatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const manageTreatsConclusion = (
  manageTreatsConclusionBodyItem: ManageTreatsConclusionBodyItem[],
) => {
  return request<boolean>({
    url: `/treats/treat`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: manageTreatsConclusionBodyItem,
  });
};

export const getManageTreatsConclusionMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof manageTreatsConclusion>>,
    TError,
    { data: ManageTreatsConclusionBodyItem[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof manageTreatsConclusion>>,
  TError,
  { data: ManageTreatsConclusionBodyItem[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof manageTreatsConclusion>>,
    { data: ManageTreatsConclusionBodyItem[] }
  > = (props) => {
    const { data } = props ?? {};

    return manageTreatsConclusion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManageTreatsConclusionMutationResult = NonNullable<
  Awaited<ReturnType<typeof manageTreatsConclusion>>
>;
export type ManageTreatsConclusionMutationBody =
  ManageTreatsConclusionBodyItem[];
export type ManageTreatsConclusionMutationError = ErrorType<HttpError>;

export const useManageTreatsConclusion = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof manageTreatsConclusion>>,
    TError,
    { data: ManageTreatsConclusionBodyItem[] },
    TContext
  >;
}) => {
  const mutationOptions = getManageTreatsConclusionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTreatRealized = (id: number) => {
  return request<boolean>({ url: `/treats/${id}`, method: "DELETE" });
};

export const getDeleteTreatRealizedMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTreatRealized>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTreatRealized>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTreatRealized>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTreatRealized(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTreatRealizedMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTreatRealized>>
>;

export type DeleteTreatRealizedMutationError = ErrorType<HttpError>;

export const useDeleteTreatRealized = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTreatRealized>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteTreatRealizedMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateTreat = (id: number, updateTreat: UpdateTreat) => {
  return request<UpdateTreatResponse>({
    url: `/treats/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateTreat,
  });
};

export const getUpdateTreatMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreat>>,
    TError,
    { id: number; data: UpdateTreat },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTreat>>,
  TError,
  { id: number; data: UpdateTreat },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTreat>>,
    { id: number; data: UpdateTreat }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTreat(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTreatMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTreat>>
>;
export type UpdateTreatMutationBody = UpdateTreat;
export type UpdateTreatMutationError = ErrorType<unknown>;

export const useUpdateTreat = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreat>>,
    TError,
    { id: number; data: UpdateTreat },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateTreatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const transferTreatRealized = (
  id: number,
  transferTreatRealizedBody: TransferTreatRealizedBody,
) => {
  return request<boolean>({
    url: `/treats/${id}/transfer-treat-realized`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: transferTreatRealizedBody,
  });
};

export const getTransferTreatRealizedMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferTreatRealized>>,
    TError,
    { id: number; data: TransferTreatRealizedBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferTreatRealized>>,
  TError,
  { id: number; data: TransferTreatRealizedBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferTreatRealized>>,
    { id: number; data: TransferTreatRealizedBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return transferTreatRealized(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferTreatRealizedMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferTreatRealized>>
>;
export type TransferTreatRealizedMutationBody = TransferTreatRealizedBody;
export type TransferTreatRealizedMutationError = ErrorType<HttpError>;

export const useTransferTreatRealized = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferTreatRealized>>,
    TError,
    { id: number; data: TransferTreatRealizedBody },
    TContext
  >;
}) => {
  const mutationOptions = getTransferTreatRealizedMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportFeedData = (
  params: ExportFeedDataParams,
  signal?: AbortSignal,
) => {
  return request<ExportFeedDataResponse>({
    url: `/utils/backup`,
    method: "GET",
    params,
    signal,
  });
};

export const getExportFeedDataQueryKey = (params: ExportFeedDataParams) => {
  return [`/utils/backup`, ...(params ? [params] : [])] as const;
};

export const getExportFeedDataInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof exportFeedData>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportFeedDataParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof exportFeedData>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportFeedDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportFeedData>>> = ({
    signal,
  }) => exportFeedData(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof exportFeedData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportFeedDataInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportFeedData>>
>;
export type ExportFeedDataInfiniteQueryError = ErrorType<HttpError>;

export const useExportFeedDataInfinite = <
  TData = Awaited<ReturnType<typeof exportFeedData>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportFeedDataParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof exportFeedData>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getExportFeedDataInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getExportFeedDataQueryOptions = <
  TData = Awaited<ReturnType<typeof exportFeedData>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportFeedDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportFeedData>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportFeedDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportFeedData>>> = ({
    signal,
  }) => exportFeedData(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportFeedData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportFeedDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportFeedData>>
>;
export type ExportFeedDataQueryError = ErrorType<HttpError>;

export const useExportFeedData = <
  TData = Awaited<ReturnType<typeof exportFeedData>>,
  TError = ErrorType<HttpError>,
>(
  params: ExportFeedDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportFeedData>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getExportFeedDataQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const restoreFeedData = (restoreFeedDataBody: RestoreFeedDataBody) => {
  return request<boolean>({
    url: `/utils/backup`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: restoreFeedDataBody,
  });
};

export const getRestoreFeedDataMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreFeedData>>,
    TError,
    { data: RestoreFeedDataBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreFeedData>>,
  TError,
  { data: RestoreFeedDataBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreFeedData>>,
    { data: RestoreFeedDataBody }
  > = (props) => {
    const { data } = props ?? {};

    return restoreFeedData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreFeedDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreFeedData>>
>;
export type RestoreFeedDataMutationBody = RestoreFeedDataBody;
export type RestoreFeedDataMutationError = ErrorType<HttpError>;

export const useRestoreFeedData = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreFeedData>>,
    TError,
    { data: RestoreFeedDataBody },
    TContext
  >;
}) => {
  const mutationOptions = getRestoreFeedDataMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createBackupData = (
  createBackupDataBody: CreateBackupDataBody,
) => {
  return request<CreateBackupDataResponse>({
    url: `/utils/backup-s3`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createBackupDataBody,
  });
};

export const getCreateBackupDataMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBackupData>>,
    TError,
    { data: CreateBackupDataBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBackupData>>,
  TError,
  { data: CreateBackupDataBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBackupData>>,
    { data: CreateBackupDataBody }
  > = (props) => {
    const { data } = props ?? {};

    return createBackupData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBackupDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBackupData>>
>;
export type CreateBackupDataMutationBody = CreateBackupDataBody;
export type CreateBackupDataMutationError = ErrorType<HttpError>;

export const useCreateBackupData = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBackupData>>,
    TError,
    { data: CreateBackupDataBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateBackupDataMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listSavedBackups = (
  params: ListSavedBackupsParams,
  signal?: AbortSignal,
) => {
  return request<ListSavedBackupsResponse>({
    url: `/utils/backup-s3/bucket`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSavedBackupsQueryKey = (params: ListSavedBackupsParams) => {
  return [`/utils/backup-s3/bucket`, ...(params ? [params] : [])] as const;
};

export const getListSavedBackupsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listSavedBackups>>,
  TError = ErrorType<HttpError>,
>(
  params: ListSavedBackupsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSavedBackups>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSavedBackupsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSavedBackups>>
  > = ({ signal }) => listSavedBackups(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listSavedBackups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSavedBackupsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSavedBackups>>
>;
export type ListSavedBackupsInfiniteQueryError = ErrorType<HttpError>;

export const useListSavedBackupsInfinite = <
  TData = Awaited<ReturnType<typeof listSavedBackups>>,
  TError = ErrorType<HttpError>,
>(
  params: ListSavedBackupsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listSavedBackups>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSavedBackupsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListSavedBackupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSavedBackups>>,
  TError = ErrorType<HttpError>,
>(
  params: ListSavedBackupsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSavedBackups>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSavedBackupsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSavedBackups>>
  > = ({ signal }) => listSavedBackups(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSavedBackups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSavedBackupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSavedBackups>>
>;
export type ListSavedBackupsQueryError = ErrorType<HttpError>;

export const useListSavedBackups = <
  TData = Awaited<ReturnType<typeof listSavedBackups>>,
  TError = ErrorType<HttpError>,
>(
  params: ListSavedBackupsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSavedBackups>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListSavedBackupsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackupExportProgress = (signal?: AbortSignal) => {
  return request<BackupExportProgress>({
    url: `/utils/backup/progress`,
    method: "GET",
    signal,
  });
};

export const getGetBackupExportProgressQueryKey = () => {
  return [`/utils/backup/progress`] as const;
};

export const getGetBackupExportProgressInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackupExportProgress>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBackupExportProgress>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackupExportProgressQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackupExportProgress>>
  > = ({ signal }) => getBackupExportProgress(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBackupExportProgress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackupExportProgressInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackupExportProgress>>
>;
export type GetBackupExportProgressInfiniteQueryError = ErrorType<unknown>;

export const useGetBackupExportProgressInfinite = <
  TData = Awaited<ReturnType<typeof getBackupExportProgress>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBackupExportProgress>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackupExportProgressInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetBackupExportProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackupExportProgress>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackupExportProgress>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackupExportProgressQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackupExportProgress>>
  > = ({ signal }) => getBackupExportProgress(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackupExportProgress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackupExportProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackupExportProgress>>
>;
export type GetBackupExportProgressQueryError = ErrorType<unknown>;

export const useGetBackupExportProgress = <
  TData = Awaited<ReturnType<typeof getBackupExportProgress>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackupExportProgress>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackupExportProgressQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const importMassiveAnimals = (
  importMassiveAnimalsBody: ImportMassiveAnimalsBody,
) => {
  return request<ImportMassiveAnimalsResponse>({
    url: `/utils/import-massive-animals`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importMassiveAnimalsBody,
  });
};

export const getImportMassiveAnimalsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importMassiveAnimals>>,
    TError,
    { data: ImportMassiveAnimalsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importMassiveAnimals>>,
  TError,
  { data: ImportMassiveAnimalsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importMassiveAnimals>>,
    { data: ImportMassiveAnimalsBody }
  > = (props) => {
    const { data } = props ?? {};

    return importMassiveAnimals(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportMassiveAnimalsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importMassiveAnimals>>
>;
export type ImportMassiveAnimalsMutationBody = ImportMassiveAnimalsBody;
export type ImportMassiveAnimalsMutationError = ErrorType<unknown>;

export const useImportMassiveAnimals = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importMassiveAnimals>>,
    TError,
    { data: ImportMassiveAnimalsBody },
    TContext
  >;
}) => {
  const mutationOptions = getImportMassiveAnimalsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listBNDs = (params?: ListBNDsParams, signal?: AbortSignal) => {
  return request<ListBNDsResponse>({
    url: `/utils/submit/bnd`,
    method: "GET",
    params,
    signal,
  });
};

export const getListBNDsQueryKey = (params?: ListBNDsParams) => {
  return [`/utils/submit/bnd`, ...(params ? [params] : [])] as const;
};

export const getListBNDsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listBNDs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBNDsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBNDs>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBNDsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBNDs>>> = ({
    signal,
  }) => listBNDs(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listBNDs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBNDsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBNDs>>
>;
export type ListBNDsInfiniteQueryError = ErrorType<unknown>;

export const useListBNDsInfinite = <
  TData = Awaited<ReturnType<typeof listBNDs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBNDsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listBNDs>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBNDsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListBNDsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBNDs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBNDsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBNDs>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBNDsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBNDs>>> = ({
    signal,
  }) => listBNDs(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listBNDs>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListBNDsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBNDs>>
>;
export type ListBNDsQueryError = ErrorType<unknown>;

export const useListBNDs = <
  TData = Awaited<ReturnType<typeof listBNDs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBNDsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBNDs>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListBNDsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const submitBnd = (submitBndBody: SubmitBndBody) => {
  return request<boolean>({
    url: `/utils/submit/bnd`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitBndBody,
  });
};

export const getSubmitBndMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitBnd>>,
    TError,
    { data: SubmitBndBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitBnd>>,
  TError,
  { data: SubmitBndBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitBnd>>,
    { data: SubmitBndBody }
  > = (props) => {
    const { data } = props ?? {};

    return submitBnd(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitBndMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitBnd>>
>;
export type SubmitBndMutationBody = SubmitBndBody;
export type SubmitBndMutationError = ErrorType<HttpError>;

export const useSubmitBnd = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitBnd>>,
    TError,
    { data: SubmitBndBody },
    TContext
  >;
}) => {
  const mutationOptions = getSubmitBndMutationOptions(options);

  return useMutation(mutationOptions);
};

export const bndAgreement = (bndAgreementBody: BndAgreementBody) => {
  return request<boolean>({
    url: `/utils/submit/bnd/agreement`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bndAgreementBody,
  });
};

export const getBndAgreementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bndAgreement>>,
    TError,
    { data: BndAgreementBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bndAgreement>>,
  TError,
  { data: BndAgreementBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bndAgreement>>,
    { data: BndAgreementBody }
  > = (props) => {
    const { data } = props ?? {};

    return bndAgreement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BndAgreementMutationResult = NonNullable<
  Awaited<ReturnType<typeof bndAgreement>>
>;
export type BndAgreementMutationBody = BndAgreementBody;
export type BndAgreementMutationError = ErrorType<HttpError>;

export const useBndAgreement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bndAgreement>>,
    TError,
    { data: BndAgreementBody },
    TContext
  >;
}) => {
  const mutationOptions = getBndAgreementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const bndDesagreement = (bndDesagreementBody: BndDesagreementBody) => {
  return request<boolean>({
    url: `/utils/submit/bnd/desagreement`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: bndDesagreementBody,
  });
};

export const getBndDesagreementMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bndDesagreement>>,
    TError,
    { data: BndDesagreementBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bndDesagreement>>,
  TError,
  { data: BndDesagreementBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bndDesagreement>>,
    { data: BndDesagreementBody }
  > = (props) => {
    const { data } = props ?? {};

    return bndDesagreement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BndDesagreementMutationResult = NonNullable<
  Awaited<ReturnType<typeof bndDesagreement>>
>;
export type BndDesagreementMutationBody = BndDesagreementBody;
export type BndDesagreementMutationError = ErrorType<HttpError>;

export const useBndDesagreement = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bndDesagreement>>,
    TError,
    { data: BndDesagreementBody },
    TContext
  >;
}) => {
  const mutationOptions = getBndDesagreementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const findBndInfoBySisbov = (
  params: FindBndInfoBySisbovParams,
  signal?: AbortSignal,
) => {
  return request<FindBndInfoBySisbovResponse>({
    url: `/utils/submit/bnd/find-bnd-info-by-sisbov`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindBndInfoBySisbovQueryKey = (
  params: FindBndInfoBySisbovParams,
) => {
  return [
    `/utils/submit/bnd/find-bnd-info-by-sisbov`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindBndInfoBySisbovInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof findBndInfoBySisbov>>,
  TError = ErrorType<HttpError>,
>(
  params: FindBndInfoBySisbovParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof findBndInfoBySisbov>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindBndInfoBySisbovQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findBndInfoBySisbov>>
  > = ({ signal }) => findBndInfoBySisbov(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof findBndInfoBySisbov>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindBndInfoBySisbovInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBndInfoBySisbov>>
>;
export type FindBndInfoBySisbovInfiniteQueryError = ErrorType<HttpError>;

export const useFindBndInfoBySisbovInfinite = <
  TData = Awaited<ReturnType<typeof findBndInfoBySisbov>>,
  TError = ErrorType<HttpError>,
>(
  params: FindBndInfoBySisbovParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof findBndInfoBySisbov>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindBndInfoBySisbovInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFindBndInfoBySisbovQueryOptions = <
  TData = Awaited<ReturnType<typeof findBndInfoBySisbov>>,
  TError = ErrorType<HttpError>,
>(
  params: FindBndInfoBySisbovParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findBndInfoBySisbov>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindBndInfoBySisbovQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findBndInfoBySisbov>>
  > = ({ signal }) => findBndInfoBySisbov(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findBndInfoBySisbov>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindBndInfoBySisbovQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBndInfoBySisbov>>
>;
export type FindBndInfoBySisbovQueryError = ErrorType<HttpError>;

export const useFindBndInfoBySisbov = <
  TData = Awaited<ReturnType<typeof findBndInfoBySisbov>>,
  TError = ErrorType<HttpError>,
>(
  params: FindBndInfoBySisbovParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findBndInfoBySisbov>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindBndInfoBySisbovQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const bndVerification = (
  params: BndVerificationParams,
  signal?: AbortSignal,
) => {
  return request<BndVerificationResponse>({
    url: `/utils/submit/bnd/verification`,
    method: "GET",
    params,
    signal,
  });
};

export const getBndVerificationQueryKey = (params: BndVerificationParams) => {
  return [
    `/utils/submit/bnd/verification`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBndVerificationInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof bndVerification>>,
  TError = ErrorType<HttpError>,
>(
  params: BndVerificationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof bndVerification>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBndVerificationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bndVerification>>> = ({
    signal,
  }) => bndVerification(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof bndVerification>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BndVerificationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof bndVerification>>
>;
export type BndVerificationInfiniteQueryError = ErrorType<HttpError>;

export const useBndVerificationInfinite = <
  TData = Awaited<ReturnType<typeof bndVerification>>,
  TError = ErrorType<HttpError>,
>(
  params: BndVerificationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof bndVerification>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBndVerificationInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBndVerificationQueryOptions = <
  TData = Awaited<ReturnType<typeof bndVerification>>,
  TError = ErrorType<HttpError>,
>(
  params: BndVerificationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof bndVerification>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBndVerificationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bndVerification>>> = ({
    signal,
  }) => bndVerification(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bndVerification>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BndVerificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof bndVerification>>
>;
export type BndVerificationQueryError = ErrorType<HttpError>;

export const useBndVerification = <
  TData = Awaited<ReturnType<typeof bndVerification>>,
  TError = ErrorType<HttpError>,
>(
  params: BndVerificationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof bndVerification>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBndVerificationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const submitCertifier = (submitCertifierBody: SubmitCertifierBody) => {
  return request<SubmitCertifierResponse>({
    url: `/utils/submit/certifier`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitCertifierBody,
  });
};

export const getSubmitCertifierMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitCertifier>>,
    TError,
    { data: SubmitCertifierBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitCertifier>>,
  TError,
  { data: SubmitCertifierBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitCertifier>>,
    { data: SubmitCertifierBody }
  > = (props) => {
    const { data } = props ?? {};

    return submitCertifier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitCertifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitCertifier>>
>;
export type SubmitCertifierMutationBody = SubmitCertifierBody;
export type SubmitCertifierMutationError = ErrorType<HttpError>;

export const useSubmitCertifier = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitCertifier>>,
    TError,
    { data: SubmitCertifierBody },
    TContext
  >;
}) => {
  const mutationOptions = getSubmitCertifierMutationOptions(options);

  return useMutation(mutationOptions);
};

export const syncManagement = (signal?: AbortSignal) => {
  return request<SyncManagementResponse>({
    url: `/utils/sync-management`,
    method: "GET",
    signal,
  });
};

export const getSyncManagementQueryKey = () => {
  return [`/utils/sync-management`] as const;
};

export const getSyncManagementInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof syncManagement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof syncManagement>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSyncManagementQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof syncManagement>>> = ({
    signal,
  }) => syncManagement(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof syncManagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SyncManagementInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof syncManagement>>
>;
export type SyncManagementInfiniteQueryError = ErrorType<unknown>;

export const useSyncManagementInfinite = <
  TData = Awaited<ReturnType<typeof syncManagement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof syncManagement>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSyncManagementInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSyncManagementQueryOptions = <
  TData = Awaited<ReturnType<typeof syncManagement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof syncManagement>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSyncManagementQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof syncManagement>>> = ({
    signal,
  }) => syncManagement(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof syncManagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SyncManagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof syncManagement>>
>;
export type SyncManagementQueryError = ErrorType<unknown>;

export const useSyncManagement = <
  TData = Awaited<ReturnType<typeof syncManagement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof syncManagement>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSyncManagementQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const restoreFeedDataPublic = (
  restoreFeedDataPublicBody: RestoreFeedDataPublicBody,
) => {
  return request<RestoreFeedDataPublicResponse>({
    url: `/utils/upload-backup-public`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: restoreFeedDataPublicBody,
  });
};

export const getRestoreFeedDataPublicMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreFeedDataPublic>>,
    TError,
    { data: RestoreFeedDataPublicBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreFeedDataPublic>>,
  TError,
  { data: RestoreFeedDataPublicBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreFeedDataPublic>>,
    { data: RestoreFeedDataPublicBody }
  > = (props) => {
    const { data } = props ?? {};

    return restoreFeedDataPublic(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreFeedDataPublicMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreFeedDataPublic>>
>;
export type RestoreFeedDataPublicMutationBody = RestoreFeedDataPublicBody;
export type RestoreFeedDataPublicMutationError = ErrorType<HttpError>;

export const useRestoreFeedDataPublic = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreFeedDataPublic>>,
    TError,
    { data: RestoreFeedDataPublicBody },
    TContext
  >;
}) => {
  const mutationOptions = getRestoreFeedDataPublicMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getVersion = (signal?: AbortSignal) => {
  return request<GetVersionResponse>({
    url: `/utils/version`,
    method: "GET",
    signal,
  });
};

export const getGetVersionQueryKey = () => {
  return [`/utils/version`] as const;
};

export const getGetVersionInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getVersion>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getVersion>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVersionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({
    signal,
  }) => getVersion(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVersionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVersion>>
>;
export type GetVersionInfiniteQueryError = ErrorType<unknown>;

export const useGetVersionInfinite = <
  TData = Awaited<ReturnType<typeof getVersion>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getVersion>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetVersionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getVersion>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVersion>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVersionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({
    signal,
  }) => getVersion(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVersion>>
>;
export type GetVersionQueryError = ErrorType<unknown>;

export const useGetVersion = <
  TData = Awaited<ReturnType<typeof getVersion>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVersion>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetVersionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const downloadVegasIntegrationForBirth = (
  downloadVegasIntegration: DownloadVegasIntegration,
) => {
  return request<DownloadVegasIntegrationForBirthResponse>({
    url: `/vegas/birth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: downloadVegasIntegration,
  });
};

export const getDownloadVegasIntegrationForBirthMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForBirth>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadVegasIntegrationForBirth>>,
  TError,
  { data: DownloadVegasIntegration },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadVegasIntegrationForBirth>>,
    { data: DownloadVegasIntegration }
  > = (props) => {
    const { data } = props ?? {};

    return downloadVegasIntegrationForBirth(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadVegasIntegrationForBirthMutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadVegasIntegrationForBirth>>
>;
export type DownloadVegasIntegrationForBirthMutationBody =
  DownloadVegasIntegration;
export type DownloadVegasIntegrationForBirthMutationError =
  ErrorType<HttpError>;

export const useDownloadVegasIntegrationForBirth = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForBirth>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}) => {
  const mutationOptions =
    getDownloadVegasIntegrationForBirthMutationOptions(options);

  return useMutation(mutationOptions);
};

export const downloadVegasIntegrationForDeath = (
  downloadVegasIntegration: DownloadVegasIntegration,
) => {
  return request<DownloadVegasIntegrationForDeathResponse>({
    url: `/vegas/death`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: downloadVegasIntegration,
  });
};

export const getDownloadVegasIntegrationForDeathMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForDeath>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadVegasIntegrationForDeath>>,
  TError,
  { data: DownloadVegasIntegration },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadVegasIntegrationForDeath>>,
    { data: DownloadVegasIntegration }
  > = (props) => {
    const { data } = props ?? {};

    return downloadVegasIntegrationForDeath(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadVegasIntegrationForDeathMutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadVegasIntegrationForDeath>>
>;
export type DownloadVegasIntegrationForDeathMutationBody =
  DownloadVegasIntegration;
export type DownloadVegasIntegrationForDeathMutationError =
  ErrorType<HttpError>;

export const useDownloadVegasIntegrationForDeath = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForDeath>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}) => {
  const mutationOptions =
    getDownloadVegasIntegrationForDeathMutationOptions(options);

  return useMutation(mutationOptions);
};

export const downloadVegasIntegrationForEntry = (
  downloadVegasIntegration: DownloadVegasIntegration,
) => {
  return request<DownloadVegasIntegrationForEntryResponse>({
    url: `/vegas/entry`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: downloadVegasIntegration,
  });
};

export const getDownloadVegasIntegrationForEntryMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForEntry>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadVegasIntegrationForEntry>>,
  TError,
  { data: DownloadVegasIntegration },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadVegasIntegrationForEntry>>,
    { data: DownloadVegasIntegration }
  > = (props) => {
    const { data } = props ?? {};

    return downloadVegasIntegrationForEntry(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadVegasIntegrationForEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadVegasIntegrationForEntry>>
>;
export type DownloadVegasIntegrationForEntryMutationBody =
  DownloadVegasIntegration;
export type DownloadVegasIntegrationForEntryMutationError =
  ErrorType<HttpError>;

export const useDownloadVegasIntegrationForEntry = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForEntry>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}) => {
  const mutationOptions =
    getDownloadVegasIntegrationForEntryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const downloadVegasIntegrationForExit = (
  downloadVegasIntegration: DownloadVegasIntegration,
) => {
  return request<DownloadVegasIntegrationForExitResponse>({
    url: `/vegas/exit`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: downloadVegasIntegration,
  });
};

export const getDownloadVegasIntegrationForExitMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForExit>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadVegasIntegrationForExit>>,
  TError,
  { data: DownloadVegasIntegration },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadVegasIntegrationForExit>>,
    { data: DownloadVegasIntegration }
  > = (props) => {
    const { data } = props ?? {};

    return downloadVegasIntegrationForExit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadVegasIntegrationForExitMutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadVegasIntegrationForExit>>
>;
export type DownloadVegasIntegrationForExitMutationBody =
  DownloadVegasIntegration;
export type DownloadVegasIntegrationForExitMutationError = ErrorType<HttpError>;

export const useDownloadVegasIntegrationForExit = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForExit>>,
    TError,
    { data: DownloadVegasIntegration },
    TContext
  >;
}) => {
  const mutationOptions =
    getDownloadVegasIntegrationForExitMutationOptions(options);

  return useMutation(mutationOptions);
};

export const downloadVegasIntegrationForSaleOrder = (
  downloadVegasIntegrationForSaleOrder: DownloadVegasIntegrationForSaleOrder,
) => {
  return request<DownloadVegasIntegrationForSaleOrderResponse>({
    url: `/vegas/sale-orders`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: downloadVegasIntegrationForSaleOrder,
  });
};

export const getDownloadVegasIntegrationForSaleOrderMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForSaleOrder>>,
    TError,
    { data: DownloadVegasIntegrationForSaleOrder },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadVegasIntegrationForSaleOrder>>,
  TError,
  { data: DownloadVegasIntegrationForSaleOrder },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadVegasIntegrationForSaleOrder>>,
    { data: DownloadVegasIntegrationForSaleOrder }
  > = (props) => {
    const { data } = props ?? {};

    return downloadVegasIntegrationForSaleOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadVegasIntegrationForSaleOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadVegasIntegrationForSaleOrder>>
>;
export type DownloadVegasIntegrationForSaleOrderMutationBody =
  DownloadVegasIntegrationForSaleOrder;
export type DownloadVegasIntegrationForSaleOrderMutationError =
  ErrorType<HttpError>;

export const useDownloadVegasIntegrationForSaleOrder = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadVegasIntegrationForSaleOrder>>,
    TError,
    { data: DownloadVegasIntegrationForSaleOrder },
    TContext
  >;
}) => {
  const mutationOptions =
    getDownloadVegasIntegrationForSaleOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const batchDetails = (
  params: BatchDetailsParams,
  signal?: AbortSignal,
) => {
  return request<BatchDetailsResponse>({
    url: `/view/batch-details`,
    method: "GET",
    params,
    signal,
  });
};

export const getBatchDetailsQueryKey = (params: BatchDetailsParams) => {
  return [`/view/batch-details`, ...(params ? [params] : [])] as const;
};

export const getBatchDetailsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof batchDetails>>,
  TError = ErrorType<unknown>,
>(
  params: BatchDetailsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchDetailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchDetails>>> = ({
    signal,
  }) => batchDetails(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof batchDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchDetailsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchDetails>>
>;
export type BatchDetailsInfiniteQueryError = ErrorType<unknown>;

export const useBatchDetailsInfinite = <
  TData = Awaited<ReturnType<typeof batchDetails>>,
  TError = ErrorType<unknown>,
>(
  params: BatchDetailsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof batchDetails>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchDetailsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBatchDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof batchDetails>>,
  TError = ErrorType<unknown>,
>(
  params: BatchDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchDetails>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBatchDetailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof batchDetails>>> = ({
    signal,
  }) => batchDetails(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof batchDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BatchDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchDetails>>
>;
export type BatchDetailsQueryError = ErrorType<unknown>;

export const useBatchDetails = <
  TData = Awaited<ReturnType<typeof batchDetails>>,
  TError = ErrorType<unknown>,
>(
  params: BatchDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof batchDetails>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBatchDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const beatView = (signal?: AbortSignal) => {
  return request<BeatViewResponse>({
    url: `/view/beat`,
    method: "GET",
    signal,
  });
};

export const getBeatViewQueryKey = () => {
  return [`/view/beat`] as const;
};

export const getBeatViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof beatView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof beatView>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBeatViewQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof beatView>>> = ({
    signal,
  }) => beatView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof beatView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BeatViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof beatView>>
>;
export type BeatViewInfiniteQueryError = ErrorType<unknown>;

export const useBeatViewInfinite = <
  TData = Awaited<ReturnType<typeof beatView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof beatView>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBeatViewInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBeatViewQueryOptions = <
  TData = Awaited<ReturnType<typeof beatView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof beatView>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBeatViewQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof beatView>>> = ({
    signal,
  }) => beatView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof beatView>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type BeatViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof beatView>>
>;
export type BeatViewQueryError = ErrorType<unknown>;

export const useBeatView = <
  TData = Awaited<ReturnType<typeof beatView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof beatView>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBeatViewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const dietTransitionListView = (signal?: AbortSignal) => {
  return request<DietTransitionListViewResponse>({
    url: `/view/diet-transition`,
    method: "GET",
    signal,
  });
};

export const getDietTransitionListViewQueryKey = () => {
  return [`/view/diet-transition`] as const;
};

export const getDietTransitionListViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof dietTransitionListView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof dietTransitionListView>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDietTransitionListViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dietTransitionListView>>
  > = ({ signal }) => dietTransitionListView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof dietTransitionListView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DietTransitionListViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof dietTransitionListView>>
>;
export type DietTransitionListViewInfiniteQueryError = ErrorType<unknown>;

export const useDietTransitionListViewInfinite = <
  TData = Awaited<ReturnType<typeof dietTransitionListView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof dietTransitionListView>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDietTransitionListViewInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getDietTransitionListViewQueryOptions = <
  TData = Awaited<ReturnType<typeof dietTransitionListView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dietTransitionListView>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDietTransitionListViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dietTransitionListView>>
  > = ({ signal }) => dietTransitionListView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof dietTransitionListView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DietTransitionListViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof dietTransitionListView>>
>;
export type DietTransitionListViewQueryError = ErrorType<unknown>;

export const useDietTransitionListView = <
  TData = Awaited<ReturnType<typeof dietTransitionListView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dietTransitionListView>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDietTransitionListViewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const entryManagementView = (signal?: AbortSignal) => {
  return request<EntryManagementViewResponse>({
    url: `/view/entry-management`,
    method: "GET",
    signal,
  });
};

export const getEntryManagementViewQueryKey = () => {
  return [`/view/entry-management`] as const;
};

export const getEntryManagementViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof entryManagementView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof entryManagementView>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEntryManagementViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entryManagementView>>
  > = ({ signal }) => entryManagementView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof entryManagementView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntryManagementViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof entryManagementView>>
>;
export type EntryManagementViewInfiniteQueryError = ErrorType<unknown>;

export const useEntryManagementViewInfinite = <
  TData = Awaited<ReturnType<typeof entryManagementView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof entryManagementView>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getEntryManagementViewInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEntryManagementViewQueryOptions = <
  TData = Awaited<ReturnType<typeof entryManagementView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof entryManagementView>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEntryManagementViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entryManagementView>>
  > = ({ signal }) => entryManagementView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof entryManagementView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntryManagementViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof entryManagementView>>
>;
export type EntryManagementViewQueryError = ErrorType<unknown>;

export const useEntryManagementView = <
  TData = Awaited<ReturnType<typeof entryManagementView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof entryManagementView>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getEntryManagementViewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const feedLinkRecipes = (signal?: AbortSignal) => {
  return request<FeedLinkRecipesResponse>({
    url: `/view/feed-link`,
    method: "GET",
    signal,
  });
};

export const getFeedLinkRecipesQueryKey = () => {
  return [`/view/feed-link`] as const;
};

export const getFeedLinkRecipesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof feedLinkRecipes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof feedLinkRecipes>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeedLinkRecipesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof feedLinkRecipes>>> = ({
    signal,
  }) => feedLinkRecipes(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof feedLinkRecipes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FeedLinkRecipesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof feedLinkRecipes>>
>;
export type FeedLinkRecipesInfiniteQueryError = ErrorType<unknown>;

export const useFeedLinkRecipesInfinite = <
  TData = Awaited<ReturnType<typeof feedLinkRecipes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof feedLinkRecipes>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFeedLinkRecipesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFeedLinkRecipesQueryOptions = <
  TData = Awaited<ReturnType<typeof feedLinkRecipes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof feedLinkRecipes>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeedLinkRecipesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof feedLinkRecipes>>> = ({
    signal,
  }) => feedLinkRecipes(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof feedLinkRecipes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FeedLinkRecipesQueryResult = NonNullable<
  Awaited<ReturnType<typeof feedLinkRecipes>>
>;
export type FeedLinkRecipesQueryError = ErrorType<unknown>;

export const useFeedLinkRecipes = <
  TData = Awaited<ReturnType<typeof feedLinkRecipes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof feedLinkRecipes>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFeedLinkRecipesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const findOx = (params?: FindOxParams, signal?: AbortSignal) => {
  return request<FindOxResponse>({
    url: `/view/find-ox`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindOxQueryKey = (params?: FindOxParams) => {
  return [`/view/find-ox`, ...(params ? [params] : [])] as const;
};

export const getFindOxInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof findOx>>,
  TError = ErrorType<HttpError>,
>(
  params?: FindOxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof findOx>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindOxQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findOx>>> = ({
    signal,
  }) => findOx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof findOx>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindOxInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof findOx>>
>;
export type FindOxInfiniteQueryError = ErrorType<HttpError>;

export const useFindOxInfinite = <
  TData = Awaited<ReturnType<typeof findOx>>,
  TError = ErrorType<HttpError>,
>(
  params?: FindOxParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof findOx>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindOxInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFindOxQueryOptions = <
  TData = Awaited<ReturnType<typeof findOx>>,
  TError = ErrorType<HttpError>,
>(
  params?: FindOxParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof findOx>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindOxQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findOx>>> = ({
    signal,
  }) => findOx(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof findOx>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type FindOxQueryResult = NonNullable<Awaited<ReturnType<typeof findOx>>>;
export type FindOxQueryError = ErrorType<HttpError>;

export const useFindOx = <
  TData = Awaited<ReturnType<typeof findOx>>,
  TError = ErrorType<HttpError>,
>(
  params?: FindOxParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof findOx>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindOxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listManagedBatches = (
  params?: ListManagedBatchesParams,
  signal?: AbortSignal,
) => {
  return request<ListManagedBatchesResponse>({
    url: `/view/list-managed-batches`,
    method: "GET",
    params,
    signal,
  });
};

export const getListManagedBatchesQueryKey = (
  params?: ListManagedBatchesParams,
) => {
  return [`/view/list-managed-batches`, ...(params ? [params] : [])] as const;
};

export const getListManagedBatchesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listManagedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagedBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listManagedBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListManagedBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listManagedBatches>>
  > = ({ signal }) => listManagedBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listManagedBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListManagedBatchesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listManagedBatches>>
>;
export type ListManagedBatchesInfiniteQueryError = ErrorType<unknown>;

export const useListManagedBatchesInfinite = <
  TData = Awaited<ReturnType<typeof listManagedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagedBatchesParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof listManagedBatches>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListManagedBatchesInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListManagedBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listManagedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagedBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listManagedBatches>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListManagedBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listManagedBatches>>
  > = ({ signal }) => listManagedBatches(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listManagedBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListManagedBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listManagedBatches>>
>;
export type ListManagedBatchesQueryError = ErrorType<unknown>;

export const useListManagedBatches = <
  TData = Awaited<ReturnType<typeof listManagedBatches>>,
  TError = ErrorType<unknown>,
>(
  params?: ListManagedBatchesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listManagedBatches>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListManagedBatchesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listLogs = (signal?: AbortSignal) => {
  return request<ListLogsResponse>({
    url: `/view/logs`,
    method: "GET",
    signal,
  });
};

export const getListLogsQueryKey = () => {
  return [`/view/logs`] as const;
};

export const getListLogsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listLogs>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLogsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLogs>>> = ({
    signal,
  }) => listLogs(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLogsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLogs>>
>;
export type ListLogsInfiniteQueryError = ErrorType<unknown>;

export const useListLogsInfinite = <
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listLogs>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListLogsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLogsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLogs>>> = ({
    signal,
  }) => listLogs(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLogs>>
>;
export type ListLogsQueryError = ErrorType<unknown>;

export const useListLogs = <
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListLogsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const multipleBeatsView = (
  params?: MultipleBeatsViewParams,
  signal?: AbortSignal,
) => {
  return request<MultipleBeatsViewResponse>({
    url: `/view/multiple-beats`,
    method: "GET",
    params,
    signal,
  });
};

export const getMultipleBeatsViewQueryKey = (
  params?: MultipleBeatsViewParams,
) => {
  return [`/view/multiple-beats`, ...(params ? [params] : [])] as const;
};

export const getMultipleBeatsViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof multipleBeatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleBeatsViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof multipleBeatsView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMultipleBeatsViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof multipleBeatsView>>
  > = ({ signal }) => multipleBeatsView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof multipleBeatsView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MultipleBeatsViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof multipleBeatsView>>
>;
export type MultipleBeatsViewInfiniteQueryError = ErrorType<unknown>;

export const useMultipleBeatsViewInfinite = <
  TData = Awaited<ReturnType<typeof multipleBeatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleBeatsViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof multipleBeatsView>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMultipleBeatsViewInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getMultipleBeatsViewQueryOptions = <
  TData = Awaited<ReturnType<typeof multipleBeatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleBeatsViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof multipleBeatsView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMultipleBeatsViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof multipleBeatsView>>
  > = ({ signal }) => multipleBeatsView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof multipleBeatsView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MultipleBeatsViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof multipleBeatsView>>
>;
export type MultipleBeatsViewQueryError = ErrorType<unknown>;

export const useMultipleBeatsView = <
  TData = Awaited<ReturnType<typeof multipleBeatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleBeatsViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof multipleBeatsView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMultipleBeatsViewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const multipleTreatsView = (
  params?: MultipleTreatsViewParams,
  signal?: AbortSignal,
) => {
  return request<MultipleTreatsViewResponse>({
    url: `/view/multiple-treats`,
    method: "GET",
    params,
    signal,
  });
};

export const getMultipleTreatsViewQueryKey = (
  params?: MultipleTreatsViewParams,
) => {
  return [`/view/multiple-treats`, ...(params ? [params] : [])] as const;
};

export const getMultipleTreatsViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof multipleTreatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleTreatsViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof multipleTreatsView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMultipleTreatsViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof multipleTreatsView>>
  > = ({ signal }) => multipleTreatsView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof multipleTreatsView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MultipleTreatsViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof multipleTreatsView>>
>;
export type MultipleTreatsViewInfiniteQueryError = ErrorType<unknown>;

export const useMultipleTreatsViewInfinite = <
  TData = Awaited<ReturnType<typeof multipleTreatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleTreatsViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof multipleTreatsView>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMultipleTreatsViewInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getMultipleTreatsViewQueryOptions = <
  TData = Awaited<ReturnType<typeof multipleTreatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleTreatsViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof multipleTreatsView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMultipleTreatsViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof multipleTreatsView>>
  > = ({ signal }) => multipleTreatsView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof multipleTreatsView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MultipleTreatsViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof multipleTreatsView>>
>;
export type MultipleTreatsViewQueryError = ErrorType<unknown>;

export const useMultipleTreatsView = <
  TData = Awaited<ReturnType<typeof multipleTreatsView>>,
  TError = ErrorType<unknown>,
>(
  params?: MultipleTreatsViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof multipleTreatsView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMultipleTreatsViewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const nmUpdatesHistory = (signal?: AbortSignal) => {
  return request<NmUpdatesHistoryResponse>({
    url: `/view/nm-update-history`,
    method: "GET",
    signal,
  });
};

export const getNmUpdatesHistoryQueryKey = () => {
  return [`/view/nm-update-history`] as const;
};

export const getNmUpdatesHistoryInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof nmUpdatesHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof nmUpdatesHistory>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNmUpdatesHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof nmUpdatesHistory>>
  > = ({ signal }) => nmUpdatesHistory(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof nmUpdatesHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NmUpdatesHistoryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof nmUpdatesHistory>>
>;
export type NmUpdatesHistoryInfiniteQueryError = ErrorType<unknown>;

export const useNmUpdatesHistoryInfinite = <
  TData = Awaited<ReturnType<typeof nmUpdatesHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof nmUpdatesHistory>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getNmUpdatesHistoryInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getNmUpdatesHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof nmUpdatesHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof nmUpdatesHistory>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNmUpdatesHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof nmUpdatesHistory>>
  > = ({ signal }) => nmUpdatesHistory(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof nmUpdatesHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NmUpdatesHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof nmUpdatesHistory>>
>;
export type NmUpdatesHistoryQueryError = ErrorType<unknown>;

export const useNmUpdatesHistory = <
  TData = Awaited<ReturnType<typeof nmUpdatesHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof nmUpdatesHistory>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getNmUpdatesHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const sideBarView = (
  params: SideBarViewParams,
  signal?: AbortSignal,
) => {
  return request<SideBarViewResponse>({
    url: `/view/sider-bar`,
    method: "GET",
    params,
    signal,
  });
};

export const getSideBarViewQueryKey = (params: SideBarViewParams) => {
  return [`/view/sider-bar`, ...(params ? [params] : [])] as const;
};

export const getSideBarViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof sideBarView>>,
  TError = ErrorType<HttpError>,
>(
  params: SideBarViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof sideBarView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSideBarViewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sideBarView>>> = ({
    signal,
  }) => sideBarView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof sideBarView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SideBarViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof sideBarView>>
>;
export type SideBarViewInfiniteQueryError = ErrorType<HttpError>;

export const useSideBarViewInfinite = <
  TData = Awaited<ReturnType<typeof sideBarView>>,
  TError = ErrorType<HttpError>,
>(
  params: SideBarViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof sideBarView>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSideBarViewInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSideBarViewQueryOptions = <
  TData = Awaited<ReturnType<typeof sideBarView>>,
  TError = ErrorType<HttpError>,
>(
  params: SideBarViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof sideBarView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSideBarViewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sideBarView>>> = ({
    signal,
  }) => sideBarView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sideBarView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SideBarViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof sideBarView>>
>;
export type SideBarViewQueryError = ErrorType<HttpError>;

export const useSideBarView = <
  TData = Awaited<ReturnType<typeof sideBarView>>,
  TError = ErrorType<HttpError>,
>(
  params: SideBarViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof sideBarView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSideBarViewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const transferView = (
  params: TransferViewParams,
  signal?: AbortSignal,
) => {
  return request<TransferViewResponse>({
    url: `/view/transfer`,
    method: "GET",
    params,
    signal,
  });
};

export const getTransferViewQueryKey = (params: TransferViewParams) => {
  return [`/view/transfer`, ...(params ? [params] : [])] as const;
};

export const getTransferViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof transferView>>,
  TError = ErrorType<HttpError>,
>(
  params: TransferViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof transferView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTransferViewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof transferView>>> = ({
    signal,
  }) => transferView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof transferView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransferViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof transferView>>
>;
export type TransferViewInfiniteQueryError = ErrorType<HttpError>;

export const useTransferViewInfinite = <
  TData = Awaited<ReturnType<typeof transferView>>,
  TError = ErrorType<HttpError>,
>(
  params: TransferViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof transferView>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTransferViewInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTransferViewQueryOptions = <
  TData = Awaited<ReturnType<typeof transferView>>,
  TError = ErrorType<HttpError>,
>(
  params: TransferViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof transferView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTransferViewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof transferView>>> = ({
    signal,
  }) => transferView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof transferView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransferViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof transferView>>
>;
export type TransferViewQueryError = ErrorType<HttpError>;

export const useTransferView = <
  TData = Awaited<ReturnType<typeof transferView>>,
  TError = ErrorType<HttpError>,
>(
  params: TransferViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof transferView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTransferViewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const treatView = (params?: TreatViewParams, signal?: AbortSignal) => {
  return request<TreatViewResponse>({
    url: `/view/treat`,
    method: "GET",
    params,
    signal,
  });
};

export const getTreatViewQueryKey = (params?: TreatViewParams) => {
  return [`/view/treat`, ...(params ? [params] : [])] as const;
};

export const getTreatViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof treatView>>,
  TError = ErrorType<unknown>,
>(
  params?: TreatViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof treatView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTreatViewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof treatView>>> = ({
    signal,
  }) => treatView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof treatView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TreatViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof treatView>>
>;
export type TreatViewInfiniteQueryError = ErrorType<unknown>;

export const useTreatViewInfinite = <
  TData = Awaited<ReturnType<typeof treatView>>,
  TError = ErrorType<unknown>,
>(
  params?: TreatViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof treatView>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTreatViewInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTreatViewQueryOptions = <
  TData = Awaited<ReturnType<typeof treatView>>,
  TError = ErrorType<unknown>,
>(
  params?: TreatViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof treatView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTreatViewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof treatView>>> = ({
    signal,
  }) => treatView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof treatView>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type TreatViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof treatView>>
>;
export type TreatViewQueryError = ErrorType<unknown>;

export const useTreatView = <
  TData = Awaited<ReturnType<typeof treatView>>,
  TError = ErrorType<unknown>,
>(
  params?: TreatViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof treatView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTreatViewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const troughManagementView = (
  params?: TroughManagementViewParams,
  signal?: AbortSignal,
) => {
  return request<TroughManagementViewResponse>({
    url: `/view/trough-management`,
    method: "GET",
    params,
    signal,
  });
};

export const getTroughManagementViewQueryKey = (
  params?: TroughManagementViewParams,
) => {
  return [`/view/trough-management`, ...(params ? [params] : [])] as const;
};

export const getTroughManagementViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof troughManagementView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof troughManagementView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTroughManagementViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof troughManagementView>>
  > = ({ signal }) => troughManagementView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof troughManagementView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TroughManagementViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof troughManagementView>>
>;
export type TroughManagementViewInfiniteQueryError = ErrorType<unknown>;

export const useTroughManagementViewInfinite = <
  TData = Awaited<ReturnType<typeof troughManagementView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof troughManagementView>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTroughManagementViewInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTroughManagementViewQueryOptions = <
  TData = Awaited<ReturnType<typeof troughManagementView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof troughManagementView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTroughManagementViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof troughManagementView>>
  > = ({ signal }) => troughManagementView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof troughManagementView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TroughManagementViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof troughManagementView>>
>;
export type TroughManagementViewQueryError = ErrorType<unknown>;

export const useTroughManagementView = <
  TData = Awaited<ReturnType<typeof troughManagementView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof troughManagementView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTroughManagementViewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const troughManagementGraphView = (
  params?: TroughManagementGraphViewParams,
  signal?: AbortSignal,
) => {
  return request<TroughManagementGraphViewResponse>({
    url: `/view/trough-management-graph`,
    method: "GET",
    params,
    signal,
  });
};

export const getTroughManagementGraphViewQueryKey = (
  params?: TroughManagementGraphViewParams,
) => {
  return [
    `/view/trough-management-graph`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTroughManagementGraphViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof troughManagementGraphView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementGraphViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof troughManagementGraphView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTroughManagementGraphViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof troughManagementGraphView>>
  > = ({ signal }) => troughManagementGraphView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof troughManagementGraphView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TroughManagementGraphViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof troughManagementGraphView>>
>;
export type TroughManagementGraphViewInfiniteQueryError = ErrorType<unknown>;

export const useTroughManagementGraphViewInfinite = <
  TData = Awaited<ReturnType<typeof troughManagementGraphView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementGraphViewParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof troughManagementGraphView>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTroughManagementGraphViewInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTroughManagementGraphViewQueryOptions = <
  TData = Awaited<ReturnType<typeof troughManagementGraphView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementGraphViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof troughManagementGraphView>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTroughManagementGraphViewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof troughManagementGraphView>>
  > = ({ signal }) => troughManagementGraphView(params, signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof troughManagementGraphView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TroughManagementGraphViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof troughManagementGraphView>>
>;
export type TroughManagementGraphViewQueryError = ErrorType<unknown>;

export const useTroughManagementGraphView = <
  TData = Awaited<ReturnType<typeof troughManagementGraphView>>,
  TError = ErrorType<unknown>,
>(
  params?: TroughManagementGraphViewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof troughManagementGraphView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTroughManagementGraphViewQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const troughManagementPrintingCardView = (signal?: AbortSignal) => {
  return request<TroughManagementPrintingCardViewResponse>({
    url: `/view/trough-management-printing-card`,
    method: "GET",
    signal,
  });
};

export const getTroughManagementPrintingCardViewQueryKey = () => {
  return [`/view/trough-management-printing-card`] as const;
};

export const getTroughManagementPrintingCardViewInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTroughManagementPrintingCardViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>
  > = ({ signal }) => troughManagementPrintingCardView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TroughManagementPrintingCardViewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof troughManagementPrintingCardView>>
>;
export type TroughManagementPrintingCardViewInfiniteQueryError =
  ErrorType<unknown>;

export const useTroughManagementPrintingCardViewInfinite = <
  TData = Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getTroughManagementPrintingCardViewInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTroughManagementPrintingCardViewQueryOptions = <
  TData = Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTroughManagementPrintingCardViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>
  > = ({ signal }) => troughManagementPrintingCardView(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TroughManagementPrintingCardViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof troughManagementPrintingCardView>>
>;
export type TroughManagementPrintingCardViewQueryError = ErrorType<unknown>;

export const useTroughManagementPrintingCardView = <
  TData = Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof troughManagementPrintingCardView>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTroughManagementPrintingCardViewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const listWeightingMaps = (signal?: AbortSignal) => {
  return request<ListWeightingMapsResponse>({
    url: `/weighting-maps`,
    method: "GET",
    signal,
  });
};

export const getListWeightingMapsQueryKey = () => {
  return [`/weighting-maps`] as const;
};

export const getListWeightingMapsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listWeightingMaps>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWeightingMapsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWeightingMaps>>
  > = ({ signal }) => listWeightingMaps(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listWeightingMaps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWeightingMapsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWeightingMaps>>
>;
export type ListWeightingMapsInfiniteQueryError = ErrorType<unknown>;

export const useListWeightingMapsInfinite = <
  TData = Awaited<ReturnType<typeof listWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listWeightingMaps>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListWeightingMapsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListWeightingMapsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWeightingMaps>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWeightingMapsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWeightingMaps>>
  > = ({ signal }) => listWeightingMaps(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWeightingMaps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWeightingMapsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWeightingMaps>>
>;
export type ListWeightingMapsQueryError = ErrorType<unknown>;

export const useListWeightingMaps = <
  TData = Awaited<ReturnType<typeof listWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWeightingMaps>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListWeightingMapsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createWeightingMap = (
  createWeightingMapBody: CreateWeightingMapBody,
) => {
  return request<CreateWeightingMapResponse>({
    url: `/weighting-maps`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createWeightingMapBody,
  });
};

export const getCreateWeightingMapMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWeightingMap>>,
    TError,
    { data: CreateWeightingMapBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWeightingMap>>,
  TError,
  { data: CreateWeightingMapBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWeightingMap>>,
    { data: CreateWeightingMapBody }
  > = (props) => {
    const { data } = props ?? {};

    return createWeightingMap(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWeightingMapMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWeightingMap>>
>;
export type CreateWeightingMapMutationBody = CreateWeightingMapBody;
export type CreateWeightingMapMutationError = ErrorType<HttpError>;

export const useCreateWeightingMap = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWeightingMap>>,
    TError,
    { data: CreateWeightingMapBody },
    TContext
  >;
}) => {
  const mutationOptions = getCreateWeightingMapMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAvailableGtasForWeightingMap = (signal?: AbortSignal) => {
  return request<ListAvailableGtasForWeightingMapResponse>({
    url: `/weighting-maps/available-gtas`,
    method: "GET",
    signal,
  });
};

export const getListAvailableGtasForWeightingMapQueryKey = () => {
  return [`/weighting-maps/available-gtas`] as const;
};

export const getListAvailableGtasForWeightingMapInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAvailableGtasForWeightingMapQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>
  > = ({ signal }) => listAvailableGtasForWeightingMap(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAvailableGtasForWeightingMapInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>
>;
export type ListAvailableGtasForWeightingMapInfiniteQueryError =
  ErrorType<unknown>;

export const useListAvailableGtasForWeightingMapInfinite = <
  TData = Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListAvailableGtasForWeightingMapInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListAvailableGtasForWeightingMapQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAvailableGtasForWeightingMapQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>
  > = ({ signal }) => listAvailableGtasForWeightingMap(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAvailableGtasForWeightingMapQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>
>;
export type ListAvailableGtasForWeightingMapQueryError = ErrorType<unknown>;

export const useListAvailableGtasForWeightingMap = <
  TData = Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableGtasForWeightingMap>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAvailableGtasForWeightingMapQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Lista apenas notas fiscais disponíveis para vincular a um mapa de pesagem: sem mapa, sem caminhão de saída e sem
pedido de venda
 */
export const listAvailableInvoicesForWeightingMap = (signal?: AbortSignal) => {
  return request<ListAvailableInvoicesForWeightingMapResponse>({
    url: `/weighting-maps/available-invoices`,
    method: "GET",
    signal,
  });
};

export const getListAvailableInvoicesForWeightingMapQueryKey = () => {
  return [`/weighting-maps/available-invoices`] as const;
};

export const getListAvailableInvoicesForWeightingMapInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAvailableInvoicesForWeightingMapQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>
  > = ({ signal }) => listAvailableInvoicesForWeightingMap(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAvailableInvoicesForWeightingMapInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>>;
export type ListAvailableInvoicesForWeightingMapInfiniteQueryError =
  ErrorType<unknown>;

export const useListAvailableInvoicesForWeightingMapInfinite = <
  TData = Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListAvailableInvoicesForWeightingMapInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListAvailableInvoicesForWeightingMapQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAvailableInvoicesForWeightingMapQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>
  > = ({ signal }) => listAvailableInvoicesForWeightingMap(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAvailableInvoicesForWeightingMapQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>
>;
export type ListAvailableInvoicesForWeightingMapQueryError = ErrorType<unknown>;

export const useListAvailableInvoicesForWeightingMap = <
  TData = Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableInvoicesForWeightingMap>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListAvailableInvoicesForWeightingMapQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Lista mapas de pesagem disponíveis para vincular a um pedido de compra.
 */
export const listAvailableWeightingMaps = (signal?: AbortSignal) => {
  return request<ListAvailableWeightingMapsResponse>({
    url: `/weighting-maps/available-maps`,
    method: "GET",
    signal,
  });
};

export const getListAvailableWeightingMapsQueryKey = () => {
  return [`/weighting-maps/available-maps`] as const;
};

export const getListAvailableWeightingMapsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAvailableWeightingMapsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>
  > = ({ signal }) => listAvailableWeightingMaps(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAvailableWeightingMapsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableWeightingMaps>>
>;
export type ListAvailableWeightingMapsInfiniteQueryError = ErrorType<unknown>;

export const useListAvailableWeightingMapsInfinite = <
  TData = Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListAvailableWeightingMapsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getListAvailableWeightingMapsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAvailableWeightingMapsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>
  > = ({ signal }) => listAvailableWeightingMaps(signal);

  return {
    queryKey,
    queryFn,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAvailableWeightingMapsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableWeightingMaps>>
>;
export type ListAvailableWeightingMapsQueryError = ErrorType<unknown>;

export const useListAvailableWeightingMaps = <
  TData = Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableWeightingMaps>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAvailableWeightingMapsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getWeightingMap = (id: number, signal?: AbortSignal) => {
  return request<GetWeightingMapResponse>({
    url: `/weighting-maps/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetWeightingMapQueryKey = (id: number) => {
  return [`/weighting-maps/${id}`] as const;
};

export const getGetWeightingMapInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightingMap>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getWeightingMap>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWeightingMapQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeightingMap>>> = ({
    signal,
  }) => getWeightingMap(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWeightingMap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightingMapInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightingMap>>
>;
export type GetWeightingMapInfiniteQueryError = ErrorType<unknown>;

export const useGetWeightingMapInfinite = <
  TData = Awaited<ReturnType<typeof getWeightingMap>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getWeightingMap>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightingMapInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGetWeightingMapQueryOptions = <
  TData = Awaited<ReturnType<typeof getWeightingMap>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWeightingMap>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWeightingMapQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeightingMap>>> = ({
    signal,
  }) => getWeightingMap(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    networkMode: "always",
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWeightingMap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWeightingMapQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWeightingMap>>
>;
export type GetWeightingMapQueryError = ErrorType<unknown>;

export const useGetWeightingMap = <
  TData = Awaited<ReturnType<typeof getWeightingMap>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWeightingMap>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWeightingMapQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateWeightingMap = (
  id: number,
  updateWeightingMapBody: UpdateWeightingMapBody,
) => {
  return request<UpdateWeightingMapResponse>({
    url: `/weighting-maps/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateWeightingMapBody,
  });
};

export const getUpdateWeightingMapMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWeightingMap>>,
    TError,
    { id: number; data: UpdateWeightingMapBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWeightingMap>>,
  TError,
  { id: number; data: UpdateWeightingMapBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWeightingMap>>,
    { id: number; data: UpdateWeightingMapBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWeightingMap(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWeightingMapMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWeightingMap>>
>;
export type UpdateWeightingMapMutationBody = UpdateWeightingMapBody;
export type UpdateWeightingMapMutationError = ErrorType<HttpError>;

export const useUpdateWeightingMap = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWeightingMap>>,
    TError,
    { id: number; data: UpdateWeightingMapBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateWeightingMapMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteWeightingMap = (id: number) => {
  return request<void>({
    url: `/weighting-maps/${id}/delete`,
    method: "DELETE",
  });
};

export const getDeleteWeightingMapMutationOptions = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWeightingMap>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWeightingMap>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWeightingMap>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteWeightingMap(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWeightingMapMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWeightingMap>>
>;

export type DeleteWeightingMapMutationError = ErrorType<HttpError>;

export const useDeleteWeightingMap = <
  TError = ErrorType<HttpError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWeightingMap>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteWeightingMapMutationOptions(options);

  return useMutation(mutationOptions);
};
